function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1jMgA", function(module, exports) {
    $parcel$export(module.exports, "Search", ()=>$51999f6351274dfb$export$4b85d3515bd863a5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jZ4fr;
    var $5Fk4Z;
    var $7CMCs;
    var $4R6GH;
    var $7VHMR;
    var $koVbs;
    var $15rEL;
    var $lmyls;
    var $2Ui4E;
    var $6cNb0;
    var $3HwlS;
    var $h9iZl;
    var $9OXo1;
    var $lVJAU;
    var $Mp6qH;
    var $4uXxK;
    var $iPj86;
    var $eoNiZ;
    var $bMQpY;
    var $hteTr;
    var $gIk9n;
    var $crtj2;
    const $51999f6351274dfb$export$b77c6c44f6e7248e = (ref, isOpen)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) setTimeout(()=>{
                ref && ref.current && ref.current.focus();
            }, 0);
        }, [
            isOpen,
            ref
        ]);
    };
    const $51999f6351274dfb$var$styles = {
        nav4SearchInputWrapper: "_1bsb1osq _p12fktbq",
        nav4SearchInputOverrider: "_1bsb1osq",
        searchInputWrapper: "_1e0c1txw _1bah1h6o _4cvr1h6o _kqswh2mm _1ul9t94y",
        searchInputOverrider: "_1xhqi2wt"
    };
    const $51999f6351274dfb$var$Search = (0, $5uXOq.forwardRef)(({ ExtensibleCrossProductSearchDialog: ExtensibleCrossProductSearchDialog = (0, (0, parcelRequire("hteTr")).ExtensibleCrossProductSearchDialog), ClientProvider: ClientProvider = (0, (0, parcelRequire("bMQpY")).ClientProvider), EngagementSpotlight: EngagementSpotlight = (0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), SearchInputOverrider: SearchInputOverrider = $51999f6351274dfb$var$SearchInputOverriderDI, SearchInputWrapper: SearchInputWrapper = $51999f6351274dfb$var$SearchInputWrapperDI, SpotlightTarget: SpotlightTarget = (0, (0, parcelRequire("5Fk4Z")).default), useEffectFocusOnOpen: useEffectFocusOnOpen = $51999f6351274dfb$export$b77c6c44f6e7248e, useNavigationItemAnalytics: useNavigationItemAnalytics = (0, (0, parcelRequire("iPj86")).useNavigationItemAnalytics), useRouterActions: useRouterActions = (0, (0, parcelRequire("lVJAU")).useRouterActions), useTenantContext: useTenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext), useNavigationViewPlansPermission: useNavigationViewPlansPermission = (0, (0, parcelRequire("h9iZl")).useNavigationViewPlansPermission), useTheme: useTheme = (0, (0, parcelRequire("eoNiZ")).useTheme), useTopMenus: useTopMenus = (0, (0, parcelRequire("2Ui4E")).useTopMenus), JsErrorBoundary: JsErrorBoundary = (0, (0, parcelRequire("7CMCs")).JSErrorBoundary) }, forwardedInputRef)=>{
        const testId = (0, (0, parcelRequire("6cNb0")).testIdGenerate)('secondary-actions', 'search');
        const inputRef = (0, $5uXOq.useRef)();
        const tenantContext = useTenantContext();
        const { cloudId: cloudId, baseUrl: baseUrl, isAnonymous: isAnonymous, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId } = tenantContext;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const theme = useTheme();
        const [isSearchMenuOpen, { on: openMenu, off: closeMenu }] = useTopMenus((0, (0, parcelRequire("lmyls")).MENU_ID).SEARCH);
        const triggerAnalytics = useNavigationItemAnalytics({
            navigationItemId: (0, (0, parcelRequire("Mp6qH")).NAVIGATION_ITEM_ID).SEARCH
        });
        const [hasEditOrViewPlanPermission] = useNavigationViewPlansPermission();
        const onOpen = (0, $5uXOq.useCallback)(()=>{
            openMenu();
            triggerAnalytics();
        }, [
            openMenu,
            triggerAnalytics
        ]);
        const withUpdatedLabel = (formattedDate)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, `${formatMessage((0, (0, parcelRequire("gIk9n")).default).updated)} ${formattedDate}`);
        const formatDate = (lastModified)=>{
            const daysElapsed = (Date.now() - new Date(lastModified)) / 86400000;
            if (daysElapsed < 8) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15rEL")).FormattedRelativeV2), {
                value: lastModified
            }, withUpdatedLabel);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
                year: "numeric",
                month: "short",
                day: "2-digit",
                value: lastModified
            }, withUpdatedLabel);
        };
        const { push: push } = useRouterActions();
        const onNavigate = (href, event)=>{
            if (!(event.ctrlKey || event.metaKey)) {
                const url = event?.target?.href ?? event.target?.closest?.('a')?.href ?? href;
                push(url);
            }
            event.preventDefault();
        };
        useEffectFocusOnOpen(forwardedInputRef || inputRef, isSearchMenuOpen);
        const features = {
            hasSoftwareAccess: appPermissions.hasSoftwareAccess,
            hasAdvancedRoadmapsAccess: hasEditOrViewPlanPermission,
            issueNavigatorTransitionOn: true,
            isNINSmartQuerySPATransitionOn: true,
            isReportedByMeFilterEnabled: true,
            isPreviewOnJiraSearchResultsEnabled: true,
            enableIssueLabelsFilter: true,
            enableDateFromFilter: true
        };
        const dialogProps = {
            isExpanded: isSearchMenuOpen,
            onOpen: onOpen,
            onClose: closeMenu,
            onNavigate: onNavigate,
            jiraFeatures: features,
            formatDate: formatDate,
            dialogFeatures: undefined,
            theme: theme?.mode?.search,
            pageLoadMetrics: {
                metric: (0, (0, parcelRequire("crtj2")).searchDialogMetric),
                customDataGetter: (0, ($parcel$interopDefault($8Rkzz)))
            }
        };
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('hot-113350-search-optimisation-experiement')) return (0, ($parcel$interopDefault($5uXOq))).createElement(JsErrorBoundary, {
            id: "jira-quick-search",
            packageName: "product-search-dialog",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ClientProvider, {
            cloudId: cloudId,
            baseUrl: baseUrl,
            isAnonymous: isAnonymous,
            atlassianAccountId: atlassianAccountId
        }, ({ aggregatorUrl: aggregatorUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement(SearchInputWrapper, {
                "data-testid": testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(SearchInputOverrider, null, (0, ($parcel$interopDefault($5uXOq))).createElement(ExtensibleCrossProductSearchDialog, {
                ...dialogProps,
                cloudId: cloudId,
                aggregatorUrl: aggregatorUrl,
                forwardRef: forwardedInputRef || inputRef
            })))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement(JsErrorBoundary, {
            id: "jira-quick-search",
            packageName: "product-search-dialog",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ClientProvider, {
            cloudId: cloudId,
            baseUrl: baseUrl,
            isAnonymous: isAnonymous,
            atlassianAccountId: atlassianAccountId
        }, ({ aggregatorUrl: aggregatorUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement(SearchInputWrapper, {
                "data-testid": testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(SearchInputOverrider, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
                name: (0, (0, parcelRequire("Mp6qH")).SEARCH_SPOTLIGHT_KEY)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement(ExtensibleCrossProductSearchDialog, {
                ...dialogProps,
                cloudId: cloudId,
                aggregatorUrl: aggregatorUrl,
                forwardRef: forwardedInputRef || inputRef
            }))), !false ? (0, ($parcel$interopDefault($5uXOq))).createElement(EngagementSpotlight, {
                engagementId: (0, (0, parcelRequire("Mp6qH")).SEARCH_SPOTLIGHT_KEY)
            }) : null))));
    });
    const $51999f6351274dfb$export$4b85d3515bd863a5 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uXxK")).TopLevelErrorBoundary), {
            id: (0, (0, parcelRequire("Mp6qH")).NAVIGATION_ITEM_ID).SEARCH
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($51999f6351274dfb$var$Search, props));
    const $51999f6351274dfb$var$SearchInputWrapperDI = (props)=>{
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $51999f6351274dfb$var$styles.searchInputWrapper,
                $51999f6351274dfb$var$styles.nav4SearchInputWrapper
            ])
        }, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-vc": `search-input-wrapper${false ? '-ssr' : ''}`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $51999f6351274dfb$var$styles.searchInputWrapper
            ])
        }, props.children);
    };
    const $51999f6351274dfb$var$SearchInputOverriderDI = (props)=>{
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $51999f6351274dfb$var$styles.searchInputOverrider,
                $51999f6351274dfb$var$styles.nav4SearchInputOverrider
            ])
        }, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $51999f6351274dfb$var$styles.searchInputOverrider
            ])
        }, props.children);
    };
});
parcelRegister("15rEL", function(module, exports) {
    $parcel$export(module.exports, "getRelativeTimeAndUnit", ()=>$dff2faa5ae8b6f27$export$307c4b8ee56b97bb);
    $parcel$export(module.exports, "FormattedRelativeV2", ()=>$dff2faa5ae8b6f27$export$7317ee2f88fd1276);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7anB;
    var $2tElP;
    const $dff2faa5ae8b6f27$var$getTimeInUnits = (unitValue)=>{
        const seconds = unitValue / 1000;
        const minutes = seconds / 60;
        const hours = minutes / 60;
        const days = hours / 24;
        const weeks = days / 7;
        const months = weeks / 4;
        const years = months / 12;
        return {
            seconds: seconds,
            minutes: minutes,
            hours: hours,
            days: days,
            weeks: weeks,
            months: months,
            years: years
        };
    };
    const $dff2faa5ae8b6f27$export$307c4b8ee56b97bb = (value, units)=>{
        const timeInMilliseconds = new Date(value);
        const delta = timeInMilliseconds - Date.now();
        let valueInUnit;
        if (!units) {
            const { value: time, unit: unit } = (0, (0, parcelRequire("j7anB")).selectUnit)(timeInMilliseconds, new Date());
            return {
                time: time,
                unit: unit
            };
        }
        const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $dff2faa5ae8b6f27$var$getTimeInUnits(delta);
        switch(units){
            case 'second':
                valueInUnit = seconds;
                break;
            case 'minute':
                valueInUnit = minutes;
                break;
            case 'hour':
                valueInUnit = hours;
                break;
            case 'day':
                valueInUnit = days;
                break;
            case 'week':
                valueInUnit = weeks;
                break;
            case 'month':
                valueInUnit = months;
                break;
            case 'year':
                valueInUnit = years;
                break;
            default:
                valueInUnit = 0;
                break;
        }
        return {
            time: Math.ceil(valueInUnit),
            unit: units
        };
    };
    const $dff2faa5ae8b6f27$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
        const { time: time, unit: unit } = $dff2faa5ae8b6f27$export$307c4b8ee56b97bb(value, units);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: time,
            unit: unit,
            numeric: style === 'numeric' ? 'always' : 'auto',
            format: format,
            updateIntervalInSeconds: updateInterval
        }, children);
    };
    $dff2faa5ae8b6f27$export$7317ee2f88fd1276.displayName = 'FormattedRelative';
});
parcelRegister("bMQpY", function(module, exports) {
    $parcel$export(module.exports, "ClientProvider", ()=>$5381ac7e84b10acd$export$5d91bb6ce8e0f47);
    var $5uXOq = parcelRequire("5uXOq");
    var $9YbJT;
    var $3nZO6;
    const $5381ac7e84b10acd$export$5d91bb6ce8e0f47 = ({ JiraSearchClientProvider: JiraSearchClientProvider = (0, (0, parcelRequire("3nZO6")).JiraSearchClientProvider), ConfluenceClientsProvider: ConfluenceClientsProvider = (0, (0, parcelRequire("9YbJT")).ConfluenceClientsProvider), children: children, cloudId: cloudId, isAnonymous: isAnonymous, baseUrl: baseUrl, atlassianAccountId: atlassianAccountId })=>{
        const clientProviderConfig = {
            cloudId: cloudId,
            isUserAnonymous: isAnonymous,
            aggregatorUrl: `${baseUrl}/${(0, $3858a166c616a5ee$export$58d86c1da4a2ca1)}`,
            baseUrl: `${window.location.protocol}//${window.location.hostname}${baseUrl}`,
            collaborationGraphUrl: '/gateway/api/collaboration',
            accountId: atlassianAccountId
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement(JiraSearchClientProvider, clientProviderConfig, (0, ($parcel$interopDefault($5uXOq))).createElement(ConfluenceClientsProvider, {
            config: {
                ...clientProviderConfig,
                baseUrl: `${clientProviderConfig.baseUrl}/wiki`
            }
        }, children(clientProviderConfig)));
    };
});
parcelRegister("9YbJT", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceClientsProvider", ()=>$dd7d1a2d5f811ad9$export$43e8a9214cb124ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $9rqWx;
    var $8QpSo;
    var $6SBvm = parcelRequire("6SBvm");
    var $8RYU8;
    var $jFHlY;
    var $ckvH1;
    var $7Jxgt = parcelRequire("7Jxgt");
    const $dd7d1a2d5f811ad9$var$defaultCollaborationGraphConfig = {
        collaborationGraphUrl: 'gateway/api/collaboration',
        useCollaborationGraphForRecents: false
    };
    const $dd7d1a2d5f811ad9$var$getSearchClientWithConfig = (0, (0, parcelRequire("8QpSo")).default)((config, collabGraphClient)=>new (0, (0, parcelRequire("9rqWx")).ConfluenceSearchClient)(config, collabGraphClient), (0, ($parcel$interopDefault($6SBvm))));
    const $dd7d1a2d5f811ad9$var$getRecentsClientWithConfig = (0, (0, parcelRequire("8QpSo")).default)((config, collabGraphClient)=>new (0, (0, parcelRequire("8RYU8")).ConfluenceRecentsClient)(config, collabGraphClient), (0, ($parcel$interopDefault($6SBvm))));
    const $dd7d1a2d5f811ad9$var$getCollabGraphClientWithConfig = (0, (0, parcelRequire("8QpSo")).default)((config)=>new (0, (0, parcelRequire("jFHlY")).CollaborationGraphClient)({
            collaborationGraphUrl: config.collaborationGraphUrl,
            cloudId: config.cloudId,
            isMultiSite: config.isMultiSite,
            collabGraphSessionId: config.collabGraphSessionId,
            sites: config.sites
        }), (0, ($parcel$interopDefault($6SBvm))));
    const $dd7d1a2d5f811ad9$export$5a44dbd630fde657 = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    const $dd7d1a2d5f811ad9$var$MISSING_PROVIDER_ERROR = new Error(`Could not find all required Clients, make sure ConfluenceClientsProvider is created further up the tree`);
    const $dd7d1a2d5f811ad9$var$COLLABORATION_GRAPH_SESSION_ID = (0, $7Jxgt.v4)();
    const $dd7d1a2d5f811ad9$export$413dca1b70dbb4a7 = (Component)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($dd7d1a2d5f811ad9$export$5a44dbd630fde657.Consumer, null, ({ searchClient: searchClient, recentClient: recentClient, cloudId: cloudId, siteUrl: siteUrl = '', sites: sites, collabGraphSessionId: collabGraphSessionId })=>{
                if (!searchClient || !recentClient) throw $dd7d1a2d5f811ad9$var$MISSING_PROVIDER_ERROR;
                const { ...rest } = props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...rest,
                    searchClient: searchClient,
                    recentClient: recentClient,
                    cloudId: cloudId,
                    collabGraphSessionId: collabGraphSessionId,
                    siteUrl: siteUrl,
                    sites: sites
                });
            });
    };
    const $dd7d1a2d5f811ad9$export$43e8a9214cb124ba = ({ children: children, config: config })=>{
        const { baseUrl: baseUrl, cloudId: cloudId, collaborationGraphUrl: collaborationGraphUrl, aggregatorUrl: aggregatorUrl, isUserAnonymous: isUserAnonymous, useCollaborationGraphForRecents: useCollaborationGraphForRecents, recentItemsSupplier: recentItemsSupplier, sites: sites = [], collabGraphSessionId: collabGraphSessionId, scopes: scopes, useGraphQLClient: useGraphQLClient, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl } = {
            ...$dd7d1a2d5f811ad9$var$defaultCollaborationGraphConfig,
            ...config
        };
        const siteUrl = (0, (0, parcelRequire("ckvH1")).extractSiteUrl)(config);
        const collabGraphClient = $dd7d1a2d5f811ad9$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: collaborationGraphUrl,
            cloudId: cloudId,
            isMultiSite: sites.length > 1,
            sites: sites,
            collabGraphSessionId: collabGraphSessionId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dd7d1a2d5f811ad9$export$5a44dbd630fde657.Provider, {
            value: {
                searchClient: $dd7d1a2d5f811ad9$var$getSearchClientWithConfig({
                    isUserAnonymous: isUserAnonymous,
                    url: aggregatorUrl,
                    cloudId: cloudId,
                    isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                    siteMasterList: sites,
                    scopes: scopes,
                    useGraphQLClient: useGraphQLClient
                }, collabGraphClient),
                recentClient: $dd7d1a2d5f811ad9$var$getRecentsClientWithConfig({
                    url: baseUrl,
                    isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                    recentItemsSupplier: recentItemsSupplier,
                    useRecentWork: useRecentWork,
                    recentWorkAPIUrl: recentWorkAPIUrl
                }, collabGraphClient),
                collabGraphClient: collabGraphClient,
                siteUrl: siteUrl,
                cloudId: cloudId,
                sites: sites,
                collabGraphSessionId: $dd7d1a2d5f811ad9$var$COLLABORATION_GRAPH_SESSION_ID
            }
        }, children);
    };
    const $dd7d1a2d5f811ad9$export$4823a6cc022cca16 = ()=>{
        const context = (0, ($parcel$interopDefault($5uXOq))).useContext($dd7d1a2d5f811ad9$export$5a44dbd630fde657);
        if (!context.searchClient || !context.recentClient) throw $dd7d1a2d5f811ad9$var$MISSING_PROVIDER_ERROR;
        return context;
    };
    const $dd7d1a2d5f811ad9$export$376c08f4921c6b8d = ()=>{
        const context = (0, ($parcel$interopDefault($5uXOq))).useContext($dd7d1a2d5f811ad9$export$5a44dbd630fde657);
        return context.recentClient;
    };
});
parcelRegister("9rqWx", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceSearchClient", ()=>$471e7052ca87b8fc$export$2bdc82bf1cf036b4);
    var $aHYZV;
    var $3JOCw = parcelRequire("3JOCw");
    var $zo35K;
    var $lQmoS;
    var $3GGIR;
    var $k7rsK;
    var $ckvH1;
    var $cm5BA;
    var $jmwt7;
    const $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
    const $471e7052ca87b8fc$var$EMPTY_RESULT_PROMISE = Promise.resolve({
        items: [],
        timings: 0
    });
    class $471e7052ca87b8fc$export$2bdc82bf1cf036b4 {
        static{
            this.ITEM_RESULT_LIMIT = 30;
        }
        static{
            this.SPACE_RESULT_LIMIT = 10;
        }
        static{
            this.PEOPLE_RESULT_LIMIT = 10;
        }
        constructor(config, collabGraphClient){
            this.abTestDataCache = null;
            this.permissionsDataCache = null;
            this.searchWithFilters = (query, filters, context, modelParams, sites)=>{
                const scopes = [
                    (0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment
                ];
                const allFilters = [];
                let baseSpaceFilters = null;
                let baseUserFilters = null;
                let baseTimeFilters = null;
                filters.forEach((filter)=>{
                    switch(filter.type){
                        case 'space':
                            if (!baseSpaceFilters) {
                                baseSpaceFilters = {
                                    '@type': 'spaces',
                                    spaceKeys: []
                                };
                                allFilters.push(baseSpaceFilters);
                            }
                            baseSpaceFilters.spaceKeys.push(filter.id);
                            break;
                        case 'contributor':
                            if (!baseUserFilters) {
                                baseUserFilters = {
                                    '@type': 'contributors',
                                    accountIds: []
                                };
                                allFilters.push(baseUserFilters);
                            }
                            baseUserFilters.accountIds.push(filter.id);
                            break;
                        case 'lastModified':
                            if (!baseTimeFilters) {
                                baseTimeFilters = {
                                    '@type': 'lastModified',
                                    from: filter.id
                                };
                                allFilters.push(baseTimeFilters);
                            }
                            break;
                        default:
                            break;
                    }
                });
                const responseAndTiming = this.aggregatorClient.search({
                    query: query,
                    context: context,
                    scopes: scopes,
                    modelParams: modelParams,
                    resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                    filters: allFilters,
                    experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                    sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
                });
                const results = {
                    [(0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope((0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment), requestDurationMs))),
                    [(0, (0, parcelRequire("3GGIR")).Scope).ConfluenceSpace]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from($471e7052ca87b8fc$var$EMPTY_RESULT_PROMISE),
                    [(0, (0, parcelRequire("3GGIR")).Scope).UserConfluence]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from($471e7052ca87b8fc$var$EMPTY_RESULT_PROMISE)
                };
                return results;
            };
            this.recentPeopleSupplier = (context, sites)=>{
                if (this.isUserAnonymous) return Promise.resolve({
                    items: [],
                    timings: 0
                });
                if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getUsers().then((response)=>this.mapCollabGraphPeople(response));
                return this.aggregatorClient.search({
                    query: '',
                    context: context,
                    scopes: [
                        (0, (0, parcelRequire("3GGIR")).Scope).UserConfluence
                    ],
                    modelParams: [],
                    resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
                    experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                    sites: sites?.map((s)=>s.cloudId)
                }).then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, (0, parcelRequire("3GGIR")).Scope).UserConfluence), requestDurationMs, sites.length > 0));
            };
            this.mapUrsPeople = (response, timings, isMultiSite)=>{
                if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, (0, parcelRequire("3GGIR")).Scope).UserConfluence}`);
                if (response.error) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(response.error);
                const items = response.results.map((item)=>({
                        resultType: (0, (0, parcelRequire("3GGIR")).PersonResult),
                        resultId: `people-${item.id}`,
                        userId: item.id,
                        name: item.name,
                        href: (0, (0, parcelRequire("ckvH1")).generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
                        avatarUrl: item.avatarUrl,
                        contentType: (0, (0, parcelRequire("3GGIR")).Person),
                        analyticsType: (0, (0, parcelRequire("3GGIR")).ResultPerson),
                        mentionName: item.nickname || '',
                        presenceMessage: ''
                    }));
                return {
                    items: (0, ($parcel$interopDefault($3JOCw)))(items, (item)=>item.resultId),
                    timings: timings
                };
            };
            this.mapCollabGraphPeople = (response)=>{
                const items = response.collaborationGraphEntities.map((item)=>({
                        resultId: item.userProfile.account_id,
                        userId: item.userProfile.account_id,
                        name: item.userProfile.name,
                        href: `${(0, (0, parcelRequire("ckvH1")).mapTenantIdToSiteUrl)(item.siteId, this.siteMasterList)}/people/${item.userProfile.account_id}`,
                        analyticsType: (0, (0, parcelRequire("3GGIR")).RecentPerson),
                        mentionName: item.userProfile.name,
                        presenceMessage: item.userProfile.name,
                        resultType: (0, (0, parcelRequire("3GGIR")).PersonResult),
                        avatarUrl: item.userProfile.picture,
                        contentType: (0, (0, parcelRequire("3GGIR")).Person)
                    }));
                return {
                    items: items,
                    timings: response.timings
                };
            };
            const { siteMasterList: siteMasterList, scopes: scopes } = config;
            this.aggregatorClient = new (0, (0, parcelRequire("zo35K")).AggregatorClient)(config);
            this.graphQLClient = new (0, (0, parcelRequire("jmwt7")).GraphQLClient)(config);
            this.isUserAnonymous = config.isUserAnonymous;
            this.useGraphQLClient = config.useGraphQLClient || false;
            this.bootstrapPeopleCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.recentPeopleSupplier);
            this.siteMasterList = siteMasterList;
            this.collaborationGraphClient = collabGraphClient;
            this.isCollabGraphEnabled = config.isCollaborationGraphEnabled;
            this.scopes = {
                itemScope: scopes?.itemScope ? scopes.itemScope : (0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment,
                spaceScope: scopes?.spaceScope ? scopes.spaceScope : (0, (0, parcelRequire("3GGIR")).Scope).ConfluenceSpace,
                ursUserScope: scopes?.ursUserScope ? scopes.ursUserScope : (0, (0, parcelRequire("3GGIR")).Scope).UserConfluence
            };
        }
        search(query, filters, context, queryVersion, sites) {
            const modelParams = [
                {
                    '@type': 'queryParams',
                    queryVersion: queryVersion
                }
            ];
            if (filters.length > 0) return this.searchWithFilters(query, filters, context, modelParams, sites);
            if (this.useGraphQLClient) this.graphQLClient.search({
                query: query,
                context: context,
                entities: (0, (0, parcelRequire("cm5BA")).CONFLUENCE_ITEM_ENTITIES),
                modelParams: modelParams,
                resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            const scopes = [
                this.scopes.itemScope,
                this.scopes.spaceScope,
                this.scopes.ursUserScope
            ];
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                filters: [],
                experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            const allResults = {
                [(0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope(this.scopes.itemScope), requestDurationMs))),
                [(0, (0, parcelRequire("3GGIR")).Scope).ConfluenceSpace]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope(this.scopes.spaceScope), requestDurationMs))),
                [(0, (0, parcelRequire("3GGIR")).Scope).UserConfluence]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope(this.scopes.ursUserScope), requestDurationMs, sites.length > 0)))
            };
            return allResults;
        }
        searchSpaces(query, context, sites) {
            const scopes = [
                (0, (0, parcelRequire("3GGIR")).Scope).ConfluenceSpace
            ];
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: [],
                resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT,
                filters: [],
                experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            return (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope((0, (0, parcelRequire("3GGIR")).Scope).ConfluenceSpace), requestDurationMs)));
        }
        searchUsers(query, context, sites) {
            const scopes = [
                (0, (0, parcelRequire("3GGIR")).Scope).UserConfluence
            ];
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: [],
                resultLimit: $471e7052ca87b8fc$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
                filters: [],
                experience: $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            return (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, (0, parcelRequire("3GGIR")).Scope).UserConfluence), requestDurationMs, sites.length > 0)));
        }
        getRecentPeople(context, sites) {
            const { fromCache: fromCache, value: value } = this.bootstrapPeopleCache.get(context, sites);
            return new (0, (0, parcelRequire("aHYZV")).CancellablePromise)(value.then((results)=>({
                    ...results,
                    isCached: fromCache
                })));
        }
        async getProductPermissions(products) {
            if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE);
            return this.permissionsDataCache;
        }
        async getAbTestData() {
            if (this.abTestDataCache) return this.abTestDataCache;
            const abTest = await this.aggregatorClient.getAbTestData((0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment, $471e7052ca87b8fc$var$NAVIGATION_V3_EXPERIENCE);
            this.abTestDataCache = abTest;
            return abTest;
        }
        mapConfItem(response, timings) {
            if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, (0, parcelRequire("3GGIR")).Scope).ConfluencePageBlogAttachment}`);
            if (response.error) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(response.error);
            function removeHighlightTags(text) {
                return text.replace(/@@@hl@@@|@@@endhl@@@/g, '');
            }
            const items = response.results.map((item)=>({
                    resultId: item.content.id,
                    name: removeHighlightTags(item.title),
                    href: `${item.baseUrl}${item.url}`,
                    containerName: item.container.title,
                    analyticsType: (0, (0, parcelRequire("3GGIR")).ResultConfluence),
                    contentType: `confluence-${item.content.type}`,
                    resultType: (0, (0, parcelRequire("3GGIR")).ConfluenceObjectResult),
                    containerId: item.content.space && item.content.space.id ? item.content.space.id : 'UNAVAILABLE',
                    spaceId: item.container.id,
                    iconClass: item.iconCssClass,
                    lastModified: item.lastModified,
                    isRecentResult: false
                }));
            return {
                items: items,
                totalSize: response.size !== undefined ? response.size : response.results.length,
                timings: timings
            };
        }
        mapConfSpace(response, timings) {
            if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, (0, parcelRequire("3GGIR")).Scope).ConfluenceSpace}`);
            if (response.error) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(response.error);
            const items = response.results.map((item)=>({
                    resultId: item.id,
                    avatarUrl: `${item.baseUrl}${item.space.icon.path}`,
                    name: item.container.title,
                    href: `${item.baseUrl || ''}${item.container.displayUrl}`,
                    analyticsType: (0, (0, parcelRequire("3GGIR")).ResultConfluence),
                    resultType: (0, (0, parcelRequire("3GGIR")).GenericContainerResult),
                    contentType: (0, (0, parcelRequire("3GGIR")).ConfluenceSpace),
                    key: item.space.key,
                    id: item.id
                }));
            return {
                items: items,
                timings: timings
            };
        }
    }
});
parcelRegister("aHYZV", function(module, exports) {
    $parcel$export(module.exports, "CancellablePromise", ()=>$51cb7e70082e66c9$export$5782acf08706f13d);
    class $51cb7e70082e66c9$export$d7f5e52d091a66db extends Error {
        constructor(...args){
            super(...args), this.isCancelled = true;
        }
    }
    const $51cb7e70082e66c9$var$CANCEL_ERROR = new $51cb7e70082e66c9$export$d7f5e52d091a66db('Promise is cancelled');
    class $51cb7e70082e66c9$export$5782acf08706f13d {
        constructor(promise){
            this.cancelInternal = ()=>{
                throw new Error('Programming error, cancelling promise is not properly rejected');
            };
            this.promise = ()=>this.cancellablePromiseInternal;
            this.cancel = ()=>this.cancelInternal();
            this.cancellablePromiseInternal = Promise.race([
                promise,
                new Promise((_, reject)=>{
                    this.cancelInternal = ()=>reject($51cb7e70082e66c9$var$CANCEL_ERROR);
                })
            ]);
        }
        static from(promise) {
            return new $51cb7e70082e66c9$export$5782acf08706f13d(promise);
        }
    }
});
parcelRegister("zo35K", function(module, exports) {
    $parcel$export(module.exports, "AggregatorClient", ()=>$e6310830ec3a84a0$export$842695bca69eca86);
    var $dS9cn = parcelRequire("dS9cn");
    var $lFNae;
    var $ckvH1;
    var $ejWYQ;
    var $dZkNM;
    class $e6310830ec3a84a0$export$842695bca69eca86 {
        static{
            this.EXPERIMENT_URL_PATH = 'experiment/v1';
        }
        static{
            this.QUICKSEARCH_API_URL = 'quicksearch/v1';
        }
        constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList, backendExperiment: backendExperiment }){
            this.getAggregatorConfig = ()=>{
                return {
                    url: this.serviceConfig.url,
                    cloudId: this.cloudId,
                    siteMasterList: this.siteMasterList
                };
            };
            this.getGenericProductPermissions = async (args)=>{
                return (0, (0, parcelRequire("dZkNM")).getFetchProductPermissions)(this.makeGetRequest)(args.productIds, this.cloudId, args.experience);
            };
            this.batchedGetExtensibleProductPermission = (0, (0, parcelRequire("ejWYQ")).batchMethod)((args)=>{
                const emptyProductPermissions = {
                    productIds: [],
                    experience: ''
                };
                if (args.length === 0) return emptyProductPermissions;
                return args.reduce((acc, arg)=>{
                    return {
                        productIds: [
                            ...acc.productIds,
                            ...arg.productIds
                        ],
                        experience: arg.experience
                    };
                }, emptyProductPermissions);
            }, this.getGenericProductPermissions, (response, id)=>response.get(id) || []);
            this.makePostRequest = (path, body)=>{
                const options = {
                    path: path,
                    requestInit: {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    }
                };
                return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
            };
            this.makeGetRequest = (path)=>{
                const options = {
                    path: path,
                    requestInit: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                };
                return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
            };
            this.serviceConfig = {
                url: url
            };
            this.cloudId = cloudId;
            this.siteMasterList = siteMasterList;
            this.backendExperiment = backendExperiment;
        }
        async getAbTestData(scope, experience, product) {
            const body = {
                cloudId: this.cloudId,
                scopes: [
                    scope
                ],
                experience: experience,
                product: product
            };
            const response = await this.makePostRequest($e6310830ec3a84a0$export$842695bca69eca86.EXPERIMENT_URL_PATH, body);
            const scopeWithAbTest = response.scopes.find((s)=>s.id === scope);
            const abTestPromise = scopeWithAbTest ? Promise.resolve(scopeWithAbTest.abTest) : Promise.resolve(null);
            return abTestPromise;
        }
        async getProductScopes(productId, experience) {
            const productScopeMap = await this.getGenericProductPermissions({
                productIds: [
                    productId
                ],
                experience: experience
            });
            return productScopeMap.get(productId) || [];
        }
        async getProductPermissions(products, experience) {
            const lowercaseProductIds = products.map((p)=>p.toLowerCase());
            const productScopeMap = await this.getGenericProductPermissions({
                productIds: lowercaseProductIds,
                experience: experience
            });
            return lowercaseProductIds.filter((product)=>productScopeMap.get(product)?.length).map((product)=>product.toUpperCase());
        }
        async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
            const cloudId = this.cloudId;
            const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, (0, parcelRequire("ckvH1")).limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
            const body = {
                query: query,
                cloudId: cloudId,
                limit: resultLimit,
                scopes: scopes,
                filters: filters,
                searchSession: context,
                ...modelParams.length > 0 ? {
                    modelParams: modelParams
                } : {},
                experience: experience,
                cloudIds: cloudIdsToFilterOn,
                experimentId: this.backendExperiment?.experimentId,
                shadowExperimentId: this.backendExperiment?.shadowExperimentId
            };
            const { result: response, durationMs: requestDurationMs } = await (0, (0, parcelRequire("lFNae")).timed)(this.makePostRequest($e6310830ec3a84a0$export$842695bca69eca86.QUICKSEARCH_API_URL, body));
            return {
                response: {
                    rawData: response,
                    retrieveScope: (scope)=>response.scopes.find((s)=>s.id === scope) || null
                },
                requestDurationMs: requestDurationMs
            };
        }
    }
});
parcelRegister("lFNae", function(module, exports) {
    $parcel$export(module.exports, "timed", ()=>$11fc4f474ad1f553$export$d35186a762cd39c8);
    const $11fc4f474ad1f553$export$d35186a762cd39c8 = async (promise)=>{
        const startTime = Date.now();
        const result = await promise;
        const duration = Date.now() - startTime;
        return {
            result: result,
            durationMs: duration
        };
    };
});
parcelRegister("ckvH1", function(module, exports) {
    $parcel$export(module.exports, "extractSiteUrl", ()=>$1443f685fc002ca7$export$c9a345fa92182d1c);
    $parcel$export(module.exports, "mapTenantIdToSiteUrl", ()=>$1443f685fc002ca7$export$fdb149c8c29e67a2);
    $parcel$export(module.exports, "extractSiteIdBySiteUrl", ()=>$1443f685fc002ca7$export$4be99cb40bcf5aef);
    $parcel$export(module.exports, "generatePeopleProfileUrl", ()=>$1443f685fc002ca7$export$ca98b3a6d1ea77f3);
    $parcel$export(module.exports, "limitToMaxSiteUsage", ()=>$1443f685fc002ca7$export$ba81234f3ab84a86);
    const $1443f685fc002ca7$export$c9a345fa92182d1c = ({ siteUrl: siteUrl, sites: sites })=>{
        if (siteUrl) return siteUrl;
        if (sites && sites.length > 0) return sites[0].siteUrl;
        return '';
    };
    const $1443f685fc002ca7$export$fdb149c8c29e67a2 = (siteId, sites)=>{
        const matchingSite = sites.find((site)=>site.cloudId === siteId);
        return matchingSite ? matchingSite.siteUrl : '';
    };
    const $1443f685fc002ca7$export$4be99cb40bcf5aef = (absSiteUrl, sites = [])=>{
        const baseUrlRegex = /^(http(s)?:\/\/[^\/]+)/;
        const urlRegexMatches = absSiteUrl.match(baseUrlRegex);
        if (!urlRegexMatches) return '';
        const baseUrl = urlRegexMatches[0];
        const matchingSite = sites.find((site)=>site.siteUrl === baseUrl);
        return matchingSite ? matchingSite.cloudId : '';
    };
    const $1443f685fc002ca7$export$ca98b3a6d1ea77f3 = (isMultiSite, absoluteUrl = '', accountId, contextPath = '')=>{
        if (isMultiSite && absoluteUrl) return absoluteUrl;
        return contextPath ? `/${contextPath}/people/${accountId}` : `/people/${accountId}`;
    };
    const $1443f685fc002ca7$var$MAX_SITES_INITIAL_QUERY = 3;
    const $1443f685fc002ca7$export$ba81234f3ab84a86 = (sites = [])=>{
        return sites.slice(0, $1443f685fc002ca7$var$MAX_SITES_INITIAL_QUERY);
    };
});
parcelRegister("ejWYQ", function(module, exports) {
    $parcel$export(module.exports, "batchMethod", ()=>$a7dae7cbb19bb5a7$export$198da76335167312);
    var $lFKmC = parcelRequire("lFKmC");
    const $a7dae7cbb19bb5a7$export$198da76335167312 = (argumentResolver, finalFn, successfulResponseMapper, debounceTime = 100)=>{
        const batchMap = {};
        const timedFn = (0, ($parcel$interopDefault($lFKmC)))(()=>{
            const inFlightRequestsMap = {
                ...batchMap
            };
            const keys = Object.keys(inFlightRequestsMap);
            const args = keys.map((key)=>inFlightRequestsMap[key].arg);
            finalFn(argumentResolver(args)).then((response)=>{
                keys.forEach((key)=>{
                    inFlightRequestsMap[key].resolve(successfulResponseMapper(response, key));
                });
            }).catch(()=>{
                keys.forEach((product)=>{
                    inFlightRequestsMap[product].reject();
                });
            }).finally(()=>keys.forEach((key)=>delete batchMap[key]));
        }, debounceTime);
        return (id, arg)=>{
            const promise = new Promise((resolve, reject)=>{
                batchMap[id] = {
                    resolve: resolve,
                    reject: reject,
                    arg: arg
                };
            });
            timedFn();
            return promise;
        };
    };
});
parcelRegister("dZkNM", function(module, exports) {
    $parcel$export(module.exports, "getFetchProductPermissions", ()=>$981ee2355df2e9f0$export$b756f4e692ecc8f);
    const $981ee2355df2e9f0$var$SCOPES_API_URL = 'scopes/v1';
    const $981ee2355df2e9f0$export$b756f4e692ecc8f = (makeRequest)=>async (productIds, cloudId, experience)=>{
            if (productIds.length === 0) return Promise.resolve(new Map());
            try {
                const productParams = productIds.map((productId)=>[
                        'productId',
                        productId
                    ]);
                const params = new URLSearchParams([
                    [
                        'experience',
                        experience
                    ],
                    ...productParams
                ]);
                const path = `${$981ee2355df2e9f0$var$SCOPES_API_URL}/${cloudId}?${params.toString()}`;
                const response = await makeRequest(path);
                return new Map(Object.keys(response.products).map((product)=>[
                        product,
                        response.products[product]
                    ]));
            } catch (e) {
                return new Map();
            }
        };
});
parcelRegister("lQmoS", function(module, exports) {
    $parcel$export(module.exports, "responseErrorToError", ()=>$b0458111dc193a05$export$59a963eec12b52ed);
    function $b0458111dc193a05$export$59a963eec12b52ed(responseError) {
        let stringRepresentation = 'undefined';
        const error = responseError.message ? responseError.message : responseError;
        if (error) {
            stringRepresentation = String(error);
            if (typeof error === 'object') try {
                stringRepresentation = JSON.stringify(responseError);
            } catch  {}
        }
        return new Error(stringRepresentation);
    }
});
parcelRegister("3GGIR", function(module, exports) {
    $parcel$export(module.exports, "Scope", ()=>$000ed1db71ba91f1$export$775b6bb06e53a214);
    $parcel$export(module.exports, "GenericContainerResult", ()=>$000ed1db71ba91f1$export$6ec00f56b27cdc1d);
    $parcel$export(module.exports, "PersonResult", ()=>$000ed1db71ba91f1$export$ca1a50bc869949e);
    $parcel$export(module.exports, "ConfluenceObjectResult", ()=>$000ed1db71ba91f1$export$a99961038e9d5471);
    $parcel$export(module.exports, "RecentConfluence", ()=>$000ed1db71ba91f1$export$18c69de2b4aa679c);
    $parcel$export(module.exports, "ResultConfluence", ()=>$000ed1db71ba91f1$export$dc31f0db54ab1a30);
    $parcel$export(module.exports, "RecentPerson", ()=>$000ed1db71ba91f1$export$cb8b6c470492bee8);
    $parcel$export(module.exports, "ResultPerson", ()=>$000ed1db71ba91f1$export$ebb42dafe7a39a20);
    $parcel$export(module.exports, "ConfluenceSpace", ()=>$000ed1db71ba91f1$export$8ee8726ca4e2f8bd);
    $parcel$export(module.exports, "Person", ()=>$000ed1db71ba91f1$export$d0e824889e01c751);
    var $000ed1db71ba91f1$export$775b6bb06e53a214;
    (function(Scope) {
        Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
        Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
        Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
        Scope["ConfluenceSpace"] = "confluence.space";
        Scope["UserConfluence"] = "urs.user-confluence";
    })($000ed1db71ba91f1$export$775b6bb06e53a214 || ($000ed1db71ba91f1$export$775b6bb06e53a214 = {}));
    const $000ed1db71ba91f1$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
    const $000ed1db71ba91f1$export$da1906f69c8621ca = 'confluence.page,blogpost';
    const $000ed1db71ba91f1$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
    const $000ed1db71ba91f1$export$80a5be864676016b = 'confluence.space';
    const $000ed1db71ba91f1$export$70542451ad6057d2 = 'urs.user-confluence';
    const $000ed1db71ba91f1$export$6ec00f56b27cdc1d = 'generic-container-result';
    const $000ed1db71ba91f1$export$ca1a50bc869949e = 'person-result';
    const $000ed1db71ba91f1$export$a99961038e9d5471 = 'confluence-object-result';
    const $000ed1db71ba91f1$export$18c69de2b4aa679c = 'recent-confluence';
    const $000ed1db71ba91f1$export$dc31f0db54ab1a30 = 'result-confluence';
    const $000ed1db71ba91f1$export$cb8b6c470492bee8 = 'recent-person';
    const $000ed1db71ba91f1$export$ebb42dafe7a39a20 = 'result-person';
    const $000ed1db71ba91f1$export$602b44a55c824e30 = 'advanced-search-confluence';
    const $000ed1db71ba91f1$export$3eb1eaefdca3e463 = 'advanced-search-people';
    const $000ed1db71ba91f1$export$bbd1709e62826142 = 'confluence-page';
    const $000ed1db71ba91f1$export$4a1ec8cc030bc82a = 'confluence-blogpost';
    const $000ed1db71ba91f1$export$b441f0c13fd510b9 = 'confluence-attachment';
    const $000ed1db71ba91f1$export$8ee8726ca4e2f8bd = 'confluence-space';
    const $000ed1db71ba91f1$export$d0e824889e01c751 = 'person';
});
parcelRegister("k7rsK", function(module, exports) {
    $parcel$export(module.exports, "SimpleCache", ()=>$320d4902f9d2c6a3$export$de40364712978bcb);
    class $320d4902f9d2c6a3$export$de40364712978bcb {
        static{
            this.DEFAULT_TIMEOUT_IN_MS = 900000;
        }
        constructor(supplier, initialValue = null, timeoutMs = $320d4902f9d2c6a3$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS){
            this.nextCacheRefreshTime = Date.now();
            this.timeoutMs = timeoutMs;
            this.supplier = supplier;
            this.currentValue = null;
            if (initialValue) {
                this.currentValue = initialValue;
                this.updateNextRefreshTime();
            }
        }
        get(...args) {
            if (!this.currentValue || Date.now() >= this.nextCacheRefreshTime) {
                this.updateNextRefreshTime();
                let exception = new Error('');
                try {
                    const result = this.supplier(...args);
                    this.currentValue = result;
                    if (this.currentValue) return {
                        fromCache: false,
                        value: this.currentValue
                    };
                } catch (e) {
                    this.invalidate();
                    exception = e;
                }
                if (!this.currentValue) throw new Error(`Failed to initialise a value for the cache: ${exception?.stack}`);
            }
            return {
                fromCache: true,
                value: this.currentValue
            };
        }
        getAsync(...args) {
            const { fromCache: fromCache, value: value } = this.get(...args);
            Promise.resolve(value).catch(()=>this.invalidate());
            return {
                fromCache: fromCache,
                value: value
            };
        }
        invalidate() {
            this.nextCacheRefreshTime = Date.now();
        }
        updateNextRefreshTime() {
            this.nextCacheRefreshTime = Date.now() + this.timeoutMs;
        }
    }
});
parcelRegister("cm5BA", function(module, exports) {
    $parcel$export(module.exports, "CONFLUENCE_ITEM_ENTITIES", ()=>$c5556eab8dba4d6a$export$8c5e9a2b7d8e96fa);
    $parcel$export(module.exports, "SEARCH_QUERY", ()=>$c5556eab8dba4d6a$export$f8e8a5f34f6ea725);
    $parcel$export(module.exports, "sitesToLocations", ()=>$c5556eab8dba4d6a$export$13404986e7746e72);
    const $c5556eab8dba4d6a$export$8c5e9a2b7d8e96fa = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:blogpost'
    ];
    const $c5556eab8dba4d6a$export$f8e8a5f34f6ea725 = `
query($query: String, $entities:[String!]!, $locations: [String!]!, $confluenceFilters: SearchConfluenceFilter, $experience: String!){
  search{
    search(
      query: $query
      filters: {entities: $entities, locations: $locations, confluenceFilters: $confluenceFilters}
      analytics: {searchSessionId: "graphql"}
      experience: $experience
    ) {
      edges {
        node {
          id
          title
          url
          description
          type
          lastModifiedDate
          __typename
          ... on SearchConfluencePageBlogAttachment {
            type
            space {
              key
              iconUrl
            }
          }
        }
      }
    }
  }
}`;
    const $c5556eab8dba4d6a$export$13404986e7746e72 = (sites, cloudId)=>{
        const cloudIds = sites.length > 0 ? sites : [
            cloudId
        ];
        const locations = cloudIds.map((cloudId)=>`ari:cloud:confluence::site/${cloudId}`);
        return locations;
    };
    const $c5556eab8dba4d6a$export$2351037d7dbc8a11 = (filters)=>{
        return {
            spaceFilter: filters.filter((filter)=>filter.type === 'space').map((filter)=>filter.id),
            contributorsFilter: filters.filter((filter)=>filter.type === 'contributor').map((filter)=>filter.id)
        };
    };
});
parcelRegister("jmwt7", function(module, exports) {
    $parcel$export(module.exports, "GraphQLClient", ()=>$94c9f4c748a90ea0$export$b0f268a6eae2cdf1);
    var $dS9cn = parcelRequire("dS9cn");
    var $lFNae;
    var $ckvH1;
    var $cm5BA;
    class $94c9f4c748a90ea0$export$b0f268a6eae2cdf1 {
        static{
            this.GRAPHQL_API_URL = 'graphql';
        }
        constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
            this.makePostRequest = (path, body)=>{
                const options = {
                    path: path,
                    requestInit: {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    }
                };
                return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
            };
            this.serviceConfig = {
                url: url
            };
            this.cloudId = cloudId;
            this.siteMasterList = siteMasterList;
        }
        async search({ query: query, context: context, entities: entities, modelParams: modelParams, resultLimit: resultLimit, filters: filters, experience: experience, sites: sites = [] }) {
            const cloudId = this.cloudId;
            const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, (0, parcelRequire("ckvH1")).limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
            const locations = (0, (0, parcelRequire("cm5BA")).sitesToLocations)(cloudIdsToFilterOn, cloudId);
            const body = {
                query: (0, (0, parcelRequire("cm5BA")).SEARCH_QUERY),
                variables: {
                    locations: locations,
                    entities: entities,
                    query: query,
                    confluenceFilters: filters,
                    experience: experience
                }
            };
            const { result: response, durationMs: requestDurationMs } = await (0, (0, parcelRequire("lFNae")).timed)(this.makePostRequest($94c9f4c748a90ea0$export$b0f268a6eae2cdf1.GRAPHQL_API_URL, body));
            return {
                response: {
                    rawData: response
                },
                requestDurationMs: requestDurationMs
            };
        }
    }
});
parcelRegister("6SBvm", function(module, exports) {
    var $dZMWQ = parcelRequire("dZMWQ");
    var $eyPxb = parcelRequire("eyPxb");
    var $joK88 = parcelRequire("joK88");
    var $2jaDc = parcelRequire("2jaDc");
    var $kjdG6 = parcelRequire("kjdG6");
    var $6Fkfb = parcelRequire("6Fkfb");
    var $5024e0e3cc4aeda1$var$getTime = Date.prototype.getTime;
    function $5024e0e3cc4aeda1$var$deepEqual(actual, expected, options) {
        var opts = options || {};
        if (opts.strict ? $joK88(actual, expected) : actual === expected) return true;
        if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $joK88(actual, expected) : actual == expected;
        return $5024e0e3cc4aeda1$var$objEquiv(actual, expected, opts);
    }
    function $5024e0e3cc4aeda1$var$isUndefinedOrNull(value) {
        return value === null || value === undefined;
    }
    function $5024e0e3cc4aeda1$var$isBuffer(x) {
        if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
        if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
        if (x.length > 0 && typeof x[0] !== 'number') return false;
        return true;
    }
    function $5024e0e3cc4aeda1$var$objEquiv(a, b, opts) {
        var i, key;
        if (typeof a !== typeof b) return false;
        if ($5024e0e3cc4aeda1$var$isUndefinedOrNull(a) || $5024e0e3cc4aeda1$var$isUndefinedOrNull(b)) return false;
        if (a.prototype !== b.prototype) return false;
        if ($eyPxb(a) !== $eyPxb(b)) return false;
        var aIsRegex = $2jaDc(a);
        var bIsRegex = $2jaDc(b);
        if (aIsRegex !== bIsRegex) return false;
        if (aIsRegex || bIsRegex) return a.source === b.source && $kjdG6(a) === $kjdG6(b);
        if ($6Fkfb(a) && $6Fkfb(b)) return $5024e0e3cc4aeda1$var$getTime.call(a) === $5024e0e3cc4aeda1$var$getTime.call(b);
        var aIsBuffer = $5024e0e3cc4aeda1$var$isBuffer(a);
        var bIsBuffer = $5024e0e3cc4aeda1$var$isBuffer(b);
        if (aIsBuffer !== bIsBuffer) return false;
        if (aIsBuffer || bIsBuffer) {
            if (a.length !== b.length) return false;
            for(i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (typeof a !== typeof b) return false;
        try {
            var ka = $dZMWQ(a);
            var kb = $dZMWQ(b);
        } catch (e) {
            return false;
        }
        if (ka.length !== kb.length) return false;
        ka.sort();
        kb.sort();
        for(i = ka.length - 1; i >= 0; i--){
            if (ka[i] != kb[i]) return false;
        }
        for(i = ka.length - 1; i >= 0; i--){
            key = ka[i];
            if (!$5024e0e3cc4aeda1$var$deepEqual(a[key], b[key], opts)) return false;
        }
        return true;
    }
    module.exports = $5024e0e3cc4aeda1$var$deepEqual;
});
parcelRegister("dZMWQ", function(module, exports) {
    'use strict';
    var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;
    var $1Houy = parcelRequire("1Houy");
    var $a306f0f1bb5f232a$var$origKeys = Object.keys;
    var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
        return $a306f0f1bb5f232a$var$origKeys(o);
    } : (parcelRequire("eQVXL"));
    var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
    $a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
        if (Object.keys) {
            var keysWorksWithArguments = function() {
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
            }(1, 2);
            if (!keysWorksWithArguments) Object.keys = function keys(object) {
                if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
                return $a306f0f1bb5f232a$var$originalKeys(object);
            };
        } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
        return Object.keys || $a306f0f1bb5f232a$var$keysShim;
    };
    module.exports = $a306f0f1bb5f232a$var$keysShim;
});
parcelRegister("1Houy", function(module, exports) {
    'use strict';
    var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
    module.exports = function isArguments(value) {
        var str = $13ccce2fa6936c75$var$toStr.call(value);
        var isArgs = str === '[object Arguments]';
        if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
        return isArgs;
    };
});
parcelRegister("eQVXL", function(module, exports) {
    'use strict';
    var $ad02e23a59d3730f$var$keysShim;
    if (!Object.keys) {
        var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
        var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
        var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy"));
        var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
        var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
            toString: null
        }, 'toString');
        var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
        var $ad02e23a59d3730f$var$dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
        };
        var $ad02e23a59d3730f$var$excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
            if (typeof window === 'undefined') return false;
            for(var k in window)try {
                if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                    $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
                } catch (e) {
                    return true;
                }
            } catch (e) {
                return true;
            }
            return false;
        }();
        var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
            if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            try {
                return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            } catch (e) {
                return false;
            }
        };
        $ad02e23a59d3730f$var$keysShim = function keys(object) {
            var isObject = object !== null && typeof object === 'object';
            var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
            var isArguments = $ad02e23a59d3730f$var$isArgs(object);
            var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
            var theKeys = [];
            if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
            var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
            if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
            else {
                for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
            }
            if ($ad02e23a59d3730f$var$hasDontEnumBug) {
                var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
                for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
            }
            return theKeys;
        };
    }
    module.exports = $ad02e23a59d3730f$var$keysShim;
});
parcelRegister("eyPxb", function(module, exports) {
    'use strict';
    var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $53KqO = parcelRequire("53KqO");
    var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
    var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
        return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
    };
    var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
        return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
    };
    var $a99c3747cd09063d$var$supportsStandardArguments = function() {
        return $a99c3747cd09063d$var$isStandardArguments(arguments);
    }();
    $a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments;
    module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;
});
parcelRegister("fmBzB", function(module, exports) {
    'use strict';
    var $9T9x9 = parcelRequire("9T9x9");
    module.exports = function hasToStringTagShams() {
        return $9T9x9() && !!Symbol.toStringTag;
    };
});
parcelRegister("joK88", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $h05ZS = parcelRequire("h05ZS");
    var $iwNFM = parcelRequire("iwNFM");
    var $eJazH = parcelRequire("eJazH");
    var $90RaO = parcelRequire("90RaO");
    var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
    $d94D2($e1f40ab7009ea590$var$polyfill, {
        getPolyfill: $eJazH,
        implementation: $iwNFM,
        shim: $90RaO
    });
    module.exports = $e1f40ab7009ea590$var$polyfill;
});
parcelRegister("d94D2", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
    var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
    var $991fb4ca00f3da54$var$concat = Array.prototype.concat;
    var $le88V;
    var $991fb4ca00f3da54$var$isFunction = function(fn) {
        return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
    };
    var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
    var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
        if (name in object) {
            if (predicate === true) {
                if (object[name] === value) return;
            } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
        }
        if ($991fb4ca00f3da54$var$supportsDescriptors) (0, parcelRequire("le88V"))(object, name, value, true);
        else (0, parcelRequire("le88V"))(object, name, value);
    };
    var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
        var predicates = arguments.length > 2 ? arguments[2] : {};
        var props = $dZMWQ(map);
        if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
        for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    };
    $991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
    module.exports = $991fb4ca00f3da54$var$defineProperties;
});
parcelRegister("iwNFM", function(module, exports) {
    'use strict';
    var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
        return value !== value;
    };
    module.exports = function is(a, b) {
        if (a === 0 && b === 0) return 1 / a === 1 / b;
        if (a === b) return true;
        if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
        return false;
    };
});
parcelRegister("eJazH", function(module, exports) {
    'use strict';
    var $iwNFM = parcelRequire("iwNFM");
    module.exports = function getPolyfill() {
        return typeof Object.is === 'function' ? Object.is : $iwNFM;
    };
});
parcelRegister("90RaO", function(module, exports) {
    'use strict';
    var $eJazH = parcelRequire("eJazH");
    var $d94D2 = parcelRequire("d94D2");
    module.exports = function shimObjectIs() {
        var polyfill = $eJazH();
        $d94D2(Object, {
            is: polyfill
        }, {
            is: function testObjectIs() {
                return Object.is !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("2jaDc", function(module, exports) {
    'use strict';
    var $53KqO = parcelRequire("53KqO");
    var $1ae59a456e400bfc$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $1ae59a456e400bfc$var$has;
    var $1ae59a456e400bfc$var$$exec;
    var $1ae59a456e400bfc$var$isRegexMarker;
    var $1ae59a456e400bfc$var$badStringifier;
    if ($1ae59a456e400bfc$var$hasToStringTag) {
        $1ae59a456e400bfc$var$has = $53KqO('Object.prototype.hasOwnProperty');
        $1ae59a456e400bfc$var$$exec = $53KqO('RegExp.prototype.exec');
        $1ae59a456e400bfc$var$isRegexMarker = {};
        var $1ae59a456e400bfc$var$throwRegexMarker = function() {
            throw $1ae59a456e400bfc$var$isRegexMarker;
        };
        $1ae59a456e400bfc$var$badStringifier = {
            toString: $1ae59a456e400bfc$var$throwRegexMarker,
            valueOf: $1ae59a456e400bfc$var$throwRegexMarker
        };
        if (typeof Symbol.toPrimitive === 'symbol') $1ae59a456e400bfc$var$badStringifier[Symbol.toPrimitive] = $1ae59a456e400bfc$var$throwRegexMarker;
    }
    var $1ae59a456e400bfc$var$$toString = $53KqO('Object.prototype.toString');
    var $1ae59a456e400bfc$var$gOPD = Object.getOwnPropertyDescriptor;
    var $1ae59a456e400bfc$var$regexClass = '[object RegExp]';
    module.exports = $1ae59a456e400bfc$var$hasToStringTag ? function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        var descriptor = $1ae59a456e400bfc$var$gOPD(value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $1ae59a456e400bfc$var$has(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            $1ae59a456e400bfc$var$$exec(value, $1ae59a456e400bfc$var$badStringifier);
        } catch (e) {
            return e === $1ae59a456e400bfc$var$isRegexMarker;
        }
    } : function isRegex(value) {
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $1ae59a456e400bfc$var$$toString(value) === $1ae59a456e400bfc$var$regexClass;
    };
});
parcelRegister("kjdG6", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $h05ZS = parcelRequire("h05ZS");
    var $ckZYs = parcelRequire("ckZYs");
    var $1kOo9 = parcelRequire("1kOo9");
    var $jvGc4 = parcelRequire("jvGc4");
    var $ec90312fceb278a3$var$flagsBound = $h05ZS($1kOo9());
    $d94D2($ec90312fceb278a3$var$flagsBound, {
        getPolyfill: $1kOo9,
        implementation: $ckZYs,
        shim: $jvGc4
    });
    module.exports = $ec90312fceb278a3$var$flagsBound;
});
parcelRegister("ckZYs", function(module, exports) {
    'use strict';
    var $6vStt = parcelRequire("6vStt");
    var $kQfBa;
    var $8fb76d112b6eea5e$var$$Object = Object;
    module.exports = $6vStt(function flags() {
        if (this == null || this !== $8fb76d112b6eea5e$var$$Object(this)) throw new (0, parcelRequire("kQfBa"))('RegExp.prototype.flags getter called on non-object');
        var result = '';
        if (this.hasIndices) result += 'd';
        if (this.global) result += 'g';
        if (this.ignoreCase) result += 'i';
        if (this.multiline) result += 'm';
        if (this.dotAll) result += 's';
        if (this.unicode) result += 'u';
        if (this.unicodeSets) result += 'v';
        if (this.sticky) result += 'y';
        return result;
    }, 'get flags', true);
});
parcelRegister("6vStt", function(module, exports) {
    'use strict';
    var $le88V;
    var $4bdfe4c785c362d4$var$hasDescriptors = (parcelRequire("9lmlE"))();
    var $4bdfe4c785c362d4$var$functionsHaveConfigurableNames = (parcelRequire("9x3DX")).functionsHaveConfigurableNames();
    var $kQfBa;
    module.exports = function setFunctionName(fn, name) {
        if (typeof fn !== 'function') throw new (0, parcelRequire("kQfBa"))('`fn` is not a function');
        var loose = arguments.length > 2 && !!arguments[2];
        if (!loose || $4bdfe4c785c362d4$var$functionsHaveConfigurableNames) {
            if ($4bdfe4c785c362d4$var$hasDescriptors) (0, parcelRequire("le88V"))(fn, 'name', name, true, true);
            else (0, parcelRequire("le88V"))(fn, 'name', name);
        }
        return fn;
    };
});
parcelRegister("9x3DX", function(module, exports) {
    'use strict';
    var $6f0a05a05756bb65$var$functionsHaveNames = function functionsHaveNames() {
        return typeof (function f() {}).name === 'string';
    };
    var $6f0a05a05756bb65$var$gOPD = Object.getOwnPropertyDescriptor;
    if ($6f0a05a05756bb65$var$gOPD) try {
        $6f0a05a05756bb65$var$gOPD([], 'length');
    } catch (e) {
        $6f0a05a05756bb65$var$gOPD = null;
    }
    $6f0a05a05756bb65$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
        if (!$6f0a05a05756bb65$var$functionsHaveNames() || !$6f0a05a05756bb65$var$gOPD) return false;
        var desc = $6f0a05a05756bb65$var$gOPD(function() {}, 'name');
        return !!desc && !!desc.configurable;
    };
    var $6f0a05a05756bb65$var$$bind = Function.prototype.bind;
    $6f0a05a05756bb65$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
        return $6f0a05a05756bb65$var$functionsHaveNames() && typeof $6f0a05a05756bb65$var$$bind === 'function' && (function f() {}).bind().name !== '';
    };
    module.exports = $6f0a05a05756bb65$var$functionsHaveNames;
});
parcelRegister("1kOo9", function(module, exports) {
    'use strict';
    var $ckZYs = parcelRequire("ckZYs");
    var $d94D2 = parcelRequire("d94D2");
    var $0f8ebecd0b3aa0aa$require$supportsDescriptors = $d94D2.supportsDescriptors;
    var $0f8ebecd0b3aa0aa$var$$gOPD = Object.getOwnPropertyDescriptor;
    module.exports = function getPolyfill() {
        if ($0f8ebecd0b3aa0aa$require$supportsDescriptors && /a/mig.flags === 'gim') {
            var descriptor = $0f8ebecd0b3aa0aa$var$$gOPD(RegExp.prototype, 'flags');
            if (descriptor && typeof descriptor.get === 'function' && typeof RegExp.prototype.dotAll === 'boolean' && typeof RegExp.prototype.hasIndices === 'boolean') {
                var calls = '';
                var o = {};
                Object.defineProperty(o, 'hasIndices', {
                    get: function() {
                        calls += 'd';
                    }
                });
                Object.defineProperty(o, 'sticky', {
                    get: function() {
                        calls += 'y';
                    }
                });
                if (calls === 'dy') return descriptor.get;
            }
        }
        return $ckZYs;
    };
});
parcelRegister("jvGc4", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $e341a45c8a08c1ee$require$supportsDescriptors = $d94D2.supportsDescriptors;
    var $1kOo9 = parcelRequire("1kOo9");
    var $e341a45c8a08c1ee$var$gOPD = Object.getOwnPropertyDescriptor;
    var $e341a45c8a08c1ee$var$defineProperty = Object.defineProperty;
    var $e341a45c8a08c1ee$var$TypeErr = TypeError;
    var $e341a45c8a08c1ee$var$getProto = Object.getPrototypeOf;
    var $e341a45c8a08c1ee$var$regex = /a/;
    module.exports = function shimFlags() {
        if (!$e341a45c8a08c1ee$require$supportsDescriptors || !$e341a45c8a08c1ee$var$getProto) throw new $e341a45c8a08c1ee$var$TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
        var polyfill = $1kOo9();
        var proto = $e341a45c8a08c1ee$var$getProto($e341a45c8a08c1ee$var$regex);
        var descriptor = $e341a45c8a08c1ee$var$gOPD(proto, 'flags');
        if (!descriptor || descriptor.get !== polyfill) $e341a45c8a08c1ee$var$defineProperty(proto, 'flags', {
            configurable: true,
            enumerable: false,
            get: polyfill
        });
        return polyfill;
    };
});
parcelRegister("6Fkfb", function(module, exports) {
    'use strict';
    var $4da6466ec2c71190$var$getDay = Date.prototype.getDay;
    var $4da6466ec2c71190$var$tryDateObject = function tryDateGetDayCall(value) {
        try {
            $4da6466ec2c71190$var$getDay.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var $4da6466ec2c71190$var$toStr = Object.prototype.toString;
    var $4da6466ec2c71190$var$dateClass = '[object Date]';
    var $4da6466ec2c71190$var$hasToStringTag = (parcelRequire("fmBzB"))();
    module.exports = function isDateObject(value) {
        if (typeof value !== 'object' || value === null) return false;
        return $4da6466ec2c71190$var$hasToStringTag ? $4da6466ec2c71190$var$tryDateObject(value) : $4da6466ec2c71190$var$toStr.call(value) === $4da6466ec2c71190$var$dateClass;
    };
});
parcelRegister("8RYU8", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceRecentsClient", ()=>$46ad8c35ae2dd88a$export$2c04424b0b9ef0ac);
    var $dS9cn = parcelRequire("dS9cn");
    var $aHYZV;
    var $lFNae;
    var $k7rsK;
    var $3GGIR;
    const $46ad8c35ae2dd88a$export$be774cfa50234d6d = 'rest/recentlyviewed/1.0/recent';
    const $46ad8c35ae2dd88a$export$d8751bf2ebec9fba = 'rest/recentlyviewed/1.0/recent/spaces';
    const $46ad8c35ae2dd88a$var$RECENT_PAGES_LIMIT = 200;
    const $46ad8c35ae2dd88a$var$RECENT_SPACE_LIMIT = 5;
    class $46ad8c35ae2dd88a$export$2c04424b0b9ef0ac {
        constructor({ url: url, isCollaborationGraphEnabled: isCollaborationGraphEnabled, recentItemsSupplier: recentItemsSupplier, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl }, collabGraphClient){
            this.recentItemsSupplier = async ()=>{
                if (this.useRecentWork) {
                    const { createActivityClient: createActivityClient } = await (parcelRequire("lljEA"));
                    const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentWorkAPIUrl);
                    const { viewed: viewed } = await activityClient.fetchActivities([
                        250
                    ], {
                        products: [
                            'confluence'
                        ]
                    }, [
                        'viewed'
                    ]);
                    const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$46ad8c35ae2dd88a$var$recentWorkItemToResult(item));
                    return {
                        items: items,
                        totalSize: items.length,
                        timings: 0
                    };
                } else {
                    const baseUrl = this.serviceConfig.url;
                    const recentPagesPromiseWithTimings = this.createRecentRequestPromise($46ad8c35ae2dd88a$export$be774cfa50234d6d, {
                        limit: $46ad8c35ae2dd88a$var$RECENT_PAGES_LIMIT
                    });
                    const { result: result, durationMs: durationMs } = await recentPagesPromiseWithTimings;
                    const items = result.filter((page)=>!!page.title).map((recentPage)=>$46ad8c35ae2dd88a$var$recentPageToResult(recentPage, baseUrl));
                    return {
                        items: items,
                        totalSize: items.length,
                        timings: durationMs
                    };
                }
            };
            this.recentSpacesSupplier = ()=>{
                if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getContainers([
                    (0, $94417f843d249742$export$e28d152a38023114)
                ]).then((response)=>$46ad8c35ae2dd88a$var$mapCollabGraphContainer(response));
                else {
                    const recentSpacesPromise = this.createRecentRequestPromise($46ad8c35ae2dd88a$export$d8751bf2ebec9fba, {
                        limit: $46ad8c35ae2dd88a$var$RECENT_SPACE_LIMIT
                    });
                    return recentSpacesPromise.then(({ result: result, durationMs: durationMs })=>({
                            items: result.map((recentSpace)=>$46ad8c35ae2dd88a$var$recentSpaceToResult(recentSpace, `${this.baseUrl}/spaces/${recentSpace.key}`)),
                            timings: durationMs
                        }));
                }
            };
            this.serviceConfig = {
                url: url
            };
            this.baseUrl = url;
            this.recentItemCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(recentItemsSupplier || this.recentItemsSupplier);
            this.recentSpaceCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.recentSpacesSupplier);
            this.collaborationGraphClient = collabGraphClient;
            this.isCollabGraphEnabled = isCollaborationGraphEnabled;
            this.useRecentWork = useRecentWork || false;
            this.recentWorkAPIUrl = recentWorkAPIUrl;
        }
        getRecent(cache) {
            const { fromCache: fromCache, value: value } = cache.get();
            return (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(value.then((results)=>({
                    ...results,
                    isCached: fromCache
                })));
        }
        getRecentItems() {
            return this.getRecent(this.recentItemCache);
        }
        getRecentSpaces() {
            return this.getRecent(this.recentSpaceCache);
        }
        createRecentRequestPromise(path, queryParams) {
            const options = {
                path: path,
                queryParams: queryParams
            };
            const requestPromise = (0, $dS9cn.utils).requestService(this.serviceConfig, options);
            return (0, (0, parcelRequire("lFNae")).timed)(requestPromise);
        }
    }
    function $46ad8c35ae2dd88a$var$recentWorkItemToResult(recentItem) {
        const { object: object, containers: containers } = recentItem;
        return {
            resultId: object.id,
            containerName: containers[0].name,
            containerId: '',
            resultType: (0, (0, parcelRequire("3GGIR")).ConfluenceObjectResult),
            isRecentResult: true,
            name: object.name || '',
            href: object.url,
            contentType: `confluence-${object.type}`,
            lastModified: undefined,
            analyticsType: (0, (0, parcelRequire("3GGIR")).RecentConfluence)
        };
    }
    function $46ad8c35ae2dd88a$var$recentPageToResult(recentPage, baseUrl) {
        return {
            resultId: String(recentPage.id),
            name: recentPage.title || '',
            href: `${baseUrl}${recentPage.url}`,
            containerName: recentPage.space,
            analyticsType: (0, (0, parcelRequire("3GGIR")).RecentConfluence),
            resultType: (0, (0, parcelRequire("3GGIR")).ConfluenceObjectResult),
            contentType: `confluence-${recentPage.contentType}`,
            iconClass: recentPage.iconClass,
            containerId: recentPage.spaceId.toString(),
            isRecentResult: true,
            lastModified: undefined,
            spaceId: recentPage.spaceId?.toString()
        };
    }
    function $46ad8c35ae2dd88a$var$recentSpaceToResult(recentSpace, href) {
        return {
            resultId: recentSpace.id,
            name: recentSpace.name,
            key: recentSpace.key,
            href: href,
            avatarUrl: recentSpace.icon,
            analyticsType: (0, (0, parcelRequire("3GGIR")).RecentConfluence),
            resultType: (0, (0, parcelRequire("3GGIR")).GenericContainerResult),
            contentType: (0, (0, parcelRequire("3GGIR")).ConfluenceSpace),
            id: recentSpace.id
        };
    }
    function $46ad8c35ae2dd88a$var$mapCollabGraphContainer(response) {
        const items = response.collaborationGraphEntities.map((item)=>({
                id: item.containerDetails?.id,
                key: item.containerDetails?.key,
                icon: item.containerDetails?.iconUrl,
                name: item.containerDetails?.name,
                url: item.containerDetails?.url,
                siteId: item.siteId
            })).filter((space)=>space.id !== undefined).map((space)=>$46ad8c35ae2dd88a$var$recentSpaceToResult(space, space.url));
        return {
            items: items,
            timings: response.timings
        };
    }
});
const $94417f843d249742$export$e28d152a38023114 = 'confluenceSpace';
const $94417f843d249742$export$b9a68081b849a9ab = 'jiraProject';
parcelRegister("lljEA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Gx3zW").then(()=>parcelRequire('8l3CP'));
});
parcelRegister("jFHlY", function(module, exports) {
    $parcel$export(module.exports, "MAX_CG_RESULTS", ()=>$8e63f092c88bbd60$export$8b133b5f27893e80);
    $parcel$export(module.exports, "CONTEXT_USER_ID", ()=>$8e63f092c88bbd60$export$886facd7f1fb825b);
    $parcel$export(module.exports, "QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT", ()=>$8e63f092c88bbd60$export$c4871241365cf270);
    $parcel$export(module.exports, "CollaborationGraphClient", ()=>$8e63f092c88bbd60$export$cd5b4a06db0ea4e2);
    var $jRjRt;
    var $8TDoB;
    const $8e63f092c88bbd60$export$8b133b5f27893e80 = 10;
    const $8e63f092c88bbd60$export$886facd7f1fb825b = 'context';
    const $8e63f092c88bbd60$export$c4871241365cf270 = 'quickSearch';
    class $8e63f092c88bbd60$export$cd5b4a06db0ea4e2 {
        constructor(config){
            this.getContainers = (containerTypes, sites = [])=>{
                if (this.isMultiSite) return this.collabGraphMultiSite.getContainers({
                    selectedSites: sites,
                    containerTypes: containerTypes,
                    allSites: this.sites.length > 0 ? this.sites : [
                        {
                            cloudId: this.cloudId
                        }
                    ]
                });
                else return this.collabGraphSingleSite.getContainers({
                    containerTypes: containerTypes,
                    cloudId: this.cloudId
                });
            };
            this.getUsers = (sites = [])=>{
                if (this.isMultiSite) return this.collabGraphMultiSite.getUsers({
                    allSites: this.sites.length > 0 ? this.sites : [
                        {
                            cloudId: this.cloudId
                        }
                    ],
                    selectedSites: sites
                });
                else return this.collabGraphSingleSite.getUsers({
                    cloudId: this.cloudId
                });
            };
            this.collabGraphSingleSite = new (0, (0, parcelRequire("jRjRt")).CollaborationGraphSingleSite)(config);
            this.collabGraphMultiSite = new (0, (0, parcelRequire("8TDoB")).CollaborationGraphMultiSite)(config);
            this.isMultiSite = config.isMultiSite;
            this.cloudId = config.cloudId;
            this.sites = config.sites;
        }
    }
});
parcelRegister("jRjRt", function(module, exports) {
    $parcel$export(module.exports, "CollaborationGraphSingleSite", ()=>$64fd0e4444d66622$export$75acaca275e7d34b);
    var $6DbKR;
    var $jFHlY;
    class $64fd0e4444d66622$export$75acaca275e7d34b extends (0, (0, parcelRequire("6DbKR")).CollaborationGraph) {
        constructor({ collaborationGraphUrl: url }){
            super({
                url: url
            }), this.CONTAINER_URL_PATH = 'v1/collaborationgraph/user/container', this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
        }
        getUsers(arg) {
            return this.usersCache.get(arg).value;
        }
        getContainers({ containerTypes: containerTypes, cloudId: cloudId }) {
            return this.containersCache.get({
                containerTypes: containerTypes,
                cloudId: cloudId
            }).value;
        }
        async getContainersSupplier({ containerTypes: containerTypes, cloudId: cloudId }) {
            const body = {
                containerTypes: containerTypes,
                context: {
                    principalId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                    siteId: cloudId,
                    contextType: (0, (0, parcelRequire("jFHlY")).QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                },
                maxNumberOfResults: (0, (0, parcelRequire("jFHlY")).MAX_CG_RESULTS),
                userId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
                return {
                    ...cgEntity,
                    siteId: cloudId
                };
            });
            return {
                ...result,
                timings: durationMs
            };
        }
        async getUsersSupplier({ cloudId: cloudId = '', collabGraphSessionId: collabGraphSessionId = '' }) {
            const body = {
                context: {
                    principalId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                    siteId: cloudId,
                    sessionId: collabGraphSessionId,
                    contextType: (0, (0, parcelRequire("jFHlY")).QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                },
                maxNumberOfResults: (0, (0, parcelRequire("jFHlY")).MAX_CG_RESULTS),
                userId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
                return {
                    ...cgEntity,
                    siteId: cloudId
                };
            });
            return {
                ...result,
                timings: durationMs
            };
        }
    }
});
parcelRegister("6DbKR", function(module, exports) {
    $parcel$export(module.exports, "CollaborationGraph", ()=>$726c91b739953762$export$d4989257696242c9);
    var $dS9cn = parcelRequire("dS9cn");
    var $k7rsK;
    var $lFNae;
    class $726c91b739953762$export$d4989257696242c9 {
        async makeRequest(path, body) {
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify(body)
                }
            };
            return (0, (0, parcelRequire("lFNae")).timed)((0, $dS9cn.utils).requestService(this.serviceConfig, options));
        }
        constructor({ url: url }){
            this.serviceConfig = {
                url: url
            };
            this.getContainersSupplier = this.getContainersSupplier.bind(this);
            this.getUsersSupplier = this.getUsersSupplier.bind(this);
            this.containersCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.getContainersSupplier);
            this.usersCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.getUsersSupplier);
        }
    }
});
parcelRegister("8TDoB", function(module, exports) {
    $parcel$export(module.exports, "CollaborationGraphMultiSite", ()=>$84bac3b9614ce172$export$6150ad6d7e95f129);
    var $3JOCw = parcelRequire("3JOCw");
    var $6DbKR;
    var $jFHlY;
    var $ckvH1;
    const $84bac3b9614ce172$var$mergeUsers = (prevResult, nextResult)=>({
            timings: Math.max(prevResult.timings, nextResult.timings),
            collaborationGraphEntities: (0, ($parcel$interopDefault($3JOCw)))(prevResult.collaborationGraphEntities.concat(nextResult.collaborationGraphEntities), (user)=>user.id)
        });
    const $84bac3b9614ce172$var$emptyUserResponse = {
        timings: 0,
        collaborationGraphEntities: []
    };
    class $84bac3b9614ce172$export$6150ad6d7e95f129 extends (0, (0, parcelRequire("6DbKR")).CollaborationGraph) {
        async getContainersSupplier(arg) {
            const body = {
                containerTypes: arg.containerTypes,
                context: {
                    principalId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                    siteIds: arg.cloudIds,
                    contextType: (0, (0, parcelRequire("jFHlY")).QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                },
                maxNumberOfResults: (0, (0, parcelRequire("jFHlY")).MAX_CG_RESULTS),
                userId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
                return {
                    ...cgEntity,
                    siteId: (0, (0, parcelRequire("ckvH1")).extractSiteIdBySiteUrl)(cgEntity.containerDetails.url, arg.allSites)
                };
            });
            return {
                ...result,
                timings: durationMs
            };
        }
        async getUsersSupplier(arg) {
            const results = arg.cloudIds.map(async (cloudId)=>{
                const body = {
                    context: {
                        principalId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                        siteId: cloudId,
                        contextType: (0, (0, parcelRequire("jFHlY")).QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                    },
                    maxNumberOfResults: (0, (0, parcelRequire("jFHlY")).MAX_CG_RESULTS),
                    userId: (0, (0, parcelRequire("jFHlY")).CONTEXT_USER_ID),
                    expanded: true
                };
                const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
                result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>({
                        ...cgEntity,
                        siteId: cloudId
                    }));
                return {
                    ...result,
                    timings: durationMs
                };
            });
            return Promise.all(results).then((values)=>values.reduce($84bac3b9614ce172$var$mergeUsers, $84bac3b9614ce172$var$emptyUserResponse));
        }
        getUsers({ allSites: allSites, selectedSites: selectedSites }) {
            if (selectedSites.length === 0) return this.usersCache.get({
                cloudIds: (0, (0, parcelRequire("ckvH1")).limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId)
            }).value;
            else return this.getUsersSupplier({
                cloudIds: selectedSites.map((site)=>site.cloudId)
            });
        }
        getContainers({ allSites: allSites, selectedSites: selectedSites, containerTypes: containerTypes }) {
            if (selectedSites.length === 0) return this.containersCache.get({
                cloudIds: (0, (0, parcelRequire("ckvH1")).limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId),
                containerTypes: containerTypes
            }).value;
            else return this.getContainersSupplier({
                cloudIds: selectedSites.map((site)=>site.cloudId),
                containerTypes: containerTypes,
                allSites: allSites
            });
        }
        constructor(config){
            super({
                url: config.collaborationGraphUrl
            }), this.CONTAINER_URL_PATH = 'v1/collaborationgraph/multitenant/user/container', this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
        }
    }
});
parcelRegister("3nZO6", function(module, exports) {
    $parcel$export(module.exports, "JiraSearchClientProvider", ()=>$b13747da55b8eb78$export$f8102de5af58503c);
    $parcel$export(module.exports, "useJiraSearchClientContext", ()=>$b13747da55b8eb78$export$71e1e199804dfd5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $6SBvm = parcelRequire("6SBvm");
    var $8QpSo;
    var $fnNov;
    var $fisvb;
    var $jFHlY;
    var $ckvH1;
    var $j97IK;
    const $b13747da55b8eb78$var$ERROR_MESSAGE = 'Jira search client has not been instantiated. This is most likely because you are missing a JiraSearchClientProvider.';
    const $b13747da55b8eb78$var$defaultCollaborationGraphConfig = {
        collaborationGraphUrl: 'gateway/api/collaboration',
        useCollaborationGraphForRecents: false
    };
    const $b13747da55b8eb78$var$getCollabGraphClientWithConfig = (0, (0, parcelRequire("8QpSo")).default)((config)=>new (0, (0, parcelRequire("jFHlY")).CollaborationGraphClient)({
            collaborationGraphUrl: config.collaborationGraphUrl,
            cloudId: config.cloudId,
            isMultiSite: config.isMultiSite,
            sites: config.sites
        }), (0, ($parcel$interopDefault($6SBvm))));
    const $b13747da55b8eb78$export$5b76b773dfc5ee6a = (0, $5uXOq.createContext)({});
    const $b13747da55b8eb78$var$DEFAULT_SITES = [];
    const $b13747da55b8eb78$export$f8102de5af58503c = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, isUserAnonymous: isUserAnonymous, collaborationGraphUrl: collaborationGraphUrl, children: children, baseUrl: baseUrl, accountId: accountId, siteUrl: siteUrl = '', recentIssuesSupplier: recentIssuesSupplier, currentUserSupplier: currentUserSupplier, sites: sites = $b13747da55b8eb78$var$DEFAULT_SITES })=>{
        siteUrl = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("ckvH1")).extractSiteUrl)({
                siteUrl: siteUrl,
                sites: sites
            }), [
            siteUrl,
            sites
        ]);
        const { backendExperiment: backendExperiment } = (0, (0, parcelRequire("j97IK")).useExperiments)();
        const searchClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("fisvb")).JiraSearchClient)({
                siteMasterList: sites,
                url: aggregatorUrl,
                cloudId: cloudId,
                isUserAnonymous: isUserAnonymous,
                recentIssuesSupplier: recentIssuesSupplier,
                siteUrl: siteUrl,
                backendExperiment: backendExperiment
            }), [
            aggregatorUrl,
            cloudId,
            isUserAnonymous,
            recentIssuesSupplier,
            siteUrl,
            sites,
            backendExperiment
        ]);
        const collabGraphClient = $b13747da55b8eb78$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: collaborationGraphUrl || $b13747da55b8eb78$var$defaultCollaborationGraphConfig.collaborationGraphUrl,
            cloudId: cloudId,
            isMultiSite: sites.length > 1,
            sites: sites
        });
        const currentUserClient = (0, $5uXOq.useMemo)(()=>accountId ? new (0, (0, parcelRequire("fnNov")).JiraCurrentUserClient)({
                accountId: accountId,
                baseUrl: baseUrl,
                currentUserSupplier: currentUserSupplier
            }) : undefined, [
            accountId,
            baseUrl,
            currentUserSupplier
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b13747da55b8eb78$export$5b76b773dfc5ee6a.Provider, {
            value: {
                searchClient: searchClient,
                collabGraphClient: collabGraphClient,
                currentUserClient: currentUserClient,
                siteUrl: siteUrl,
                cloudId: cloudId,
                sites: sites
            }
        }, children);
    };
    const $b13747da55b8eb78$export$413dca1b70dbb4a7 = (Component)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($b13747da55b8eb78$export$5b76b773dfc5ee6a.Consumer, null, ({ searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, cloudId: cloudId, sites: sites })=>{
                if (!searchClient) throw new Error($b13747da55b8eb78$var$ERROR_MESSAGE);
                const { ...rest } = props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...rest,
                    searchClient: searchClient,
                    collabGraphClient: collabGraphClient,
                    currentUserClient: currentUserClient,
                    cloudId: cloudId,
                    sites: sites
                });
            });
    };
    function $b13747da55b8eb78$export$71e1e199804dfd5e() {
        const { searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, siteUrl: siteUrl, sites: sites, cloudId: cloudId } = (0, $5uXOq.useContext)($b13747da55b8eb78$export$5b76b773dfc5ee6a);
        if (!searchClient) throw new Error($b13747da55b8eb78$var$ERROR_MESSAGE);
        return {
            searchClient: searchClient,
            collabGraphClient: collabGraphClient,
            currentUserClient: currentUserClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites
        };
    }
});
parcelRegister("fnNov", function(module, exports) {
    $parcel$export(module.exports, "JiraCurrentUserClient", ()=>$c8ed37043c300774$export$bbcfcc9f52275229);
    var $5uXOq = parcelRequire("5uXOq");
    var $dS9cn = parcelRequire("dS9cn");
    var $lFNae;
    var $k7rsK;
    var $3nZO6;
    const $c8ed37043c300774$var$USER_DATA_URL = '/rest/api/3/user';
    class $c8ed37043c300774$export$bbcfcc9f52275229 {
        constructor({ accountId: accountId, baseUrl: baseUrl, currentUserSupplier: currentUserSupplier }){
            this.getCurrentUser = ()=>this.currentUserCache.get().value;
            this.getUserSupplier = async ()=>{
                const { result: result, durationMs: durationMs } = await this.makeRequest($c8ed37043c300774$var$USER_DATA_URL);
                return {
                    ...result,
                    timings: durationMs
                };
            };
            this.serviceConfig = {
                url: baseUrl
            };
            this.accountId = accountId;
            this.currentUserCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(currentUserSupplier || this.getUserSupplier);
        }
        async makeRequest(path) {
            const options = {
                path: path,
                queryParams: {
                    accountId: this.accountId,
                    expand: 'applicationRoles'
                }
            };
            return (0, (0, parcelRequire("lFNae")).timed)((0, $dS9cn.utils).requestService(this.serviceConfig, options));
        }
    }
    const $c8ed37043c300774$export$2393d475b44b8a57 = (user = {})=>{
        const [loadingComplete, setLoadingComplete] = (0, $5uXOq.useState)(false);
        const [currentUser, setCurrentUser] = (0, $5uXOq.useState)(user);
        const { currentUserClient: currentUserClient } = (0, (0, parcelRequire("3nZO6")).useJiraSearchClientContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (!loadingComplete) {
                let shouldUpdate = true;
                currentUserClient?.getCurrentUser().then((result)=>{
                    if (shouldUpdate && !loadingComplete) {
                        setCurrentUser({
                            id: result.accountId,
                            name: result.displayName,
                            avatarUrl: result.avatarUrls['24x24'],
                            email: result.emailAddress,
                            hasSoftwareAccess: result.applicationRoles.items.some((item)=>item.key === 'jira-software')
                        });
                        setLoadingComplete(true);
                    }
                }).catch(()=>{});
                return ()=>{
                    shouldUpdate = false;
                };
            }
        }, [
            currentUserClient,
            loadingComplete
        ]);
        return currentUser;
    };
});
parcelRegister("fisvb", function(module, exports) {
    $parcel$export(module.exports, "JiraSearchClient", ()=>$c87c5ab85f19b8e5$export$824e4d5b28750c3f);
    $parcel$export(module.exports, "attributeTypeToContentType", ()=>$c87c5ab85f19b8e5$export$1436a8642ffb43cf);
    var $aHYZV;
    var $zo35K;
    var $lQmoS;
    var $4biU5;
    var $k7rsK;
    var $6d2Zk;
    var $4r0zY;
    var $ckvH1;
    const $c87c5ab85f19b8e5$var$RECENT_PLANS_SOFT_LIMIT = 2;
    const $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE = 'jira.nav-v3';
    class $c87c5ab85f19b8e5$export$824e4d5b28750c3f {
        static{
            this.ITEM_RESULT_LIMIT = 50;
        }
        static{
            this.PROJECT_BOARD_FILTER_LIMIT = 6;
        }
        static{
            this.PROJECT_BOARD_FILTER_PLAN_LIMIT = 8;
        }
        static{
            this.PROJECT_RESULT_LIMIT = 10;
        }
        static{
            this.PEOPLE_RESULT_LIMIT = 10;
        }
        constructor(config){
            this.abTestDataCache = null;
            this.permissionsDataCache = null;
            this.recentIssuesSupplier = async (context, sites)=>{
                const results = this.searchForScope('', [], context, [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraIssue
                ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, true, sites)[(0, (0, parcelRequire("4biU5")).Scope).JiraIssue];
                if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, (0, parcelRequire("4biU5")).Scope).JiraIssue}`);
                return results.promise();
            };
            this.interleaveRecentBoardsProjectsFiltersPlans = (boardProjectFilterResults, planResults)=>{
                const timings = planResults.timings > boardProjectFilterResults.timings ? planResults.timings : boardProjectFilterResults.timings;
                const { items: items } = boardProjectFilterResults;
                if (planResults.items.length >= $c87c5ab85f19b8e5$var$RECENT_PLANS_SOFT_LIMIT) while(items.length > $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - $c87c5ab85f19b8e5$var$RECENT_PLANS_SOFT_LIMIT)items.pop();
                else while(items.length > $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - planResults.items.length)items.pop();
                for(let planCount = 0; items.length < $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT && planResults.items.length > planCount; planCount++)items.push(planResults.items[planCount]);
                return {
                    timings: timings,
                    items: items,
                    totalSize: items.length
                };
            };
            this.search = (query, filters, context, queryVersion, hasAdvancedRoadmapsAccess, sites)=>{
                const issueSearch = this.searchForScope(query, filters, context, [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraIssue
                ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites, queryVersion);
                const onlyDateFilterEnabled = filters.length === 1 && filters[0]?.type === 'dateFromLastModified';
                const scopes = hasAdvancedRoadmapsAccess ? [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilterPlan
                ] : [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilter
                ];
                const limit = hasAdvancedRoadmapsAccess ? $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT : $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT;
                const jiraBoardProjectFilterSearch = filters.length === 0 || onlyDateFilterEnabled ? this.searchForScope(query, filters, context, scopes, limit, false, sites, queryVersion) : {};
                return {
                    ...issueSearch,
                    ...jiraBoardProjectFilterSearch
                };
            };
            this.searchForScope = (query, filters, context, scopes, resultLimit, isForRecentResults, sites = [], queryVersion)=>{
                const modelParams = queryVersion || queryVersion === 0 ? [
                    {
                        '@type': 'queryParams',
                        queryVersion: queryVersion
                    }
                ] : [];
                const allFilters = [];
                let baseProjectFilters = null;
                let baseAssigneeFilters = null;
                let baseBinaryStatusCategoryFilters = null;
                let lastModifiedFilter = {
                    '@type': 'lastModified'
                };
                let lastViewedFilter = {
                    '@type': 'lastViewed'
                };
                filters.forEach((filter)=>{
                    switch(filter.type){
                        case 'project':
                            if (!baseProjectFilters) {
                                baseProjectFilters = {
                                    '@type': 'projects',
                                    projectIds: []
                                };
                                allFilters.push(baseProjectFilters);
                            }
                            baseProjectFilters.projectIds.push(filter.id);
                            break;
                        case 'assignee':
                            if (!baseAssigneeFilters) {
                                baseAssigneeFilters = {
                                    '@type': 'assignees',
                                    accountIds: []
                                };
                                allFilters.push(baseAssigneeFilters);
                            }
                            baseAssigneeFilters.accountIds.push(filter.id);
                            break;
                        case 'binary_status_category':
                            if (!baseBinaryStatusCategoryFilters) {
                                baseBinaryStatusCategoryFilters = {
                                    '@type': 'binary_status_categories',
                                    binaryStatusCategories: []
                                };
                                allFilters.push(baseBinaryStatusCategoryFilters);
                            }
                            baseBinaryStatusCategoryFilters.binaryStatusCategories.push(filter.id);
                            break;
                        case 'dateFromLastModified':
                            filter.id && (lastModifiedFilter.from = filter.id);
                            break;
                        case 'dateFromLastViewed':
                            filter.id && (lastViewedFilter.from = filter.id);
                            break;
                        case 'dateToLastModified':
                            filter.id && (lastModifiedFilter.to = filter.id);
                            break;
                        default:
                            break;
                    }
                });
                if (lastModifiedFilter.from || lastModifiedFilter.to) allFilters.push(lastModifiedFilter);
                if (lastViewedFilter.from) allFilters.push(lastViewedFilter);
                const responses = this.aggregatorClient.search({
                    query: query,
                    context: context,
                    scopes: scopes,
                    modelParams: modelParams,
                    resultLimit: resultLimit,
                    filters: allFilters,
                    experience: $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE,
                    sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
                });
                return scopes.reduce((results, currentScope)=>({
                        ...results,
                        [currentScope]: (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(responses.then(({ response: response, requestDurationMs: requestDurationMs })=>{
                            const scopedResponse = response.retrieveScope(currentScope);
                            if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
                            if (scopedResponse.error) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(scopedResponse.error);
                            if (currentScope === (0, (0, parcelRequire("4biU5")).Scope).JiraIssue) return (0, (0, parcelRequire("4r0zY")).transformJiraIssueScope)(scopedResponse, isForRecentResults, requestDurationMs);
                            else if (currentScope === (0, (0, parcelRequire("4biU5")).Scope).JiraPlan) return (0, (0, parcelRequire("4r0zY")).transformJiraPlanScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                            else if (currentScope === (0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilter) return (0, (0, parcelRequire("4r0zY")).transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                            else if (currentScope === (0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilterPlan) return (0, (0, parcelRequire("4r0zY")).transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                            else if (currentScope === (0, (0, parcelRequire("4biU5")).Scope).JiraProject) return (0, (0, parcelRequire("4r0zY")).transformJiraProjectScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                            else if (currentScope === (0, (0, parcelRequire("4biU5")).Scope).People) return (0, (0, parcelRequire("4r0zY")).transformUrsPeople)(scopedResponse.results, isForRecentResults, requestDurationMs, sites.length > 0);
                        }))
                    }), {});
            };
            const { recentIssuesSupplier: recentIssuesSupplier = null } = config;
            this.aggregatorClient = new (0, (0, parcelRequire("zo35K")).AggregatorClient)(config);
            this.recentPeopleCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)((context, sites)=>this.searchForPeopleScope('', context, true, sites));
            this.recentIssuesCache = recentIssuesSupplier ? new (0, (0, parcelRequire("k7rsK")).SimpleCache)((ignored)=>recentIssuesSupplier()) : new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.recentIssuesSupplier);
            this.recentBoardsProjectsFiltersCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(async (context, sites)=>{
                const results = this.searchForScope('', [], context, [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilter
                ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilter];
                if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, (0, parcelRequire("4biU5")).Scope).JiraBoardProjectFilter}`);
                return results.promise();
            });
            this.recentPlansCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(async (context, sites)=>{
                const results = this.searchForScope('', [], context, [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraPlan
                ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, (0, parcelRequire("4biU5")).Scope).JiraPlan];
                if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, (0, parcelRequire("4biU5")).Scope).JiraPlan}`);
                return results.promise();
            });
            this.recentProjectsCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(async (context, sites)=>{
                const results = this.searchForScope('', [], context, [
                    (0, (0, parcelRequire("4biU5")).Scope).JiraProject
                ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT, true, sites)[(0, (0, parcelRequire("4biU5")).Scope).JiraProject];
                if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, (0, parcelRequire("4biU5")).Scope).JiraProject}`);
                return results.promise();
            });
            this.isUserAnonymous = config.isUserAnonymous;
        }
        getRecent(cache, context, sites) {
            const { fromCache: fromCache, value: value } = cache.get(context, (0, (0, parcelRequire("ckvH1")).limitToMaxSiteUsage)(sites));
            return (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(value.then((results)=>({
                    ...results,
                    isCached: fromCache
                })));
        }
        getRecentBoardsProjectsFiltersPlansInterleaved(context, sites) {
            const { fromCache: boardsProjectsFiltersFromCache, value: boardsProjectsFiltersValue } = this.recentBoardsProjectsFiltersCache.get(context, sites);
            const { fromCache: plansFromCache, value: plansValue } = this.recentPlansCache.get(context, sites);
            return (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(Promise.all([
                boardsProjectsFiltersValue,
                plansValue
            ]).then((results)=>({
                    ...this.interleaveRecentBoardsProjectsFiltersPlans(results[0], results[1]),
                    isCached: plansFromCache && boardsProjectsFiltersFromCache
                })));
        }
        getRecentIssues(context, sites) {
            return this.getRecent(this.recentIssuesCache, context, sites);
        }
        getRecentPlans(context, sites) {
            return this.getRecent(this.recentPlansCache, context, sites);
        }
        getRecentProjects(context, sites) {
            return this.getRecent(this.recentProjectsCache, context, sites);
        }
        getRecentBoardsProjectsFilters(context, sites) {
            return this.getRecent(this.recentBoardsProjectsFiltersCache, context, sites);
        }
        getRecentBoardsProjectsFiltersPlans(context, sites) {
            return this.getRecentBoardsProjectsFiltersPlansInterleaved(context, sites);
        }
        async getProductPermissions(products) {
            if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE);
            return this.permissionsDataCache;
        }
        async getAbTestData() {
            if (this.abTestDataCache) return this.abTestDataCache;
            const abTest = await this.aggregatorClient.getAbTestData((0, (0, parcelRequire("4biU5")).Scope).JiraIssue, $c87c5ab85f19b8e5$var$NAVIGATION_V3_EXPERIENCE);
            this.abTestDataCache = abTest;
            return abTest;
        }
        getRecentPeople(context, sites) {
            return this.getRecent(this.recentPeopleCache, context, sites);
        }
        searchPeople(query, context, sites) {
            return (0, (0, parcelRequire("aHYZV")).CancellablePromise).from(this.searchForPeopleScope(query, context, false, sites));
        }
        searchForPeopleScope(query, context, isForRecentResults, sites, queryVersion) {
            if (this.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0,
                totalSize: 0
            });
            const results = this.searchForScope(query, [], context, [
                (0, (0, parcelRequire("4biU5")).Scope).People
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT, isForRecentResults, sites, queryVersion)[(0, (0, parcelRequire("4biU5")).Scope).People];
            if (!results) throw new Error(`Failed to retrieve results for scope ${(0, (0, parcelRequire("4biU5")).Scope).People}`);
            return results.promise();
        }
        searchProjects(query, context, sites) {
            const results = this.searchForScope(query, [], context, [
                (0, (0, parcelRequire("4biU5")).Scope).JiraProject
            ], $c87c5ab85f19b8e5$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites)[(0, (0, parcelRequire("4biU5")).Scope).JiraProject];
            if (!results) throw new Error(`Failed to retrieve results for scope ${(0, (0, parcelRequire("4biU5")).Scope).JiraProject}`);
            return results;
        }
    }
    function $c87c5ab85f19b8e5$export$1436a8642ffb43cf(attributeType) {
        switch(attributeType){
            case (0, (0, parcelRequire("4biU5")).AttributeType).issue:
                return (0, (0, parcelRequire("4biU5")).ContentType).JiraIssue;
            case (0, (0, parcelRequire("4biU5")).AttributeType).project:
                return (0, (0, parcelRequire("4biU5")).ContentType).JiraProject;
            case (0, (0, parcelRequire("4biU5")).AttributeType).board:
                return (0, (0, parcelRequire("4biU5")).ContentType).JiraBoard;
            case (0, (0, parcelRequire("4biU5")).AttributeType).filter:
                return (0, (0, parcelRequire("4biU5")).ContentType).JiraFilter;
            case (0, (0, parcelRequire("4biU5")).AttributeType).plan:
                return (0, (0, parcelRequire("4biU5")).ContentType).JiraPlan;
            case (0, (0, parcelRequire("4biU5")).AttributeType).people:
                return (0, (0, parcelRequire("4biU5")).ContentType).JiraPeople;
            default:
                throw new (0, (0, parcelRequire("6d2Zk")).UnreachableError)(attributeType);
        }
    }
});
parcelRegister("4biU5", function(module, exports) {
    $parcel$export(module.exports, "Scope", ()=>$8afcf00701a56fa4$export$775b6bb06e53a214);
    $parcel$export(module.exports, "ContentType", ()=>$8afcf00701a56fa4$export$e2e108cbe2e4f865);
    $parcel$export(module.exports, "AttributeType", ()=>$8afcf00701a56fa4$export$d31c6c64cddbeeac);
    var $8afcf00701a56fa4$export$775b6bb06e53a214;
    (function(Scope) {
        Scope["JiraIssue"] = "jira.issue";
        Scope["JiraPlan"] = "jira.plan";
        Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
        Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
        Scope["JiraProject"] = "jira.project";
        Scope["People"] = "urs.user-jira";
    })($8afcf00701a56fa4$export$775b6bb06e53a214 || ($8afcf00701a56fa4$export$775b6bb06e53a214 = {}));
    var $8afcf00701a56fa4$export$e2e108cbe2e4f865;
    (function(ContentType) {
        ContentType["JiraIssue"] = "jira-issue";
        ContentType["JiraBoard"] = "jira-board";
        ContentType["JiraProject"] = "jira-project";
        ContentType["JiraFilter"] = "jira-filter";
        ContentType["JiraPlan"] = "jira-plan";
        ContentType["JiraPeople"] = "jira-people";
    })($8afcf00701a56fa4$export$e2e108cbe2e4f865 || ($8afcf00701a56fa4$export$e2e108cbe2e4f865 = {}));
    function $8afcf00701a56fa4$export$b3b8cefe01df28d2(avatar) {
        return Object.prototype.hasOwnProperty.call(avatar, 'url');
    }
    function $8afcf00701a56fa4$export$496f9fe01bbac92b(avatar) {
        return Object.prototype.hasOwnProperty.call(avatar, 'urls');
    }
    var $8afcf00701a56fa4$export$d31c6c64cddbeeac;
    (function(AttributeType) {
        AttributeType["issue"] = "issue";
        AttributeType["board"] = "board";
        AttributeType["project"] = "project";
        AttributeType["filter"] = "filter";
        AttributeType["plan"] = "plan";
        AttributeType["people"] = "people";
    })($8afcf00701a56fa4$export$d31c6c64cddbeeac || ($8afcf00701a56fa4$export$d31c6c64cddbeeac = {}));
});
parcelRegister("6d2Zk", function(module, exports) {
    $parcel$export(module.exports, "UnreachableError", ()=>$42598c636176952f$export$676c8946b241bf4b);
    class $42598c636176952f$export$676c8946b241bf4b extends Error {
        constructor(v){
            super(`Unreachable code was reachable, value: ${v}`);
        }
    }
});
parcelRegister("4r0zY", function(module, exports) {
    $parcel$export(module.exports, "transformJiraIssueScope", ()=>$bbbead478f5b2048$export$ed218c5a500295c6);
    $parcel$export(module.exports, "transformJiraPlanScope", ()=>$bbbead478f5b2048$export$3327c57623badb76);
    $parcel$export(module.exports, "transformJiraBoardProjectFilterScope", ()=>$bbbead478f5b2048$export$313c00d1fd0198a9);
    $parcel$export(module.exports, "transformJiraProjectScope", ()=>$bbbead478f5b2048$export$61106bcfd557994b);
    $parcel$export(module.exports, "transformUrsPeople", ()=>$bbbead478f5b2048$export$ca9c7208f3fa3596);
    var $4biU5;
    var $fisvb;
    var $3JOCw = parcelRequire("3JOCw");
    var $ckvH1;
    function $bbbead478f5b2048$export$ed218c5a500295c6(response, isCached, timings) {
        const { results: results, size: size } = response;
        return {
            items: results.filter((item)=>item.attributes['@type'] === (0, (0, parcelRequire("4biU5")).AttributeType).issue).map((item)=>{
                return {
                    resultId: item.id,
                    name: item.name,
                    href: item.url,
                    contentType: (0, (0, parcelRequire("4biU5")).ContentType).JiraIssue,
                    attributes: {
                        ...item.attributes,
                        isRecentResult: isCached
                    },
                    isCached: isCached
                };
            }),
            timings: timings,
            totalSize: size || results.length
        };
    }
    function $bbbead478f5b2048$export$3327c57623badb76(results, isCached, timings) {
        return {
            items: results.map((item)=>{
                return {
                    resultId: item.id,
                    name: item.name,
                    href: item.url,
                    contentType: (0, (0, parcelRequire("4biU5")).ContentType).JiraPlan,
                    attributes: item.attributes,
                    isCached: isCached
                };
            }),
            timings: timings,
            totalSize: results.length
        };
    }
    function $bbbead478f5b2048$export$313c00d1fd0198a9(results, isCached, timings) {
        return {
            items: results.filter((item)=>[
                    (0, (0, parcelRequire("4biU5")).AttributeType).board,
                    (0, (0, parcelRequire("4biU5")).AttributeType).project,
                    (0, (0, parcelRequire("4biU5")).AttributeType).filter,
                    (0, (0, parcelRequire("4biU5")).AttributeType).plan
                ].includes(item.attributes['@type'])).map((item)=>{
                const contentType = (0, (0, parcelRequire("fisvb")).attributeTypeToContentType)(item.attributes['@type']);
                return {
                    resultId: item.id,
                    name: item.name,
                    href: item.url,
                    contentType: contentType,
                    attributes: item.attributes,
                    isCached: isCached
                };
            }),
            timings: timings,
            totalSize: results.length
        };
    }
    function $bbbead478f5b2048$export$61106bcfd557994b(results, isCached, timings) {
        return {
            items: results.map((item)=>{
                return {
                    resultId: item.id,
                    name: item.name,
                    href: item.url,
                    contentType: (0, (0, parcelRequire("4biU5")).ContentType).JiraProject,
                    attributes: item.attributes,
                    isCached: isCached
                };
            }),
            timings: timings,
            totalSize: results.length
        };
    }
    function $bbbead478f5b2048$export$ca9c7208f3fa3596(results, isCached, timings, isMultiSite) {
        return {
            items: (0, ($parcel$interopDefault($3JOCw)))(results, (item)=>item.id).map((item)=>({
                    resultId: item.id,
                    name: item.name,
                    href: (0, (0, parcelRequire("ckvH1")).generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id, 'jira'),
                    contentType: (0, (0, parcelRequire("4biU5")).ContentType).JiraPeople,
                    attributes: {
                        '@type': (0, (0, parcelRequire("4biU5")).AttributeType).people,
                        avatarUrl: item.avatarUrl,
                        userId: item.id
                    },
                    isCached: isCached
                })),
            timings: timings,
            totalSize: results.length
        };
    }
});
parcelRegister("j97IK", function(module, exports) {
    $parcel$export(module.exports, "useExperiments", ()=>$b6add2fb9633682e$export$d98589668c6e11a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $1KoBw;
    var $1iGI5;
    var $jlJyd;
    const $b6add2fb9633682e$export$ce7a53bcef5d6aee = ({ quickFindEnabled: quickFindEnabled, children: children })=>{
        const layerName = quickFindEnabled ? (0, (0, parcelRequire("jlJyd")).STATSIG_QUICK_FIND_LAYER) : undefined;
        const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1iGI5")).getMutuallyExclusiveExperiment)(layerName), [
            layerName
        ]);
        let frontendExperiments;
        if (quickFindEnabled) {
            const exampleFrontendExperiment = (0, (0, parcelRequire("1KoBw")).getFrontendExperiment)({
                abTestId: 'fe_search_experiment'
            });
            frontendExperiments = {
                ...frontendExperiment?.abTestId && {
                    [frontendExperiment.abTestId]: frontendExperiment
                },
                [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment
            };
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b6add2fb9633682e$var$ExperimentContext.Provider, {
            value: {
                backendExperiment: backendExperiment,
                frontendExperiments: frontendExperiments
            }
        }, children);
    };
    const $b6add2fb9633682e$var$ExperimentContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        backendExperiment: undefined,
        frontendExperiments: undefined
    });
    const $b6add2fb9633682e$export$d98589668c6e11a9 = ()=>{
        return (0, $5uXOq.useContext)($b6add2fb9633682e$var$ExperimentContext);
    };
});
parcelRegister("1KoBw", function(module, exports) {
    $parcel$export(module.exports, "getFrontendExperiment", ()=>$6e63d8e0ca134d4c$export$a68238496eb1c8ce);
    var $5IPCv;
    var $1jKPO;
    const $6e63d8e0ca134d4c$export$a68238496eb1c8ce = ({ abTestId: abTestId })=>{
        const cohort = (0, (0, parcelRequire("5IPCv")).default).getExperiment(abTestId).get('cohort', (0, (0, parcelRequire("1jKPO")).Cohort).Default);
        const serveExperiment = cohort === (0, (0, parcelRequire("1jKPO")).Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    };
    const $6e63d8e0ca134d4c$export$8774a01dc80b4a26 = (overrides)=>{
        if ((0, (0, parcelRequire("5IPCv")).default).checkGate('search-experiment-overrides-killswitch')) return $6e63d8e0ca134d4c$var$defaultCheckGate;
        if (!overrides) return $6e63d8e0ca134d4c$var$defaultCheckGate;
        try {
            const gates = overrides.filter((overrides)=>overrides.type === 'gate');
            const getFeatureGate = (name)=>{
                const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
                if (!overrideFeatureGate) return $6e63d8e0ca134d4c$var$defaultCheckGate(name);
                return true;
            };
            return getFeatureGate;
        } catch (e) {
            console.error(e);
            return $6e63d8e0ca134d4c$var$defaultCheckGate;
        }
    };
    const $6e63d8e0ca134d4c$export$841981a8a1feee8d = (overrides)=>{
        if ((0, (0, parcelRequire("5IPCv")).default).checkGate('search-experiment-overrides-killswitch')) return $6e63d8e0ca134d4c$export$a68238496eb1c8ce;
        if (!overrides) return $6e63d8e0ca134d4c$export$a68238496eb1c8ce;
        try {
            const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
            const customGetFrontendExperiment = ({ abTestId: abTestId })=>{
                const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
                if (!overrideFrontendExperiment) return $6e63d8e0ca134d4c$export$a68238496eb1c8ce({
                    abTestId: abTestId
                });
                return {
                    abTestId: abTestId,
                    serveExperiment: true,
                    cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, (0, parcelRequire("1jKPO")).Cohort).Test
                };
            };
            return customGetFrontendExperiment;
        } catch (e) {
            console.error(e);
            return $6e63d8e0ca134d4c$export$a68238496eb1c8ce;
        }
    };
    const $6e63d8e0ca134d4c$var$defaultCheckGate = (name)=>(0, (0, parcelRequire("5IPCv")).default).checkGate(name);
});
parcelRegister("1jKPO", function(module, exports) {
    $parcel$export(module.exports, "Cohort", ()=>$7ad507c82dc589a7$export$b76685d1b5a37732);
    var $7ad507c82dc589a7$export$b76685d1b5a37732;
    (function(Cohort) {
        Cohort["Default"] = "not-enrolled";
        Cohort["Control"] = "control";
        Cohort["Test"] = "test";
    })($7ad507c82dc589a7$export$b76685d1b5a37732 || ($7ad507c82dc589a7$export$b76685d1b5a37732 = {}));
});
parcelRegister("1iGI5", function(module, exports) {
    $parcel$export(module.exports, "getMutuallyExclusiveExperiment", ()=>$6a4b2e2566fb6e32$export$fd4704975f80304e);
    var $5IPCv;
    var $jlJyd;
    var $7QxWg;
    var $1KoBw;
    const $6a4b2e2566fb6e32$export$fd4704975f80304e = (layerName, onErrorFn)=>{
        try {
            if (!layerName) return {
                frontendExperiment: undefined,
                backendExperiment: (0, (0, parcelRequire("7QxWg")).getBackendExperimentConfig)(onErrorFn)
            };
            const layer = (0, (0, parcelRequire("5IPCv")).default).getLayer(layerName, {
                fireLayerExposure: false
            });
            const frontendExperimentName = layer.get('frontendExperimentName', '');
            if (frontendExperimentName) return {
                frontendExperiment: (0, (0, parcelRequire("1KoBw")).getFrontendExperiment)({
                    abTestId: frontendExperimentName
                }),
                backendExperiment: (0, (0, parcelRequire("jlJyd")).DEFAULT_STATSIG_EXPERIMENT_CONFIG)
            };
            return {
                frontendExperiment: undefined,
                backendExperiment: (0, (0, parcelRequire("7QxWg")).getBackendExperimentConfig)(onErrorFn)
            };
        } catch (error) {
            onErrorFn?.(error);
        }
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, (0, parcelRequire("jlJyd")).DEFAULT_STATSIG_EXPERIMENT_CONFIG)
        };
    };
    const $6a4b2e2566fb6e32$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn)=>{
        if (!(0, (0, parcelRequire("5IPCv")).default).checkGate('search-experiment-overrides-backend') || !overrides || overrides.length === 0) return $6a4b2e2566fb6e32$export$fd4704975f80304e(layerName, onErrorFn);
        const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
        if (!backendOverrideExperiments.length) return $6a4b2e2566fb6e32$export$fd4704975f80304e(layerName, onErrorFn);
        const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = $6a4b2e2566fb6e32$export$fd4704975f80304e(layerName, onErrorFn);
        if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
            const layerToOverride = backendOverrideExperiments.find((exp)=>{
                return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
            });
            if (!layerToOverride) {
                const { testId: _, ...rest } = layer;
                return rest;
            }
            const statsigOverrideExperiment = (0, (0, parcelRequire("5IPCv")).default).getExperiment(layerToOverride?.name);
            if (!statsigOverrideExperiment.get('testId', null)) {
                const { testId: _, ...rest } = layer;
                return rest;
            }
            return {
                name: layer.name,
                layerId: statsigOverrideExperiment.get('testId', null),
                shadowId: statsigOverrideExperiment.get('shadowId', null),
                controlId: statsigOverrideExperiment.get('controlId', null),
                abTestId: statsigOverrideExperiment.get('abTestId', null)
            };
        });
        return {
            backendExperiment: backendExperiment,
            frontendExperiment: frontendExperiment
        };
    };
});
parcelRegister("jlJyd", function(module, exports) {
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_LAYER", ()=>$6d7c25a0c5e201a6$export$24fd0d427b93757);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM", ()=>$6d7c25a0c5e201a6$export$71a8b319599e57dc);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD", ()=>$6d7c25a0c5e201a6$export$c076c4dd9e9d1e6e);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM", ()=>$6d7c25a0c5e201a6$export$23877616cb34cf0c);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM", ()=>$6d7c25a0c5e201a6$export$68be56e20dba0ed5);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD", ()=>$6d7c25a0c5e201a6$export$f39fa5cd744578ae);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM", ()=>$6d7c25a0c5e201a6$export$a36d8c2d9981ec2b);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER", ()=>$6d7c25a0c5e201a6$export$fe025e19388affcf);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER", ()=>$6d7c25a0c5e201a6$export$11e2cd4e8edc5e82);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER", ()=>$6d7c25a0c5e201a6$export$9b30fb0a29b39382);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED", ()=>$6d7c25a0c5e201a6$export$a62089c95934ccf8);
    $parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED", ()=>$6d7c25a0c5e201a6$export$4e36729d15b3db9e);
    $parcel$export(module.exports, "STATSIG_QUICK_FIND_LAYER", ()=>$6d7c25a0c5e201a6$export$b669e8e4ed2b4c67);
    $parcel$export(module.exports, "DEFAULT_STATSIG_EXPERIMENT_CONFIG", ()=>$6d7c25a0c5e201a6$export$afc3cbf9db978004);
    $parcel$export(module.exports, "DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG", ()=>$6d7c25a0c5e201a6$export$fca208e1e43c6fac);
    const $6d7c25a0c5e201a6$export$24fd0d427b93757 = 'search_platform_layer';
    const $6d7c25a0c5e201a6$export$71a8b319599e57dc = 'l1_premium_vs_standard';
    const $6d7c25a0c5e201a6$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
    const $6d7c25a0c5e201a6$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
    const $6d7c25a0c5e201a6$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
    const $6d7c25a0c5e201a6$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
    const $6d7c25a0c5e201a6$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
    const $6d7c25a0c5e201a6$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
    const $6d7c25a0c5e201a6$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
    const $6d7c25a0c5e201a6$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
    const $6d7c25a0c5e201a6$export$a62089c95934ccf8 = 'enable_l3';
    const $6d7c25a0c5e201a6$export$4e36729d15b3db9e = 'enable_query_rewrite';
    const $6d7c25a0c5e201a6$export$39bbb550e0341d58 = 'full_page_search_layer';
    const $6d7c25a0c5e201a6$export$b669e8e4ed2b4c67 = 'quick_find_layer';
    const $6d7c25a0c5e201a6$export$afc3cbf9db978004 = {
        experimentId: 'default',
        shadowExperimentId: 'default',
        controlId: 'default',
        abTestId: 'default'
    };
    const $6d7c25a0c5e201a6$export$fca208e1e43c6fac = {
        experimentId: 'default',
        shadowExperimentId: 'default',
        experimentLayers: []
    };
});
parcelRegister("7QxWg", function(module, exports) {
    $parcel$export(module.exports, "getBackendExperimentConfig", ()=>$42e634b0c22afc73$export$2f6c9ab85be44d1a);
    var $5IPCv;
    var $jlJyd;
    const $42e634b0c22afc73$export$2f6c9ab85be44d1a = (onErrorFn)=>{
        const isRequestDrivenExperimentationEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('request_driven_experimentation_enabled');
        if (!isRequestDrivenExperimentationEnabled) return;
        const isParallelBackendExperimentationEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('run_multiple_layer_models_in_parallel');
        if (isParallelBackendExperimentationEnabled) return $42e634b0c22afc73$var$getParallelBackendExperimentsConfig(onErrorFn);
        return $42e634b0c22afc73$var$getSingleBackendExperimentConfig(onErrorFn);
    };
    const $42e634b0c22afc73$var$getSingleBackendExperimentConfig = (onErrorFn)=>{
        let response = {
            ...(0, (0, parcelRequire("jlJyd")).DEFAULT_STATSIG_EXPERIMENT_CONFIG)
        };
        try {
            const layer = (0, (0, parcelRequire("5IPCv")).default).getLayer((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_LAYER));
            for (const [key, value] of Object.entries(response))response[key] = layer.get(key, value);
        } catch (error) {
            onErrorFn?.(error);
        }
        return response;
    };
    const $42e634b0c22afc73$var$getLayerValues = (layerName)=>{
        const layer = (0, (0, parcelRequire("5IPCv")).default).getLayer(layerName);
        const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
        return {
            name: layerNameWithoutSuffix,
            layerId: layer.get('layerId', null),
            shadowId: layer.get('shadowId', null),
            controlId: layer.get('controlId', null),
            abTestId: layer.get('abTestId', null),
            ...(0, (0, parcelRequire("5IPCv")).default).checkGate('search-experiment-overrides-backend') && {
                testId: layer.get('testId', null)
            }
        };
    };
    const $42e634b0c22afc73$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName)=>{
        const isPremium = (0, (0, parcelRequire("5IPCv")).default).checkGate(featureGateName);
        if (isPremium) return $42e634b0c22afc73$var$getLayerValues(premiumLayerName);
        return $42e634b0c22afc73$var$getLayerValues(standardLayerName);
    };
    const $42e634b0c22afc73$var$getParallelBackendExperimentsConfig = (onErrorFn)=>{
        const isRequestDrivenExperimentationEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate('request_driven_experimentation_enabled');
        if (!isRequestDrivenExperimentationEnabled) return;
        try {
            const allLayers = [];
            const layer1 = $42e634b0c22afc73$var$getStandardOrPremiumLayerValues((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM));
            allLayers.push(layer1);
            const layer2 = $42e634b0c22afc73$var$getStandardOrPremiumLayerValues((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM));
            allLayers.push(layer2);
            const layer2Blending = $42e634b0c22afc73$var$getLayerValues((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
            allLayers.push(layer2Blending);
            const isLayer3Enabled = (0, (0, parcelRequire("5IPCv")).default).checkGate((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
            if (isLayer3Enabled) {
                const layer3 = $42e634b0c22afc73$var$getLayerValues((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_L3_LAYER));
                allLayers.push(layer3);
            }
            const isQueryExpansionLayerEnabled = (0, (0, parcelRequire("5IPCv")).default).checkGate((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
            if (isQueryExpansionLayerEnabled) {
                const layerQueryExpansion = $42e634b0c22afc73$var$getLayerValues((0, (0, parcelRequire("jlJyd")).STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
                allLayers.push(layerQueryExpansion);
            }
            const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
            const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
            return {
                experimentId: concatenatedExperimentId,
                shadowExperimentId: concatenatedShadowExperimentId,
                experimentLayers: allLayers
            };
        } catch (error) {
            onErrorFn?.(error);
        }
        return 0, (0, parcelRequire("jlJyd")).DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
    };
});
const $3858a166c616a5ee$export$58d86c1da4a2ca1 = 'gateway/api/xpsearch-aggregator';
parcelRegister("hteTr", function(module, exports) {
    $parcel$export(module.exports, "ExtensibleCrossProductSearchDialog", ()=>$46a7ffce8732ffa8$export$c89d6fd97d04eec5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $daJ0i;
    var $8dO33;
    var $ld2hZ;
    var $4R6GH;
    var $eusud;
    var $lpwtK;
    var $3HwlS;
    var $cYlk7;
    var $14XJw;
    var $hqBSi;
    var $al2bB;
    var $c5R4n;
    var $gZ0uu;
    var $dlQRr;
    var $hynt0;
    var $7PQor;
    var $9RlGt;
    var $6P5ov;
    var $ffvO4;
    var $bHEFa;
    var $gUnI2;
    var $2k6eV;
    var $cbTYT;
    const $46a7ffce8732ffa8$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER = 'watermelon';
    const $46a7ffce8732ffa8$var$COMPASS_PRODUCT_IDENTIFIER = 'compass';
    const $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL = '/gateway/api/collaboration';
    const $46a7ffce8732ffa8$var$ANALYTICS_CONTEXT_LOCATION = 'extensibleJiraTab';
    const $46a7ffce8732ffa8$export$384daeb836cbae0f = [
        'jira.issue',
        'jira.project,board,plan,filter',
        'urs.user'
    ];
    const $46a7ffce8732ffa8$export$12de0ba0966e9d50 = ()=>{
        const request = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/api/3/serverInfo'), []);
        return (0, (0, parcelRequire("ld2hZ")).useService)(request);
    };
    const $46a7ffce8732ffa8$var$jiraLinkComponent = (onJiraNavigation)=>(linkProps)=>{
            const { href: href } = linkProps;
            const onClick = (event)=>{
                if (!(event.ctrlKey || event.metaKey)) onJiraNavigation(href || '', event);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement($46a7ffce8732ffa8$var$LinkComponent, {
                onClick: onClick,
                role: "none",
                ...linkProps
            }, linkProps.children);
        };
    const $46a7ffce8732ffa8$var$PreviewWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: {
                    location: $46a7ffce8732ffa8$var$ANALYTICS_CONTEXT_LOCATION
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), null, children));
    const $46a7ffce8732ffa8$export$c89d6fd97d04eec5 = (props)=>{
        const { cloudId: cloudId, aggregatorUrl: aggregatorUrl, formatDate: formatDate, isExpanded: isExpanded, forwardRef: forwardRef, jiraFeatures: jiraFeatures, onNavigate: onNavigate, onOpen: onOpen, onClose: onClose, theme: theme, pageLoadMetrics: pageLoadMetrics, dialogFeatures: dialogFeatures } = props;
        const instanceInfoResponse = $46a7ffce8732ffa8$export$12de0ba0966e9d50();
        const { fetch: fetchInstanceInfo } = instanceInfoResponse;
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('search_dialog_fetch_server_info')) fetchInstanceInfo();
        }, [
            fetchInstanceInfo
        ]);
        const secondaryProductNavigate = (href)=>{
            window.location.assign(href);
        };
        const onJiraNavigation = (0, $5uXOq.useCallback)((href, event)=>{
            onNavigate(href, event);
            onClose();
        }, [
            onClose,
            onNavigate
        ]);
        const onNavigateMultiProduct = (id, href, event)=>{
            switch(id){
                case 'jira':
                    onJiraNavigation(href, event);
                    break;
                default:
                    secondaryProductNavigate(href);
            }
        };
        const JiraLinkComponent = (0, $5uXOq.useMemo)(()=>$46a7ffce8732ffa8$var$jiraLinkComponent(onJiraNavigation), [
            onJiraNavigation
        ]);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const projectData = (0, (0, parcelRequire("lpwtK")).useProject)();
        const { user: user } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)().data;
        const userDetails = (0, $5uXOq.useMemo)(()=>user && !user.isAnonymous && user.accountId ? {
                id: user.accountId,
                name: user.userFullname,
                avatarUrl: user.avatarUrls ? user.avatarUrls['48x48'] : ''
            } : undefined, [
            user
        ]);
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        let isSearchWithTextFieldInAllIssuesLinkEnabled = true;
        if ((0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) isSearchWithTextFieldInAllIssuesLinkEnabled = !(0, (0, parcelRequire("cbTYT")).useNINGlobalScopeEnrolment)({
            cloudId: cloudId,
            isExpanded: isExpanded
        });
        const newTheme = (0, (0, parcelRequire("al2bB")).useLegacySearchTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2k6eV")).UserInputContextProvider), {
            stickySearchEnabled: true,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlQRr")).FilterContextProvider), {
            isEnabled: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RlGt")).FilterContextProvider), {
            isEnabled: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6P5ov")).MultiProductDialog), {
            shouldFillContainer: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
            aggregatorUrl: aggregatorUrl,
            abTestCloudId: cloudId,
            isExpanded: isExpanded,
            setIsExpanded: (value)=>value ? onOpen() : onClose(),
            theme: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_search_theming') ? newTheme : theme,
            forwardRef: forwardRef,
            onNavigateGeneric: onNavigateMultiProduct,
            pageLoadMetrics: pageLoadMetrics,
            dialogFeatures: dialogFeatures
        }, ({ onRetry: onRetry })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($46a7ffce8732ffa8$var$PreviewWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7PQor")).ExtensibleJiraTab), {
                onRetry: onRetry,
                permissionSupplier: ()=>Promise.resolve($46a7ffce8732ffa8$export$384daeb836cbae0f),
                features: {
                    ...jiraFeatures,
                    isSearchWithTextFieldInAllIssuesLinkEnabled: isSearchWithTextFieldInAllIssuesLinkEnabled
                },
                order: 0,
                isPrefetchingEnabled: true,
                linkComponent: JiraLinkComponent,
                config: {
                    cloudId: cloudId,
                    collaborationGraphUrl: $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL
                },
                currentProject: projectData.data ? {
                    id: projectData.data.id.toString(),
                    label: projectData.data.name,
                    avatarUrl: projectData.data.avatarUrl
                } : undefined,
                currentUser: userDetails,
                autocorrectEnabled: true
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hynt0")).ExtensibleConfluenceTab), {
                formatDate: formatDate,
                onRetry: onRetry,
                recentClientConfig: {
                    url: instanceInfoResponse.data?.displayUrlConfluence ? `${instanceInfoResponse.data.displayUrlConfluence}/wiki` : '/wiki',
                    cloudId: cloudId,
                    isUserAnonymous: !user.accountId,
                    isCollaborationGraphEnabled: false,
                    collaborationGraphUrl: $46a7ffce8732ffa8$var$COLLABORATION_GRAPH_URL
                },
                order: 1
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5R4n")).BitbucketTab), {
                order: 2,
                onRetry: onRetry,
                features: {
                    enableSingleScopesCall: true
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZ0uu")).CompassTab), {
                crossFlowEnabled: true,
                sourceContext: "jira",
                isCompassActivated: licensedProducts?.compass ?? false,
                isUserAnonymous: user.isAnonymous,
                order: 3,
                onRetry: onRetry,
                userTeamConfig: {
                    context: {
                        contextType: 'filter',
                        organizationId: orgId,
                        principalId: 'Context',
                        productKey: $46a7ffce8732ffa8$var$COMPASS_PRODUCT_IDENTIFIER,
                        siteId: cloudId
                    }
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ffvO4")).OpsgenieTab), {
                order: 4,
                onRetry: onRetry,
                cloudId: cloudId
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bHEFa")).TownsquareTab), {
                order: 5,
                onRetry: onRetry,
                userTeamConfig: {
                    context: {
                        contextType: 'filter',
                        organizationId: orgId,
                        principalId: 'Context',
                        productKey: $46a7ffce8732ffa8$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER,
                        siteId: cloudId
                    }
                },
                cloudId: cloudId
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUnI2")).TrelloTab), {
                order: 5,
                onRetry: onRetry
            }))))));
    };
    const $46a7ffce8732ffa8$var$LinkComponent = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1q5t1r31 _1dit1r31 _1ohyglyw _ksodglyw _1r9x1o36 _4hz81o36",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8dO33", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$08b794feb02c83c1$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $cCcdH;
    var $k9B19;
    var $8b7fu;
    var $kECas;
    var $7cFR3;
    function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("8b7fu")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("7cFR3")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("cCcdH")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("k9B19")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kECas")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;
});
parcelRegister("cCcdH", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
    const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("k9B19", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$596309a7bcc79771$export$4b0d98b1b7f6d115);
    var $TFljV;
    var $7OmtM;
    const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("TFljV")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("TFljV", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$f8cdc1e628cbc347$export$3e8ad908070b68b2);
    const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("7OmtM", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$0784379594099aa0$export$396ba4ef2e37dc65);
    const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("8b7fu", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$92a815d7e26b35c0$export$3c7c3113a97b6492);
    var $2yPrN;
    var $fiKQs;
    const $92a815d7e26b35c0$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("2yPrN")).ACTION_PENDING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED),
            (0, (0, parcelRequire("2yPrN")).ACTION_RELOADING),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("fiKQs")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("2yPrN")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("2yPrN")).ACTION_RELOADING:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("2yPrN", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$23a1ee9f12bb755d$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$23a1ee9f12bb755d$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$23a1ee9f12bb755d$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$23a1ee9f12bb755d$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$23a1ee9f12bb755d$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$23a1ee9f12bb755d$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$23a1ee9f12bb755d$export$a884a52152489cc3);
    const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
    const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
    const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
    const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
    const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
    const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
    const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
    const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
    const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("fiKQs", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5c2f531cb20db568$export$b70265791d2079d4);
    const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("kECas", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$b53b46c99cf8fc02$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$b53b46c99cf8fc02$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $b53b46c99cf8fc02$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $b53b46c99cf8fc02$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($b53b46c99cf8fc02$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $b53b46c99cf8fc02$export$2e2bcd8739ae039 = $b53b46c99cf8fc02$export$156b523e63b4f63a;
});
parcelRegister("7cFR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d96ed473518bd99$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $kDZ6Z;
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $4Bkrp;
    var $iwKVT = parcelRequire("iwKVT");
    const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
    const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
    class $8d96ed473518bd99$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("fiKQs")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("dV0Jy")).NetworkError)) return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("kDZ6Z", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$8c263ecf028a2c14$export$3e5b797e39668f84);
    class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("itO4f", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$21a0efece812cd9a$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$21a0efece812cd9a$export$dc37652c1696f231);
    const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $21a0efece812cd9a$export$e2b040f052407032 = {
        dev: $21a0efece812cd9a$var$devBaseUrl,
        development: $21a0efece812cd9a$var$devBaseUrl,
        stg: $21a0efece812cd9a$var$stgBaseUrl,
        staging: $21a0efece812cd9a$var$stgBaseUrl,
        prd: $21a0efece812cd9a$var$prodBaseUrl,
        prod: $21a0efece812cd9a$var$prodBaseUrl,
        production: $21a0efece812cd9a$var$prodBaseUrl
    };
    const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;
});
parcelRegister("dV0Jy", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$5576d4e9d0a3858d$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$5576d4e9d0a3858d$export$b5fe3f66a567bec0);
    const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("4Bkrp", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
    const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("c5R4n", function(module, exports) {
    $parcel$export(module.exports, "BitbucketTab", ()=>$f1e7b2e1c6cce5f3$export$a83467d99f696187);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $f4GCr;
    var $e17vR;
    var $k4hbD;
    var $cxU5p;
    var $8Xs9r;
    var $kbhX0;
    var $b1ovj;
    var $hEvMC;
    const $f1e7b2e1c6cce5f3$var$mapAggregatorResponseToSearchItem = (repo)=>{
        return {
            title: repo.name,
            id: repo.uuid,
            meta: repo.workspace.name,
            url: repo.links.html.href,
            iconUrl: repo.links.avatar.href,
            containerId: repo.workspace.uuid
        };
    };
    const $f1e7b2e1c6cce5f3$export$9d75ef492044e493 = ({ intl: intl, viewAllLinkGenerator: overriddenViewAllLinkGenerator, codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator, codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen, permissionSupplier: overriddenPermissionsSupplier, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, currentContext: currentContext, features: features, ...rest })=>{
        const { viewAllLinkGenerator: viewAllLinkGenerator, codeSearchUrlGenerator: codeSearchUrlGenerator, codeSearchContextualUrlGenerator: codeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("hEvMC")).bitbucketURLGenerators)({
                viewAllLinkGenerator: overriddenViewAllLinkGenerator,
                codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator,
                codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator,
                urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen
            });
        }, [
            overriddenCodeSearchUrlGenerator,
            overriddenCodeSearchContextualUrlGenerator,
            overriddenUrlGeneratorForNoResultsScreen,
            overriddenViewAllLinkGenerator
        ]);
        const sections = [
            {
                id: (0, (0, parcelRequire("b1ovj")).BitbucketScope).BitbucketRepostitory,
                title: intl.formatMessage((0, (0, parcelRequire("e17vR")).messages).bitbucket_repository_heading),
                scope: (0, (0, parcelRequire("b1ovj")).BitbucketScope).BitbucketRepostitory,
                showResultCount: true,
                viewAllLinkGenerator: viewAllLinkGenerator,
                resultMapper: ({ results: results })=>results.map((value)=>$f1e7b2e1c6cce5f3$var$mapAggregatorResponseToSearchItem(value))
            }
        ];
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)((0, (0, parcelRequire("b1ovj")).BITBUCKET_PRODUCT_ID), sections, {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        });
        const permissionSupplier = (0, (0, parcelRequire("kbhX0")).useBitbucketPermissionSupplier)(overriddenPermissionsSupplier);
        const formattedSearchForCodeLabel = (context)=>{
            const { repository: repository, workspace: workspace } = context || {};
            let source = 'Bitbucket';
            if (repository) source = repository.name;
            else if (workspace) source = workspace.name;
            return intl.formatMessage((0, (0, parcelRequire("e17vR")).messages).bitbucket_advanced_search, {
                source: source
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            expandedStateInputPlaceholder: intl.formatMessage((0, (0, parcelRequire("e17vR")).messages).bitbucket_expanded_input_placeholder),
            generateAdvancedSearchUrl: viewAllLinkGenerator,
            id: (0, (0, parcelRequire("b1ovj")).BITBUCKET_PRODUCT_ID),
            permissionSupplier: permissionSupplier,
            preQuerySectionTitleGenerator: (section)=>section.id === (0, (0, parcelRequire("b1ovj")).BitbucketScope).BitbucketRepostitory ? intl.formatMessage((0, (0, parcelRequire("e17vR")).messages).bitbucket_recent_repositories) : '',
            sections: sections,
            title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).bitbucket_tab_label),
            urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
            ...rest,
            ...itemSuppliers
        }, ({ linkComponent: linkComponent, query: query })=>{
            const codeSearchUrl = currentContext ? codeSearchContextualUrlGenerator(query, currentContext) : codeSearchUrlGenerator(query);
            const contextualSearchMessage = formattedSearchForCodeLabel(currentContext);
            return {
                Header: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cxU5p")).AdvancedSearch), {
                        advancedSearchMessage: contextualSearchMessage,
                        advancedSearchUrl: codeSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
            };
        });
    };
    const $f1e7b2e1c6cce5f3$export$a83467d99f696187 = (0, (0, parcelRequire("8RXs9")).default)($f1e7b2e1c6cce5f3$export$9d75ef492044e493);
});
parcelRegister("f4GCr", function(module, exports) {
    $parcel$export(module.exports, "useDefaultSuppliers", ()=>$2d1493dd7443ea05$export$967ff0f6c3886589);
    var $jKEl7;
    var $6ZsPS;
    var $lvCts;
    var $bONub;
    const $2d1493dd7443ea05$var$MAX_DEFAULT_SITES = 3;
    const $2d1493dd7443ea05$export$dc64f87f5460b276 = (aggregatorClient, sections, context, experience)=>async ({ query: query, filters: allFilters, workspaces: workspaces, sectionIds: allPermissionedScopes })=>{
            const defaultSites = workspaces?.slice(0, $2d1493dd7443ea05$var$MAX_DEFAULT_SITES).map((workspace)=>workspace.id);
            const siteFilter = allFilters.find((filter)=>filter['@type'] === (0, (0, parcelRequire("bONub")).SITE_FILTER_TYPE_NAME));
            const sites = siteFilter?.values || defaultSites || [];
            const filters = allFilters.filter((filter)=>filter['@type'] !== (0, (0, parcelRequire("bONub")).SITE_FILTER_TYPE_NAME)).map((f)=>f);
            const permittedSections = sections.filter((section)=>allPermissionedScopes.indexOf(section.id) >= 0).filter((section)=>section.isEnabled ? section.isEnabled(query, filters) : true);
            const scopes = permittedSections.map((section)=>section.scope);
            if (!aggregatorClient) return {
                sections: []
            };
            const { response: response } = await aggregatorClient.search({
                query: query,
                scopes: scopes,
                modelParams: [],
                experience: experience,
                context: context,
                filters: filters,
                sites: sites
            });
            const sectionsWithResults = permittedSections.map(({ scope: scope, id: id, title: title, resultMapper: resultMapper, ...rest })=>{
                const results = response.retrieveScope(scope);
                if (results === null) throw new Error(`Scope ${scope} was not found in the response, despite being requested`);
                return {
                    ...rest,
                    id: id,
                    title: title,
                    size: results.size,
                    searchResults: resultMapper(results) || [],
                    resultMapper: resultMapper
                };
            });
            const scopesWithSize = response.rawData.scopes.filter(({ size: size })=>size);
            const reponseHasSize = scopesWithSize.length > 0;
            const totalSizeAsReportedByAPI = reponseHasSize ? response.rawData.scopes.reduce((count, scope)=>count + (scope.size || 0), 0) : undefined;
            return {
                size: totalSizeAsReportedByAPI,
                sections: sectionsWithResults
            };
        };
    const $2d1493dd7443ea05$export$967ff0f6c3886589 = (id, sections, overrides)=>{
        const aggregatorClient = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        const sessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const search = $2d1493dd7443ea05$export$dc64f87f5460b276(aggregatorClient, sections, {
            sessionId: sessionId,
            referrerId: ''
        }, (0, (0, parcelRequire("jKEl7")).PLACEHOLDER_EXPERIENCE));
        return {
            preQueryItemSupplier: overrides?.preQueryItemSupplier ?? ((args)=>search({
                    ...args,
                    query: '',
                    filters: []
                })),
            postQueryItemSupplier: overrides?.postQueryItemSupplier ?? search
        };
    };
});
parcelRegister("jKEl7", function(module, exports) {
    $parcel$export(module.exports, "PLACEHOLDER_EXPERIENCE", ()=>$b4ca9de00d663510$export$2bde439437c11152);
    var $lvCts;
    const $b4ca9de00d663510$export$2bde439437c11152 = 'product-search-dialog';
});
parcelRegister("lvCts", function(module, exports) {
    $parcel$export(module.exports, "AggregatorClientContextProvider", ()=>$6af66ca999c4da2e$export$db02e603a9db00);
    $parcel$export(module.exports, "useAggregatorClient", ()=>$6af66ca999c4da2e$export$b8a9ed32354e757e);
    $parcel$export(module.exports, "useTypedAggregatorClient", ()=>$6af66ca999c4da2e$export$51bbe78d05c20324);
    var $5uXOq = parcelRequire("5uXOq");
    var $zo35K;
    var $j97IK;
    const $6af66ca999c4da2e$var$AggregatorClientContext = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $6af66ca999c4da2e$export$db02e603a9db00 = ({ abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, children: children })=>{
        const { backendExperiment: backendExperiment } = (0, (0, parcelRequire("j97IK")).useExperiments)();
        const aggregatorClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("zo35K")).AggregatorClient)({
                url: aggregatorUrl,
                cloudId: abTestCloudId,
                siteMasterList: [],
                backendExperiment: backendExperiment
            }), [
            abTestCloudId,
            aggregatorUrl,
            backendExperiment
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6af66ca999c4da2e$var$AggregatorClientContext.Provider, {
            value: aggregatorClient
        }, children);
    };
    const $6af66ca999c4da2e$export$b8a9ed32354e757e = ()=>{
        const aggregatorClient = (0, $5uXOq.useContext)($6af66ca999c4da2e$var$AggregatorClientContext);
        return aggregatorClient;
    };
    const $6af66ca999c4da2e$export$51bbe78d05c20324 = ()=>{
        const untypedClient = (0, $5uXOq.useContext)($6af66ca999c4da2e$var$AggregatorClientContext);
        return untypedClient;
    };
});
parcelRegister("6ZsPS", function(module, exports) {
    $parcel$export(module.exports, "SearchSessionProvider", ()=>$825e156d58807f26$export$facabd4fde35268);
    $parcel$export(module.exports, "useSearchSessionId", ()=>$825e156d58807f26$export$e1e7a4797df1a656);
    var $5uXOq = parcelRequire("5uXOq");
    var $bXrHm = parcelRequire("bXrHm");
    var $tUDIN;
    const $825e156d58807f26$var$SearchSessionContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        searchSessionId: undefined
    });
    class $825e156d58807f26$var$SearchSessionProviderError extends Error {
        constructor(){
            super('Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree');
        }
    }
    function $825e156d58807f26$export$432081be24450536(Component) {
        const WrapperComponent = (props)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement($825e156d58807f26$var$SearchSessionContext.Consumer, null, ({ searchSessionId: searchSessionId })=>{
                if (!searchSessionId) throw new $825e156d58807f26$var$SearchSessionProviderError();
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...props,
                    searchSessionId: searchSessionId
                });
            });
        };
        return WrapperComponent;
    }
    class $825e156d58807f26$export$facabd4fde35268 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            return {
                sessionKey: props.sessionKey,
                searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_false' ? (0, ($parcel$interopDefault($bXrHm)))() : state.searchSessionId
            };
        }
        render() {
            const { children: children } = this.props;
            const { searchSessionId: searchSessionId } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($825e156d58807f26$var$SearchSessionContext.Provider, {
                value: {
                    searchSessionId: searchSessionId
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
                analyticContext: {
                    searchSessionId: searchSessionId
                },
                nonPrivacySafeAnalyticContext: {}
            }, children));
        }
        constructor(...args){
            super(...args), this.state = {
                sessionKey: this.props.sessionKey,
                searchSessionId: (0, ($parcel$interopDefault($bXrHm)))()
            };
        }
    }
    function $825e156d58807f26$export$e1e7a4797df1a656() {
        const { searchSessionId: searchSessionId } = (0, $5uXOq.useContext)($825e156d58807f26$var$SearchSessionContext);
        if (searchSessionId) return searchSessionId;
        throw new $825e156d58807f26$var$SearchSessionProviderError();
    }
});
parcelRegister("tUDIN", function(module, exports) {
    $parcel$export(module.exports, "SearchDialogAnalyticsContext", ()=>$a2cc995c65c8dc02$export$b6f131c43d0365a);
    var $5uXOq = parcelRequire("5uXOq");
    var $3FqY6;
    var $bvUB1;
    const $a2cc995c65c8dc02$export$b6f131c43d0365a = ({ analyticContext: analyticContext, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext = {}, filterAnalyticsContext: filterAnalyticsContext = {}, nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeAnalyticContextGenerator, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvUB1")).default), {
            channel: (0, (0, parcelRequire("3FqY6")).DEFAULT_GAS_CHANNEL),
            onEvent: (event)=>{
                const additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
                const nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
                event.update((payload)=>{
                    const filters = {
                        ...payload.attributes?.filters,
                        ...filterAnalyticsContext
                    };
                    const nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
                        nonPrivacySafeAttributes: {
                            ...payload?.nonPrivacySafeAttributes,
                            ...nonPrivacySafeAttributes
                        }
                    };
                    return {
                        ...payload,
                        attributes: {
                            ...payload.attributes,
                            ...additionalAttributes,
                            filters: Object.keys(filters).length > 0 ? filters : undefined
                        },
                        ...nonPrivacySafeAttributesPayload
                    };
                });
            }
        }, children);
    };
});
parcelRegister("3FqY6", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_GAS_CHANNEL", ()=>$64fe155c5383b984$export$ed78826c06dd24e3);
    $parcel$export(module.exports, "Trigger", ()=>$64fe155c5383b984$export$41fb9f06171c75f4);
    $parcel$export(module.exports, "AdvancedSearchLinkSubjectId", ()=>$64fe155c5383b984$export$f7a2a633defbe589);
    $parcel$export(module.exports, "onAdvancedSearchSelected", ()=>$64fe155c5383b984$export$b544183e0becb531);
    $parcel$export(module.exports, "onXButtonClicked", ()=>$64fe155c5383b984$export$19360e9b825e4dfb);
    $parcel$export(module.exports, "onNonDebouncedSearchTriggered", ()=>$64fe155c5383b984$export$72e9f7dfc882e584);
    $parcel$export(module.exports, "onStickySearchCleared", ()=>$64fe155c5383b984$export$9cb41cdfd7c5452f);
    $parcel$export(module.exports, "onAutocorrectShown", ()=>$64fe155c5383b984$export$b4f9d93cc4bd7b82);
    $parcel$export(module.exports, "onAutocorrectClicked", ()=>$64fe155c5383b984$export$33cdbdfa7f154d6c);
    $parcel$export(module.exports, "onHoverPreviewShow", ()=>$64fe155c5383b984$export$82cfcc46988a9165);
    $parcel$export(module.exports, "onHoverPreviewShown", ()=>$64fe155c5383b984$export$c666b7de327a3cc2);
    $parcel$export(module.exports, "onHoverPreviewClicked", ()=>$64fe155c5383b984$export$dfba1b0d5d9e4887);
    $parcel$export(module.exports, "onCardRequestFailed", ()=>$64fe155c5383b984$export$4b429c3d1a2c2d67);
    $parcel$export(module.exports, "onSearchResultViewAllLinkClicked", ()=>$64fe155c5383b984$export$b87f0592bfac0edc);
    $parcel$export(module.exports, "onMultiSiteAdvancedSearchSelected", ()=>$64fe155c5383b984$export$62946e9fdc11ae8d);
    $parcel$export(module.exports, "onMoreFiltersSelected", ()=>$64fe155c5383b984$export$6c5bd82ba411ffb0);
    $parcel$export(module.exports, "onSearchResultSelected", ()=>$64fe155c5383b984$export$7816fccc5a0a2fed);
    $parcel$export(module.exports, "onSearchResultHighlighted", ()=>$64fe155c5383b984$export$95ef6569b5b2de4a);
    $parcel$export(module.exports, "onSearchResultContext", ()=>$64fe155c5383b984$export$656ab76fbb25e04);
    $parcel$export(module.exports, "ResultsShownActionSubjectId", ()=>$64fe155c5383b984$export$676101ab18001bd5);
    $parcel$export(module.exports, "onSearchResultsShown", ()=>$64fe155c5383b984$export$2d1da932f40a427e);
    $parcel$export(module.exports, "onTextEntered", ()=>$64fe155c5383b984$export$db28d8e16fb16e80);
    $parcel$export(module.exports, "onPreQueryScreenViewed", ()=>$64fe155c5383b984$export$145f05df248491e5);
    $parcel$export(module.exports, "onRequestMade", ()=>$64fe155c5383b984$export$93a340bed59d6525);
    $parcel$export(module.exports, "onDismissed", ()=>$64fe155c5383b984$export$97e12e4b0f216b1d);
    $parcel$export(module.exports, "onShown", ()=>$64fe155c5383b984$export$e79368bde551c62e);
    $parcel$export(module.exports, "onDropdownMenuFilterView", ()=>$64fe155c5383b984$export$9e2ba0ae72f48da8);
    $parcel$export(module.exports, "onFilterSelect", ()=>$64fe155c5383b984$export$151951fdc112763c);
    $parcel$export(module.exports, "onFilterUnselect", ()=>$64fe155c5383b984$export$f448c439d93613dd);
    $parcel$export(module.exports, "onFilterFieldCleared", ()=>$64fe155c5383b984$export$2e387d28788cf23b);
    $parcel$export(module.exports, "onPaneLoadComplete", ()=>$64fe155c5383b984$export$8ba00734f8071933);
    $parcel$export(module.exports, "onExperimentLoaded", ()=>$64fe155c5383b984$export$d9576525adc921c1);
    $parcel$export(module.exports, "onTabSelected", ()=>$64fe155c5383b984$export$cb0c8d6d4bf862f8);
    $parcel$export(module.exports, "selectEvent", ()=>$64fe155c5383b984$export$48143d759475d90f);
    $parcel$export(module.exports, "onPrequeryBannerShown", ()=>$64fe155c5383b984$export$1338fc4f37de8396);
    $parcel$export(module.exports, "onSuggestedPromptClick", ()=>$64fe155c5383b984$export$e7721900a147b5b2);
    $parcel$export(module.exports, "onPrequeryBannerDismiss", ()=>$64fe155c5383b984$export$889f319cb696bfae);
    const $64fe155c5383b984$export$ed78826c06dd24e3 = 'fabric-elements';
    var $64fe155c5383b984$export$41fb9f06171c75f4;
    (function(Trigger) {
        Trigger["SHORTCUT"] = "shortcut";
        Trigger["SHORTCUT_MODIFIED"] = "shortcutModified";
        Trigger["RETURN"] = "return";
        Trigger["CLICK"] = "click";
        Trigger["TEXT_ENTERED"] = "textEntered";
    })($64fe155c5383b984$export$41fb9f06171c75f4 || ($64fe155c5383b984$export$41fb9f06171c75f4 = {}));
    var $64fe155c5383b984$export$f7a2a633defbe589;
    (function(AdvancedSearchLinkSubjectId) {
        AdvancedSearchLinkSubjectId["CONFLUENCE"] = "confluenceAdvancedSearchLink";
        AdvancedSearchLinkSubjectId["CONFLUENCE_PEOPLE"] = "confluencePeopleSearchLink";
        AdvancedSearchLinkSubjectId["JIRA_ISSUES"] = "jiraIssuesSearchLink";
        AdvancedSearchLinkSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
        AdvancedSearchLinkSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
        AdvancedSearchLinkSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
        AdvancedSearchLinkSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
        AdvancedSearchLinkSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
        AdvancedSearchLinkSubjectId["NO_RESULTS"] = "noResultsAdvancedSearchLink";
    })($64fe155c5383b984$export$f7a2a633defbe589 || ($64fe155c5383b984$export$f7a2a633defbe589 = {}));
    const $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE = 'searchDialog';
    const $64fe155c5383b984$export$b544183e0becb531 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab })=>{
        return {
            action: 'selected',
            actionSubject: 'advancedSearchLink',
            actionSubjectId: actionSubjectId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {
                trigger: trigger,
                isLoading: isLoading,
                newTab: newTab
            }
        };
    };
    const $64fe155c5383b984$export$7d52695c66ad1422 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab })=>{
        return {
            action: 'selected',
            actionSubject: 'askAtlassianIntelligenceLink',
            actionSubjectId: actionSubjectId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {
                trigger: trigger,
                isLoading: isLoading,
                newTab: newTab
            }
        };
    };
    const $64fe155c5383b984$export$19360e9b825e4dfb = ({ actionSubjectId: actionSubjectId, searchSessionId: searchSessionId })=>{
        return {
            action: 'dismissed',
            actionSubject: 'stickySearch',
            actionSubjectId: actionSubjectId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                searchSessionId: searchSessionId
            }
        };
    };
    const $64fe155c5383b984$export$72e9f7dfc882e584 = ()=>{
        return {
            action: 'triggered',
            actionSubject: 'nonDebouncedSearch',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui'
        };
    };
    const $64fe155c5383b984$export$9cb41cdfd7c5452f = ({ timeout: timeout })=>{
        return {
            eventType: 'track',
            action: 'cleared',
            actionSubject: 'stickySearch',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            attributes: {
                timeout: timeout
            }
        };
    };
    const $64fe155c5383b984$export$b4f9d93cc4bd7b82 = ({ source: source, attributes: attributes })=>{
        return {
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'link',
            actionSubjectId: 'autocorrect',
            source: source,
            attributes: attributes
        };
    };
    const $64fe155c5383b984$export$33cdbdfa7f154d6c = ({ source: source, attributes: attributes })=>{
        return {
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'autocorrect',
            source: source,
            attributes: attributes
        };
    };
    const $64fe155c5383b984$export$82cfcc46988a9165 = ({ actionSubjectId: actionSubjectId })=>({
            eventType: 'ui',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            action: 'show',
            actionSubject: 'hoverPreview',
            actionSubjectId: actionSubjectId
        });
    const $64fe155c5383b984$export$c666b7de327a3cc2 = ({ actionSubjectId: actionSubjectId })=>({
            eventType: 'ui',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            action: 'shown',
            actionSubject: 'hoverPreview',
            actionSubjectId: actionSubjectId
        });
    const $64fe155c5383b984$export$dfba1b0d5d9e4887 = ({ actionSubjectId: actionSubjectId })=>({
            eventType: 'ui',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            action: 'clicked',
            actionSubject: 'hoverPreview',
            actionSubjectId: actionSubjectId
        });
    const $64fe155c5383b984$export$4b429c3d1a2c2d67 = ({ attributes: attributes })=>({
            eventType: 'operational',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            action: 'failed',
            actionSubject: 'trelloCardRequest',
            attributes: {
                ...attributes
            }
        });
    const $64fe155c5383b984$export$b87f0592bfac0edc = (sectionId)=>({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'searchResultViewAllLink',
            attributes: {
                sectionId: sectionId
            }
        });
    const $64fe155c5383b984$export$62946e9fdc11ae8d = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, destinationId: destinationId, index: index })=>{
        return {
            action: 'selected',
            actionSubject: 'advancedSearchLink',
            actionSubjectId: actionSubjectId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                trigger: trigger,
                isLoading: isLoading,
                newTab: newTab,
                destinationId: destinationId,
                index: index
            }
        };
    };
    const $64fe155c5383b984$export$6c5bd82ba411ffb0 = ({ trigger: trigger, selectedFiltersCount: selectedFiltersCount })=>{
        return {
            action: 'selected',
            actionSubject: 'moreFilterLink',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                trigger: trigger,
                selectedFiltersCount: selectedFiltersCount
            }
        };
    };
    const $64fe155c5383b984$export$7816fccc5a0a2fed = ({ screen: screen, actionSubject: actionSubject })=>{
        return {
            action: 'selected',
            actionSubject: actionSubject,
            actionSubjectId: screen,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$95ef6569b5b2de4a = ({ screen: screen, actionSubject: actionSubject })=>{
        return {
            action: 'highlighted',
            actionSubject: actionSubject,
            actionSubjectId: screen,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$656ab76fbb25e04 = ({ screen: screen, actionSubject: actionSubject })=>{
        return {
            action: 'contextMenu opened',
            actionSubject: actionSubject,
            actionSubjectId: screen,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
    var $64fe155c5383b984$export$676101ab18001bd5;
    (function(ResultsShownActionSubjectId) {
        ResultsShownActionSubjectId["PREQUERY"] = "preQuerySearchResults";
        ResultsShownActionSubjectId["POSTQUERY"] = "postQuerySearchResults";
        ResultsShownActionSubjectId["CACHED"] = "cachedResults";
    })($64fe155c5383b984$export$676101ab18001bd5 || ($64fe155c5383b984$export$676101ab18001bd5 = {}));
    const $64fe155c5383b984$export$2d1da932f40a427e = ({ actionSubjectId: actionSubjectId, resultCount: resultCount, sectionCount: sectionCount, results: results, timeToQueryMs: timeToQueryMs, activeProduct: activeProduct, isMultiProduct: isMultiProduct, filters: filters })=>{
        return {
            action: 'shown',
            actionSubject: 'searchResults',
            actionSubjectId: actionSubjectId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                resultCount: resultCount,
                sectionCount: sectionCount,
                timeToQueryMs: timeToQueryMs,
                results: results,
                noResultsFetched: !resultCount,
                activeProduct: activeProduct,
                isMultiProduct: isMultiProduct,
                filters: filters
            }
        };
    };
    const $64fe155c5383b984$export$db28d8e16fb16e80 = ()=>{
        return {
            action: 'entered',
            actionSubject: 'text',
            actionSubjectId: 'searchDialogTextField',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$3484ea513055aa12 = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
        return {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'showMoreButton',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                total: total,
                currentSize: currentSize,
                pageSize: pageSize
            }
        };
    };
    const $64fe155c5383b984$export$3fb15ebf22b4884e = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
        return {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'showAllLink',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                total: total,
                currentSize: currentSize,
                pageSize: pageSize
            }
        };
    };
    const $64fe155c5383b984$export$145f05df248491e5 = ({ searchSessionId: searchSessionId, trigger: trigger })=>{
        return {
            name: 'searchDialogPreQueryScreen',
            eventType: 'screen',
            attributes: {
                searchSessionId: searchSessionId,
                trigger: trigger
            }
        };
    };
    const $64fe155c5383b984$export$93a340bed59d6525 = ({ actionSubjectId: actionSubjectId, timings: timings, activeProduct: activeProduct, isExpanded: isExpanded, isMultiProduct: isMultiProduct, filters: filters }, additionalContext = {}, nonPrivacySafeAttributes = {
        query: ''
    })=>{
        return {
            action: 'completed',
            actionSubject: 'searchRequest',
            actionSubjectId: actionSubjectId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {
                activeProduct: activeProduct,
                isExpanded: isExpanded,
                isMultiProduct: isMultiProduct,
                filters: filters,
                ...timings,
                ...additionalContext
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        };
    };
    const $64fe155c5383b984$export$a8d299e4bdceb0be = ()=>({
            action: 'shown',
            eventType: 'ui',
            actionSubject: 'searchResults',
            actionSubjectId: 'preQuerySearchResults',
            attributes: {
                resultCount: 0,
                results: []
            },
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE
        });
    const $64fe155c5383b984$export$97e12e4b0f216b1d = ()=>{
        return {
            action: 'dismissed',
            actionSubject: 'searchDialog',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui'
        };
    };
    const $64fe155c5383b984$export$e79368bde551c62e = ({ visibleProducts: visibleProducts, visibleTabsCount: visibleTabsCount })=>{
        return {
            action: 'shown',
            actionSubject: 'searchDialog',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                visibleProducts: visibleProducts,
                visibleTabsCount: visibleTabsCount
            }
        };
    };
    const $64fe155c5383b984$export$9e2ba0ae72f48da8 = ({ filterType: filterType })=>{
        return {
            action: 'viewed',
            actionSubject: 'filterField',
            actionSubjectId: 'dropdownMenuFilterField',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                filterType: filterType
            }
        };
    };
    const $64fe155c5383b984$export$151951fdc112763c = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
        return {
            action: 'selected',
            actionSubject: 'filter',
            actionSubjectId: 'searchDialogFilter',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                filterId: filterId,
                filterType: filterType,
                filterSource: filterSource
            }
        };
    };
    const $64fe155c5383b984$export$f448c439d93613dd = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
        return {
            action: 'unselected',
            actionSubject: 'filter',
            actionSubjectId: 'searchDialogFilter',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                filterId: filterId,
                filterType: filterType,
                filterSource: filterSource
            }
        };
    };
    const $64fe155c5383b984$export$2e387d28788cf23b = ({ filterType: filterType })=>{
        return {
            action: 'cleared',
            actionSubject: 'filterField',
            actionSubjectId: 'searchDialogFilterField',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                filterType: filterType
            }
        };
    };
    const $64fe155c5383b984$export$e785b4d14ffa4348 = ()=>{
        return {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'searchDialogClearFilters',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$8ba00734f8071933 = (product, duration)=>{
        return {
            action: 'loadComplete',
            actionSubject: 'searchDialogPane',
            actionSubjectId: product,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {
                durationMs: duration
            }
        };
    };
    const $64fe155c5383b984$export$d9576525adc921c1 = (abTest, experimentRequestDuration, isMultiProduct)=>{
        return {
            action: 'loaded',
            actionSubject: 'experiment',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'operational',
            attributes: {
                abTest: abTest,
                experimentRequestDuration: experimentRequestDuration,
                isMultiProduct: isMultiProduct
            }
        };
    };
    const $64fe155c5383b984$export$cb0c8d6d4bf862f8 = ({ tabName: tabName }, additionalContext = {}, nonPrivacySafeAttributes = {
        query: ''
    })=>{
        return {
            action: 'clicked',
            actionSubject: 'tab',
            actionSubjectId: 'crossProductSearchTab',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {
                tabName: tabName,
                ...additionalContext
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        };
    };
    const $64fe155c5383b984$export$e89c96d52a36944 = (authorised, product)=>{
        return {
            action: 'checked',
            actionSubject: 'thirdPartyAuth',
            actionSubjectId: product,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {
                authorised: authorised
            }
        };
    };
    const $64fe155c5383b984$export$a93c057f87e755b3 = (product)=>{
        return {
            action: 'authorised',
            actionSubject: 'thirdPartyProduct',
            actionSubjectId: product,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'track',
            attributes: {}
        };
    };
    const $64fe155c5383b984$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            attributes: {
                ...attributes
            }
        });
    const $64fe155c5383b984$var$position = (options, value)=>{
        return value ? options.findIndex((option)=>option.id === value.data.id) : -1;
    };
    const $64fe155c5383b984$var$result = (option)=>{
        return option ? $64fe155c5383b984$var$optionData2Analytics(option.data) : null;
    };
    const $64fe155c5383b984$var$optionData2Analytics = (option)=>{
        const { id: id, type: type } = option;
        return {
            id: id ? id : null,
            type: type || null
        };
    };
    const $64fe155c5383b984$var$createDefaultPickerAttributes = (fieldId, collabGraphSessionId)=>({
            context: fieldId,
            isCheckbox: true,
            queryLength: 0,
            collabGraphSessionId: collabGraphSessionId
        });
    const $64fe155c5383b984$export$48143d759475d90f = (value, options, fieldId, collabGraphSessionId)=>{
        return $64fe155c5383b984$var$createEvent('ui', 'clicked', 'userPicker', {
            ...$64fe155c5383b984$var$createDefaultPickerAttributes(fieldId, collabGraphSessionId),
            position: $64fe155c5383b984$var$position(options, value),
            result: $64fe155c5383b984$var$result(value)
        });
    };
    const $64fe155c5383b984$export$73da5bde227e14d8 = ()=>{
        return {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'recentSearch',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$1338fc4f37de8396 = ()=>{
        return {
            action: 'shown',
            actionSubject: 'aiOnboardingPrompt',
            actionSubjectId: 'prequeryBanner',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$e7721900a147b5b2 = (promptId)=>{
        return {
            action: 'clicked',
            actionSubject: 'aiOnboardingPrompt',
            actionSubjectId: promptId,
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
    const $64fe155c5383b984$export$889f319cb696bfae = ()=>{
        return {
            action: 'clicked',
            actionSubject: 'aiOnboardingPrompt',
            actionSubjectId: 'dismissButton',
            source: $64fe155c5383b984$var$BASE_ANALYTICS_SOURCE,
            eventType: 'ui',
            attributes: {}
        };
    };
});
parcelRegister("bONub", function(module, exports) {
    $parcel$export(module.exports, "SITE_FILTER_TYPE_NAME", ()=>$86086a4870183521$export$f76bd7c689371575);
    $parcel$export(module.exports, "DEFAULT_OPTION", ()=>$86086a4870183521$export$d3212964e526b51c);
    $parcel$export(module.exports, "FilterUIVariant", ()=>$86086a4870183521$export$ab762b8071023de0);
    $parcel$export(module.exports, "LastModifiedValues", ()=>$86086a4870183521$export$2a1fb5b806348bf0);
    const $86086a4870183521$export$f76bd7c689371575 = 'sites';
    const $86086a4870183521$export$d3212964e526b51c = 'default';
    var $86086a4870183521$export$ab762b8071023de0;
    (function(FilterUIVariant) {
        FilterUIVariant["CHECKBOX"] = "CHECKBOX";
        FilterUIVariant["STATIC_SELECT"] = "STATIC_SELECT";
        FilterUIVariant["MULTI_SELECT"] = "MULTI_SELECT";
    })($86086a4870183521$export$ab762b8071023de0 || ($86086a4870183521$export$ab762b8071023de0 = {}));
    var $86086a4870183521$export$2a1fb5b806348bf0;
    (function(LastModifiedValues) {
        LastModifiedValues["DEFAULT"] = "default";
        LastModifiedValues["TODAY"] = "today";
        LastModifiedValues["YESTERDAY"] = "yesterday";
        LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
        LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
        LastModifiedValues["PAST_YEAR"] = "pastYear";
    })($86086a4870183521$export$2a1fb5b806348bf0 || ($86086a4870183521$export$2a1fb5b806348bf0 = {}));
});
parcelRegister("e17vR", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$53c844f08b6ae79b$export$defe85febe8b728c);
    var $7VHMR;
    const $53c844f08b6ae79b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        bitbucket_repository_heading: {
            id: 'product_search_dialog.bitbucket.repository_heading',
            defaultMessage: 'Repositories',
            description: ''
        },
        bitbucket_advanced_search: {
            id: 'product_search_dialog.bitbucket.bitbucket_advanced_search',
            defaultMessage: 'Search for code in {source}',
            description: ''
        },
        bitbucket_repositories_section_title: {
            id: 'product_search_dialog.bitbucket.bitbucket_repositories_section_title',
            defaultMessage: 'Repositories',
            description: ''
        },
        bitbucket_recent_repositories: {
            id: 'product_search_dialog.bitbucket.bitbucket_recent_repositories',
            defaultMessage: 'Recently updated repositories',
            description: ''
        },
        bitbucket_expanded_input_placeholder: {
            id: 'product_search_dialog.bitbucket.expanded.input-placeholder',
            defaultMessage: 'Search Bitbucket',
            description: 'The placeholder which is visible to the user when bitbucket tab is active '
        }
    });
});
parcelRegister("k4hbD", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ed77fbf192bbe6bf$export$defe85febe8b728c);
    var $7VHMR;
    const $ed77fbf192bbe6bf$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        common_updated_date_formatter: {
            id: 'product_search_dialog.updated_date_formatter',
            defaultMessage: 'Updated {date}',
            description: 'A text shown next to the date for the search results.'
        },
        common_recently_viewed_section_heading: {
            id: 'product_search_dialog.recently_viewed_section_heading',
            defaultMessage: 'Recently viewed',
            description: ''
        },
        common_recently_spaces_section_heading: {
            id: 'product_search_dialog.recent_spaces_section_heading',
            defaultMessage: 'Recent spaces',
            description: ''
        },
        common_recently_worked_with_section_heading: {
            id: 'product_search_dialog.recently_worked_with_section_heading',
            defaultMessage: 'Recently worked with',
            description: ''
        },
        common_error_state_failed_search_heading: {
            id: 'product_search_dialog.error.failed_loading_search_heading',
            defaultMessage: "We're having trouble loading your recently viewed content.",
            description: ''
        },
        common_error_state_failed_search_body: {
            id: 'product_search_dialog.error.failed_loading_search_body',
            defaultMessage: 'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
            description: ''
        },
        common_empty_state_heading: {
            id: 'product_search_dialog.empty.no_results_heading',
            defaultMessage: "We couldn't find anything matching your search.",
            description: ''
        },
        common_empty_state_prequery_heading: {
            id: 'product_search_dialog.empty_prequery.no_results_heading',
            defaultMessage: 'Search for what you need',
            description: ''
        },
        common_error_state_prequery_heading: {
            id: 'product_search_dialog.empty_prequery.error_heading',
            defaultMessage: 'Something went wrong with showing initial results',
            description: ''
        },
        common_show_more_results_link: {
            id: 'product_search_dialog.show_more_results_link',
            defaultMessage: 'Show more',
            description: ''
        },
        common_show_all_results_link: {
            id: 'product_search_dialog.show_all_results_link',
            defaultMessage: 'View all results',
            description: ''
        },
        common_search_people_link: {
            id: 'product_search_dialog.search_people_link',
            defaultMessage: 'Search people',
            description: ''
        },
        common_search_input_collapsed_placeholder: {
            id: 'product_search_dialog.search_input_collapsed_placeholder',
            defaultMessage: 'Search',
            description: ''
        },
        common_search_input_enlarged_aria_label: {
            id: 'product_search_dialog.search_input_enlarged_aria_label',
            defaultMessage: 'Press enter to navigate to advanced search',
            description: 'used for accessibility for the EnlargedSearchInput component'
        },
        common_empty_state_body: {
            id: 'product_search_dialog.empty.no_results_body',
            defaultMessage: 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
            description: ''
        },
        common_empty_state_body_no_advanced_search: {
            id: 'product_search_dialog.empty.no_results_body_with_no_advanced_search',
            defaultMessage: 'Try again with a different term.',
            description: ''
        },
        common_give_feedback: {
            id: 'product_search_dialog.give_feedback',
            defaultMessage: 'Give feedback',
            description: 'Button that looks like a link that the user clicks to open a dialog to give feedback about search'
        },
        common_inline_onboarding_title: {
            id: 'product_search_dialog.inline_onboarding_title',
            defaultMessage: 'Search across Jira and Confluence',
            description: 'Heading of the inline section message which educates first time users about cross product search tabs'
        },
        common_inline_onboarding_body: {
            id: 'product_search_dialog.inline_onboarding_body',
            defaultMessage: 'Use the Jira and Confluence tabs to search and see recent items in either location.',
            description: 'Description of the inline section message which educates first time users about cross product search tabs'
        },
        common_inline_onboarding_action: {
            id: 'product_search_dialog.inline_onboarding_action',
            defaultMessage: 'Ok',
            description: 'A button that looks like a link which suspends the section message.'
        },
        common_search_input_exit_button_label: {
            id: 'search_dialog.search_input_exit_label',
            defaultMessage: 'Exit Search',
            description: 'Label for the back button to exit search'
        },
        common_search_input_clear_button_label: {
            id: 'search_dialog.search_input_clear_label',
            defaultMessage: 'Clear search session',
            description: 'Label for the x button to clear the search input'
        },
        multi_site_advanced_search_label: {
            id: 'product_search_dialog.multi_site_advanced_search_label',
            defaultMessage: 'Search on:',
            description: 'Label for a list of site links in advanced search'
        },
        multi_site_advanced_search_more_dropdown: {
            id: 'product_search_dialog.multi_site_advanced_search_more_dropdown',
            defaultMessage: '{count} more',
            description: 'A dropdown which opens a list of links to sites to advanced search in'
        },
        common_autocorrection_label: {
            id: 'product_search_dialog.autocorrection.label',
            defaultMessage: 'Did you mean',
            description: 'Label text for the autocorrection component'
        },
        jira_tab_label: {
            id: 'cross_product_search_dialog.jira.tab_label',
            defaultMessage: 'Jira',
            description: ''
        },
        confluence_tab_label: {
            id: 'cross_product_search_dialog.confluence.tab_label',
            defaultMessage: 'Confluence',
            description: ''
        },
        atlas_tab_label: {
            id: 'cross_product_search_dialog.atlas.tab_label',
            defaultMessage: 'Atlas',
            description: 'The name of the Atlas product'
        },
        mercury_tab_label: {
            id: 'cross_product_search_dialog.mercury.tab_label',
            defaultMessage: 'Focus',
            description: 'The name of the Focus (Mercury) product'
        },
        bitbucket_tab_label: {
            id: 'cross_product_search_dialog.bitbucket.tab_label',
            defaultMessage: 'Bitbucket',
            description: ''
        },
        opsgenie_tab_label: {
            id: 'cross_product_search_dialog.opsgenie.tab_label',
            defaultMessage: 'Opsgenie',
            description: ''
        },
        trello_tab_label: {
            id: 'cross_product_search_dialog.trello.tab_label',
            defaultMessage: 'Trello',
            description: ''
        },
        view_all_results_link: {
            id: 'cross_product_search_dialog.view_all_results_link',
            defaultMessage: 'View all {sectionTitle}',
            description: ''
        },
        recently_viewed_title: {
            id: 'cross_product_search_dialog.recently_viewed_title',
            defaultMessage: 'Recently Viewed {sectionTitle}',
            description: ''
        },
        confluence_people_section_heading: {
            id: 'product_search_dialog.confluence.people_section_heading',
            defaultMessage: 'People',
            description: ''
        },
        confluence_content_section_heading: {
            id: 'product_search_dialog.confluence.content_section_heading',
            defaultMessage: 'Content',
            description: 'Section label for pages, blogs, attachments, and whiteboards in quick search dialog'
        },
        confluence_spaces_section_heading: {
            id: 'product_search_dialog.confluence.spaces_section_heading',
            defaultMessage: 'Spaces',
            description: ''
        },
        confluence_search_input_expanded_placeholder: {
            id: 'product_search_dialog.confluence.search_input_expanded_placeholder',
            defaultMessage: 'Search Confluence',
            description: ''
        },
        confluence_search_input_expanded_placeholder_ai: {
            id: 'product_search_dialog.confluence.search_input_expanded_placeholder_ai',
            defaultMessage: 'Search or ask questions within your Confluence',
            description: ''
        },
        confluence_pages_blogs_attachments_section_heading: {
            id: 'product_search_dialog.confluence.pages_blogs_attachments_section_heading',
            defaultMessage: 'Pages, blogs and attachments',
            description: ''
        },
        filters_applied: {
            id: 'product_search_dialog.confluence.filters_applied',
            defaultMessage: 'Looks like you have some filters applied',
            description: 'Message to show when there are no search results due to filters being applied'
        },
        clear_filters: {
            id: 'product_search_dialog.confluence.clear_filters',
            defaultMessage: 'Clear filters',
            description: 'Message to be displayed on button to clear the filters applied'
        },
        show_more_filters: {
            id: 'search_dialog.filters.group.show-more',
            defaultMessage: 'Show more',
            description: 'Text display on button to select more items to filter by'
        },
        more_filters: {
            id: 'product_search_dialog.more_filters',
            defaultMessage: 'View all filters',
            description: 'Clicking on this link takes a user to a page with more filters and options.'
        },
        no_options_filters: {
            id: 'product_search_dialog.no_options_filters',
            defaultMessage: 'No options',
            description: 'Message to show when no results are returned when filtering'
        },
        loading_filters: {
            id: 'product_search_dialog.loading_filters',
            defaultMessage: 'Loading',
            description: 'Message to show when filter results are loading'
        },
        site_filters_title: {
            id: 'product_search_dialog.common.site_filters',
            defaultMessage: 'Filter by site',
            description: 'Section title for site filters'
        },
        space_filters_title: {
            id: 'product_search_dialog.confluence.space_filters',
            defaultMessage: 'Filter by space',
            description: 'Section title for space filters in Confluence'
        },
        contributor_filters_title: {
            id: 'product_search_dialog.confluence.contributor_filters',
            defaultMessage: 'Filter by contributor',
            description: 'Section title for contributor filters in Confluence'
        },
        contributor_filters_find_more: {
            id: 'product_search_dialog.confluence.contributor_filters_find_more',
            defaultMessage: 'Find a contributor',
            description: 'Placeholder text for select menu when finding a contributor to filter results by'
        },
        space_filters_find_more: {
            id: 'product_search_dialog.confluence.space_filters_find_more',
            defaultMessage: 'Find a space',
            description: 'Placeholder text for select menu when finding a space to filter results by'
        },
        site_filters_find_more: {
            id: 'product_search_dialog.jira.site_filters_find_more',
            defaultMessage: 'Find a site',
            description: 'Placeholder text for select menu when finding a site to filter results by'
        },
        project_filters_find_more: {
            id: 'product_search_dialog.jira.project_filters_find_more',
            defaultMessage: 'Find a project',
            description: 'Placeholder text for select menu when finding a project to filter results by'
        },
        project_filters_title: {
            id: 'product_search_dialog.jira.project_filters',
            defaultMessage: 'Filter by project',
            description: 'Section title for project filters in Jira'
        },
        assignee_filters_find_more: {
            id: 'product_s earch_dialog.confluence.assignee_filters_find_more',
            defaultMessage: 'Find an assignee',
            description: 'Placeholder text for select menu when finding a assignee to filter results by'
        },
        assignee_filters_title: {
            id: 'product_search_dialog.jira.assignee_filters',
            defaultMessage: 'Filter by assignee',
            description: 'Section title for assignee filters in Jira'
        },
        binary_status_category_filters_title: {
            id: 'product_search_dialog.jira.issue_filters',
            defaultMessage: 'Filter by status',
            description: 'Section title for issue filters in Jira'
        },
        binary_status_category_filter_option_done: {
            id: 'product_search_dialog.jira.issue_filter_done',
            defaultMessage: 'Done',
            description: 'Filter option title for done issues'
        },
        binary_status_category_filter_option_open: {
            id: 'product_search_dialog.jira.issue_filter_open',
            defaultMessage: 'Open',
            description: 'Filter option title for open issues'
        },
        date_filter_any_time_label: {
            id: 'product_search_dialog.jira.date_filter_any',
            defaultMessage: 'Any time',
            description: 'Date filter label for any time.'
        },
        date_filter_filters_title: {
            id: 'product_search_dialog.jira.date_filters',
            defaultMessage: 'Last updated',
            description: 'Section title for date filters in Jira'
        },
        jira_advanced_search_label: {
            id: 'global_search.jira.advanced_search_label',
            defaultMessage: 'Go to all:',
            description: ''
        },
        jira_advanced_search_issues: {
            id: 'global_search.jira.advanced_search_issues',
            defaultMessage: 'Issues',
            description: 'Plural of issue'
        },
        jira_advanced_search_projects: {
            id: 'global_search.jira.advanced_search_projects',
            defaultMessage: 'Projects',
            description: 'Plural of project'
        },
        jira_advanced_search_boards: {
            id: 'global_search.jira.advanced_search_boards',
            defaultMessage: 'Boards',
            description: 'Plural of board'
        },
        jira_advanced_search_filters: {
            id: 'global_search.jira.advanced_search_filters',
            defaultMessage: 'Filters',
            description: 'Plural of filter'
        },
        jira_advanced_search_plans: {
            id: 'global_search.jira.advanced_search_plans',
            defaultMessage: 'Plans',
            description: 'Plural of plan'
        },
        jira_advanced_search_people: {
            id: 'global_search.jira.advanced_search_people',
            defaultMessage: 'People',
            description: ''
        },
        jira_empty_state_prequery_heading: {
            id: 'product_search_dialog.jira.empty_prequery.no_results_heading',
            defaultMessage: 'Start searching to find your work',
            description: 'This message is shown when the user has no recently viewed issues and has not yet typed a search query'
        },
        jira_issues_section_heading: {
            id: 'product_search_dialog.jira.issues_section_heading',
            defaultMessage: 'Issues',
            description: ''
        },
        jira_boards_projects_filters_section_heading: {
            id: 'product_search_dialog.jira.boards_projects_filters_section_heading',
            defaultMessage: 'Boards, Projects and Filters',
            description: ''
        },
        jira_projects_filters_section_heading: {
            id: 'product_search_dialog.jira.projects_filters_section_heading',
            defaultMessage: 'Projects and Filters',
            description: ''
        },
        jira_boards_projects_filters_plans_section_heading: {
            id: 'product_search_dialog.jira.boards_projects_filters_plans_section_heading',
            defaultMessage: 'Boards, Projects, Filters and Plans',
            description: 'Title for search results of Jira entities (Boards, Projects, Filters, and Plans)'
        },
        jira_view_all_issues_new: {
            id: 'product_search_dialog.jira.jira_view_all_issues_new',
            defaultMessage: 'View all issues',
            description: 'Text for link that takes users to advanced search for issues - renamed from "Advanced issue search"'
        },
        jira_recent_boards_projects_filters_section_heading: {
            id: 'product_search_dialog.jira.recent_boards_projects_filters_section_heading',
            defaultMessage: 'Recent Boards, Projects and Filters',
            description: ''
        },
        jira_recent_projects_filters_section_heading: {
            id: 'product_search_dialog.jira.recent_projects_filters_section_heading',
            defaultMessage: 'Recent Projects and Filters',
            description: ''
        },
        jira_recent_boards_projects_filters_plans_section_heading: {
            id: 'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading',
            defaultMessage: 'Recent Boards, Projects, Filters and Plans',
            description: 'Title for recently accessed Jira entities (Boards, Projects, Filters, and Plans)'
        },
        jira_recently_viewed_issues_section_heading: {
            id: 'product_search_dialog.jira.recently_viewed_issues_section_heading',
            defaultMessage: 'Recently viewed issues',
            description: ''
        },
        jira_search_placeholder: {
            id: 'global_search.jira.search_placeholder',
            defaultMessage: 'Search Jira',
            description: 'Search field placeholder when the Jira tab is active'
        },
        jira_search_placeholder_experiment_jsw_enabled: {
            id: 'global_search.jira.search_placeholder_experiment_jsw_enabled',
            defaultMessage: 'Search for issues, boards, projects, and filters',
            description: 'Search field placeholder when the Jira tab is active and the user has a JSW license but no access to advanced roadmaps'
        }
    });
});
parcelRegister("cxU5p", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSearch", ()=>$a580255cf910629e$export$2709da4acd7d0aec);
    var $5uXOq = parcelRequire("5uXOq");
    var $cIQMR;
    var $fYvdU;
    var $26g7Y;
    var $8oG5R;
    var $3FqY6;
    var $75NXP;
    var $3FqY6;
    var $8TPno;
    var $hN1kQ;
    var $kv2Va;
    var $2dI5H;
    var $dV2Gy;
    const $a580255cf910629e$var$onKeyDown = (e, target, actionSubjectId, fireAnalyticsEvent)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)({
                trigger: (0, (0, parcelRequire("3FqY6")).Trigger).RETURN,
                actionSubjectId: actionSubjectId,
                isLoading: false,
                newTab: false
            }));
            target.firstElementChild?.click?.();
        }
    };
    const $a580255cf910629e$export$2709da4acd7d0aec = ({ advancedSearchMessage: advancedSearchMessage, advancedSearchUrl: advancedSearchUrl, linkComponent: linkComponent })=>{
        const { isLoading: isLoading } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const productName = getActiveProduct()?.title;
        const actionSubjectId = `${productName}AdvancedSearchLink`;
        const onAdvancedSearchClicked = (0, $5uXOq.useCallback)((e)=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)({
                trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                actionSubjectId: actionSubjectId,
                isLoading: isLoading,
                newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e)
            }));
        }, [
            fireAnalyticsEvent,
            actionSubjectId,
            isLoading
        ]);
        const [isKeyboardHighlighted, ref] = (0, (0, parcelRequire("fYvdU")).useKeyboardNavigation)({
            onKeydownCallback: (0, $5uXOq.useCallback)((e, target)=>$a580255cf910629e$var$onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent), [
                actionSubjectId,
                fireAnalyticsEvent
            ])
        });
        if (!advancedSearchUrl || !advancedSearchMessage) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV2Gy")).AdvancedSearchLinkWrapper), {
            ref: ref,
            onClick: onAdvancedSearchClicked,
            role: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hN1kQ")).AdvancedSearchLink), {
            href: advancedSearchUrl,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TPno")).CenteredAdvancedSearchGroup), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: advancedSearchMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TPno")).AdvancedSearchContent), null, advancedSearchMessage)), isKeyboardHighlighted && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIQMR")).ReturnIcon), {
            inverted: isKeyboardHighlighted
        })));
    };
});
parcelRegister("cIQMR", function(module, exports) {
    $parcel$export(module.exports, "ReturnIcon", ()=>$635887d47813f9b5$export$d6c38c54dfb7c9d5);
    var $5uXOq = parcelRequire("5uXOq");
    const $635887d47813f9b5$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "16",
            viewBox: "0 0 24 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "16",
            fill: inverted ? `var(--ds-background-neutral-bold, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})` : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
            rx: "3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: inverted ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`,
            fillRule: "nonzero",
            d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
        })));
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("fYvdU", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardNavigation", ()=>$f1d9337c6a7330cc$export$4da28cf324280418);
    $parcel$export(module.exports, "KeyboardHighlightProvider", ()=>$f1d9337c6a7330cc$export$c8551b32665b42b);
    var $5uXOq = parcelRequire("5uXOq");
    const $f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        registerKeyboardEnabled: undefined,
        unregisterKeyboardEnabled: undefined,
        getSelectedIndex: undefined,
        highlightComponentAt: undefined,
        unhighlightComponentAt: undefined,
        unhighlightAll: undefined,
        keyboardNavComponents: []
    });
    const $f1d9337c6a7330cc$export$4da28cf324280418 = (options)=>{
        const [ref, setRef] = (0, ($parcel$interopDefault($5uXOq))).useState(null);
        const registrationId = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const navigationTrackingId = options?.navigationTrackingId ?? null;
        const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $5uXOq.useContext)($f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1);
        const [isHighlighted, setIsHighlighted] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        const onKeydownCallback = options?.onKeydownCallback;
        const onHighlightedCallback = options?.onHighlightedCallback;
        const unregister = (0, $5uXOq.useCallback)(()=>{
            if (registrationId.current && unregisterKeyboardEnabled) unregisterKeyboardEnabled(registrationId.current);
        }, [
            unregisterKeyboardEnabled
        ]);
        (0, $5uXOq.useEffect)(()=>()=>unregister(), [
            unregister
        ]);
        (0, $5uXOq.useEffect)(()=>{
            !ref && unregister();
        }, [
            ref,
            unregister
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
            if (!ref) return;
            if (ref) {
                if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                    console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                    return;
                }
                registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
            }
        }, [
            ref,
            setIsHighlighted,
            onKeydownCallback,
            registerKeyboardEnabled,
            unregisterKeyboardEnabled,
            navigationTrackingId,
            onHighlightedCallback
        ]);
        return [
            isHighlighted,
            setRef
        ];
    };
    class $f1d9337c6a7330cc$export$c8551b32665b42b extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.attach(this.props.listenerNode);
        }
        componentDidUpdate(prevProps) {
            if (prevProps.listenerNode !== this.props.listenerNode) {
                this.detach(prevProps.listenerNode);
                this.attach(this.props.listenerNode);
            }
        }
        componentWillUnmount() {
            this.detach(this.props.listenerNode);
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1.Provider, {
                value: {
                    registerKeyboardEnabled: this.registerKeyboardEnabled,
                    unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                    getSelectedIndex: this.getSelectedIndex,
                    highlightComponentAt: this.highlightComponentAt,
                    unhighlightComponentAt: this.unhighlightComponentAt,
                    unhighlightAll: this.unhighlightAll,
                    keyboardNavComponents: this.keyboardNavComponents
                }
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.currentlySelected = undefined, this.currentSelectedTrackingId = null, this.keyboardNavComponents = [], this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
                const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
                const isNew = currentId === null || currentId === undefined || indexAt === -1;
                const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
                if (isNew) this.keyboardNavComponents.push({
                    id: id,
                    domRef: domRef,
                    onHighlightChanged: onHighlightChanged,
                    onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                    navigationTrackingId: navigationTrackingId,
                    onHighlightedCallback: onHighlightedCallback
                });
                else this.keyboardNavComponents[indexAt] = {
                    id: id,
                    domRef: domRef,
                    onHighlightChanged: onHighlightChanged,
                    onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                    navigationTrackingId: navigationTrackingId,
                    onHighlightedCallback: onHighlightedCallback
                };
                this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                    const result = c1.domRef.compareDocumentPosition(c2.domRef);
                    if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                    else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                    return 0;
                });
                const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
                if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                    this.unhighlightAll();
                    this.highlightComponentAt(indexToHighlight);
                }
                this.keyboardNavComponents = [
                    ...this.keyboardNavComponents
                ];
                return id;
            }, this.unregisterKeyboardEnabled = (unregisterRef)=>{
                if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
                this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
            }, this.onKeyDownCallbackAt = (index, e)=>{
                if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                    const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                    onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
                }
            }, this.onHighlightedCallback = (index)=>{
                if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                    const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                    callback && callback(index);
                }
            }, this.unhighlightComponentAt = (index)=>{
                if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
            }, this.highlightComponentAt = (index)=>{
                if (index >= 0 && index < this.keyboardNavComponents.length) {
                    const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                    this.currentlySelected = id;
                    this.currentSelectedTrackingId = navigationTrackingId;
                    this.keyboardNavComponents[index].onHighlightChanged(true);
                }
            }, this.unhighlightAll = ()=>{
                this.currentSelectedTrackingId = null;
                this.currentlySelected = undefined;
                this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
            }, this.getSelectedIndex = ()=>{
                if (!this.currentlySelected) return undefined;
                return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
            }, this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), this.onKeyDown = (e)=>{
                if (this.keyboardNavComponents.length === 0) return;
                if (e.isComposing || e.keyCode === 229) return;
                let currentIndex = this.getSelectedIndex();
                const prevIndex = currentIndex;
                if (e.code === 'ArrowDown' || e.keyCode === 40) {
                    if (!e.shiftKey) {
                        if (typeof currentIndex === 'undefined') currentIndex = 0;
                        else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                        e.preventDefault();
                    }
                } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                    if (!e.shiftKey) {
                        if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                        else {
                            currentIndex -= 1;
                            if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                        }
                        e.preventDefault();
                    }
                } else {
                    if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                    return;
                }
                if (prevIndex !== currentIndex && currentIndex !== undefined) {
                    this.unhighlightComponentAt(prevIndex);
                    this.highlightComponentAt(currentIndex);
                    this.onHighlightedCallback(currentIndex);
                }
            }, this.attach = (listenerNode)=>{
                if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
            }, this.detach = (listenerNode)=>{
                if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
            };
        }
    }
    const $f1d9337c6a7330cc$export$cbeda0f7f7a8026c = ()=>{
        return (0, $5uXOq.useContext)($f1d9337c6a7330cc$export$ef7af5d8bc5d5ac1);
    };
});
parcelRegister("8oG5R", function(module, exports) {
    $parcel$export(module.exports, "sha256Hash", ()=>$b98021c2bc89ec3c$export$e9131c78c1110376);
    $parcel$export(module.exports, "getTrigger", ()=>$b98021c2bc89ec3c$export$670ec347a1a78e34);
    $parcel$export(module.exports, "isNewTab", ()=>$b98021c2bc89ec3c$export$dfd8482ecf3b52d8);
    $parcel$export(module.exports, "getWordCount", ()=>$b98021c2bc89ec3c$export$dba3e2bcdbd49da4);
    var $3FqY6;
    var $gvK9N;
    const $b98021c2bc89ec3c$export$e9131c78c1110376 = (str)=>(0, ($parcel$interopDefault((0, parcelRequire("gvK9N"))))).createHash('sha256').update(str).digest('hex');
    const $b98021c2bc89ec3c$export$670ec347a1a78e34 = (e)=>{
        if (e instanceof KeyboardEvent) return (0, (0, parcelRequire("3FqY6")).Trigger).RETURN;
        return e.screenX === 0 ? (0, (0, parcelRequire("3FqY6")).Trigger).RETURN : (0, (0, parcelRequire("3FqY6")).Trigger).CLICK;
    };
    const $b98021c2bc89ec3c$export$dfd8482ecf3b52d8 = (e)=>{
        return !!(e && (e.metaKey || e.ctrlKey || e.shiftKey));
    };
    const $b98021c2bc89ec3c$export$dba3e2bcdbd49da4 = (str)=>{
        return str.length > 0 ? str.split(/\s+/).length : 0;
    };
});
parcelRegister("gvK9N", function(module, exports) {
    $parcel$export(module.exports, "randomBytes", ()=>$c053586507d63757$export$5f828d93ff035aa8, (v)=>$c053586507d63757$export$5f828d93ff035aa8 = v);
    $parcel$export(module.exports, "rng", ()=>$c053586507d63757$export$cd94982b18c6332c, (v)=>$c053586507d63757$export$cd94982b18c6332c = v);
    $parcel$export(module.exports, "pseudoRandomBytes", ()=>$c053586507d63757$export$1d518568e4f529b0, (v)=>$c053586507d63757$export$1d518568e4f529b0 = v);
    $parcel$export(module.exports, "prng", ()=>$c053586507d63757$export$5285b6d41c912b41, (v)=>$c053586507d63757$export$5285b6d41c912b41 = v);
    $parcel$export(module.exports, "createHash", ()=>$c053586507d63757$export$2fb37efbf6ae0c0e, (v)=>$c053586507d63757$export$2fb37efbf6ae0c0e = v);
    $parcel$export(module.exports, "Hash", ()=>$c053586507d63757$export$ab85ecd77ce6a5cd, (v)=>$c053586507d63757$export$ab85ecd77ce6a5cd = v);
    $parcel$export(module.exports, "createHmac", ()=>$c053586507d63757$export$da39cf97e1eb7c91, (v)=>$c053586507d63757$export$da39cf97e1eb7c91 = v);
    $parcel$export(module.exports, "Hmac", ()=>$c053586507d63757$export$52a9039d7177394f, (v)=>$c053586507d63757$export$52a9039d7177394f = v);
    $parcel$export(module.exports, "getHashes", ()=>$c053586507d63757$export$f7201db400317331, (v)=>$c053586507d63757$export$f7201db400317331 = v);
    $parcel$export(module.exports, "pbkdf2", ()=>$c053586507d63757$export$448fa22aedc9dbca, (v)=>$c053586507d63757$export$448fa22aedc9dbca = v);
    $parcel$export(module.exports, "pbkdf2Sync", ()=>$c053586507d63757$export$b80c7ba289c8fa56, (v)=>$c053586507d63757$export$b80c7ba289c8fa56 = v);
    $parcel$export(module.exports, "Cipher", ()=>$c053586507d63757$export$26e5786e8ac8e530, (v)=>$c053586507d63757$export$26e5786e8ac8e530 = v);
    $parcel$export(module.exports, "createCipher", ()=>$c053586507d63757$export$bdd223f16383713e, (v)=>$c053586507d63757$export$bdd223f16383713e = v);
    $parcel$export(module.exports, "Cipheriv", ()=>$c053586507d63757$export$20533d26f07f1ee0, (v)=>$c053586507d63757$export$20533d26f07f1ee0 = v);
    $parcel$export(module.exports, "createCipheriv", ()=>$c053586507d63757$export$2f64596b8cbf08b4, (v)=>$c053586507d63757$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "Decipher", ()=>$c053586507d63757$export$2ce6d8d0e8b04e1a, (v)=>$c053586507d63757$export$2ce6d8d0e8b04e1a = v);
    $parcel$export(module.exports, "createDecipher", ()=>$c053586507d63757$export$12ada9414fbc594c, (v)=>$c053586507d63757$export$12ada9414fbc594c = v);
    $parcel$export(module.exports, "Decipheriv", ()=>$c053586507d63757$export$f5e7e39d57cd9700, (v)=>$c053586507d63757$export$f5e7e39d57cd9700 = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$c053586507d63757$export$36b6d6ef312eab39, (v)=>$c053586507d63757$export$36b6d6ef312eab39 = v);
    $parcel$export(module.exports, "getCiphers", ()=>$c053586507d63757$export$58a258485f1e49f6, (v)=>$c053586507d63757$export$58a258485f1e49f6 = v);
    $parcel$export(module.exports, "listCiphers", ()=>$c053586507d63757$export$dedd8dc3dc62b370, (v)=>$c053586507d63757$export$dedd8dc3dc62b370 = v);
    $parcel$export(module.exports, "DiffieHellmanGroup", ()=>$c053586507d63757$export$971862a2fcb1bb40, (v)=>$c053586507d63757$export$971862a2fcb1bb40 = v);
    $parcel$export(module.exports, "createDiffieHellmanGroup", ()=>$c053586507d63757$export$c6ff6a88acbeaf40, (v)=>$c053586507d63757$export$c6ff6a88acbeaf40 = v);
    $parcel$export(module.exports, "getDiffieHellman", ()=>$c053586507d63757$export$fdc27893e98845cc, (v)=>$c053586507d63757$export$fdc27893e98845cc = v);
    $parcel$export(module.exports, "createDiffieHellman", ()=>$c053586507d63757$export$6671fb9a1323bed, (v)=>$c053586507d63757$export$6671fb9a1323bed = v);
    $parcel$export(module.exports, "DiffieHellman", ()=>$c053586507d63757$export$d74daf141a551db, (v)=>$c053586507d63757$export$d74daf141a551db = v);
    $parcel$export(module.exports, "createSign", ()=>$c053586507d63757$export$45df7cae684751af, (v)=>$c053586507d63757$export$45df7cae684751af = v);
    $parcel$export(module.exports, "Sign", ()=>$c053586507d63757$export$1db683ad541682f6, (v)=>$c053586507d63757$export$1db683ad541682f6 = v);
    $parcel$export(module.exports, "createVerify", ()=>$c053586507d63757$export$6f65485f87568e37, (v)=>$c053586507d63757$export$6f65485f87568e37 = v);
    $parcel$export(module.exports, "Verify", ()=>$c053586507d63757$export$91a8e56769aeb334, (v)=>$c053586507d63757$export$91a8e56769aeb334 = v);
    $parcel$export(module.exports, "createECDH", ()=>$c053586507d63757$export$2d4117e99c2179e4, (v)=>$c053586507d63757$export$2d4117e99c2179e4 = v);
    $parcel$export(module.exports, "publicEncrypt", ()=>$c053586507d63757$export$512823e338ddb1b7, (v)=>$c053586507d63757$export$512823e338ddb1b7 = v);
    $parcel$export(module.exports, "privateEncrypt", ()=>$c053586507d63757$export$9d0e0c0c4a8d30f3, (v)=>$c053586507d63757$export$9d0e0c0c4a8d30f3 = v);
    $parcel$export(module.exports, "publicDecrypt", ()=>$c053586507d63757$export$b9d55ff329113abd, (v)=>$c053586507d63757$export$b9d55ff329113abd = v);
    $parcel$export(module.exports, "privateDecrypt", ()=>$c053586507d63757$export$7efb24e2fddf99b9, (v)=>$c053586507d63757$export$7efb24e2fddf99b9 = v);
    $parcel$export(module.exports, "randomFill", ()=>$c053586507d63757$export$bb1abf2ce84fc7e8, (v)=>$c053586507d63757$export$bb1abf2ce84fc7e8 = v);
    $parcel$export(module.exports, "randomFillSync", ()=>$c053586507d63757$export$2f7171e78e524d5e, (v)=>$c053586507d63757$export$2f7171e78e524d5e = v);
    $parcel$export(module.exports, "createCredentials", ()=>$c053586507d63757$export$e1d879b482f37d98, (v)=>$c053586507d63757$export$e1d879b482f37d98 = v);
    $parcel$export(module.exports, "constants", ()=>$c053586507d63757$export$1a988e7317c65621, (v)=>$c053586507d63757$export$1a988e7317c65621 = v);
    var $c053586507d63757$export$5f828d93ff035aa8;
    var $c053586507d63757$export$cd94982b18c6332c;
    var $c053586507d63757$export$1d518568e4f529b0;
    var $c053586507d63757$export$5285b6d41c912b41;
    var $c053586507d63757$export$2fb37efbf6ae0c0e;
    var $c053586507d63757$export$ab85ecd77ce6a5cd;
    var $c053586507d63757$export$da39cf97e1eb7c91;
    var $c053586507d63757$export$52a9039d7177394f;
    var $c053586507d63757$export$f7201db400317331;
    var $c053586507d63757$export$448fa22aedc9dbca;
    var $c053586507d63757$export$b80c7ba289c8fa56;
    var $c053586507d63757$export$26e5786e8ac8e530;
    var $c053586507d63757$export$bdd223f16383713e;
    var $c053586507d63757$export$20533d26f07f1ee0;
    var $c053586507d63757$export$2f64596b8cbf08b4;
    var $c053586507d63757$export$2ce6d8d0e8b04e1a;
    var $c053586507d63757$export$12ada9414fbc594c;
    var $c053586507d63757$export$f5e7e39d57cd9700;
    var $c053586507d63757$export$36b6d6ef312eab39;
    var $c053586507d63757$export$58a258485f1e49f6;
    var $c053586507d63757$export$dedd8dc3dc62b370;
    var $c053586507d63757$export$971862a2fcb1bb40;
    var $c053586507d63757$export$c6ff6a88acbeaf40;
    var $c053586507d63757$export$fdc27893e98845cc;
    var $c053586507d63757$export$6671fb9a1323bed;
    var $c053586507d63757$export$d74daf141a551db;
    var $c053586507d63757$export$45df7cae684751af;
    var $c053586507d63757$export$1db683ad541682f6;
    var $c053586507d63757$export$6f65485f87568e37;
    var $c053586507d63757$export$91a8e56769aeb334;
    var $c053586507d63757$export$2d4117e99c2179e4;
    var $c053586507d63757$export$512823e338ddb1b7;
    var $c053586507d63757$export$9d0e0c0c4a8d30f3;
    var $c053586507d63757$export$b9d55ff329113abd;
    var $c053586507d63757$export$7efb24e2fddf99b9;
    var $c053586507d63757$export$bb1abf2ce84fc7e8;
    var $c053586507d63757$export$2f7171e78e524d5e;
    var $c053586507d63757$export$e1d879b482f37d98;
    var $c053586507d63757$export$1a988e7317c65621;
    'use strict';
    $c053586507d63757$export$5f828d93ff035aa8 = $c053586507d63757$export$cd94982b18c6332c = $c053586507d63757$export$1d518568e4f529b0 = $c053586507d63757$export$5285b6d41c912b41 = (parcelRequire("1DyI6"));
    $c053586507d63757$export$2fb37efbf6ae0c0e = $c053586507d63757$export$ab85ecd77ce6a5cd = (parcelRequire("7K4uY"));
    $c053586507d63757$export$da39cf97e1eb7c91 = $c053586507d63757$export$52a9039d7177394f = (parcelRequire("j65bP"));
    var $NKdOQ = parcelRequire("NKdOQ");
    var $c053586507d63757$var$algoKeys = Object.keys($NKdOQ);
    var $c053586507d63757$var$hashes = [
        'sha1',
        'sha224',
        'sha256',
        'sha384',
        'sha512',
        'md5',
        'rmd160'
    ].concat($c053586507d63757$var$algoKeys);
    $c053586507d63757$export$f7201db400317331 = function() {
        return $c053586507d63757$var$hashes;
    };
    var $fS6zE = parcelRequire("fS6zE");
    $c053586507d63757$export$448fa22aedc9dbca = $fS6zE.pbkdf2;
    $c053586507d63757$export$b80c7ba289c8fa56 = $fS6zE.pbkdf2Sync;
    var $a2ApW = parcelRequire("a2ApW");
    $c053586507d63757$export$26e5786e8ac8e530 = $a2ApW.Cipher;
    $c053586507d63757$export$bdd223f16383713e = $a2ApW.createCipher;
    $c053586507d63757$export$20533d26f07f1ee0 = $a2ApW.Cipheriv;
    $c053586507d63757$export$2f64596b8cbf08b4 = $a2ApW.createCipheriv;
    $c053586507d63757$export$2ce6d8d0e8b04e1a = $a2ApW.Decipher;
    $c053586507d63757$export$12ada9414fbc594c = $a2ApW.createDecipher;
    $c053586507d63757$export$f5e7e39d57cd9700 = $a2ApW.Decipheriv;
    $c053586507d63757$export$36b6d6ef312eab39 = $a2ApW.createDecipheriv;
    $c053586507d63757$export$58a258485f1e49f6 = $a2ApW.getCiphers;
    $c053586507d63757$export$dedd8dc3dc62b370 = $a2ApW.listCiphers;
    var $ilRwV = parcelRequire("ilRwV");
    $c053586507d63757$export$971862a2fcb1bb40 = $ilRwV.DiffieHellmanGroup;
    $c053586507d63757$export$c6ff6a88acbeaf40 = $ilRwV.createDiffieHellmanGroup;
    $c053586507d63757$export$fdc27893e98845cc = $ilRwV.getDiffieHellman;
    $c053586507d63757$export$6671fb9a1323bed = $ilRwV.createDiffieHellman;
    $c053586507d63757$export$d74daf141a551db = $ilRwV.DiffieHellman;
    var $kqxVX = parcelRequire("kqxVX");
    $c053586507d63757$export$45df7cae684751af = $kqxVX.createSign;
    $c053586507d63757$export$1db683ad541682f6 = $kqxVX.Sign;
    $c053586507d63757$export$6f65485f87568e37 = $kqxVX.createVerify;
    $c053586507d63757$export$91a8e56769aeb334 = $kqxVX.Verify;
    $c053586507d63757$export$2d4117e99c2179e4 = (parcelRequire("bsZLy"));
    var $bIasb = parcelRequire("bIasb");
    $c053586507d63757$export$512823e338ddb1b7 = $bIasb.publicEncrypt;
    $c053586507d63757$export$9d0e0c0c4a8d30f3 = $bIasb.privateEncrypt;
    $c053586507d63757$export$b9d55ff329113abd = $bIasb.publicDecrypt;
    $c053586507d63757$export$7efb24e2fddf99b9 = $bIasb.privateDecrypt;
    var $9hQRv = parcelRequire("9hQRv");
    $c053586507d63757$export$bb1abf2ce84fc7e8 = $9hQRv.randomFill;
    $c053586507d63757$export$2f7171e78e524d5e = $9hQRv.randomFillSync;
    $c053586507d63757$export$e1d879b482f37d98 = function() {
        throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
    };
    $c053586507d63757$export$1a988e7317c65621 = {
        DH_CHECK_P_NOT_SAFE_PRIME: 2,
        DH_CHECK_P_NOT_PRIME: 1,
        DH_UNABLE_TO_CHECK_GENERATOR: 4,
        DH_NOT_SUITABLE_GENERATOR: 8,
        NPN_ENABLED: 1,
        ALPN_ENABLED: 1,
        RSA_PKCS1_PADDING: 1,
        RSA_SSLV23_PADDING: 2,
        RSA_NO_PADDING: 3,
        RSA_PKCS1_OAEP_PADDING: 4,
        RSA_X931_PADDING: 5,
        RSA_PKCS1_PSS_PADDING: 6,
        POINT_CONVERSION_COMPRESSED: 2,
        POINT_CONVERSION_UNCOMPRESSED: 4,
        POINT_CONVERSION_HYBRID: 6
    };
});
parcelRegister("1DyI6", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $13145bb397e3672d$var$MAX_BYTES = 65536;
    var $13145bb397e3672d$var$MAX_UINT32 = 4294967295;
    function $13145bb397e3672d$var$oldBrowser() {
        throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
    }
    var $Wth4q = parcelRequire("Wth4q");
    var $13145bb397e3672d$require$Buffer = $Wth4q.Buffer;
    var $13145bb397e3672d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
    if ($13145bb397e3672d$var$crypto && $13145bb397e3672d$var$crypto.getRandomValues) module.exports = $13145bb397e3672d$var$randomBytes;
    else module.exports = $13145bb397e3672d$var$oldBrowser;
    function $13145bb397e3672d$var$randomBytes(size, cb) {
        if (size > $13145bb397e3672d$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
        var bytes = $13145bb397e3672d$require$Buffer.allocUnsafe(size);
        if (size > 0) {
            if (size > $13145bb397e3672d$var$MAX_BYTES) for(var generated = 0; generated < size; generated += $13145bb397e3672d$var$MAX_BYTES)$13145bb397e3672d$var$crypto.getRandomValues(bytes.slice(generated, generated + $13145bb397e3672d$var$MAX_BYTES));
            else $13145bb397e3672d$var$crypto.getRandomValues(bytes);
        }
        if (typeof cb === 'function') return $6cAn5.nextTick(function() {
            cb(null, bytes);
        });
        return bytes;
    }
});
parcelRegister("Wth4q", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $0afc202a9b74167d$var$Buffer = $5k7LC.Buffer;
    function $0afc202a9b74167d$var$copyProps(src, dst) {
        for(var key in src)dst[key] = src[key];
    }
    if ($0afc202a9b74167d$var$Buffer.from && $0afc202a9b74167d$var$Buffer.alloc && $0afc202a9b74167d$var$Buffer.allocUnsafe && $0afc202a9b74167d$var$Buffer.allocUnsafeSlow) module.exports = $5k7LC;
    else {
        $0afc202a9b74167d$var$copyProps($5k7LC, module.exports);
        module.exports.Buffer = $0afc202a9b74167d$var$SafeBuffer;
    }
    function $0afc202a9b74167d$var$SafeBuffer(arg, encodingOrOffset, length) {
        return $0afc202a9b74167d$var$Buffer(arg, encodingOrOffset, length);
    }
    $0afc202a9b74167d$var$SafeBuffer.prototype = Object.create($0afc202a9b74167d$var$Buffer.prototype);
    $0afc202a9b74167d$var$copyProps($0afc202a9b74167d$var$Buffer, $0afc202a9b74167d$var$SafeBuffer);
    $0afc202a9b74167d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
        return $0afc202a9b74167d$var$Buffer(arg, encodingOrOffset, length);
    };
    $0afc202a9b74167d$var$SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        var buf = $0afc202a9b74167d$var$Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === 'string') buf.fill(fill, encoding);
            else buf.fill(fill);
        } else buf.fill(0);
        return buf;
    };
    $0afc202a9b74167d$var$SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $0afc202a9b74167d$var$Buffer(size);
    };
    $0afc202a9b74167d$var$SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $5k7LC.SlowBuffer(size);
    };
});
parcelRegister("7K4uY", function(module, exports) {
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $8ZJxF = parcelRequire("8ZJxF");
    var $6EPBm = parcelRequire("6EPBm");
    var $a21Ya = parcelRequire("a21Ya");
    var $77fwb = parcelRequire("77fwb");
    function $5a3051967cf0fdc1$var$Hash(hash) {
        $77fwb.call(this, 'digest');
        this._hash = hash;
    }
    $v3bBu($5a3051967cf0fdc1$var$Hash, $77fwb);
    $5a3051967cf0fdc1$var$Hash.prototype._update = function(data) {
        this._hash.update(data);
    };
    $5a3051967cf0fdc1$var$Hash.prototype._final = function() {
        return this._hash.digest();
    };
    module.exports = function createHash(alg) {
        alg = alg.toLowerCase();
        if (alg === 'md5') return new $8ZJxF();
        if (alg === 'rmd160' || alg === 'ripemd160') return new $6EPBm();
        return new $5a3051967cf0fdc1$var$Hash($a21Ya(alg));
    };
});
parcelRegister("v3bBu", function(module, exports) {
    if (typeof Object.create === 'function') module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
parcelRegister("8ZJxF", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $68c758ebde74a508$require$Buffer = $5k7LC.Buffer;
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $gOR7Z = parcelRequire("gOR7Z");
    var $68c758ebde74a508$var$ARRAY16 = new Array(16);
    function $68c758ebde74a508$var$MD5() {
        $gOR7Z.call(this, 64);
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
    }
    $v3bBu($68c758ebde74a508$var$MD5, $gOR7Z);
    $68c758ebde74a508$var$MD5.prototype._update = function() {
        var M = $68c758ebde74a508$var$ARRAY16;
        for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
        var a = this._a;
        var b = this._b;
        var c = this._c;
        var d = this._d;
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
        this._a = this._a + a | 0;
        this._b = this._b + b | 0;
        this._c = this._c + c | 0;
        this._d = this._d + d | 0;
    };
    $68c758ebde74a508$var$MD5.prototype._digest = function() {
        this._block[this._blockOffset++] = 0x80;
        if (this._blockOffset > 56) {
            this._block.fill(0, this._blockOffset, 64);
            this._update();
            this._blockOffset = 0;
        }
        this._block.fill(0, this._blockOffset, 56);
        this._block.writeUInt32LE(this._length[0], 56);
        this._block.writeUInt32LE(this._length[1], 60);
        this._update();
        var buffer = new $68c758ebde74a508$require$Buffer(16);
        buffer.writeInt32LE(this._a, 0);
        buffer.writeInt32LE(this._b, 4);
        buffer.writeInt32LE(this._c, 8);
        buffer.writeInt32LE(this._d, 12);
        return buffer;
    };
    function $68c758ebde74a508$var$rotl(x, n) {
        return x << n | x >>> 32 - n;
    }
    function $68c758ebde74a508$var$fnF(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
    }
    function $68c758ebde74a508$var$fnG(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
    }
    function $68c758ebde74a508$var$fnH(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
    }
    function $68c758ebde74a508$var$fnI(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
    }
    module.exports = $68c758ebde74a508$var$MD5;
});
parcelRegister("gOR7Z", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $c3ea86f24fd070bd$require$Buffer = $Wth4q.Buffer;
    var $e2HvS = parcelRequire("e2HvS");
    var $c3ea86f24fd070bd$require$Transform = $e2HvS.Transform;
    var $v3bBu = parcelRequire("v3bBu");
    function $c3ea86f24fd070bd$var$throwIfNotStringOrBuffer(val, prefix) {
        if (!$c3ea86f24fd070bd$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
    }
    function $c3ea86f24fd070bd$var$HashBase(blockSize) {
        $c3ea86f24fd070bd$require$Transform.call(this);
        this._block = $c3ea86f24fd070bd$require$Buffer.allocUnsafe(blockSize);
        this._blockSize = blockSize;
        this._blockOffset = 0;
        this._length = [
            0,
            0,
            0,
            0
        ];
        this._finalized = false;
    }
    $v3bBu($c3ea86f24fd070bd$var$HashBase, $c3ea86f24fd070bd$require$Transform);
    $c3ea86f24fd070bd$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
        var error = null;
        try {
            this.update(chunk, encoding);
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    $c3ea86f24fd070bd$var$HashBase.prototype._flush = function(callback) {
        var error = null;
        try {
            this.push(this.digest());
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    $c3ea86f24fd070bd$var$HashBase.prototype.update = function(data, encoding) {
        $c3ea86f24fd070bd$var$throwIfNotStringOrBuffer(data, 'Data');
        if (this._finalized) throw new Error('Digest already called');
        if (!$c3ea86f24fd070bd$require$Buffer.isBuffer(data)) data = $c3ea86f24fd070bd$require$Buffer.from(data, encoding);
        var block = this._block;
        var offset = 0;
        while(this._blockOffset + data.length - offset >= this._blockSize){
            for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
            this._update();
            this._blockOffset = 0;
        }
        while(offset < data.length)block[this._blockOffset++] = data[offset++];
        for(var j = 0, carry = data.length * 8; carry > 0; ++j){
            this._length[j] += carry;
            carry = this._length[j] / 0x0100000000 | 0;
            if (carry > 0) this._length[j] -= 0x0100000000 * carry;
        }
        return this;
    };
    $c3ea86f24fd070bd$var$HashBase.prototype._update = function() {
        throw new Error('_update is not implemented');
    };
    $c3ea86f24fd070bd$var$HashBase.prototype.digest = function(encoding) {
        if (this._finalized) throw new Error('Digest already called');
        this._finalized = true;
        var digest = this._digest();
        if (encoding !== undefined) digest = digest.toString(encoding);
        this._block.fill(0);
        this._blockOffset = 0;
        for(var i = 0; i < 4; ++i)this._length[i] = 0;
        return digest;
    };
    $c3ea86f24fd070bd$var$HashBase.prototype._digest = function() {
        throw new Error('_digest is not implemented');
    };
    module.exports = $c3ea86f24fd070bd$var$HashBase;
});
parcelRegister("e2HvS", function(module, exports) {
    module.exports = $a393016297afccce$var$Stream;
    var $6Oghe = parcelRequire("6Oghe");
    var $a393016297afccce$require$EE = $6Oghe.EventEmitter;
    var $v3bBu = parcelRequire("v3bBu");
    $v3bBu($a393016297afccce$var$Stream, $a393016297afccce$require$EE);
    $a393016297afccce$var$Stream.Readable = (parcelRequire("bf0eV"));
    $a393016297afccce$var$Stream.Writable = (parcelRequire("eys0S"));
    $a393016297afccce$var$Stream.Duplex = (parcelRequire("i5T1N"));
    $a393016297afccce$var$Stream.Transform = (parcelRequire("imCs6"));
    $a393016297afccce$var$Stream.PassThrough = (parcelRequire("7UmdZ"));
    $a393016297afccce$var$Stream.finished = (parcelRequire("fdhlO"));
    $a393016297afccce$var$Stream.pipeline = (parcelRequire("4kgjk"));
    $a393016297afccce$var$Stream.Stream = $a393016297afccce$var$Stream;
    function $a393016297afccce$var$Stream() {
        $a393016297afccce$require$EE.call(this);
    }
    $a393016297afccce$var$Stream.prototype.pipe = function(dest, options) {
        var source = this;
        function ondata(chunk) {
            if (dest.writable) {
                if (false === dest.write(chunk) && source.pause) source.pause();
            }
        }
        source.on('data', ondata);
        function ondrain() {
            if (source.readable && source.resume) source.resume();
        }
        dest.on('drain', ondrain);
        if (!dest._isStdio && (!options || options.end !== false)) {
            source.on('end', onend);
            source.on('close', onclose);
        }
        var didOnEnd = false;
        function onend() {
            if (didOnEnd) return;
            didOnEnd = true;
            dest.end();
        }
        function onclose() {
            if (didOnEnd) return;
            didOnEnd = true;
            if (typeof dest.destroy === 'function') dest.destroy();
        }
        function onerror(er) {
            cleanup();
            if ($a393016297afccce$require$EE.listenerCount(this, 'error') === 0) throw er;
        }
        source.on('error', onerror);
        dest.on('error', onerror);
        function cleanup() {
            source.removeListener('data', ondata);
            dest.removeListener('drain', ondrain);
            source.removeListener('end', onend);
            source.removeListener('close', onclose);
            source.removeListener('error', onerror);
            dest.removeListener('error', onerror);
            source.removeListener('end', cleanup);
            source.removeListener('close', cleanup);
            dest.removeListener('close', cleanup);
        }
        source.on('end', cleanup);
        source.on('close', cleanup);
        dest.on('close', cleanup);
        dest.emit('pipe', source);
        return dest;
    };
});
parcelRegister("6Oghe", function(module, exports) {
    'use strict';
    var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
    var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var $4f5409da028b4771$var$ReflectOwnKeys;
    if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
    else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function $4f5409da028b4771$var$EventEmitter() {
        $4f5409da028b4771$var$EventEmitter.init.call(this);
    }
    module.exports = $4f5409da028b4771$var$EventEmitter;
    module.exports.once = $4f5409da028b4771$var$once;
    $4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
    $4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
    $4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
    $4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
    var $4f5409da028b4771$var$defaultMaxListeners = 10;
    function $4f5409da028b4771$var$checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return $4f5409da028b4771$var$defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            $4f5409da028b4771$var$defaultMaxListeners = arg;
        }
    });
    $4f5409da028b4771$var$EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function $4f5409da028b4771$var$_getMaxListeners(that) {
        if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $4f5409da028b4771$var$_getMaxListeners(this);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) throw er;
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err;
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
            for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        $4f5409da028b4771$var$checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            m = $4f5409da028b4771$var$_getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $4f5409da028b4771$var$ProcessEmitWarning(w);
            }
        }
        return target;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, false);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
    $4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, true);
    };
    function $4f5409da028b4771$var$onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        $4f5409da028b4771$var$checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else $4f5409da028b4771$var$spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
    $4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
    }
    $4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, true);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, false);
    };
    $4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
    function $4f5409da028b4771$var$listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
    };
    function $4f5409da028b4771$var$arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function $4f5409da028b4771$var$spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function $4f5409da028b4771$var$unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function $4f5409da028b4771$var$once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') emitter.addEventListener(name, function wrapListener(arg) {
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
});
parcelRegister("bf0eV", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    module.exports = $82f1480952ab7c7d$var$Readable;
    var $82f1480952ab7c7d$var$Duplex;
    $82f1480952ab7c7d$var$Readable.ReadableState = $82f1480952ab7c7d$var$ReadableState;
    var $6Oghe = parcelRequire("6Oghe");
    var $82f1480952ab7c7d$require$EE = $6Oghe.EventEmitter;
    var $82f1480952ab7c7d$var$EElistenerCount = function EElistenerCount(emitter, type) {
        return emitter.listeners(type).length;
    };
    var $aX75n = parcelRequire("aX75n");
    var $5k7LC = parcelRequire("5k7LC");
    var $82f1480952ab7c7d$require$Buffer = $5k7LC.Buffer;
    var $82f1480952ab7c7d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $82f1480952ab7c7d$var$_uint8ArrayToBuffer(chunk) {
        return $82f1480952ab7c7d$require$Buffer.from(chunk);
    }
    function $82f1480952ab7c7d$var$_isUint8Array(obj) {
        return $82f1480952ab7c7d$require$Buffer.isBuffer(obj) || obj instanceof $82f1480952ab7c7d$var$OurUint8Array;
    }
    var $3gWwf = parcelRequire("3gWwf");
    var $82f1480952ab7c7d$var$debug;
    if ($3gWwf && $3gWwf.debuglog) $82f1480952ab7c7d$var$debug = $3gWwf.debuglog('stream');
    else $82f1480952ab7c7d$var$debug = function debug() {};
    var $ifkfB = parcelRequire("ifkfB");
    var $kZqR5 = parcelRequire("kZqR5");
    var $9GAcH = parcelRequire("9GAcH");
    var $82f1480952ab7c7d$var$getHighWaterMark = $9GAcH.getHighWaterMark;
    var $bBIKv = parcelRequire("bBIKv");
    var $82f1480952ab7c7d$require$_require$codes = $bBIKv.codes;
    var $82f1480952ab7c7d$var$ERR_INVALID_ARG_TYPE = $82f1480952ab7c7d$require$_require$codes.ERR_INVALID_ARG_TYPE, $82f1480952ab7c7d$var$ERR_STREAM_PUSH_AFTER_EOF = $82f1480952ab7c7d$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $82f1480952ab7c7d$var$ERR_METHOD_NOT_IMPLEMENTED = $82f1480952ab7c7d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $82f1480952ab7c7d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $82f1480952ab7c7d$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    var $82f1480952ab7c7d$var$StringDecoder;
    var $82f1480952ab7c7d$var$createReadableStreamAsyncIterator;
    var $82f1480952ab7c7d$var$from;
    (parcelRequire("v3bBu"))($82f1480952ab7c7d$var$Readable, $aX75n);
    var $82f1480952ab7c7d$var$errorOrDestroy = $kZqR5.errorOrDestroy;
    var $82f1480952ab7c7d$var$kProxyEvents = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    function $82f1480952ab7c7d$var$prependListener(emitter, event, fn) {
        if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
    function $82f1480952ab7c7d$var$ReadableState(options, stream, isDuplex) {
        $82f1480952ab7c7d$var$Duplex = $82f1480952ab7c7d$var$Duplex || (parcelRequire("i5T1N"));
        options = options || {};
        if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $82f1480952ab7c7d$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
        this.highWaterMark = $82f1480952ab7c7d$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
        this.buffer = new $ifkfB();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        this.sync = true;
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        this.paused = true;
        this.emitClose = options.emitClose !== false;
        this.autoDestroy = !!options.autoDestroy;
        this.destroyed = false;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.awaitDrain = 0;
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options.encoding) {
            if (!$82f1480952ab7c7d$var$StringDecoder) $82f1480952ab7c7d$var$StringDecoder = (parcelRequire("3872E")).StringDecoder;
            this.decoder = new $82f1480952ab7c7d$var$StringDecoder(options.encoding);
            this.encoding = options.encoding;
        }
    }
    function $82f1480952ab7c7d$var$Readable(options) {
        $82f1480952ab7c7d$var$Duplex = $82f1480952ab7c7d$var$Duplex || (parcelRequire("i5T1N"));
        if (!(this instanceof $82f1480952ab7c7d$var$Readable)) return new $82f1480952ab7c7d$var$Readable(options);
        var isDuplex = this instanceof $82f1480952ab7c7d$var$Duplex;
        this._readableState = new $82f1480952ab7c7d$var$ReadableState(options, this, isDuplex);
        this.readable = true;
        if (options) {
            if (typeof options.read === 'function') this._read = options.read;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
        }
        $aX75n.call(this);
    }
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'destroyed', {
        enumerable: false,
        get: function get() {
            if (this._readableState === undefined) return false;
            return this._readableState.destroyed;
        },
        set: function set(value) {
            if (!this._readableState) return;
            this._readableState.destroyed = value;
        }
    });
    $82f1480952ab7c7d$var$Readable.prototype.destroy = $kZqR5.destroy;
    $82f1480952ab7c7d$var$Readable.prototype._undestroy = $kZqR5.undestroy;
    $82f1480952ab7c7d$var$Readable.prototype._destroy = function(err, cb) {
        cb(err);
    };
    $82f1480952ab7c7d$var$Readable.prototype.push = function(chunk, encoding) {
        var state = this._readableState;
        var skipChunkCheck;
        if (!state.objectMode) {
            if (typeof chunk === 'string') {
                encoding = encoding || state.defaultEncoding;
                if (encoding !== state.encoding) {
                    chunk = $82f1480952ab7c7d$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
                skipChunkCheck = true;
            }
        } else skipChunkCheck = true;
        return $82f1480952ab7c7d$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };
    $82f1480952ab7c7d$var$Readable.prototype.unshift = function(chunk) {
        return $82f1480952ab7c7d$var$readableAddChunk(this, chunk, null, true, false);
    };
    function $82f1480952ab7c7d$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
        $82f1480952ab7c7d$var$debug('readableAddChunk', chunk);
        var state = stream._readableState;
        if (chunk === null) {
            state.reading = false;
            $82f1480952ab7c7d$var$onEofChunk(stream, state);
        } else {
            var er;
            if (!skipChunkCheck) er = $82f1480952ab7c7d$var$chunkInvalid(state, chunk);
            if (er) $82f1480952ab7c7d$var$errorOrDestroy(stream, er);
            else if (state.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $82f1480952ab7c7d$require$Buffer.prototype) chunk = $82f1480952ab7c7d$var$_uint8ArrayToBuffer(chunk);
                if (addToFront) {
                    if (state.endEmitted) $82f1480952ab7c7d$var$errorOrDestroy(stream, new $82f1480952ab7c7d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                    else $82f1480952ab7c7d$var$addChunk(stream, state, chunk, true);
                } else if (state.ended) $82f1480952ab7c7d$var$errorOrDestroy(stream, new $82f1480952ab7c7d$var$ERR_STREAM_PUSH_AFTER_EOF());
                else if (state.destroyed) return false;
                else {
                    state.reading = false;
                    if (state.decoder && !encoding) {
                        chunk = state.decoder.write(chunk);
                        if (state.objectMode || chunk.length !== 0) $82f1480952ab7c7d$var$addChunk(stream, state, chunk, false);
                        else $82f1480952ab7c7d$var$maybeReadMore(stream, state);
                    } else $82f1480952ab7c7d$var$addChunk(stream, state, chunk, false);
                }
            } else if (!addToFront) {
                state.reading = false;
                $82f1480952ab7c7d$var$maybeReadMore(stream, state);
            }
        }
        return !state.ended && (state.length < state.highWaterMark || state.length === 0);
    }
    function $82f1480952ab7c7d$var$addChunk(stream, state, chunk, addToFront) {
        if (state.flowing && state.length === 0 && !state.sync) {
            state.awaitDrain = 0;
            stream.emit('data', chunk);
        } else {
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);
            else state.buffer.push(chunk);
            if (state.needReadable) $82f1480952ab7c7d$var$emitReadable(stream);
        }
        $82f1480952ab7c7d$var$maybeReadMore(stream, state);
    }
    function $82f1480952ab7c7d$var$chunkInvalid(state, chunk) {
        var er;
        if (!$82f1480952ab7c7d$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $82f1480952ab7c7d$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
        return er;
    }
    $82f1480952ab7c7d$var$Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    $82f1480952ab7c7d$var$Readable.prototype.setEncoding = function(enc) {
        if (!$82f1480952ab7c7d$var$StringDecoder) $82f1480952ab7c7d$var$StringDecoder = (parcelRequire("3872E")).StringDecoder;
        var decoder = new $82f1480952ab7c7d$var$StringDecoder(enc);
        this._readableState.decoder = decoder;
        this._readableState.encoding = this._readableState.decoder.encoding;
        var p = this._readableState.buffer.head;
        var content = '';
        while(p !== null){
            content += decoder.write(p.data);
            p = p.next;
        }
        this._readableState.buffer.clear();
        if (content !== '') this._readableState.buffer.push(content);
        this._readableState.length = content.length;
        return this;
    };
    var $82f1480952ab7c7d$var$MAX_HWM = 0x40000000;
    function $82f1480952ab7c7d$var$computeNewHighWaterMark(n) {
        if (n >= $82f1480952ab7c7d$var$MAX_HWM) n = $82f1480952ab7c7d$var$MAX_HWM;
        else {
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    function $82f1480952ab7c7d$var$howMuchToRead(n, state) {
        if (n <= 0 || state.length === 0 && state.ended) return 0;
        if (state.objectMode) return 1;
        if (n !== n) {
            if (state.flowing && state.length) return state.buffer.head.data.length;
            else return state.length;
        }
        if (n > state.highWaterMark) state.highWaterMark = $82f1480952ab7c7d$var$computeNewHighWaterMark(n);
        if (n <= state.length) return n;
        if (!state.ended) {
            state.needReadable = true;
            return 0;
        }
        return state.length;
    }
    $82f1480952ab7c7d$var$Readable.prototype.read = function(n) {
        $82f1480952ab7c7d$var$debug('read', n);
        n = parseInt(n, 10);
        var state = this._readableState;
        var nOrig = n;
        if (n !== 0) state.emittedReadable = false;
        if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
            $82f1480952ab7c7d$var$debug('read: emitReadable', state.length, state.ended);
            if (state.length === 0 && state.ended) $82f1480952ab7c7d$var$endReadable(this);
            else $82f1480952ab7c7d$var$emitReadable(this);
            return null;
        }
        n = $82f1480952ab7c7d$var$howMuchToRead(n, state);
        if (n === 0 && state.ended) {
            if (state.length === 0) $82f1480952ab7c7d$var$endReadable(this);
            return null;
        }
        var doRead = state.needReadable;
        $82f1480952ab7c7d$var$debug('need readable', doRead);
        if (state.length === 0 || state.length - n < state.highWaterMark) {
            doRead = true;
            $82f1480952ab7c7d$var$debug('length less than watermark', doRead);
        }
        if (state.ended || state.reading) {
            doRead = false;
            $82f1480952ab7c7d$var$debug('reading or ended', doRead);
        } else if (doRead) {
            $82f1480952ab7c7d$var$debug('do read');
            state.reading = true;
            state.sync = true;
            if (state.length === 0) state.needReadable = true;
            this._read(state.highWaterMark);
            state.sync = false;
            if (!state.reading) n = $82f1480952ab7c7d$var$howMuchToRead(nOrig, state);
        }
        var ret;
        if (n > 0) ret = $82f1480952ab7c7d$var$fromList(n, state);
        else ret = null;
        if (ret === null) {
            state.needReadable = state.length <= state.highWaterMark;
            n = 0;
        } else {
            state.length -= n;
            state.awaitDrain = 0;
        }
        if (state.length === 0) {
            if (!state.ended) state.needReadable = true;
            if (nOrig !== n && state.ended) $82f1480952ab7c7d$var$endReadable(this);
        }
        if (ret !== null) this.emit('data', ret);
        return ret;
    };
    function $82f1480952ab7c7d$var$onEofChunk(stream, state) {
        $82f1480952ab7c7d$var$debug('onEofChunk');
        if (state.ended) return;
        if (state.decoder) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
            }
        }
        state.ended = true;
        if (state.sync) $82f1480952ab7c7d$var$emitReadable(stream);
        else {
            state.needReadable = false;
            if (!state.emittedReadable) {
                state.emittedReadable = true;
                $82f1480952ab7c7d$var$emitReadable_(stream);
            }
        }
    }
    function $82f1480952ab7c7d$var$emitReadable(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('emitReadable', state.needReadable, state.emittedReadable);
        state.needReadable = false;
        if (!state.emittedReadable) {
            $82f1480952ab7c7d$var$debug('emitReadable', state.flowing);
            state.emittedReadable = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$emitReadable_, stream);
        }
    }
    function $82f1480952ab7c7d$var$emitReadable_(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
        if (!state.destroyed && (state.length || state.ended)) {
            stream.emit('readable');
            state.emittedReadable = false;
        }
        state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
        $82f1480952ab7c7d$var$flow(stream);
    }
    function $82f1480952ab7c7d$var$maybeReadMore(stream, state) {
        if (!state.readingMore) {
            state.readingMore = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$maybeReadMore_, stream, state);
        }
    }
    function $82f1480952ab7c7d$var$maybeReadMore_(stream, state) {
        while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
            var len = state.length;
            $82f1480952ab7c7d$var$debug('maybeReadMore read 0');
            stream.read(0);
            if (len === state.length) break;
        }
        state.readingMore = false;
    }
    $82f1480952ab7c7d$var$Readable.prototype._read = function(n) {
        $82f1480952ab7c7d$var$errorOrDestroy(this, new $82f1480952ab7c7d$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
    };
    $82f1480952ab7c7d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state = this._readableState;
        switch(state.pipesCount){
            case 0:
                state.pipes = dest;
                break;
            case 1:
                state.pipes = [
                    state.pipes,
                    dest
                ];
                break;
            default:
                state.pipes.push(dest);
                break;
        }
        state.pipesCount += 1;
        $82f1480952ab7c7d$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
        var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6cAn5.stdout && dest !== $6cAn5.stderr;
        var endFn = doEnd ? onend : unpipe;
        if (state.endEmitted) $6cAn5.nextTick(endFn);
        else src.once('end', endFn);
        dest.on('unpipe', onunpipe);
        function onunpipe(readable, unpipeInfo) {
            $82f1480952ab7c7d$var$debug('onunpipe');
            if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                    unpipeInfo.hasUnpiped = true;
                    cleanup();
                }
            }
        }
        function onend() {
            $82f1480952ab7c7d$var$debug('onend');
            dest.end();
        }
        var ondrain = $82f1480952ab7c7d$var$pipeOnDrain(src);
        dest.on('drain', ondrain);
        var cleanedUp = false;
        function cleanup() {
            $82f1480952ab7c7d$var$debug('cleanup');
            dest.removeListener('close', onclose);
            dest.removeListener('finish', onfinish);
            dest.removeListener('drain', ondrain);
            dest.removeListener('error', onerror);
            dest.removeListener('unpipe', onunpipe);
            src.removeListener('end', onend);
            src.removeListener('end', unpipe);
            src.removeListener('data', ondata);
            cleanedUp = true;
            if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        src.on('data', ondata);
        function ondata(chunk) {
            $82f1480952ab7c7d$var$debug('ondata');
            var ret = dest.write(chunk);
            $82f1480952ab7c7d$var$debug('dest.write', ret);
            if (ret === false) {
                if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $82f1480952ab7c7d$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                    $82f1480952ab7c7d$var$debug('false write response, pause', state.awaitDrain);
                    state.awaitDrain++;
                }
                src.pause();
            }
        }
        function onerror(er) {
            $82f1480952ab7c7d$var$debug('onerror', er);
            unpipe();
            dest.removeListener('error', onerror);
            if ($82f1480952ab7c7d$var$EElistenerCount(dest, 'error') === 0) $82f1480952ab7c7d$var$errorOrDestroy(dest, er);
        }
        $82f1480952ab7c7d$var$prependListener(dest, 'error', onerror);
        function onclose() {
            dest.removeListener('finish', onfinish);
            unpipe();
        }
        dest.once('close', onclose);
        function onfinish() {
            $82f1480952ab7c7d$var$debug('onfinish');
            dest.removeListener('close', onclose);
            unpipe();
        }
        dest.once('finish', onfinish);
        function unpipe() {
            $82f1480952ab7c7d$var$debug('unpipe');
            src.unpipe(dest);
        }
        dest.emit('pipe', src);
        if (!state.flowing) {
            $82f1480952ab7c7d$var$debug('pipe resume');
            src.resume();
        }
        return dest;
    };
    function $82f1480952ab7c7d$var$pipeOnDrain(src) {
        return function pipeOnDrainFunctionResult() {
            var state = src._readableState;
            $82f1480952ab7c7d$var$debug('pipeOnDrain', state.awaitDrain);
            if (state.awaitDrain) state.awaitDrain--;
            if (state.awaitDrain === 0 && $82f1480952ab7c7d$var$EElistenerCount(src, 'data')) {
                state.flowing = true;
                $82f1480952ab7c7d$var$flow(src);
            }
        };
    }
    $82f1480952ab7c7d$var$Readable.prototype.unpipe = function(dest) {
        var state = this._readableState;
        var unpipeInfo = {
            hasUnpiped: false
        };
        if (state.pipesCount === 0) return this;
        if (state.pipesCount === 1) {
            if (dest && dest !== state.pipes) return this;
            if (!dest) dest = state.pipes;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            if (dest) dest.emit('unpipe', this, unpipeInfo);
            return this;
        }
        if (!dest) {
            var dests = state.pipes;
            var len = state.pipesCount;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
                hasUnpiped: false
            });
            return this;
        }
        var index = $82f1480952ab7c7d$var$indexOf(state.pipes, dest);
        if (index === -1) return this;
        state.pipes.splice(index, 1);
        state.pipesCount -= 1;
        if (state.pipesCount === 1) state.pipes = state.pipes[0];
        dest.emit('unpipe', this, unpipeInfo);
        return this;
    };
    $82f1480952ab7c7d$var$Readable.prototype.on = function(ev, fn) {
        var res = $aX75n.prototype.on.call(this, ev, fn);
        var state = this._readableState;
        if (ev === 'data') {
            state.readableListening = this.listenerCount('readable') > 0;
            if (state.flowing !== false) this.resume();
        } else if (ev === 'readable') {
            if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.flowing = false;
                state.emittedReadable = false;
                $82f1480952ab7c7d$var$debug('on readable', state.length, state.reading);
                if (state.length) $82f1480952ab7c7d$var$emitReadable(this);
                else if (!state.reading) $6cAn5.nextTick($82f1480952ab7c7d$var$nReadingNextTick, this);
            }
        }
        return res;
    };
    $82f1480952ab7c7d$var$Readable.prototype.addListener = $82f1480952ab7c7d$var$Readable.prototype.on;
    $82f1480952ab7c7d$var$Readable.prototype.removeListener = function(ev, fn) {
        var res = $aX75n.prototype.removeListener.call(this, ev, fn);
        if (ev === 'readable') $6cAn5.nextTick($82f1480952ab7c7d$var$updateReadableListening, this);
        return res;
    };
    $82f1480952ab7c7d$var$Readable.prototype.removeAllListeners = function(ev) {
        var res = $aX75n.prototype.removeAllListeners.apply(this, arguments);
        if (ev === 'readable' || ev === undefined) $6cAn5.nextTick($82f1480952ab7c7d$var$updateReadableListening, this);
        return res;
    };
    function $82f1480952ab7c7d$var$updateReadableListening(self1) {
        var state = self1._readableState;
        state.readableListening = self1.listenerCount('readable') > 0;
        if (state.resumeScheduled && !state.paused) state.flowing = true;
        else if (self1.listenerCount('data') > 0) self1.resume();
    }
    function $82f1480952ab7c7d$var$nReadingNextTick(self1) {
        $82f1480952ab7c7d$var$debug('readable nexttick read 0');
        self1.read(0);
    }
    $82f1480952ab7c7d$var$Readable.prototype.resume = function() {
        var state = this._readableState;
        if (!state.flowing) {
            $82f1480952ab7c7d$var$debug('resume');
            state.flowing = !state.readableListening;
            $82f1480952ab7c7d$var$resume(this, state);
        }
        state.paused = false;
        return this;
    };
    function $82f1480952ab7c7d$var$resume(stream, state) {
        if (!state.resumeScheduled) {
            state.resumeScheduled = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$resume_, stream, state);
        }
    }
    function $82f1480952ab7c7d$var$resume_(stream, state) {
        $82f1480952ab7c7d$var$debug('resume', state.reading);
        if (!state.reading) stream.read(0);
        state.resumeScheduled = false;
        stream.emit('resume');
        $82f1480952ab7c7d$var$flow(stream);
        if (state.flowing && !state.reading) stream.read(0);
    }
    $82f1480952ab7c7d$var$Readable.prototype.pause = function() {
        $82f1480952ab7c7d$var$debug('call pause flowing=%j', this._readableState.flowing);
        if (this._readableState.flowing !== false) {
            $82f1480952ab7c7d$var$debug('pause');
            this._readableState.flowing = false;
            this.emit('pause');
        }
        this._readableState.paused = true;
        return this;
    };
    function $82f1480952ab7c7d$var$flow(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('flow', state.flowing);
        while(state.flowing && stream.read() !== null);
    }
    $82f1480952ab7c7d$var$Readable.prototype.wrap = function(stream) {
        var _this = this;
        var state = this._readableState;
        var paused = false;
        stream.on('end', function() {
            $82f1480952ab7c7d$var$debug('wrapped end');
            if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
            }
            _this.push(null);
        });
        stream.on('data', function(chunk) {
            $82f1480952ab7c7d$var$debug('wrapped data');
            if (state.decoder) chunk = state.decoder.write(chunk);
            if (state.objectMode && (chunk === null || chunk === undefined)) return;
            else if (!state.objectMode && (!chunk || !chunk.length)) return;
            var ret = _this.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
            return function methodWrapReturnFunction() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        for(var n = 0; n < $82f1480952ab7c7d$var$kProxyEvents.length; n++)stream.on($82f1480952ab7c7d$var$kProxyEvents[n], this.emit.bind(this, $82f1480952ab7c7d$var$kProxyEvents[n]));
        this._read = function(n) {
            $82f1480952ab7c7d$var$debug('wrapped _read', n);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return this;
    };
    if (typeof Symbol === 'function') $82f1480952ab7c7d$var$Readable.prototype[Symbol.asyncIterator] = function() {
        if ($82f1480952ab7c7d$var$createReadableStreamAsyncIterator === undefined) $82f1480952ab7c7d$var$createReadableStreamAsyncIterator = (parcelRequire("LC63a"));
        return $82f1480952ab7c7d$var$createReadableStreamAsyncIterator(this);
    };
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableHighWaterMark', {
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    });
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableBuffer', {
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    });
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableFlowing', {
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    });
    $82f1480952ab7c7d$var$Readable._fromList = $82f1480952ab7c7d$var$fromList;
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableLength', {
        enumerable: false,
        get: function get() {
            return this._readableState.length;
        }
    });
    function $82f1480952ab7c7d$var$fromList(n, state) {
        if (state.length === 0) return null;
        var ret;
        if (state.objectMode) ret = state.buffer.shift();
        else if (!n || n >= state.length) {
            if (state.decoder) ret = state.buffer.join('');
            else if (state.buffer.length === 1) ret = state.buffer.first();
            else ret = state.buffer.concat(state.length);
            state.buffer.clear();
        } else ret = state.buffer.consume(n, state.decoder);
        return ret;
    }
    function $82f1480952ab7c7d$var$endReadable(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('endReadable', state.endEmitted);
        if (!state.endEmitted) {
            state.ended = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$endReadableNT, state, stream);
        }
    }
    function $82f1480952ab7c7d$var$endReadableNT(state, stream) {
        $82f1480952ab7c7d$var$debug('endReadableNT', state.endEmitted, state.length);
        if (!state.endEmitted && state.length === 0) {
            state.endEmitted = true;
            stream.readable = false;
            stream.emit('end');
            if (state.autoDestroy) {
                var wState = stream._writableState;
                if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
            }
        }
    }
    if (typeof Symbol === 'function') $82f1480952ab7c7d$var$Readable.from = function(iterable, opts) {
        if ($82f1480952ab7c7d$var$from === undefined) $82f1480952ab7c7d$var$from = (parcelRequire("jV0Pb"));
        return $82f1480952ab7c7d$var$from($82f1480952ab7c7d$var$Readable, iterable, opts);
    };
    function $82f1480952ab7c7d$var$indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
});
parcelRegister("aX75n", function(module, exports) {
    module.exports = (parcelRequire("6Oghe")).EventEmitter;
});
parcelRegister("ifkfB", function(module, exports) {
    'use strict';
    function $d4895617e8f18431$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $d4895617e8f18431$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? $d4895617e8f18431$var$ownKeys(Object(source), !0).forEach(function(key) {
                $d4895617e8f18431$var$_defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d4895617e8f18431$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $d4895617e8f18431$var$_defineProperty(obj, key, value) {
        key = $d4895617e8f18431$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $d4895617e8f18431$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $d4895617e8f18431$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $d4895617e8f18431$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $d4895617e8f18431$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $d4895617e8f18431$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $d4895617e8f18431$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $d4895617e8f18431$var$_toPropertyKey(arg) {
        var key = $d4895617e8f18431$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $d4895617e8f18431$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $5k7LC = parcelRequire("5k7LC");
    var $d4895617e8f18431$var$Buffer = $5k7LC.Buffer;
    var $3gWwf = parcelRequire("3gWwf");
    var $d4895617e8f18431$var$inspect = $3gWwf.inspect;
    var $d4895617e8f18431$var$custom = $d4895617e8f18431$var$inspect && $d4895617e8f18431$var$inspect.custom || 'inspect';
    function $d4895617e8f18431$var$copyBuffer(src, target, offset) {
        $d4895617e8f18431$var$Buffer.prototype.copy.call(src, target, offset);
    }
    module.exports = function() {
        function BufferList() {
            $d4895617e8f18431$var$_classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        $d4895617e8f18431$var$_createClass(BufferList, [
            {
                key: "push",
                value: function push(v) {
                    var entry = {
                        data: v,
                        next: null
                    };
                    if (this.length > 0) this.tail.next = entry;
                    else this.head = entry;
                    this.tail = entry;
                    ++this.length;
                }
            },
            {
                key: "unshift",
                value: function unshift(v) {
                    var entry = {
                        data: v,
                        next: this.head
                    };
                    if (this.length === 0) this.tail = entry;
                    this.head = entry;
                    ++this.length;
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (this.length === 0) return;
                    var ret = this.head.data;
                    if (this.length === 1) this.head = this.tail = null;
                    else this.head = this.head.next;
                    --this.length;
                    return ret;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
            },
            {
                key: "join",
                value: function join(s) {
                    if (this.length === 0) return '';
                    var p = this.head;
                    var ret = '' + p.data;
                    while(p = p.next)ret += s + p.data;
                    return ret;
                }
            },
            {
                key: "concat",
                value: function concat(n) {
                    if (this.length === 0) return $d4895617e8f18431$var$Buffer.alloc(0);
                    var ret = $d4895617e8f18431$var$Buffer.allocUnsafe(n >>> 0);
                    var p = this.head;
                    var i = 0;
                    while(p){
                        $d4895617e8f18431$var$copyBuffer(p.data, ret, i);
                        i += p.data.length;
                        p = p.next;
                    }
                    return ret;
                }
            },
            {
                key: "consume",
                value: function consume(n, hasStrings) {
                    var ret;
                    if (n < this.head.data.length) {
                        ret = this.head.data.slice(0, n);
                        this.head.data = this.head.data.slice(n);
                    } else if (n === this.head.data.length) ret = this.shift();
                    else ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                    return ret;
                }
            },
            {
                key: "first",
                value: function first() {
                    return this.head.data;
                }
            },
            {
                key: "_getString",
                value: function _getString(n) {
                    var p = this.head;
                    var c = 1;
                    var ret = p.data;
                    n -= ret.length;
                    while(p = p.next){
                        var str = p.data;
                        var nb = n > str.length ? str.length : n;
                        if (nb === str.length) ret += str;
                        else ret += str.slice(0, n);
                        n -= nb;
                        if (n === 0) {
                            if (nb === str.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = str.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                    var ret = $d4895617e8f18431$var$Buffer.allocUnsafe(n);
                    var p = this.head;
                    var c = 1;
                    p.data.copy(ret);
                    n -= p.data.length;
                    while(p = p.next){
                        var buf = p.data;
                        var nb = n > buf.length ? buf.length : n;
                        buf.copy(ret, ret.length - n, 0, nb);
                        n -= nb;
                        if (n === 0) {
                            if (nb === buf.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = buf.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: $d4895617e8f18431$var$custom,
                value: function value(_, options) {
                    return $d4895617e8f18431$var$inspect(this, $d4895617e8f18431$var$_objectSpread($d4895617e8f18431$var$_objectSpread({}, options), {}, {
                        depth: 0,
                        customInspect: false
                    }));
                }
            }
        ]);
        return BufferList;
    }();
});
parcelRegister("kZqR5", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $f47e560b8425ff2b$var$destroy(err, cb) {
        var _this = this;
        var readableDestroyed = this._readableState && this._readableState.destroyed;
        var writableDestroyed = this._writableState && this._writableState.destroyed;
        if (readableDestroyed || writableDestroyed) {
            if (cb) cb(err);
            else if (err) {
                if (!this._writableState) $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorNT, this, err);
                else if (!this._writableState.errorEmitted) {
                    this._writableState.errorEmitted = true;
                    $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorNT, this, err);
                }
            }
            return this;
        }
        if (this._readableState) this._readableState.destroyed = true;
        if (this._writableState) this._writableState.destroyed = true;
        this._destroy(err || null, function(err) {
            if (!cb && err) {
                if (!_this._writableState) $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorAndCloseNT, _this, err);
                else if (!_this._writableState.errorEmitted) {
                    _this._writableState.errorEmitted = true;
                    $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorAndCloseNT, _this, err);
                } else $6cAn5.nextTick($f47e560b8425ff2b$var$emitCloseNT, _this);
            } else if (cb) {
                $6cAn5.nextTick($f47e560b8425ff2b$var$emitCloseNT, _this);
                cb(err);
            } else $6cAn5.nextTick($f47e560b8425ff2b$var$emitCloseNT, _this);
        });
        return this;
    }
    function $f47e560b8425ff2b$var$emitErrorAndCloseNT(self, err) {
        $f47e560b8425ff2b$var$emitErrorNT(self, err);
        $f47e560b8425ff2b$var$emitCloseNT(self);
    }
    function $f47e560b8425ff2b$var$emitCloseNT(self) {
        if (self._writableState && !self._writableState.emitClose) return;
        if (self._readableState && !self._readableState.emitClose) return;
        self.emit('close');
    }
    function $f47e560b8425ff2b$var$undestroy() {
        if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
        }
        if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
        }
    }
    function $f47e560b8425ff2b$var$emitErrorNT(self, err) {
        self.emit('error', err);
    }
    function $f47e560b8425ff2b$var$errorOrDestroy(stream, err) {
        var rState = stream._readableState;
        var wState = stream._writableState;
        if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
        else stream.emit('error', err);
    }
    module.exports = {
        destroy: $f47e560b8425ff2b$var$destroy,
        undestroy: $f47e560b8425ff2b$var$undestroy,
        errorOrDestroy: $f47e560b8425ff2b$var$errorOrDestroy
    };
});
parcelRegister("9GAcH", function(module, exports) {
    'use strict';
    var $70d41e9da8f0bbbf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("bBIKv")).codes.ERR_INVALID_OPT_VALUE;
    function $70d41e9da8f0bbbf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
        return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
    }
    function $70d41e9da8f0bbbf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
        var hwm = $70d41e9da8f0bbbf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
        if (hwm != null) {
            if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                var name = isDuplex ? duplexKey : 'highWaterMark';
                throw new $70d41e9da8f0bbbf$var$ERR_INVALID_OPT_VALUE(name, hwm);
            }
            return Math.floor(hwm);
        }
        return state.objectMode ? 16 : 16384;
    }
    module.exports = {
        getHighWaterMark: $70d41e9da8f0bbbf$var$getHighWaterMark
    };
});
parcelRegister("bBIKv", function(module, exports) {
    $parcel$export(module.exports, "codes", ()=>$8735dc9fe35b6ad4$export$e45cb6485273080e, (v)=>$8735dc9fe35b6ad4$export$e45cb6485273080e = v);
    var $8735dc9fe35b6ad4$export$e45cb6485273080e;
    'use strict';
    function $8735dc9fe35b6ad4$var$_inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var $8735dc9fe35b6ad4$var$codes = {};
    function $8735dc9fe35b6ad4$var$createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = function(_Base) {
            $8735dc9fe35b6ad4$var$_inheritsLoose(NodeError, _Base);
            function NodeError(arg1, arg2, arg3) {
                return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
            }
            return NodeError;
        }(Base);
        NodeError.prototype.name = Base.name;
        NodeError.prototype.code = code;
        $8735dc9fe35b6ad4$var$codes[code] = NodeError;
    }
    function $8735dc9fe35b6ad4$var$oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function $8735dc9fe35b6ad4$var$startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function $8735dc9fe35b6ad4$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $8735dc9fe35b6ad4$var$includes(str, search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    $8735dc9fe35b6ad4$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
        return 'The value "' + value + '" is invalid for option "' + name + '"';
    }, TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
        var determiner;
        if (typeof expected === 'string' && $8735dc9fe35b6ad4$var$startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
        } else determiner = 'must be';
        var msg;
        if ($8735dc9fe35b6ad4$var$endsWith(name, ' argument')) msg = "The ".concat(name, " ").concat(determiner, " ").concat($8735dc9fe35b6ad4$var$oneOf(expected, 'type'));
        else {
            var type = $8735dc9fe35b6ad4$var$includes(name, '.') ? 'property' : 'argument';
            msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($8735dc9fe35b6ad4$var$oneOf(expected, 'type'));
        }
        msg += ". Received type ".concat(typeof actual);
        return msg;
    }, TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
        return 'The ' + name + ' method is not implemented';
    });
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
        return 'Cannot call ' + name + ' after a stream was destroyed';
    });
    $8735dc9fe35b6ad4$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
        return 'Unknown encoding: ' + arg;
    }, TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
    $8735dc9fe35b6ad4$export$e45cb6485273080e = $8735dc9fe35b6ad4$var$codes;
});
parcelRegister("i5T1N", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $d2c36102fbaedf53$var$objectKeys = Object.keys || function(obj) {
        var keys = [];
        for(var key in obj)keys.push(key);
        return keys;
    };
    module.exports = $d2c36102fbaedf53$var$Duplex;
    var $bf0eV = parcelRequire("bf0eV");
    var $eys0S = parcelRequire("eys0S");
    (parcelRequire("v3bBu"))($d2c36102fbaedf53$var$Duplex, $bf0eV);
    var $d2c36102fbaedf53$var$keys = $d2c36102fbaedf53$var$objectKeys($eys0S.prototype);
    for(var $d2c36102fbaedf53$var$v = 0; $d2c36102fbaedf53$var$v < $d2c36102fbaedf53$var$keys.length; $d2c36102fbaedf53$var$v++){
        var $d2c36102fbaedf53$var$method = $d2c36102fbaedf53$var$keys[$d2c36102fbaedf53$var$v];
        if (!$d2c36102fbaedf53$var$Duplex.prototype[$d2c36102fbaedf53$var$method]) $d2c36102fbaedf53$var$Duplex.prototype[$d2c36102fbaedf53$var$method] = $eys0S.prototype[$d2c36102fbaedf53$var$method];
    }
    function $d2c36102fbaedf53$var$Duplex(options) {
        if (!(this instanceof $d2c36102fbaedf53$var$Duplex)) return new $d2c36102fbaedf53$var$Duplex(options);
        $bf0eV.call(this, options);
        $eys0S.call(this, options);
        this.allowHalfOpen = true;
        if (options) {
            if (options.readable === false) this.readable = false;
            if (options.writable === false) this.writable = false;
            if (options.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once('end', $d2c36102fbaedf53$var$onend);
            }
        }
    }
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function get() {
            return this._writableState.highWaterMark;
        }
    });
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'writableBuffer', {
        enumerable: false,
        get: function get() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'writableLength', {
        enumerable: false,
        get: function get() {
            return this._writableState.length;
        }
    });
    function $d2c36102fbaedf53$var$onend() {
        if (this._writableState.ended) return;
        $6cAn5.nextTick($d2c36102fbaedf53$var$onEndNT, this);
    }
    function $d2c36102fbaedf53$var$onEndNT(self) {
        self.end();
    }
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'destroyed', {
        enumerable: false,
        get: function get() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(value) {
            if (this._readableState === undefined || this._writableState === undefined) return;
            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
        }
    });
});
parcelRegister("eys0S", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    module.exports = $a989f87ed04e2b91$var$Writable;
    function $a989f87ed04e2b91$var$WriteReq(chunk, encoding, cb) {
        this.chunk = chunk;
        this.encoding = encoding;
        this.callback = cb;
        this.next = null;
    }
    function $a989f87ed04e2b91$var$CorkedRequest(state) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function() {
            $a989f87ed04e2b91$var$onCorkedFinish(_this, state);
        };
    }
    var $a989f87ed04e2b91$var$Duplex;
    $a989f87ed04e2b91$var$Writable.WritableState = $a989f87ed04e2b91$var$WritableState;
    var $a989f87ed04e2b91$var$internalUtil = {
        deprecate: (parcelRequire("geQ6V"))
    };
    var $aX75n = parcelRequire("aX75n");
    var $5k7LC = parcelRequire("5k7LC");
    var $a989f87ed04e2b91$require$Buffer = $5k7LC.Buffer;
    var $a989f87ed04e2b91$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $a989f87ed04e2b91$var$_uint8ArrayToBuffer(chunk) {
        return $a989f87ed04e2b91$require$Buffer.from(chunk);
    }
    function $a989f87ed04e2b91$var$_isUint8Array(obj) {
        return $a989f87ed04e2b91$require$Buffer.isBuffer(obj) || obj instanceof $a989f87ed04e2b91$var$OurUint8Array;
    }
    var $kZqR5 = parcelRequire("kZqR5");
    var $9GAcH = parcelRequire("9GAcH");
    var $a989f87ed04e2b91$var$getHighWaterMark = $9GAcH.getHighWaterMark;
    var $bBIKv = parcelRequire("bBIKv");
    var $a989f87ed04e2b91$require$_require$codes = $bBIKv.codes;
    var $a989f87ed04e2b91$var$ERR_INVALID_ARG_TYPE = $a989f87ed04e2b91$require$_require$codes.ERR_INVALID_ARG_TYPE, $a989f87ed04e2b91$var$ERR_METHOD_NOT_IMPLEMENTED = $a989f87ed04e2b91$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a989f87ed04e2b91$var$ERR_MULTIPLE_CALLBACK = $a989f87ed04e2b91$require$_require$codes.ERR_MULTIPLE_CALLBACK, $a989f87ed04e2b91$var$ERR_STREAM_CANNOT_PIPE = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $a989f87ed04e2b91$var$ERR_STREAM_DESTROYED = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_DESTROYED, $a989f87ed04e2b91$var$ERR_STREAM_NULL_VALUES = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_NULL_VALUES, $a989f87ed04e2b91$var$ERR_STREAM_WRITE_AFTER_END = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $a989f87ed04e2b91$var$ERR_UNKNOWN_ENCODING = $a989f87ed04e2b91$require$_require$codes.ERR_UNKNOWN_ENCODING;
    var $a989f87ed04e2b91$var$errorOrDestroy = $kZqR5.errorOrDestroy;
    (parcelRequire("v3bBu"))($a989f87ed04e2b91$var$Writable, $aX75n);
    function $a989f87ed04e2b91$var$nop() {}
    function $a989f87ed04e2b91$var$WritableState(options, stream, isDuplex) {
        $a989f87ed04e2b91$var$Duplex = $a989f87ed04e2b91$var$Duplex || (parcelRequire("i5T1N"));
        options = options || {};
        if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $a989f87ed04e2b91$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
        this.highWaterMark = $a989f87ed04e2b91$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        var noDecode = options.decodeStrings === false;
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = function(er) {
            $a989f87ed04e2b91$var$onwrite(stream, er);
        };
        this.writecb = null;
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        this.pendingcb = 0;
        this.prefinished = false;
        this.errorEmitted = false;
        this.emitClose = options.emitClose !== false;
        this.autoDestroy = !!options.autoDestroy;
        this.bufferedRequestCount = 0;
        this.corkedRequestsFree = new $a989f87ed04e2b91$var$CorkedRequest(this);
    }
    $a989f87ed04e2b91$var$WritableState.prototype.getBuffer = function getBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    (function() {
        try {
            Object.defineProperty($a989f87ed04e2b91$var$WritableState.prototype, 'buffer', {
                get: $a989f87ed04e2b91$var$internalUtil.deprecate(function writableStateBufferGetter() {
                    return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
            });
        } catch (_) {}
    })();
    var $a989f87ed04e2b91$var$realHasInstance;
    if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
        $a989f87ed04e2b91$var$realHasInstance = Function.prototype[Symbol.hasInstance];
        Object.defineProperty($a989f87ed04e2b91$var$Writable, Symbol.hasInstance, {
            value: function value(object) {
                if ($a989f87ed04e2b91$var$realHasInstance.call(this, object)) return true;
                if (this !== $a989f87ed04e2b91$var$Writable) return false;
                return object && object._writableState instanceof $a989f87ed04e2b91$var$WritableState;
            }
        });
    } else $a989f87ed04e2b91$var$realHasInstance = function realHasInstance(object) {
        return object instanceof this;
    };
    function $a989f87ed04e2b91$var$Writable(options) {
        $a989f87ed04e2b91$var$Duplex = $a989f87ed04e2b91$var$Duplex || (parcelRequire("i5T1N"));
        var isDuplex = this instanceof $a989f87ed04e2b91$var$Duplex;
        if (!isDuplex && !$a989f87ed04e2b91$var$realHasInstance.call($a989f87ed04e2b91$var$Writable, this)) return new $a989f87ed04e2b91$var$Writable(options);
        this._writableState = new $a989f87ed04e2b91$var$WritableState(options, this, isDuplex);
        this.writable = true;
        if (options) {
            if (typeof options.write === 'function') this._write = options.write;
            if (typeof options.writev === 'function') this._writev = options.writev;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
            if (typeof options.final === 'function') this._final = options.final;
        }
        $aX75n.call(this);
    }
    $a989f87ed04e2b91$var$Writable.prototype.pipe = function() {
        $a989f87ed04e2b91$var$errorOrDestroy(this, new $a989f87ed04e2b91$var$ERR_STREAM_CANNOT_PIPE());
    };
    function $a989f87ed04e2b91$var$writeAfterEnd(stream, cb) {
        var er = new $a989f87ed04e2b91$var$ERR_STREAM_WRITE_AFTER_END();
        $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
        $6cAn5.nextTick(cb, er);
    }
    function $a989f87ed04e2b91$var$validChunk(stream, state, chunk, cb) {
        var er;
        if (chunk === null) er = new $a989f87ed04e2b91$var$ERR_STREAM_NULL_VALUES();
        else if (typeof chunk !== 'string' && !state.objectMode) er = new $a989f87ed04e2b91$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer'
        ], chunk);
        if (er) {
            $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
            $6cAn5.nextTick(cb, er);
            return false;
        }
        return true;
    }
    $a989f87ed04e2b91$var$Writable.prototype.write = function(chunk, encoding, cb) {
        var state = this._writableState;
        var ret = false;
        var isBuf = !state.objectMode && $a989f87ed04e2b91$var$_isUint8Array(chunk);
        if (isBuf && !$a989f87ed04e2b91$require$Buffer.isBuffer(chunk)) chunk = $a989f87ed04e2b91$var$_uint8ArrayToBuffer(chunk);
        if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (isBuf) encoding = 'buffer';
        else if (!encoding) encoding = state.defaultEncoding;
        if (typeof cb !== 'function') cb = $a989f87ed04e2b91$var$nop;
        if (state.ending) $a989f87ed04e2b91$var$writeAfterEnd(this, cb);
        else if (isBuf || $a989f87ed04e2b91$var$validChunk(this, state, chunk, cb)) {
            state.pendingcb++;
            ret = $a989f87ed04e2b91$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
        }
        return ret;
    };
    $a989f87ed04e2b91$var$Writable.prototype.cork = function() {
        this._writableState.corked++;
    };
    $a989f87ed04e2b91$var$Writable.prototype.uncork = function() {
        var state = this._writableState;
        if (state.corked) {
            state.corked--;
            if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a989f87ed04e2b91$var$clearBuffer(this, state);
        }
    };
    $a989f87ed04e2b91$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === 'string') encoding = encoding.toLowerCase();
        if (!([
            'hex',
            'utf8',
            'utf-8',
            'ascii',
            'binary',
            'base64',
            'ucs2',
            'ucs-2',
            'utf16le',
            'utf-16le',
            'raw'
        ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $a989f87ed04e2b91$var$ERR_UNKNOWN_ENCODING(encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'writableBuffer', {
        enumerable: false,
        get: function get() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    function $a989f87ed04e2b91$var$decodeChunk(state, chunk, encoding) {
        if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $a989f87ed04e2b91$require$Buffer.from(chunk, encoding);
        return chunk;
    }
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function get() {
            return this._writableState.highWaterMark;
        }
    });
    function $a989f87ed04e2b91$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
        if (!isBuf) {
            var newChunk = $a989f87ed04e2b91$var$decodeChunk(state, chunk, encoding);
            if (chunk !== newChunk) {
                isBuf = true;
                encoding = 'buffer';
                chunk = newChunk;
            }
        }
        var len = state.objectMode ? 1 : chunk.length;
        state.length += len;
        var ret = state.length < state.highWaterMark;
        if (!ret) state.needDrain = true;
        if (state.writing || state.corked) {
            var last = state.lastBufferedRequest;
            state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
            };
            if (last) last.next = state.lastBufferedRequest;
            else state.bufferedRequest = state.lastBufferedRequest;
            state.bufferedRequestCount += 1;
        } else $a989f87ed04e2b91$var$doWrite(stream, state, false, len, chunk, encoding, cb);
        return ret;
    }
    function $a989f87ed04e2b91$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
        state.writelen = len;
        state.writecb = cb;
        state.writing = true;
        state.sync = true;
        if (state.destroyed) state.onwrite(new $a989f87ed04e2b91$var$ERR_STREAM_DESTROYED('write'));
        else if (writev) stream._writev(chunk, state.onwrite);
        else stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    function $a989f87ed04e2b91$var$onwriteError(stream, state, sync, er, cb) {
        --state.pendingcb;
        if (sync) {
            $6cAn5.nextTick(cb, er);
            $6cAn5.nextTick($a989f87ed04e2b91$var$finishMaybe, stream, state);
            stream._writableState.errorEmitted = true;
            $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
        } else {
            cb(er);
            stream._writableState.errorEmitted = true;
            $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
            $a989f87ed04e2b91$var$finishMaybe(stream, state);
        }
    }
    function $a989f87ed04e2b91$var$onwriteStateUpdate(state) {
        state.writing = false;
        state.writecb = null;
        state.length -= state.writelen;
        state.writelen = 0;
    }
    function $a989f87ed04e2b91$var$onwrite(stream, er) {
        var state = stream._writableState;
        var sync = state.sync;
        var cb = state.writecb;
        if (typeof cb !== 'function') throw new $a989f87ed04e2b91$var$ERR_MULTIPLE_CALLBACK();
        $a989f87ed04e2b91$var$onwriteStateUpdate(state);
        if (er) $a989f87ed04e2b91$var$onwriteError(stream, state, sync, er, cb);
        else {
            var finished = $a989f87ed04e2b91$var$needFinish(state) || stream.destroyed;
            if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a989f87ed04e2b91$var$clearBuffer(stream, state);
            if (sync) $6cAn5.nextTick($a989f87ed04e2b91$var$afterWrite, stream, state, finished, cb);
            else $a989f87ed04e2b91$var$afterWrite(stream, state, finished, cb);
        }
    }
    function $a989f87ed04e2b91$var$afterWrite(stream, state, finished, cb) {
        if (!finished) $a989f87ed04e2b91$var$onwriteDrain(stream, state);
        state.pendingcb--;
        cb();
        $a989f87ed04e2b91$var$finishMaybe(stream, state);
    }
    function $a989f87ed04e2b91$var$onwriteDrain(stream, state) {
        if (state.length === 0 && state.needDrain) {
            state.needDrain = false;
            stream.emit('drain');
        }
    }
    function $a989f87ed04e2b91$var$clearBuffer(stream, state) {
        state.bufferProcessing = true;
        var entry = state.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            var l = state.bufferedRequestCount;
            var buffer = new Array(l);
            var holder = state.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            var allBuffers = true;
            while(entry){
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
            }
            buffer.allBuffers = allBuffers;
            $a989f87ed04e2b91$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
            state.pendingcb++;
            state.lastBufferedRequest = null;
            if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state.corkedRequestsFree = new $a989f87ed04e2b91$var$CorkedRequest(state);
            state.bufferedRequestCount = 0;
        } else {
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                $a989f87ed04e2b91$var$doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--;
                if (state.writing) break;
            }
            if (entry === null) state.lastBufferedRequest = null;
        }
        state.bufferedRequest = entry;
        state.bufferProcessing = false;
    }
    $a989f87ed04e2b91$var$Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new $a989f87ed04e2b91$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
    };
    $a989f87ed04e2b91$var$Writable.prototype._writev = null;
    $a989f87ed04e2b91$var$Writable.prototype.end = function(chunk, encoding, cb) {
        var state = this._writableState;
        if (typeof chunk === 'function') {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
        if (state.corked) {
            state.corked = 1;
            this.uncork();
        }
        if (!state.ending) $a989f87ed04e2b91$var$endWritable(this, state, cb);
        return this;
    };
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'writableLength', {
        enumerable: false,
        get: function get() {
            return this._writableState.length;
        }
    });
    function $a989f87ed04e2b91$var$needFinish(state) {
        return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }
    function $a989f87ed04e2b91$var$callFinal(stream, state) {
        stream._final(function(err) {
            state.pendingcb--;
            if (err) $a989f87ed04e2b91$var$errorOrDestroy(stream, err);
            state.prefinished = true;
            stream.emit('prefinish');
            $a989f87ed04e2b91$var$finishMaybe(stream, state);
        });
    }
    function $a989f87ed04e2b91$var$prefinish(stream, state) {
        if (!state.prefinished && !state.finalCalled) {
            if (typeof stream._final === 'function' && !state.destroyed) {
                state.pendingcb++;
                state.finalCalled = true;
                $6cAn5.nextTick($a989f87ed04e2b91$var$callFinal, stream, state);
            } else {
                state.prefinished = true;
                stream.emit('prefinish');
            }
        }
    }
    function $a989f87ed04e2b91$var$finishMaybe(stream, state) {
        var need = $a989f87ed04e2b91$var$needFinish(state);
        if (need) {
            $a989f87ed04e2b91$var$prefinish(stream, state);
            if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit('finish');
                if (state.autoDestroy) {
                    var rState = stream._readableState;
                    if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                }
            }
        }
        return need;
    }
    function $a989f87ed04e2b91$var$endWritable(stream, state, cb) {
        state.ending = true;
        $a989f87ed04e2b91$var$finishMaybe(stream, state);
        if (cb) {
            if (state.finished) $6cAn5.nextTick(cb);
            else stream.once('finish', cb);
        }
        state.ended = true;
        stream.writable = false;
    }
    function $a989f87ed04e2b91$var$onCorkedFinish(corkReq, state, err) {
        var entry = corkReq.entry;
        corkReq.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        state.corkedRequestsFree.next = corkReq;
    }
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'destroyed', {
        enumerable: false,
        get: function get() {
            if (this._writableState === undefined) return false;
            return this._writableState.destroyed;
        },
        set: function set(value) {
            if (!this._writableState) return;
            this._writableState.destroyed = value;
        }
    });
    $a989f87ed04e2b91$var$Writable.prototype.destroy = $kZqR5.destroy;
    $a989f87ed04e2b91$var$Writable.prototype._undestroy = $kZqR5.undestroy;
    $a989f87ed04e2b91$var$Writable.prototype._destroy = function(err, cb) {
        cb(err);
    };
});
parcelRegister("geQ6V", function(module, exports) {
    module.exports = $bd26603cb430fbe6$var$deprecate;
    function $bd26603cb430fbe6$var$deprecate(fn, msg) {
        if ($bd26603cb430fbe6$var$config('noDeprecation')) return fn;
        var warned = false;
        function deprecated() {
            if (!warned) {
                if ($bd26603cb430fbe6$var$config('throwDeprecation')) throw new Error(msg);
                else if ($bd26603cb430fbe6$var$config('traceDeprecation')) console.trace(msg);
                else console.warn(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    }
    function $bd26603cb430fbe6$var$config(name) {
        try {
            if (!$parcel$global.localStorage) return false;
        } catch (_) {
            return false;
        }
        var val = $parcel$global.localStorage[name];
        if (null == val) return false;
        return String(val).toLowerCase() === 'true';
    }
});
parcelRegister("3872E", function(module, exports) {
    $parcel$export(module.exports, "StringDecoder", ()=>$247794d1c930d1a9$export$63a7aa211a91ed69, (v)=>$247794d1c930d1a9$export$63a7aa211a91ed69 = v);
    var $247794d1c930d1a9$export$63a7aa211a91ed69;
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $247794d1c930d1a9$require$Buffer = $Wth4q.Buffer;
    var $247794d1c930d1a9$var$isEncoding = $247794d1c930d1a9$require$Buffer.isEncoding || function(encoding) {
        encoding = '' + encoding;
        switch(encoding && encoding.toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
            case 'raw':
                return true;
            default:
                return false;
        }
    };
    function $247794d1c930d1a9$var$_normalizeEncoding(enc) {
        if (!enc) return 'utf8';
        var retried;
        while(true)switch(enc){
            case 'utf8':
            case 'utf-8':
                return 'utf8';
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return 'utf16le';
            case 'latin1':
            case 'binary':
                return 'latin1';
            case 'base64':
            case 'ascii':
            case 'hex':
                return enc;
            default:
                if (retried) return;
                enc = ('' + enc).toLowerCase();
                retried = true;
        }
    }
    function $247794d1c930d1a9$var$normalizeEncoding(enc) {
        var nenc = $247794d1c930d1a9$var$_normalizeEncoding(enc);
        if (typeof nenc !== 'string' && ($247794d1c930d1a9$require$Buffer.isEncoding === $247794d1c930d1a9$var$isEncoding || !$247794d1c930d1a9$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
        return nenc || enc;
    }
    $247794d1c930d1a9$export$63a7aa211a91ed69 = $247794d1c930d1a9$var$StringDecoder;
    function $247794d1c930d1a9$var$StringDecoder(encoding) {
        this.encoding = $247794d1c930d1a9$var$normalizeEncoding(encoding);
        var nb;
        switch(this.encoding){
            case 'utf16le':
                this.text = $247794d1c930d1a9$var$utf16Text;
                this.end = $247794d1c930d1a9$var$utf16End;
                nb = 4;
                break;
            case 'utf8':
                this.fillLast = $247794d1c930d1a9$var$utf8FillLast;
                nb = 4;
                break;
            case 'base64':
                this.text = $247794d1c930d1a9$var$base64Text;
                this.end = $247794d1c930d1a9$var$base64End;
                nb = 3;
                break;
            default:
                this.write = $247794d1c930d1a9$var$simpleWrite;
                this.end = $247794d1c930d1a9$var$simpleEnd;
                return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = $247794d1c930d1a9$require$Buffer.allocUnsafe(nb);
    }
    $247794d1c930d1a9$var$StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return '';
        var r;
        var i;
        if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === undefined) return '';
            i = this.lastNeed;
            this.lastNeed = 0;
        } else i = 0;
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || '';
    };
    $247794d1c930d1a9$var$StringDecoder.prototype.end = $247794d1c930d1a9$var$utf8End;
    $247794d1c930d1a9$var$StringDecoder.prototype.text = $247794d1c930d1a9$var$utf8Text;
    $247794d1c930d1a9$var$StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
    };
    function $247794d1c930d1a9$var$utf8CheckByte(byte) {
        if (byte <= 0x7F) return 0;
        else if (byte >> 5 === 0x06) return 2;
        else if (byte >> 4 === 0x0E) return 3;
        else if (byte >> 3 === 0x1E) return 4;
        return byte >> 6 === 0x02 ? -1 : -2;
    }
    function $247794d1c930d1a9$var$utf8CheckIncomplete(self, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 1;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 2;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) {
                if (nb === 2) nb = 0;
                else self.lastNeed = nb - 3;
            }
            return nb;
        }
        return 0;
    }
    function $247794d1c930d1a9$var$utf8CheckExtraBytes(self, buf, p) {
        if ((buf[0] & 0xC0) !== 0x80) {
            self.lastNeed = 0;
            return '\ufffd';
        }
        if (self.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 0xC0) !== 0x80) {
                self.lastNeed = 1;
                return '\ufffd';
            }
            if (self.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 0xC0) !== 0x80) {
                    self.lastNeed = 2;
                    return '\ufffd';
                }
            }
        }
    }
    function $247794d1c930d1a9$var$utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = $247794d1c930d1a9$var$utf8CheckExtraBytes(this, buf, p);
        if (r !== undefined) return r;
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
    }
    function $247794d1c930d1a9$var$utf8Text(buf, i) {
        var total = $247794d1c930d1a9$var$utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString('utf8', i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString('utf8', i, end);
    }
    function $247794d1c930d1a9$var$utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + '\ufffd';
        return r;
    }
    function $247794d1c930d1a9$var$utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
            var r = buf.toString('utf16le', i);
            if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 0xD800 && c <= 0xDBFF) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                }
            }
            return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString('utf16le', i, buf.length - 1);
    }
    function $247794d1c930d1a9$var$utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) {
            var end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString('utf16le', 0, end);
        }
        return r;
    }
    function $247794d1c930d1a9$var$base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString('base64', i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) this.lastChar[0] = buf[buf.length - 1];
        else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString('base64', i, buf.length - n);
    }
    function $247794d1c930d1a9$var$base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
        return r;
    }
    function $247794d1c930d1a9$var$simpleWrite(buf) {
        return buf.toString(this.encoding);
    }
    function $247794d1c930d1a9$var$simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : '';
    }
});
parcelRegister("LC63a", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $08f1f116beb38af8$var$_Object$setPrototypeO;
    function $08f1f116beb38af8$var$_defineProperty(obj, key, value) {
        key = $08f1f116beb38af8$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $08f1f116beb38af8$var$_toPropertyKey(arg) {
        var key = $08f1f116beb38af8$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $08f1f116beb38af8$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $fdhlO = parcelRequire("fdhlO");
    var $08f1f116beb38af8$var$kLastResolve = Symbol('lastResolve');
    var $08f1f116beb38af8$var$kLastReject = Symbol('lastReject');
    var $08f1f116beb38af8$var$kError = Symbol('error');
    var $08f1f116beb38af8$var$kEnded = Symbol('ended');
    var $08f1f116beb38af8$var$kLastPromise = Symbol('lastPromise');
    var $08f1f116beb38af8$var$kHandlePromise = Symbol('handlePromise');
    var $08f1f116beb38af8$var$kStream = Symbol('stream');
    function $08f1f116beb38af8$var$createIterResult(value, done) {
        return {
            value: value,
            done: done
        };
    }
    function $08f1f116beb38af8$var$readAndResolve(iter) {
        var resolve = iter[$08f1f116beb38af8$var$kLastResolve];
        if (resolve !== null) {
            var data = iter[$08f1f116beb38af8$var$kStream].read();
            if (data !== null) {
                iter[$08f1f116beb38af8$var$kLastPromise] = null;
                iter[$08f1f116beb38af8$var$kLastResolve] = null;
                iter[$08f1f116beb38af8$var$kLastReject] = null;
                resolve($08f1f116beb38af8$var$createIterResult(data, false));
            }
        }
    }
    function $08f1f116beb38af8$var$onReadable(iter) {
        $6cAn5.nextTick($08f1f116beb38af8$var$readAndResolve, iter);
    }
    function $08f1f116beb38af8$var$wrapForNext(lastPromise, iter) {
        return function(resolve, reject) {
            lastPromise.then(function() {
                if (iter[$08f1f116beb38af8$var$kEnded]) {
                    resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
                    return;
                }
                iter[$08f1f116beb38af8$var$kHandlePromise](resolve, reject);
            }, reject);
        };
    }
    var $08f1f116beb38af8$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
    var $08f1f116beb38af8$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($08f1f116beb38af8$var$_Object$setPrototypeO = {
        get stream () {
            return this[$08f1f116beb38af8$var$kStream];
        },
        next: function next() {
            var _this = this;
            var error = this[$08f1f116beb38af8$var$kError];
            if (error !== null) return Promise.reject(error);
            if (this[$08f1f116beb38af8$var$kEnded]) return Promise.resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
            if (this[$08f1f116beb38af8$var$kStream].destroyed) return new Promise(function(resolve, reject) {
                $6cAn5.nextTick(function() {
                    if (_this[$08f1f116beb38af8$var$kError]) reject(_this[$08f1f116beb38af8$var$kError]);
                    else resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
                });
            });
            var lastPromise = this[$08f1f116beb38af8$var$kLastPromise];
            var promise;
            if (lastPromise) promise = new Promise($08f1f116beb38af8$var$wrapForNext(lastPromise, this));
            else {
                var data = this[$08f1f116beb38af8$var$kStream].read();
                if (data !== null) return Promise.resolve($08f1f116beb38af8$var$createIterResult(data, false));
                promise = new Promise(this[$08f1f116beb38af8$var$kHandlePromise]);
            }
            this[$08f1f116beb38af8$var$kLastPromise] = promise;
            return promise;
        }
    }, $08f1f116beb38af8$var$_defineProperty($08f1f116beb38af8$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
        return this;
    }), $08f1f116beb38af8$var$_defineProperty($08f1f116beb38af8$var$_Object$setPrototypeO, "return", function _return() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2[$08f1f116beb38af8$var$kStream].destroy(null, function(err) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
            });
        });
    }), $08f1f116beb38af8$var$_Object$setPrototypeO), $08f1f116beb38af8$var$AsyncIteratorPrototype);
    var $08f1f116beb38af8$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
        var _Object$create;
        var iterator = Object.create($08f1f116beb38af8$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kStream, {
            value: stream,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kLastResolve, {
            value: null,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kLastReject, {
            value: null,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kError, {
            value: null,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kEnded, {
            value: stream._readableState.endEmitted,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kHandlePromise, {
            value: function value(resolve, reject) {
                var data = iterator[$08f1f116beb38af8$var$kStream].read();
                if (data) {
                    iterator[$08f1f116beb38af8$var$kLastPromise] = null;
                    iterator[$08f1f116beb38af8$var$kLastResolve] = null;
                    iterator[$08f1f116beb38af8$var$kLastReject] = null;
                    resolve($08f1f116beb38af8$var$createIterResult(data, false));
                } else {
                    iterator[$08f1f116beb38af8$var$kLastResolve] = resolve;
                    iterator[$08f1f116beb38af8$var$kLastReject] = reject;
                }
            },
            writable: true
        }), _Object$create));
        iterator[$08f1f116beb38af8$var$kLastPromise] = null;
        $fdhlO(stream, function(err) {
            if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
                var reject = iterator[$08f1f116beb38af8$var$kLastReject];
                if (reject !== null) {
                    iterator[$08f1f116beb38af8$var$kLastPromise] = null;
                    iterator[$08f1f116beb38af8$var$kLastResolve] = null;
                    iterator[$08f1f116beb38af8$var$kLastReject] = null;
                    reject(err);
                }
                iterator[$08f1f116beb38af8$var$kError] = err;
                return;
            }
            var resolve = iterator[$08f1f116beb38af8$var$kLastResolve];
            if (resolve !== null) {
                iterator[$08f1f116beb38af8$var$kLastPromise] = null;
                iterator[$08f1f116beb38af8$var$kLastResolve] = null;
                iterator[$08f1f116beb38af8$var$kLastReject] = null;
                resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
            }
            iterator[$08f1f116beb38af8$var$kEnded] = true;
        });
        stream.on('readable', $08f1f116beb38af8$var$onReadable.bind(null, iterator));
        return iterator;
    };
    module.exports = $08f1f116beb38af8$var$createReadableStreamAsyncIterator;
});
parcelRegister("fdhlO", function(module, exports) {
    'use strict';
    var $b135876c7ee1da99$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("bBIKv")).codes.ERR_STREAM_PREMATURE_CLOSE;
    function $b135876c7ee1da99$var$once(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            callback.apply(this, args);
        };
    }
    function $b135876c7ee1da99$var$noop() {}
    function $b135876c7ee1da99$var$isRequest(stream) {
        return stream.setHeader && typeof stream.abort === 'function';
    }
    function $b135876c7ee1da99$var$eos(stream, opts, callback) {
        if (typeof opts === 'function') return $b135876c7ee1da99$var$eos(stream, null, opts);
        if (!opts) opts = {};
        callback = $b135876c7ee1da99$var$once(callback || $b135876c7ee1da99$var$noop);
        var readable = opts.readable || opts.readable !== false && stream.readable;
        var writable = opts.writable || opts.writable !== false && stream.writable;
        var onlegacyfinish = function onlegacyfinish() {
            if (!stream.writable) onfinish();
        };
        var writableEnded = stream._writableState && stream._writableState.finished;
        var onfinish = function onfinish() {
            writable = false;
            writableEnded = true;
            if (!readable) callback.call(stream);
        };
        var readableEnded = stream._readableState && stream._readableState.endEmitted;
        var onend = function onend() {
            readable = false;
            readableEnded = true;
            if (!writable) callback.call(stream);
        };
        var onerror = function onerror(err) {
            callback.call(stream, err);
        };
        var onclose = function onclose() {
            var err;
            if (readable && !readableEnded) {
                if (!stream._readableState || !stream._readableState.ended) err = new $b135876c7ee1da99$var$ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
            if (writable && !writableEnded) {
                if (!stream._writableState || !stream._writableState.ended) err = new $b135876c7ee1da99$var$ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
        };
        var onrequest = function onrequest() {
            stream.req.on('finish', onfinish);
        };
        if ($b135876c7ee1da99$var$isRequest(stream)) {
            stream.on('complete', onfinish);
            stream.on('abort', onclose);
            if (stream.req) onrequest();
            else stream.on('request', onrequest);
        } else if (writable && !stream._writableState) {
            stream.on('end', onlegacyfinish);
            stream.on('close', onlegacyfinish);
        }
        stream.on('end', onend);
        stream.on('finish', onfinish);
        if (opts.error !== false) stream.on('error', onerror);
        stream.on('close', onclose);
        return function() {
            stream.removeListener('complete', onfinish);
            stream.removeListener('abort', onclose);
            stream.removeListener('request', onrequest);
            if (stream.req) stream.req.removeListener('finish', onfinish);
            stream.removeListener('end', onlegacyfinish);
            stream.removeListener('close', onlegacyfinish);
            stream.removeListener('finish', onfinish);
            stream.removeListener('end', onend);
            stream.removeListener('error', onerror);
            stream.removeListener('close', onclose);
        };
    }
    module.exports = $b135876c7ee1da99$var$eos;
});
parcelRegister("jV0Pb", function(module, exports) {
    module.exports = function() {
        throw new Error('Readable.from is not available in the browser');
    };
});
parcelRegister("imCs6", function(module, exports) {
    'use strict';
    module.exports = $d5e81be4a04bf4ac$var$Transform;
    var $bBIKv = parcelRequire("bBIKv");
    var $d5e81be4a04bf4ac$require$_require$codes = $bBIKv.codes;
    var $d5e81be4a04bf4ac$var$ERR_METHOD_NOT_IMPLEMENTED = $d5e81be4a04bf4ac$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d5e81be4a04bf4ac$var$ERR_MULTIPLE_CALLBACK = $d5e81be4a04bf4ac$require$_require$codes.ERR_MULTIPLE_CALLBACK, $d5e81be4a04bf4ac$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $d5e81be4a04bf4ac$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $d5e81be4a04bf4ac$var$ERR_TRANSFORM_WITH_LENGTH_0 = $d5e81be4a04bf4ac$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
    var $i5T1N = parcelRequire("i5T1N");
    (parcelRequire("v3bBu"))($d5e81be4a04bf4ac$var$Transform, $i5T1N);
    function $d5e81be4a04bf4ac$var$afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (cb === null) return this.emit('error', new $d5e81be4a04bf4ac$var$ERR_MULTIPLE_CALLBACK());
        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
    function $d5e81be4a04bf4ac$var$Transform(options) {
        if (!(this instanceof $d5e81be4a04bf4ac$var$Transform)) return new $d5e81be4a04bf4ac$var$Transform(options);
        $i5T1N.call(this, options);
        this._transformState = {
            afterTransform: $d5e81be4a04bf4ac$var$afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null
        };
        this._readableState.needReadable = true;
        this._readableState.sync = false;
        if (options) {
            if (typeof options.transform === 'function') this._transform = options.transform;
            if (typeof options.flush === 'function') this._flush = options.flush;
        }
        this.on('prefinish', $d5e81be4a04bf4ac$var$prefinish);
    }
    function $d5e81be4a04bf4ac$var$prefinish() {
        var _this = this;
        if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
            $d5e81be4a04bf4ac$var$done(_this, er, data);
        });
        else $d5e81be4a04bf4ac$var$done(this, null, null);
    }
    $d5e81be4a04bf4ac$var$Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return $i5T1N.prototype.push.call(this, chunk, encoding);
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._transform = function(chunk, encoding, cb) {
        cb(new $d5e81be4a04bf4ac$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else ts.needTransform = true;
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._destroy = function(err, cb) {
        $i5T1N.prototype._destroy.call(this, err, function(err2) {
            cb(err2);
        });
    };
    function $d5e81be4a04bf4ac$var$done(stream, er, data) {
        if (er) return stream.emit('error', er);
        if (data != null) stream.push(data);
        if (stream._writableState.length) throw new $d5e81be4a04bf4ac$var$ERR_TRANSFORM_WITH_LENGTH_0();
        if (stream._transformState.transforming) throw new $d5e81be4a04bf4ac$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
        return stream.push(null);
    }
});
parcelRegister("7UmdZ", function(module, exports) {
    'use strict';
    module.exports = $5c1f00b9234785d5$var$PassThrough;
    var $imCs6 = parcelRequire("imCs6");
    (parcelRequire("v3bBu"))($5c1f00b9234785d5$var$PassThrough, $imCs6);
    function $5c1f00b9234785d5$var$PassThrough(options) {
        if (!(this instanceof $5c1f00b9234785d5$var$PassThrough)) return new $5c1f00b9234785d5$var$PassThrough(options);
        $imCs6.call(this, options);
    }
    $5c1f00b9234785d5$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
});
parcelRegister("4kgjk", function(module, exports) {
    'use strict';
    var $3265aea6500b968a$var$eos;
    function $3265aea6500b968a$var$once(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            callback.apply(void 0, arguments);
        };
    }
    var $bBIKv = parcelRequire("bBIKv");
    var $3265aea6500b968a$require$_require$codes = $bBIKv.codes;
    var $3265aea6500b968a$var$ERR_MISSING_ARGS = $3265aea6500b968a$require$_require$codes.ERR_MISSING_ARGS, $3265aea6500b968a$var$ERR_STREAM_DESTROYED = $3265aea6500b968a$require$_require$codes.ERR_STREAM_DESTROYED;
    function $3265aea6500b968a$var$noop(err) {
        if (err) throw err;
    }
    function $3265aea6500b968a$var$isRequest(stream) {
        return stream.setHeader && typeof stream.abort === 'function';
    }
    function $3265aea6500b968a$var$destroyer(stream, reading, writing, callback) {
        callback = $3265aea6500b968a$var$once(callback);
        var closed = false;
        stream.on('close', function() {
            closed = true;
        });
        if ($3265aea6500b968a$var$eos === undefined) $3265aea6500b968a$var$eos = (parcelRequire("fdhlO"));
        $3265aea6500b968a$var$eos(stream, {
            readable: reading,
            writable: writing
        }, function(err) {
            if (err) return callback(err);
            closed = true;
            callback();
        });
        var destroyed = false;
        return function(err) {
            if (closed) return;
            if (destroyed) return;
            destroyed = true;
            if ($3265aea6500b968a$var$isRequest(stream)) return stream.abort();
            if (typeof stream.destroy === 'function') return stream.destroy();
            callback(err || new $3265aea6500b968a$var$ERR_STREAM_DESTROYED('pipe'));
        };
    }
    function $3265aea6500b968a$var$call(fn) {
        fn();
    }
    function $3265aea6500b968a$var$pipe(from, to) {
        return from.pipe(to);
    }
    function $3265aea6500b968a$var$popCallback(streams) {
        if (!streams.length) return $3265aea6500b968a$var$noop;
        if (typeof streams[streams.length - 1] !== 'function') return $3265aea6500b968a$var$noop;
        return streams.pop();
    }
    function $3265aea6500b968a$var$pipeline() {
        for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
        var callback = $3265aea6500b968a$var$popCallback(streams);
        if (Array.isArray(streams[0])) streams = streams[0];
        if (streams.length < 2) throw new $3265aea6500b968a$var$ERR_MISSING_ARGS('streams');
        var error;
        var destroys = streams.map(function(stream, i) {
            var reading = i < streams.length - 1;
            var writing = i > 0;
            return $3265aea6500b968a$var$destroyer(stream, reading, writing, function(err) {
                if (!error) error = err;
                if (err) destroys.forEach($3265aea6500b968a$var$call);
                if (reading) return;
                destroys.forEach($3265aea6500b968a$var$call);
                callback(error);
            });
        });
        return streams.reduce($3265aea6500b968a$var$pipe);
    }
    module.exports = $3265aea6500b968a$var$pipeline;
});
parcelRegister("6EPBm", function(module, exports) {
    'use strict';
    var $5k7LC = parcelRequire("5k7LC");
    var $4d8e8181b4bf2e98$require$Buffer = $5k7LC.Buffer;
    var $v3bBu = parcelRequire("v3bBu");
    var $gOR7Z = parcelRequire("gOR7Z");
    var $4d8e8181b4bf2e98$var$ARRAY16 = new Array(16);
    var $4d8e8181b4bf2e98$var$zl = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        7,
        4,
        13,
        1,
        10,
        6,
        15,
        3,
        12,
        0,
        9,
        5,
        2,
        14,
        11,
        8,
        3,
        10,
        14,
        4,
        9,
        15,
        8,
        1,
        2,
        7,
        0,
        6,
        13,
        11,
        5,
        12,
        1,
        9,
        11,
        10,
        0,
        8,
        12,
        4,
        13,
        3,
        7,
        15,
        14,
        5,
        6,
        2,
        4,
        0,
        5,
        9,
        7,
        12,
        2,
        10,
        14,
        1,
        3,
        8,
        11,
        6,
        15,
        13
    ];
    var $4d8e8181b4bf2e98$var$zr = [
        5,
        14,
        7,
        0,
        9,
        2,
        11,
        4,
        13,
        6,
        15,
        8,
        1,
        10,
        3,
        12,
        6,
        11,
        3,
        7,
        0,
        13,
        5,
        10,
        14,
        15,
        8,
        12,
        4,
        9,
        1,
        2,
        15,
        5,
        1,
        3,
        7,
        14,
        6,
        9,
        11,
        8,
        12,
        2,
        10,
        0,
        4,
        13,
        8,
        6,
        4,
        1,
        3,
        11,
        15,
        0,
        5,
        12,
        2,
        13,
        9,
        7,
        10,
        14,
        12,
        15,
        10,
        4,
        1,
        5,
        8,
        7,
        6,
        2,
        13,
        14,
        0,
        3,
        9,
        11
    ];
    var $4d8e8181b4bf2e98$var$sl = [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8,
        7,
        6,
        8,
        13,
        11,
        9,
        7,
        15,
        7,
        12,
        15,
        9,
        11,
        7,
        13,
        12,
        11,
        13,
        6,
        7,
        14,
        9,
        13,
        15,
        14,
        8,
        13,
        6,
        5,
        12,
        7,
        5,
        11,
        12,
        14,
        15,
        14,
        15,
        9,
        8,
        9,
        14,
        5,
        6,
        8,
        6,
        5,
        12,
        9,
        15,
        5,
        11,
        6,
        8,
        13,
        12,
        5,
        12,
        13,
        14,
        11,
        8,
        5,
        6
    ];
    var $4d8e8181b4bf2e98$var$sr = [
        8,
        9,
        9,
        11,
        13,
        15,
        15,
        5,
        7,
        7,
        8,
        11,
        14,
        14,
        12,
        6,
        9,
        13,
        15,
        7,
        12,
        8,
        9,
        11,
        7,
        7,
        12,
        7,
        6,
        15,
        13,
        11,
        9,
        7,
        15,
        11,
        8,
        6,
        6,
        14,
        12,
        13,
        5,
        14,
        13,
        13,
        7,
        5,
        15,
        5,
        8,
        11,
        14,
        14,
        6,
        14,
        6,
        9,
        12,
        9,
        12,
        5,
        15,
        8,
        8,
        5,
        12,
        9,
        12,
        5,
        14,
        6,
        8,
        13,
        6,
        5,
        15,
        13,
        11,
        11
    ];
    var $4d8e8181b4bf2e98$var$hl = [
        0x00000000,
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xa953fd4e
    ];
    var $4d8e8181b4bf2e98$var$hr = [
        0x50a28be6,
        0x5c4dd124,
        0x6d703ef3,
        0x7a6d76e9,
        0x00000000
    ];
    function $4d8e8181b4bf2e98$var$RIPEMD160() {
        $gOR7Z.call(this, 64);
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._e = 0xc3d2e1f0;
    }
    $v3bBu($4d8e8181b4bf2e98$var$RIPEMD160, $gOR7Z);
    $4d8e8181b4bf2e98$var$RIPEMD160.prototype._update = function() {
        var words = $4d8e8181b4bf2e98$var$ARRAY16;
        for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
        var al = this._a | 0;
        var bl = this._b | 0;
        var cl = this._c | 0;
        var dl = this._d | 0;
        var el = this._e | 0;
        var ar = this._a | 0;
        var br = this._b | 0;
        var cr = this._c | 0;
        var dr = this._d | 0;
        var er = this._e | 0;
        for(var i = 0; i < 80; i += 1){
            var tl;
            var tr;
            if (i < 16) {
                tl = $4d8e8181b4bf2e98$var$fn1(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[0], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn5(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[0], $4d8e8181b4bf2e98$var$sr[i]);
            } else if (i < 32) {
                tl = $4d8e8181b4bf2e98$var$fn2(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[1], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn4(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[1], $4d8e8181b4bf2e98$var$sr[i]);
            } else if (i < 48) {
                tl = $4d8e8181b4bf2e98$var$fn3(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[2], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn3(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[2], $4d8e8181b4bf2e98$var$sr[i]);
            } else if (i < 64) {
                tl = $4d8e8181b4bf2e98$var$fn4(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[3], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn2(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[3], $4d8e8181b4bf2e98$var$sr[i]);
            } else {
                tl = $4d8e8181b4bf2e98$var$fn5(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[4], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn1(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[4], $4d8e8181b4bf2e98$var$sr[i]);
            }
            al = el;
            el = dl;
            dl = $4d8e8181b4bf2e98$var$rotl(cl, 10);
            cl = bl;
            bl = tl;
            ar = er;
            er = dr;
            dr = $4d8e8181b4bf2e98$var$rotl(cr, 10);
            cr = br;
            br = tr;
        }
        var t = this._b + cl + dr | 0;
        this._b = this._c + dl + er | 0;
        this._c = this._d + el + ar | 0;
        this._d = this._e + al + br | 0;
        this._e = this._a + bl + cr | 0;
        this._a = t;
    };
    $4d8e8181b4bf2e98$var$RIPEMD160.prototype._digest = function() {
        this._block[this._blockOffset++] = 0x80;
        if (this._blockOffset > 56) {
            this._block.fill(0, this._blockOffset, 64);
            this._update();
            this._blockOffset = 0;
        }
        this._block.fill(0, this._blockOffset, 56);
        this._block.writeUInt32LE(this._length[0], 56);
        this._block.writeUInt32LE(this._length[1], 60);
        this._update();
        var buffer = $4d8e8181b4bf2e98$require$Buffer.alloc ? $4d8e8181b4bf2e98$require$Buffer.alloc(20) : new $4d8e8181b4bf2e98$require$Buffer(20);
        buffer.writeInt32LE(this._a, 0);
        buffer.writeInt32LE(this._b, 4);
        buffer.writeInt32LE(this._c, 8);
        buffer.writeInt32LE(this._d, 12);
        buffer.writeInt32LE(this._e, 16);
        return buffer;
    };
    function $4d8e8181b4bf2e98$var$rotl(x, n) {
        return x << n | x >>> 32 - n;
    }
    function $4d8e8181b4bf2e98$var$fn1(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn2(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn3(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn4(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn5(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
    }
    module.exports = $4d8e8181b4bf2e98$var$RIPEMD160;
});
parcelRegister("a21Ya", function(module, exports) {
    var $74db9e664dfd9270$var$exports = module.exports = function SHA(algorithm) {
        algorithm = algorithm.toLowerCase();
        var Algorithm = $74db9e664dfd9270$var$exports[algorithm];
        if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
        return new Algorithm();
    };
    $74db9e664dfd9270$var$exports.sha = (parcelRequire("dFso9"));
    $74db9e664dfd9270$var$exports.sha1 = (parcelRequire("fWNgi"));
    $74db9e664dfd9270$var$exports.sha224 = (parcelRequire("dCenE"));
    $74db9e664dfd9270$var$exports.sha256 = (parcelRequire("jtWQG"));
    $74db9e664dfd9270$var$exports.sha384 = (parcelRequire("1c7yZ"));
    $74db9e664dfd9270$var$exports.sha512 = (parcelRequire("c0lzM"));
});
parcelRegister("dFso9", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $9f35200cb3ec19b0$require$Buffer = $Wth4q.Buffer;
    var $9f35200cb3ec19b0$var$K = [
        0x5a827999,
        0x6ed9eba1,
        -1894007588,
        -899497514
    ];
    var $9f35200cb3ec19b0$var$W = new Array(80);
    function $9f35200cb3ec19b0$var$Sha() {
        this.init();
        this._w = $9f35200cb3ec19b0$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($9f35200cb3ec19b0$var$Sha, $jCRNn);
    $9f35200cb3ec19b0$var$Sha.prototype.init = function() {
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._e = 0xc3d2e1f0;
        return this;
    };
    function $9f35200cb3ec19b0$var$rotl5(num) {
        return num << 5 | num >>> 27;
    }
    function $9f35200cb3ec19b0$var$rotl30(num) {
        return num << 30 | num >>> 2;
    }
    function $9f35200cb3ec19b0$var$ft(s, b, c, d) {
        if (s === 0) return b & c | ~b & d;
        if (s === 2) return b & c | b & d | c & d;
        return b ^ c ^ d;
    }
    $9f35200cb3ec19b0$var$Sha.prototype._update = function(M) {
        var W = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e = this._e | 0;
        for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
        for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
        for(var j = 0; j < 80; ++j){
            var s = ~~(j / 20);
            var t = $9f35200cb3ec19b0$var$rotl5(a) + $9f35200cb3ec19b0$var$ft(s, b, c, d) + e + W[j] + $9f35200cb3ec19b0$var$K[s] | 0;
            e = d;
            d = c;
            c = $9f35200cb3ec19b0$var$rotl30(b);
            b = a;
            a = t;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e + this._e | 0;
    };
    $9f35200cb3ec19b0$var$Sha.prototype._hash = function() {
        var H = $9f35200cb3ec19b0$require$Buffer.allocUnsafe(20);
        H.writeInt32BE(this._a | 0, 0);
        H.writeInt32BE(this._b | 0, 4);
        H.writeInt32BE(this._c | 0, 8);
        H.writeInt32BE(this._d | 0, 12);
        H.writeInt32BE(this._e | 0, 16);
        return H;
    };
    module.exports = $9f35200cb3ec19b0$var$Sha;
});
parcelRegister("jCRNn", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $e49b4b9320828ebb$require$Buffer = $Wth4q.Buffer;
    function $e49b4b9320828ebb$var$Hash(blockSize, finalSize) {
        this._block = $e49b4b9320828ebb$require$Buffer.alloc(blockSize);
        this._finalSize = finalSize;
        this._blockSize = blockSize;
        this._len = 0;
    }
    $e49b4b9320828ebb$var$Hash.prototype.update = function(data, enc) {
        if (typeof data === 'string') {
            enc = enc || 'utf8';
            data = $e49b4b9320828ebb$require$Buffer.from(data, enc);
        }
        var block = this._block;
        var blockSize = this._blockSize;
        var length = data.length;
        var accum = this._len;
        for(var offset = 0; offset < length;){
            var assigned = accum % blockSize;
            var remainder = Math.min(length - offset, blockSize - assigned);
            for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
            accum += remainder;
            offset += remainder;
            if (accum % blockSize === 0) this._update(block);
        }
        this._len += length;
        return this;
    };
    $e49b4b9320828ebb$var$Hash.prototype.digest = function(enc) {
        var rem = this._len % this._blockSize;
        this._block[rem] = 0x80;
        this._block.fill(0, rem + 1);
        if (rem >= this._finalSize) {
            this._update(this._block);
            this._block.fill(0);
        }
        var bits = this._len * 8;
        if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
        else {
            var lowBits = (bits & 0xffffffff) >>> 0;
            var highBits = (bits - lowBits) / 0x100000000;
            this._block.writeUInt32BE(highBits, this._blockSize - 8);
            this._block.writeUInt32BE(lowBits, this._blockSize - 4);
        }
        this._update(this._block);
        var hash = this._hash();
        return enc ? hash.toString(enc) : hash;
    };
    $e49b4b9320828ebb$var$Hash.prototype._update = function() {
        throw new Error('_update must be implemented by subclass');
    };
    module.exports = $e49b4b9320828ebb$var$Hash;
});
parcelRegister("fWNgi", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $b9c27c2bc18fcde5$require$Buffer = $Wth4q.Buffer;
    var $b9c27c2bc18fcde5$var$K = [
        0x5a827999,
        0x6ed9eba1,
        -1894007588,
        -899497514
    ];
    var $b9c27c2bc18fcde5$var$W = new Array(80);
    function $b9c27c2bc18fcde5$var$Sha1() {
        this.init();
        this._w = $b9c27c2bc18fcde5$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($b9c27c2bc18fcde5$var$Sha1, $jCRNn);
    $b9c27c2bc18fcde5$var$Sha1.prototype.init = function() {
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._e = 0xc3d2e1f0;
        return this;
    };
    function $b9c27c2bc18fcde5$var$rotl1(num) {
        return num << 1 | num >>> 31;
    }
    function $b9c27c2bc18fcde5$var$rotl5(num) {
        return num << 5 | num >>> 27;
    }
    function $b9c27c2bc18fcde5$var$rotl30(num) {
        return num << 30 | num >>> 2;
    }
    function $b9c27c2bc18fcde5$var$ft(s, b, c, d) {
        if (s === 0) return b & c | ~b & d;
        if (s === 2) return b & c | b & d | c & d;
        return b ^ c ^ d;
    }
    $b9c27c2bc18fcde5$var$Sha1.prototype._update = function(M) {
        var W = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e = this._e | 0;
        for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
        for(; i < 80; ++i)W[i] = $b9c27c2bc18fcde5$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
        for(var j = 0; j < 80; ++j){
            var s = ~~(j / 20);
            var t = $b9c27c2bc18fcde5$var$rotl5(a) + $b9c27c2bc18fcde5$var$ft(s, b, c, d) + e + W[j] + $b9c27c2bc18fcde5$var$K[s] | 0;
            e = d;
            d = c;
            c = $b9c27c2bc18fcde5$var$rotl30(b);
            b = a;
            a = t;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e + this._e | 0;
    };
    $b9c27c2bc18fcde5$var$Sha1.prototype._hash = function() {
        var H = $b9c27c2bc18fcde5$require$Buffer.allocUnsafe(20);
        H.writeInt32BE(this._a | 0, 0);
        H.writeInt32BE(this._b | 0, 4);
        H.writeInt32BE(this._c | 0, 8);
        H.writeInt32BE(this._d | 0, 12);
        H.writeInt32BE(this._e | 0, 16);
        return H;
    };
    module.exports = $b9c27c2bc18fcde5$var$Sha1;
});
parcelRegister("dCenE", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jtWQG = parcelRequire("jtWQG");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $9e99faa5be7d643e$require$Buffer = $Wth4q.Buffer;
    var $9e99faa5be7d643e$var$W = new Array(64);
    function $9e99faa5be7d643e$var$Sha224() {
        this.init();
        this._w = $9e99faa5be7d643e$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($9e99faa5be7d643e$var$Sha224, $jtWQG);
    $9e99faa5be7d643e$var$Sha224.prototype.init = function() {
        this._a = 0xc1059ed8;
        this._b = 0x367cd507;
        this._c = 0x3070dd17;
        this._d = 0xf70e5939;
        this._e = 0xffc00b31;
        this._f = 0x68581511;
        this._g = 0x64f98fa7;
        this._h = 0xbefa4fa4;
        return this;
    };
    $9e99faa5be7d643e$var$Sha224.prototype._hash = function() {
        var H = $9e99faa5be7d643e$require$Buffer.allocUnsafe(28);
        H.writeInt32BE(this._a, 0);
        H.writeInt32BE(this._b, 4);
        H.writeInt32BE(this._c, 8);
        H.writeInt32BE(this._d, 12);
        H.writeInt32BE(this._e, 16);
        H.writeInt32BE(this._f, 20);
        H.writeInt32BE(this._g, 24);
        return H;
    };
    module.exports = $9e99faa5be7d643e$var$Sha224;
});
parcelRegister("jtWQG", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $e2ee5fe8d7032812$require$Buffer = $Wth4q.Buffer;
    var $e2ee5fe8d7032812$var$K = [
        0x428A2F98,
        0x71374491,
        0xB5C0FBCF,
        0xE9B5DBA5,
        0x3956C25B,
        0x59F111F1,
        0x923F82A4,
        0xAB1C5ED5,
        0xD807AA98,
        0x12835B01,
        0x243185BE,
        0x550C7DC3,
        0x72BE5D74,
        0x80DEB1FE,
        0x9BDC06A7,
        0xC19BF174,
        0xE49B69C1,
        0xEFBE4786,
        0x0FC19DC6,
        0x240CA1CC,
        0x2DE92C6F,
        0x4A7484AA,
        0x5CB0A9DC,
        0x76F988DA,
        0x983E5152,
        0xA831C66D,
        0xB00327C8,
        0xBF597FC7,
        0xC6E00BF3,
        0xD5A79147,
        0x06CA6351,
        0x14292967,
        0x27B70A85,
        0x2E1B2138,
        0x4D2C6DFC,
        0x53380D13,
        0x650A7354,
        0x766A0ABB,
        0x81C2C92E,
        0x92722C85,
        0xA2BFE8A1,
        0xA81A664B,
        0xC24B8B70,
        0xC76C51A3,
        0xD192E819,
        0xD6990624,
        0xF40E3585,
        0x106AA070,
        0x19A4C116,
        0x1E376C08,
        0x2748774C,
        0x34B0BCB5,
        0x391C0CB3,
        0x4ED8AA4A,
        0x5B9CCA4F,
        0x682E6FF3,
        0x748F82EE,
        0x78A5636F,
        0x84C87814,
        0x8CC70208,
        0x90BEFFFA,
        0xA4506CEB,
        0xBEF9A3F7,
        0xC67178F2
    ];
    var $e2ee5fe8d7032812$var$W = new Array(64);
    function $e2ee5fe8d7032812$var$Sha256() {
        this.init();
        this._w = $e2ee5fe8d7032812$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($e2ee5fe8d7032812$var$Sha256, $jCRNn);
    $e2ee5fe8d7032812$var$Sha256.prototype.init = function() {
        this._a = 0x6a09e667;
        this._b = 0xbb67ae85;
        this._c = 0x3c6ef372;
        this._d = 0xa54ff53a;
        this._e = 0x510e527f;
        this._f = 0x9b05688c;
        this._g = 0x1f83d9ab;
        this._h = 0x5be0cd19;
        return this;
    };
    function $e2ee5fe8d7032812$var$ch(x, y, z) {
        return z ^ x & (y ^ z);
    }
    function $e2ee5fe8d7032812$var$maj(x, y, z) {
        return x & y | z & (x | y);
    }
    function $e2ee5fe8d7032812$var$sigma0(x) {
        return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
    }
    function $e2ee5fe8d7032812$var$sigma1(x) {
        return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
    }
    function $e2ee5fe8d7032812$var$gamma0(x) {
        return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
    }
    function $e2ee5fe8d7032812$var$gamma1(x) {
        return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
    }
    $e2ee5fe8d7032812$var$Sha256.prototype._update = function(M) {
        var W = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e = this._e | 0;
        var f = this._f | 0;
        var g = this._g | 0;
        var h = this._h | 0;
        for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
        for(; i < 64; ++i)W[i] = $e2ee5fe8d7032812$var$gamma1(W[i - 2]) + W[i - 7] + $e2ee5fe8d7032812$var$gamma0(W[i - 15]) + W[i - 16] | 0;
        for(var j = 0; j < 64; ++j){
            var T1 = h + $e2ee5fe8d7032812$var$sigma1(e) + $e2ee5fe8d7032812$var$ch(e, f, g) + $e2ee5fe8d7032812$var$K[j] + W[j] | 0;
            var T2 = $e2ee5fe8d7032812$var$sigma0(a) + $e2ee5fe8d7032812$var$maj(a, b, c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + T1 | 0;
            d = c;
            c = b;
            b = a;
            a = T1 + T2 | 0;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e + this._e | 0;
        this._f = f + this._f | 0;
        this._g = g + this._g | 0;
        this._h = h + this._h | 0;
    };
    $e2ee5fe8d7032812$var$Sha256.prototype._hash = function() {
        var H = $e2ee5fe8d7032812$require$Buffer.allocUnsafe(32);
        H.writeInt32BE(this._a, 0);
        H.writeInt32BE(this._b, 4);
        H.writeInt32BE(this._c, 8);
        H.writeInt32BE(this._d, 12);
        H.writeInt32BE(this._e, 16);
        H.writeInt32BE(this._f, 20);
        H.writeInt32BE(this._g, 24);
        H.writeInt32BE(this._h, 28);
        return H;
    };
    module.exports = $e2ee5fe8d7032812$var$Sha256;
});
parcelRegister("1c7yZ", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $c0lzM = parcelRequire("c0lzM");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $0decc7569dc7c272$require$Buffer = $Wth4q.Buffer;
    var $0decc7569dc7c272$var$W = new Array(160);
    function $0decc7569dc7c272$var$Sha384() {
        this.init();
        this._w = $0decc7569dc7c272$var$W;
        $jCRNn.call(this, 128, 112);
    }
    $v3bBu($0decc7569dc7c272$var$Sha384, $c0lzM);
    $0decc7569dc7c272$var$Sha384.prototype.init = function() {
        this._ah = 0xcbbb9d5d;
        this._bh = 0x629a292a;
        this._ch = 0x9159015a;
        this._dh = 0x152fecd8;
        this._eh = 0x67332667;
        this._fh = 0x8eb44a87;
        this._gh = 0xdb0c2e0d;
        this._hh = 0x47b5481d;
        this._al = 0xc1059ed8;
        this._bl = 0x367cd507;
        this._cl = 0x3070dd17;
        this._dl = 0xf70e5939;
        this._el = 0xffc00b31;
        this._fl = 0x68581511;
        this._gl = 0x64f98fa7;
        this._hl = 0xbefa4fa4;
        return this;
    };
    $0decc7569dc7c272$var$Sha384.prototype._hash = function() {
        var H = $0decc7569dc7c272$require$Buffer.allocUnsafe(48);
        function writeInt64BE(h, l, offset) {
            H.writeInt32BE(h, offset);
            H.writeInt32BE(l, offset + 4);
        }
        writeInt64BE(this._ah, this._al, 0);
        writeInt64BE(this._bh, this._bl, 8);
        writeInt64BE(this._ch, this._cl, 16);
        writeInt64BE(this._dh, this._dl, 24);
        writeInt64BE(this._eh, this._el, 32);
        writeInt64BE(this._fh, this._fl, 40);
        return H;
    };
    module.exports = $0decc7569dc7c272$var$Sha384;
});
parcelRegister("c0lzM", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $8bd638b23ac34e9a$require$Buffer = $Wth4q.Buffer;
    var $8bd638b23ac34e9a$var$K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    var $8bd638b23ac34e9a$var$W = new Array(160);
    function $8bd638b23ac34e9a$var$Sha512() {
        this.init();
        this._w = $8bd638b23ac34e9a$var$W;
        $jCRNn.call(this, 128, 112);
    }
    $v3bBu($8bd638b23ac34e9a$var$Sha512, $jCRNn);
    $8bd638b23ac34e9a$var$Sha512.prototype.init = function() {
        this._ah = 0x6a09e667;
        this._bh = 0xbb67ae85;
        this._ch = 0x3c6ef372;
        this._dh = 0xa54ff53a;
        this._eh = 0x510e527f;
        this._fh = 0x9b05688c;
        this._gh = 0x1f83d9ab;
        this._hh = 0x5be0cd19;
        this._al = 0xf3bcc908;
        this._bl = 0x84caa73b;
        this._cl = 0xfe94f82b;
        this._dl = 0x5f1d36f1;
        this._el = 0xade682d1;
        this._fl = 0x2b3e6c1f;
        this._gl = 0xfb41bd6b;
        this._hl = 0x137e2179;
        return this;
    };
    function $8bd638b23ac34e9a$var$Ch(x, y, z) {
        return z ^ x & (y ^ z);
    }
    function $8bd638b23ac34e9a$var$maj(x, y, z) {
        return x & y | z & (x | y);
    }
    function $8bd638b23ac34e9a$var$sigma0(x, xl) {
        return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
    }
    function $8bd638b23ac34e9a$var$sigma1(x, xl) {
        return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
    }
    function $8bd638b23ac34e9a$var$Gamma0(x, xl) {
        return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
    }
    function $8bd638b23ac34e9a$var$Gamma0l(x, xl) {
        return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
    }
    function $8bd638b23ac34e9a$var$Gamma1(x, xl) {
        return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
    }
    function $8bd638b23ac34e9a$var$Gamma1l(x, xl) {
        return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
    }
    function $8bd638b23ac34e9a$var$getCarry(a, b) {
        return a >>> 0 < b >>> 0 ? 1 : 0;
    }
    $8bd638b23ac34e9a$var$Sha512.prototype._update = function(M) {
        var W = this._w;
        var ah = this._ah | 0;
        var bh = this._bh | 0;
        var ch = this._ch | 0;
        var dh = this._dh | 0;
        var eh = this._eh | 0;
        var fh = this._fh | 0;
        var gh = this._gh | 0;
        var hh = this._hh | 0;
        var al = this._al | 0;
        var bl = this._bl | 0;
        var cl = this._cl | 0;
        var dl = this._dl | 0;
        var el = this._el | 0;
        var fl = this._fl | 0;
        var gl = this._gl | 0;
        var hl = this._hl | 0;
        for(var i = 0; i < 32; i += 2){
            W[i] = M.readInt32BE(i * 4);
            W[i + 1] = M.readInt32BE(i * 4 + 4);
        }
        for(; i < 160; i += 2){
            var xh = W[i - 30];
            var xl = W[i - 30 + 1];
            var gamma0 = $8bd638b23ac34e9a$var$Gamma0(xh, xl);
            var gamma0l = $8bd638b23ac34e9a$var$Gamma0l(xl, xh);
            xh = W[i - 4];
            xl = W[i - 4 + 1];
            var gamma1 = $8bd638b23ac34e9a$var$Gamma1(xh, xl);
            var gamma1l = $8bd638b23ac34e9a$var$Gamma1l(xl, xh);
            var Wi7h = W[i - 14];
            var Wi7l = W[i - 14 + 1];
            var Wi16h = W[i - 32];
            var Wi16l = W[i - 32 + 1];
            var Wil = gamma0l + Wi7l | 0;
            var Wih = gamma0 + Wi7h + $8bd638b23ac34e9a$var$getCarry(Wil, gamma0l) | 0;
            Wil = Wil + gamma1l | 0;
            Wih = Wih + gamma1 + $8bd638b23ac34e9a$var$getCarry(Wil, gamma1l) | 0;
            Wil = Wil + Wi16l | 0;
            Wih = Wih + Wi16h + $8bd638b23ac34e9a$var$getCarry(Wil, Wi16l) | 0;
            W[i] = Wih;
            W[i + 1] = Wil;
        }
        for(var j = 0; j < 160; j += 2){
            Wih = W[j];
            Wil = W[j + 1];
            var majh = $8bd638b23ac34e9a$var$maj(ah, bh, ch);
            var majl = $8bd638b23ac34e9a$var$maj(al, bl, cl);
            var sigma0h = $8bd638b23ac34e9a$var$sigma0(ah, al);
            var sigma0l = $8bd638b23ac34e9a$var$sigma0(al, ah);
            var sigma1h = $8bd638b23ac34e9a$var$sigma1(eh, el);
            var sigma1l = $8bd638b23ac34e9a$var$sigma1(el, eh);
            var Kih = $8bd638b23ac34e9a$var$K[j];
            var Kil = $8bd638b23ac34e9a$var$K[j + 1];
            var chh = $8bd638b23ac34e9a$var$Ch(eh, fh, gh);
            var chl = $8bd638b23ac34e9a$var$Ch(el, fl, gl);
            var t1l = hl + sigma1l | 0;
            var t1h = hh + sigma1h + $8bd638b23ac34e9a$var$getCarry(t1l, hl) | 0;
            t1l = t1l + chl | 0;
            t1h = t1h + chh + $8bd638b23ac34e9a$var$getCarry(t1l, chl) | 0;
            t1l = t1l + Kil | 0;
            t1h = t1h + Kih + $8bd638b23ac34e9a$var$getCarry(t1l, Kil) | 0;
            t1l = t1l + Wil | 0;
            t1h = t1h + Wih + $8bd638b23ac34e9a$var$getCarry(t1l, Wil) | 0;
            var t2l = sigma0l + majl | 0;
            var t2h = sigma0h + majh + $8bd638b23ac34e9a$var$getCarry(t2l, sigma0l) | 0;
            hh = gh;
            hl = gl;
            gh = fh;
            gl = fl;
            fh = eh;
            fl = el;
            el = dl + t1l | 0;
            eh = dh + t1h + $8bd638b23ac34e9a$var$getCarry(el, dl) | 0;
            dh = ch;
            dl = cl;
            ch = bh;
            cl = bl;
            bh = ah;
            bl = al;
            al = t1l + t2l | 0;
            ah = t1h + t2h + $8bd638b23ac34e9a$var$getCarry(al, t1l) | 0;
        }
        this._al = this._al + al | 0;
        this._bl = this._bl + bl | 0;
        this._cl = this._cl + cl | 0;
        this._dl = this._dl + dl | 0;
        this._el = this._el + el | 0;
        this._fl = this._fl + fl | 0;
        this._gl = this._gl + gl | 0;
        this._hl = this._hl + hl | 0;
        this._ah = this._ah + ah + $8bd638b23ac34e9a$var$getCarry(this._al, al) | 0;
        this._bh = this._bh + bh + $8bd638b23ac34e9a$var$getCarry(this._bl, bl) | 0;
        this._ch = this._ch + ch + $8bd638b23ac34e9a$var$getCarry(this._cl, cl) | 0;
        this._dh = this._dh + dh + $8bd638b23ac34e9a$var$getCarry(this._dl, dl) | 0;
        this._eh = this._eh + eh + $8bd638b23ac34e9a$var$getCarry(this._el, el) | 0;
        this._fh = this._fh + fh + $8bd638b23ac34e9a$var$getCarry(this._fl, fl) | 0;
        this._gh = this._gh + gh + $8bd638b23ac34e9a$var$getCarry(this._gl, gl) | 0;
        this._hh = this._hh + hh + $8bd638b23ac34e9a$var$getCarry(this._hl, hl) | 0;
    };
    $8bd638b23ac34e9a$var$Sha512.prototype._hash = function() {
        var H = $8bd638b23ac34e9a$require$Buffer.allocUnsafe(64);
        function writeInt64BE(h, l, offset) {
            H.writeInt32BE(h, offset);
            H.writeInt32BE(l, offset + 4);
        }
        writeInt64BE(this._ah, this._al, 0);
        writeInt64BE(this._bh, this._bl, 8);
        writeInt64BE(this._ch, this._cl, 16);
        writeInt64BE(this._dh, this._dl, 24);
        writeInt64BE(this._eh, this._el, 32);
        writeInt64BE(this._fh, this._fl, 40);
        writeInt64BE(this._gh, this._gl, 48);
        writeInt64BE(this._hh, this._hl, 56);
        return H;
    };
    module.exports = $8bd638b23ac34e9a$var$Sha512;
});
parcelRegister("77fwb", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $52e5397100350dcf$require$Buffer = $Wth4q.Buffer;
    var $e2HvS = parcelRequire("e2HvS");
    var $52e5397100350dcf$require$Transform = $e2HvS.Transform;
    var $3872E = parcelRequire("3872E");
    var $52e5397100350dcf$require$StringDecoder = $3872E.StringDecoder;
    var $v3bBu = parcelRequire("v3bBu");
    function $52e5397100350dcf$var$CipherBase(hashMode) {
        $52e5397100350dcf$require$Transform.call(this);
        this.hashMode = typeof hashMode === 'string';
        if (this.hashMode) this[hashMode] = this._finalOrDigest;
        else this.final = this._finalOrDigest;
        if (this._final) {
            this.__final = this._final;
            this._final = null;
        }
        this._decoder = null;
        this._encoding = null;
    }
    $v3bBu($52e5397100350dcf$var$CipherBase, $52e5397100350dcf$require$Transform);
    $52e5397100350dcf$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
        if (typeof data === 'string') data = $52e5397100350dcf$require$Buffer.from(data, inputEnc);
        var outData = this._update(data);
        if (this.hashMode) return this;
        if (outputEnc) outData = this._toString(outData, outputEnc);
        return outData;
    };
    $52e5397100350dcf$var$CipherBase.prototype.setAutoPadding = function() {};
    $52e5397100350dcf$var$CipherBase.prototype.getAuthTag = function() {
        throw new Error('trying to get auth tag in unsupported state');
    };
    $52e5397100350dcf$var$CipherBase.prototype.setAuthTag = function() {
        throw new Error('trying to set auth tag in unsupported state');
    };
    $52e5397100350dcf$var$CipherBase.prototype.setAAD = function() {
        throw new Error('trying to set aad in unsupported state');
    };
    $52e5397100350dcf$var$CipherBase.prototype._transform = function(data, _, next) {
        var err;
        try {
            if (this.hashMode) this._update(data);
            else this.push(this._update(data));
        } catch (e) {
            err = e;
        } finally{
            next(err);
        }
    };
    $52e5397100350dcf$var$CipherBase.prototype._flush = function(done) {
        var err;
        try {
            this.push(this.__final());
        } catch (e) {
            err = e;
        }
        done(err);
    };
    $52e5397100350dcf$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
        var outData = this.__final() || $52e5397100350dcf$require$Buffer.alloc(0);
        if (outputEnc) outData = this._toString(outData, outputEnc, true);
        return outData;
    };
    $52e5397100350dcf$var$CipherBase.prototype._toString = function(value, enc, fin) {
        if (!this._decoder) {
            this._decoder = new $52e5397100350dcf$require$StringDecoder(enc);
            this._encoding = enc;
        }
        if (this._encoding !== enc) throw new Error('can\'t switch encodings');
        var out = this._decoder.write(value);
        if (fin) out += this._decoder.end();
        return out;
    };
    module.exports = $52e5397100350dcf$var$CipherBase;
});
parcelRegister("j65bP", function(module, exports) {
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $3nQOH = parcelRequire("3nQOH");
    var $77fwb = parcelRequire("77fwb");
    var $Wth4q = parcelRequire("Wth4q");
    var $de729a71cb7df339$require$Buffer = $Wth4q.Buffer;
    var $2BrHl = parcelRequire("2BrHl");
    var $6EPBm = parcelRequire("6EPBm");
    var $a21Ya = parcelRequire("a21Ya");
    var $de729a71cb7df339$var$ZEROS = $de729a71cb7df339$require$Buffer.alloc(128);
    function $de729a71cb7df339$var$Hmac(alg, key) {
        $77fwb.call(this, 'digest');
        if (typeof key === 'string') key = $de729a71cb7df339$require$Buffer.from(key);
        var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
        this._alg = alg;
        this._key = key;
        if (key.length > blocksize) {
            var hash = alg === 'rmd160' ? new $6EPBm() : $a21Ya(alg);
            key = hash.update(key).digest();
        } else if (key.length < blocksize) key = $de729a71cb7df339$require$Buffer.concat([
            key,
            $de729a71cb7df339$var$ZEROS
        ], blocksize);
        var ipad = this._ipad = $de729a71cb7df339$require$Buffer.allocUnsafe(blocksize);
        var opad = this._opad = $de729a71cb7df339$require$Buffer.allocUnsafe(blocksize);
        for(var i = 0; i < blocksize; i++){
            ipad[i] = key[i] ^ 0x36;
            opad[i] = key[i] ^ 0x5C;
        }
        this._hash = alg === 'rmd160' ? new $6EPBm() : $a21Ya(alg);
        this._hash.update(ipad);
    }
    $v3bBu($de729a71cb7df339$var$Hmac, $77fwb);
    $de729a71cb7df339$var$Hmac.prototype._update = function(data) {
        this._hash.update(data);
    };
    $de729a71cb7df339$var$Hmac.prototype._final = function() {
        var h = this._hash.digest();
        var hash = this._alg === 'rmd160' ? new $6EPBm() : $a21Ya(this._alg);
        return hash.update(this._opad).update(h).digest();
    };
    module.exports = function createHmac(alg, key) {
        alg = alg.toLowerCase();
        if (alg === 'rmd160' || alg === 'ripemd160') return new $de729a71cb7df339$var$Hmac('rmd160', key);
        if (alg === 'md5') return new $3nQOH($2BrHl, key);
        return new $de729a71cb7df339$var$Hmac(alg, key);
    };
});
parcelRegister("3nQOH", function(module, exports) {
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $Wth4q = parcelRequire("Wth4q");
    var $276c7d685fb1f219$require$Buffer = $Wth4q.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $276c7d685fb1f219$var$ZEROS = $276c7d685fb1f219$require$Buffer.alloc(128);
    var $276c7d685fb1f219$var$blocksize = 64;
    function $276c7d685fb1f219$var$Hmac(alg, key) {
        $77fwb.call(this, 'digest');
        if (typeof key === 'string') key = $276c7d685fb1f219$require$Buffer.from(key);
        this._alg = alg;
        this._key = key;
        if (key.length > $276c7d685fb1f219$var$blocksize) key = alg(key);
        else if (key.length < $276c7d685fb1f219$var$blocksize) key = $276c7d685fb1f219$require$Buffer.concat([
            key,
            $276c7d685fb1f219$var$ZEROS
        ], $276c7d685fb1f219$var$blocksize);
        var ipad = this._ipad = $276c7d685fb1f219$require$Buffer.allocUnsafe($276c7d685fb1f219$var$blocksize);
        var opad = this._opad = $276c7d685fb1f219$require$Buffer.allocUnsafe($276c7d685fb1f219$var$blocksize);
        for(var i = 0; i < $276c7d685fb1f219$var$blocksize; i++){
            ipad[i] = key[i] ^ 0x36;
            opad[i] = key[i] ^ 0x5C;
        }
        this._hash = [
            ipad
        ];
    }
    $v3bBu($276c7d685fb1f219$var$Hmac, $77fwb);
    $276c7d685fb1f219$var$Hmac.prototype._update = function(data) {
        this._hash.push(data);
    };
    $276c7d685fb1f219$var$Hmac.prototype._final = function() {
        var h = this._alg($276c7d685fb1f219$require$Buffer.concat(this._hash));
        return this._alg($276c7d685fb1f219$require$Buffer.concat([
            this._opad,
            h
        ]));
    };
    module.exports = $276c7d685fb1f219$var$Hmac;
});
parcelRegister("2BrHl", function(module, exports) {
    var $8ZJxF = parcelRequire("8ZJxF");
    module.exports = function(buffer) {
        return new $8ZJxF().update(buffer).digest();
    };
});
parcelRegister("NKdOQ", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("5kFDZ"));
});
parcelRegister("5kFDZ", function(module, exports) {
    module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");
});
parcelRegister("fS6zE", function(module, exports) {
    $parcel$export(module.exports, "pbkdf2", ()=>$b8e0ffa4349c8ce4$export$448fa22aedc9dbca, (v)=>$b8e0ffa4349c8ce4$export$448fa22aedc9dbca = v);
    $parcel$export(module.exports, "pbkdf2Sync", ()=>$b8e0ffa4349c8ce4$export$b80c7ba289c8fa56, (v)=>$b8e0ffa4349c8ce4$export$b80c7ba289c8fa56 = v);
    var $b8e0ffa4349c8ce4$export$448fa22aedc9dbca;
    var $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56;
    $b8e0ffa4349c8ce4$export$448fa22aedc9dbca = (parcelRequire("8U4Ei"));
    $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56 = (parcelRequire("5GCF3"));
});
parcelRegister("8U4Ei", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $67b728dbcfdb7234$require$Buffer = $Wth4q.Buffer;
    var $4ryRx = parcelRequire("4ryRx");
    var $7DfkD = parcelRequire("7DfkD");
    var $5GCF3 = parcelRequire("5GCF3");
    var $fpAzU = parcelRequire("fpAzU");
    var $67b728dbcfdb7234$var$ZERO_BUF;
    var $67b728dbcfdb7234$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
    var $67b728dbcfdb7234$var$toBrowser = {
        sha: 'SHA-1',
        'sha-1': 'SHA-1',
        sha1: 'SHA-1',
        sha256: 'SHA-256',
        'sha-256': 'SHA-256',
        sha384: 'SHA-384',
        'sha-384': 'SHA-384',
        'sha-512': 'SHA-512',
        sha512: 'SHA-512'
    };
    var $67b728dbcfdb7234$var$checks = [];
    function $67b728dbcfdb7234$var$checkNative(algo) {
        if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
        if (!$67b728dbcfdb7234$var$subtle || !$67b728dbcfdb7234$var$subtle.importKey || !$67b728dbcfdb7234$var$subtle.deriveBits) return Promise.resolve(false);
        if ($67b728dbcfdb7234$var$checks[algo] !== undefined) return $67b728dbcfdb7234$var$checks[algo];
        $67b728dbcfdb7234$var$ZERO_BUF = $67b728dbcfdb7234$var$ZERO_BUF || $67b728dbcfdb7234$require$Buffer.alloc(8);
        var prom = $67b728dbcfdb7234$var$browserPbkdf2($67b728dbcfdb7234$var$ZERO_BUF, $67b728dbcfdb7234$var$ZERO_BUF, 10, 128, algo).then(function() {
            return true;
        }).catch(function() {
            return false;
        });
        $67b728dbcfdb7234$var$checks[algo] = prom;
        return prom;
    }
    var $67b728dbcfdb7234$var$nextTick;
    function $67b728dbcfdb7234$var$getNextTick() {
        if ($67b728dbcfdb7234$var$nextTick) return $67b728dbcfdb7234$var$nextTick;
        if ($parcel$global.process && $parcel$global.process.nextTick) $67b728dbcfdb7234$var$nextTick = $parcel$global.process.nextTick;
        else if ($parcel$global.queueMicrotask) $67b728dbcfdb7234$var$nextTick = $parcel$global.queueMicrotask;
        else if ($parcel$global.setImmediate) $67b728dbcfdb7234$var$nextTick = $parcel$global.setImmediate;
        else $67b728dbcfdb7234$var$nextTick = $parcel$global.setTimeout;
        return $67b728dbcfdb7234$var$nextTick;
    }
    function $67b728dbcfdb7234$var$browserPbkdf2(password, salt, iterations, length, algo) {
        return $67b728dbcfdb7234$var$subtle.importKey('raw', password, {
            name: 'PBKDF2'
        }, false, [
            'deriveBits'
        ]).then(function(key) {
            return $67b728dbcfdb7234$var$subtle.deriveBits({
                name: 'PBKDF2',
                salt: salt,
                iterations: iterations,
                hash: {
                    name: algo
                }
            }, key, length << 3);
        }).then(function(res) {
            return $67b728dbcfdb7234$require$Buffer.from(res);
        });
    }
    function $67b728dbcfdb7234$var$resolvePromise(promise, callback) {
        promise.then(function(out) {
            $67b728dbcfdb7234$var$getNextTick()(function() {
                callback(null, out);
            });
        }, function(e) {
            $67b728dbcfdb7234$var$getNextTick()(function() {
                callback(e);
            });
        });
    }
    module.exports = function(password, salt, iterations, keylen, digest, callback) {
        if (typeof digest === 'function') {
            callback = digest;
            digest = undefined;
        }
        digest = digest || 'sha1';
        var algo = $67b728dbcfdb7234$var$toBrowser[digest.toLowerCase()];
        if (!algo || typeof $parcel$global.Promise !== 'function') {
            $67b728dbcfdb7234$var$getNextTick()(function() {
                var out;
                try {
                    out = $5GCF3(password, salt, iterations, keylen, digest);
                } catch (e) {
                    return callback(e);
                }
                callback(null, out);
            });
            return;
        }
        $4ryRx(iterations, keylen);
        password = $fpAzU(password, $7DfkD, 'Password');
        salt = $fpAzU(salt, $7DfkD, 'Salt');
        if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
        $67b728dbcfdb7234$var$resolvePromise($67b728dbcfdb7234$var$checkNative(algo).then(function(resp) {
            if (resp) return $67b728dbcfdb7234$var$browserPbkdf2(password, salt, iterations, keylen, algo);
            return $5GCF3(password, salt, iterations, keylen, digest);
        }), callback);
    };
});
parcelRegister("4ryRx", function(module, exports) {
    var $33c4ba00ce725092$var$MAX_ALLOC = Math.pow(2, 30) - 1;
    module.exports = function(iterations, keylen) {
        if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
        if (iterations < 0) throw new TypeError('Bad iterations');
        if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
        if (keylen < 0 || keylen > $33c4ba00ce725092$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    };
});
parcelRegister("7DfkD", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    var $58e8117f50848d7e$var$defaultEncoding;
    if ($parcel$global.process && $parcel$global.process.browser) $58e8117f50848d7e$var$defaultEncoding = 'utf-8';
    else if ($parcel$global.process && $parcel$global.process.version) {
        var $58e8117f50848d7e$var$pVersionMajor = parseInt($6cAn5.version.split('.')[0].slice(1), 10);
        $58e8117f50848d7e$var$defaultEncoding = $58e8117f50848d7e$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
    } else $58e8117f50848d7e$var$defaultEncoding = 'utf-8';
    module.exports = $58e8117f50848d7e$var$defaultEncoding;
});
parcelRegister("5GCF3", function(module, exports) {
    var $2BrHl = parcelRequire("2BrHl");
    var $6EPBm = parcelRequire("6EPBm");
    var $a21Ya = parcelRequire("a21Ya");
    var $Wth4q = parcelRequire("Wth4q");
    var $423edd4c77469706$require$Buffer = $Wth4q.Buffer;
    var $4ryRx = parcelRequire("4ryRx");
    var $7DfkD = parcelRequire("7DfkD");
    var $fpAzU = parcelRequire("fpAzU");
    var $423edd4c77469706$var$ZEROS = $423edd4c77469706$require$Buffer.alloc(128);
    var $423edd4c77469706$var$sizes = {
        md5: 16,
        sha1: 20,
        sha224: 28,
        sha256: 32,
        sha384: 48,
        sha512: 64,
        rmd160: 20,
        ripemd160: 20
    };
    function $423edd4c77469706$var$Hmac(alg, key, saltLen) {
        var hash = $423edd4c77469706$var$getDigest(alg);
        var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
        if (key.length > blocksize) key = hash(key);
        else if (key.length < blocksize) key = $423edd4c77469706$require$Buffer.concat([
            key,
            $423edd4c77469706$var$ZEROS
        ], blocksize);
        var ipad = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + $423edd4c77469706$var$sizes[alg]);
        var opad = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + $423edd4c77469706$var$sizes[alg]);
        for(var i = 0; i < blocksize; i++){
            ipad[i] = key[i] ^ 0x36;
            opad[i] = key[i] ^ 0x5C;
        }
        var ipad1 = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
        ipad.copy(ipad1, 0, 0, blocksize);
        this.ipad1 = ipad1;
        this.ipad2 = ipad;
        this.opad = opad;
        this.alg = alg;
        this.blocksize = blocksize;
        this.hash = hash;
        this.size = $423edd4c77469706$var$sizes[alg];
    }
    $423edd4c77469706$var$Hmac.prototype.run = function(data, ipad) {
        data.copy(ipad, this.blocksize);
        var h = this.hash(ipad);
        h.copy(this.opad, this.blocksize);
        return this.hash(this.opad);
    };
    function $423edd4c77469706$var$getDigest(alg) {
        function shaFunc(data) {
            return $a21Ya(alg).update(data).digest();
        }
        function rmd160Func(data) {
            return new $6EPBm().update(data).digest();
        }
        if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
        if (alg === 'md5') return $2BrHl;
        return shaFunc;
    }
    function $423edd4c77469706$var$pbkdf2(password, salt, iterations, keylen, digest) {
        $4ryRx(iterations, keylen);
        password = $fpAzU(password, $7DfkD, 'Password');
        salt = $fpAzU(salt, $7DfkD, 'Salt');
        digest = digest || 'sha1';
        var hmac = new $423edd4c77469706$var$Hmac(digest, password, salt.length);
        var DK = $423edd4c77469706$require$Buffer.allocUnsafe(keylen);
        var block1 = $423edd4c77469706$require$Buffer.allocUnsafe(salt.length + 4);
        salt.copy(block1, 0, 0, salt.length);
        var destPos = 0;
        var hLen = $423edd4c77469706$var$sizes[digest];
        var l = Math.ceil(keylen / hLen);
        for(var i = 1; i <= l; i++){
            block1.writeUInt32BE(i, salt.length);
            var T = hmac.run(block1, hmac.ipad1);
            var U = T;
            for(var j = 1; j < iterations; j++){
                U = hmac.run(U, hmac.ipad2);
                for(var k = 0; k < hLen; k++)T[k] ^= U[k];
            }
            T.copy(DK, destPos);
            destPos += hLen;
        }
        return DK;
    }
    module.exports = $423edd4c77469706$var$pbkdf2;
});
parcelRegister("fpAzU", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $b38590769b62ee4f$require$Buffer = $Wth4q.Buffer;
    module.exports = function(thing, encoding, name) {
        if ($b38590769b62ee4f$require$Buffer.isBuffer(thing)) return thing;
        else if (typeof thing === 'string') return $b38590769b62ee4f$require$Buffer.from(thing, encoding);
        else if (ArrayBuffer.isView(thing)) return $b38590769b62ee4f$require$Buffer.from(thing.buffer);
        else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
    };
});
parcelRegister("a2ApW", function(module, exports) {
    $parcel$export(module.exports, "createCipher", ()=>$74f6570266d69f84$export$bdd223f16383713e, (v)=>$74f6570266d69f84$export$bdd223f16383713e = v);
    $parcel$export(module.exports, "Cipher", ()=>$74f6570266d69f84$export$26e5786e8ac8e530, (v)=>$74f6570266d69f84$export$26e5786e8ac8e530 = v);
    $parcel$export(module.exports, "createCipheriv", ()=>$74f6570266d69f84$export$2f64596b8cbf08b4, (v)=>$74f6570266d69f84$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "Cipheriv", ()=>$74f6570266d69f84$export$20533d26f07f1ee0, (v)=>$74f6570266d69f84$export$20533d26f07f1ee0 = v);
    $parcel$export(module.exports, "createDecipher", ()=>$74f6570266d69f84$export$12ada9414fbc594c, (v)=>$74f6570266d69f84$export$12ada9414fbc594c = v);
    $parcel$export(module.exports, "Decipher", ()=>$74f6570266d69f84$export$2ce6d8d0e8b04e1a, (v)=>$74f6570266d69f84$export$2ce6d8d0e8b04e1a = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$74f6570266d69f84$export$36b6d6ef312eab39, (v)=>$74f6570266d69f84$export$36b6d6ef312eab39 = v);
    $parcel$export(module.exports, "Decipheriv", ()=>$74f6570266d69f84$export$f5e7e39d57cd9700, (v)=>$74f6570266d69f84$export$f5e7e39d57cd9700 = v);
    $parcel$export(module.exports, "listCiphers", ()=>$74f6570266d69f84$export$dedd8dc3dc62b370, (v)=>$74f6570266d69f84$export$dedd8dc3dc62b370 = v);
    $parcel$export(module.exports, "getCiphers", ()=>$74f6570266d69f84$export$58a258485f1e49f6, (v)=>$74f6570266d69f84$export$58a258485f1e49f6 = v);
    var $74f6570266d69f84$export$bdd223f16383713e;
    var $74f6570266d69f84$export$26e5786e8ac8e530;
    var $74f6570266d69f84$export$2f64596b8cbf08b4;
    var $74f6570266d69f84$export$20533d26f07f1ee0;
    var $74f6570266d69f84$export$12ada9414fbc594c;
    var $74f6570266d69f84$export$2ce6d8d0e8b04e1a;
    var $74f6570266d69f84$export$36b6d6ef312eab39;
    var $74f6570266d69f84$export$f5e7e39d57cd9700;
    var $74f6570266d69f84$export$dedd8dc3dc62b370;
    var $74f6570266d69f84$export$58a258485f1e49f6;
    var $1Awtz = parcelRequire("1Awtz");
    var $gcaJj = parcelRequire("gcaJj");
    var $6WLno = parcelRequire("6WLno");
    var $dQ4TD = parcelRequire("dQ4TD");
    var $55KiC = parcelRequire("55KiC");
    function $74f6570266d69f84$var$createCipher(suite, password) {
        suite = suite.toLowerCase();
        var keyLen, ivLen;
        if ($6WLno[suite]) {
            keyLen = $6WLno[suite].key;
            ivLen = $6WLno[suite].iv;
        } else if ($dQ4TD[suite]) {
            keyLen = $dQ4TD[suite].key * 8;
            ivLen = $dQ4TD[suite].iv;
        } else throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, keyLen, ivLen);
        return $74f6570266d69f84$var$createCipheriv(suite, keys.key, keys.iv);
    }
    function $74f6570266d69f84$var$createDecipher(suite, password) {
        suite = suite.toLowerCase();
        var keyLen, ivLen;
        if ($6WLno[suite]) {
            keyLen = $6WLno[suite].key;
            ivLen = $6WLno[suite].iv;
        } else if ($dQ4TD[suite]) {
            keyLen = $dQ4TD[suite].key * 8;
            ivLen = $dQ4TD[suite].iv;
        } else throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, keyLen, ivLen);
        return $74f6570266d69f84$var$createDecipheriv(suite, keys.key, keys.iv);
    }
    function $74f6570266d69f84$var$createCipheriv(suite, key, iv) {
        suite = suite.toLowerCase();
        if ($6WLno[suite]) return $gcaJj.createCipheriv(suite, key, iv);
        if ($dQ4TD[suite]) return new $1Awtz({
            key: key,
            iv: iv,
            mode: suite
        });
        throw new TypeError('invalid suite type');
    }
    function $74f6570266d69f84$var$createDecipheriv(suite, key, iv) {
        suite = suite.toLowerCase();
        if ($6WLno[suite]) return $gcaJj.createDecipheriv(suite, key, iv);
        if ($dQ4TD[suite]) return new $1Awtz({
            key: key,
            iv: iv,
            mode: suite,
            decrypt: true
        });
        throw new TypeError('invalid suite type');
    }
    function $74f6570266d69f84$var$getCiphers() {
        return Object.keys($dQ4TD).concat($gcaJj.getCiphers());
    }
    $74f6570266d69f84$export$bdd223f16383713e = $74f6570266d69f84$export$26e5786e8ac8e530 = $74f6570266d69f84$var$createCipher;
    $74f6570266d69f84$export$2f64596b8cbf08b4 = $74f6570266d69f84$export$20533d26f07f1ee0 = $74f6570266d69f84$var$createCipheriv;
    $74f6570266d69f84$export$12ada9414fbc594c = $74f6570266d69f84$export$2ce6d8d0e8b04e1a = $74f6570266d69f84$var$createDecipher;
    $74f6570266d69f84$export$36b6d6ef312eab39 = $74f6570266d69f84$export$f5e7e39d57cd9700 = $74f6570266d69f84$var$createDecipheriv;
    $74f6570266d69f84$export$dedd8dc3dc62b370 = $74f6570266d69f84$export$58a258485f1e49f6 = $74f6570266d69f84$var$getCiphers;
});
parcelRegister("1Awtz", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $12825845b88e2981$require$Buffer = $5k7LC.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $bsIyp = parcelRequire("bsIyp");
    var $v3bBu = parcelRequire("v3bBu");
    var $12825845b88e2981$var$modes = {
        'des-ede3-cbc': $bsIyp.CBC.instantiate($bsIyp.EDE),
        'des-ede3': $bsIyp.EDE,
        'des-ede-cbc': $bsIyp.CBC.instantiate($bsIyp.EDE),
        'des-ede': $bsIyp.EDE,
        'des-cbc': $bsIyp.CBC.instantiate($bsIyp.DES),
        'des-ecb': $bsIyp.DES
    };
    $12825845b88e2981$var$modes.des = $12825845b88e2981$var$modes['des-cbc'];
    $12825845b88e2981$var$modes.des3 = $12825845b88e2981$var$modes['des-ede3-cbc'];
    module.exports = $12825845b88e2981$var$DES;
    $v3bBu($12825845b88e2981$var$DES, $77fwb);
    function $12825845b88e2981$var$DES(opts) {
        $77fwb.call(this);
        var modeName = opts.mode.toLowerCase();
        var mode = $12825845b88e2981$var$modes[modeName];
        var type;
        if (opts.decrypt) type = 'decrypt';
        else type = 'encrypt';
        var key = opts.key;
        if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $12825845b88e2981$require$Buffer.concat([
            key,
            key.slice(0, 8)
        ]);
        var iv = opts.iv;
        this._des = mode.create({
            key: key,
            iv: iv,
            type: type
        });
    }
    $12825845b88e2981$var$DES.prototype._update = function(data) {
        return new $12825845b88e2981$require$Buffer(this._des.update(data));
    };
    $12825845b88e2981$var$DES.prototype._final = function() {
        return new $12825845b88e2981$require$Buffer(this._des.final());
    };
});
parcelRegister("bsIyp", function(module, exports) {
    $parcel$export(module.exports, "utils", ()=>$8584dec09db13d9c$export$eab97d15b1788b8d, (v)=>$8584dec09db13d9c$export$eab97d15b1788b8d = v);
    $parcel$export(module.exports, "Cipher", ()=>$8584dec09db13d9c$export$26e5786e8ac8e530, (v)=>$8584dec09db13d9c$export$26e5786e8ac8e530 = v);
    $parcel$export(module.exports, "DES", ()=>$8584dec09db13d9c$export$cc8859615686b300, (v)=>$8584dec09db13d9c$export$cc8859615686b300 = v);
    $parcel$export(module.exports, "CBC", ()=>$8584dec09db13d9c$export$8ad3f227af08fcc5, (v)=>$8584dec09db13d9c$export$8ad3f227af08fcc5 = v);
    $parcel$export(module.exports, "EDE", ()=>$8584dec09db13d9c$export$947646e34766044f, (v)=>$8584dec09db13d9c$export$947646e34766044f = v);
    var $8584dec09db13d9c$export$eab97d15b1788b8d;
    var $8584dec09db13d9c$export$26e5786e8ac8e530;
    var $8584dec09db13d9c$export$cc8859615686b300;
    var $8584dec09db13d9c$export$8ad3f227af08fcc5;
    var $8584dec09db13d9c$export$947646e34766044f;
    'use strict';
    $8584dec09db13d9c$export$eab97d15b1788b8d = (parcelRequire("1Qr12"));
    $8584dec09db13d9c$export$26e5786e8ac8e530 = (parcelRequire("lE1WX"));
    $8584dec09db13d9c$export$cc8859615686b300 = (parcelRequire("6uemC"));
    $8584dec09db13d9c$export$8ad3f227af08fcc5 = (parcelRequire("bdh1b"));
    $8584dec09db13d9c$export$947646e34766044f = (parcelRequire("d53eL"));
});
parcelRegister("1Qr12", function(module, exports) {
    $parcel$export(module.exports, "readUInt32BE", ()=>$157f9a87c9609c03$export$cfaef8ed399428b0, (v)=>$157f9a87c9609c03$export$cfaef8ed399428b0 = v);
    $parcel$export(module.exports, "writeUInt32BE", ()=>$157f9a87c9609c03$export$a80c7deaea7cbd80, (v)=>$157f9a87c9609c03$export$a80c7deaea7cbd80 = v);
    $parcel$export(module.exports, "ip", ()=>$157f9a87c9609c03$export$ed7577ae6e1cd0ef, (v)=>$157f9a87c9609c03$export$ed7577ae6e1cd0ef = v);
    $parcel$export(module.exports, "rip", ()=>$157f9a87c9609c03$export$5dcbef3aa594f567, (v)=>$157f9a87c9609c03$export$5dcbef3aa594f567 = v);
    $parcel$export(module.exports, "pc1", ()=>$157f9a87c9609c03$export$5bc8001ca71ed9c5, (v)=>$157f9a87c9609c03$export$5bc8001ca71ed9c5 = v);
    $parcel$export(module.exports, "r28shl", ()=>$157f9a87c9609c03$export$3e714e2c5d5d8cb2, (v)=>$157f9a87c9609c03$export$3e714e2c5d5d8cb2 = v);
    $parcel$export(module.exports, "pc2", ()=>$157f9a87c9609c03$export$94c3e544fd062b7f, (v)=>$157f9a87c9609c03$export$94c3e544fd062b7f = v);
    $parcel$export(module.exports, "expand", ()=>$157f9a87c9609c03$export$9f77e0932fb78f72, (v)=>$157f9a87c9609c03$export$9f77e0932fb78f72 = v);
    $parcel$export(module.exports, "substitute", ()=>$157f9a87c9609c03$export$d865ce2836f5927f, (v)=>$157f9a87c9609c03$export$d865ce2836f5927f = v);
    $parcel$export(module.exports, "permute", ()=>$157f9a87c9609c03$export$95e62ad65da8b7d2, (v)=>$157f9a87c9609c03$export$95e62ad65da8b7d2 = v);
    $parcel$export(module.exports, "padSplit", ()=>$157f9a87c9609c03$export$209139ff098c441a, (v)=>$157f9a87c9609c03$export$209139ff098c441a = v);
    var $157f9a87c9609c03$export$cfaef8ed399428b0;
    var $157f9a87c9609c03$export$a80c7deaea7cbd80;
    var $157f9a87c9609c03$export$ed7577ae6e1cd0ef;
    var $157f9a87c9609c03$export$5dcbef3aa594f567;
    var $157f9a87c9609c03$export$5bc8001ca71ed9c5;
    var $157f9a87c9609c03$export$3e714e2c5d5d8cb2;
    var $157f9a87c9609c03$export$94c3e544fd062b7f;
    var $157f9a87c9609c03$export$9f77e0932fb78f72;
    var $157f9a87c9609c03$export$d865ce2836f5927f;
    var $157f9a87c9609c03$export$95e62ad65da8b7d2;
    var $157f9a87c9609c03$export$209139ff098c441a;
    'use strict';
    $157f9a87c9609c03$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
        var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
        return res >>> 0;
    };
    $157f9a87c9609c03$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
        bytes[0 + off] = value >>> 24;
        bytes[1 + off] = value >>> 16 & 0xff;
        bytes[2 + off] = value >>> 8 & 0xff;
        bytes[3 + off] = value & 0xff;
    };
    $157f9a87c9609c03$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        for(var i = 6; i >= 0; i -= 2){
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inR >>> j + i & 1;
            }
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inL >>> j + i & 1;
            }
        }
        for(var i = 6; i >= 0; i -= 2){
            for(var j = 1; j <= 25; j += 8){
                outR <<= 1;
                outR |= inR >>> j + i & 1;
            }
            for(var j = 1; j <= 25; j += 8){
                outR <<= 1;
                outR |= inL >>> j + i & 1;
            }
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
        for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        for(var i = 7; i >= 5; i--){
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inR >> j + i & 1;
            }
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inL >> j + i & 1;
            }
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var i = 1; i <= 3; i++){
            for(var j = 0; j <= 24; j += 8){
                outR <<= 1;
                outR |= inR >> j + i & 1;
            }
            for(var j = 0; j <= 24; j += 8){
                outR <<= 1;
                outR |= inL >> j + i & 1;
            }
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
        return num << shift & 0xfffffff | num >>> 28 - shift;
    };
    var $157f9a87c9609c03$var$pc2table = [
        14,
        11,
        17,
        4,
        27,
        23,
        25,
        0,
        13,
        22,
        7,
        18,
        5,
        9,
        16,
        24,
        2,
        20,
        12,
        21,
        1,
        8,
        15,
        26,
        15,
        4,
        25,
        19,
        9,
        1,
        26,
        16,
        5,
        11,
        23,
        8,
        12,
        7,
        17,
        0,
        22,
        3,
        10,
        14,
        6,
        20,
        27,
        24
    ];
    $157f9a87c9609c03$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        var len = $157f9a87c9609c03$var$pc2table.length >>> 1;
        for(var i = 0; i < len; i++){
            outL <<= 1;
            outL |= inL >>> $157f9a87c9609c03$var$pc2table[i] & 0x1;
        }
        for(var i = len; i < $157f9a87c9609c03$var$pc2table.length; i++){
            outR <<= 1;
            outR |= inR >>> $157f9a87c9609c03$var$pc2table[i] & 0x1;
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$9f77e0932fb78f72 = function expand(r, out, off) {
        var outL = 0;
        var outR = 0;
        outL = (r & 1) << 5 | r >>> 27;
        for(var i = 23; i >= 15; i -= 4){
            outL <<= 6;
            outL |= r >>> i & 0x3f;
        }
        for(var i = 11; i >= 3; i -= 4){
            outR |= r >>> i & 0x3f;
            outR <<= 6;
        }
        outR |= (r & 0x1f) << 1 | r >>> 31;
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    var $157f9a87c9609c03$var$sTable = [
        14,
        0,
        4,
        15,
        13,
        7,
        1,
        4,
        2,
        14,
        15,
        2,
        11,
        13,
        8,
        1,
        3,
        10,
        10,
        6,
        6,
        12,
        12,
        11,
        5,
        9,
        9,
        5,
        0,
        3,
        7,
        8,
        4,
        15,
        1,
        12,
        14,
        8,
        8,
        2,
        13,
        4,
        6,
        9,
        2,
        1,
        11,
        7,
        15,
        5,
        12,
        11,
        9,
        3,
        7,
        14,
        3,
        10,
        10,
        0,
        5,
        6,
        0,
        13,
        15,
        3,
        1,
        13,
        8,
        4,
        14,
        7,
        6,
        15,
        11,
        2,
        3,
        8,
        4,
        14,
        9,
        12,
        7,
        0,
        2,
        1,
        13,
        10,
        12,
        6,
        0,
        9,
        5,
        11,
        10,
        5,
        0,
        13,
        14,
        8,
        7,
        10,
        11,
        1,
        10,
        3,
        4,
        15,
        13,
        4,
        1,
        2,
        5,
        11,
        8,
        6,
        12,
        7,
        6,
        12,
        9,
        0,
        3,
        5,
        2,
        14,
        15,
        9,
        10,
        13,
        0,
        7,
        9,
        0,
        14,
        9,
        6,
        3,
        3,
        4,
        15,
        6,
        5,
        10,
        1,
        2,
        13,
        8,
        12,
        5,
        7,
        14,
        11,
        12,
        4,
        11,
        2,
        15,
        8,
        1,
        13,
        1,
        6,
        10,
        4,
        13,
        9,
        0,
        8,
        6,
        15,
        9,
        3,
        8,
        0,
        7,
        11,
        4,
        1,
        15,
        2,
        14,
        12,
        3,
        5,
        11,
        10,
        5,
        14,
        2,
        7,
        12,
        7,
        13,
        13,
        8,
        14,
        11,
        3,
        5,
        0,
        6,
        6,
        15,
        9,
        0,
        10,
        3,
        1,
        4,
        2,
        7,
        8,
        2,
        5,
        12,
        11,
        1,
        12,
        10,
        4,
        14,
        15,
        9,
        10,
        3,
        6,
        15,
        9,
        0,
        0,
        6,
        12,
        10,
        11,
        1,
        7,
        13,
        13,
        8,
        15,
        9,
        1,
        4,
        3,
        5,
        14,
        11,
        5,
        12,
        2,
        7,
        8,
        2,
        4,
        14,
        2,
        14,
        12,
        11,
        4,
        2,
        1,
        12,
        7,
        4,
        10,
        7,
        11,
        13,
        6,
        1,
        8,
        5,
        5,
        0,
        3,
        15,
        15,
        10,
        13,
        3,
        0,
        9,
        14,
        8,
        9,
        6,
        4,
        11,
        2,
        8,
        1,
        12,
        11,
        7,
        10,
        1,
        13,
        14,
        7,
        2,
        8,
        13,
        15,
        6,
        9,
        15,
        12,
        0,
        5,
        9,
        6,
        10,
        3,
        4,
        0,
        5,
        14,
        3,
        12,
        10,
        1,
        15,
        10,
        4,
        15,
        2,
        9,
        7,
        2,
        12,
        6,
        9,
        8,
        5,
        0,
        6,
        13,
        1,
        3,
        13,
        4,
        14,
        14,
        0,
        7,
        11,
        5,
        3,
        11,
        8,
        9,
        4,
        14,
        3,
        15,
        2,
        5,
        12,
        2,
        9,
        8,
        5,
        12,
        15,
        3,
        10,
        7,
        11,
        0,
        14,
        4,
        1,
        10,
        7,
        1,
        6,
        13,
        0,
        11,
        8,
        6,
        13,
        4,
        13,
        11,
        0,
        2,
        11,
        14,
        7,
        15,
        4,
        0,
        9,
        8,
        1,
        13,
        10,
        3,
        14,
        12,
        3,
        9,
        5,
        7,
        12,
        5,
        2,
        10,
        15,
        6,
        8,
        1,
        6,
        1,
        6,
        4,
        11,
        11,
        13,
        13,
        8,
        12,
        1,
        3,
        4,
        7,
        10,
        14,
        7,
        10,
        9,
        15,
        5,
        6,
        0,
        8,
        15,
        0,
        14,
        5,
        2,
        9,
        3,
        2,
        12,
        13,
        1,
        2,
        15,
        8,
        13,
        4,
        8,
        6,
        10,
        15,
        3,
        11,
        7,
        1,
        4,
        10,
        12,
        9,
        5,
        3,
        6,
        14,
        11,
        5,
        0,
        0,
        14,
        12,
        9,
        7,
        2,
        7,
        2,
        11,
        1,
        4,
        14,
        1,
        7,
        9,
        4,
        12,
        10,
        14,
        8,
        2,
        13,
        0,
        15,
        6,
        12,
        10,
        9,
        13,
        0,
        15,
        3,
        3,
        5,
        5,
        6,
        8,
        11
    ];
    $157f9a87c9609c03$export$d865ce2836f5927f = function substitute(inL, inR) {
        var out = 0;
        for(var i = 0; i < 4; i++){
            var b = inL >>> 18 - i * 6 & 0x3f;
            var sb = $157f9a87c9609c03$var$sTable[i * 0x40 + b];
            out <<= 4;
            out |= sb;
        }
        for(var i = 0; i < 4; i++){
            var b = inR >>> 18 - i * 6 & 0x3f;
            var sb = $157f9a87c9609c03$var$sTable[256 + i * 0x40 + b];
            out <<= 4;
            out |= sb;
        }
        return out >>> 0;
    };
    var $157f9a87c9609c03$var$permuteTable = [
        16,
        25,
        12,
        11,
        3,
        20,
        4,
        15,
        31,
        17,
        9,
        6,
        27,
        14,
        1,
        22,
        30,
        24,
        8,
        18,
        0,
        5,
        29,
        23,
        13,
        19,
        2,
        26,
        10,
        21,
        28,
        7
    ];
    $157f9a87c9609c03$export$95e62ad65da8b7d2 = function permute(num) {
        var out = 0;
        for(var i = 0; i < $157f9a87c9609c03$var$permuteTable.length; i++){
            out <<= 1;
            out |= num >>> $157f9a87c9609c03$var$permuteTable[i] & 0x1;
        }
        return out >>> 0;
    };
    $157f9a87c9609c03$export$209139ff098c441a = function padSplit(num, size, group) {
        var str = num.toString(2);
        while(str.length < size)str = '0' + str;
        var out = [];
        for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
        return out.join(' ');
    };
});
parcelRegister("lE1WX", function(module, exports) {
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    function $fc1ed8a00916f8f8$var$Cipher(options) {
        this.options = options;
        this.type = this.options.type;
        this.blockSize = 8;
        this._init();
        this.buffer = new Array(this.blockSize);
        this.bufferOff = 0;
    }
    module.exports = $fc1ed8a00916f8f8$var$Cipher;
    $fc1ed8a00916f8f8$var$Cipher.prototype._init = function _init() {};
    $fc1ed8a00916f8f8$var$Cipher.prototype.update = function update(data) {
        if (data.length === 0) return [];
        if (this.type === 'decrypt') return this._updateDecrypt(data);
        else return this._updateEncrypt(data);
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._buffer = function _buffer(data, off) {
        var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
        for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
        this.bufferOff += min;
        return min;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
        this._update(this.buffer, 0, out, off);
        this.bufferOff = 0;
        return this.blockSize;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
        var inputOff = 0;
        var outputOff = 0;
        var count = (this.bufferOff + data.length) / this.blockSize | 0;
        var out = new Array(count * this.blockSize);
        if (this.bufferOff !== 0) {
            inputOff += this._buffer(data, inputOff);
            if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
        }
        var max = data.length - (data.length - inputOff) % this.blockSize;
        for(; inputOff < max; inputOff += this.blockSize){
            this._update(data, inputOff, out, outputOff);
            outputOff += this.blockSize;
        }
        for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
        return out;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
        var inputOff = 0;
        var outputOff = 0;
        var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
        var out = new Array(count * this.blockSize);
        for(; count > 0; count--){
            inputOff += this._buffer(data, inputOff);
            outputOff += this._flushBuffer(out, outputOff);
        }
        inputOff += this._buffer(data, inputOff);
        return out;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype.final = function final(buffer) {
        var first;
        if (buffer) first = this.update(buffer);
        var last;
        if (this.type === 'encrypt') last = this._finalEncrypt();
        else last = this._finalDecrypt();
        if (first) return first.concat(last);
        else return last;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._pad = function _pad(buffer, off) {
        if (off === 0) return false;
        while(off < buffer.length)buffer[off++] = 0;
        return true;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
        if (!this._pad(this.buffer, this.bufferOff)) return [];
        var out = new Array(this.blockSize);
        this._update(this.buffer, 0, out, 0);
        return out;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._unpad = function _unpad(buffer) {
        return buffer;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
        $gxaFy.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
        var out = new Array(this.blockSize);
        this._flushBuffer(out, 0);
        return this._unpad(out);
    };
});
parcelRegister("gxaFy", function(module, exports) {
    module.exports = $c098011ba04e0256$var$assert;
    function $c098011ba04e0256$var$assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    $c098011ba04e0256$var$assert.equal = function assertEqual(l, r, msg) {
        if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
    };
});
parcelRegister("6uemC", function(module, exports) {
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    var $bsIyp = parcelRequire("bsIyp");
    var $4b90afcb2a1cbace$var$utils = $bsIyp.utils;
    var $4b90afcb2a1cbace$var$Cipher = $bsIyp.Cipher;
    function $4b90afcb2a1cbace$var$DESState() {
        this.tmp = new Array(2);
        this.keys = null;
    }
    function $4b90afcb2a1cbace$var$DES(options) {
        $4b90afcb2a1cbace$var$Cipher.call(this, options);
        var state = new $4b90afcb2a1cbace$var$DESState();
        this._desState = state;
        this.deriveKeys(state, options.key);
    }
    $v3bBu($4b90afcb2a1cbace$var$DES, $4b90afcb2a1cbace$var$Cipher);
    module.exports = $4b90afcb2a1cbace$var$DES;
    $4b90afcb2a1cbace$var$DES.create = function create(options) {
        return new $4b90afcb2a1cbace$var$DES(options);
    };
    var $4b90afcb2a1cbace$var$shiftTable = [
        1,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        1
    ];
    $4b90afcb2a1cbace$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
        state.keys = new Array(32);
        $gxaFy.equal(key.length, this.blockSize, 'Invalid key length');
        var kL = $4b90afcb2a1cbace$var$utils.readUInt32BE(key, 0);
        var kR = $4b90afcb2a1cbace$var$utils.readUInt32BE(key, 4);
        $4b90afcb2a1cbace$var$utils.pc1(kL, kR, state.tmp, 0);
        kL = state.tmp[0];
        kR = state.tmp[1];
        for(var i = 0; i < state.keys.length; i += 2){
            var shift = $4b90afcb2a1cbace$var$shiftTable[i >>> 1];
            kL = $4b90afcb2a1cbace$var$utils.r28shl(kL, shift);
            kR = $4b90afcb2a1cbace$var$utils.r28shl(kR, shift);
            $4b90afcb2a1cbace$var$utils.pc2(kL, kR, state.keys, i);
        }
    };
    $4b90afcb2a1cbace$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
        var state = this._desState;
        var l = $4b90afcb2a1cbace$var$utils.readUInt32BE(inp, inOff);
        var r = $4b90afcb2a1cbace$var$utils.readUInt32BE(inp, inOff + 4);
        $4b90afcb2a1cbace$var$utils.ip(l, r, state.tmp, 0);
        l = state.tmp[0];
        r = state.tmp[1];
        if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
        else this._decrypt(state, l, r, state.tmp, 0);
        l = state.tmp[0];
        r = state.tmp[1];
        $4b90afcb2a1cbace$var$utils.writeUInt32BE(out, l, outOff);
        $4b90afcb2a1cbace$var$utils.writeUInt32BE(out, r, outOff + 4);
    };
    $4b90afcb2a1cbace$var$DES.prototype._pad = function _pad(buffer, off) {
        var value = buffer.length - off;
        for(var i = off; i < buffer.length; i++)buffer[i] = value;
        return true;
    };
    $4b90afcb2a1cbace$var$DES.prototype._unpad = function _unpad(buffer) {
        var pad = buffer[buffer.length - 1];
        for(var i = buffer.length - pad; i < buffer.length; i++)$gxaFy.equal(buffer[i], pad);
        return buffer.slice(0, buffer.length - pad);
    };
    $4b90afcb2a1cbace$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
        var l = lStart;
        var r = rStart;
        for(var i = 0; i < state.keys.length; i += 2){
            var keyL = state.keys[i];
            var keyR = state.keys[i + 1];
            $4b90afcb2a1cbace$var$utils.expand(r, state.tmp, 0);
            keyL ^= state.tmp[0];
            keyR ^= state.tmp[1];
            var s = $4b90afcb2a1cbace$var$utils.substitute(keyL, keyR);
            var f = $4b90afcb2a1cbace$var$utils.permute(s);
            var t = r;
            r = (l ^ f) >>> 0;
            l = t;
        }
        $4b90afcb2a1cbace$var$utils.rip(r, l, out, off);
    };
    $4b90afcb2a1cbace$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
        var l = rStart;
        var r = lStart;
        for(var i = state.keys.length - 2; i >= 0; i -= 2){
            var keyL = state.keys[i];
            var keyR = state.keys[i + 1];
            $4b90afcb2a1cbace$var$utils.expand(l, state.tmp, 0);
            keyL ^= state.tmp[0];
            keyR ^= state.tmp[1];
            var s = $4b90afcb2a1cbace$var$utils.substitute(keyL, keyR);
            var f = $4b90afcb2a1cbace$var$utils.permute(s);
            var t = l;
            l = (r ^ f) >>> 0;
            r = t;
        }
        $4b90afcb2a1cbace$var$utils.rip(l, r, out, off);
    };
});
parcelRegister("bdh1b", function(module, exports) {
    $parcel$export(module.exports, "instantiate", ()=>$829e1c11ed1f1a2c$export$f9bb8d20ccc7477a, (v)=>$829e1c11ed1f1a2c$export$f9bb8d20ccc7477a = v);
    var $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a;
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    var $829e1c11ed1f1a2c$var$proto = {};
    function $829e1c11ed1f1a2c$var$CBCState(iv) {
        $gxaFy.equal(iv.length, 8, 'Invalid IV length');
        this.iv = new Array(8);
        for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
    }
    function $829e1c11ed1f1a2c$var$instantiate(Base) {
        function CBC(options) {
            Base.call(this, options);
            this._cbcInit();
        }
        $v3bBu(CBC, Base);
        var keys = Object.keys($829e1c11ed1f1a2c$var$proto);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            CBC.prototype[key] = $829e1c11ed1f1a2c$var$proto[key];
        }
        CBC.create = function create(options) {
            return new CBC(options);
        };
        return CBC;
    }
    $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a = $829e1c11ed1f1a2c$var$instantiate;
    $829e1c11ed1f1a2c$var$proto._cbcInit = function _cbcInit() {
        var state = new $829e1c11ed1f1a2c$var$CBCState(this.options.iv);
        this._cbcState = state;
    };
    $829e1c11ed1f1a2c$var$proto._update = function _update(inp, inOff, out, outOff) {
        var state = this._cbcState;
        var superProto = this.constructor.super_.prototype;
        var iv = state.iv;
        if (this.type === 'encrypt') {
            for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
            superProto._update.call(this, iv, 0, out, outOff);
            for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
        } else {
            superProto._update.call(this, inp, inOff, out, outOff);
            for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
            for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
        }
    };
});
parcelRegister("d53eL", function(module, exports) {
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    var $bsIyp = parcelRequire("bsIyp");
    var $02752213ee35ee04$var$Cipher = $bsIyp.Cipher;
    var $02752213ee35ee04$var$DES = $bsIyp.DES;
    function $02752213ee35ee04$var$EDEState(type, key) {
        $gxaFy.equal(key.length, 24, 'Invalid key length');
        var k1 = key.slice(0, 8);
        var k2 = key.slice(8, 16);
        var k3 = key.slice(16, 24);
        if (type === 'encrypt') this.ciphers = [
            $02752213ee35ee04$var$DES.create({
                type: 'encrypt',
                key: k1
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'decrypt',
                key: k2
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'encrypt',
                key: k3
            })
        ];
        else this.ciphers = [
            $02752213ee35ee04$var$DES.create({
                type: 'decrypt',
                key: k3
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'encrypt',
                key: k2
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'decrypt',
                key: k1
            })
        ];
    }
    function $02752213ee35ee04$var$EDE(options) {
        $02752213ee35ee04$var$Cipher.call(this, options);
        var state = new $02752213ee35ee04$var$EDEState(this.type, this.options.key);
        this._edeState = state;
    }
    $v3bBu($02752213ee35ee04$var$EDE, $02752213ee35ee04$var$Cipher);
    module.exports = $02752213ee35ee04$var$EDE;
    $02752213ee35ee04$var$EDE.create = function create(options) {
        return new $02752213ee35ee04$var$EDE(options);
    };
    $02752213ee35ee04$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
        var state = this._edeState;
        state.ciphers[0]._update(inp, inOff, out, outOff);
        state.ciphers[1]._update(out, outOff, out, outOff);
        state.ciphers[2]._update(out, outOff, out, outOff);
    };
    $02752213ee35ee04$var$EDE.prototype._pad = $02752213ee35ee04$var$DES.prototype._pad;
    $02752213ee35ee04$var$EDE.prototype._unpad = $02752213ee35ee04$var$DES.prototype._unpad;
});
parcelRegister("gcaJj", function(module, exports) {
    $parcel$export(module.exports, "createCipheriv", ()=>$bca6170d70d22f8b$export$2f64596b8cbf08b4, (v)=>$bca6170d70d22f8b$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$bca6170d70d22f8b$export$36b6d6ef312eab39, (v)=>$bca6170d70d22f8b$export$36b6d6ef312eab39 = v);
    $parcel$export(module.exports, "getCiphers", ()=>$bca6170d70d22f8b$export$58a258485f1e49f6, (v)=>$bca6170d70d22f8b$export$58a258485f1e49f6 = v);
    var $bca6170d70d22f8b$export$bdd223f16383713e;
    var $bca6170d70d22f8b$export$26e5786e8ac8e530;
    var $bca6170d70d22f8b$export$2f64596b8cbf08b4;
    var $bca6170d70d22f8b$export$20533d26f07f1ee0;
    var $bca6170d70d22f8b$export$12ada9414fbc594c;
    var $bca6170d70d22f8b$export$2ce6d8d0e8b04e1a;
    var $bca6170d70d22f8b$export$36b6d6ef312eab39;
    var $bca6170d70d22f8b$export$f5e7e39d57cd9700;
    var $bca6170d70d22f8b$export$dedd8dc3dc62b370;
    var $bca6170d70d22f8b$export$58a258485f1e49f6;
    var $8YWSl = parcelRequire("8YWSl");
    var $i9P5q = parcelRequire("i9P5q");
    var $8DplL = parcelRequire("8DplL");
    function $bca6170d70d22f8b$var$getCiphers() {
        return Object.keys($8DplL);
    }
    $bca6170d70d22f8b$export$bdd223f16383713e = $bca6170d70d22f8b$export$26e5786e8ac8e530 = $8YWSl.createCipher;
    $bca6170d70d22f8b$export$2f64596b8cbf08b4 = $bca6170d70d22f8b$export$20533d26f07f1ee0 = $8YWSl.createCipheriv;
    $bca6170d70d22f8b$export$12ada9414fbc594c = $bca6170d70d22f8b$export$2ce6d8d0e8b04e1a = $i9P5q.createDecipher;
    $bca6170d70d22f8b$export$36b6d6ef312eab39 = $bca6170d70d22f8b$export$f5e7e39d57cd9700 = $i9P5q.createDecipheriv;
    $bca6170d70d22f8b$export$dedd8dc3dc62b370 = $bca6170d70d22f8b$export$58a258485f1e49f6 = $bca6170d70d22f8b$var$getCiphers;
});
parcelRegister("8YWSl", function(module, exports) {
    $parcel$export(module.exports, "createCipheriv", ()=>$68a198cd46e098a5$export$2f64596b8cbf08b4, (v)=>$68a198cd46e098a5$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "createCipher", ()=>$68a198cd46e098a5$export$bdd223f16383713e, (v)=>$68a198cd46e098a5$export$bdd223f16383713e = v);
    var $68a198cd46e098a5$export$2f64596b8cbf08b4;
    var $68a198cd46e098a5$export$bdd223f16383713e;
    var $6WLno = parcelRequire("6WLno");
    var $dsL7z = parcelRequire("dsL7z");
    var $Wth4q = parcelRequire("Wth4q");
    var $68a198cd46e098a5$require$Buffer = $Wth4q.Buffer;
    var $ecK7f = parcelRequire("ecK7f");
    var $77fwb = parcelRequire("77fwb");
    var $h0C5b = parcelRequire("h0C5b");
    var $55KiC = parcelRequire("55KiC");
    var $v3bBu = parcelRequire("v3bBu");
    function $68a198cd46e098a5$var$Cipher(mode, key, iv) {
        $77fwb.call(this);
        this._cache = new $68a198cd46e098a5$var$Splitter();
        this._cipher = new $h0C5b.AES(key);
        this._prev = $68a198cd46e098a5$require$Buffer.from(iv);
        this._mode = mode;
        this._autopadding = true;
    }
    $v3bBu($68a198cd46e098a5$var$Cipher, $77fwb);
    $68a198cd46e098a5$var$Cipher.prototype._update = function(data) {
        this._cache.add(data);
        var chunk;
        var thing;
        var out = [];
        while(chunk = this._cache.get()){
            thing = this._mode.encrypt(this, chunk);
            out.push(thing);
        }
        return $68a198cd46e098a5$require$Buffer.concat(out);
    };
    var $68a198cd46e098a5$var$PADDING = $68a198cd46e098a5$require$Buffer.alloc(16, 0x10);
    $68a198cd46e098a5$var$Cipher.prototype._final = function() {
        var chunk = this._cache.flush();
        if (this._autopadding) {
            chunk = this._mode.encrypt(this, chunk);
            this._cipher.scrub();
            return chunk;
        }
        if (!chunk.equals($68a198cd46e098a5$var$PADDING)) {
            this._cipher.scrub();
            throw new Error('data not multiple of block length');
        }
    };
    $68a198cd46e098a5$var$Cipher.prototype.setAutoPadding = function(setTo) {
        this._autopadding = !!setTo;
        return this;
    };
    function $68a198cd46e098a5$var$Splitter() {
        this.cache = $68a198cd46e098a5$require$Buffer.allocUnsafe(0);
    }
    $68a198cd46e098a5$var$Splitter.prototype.add = function(data) {
        this.cache = $68a198cd46e098a5$require$Buffer.concat([
            this.cache,
            data
        ]);
    };
    $68a198cd46e098a5$var$Splitter.prototype.get = function() {
        if (this.cache.length > 15) {
            var out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
        return null;
    };
    $68a198cd46e098a5$var$Splitter.prototype.flush = function() {
        var len = 16 - this.cache.length;
        var padBuff = $68a198cd46e098a5$require$Buffer.allocUnsafe(len);
        var i = -1;
        while(++i < len)padBuff.writeUInt8(len, i);
        return $68a198cd46e098a5$require$Buffer.concat([
            this.cache,
            padBuff
        ]);
    };
    function $68a198cd46e098a5$var$createCipheriv(suite, password, iv) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        if (typeof password === 'string') password = $68a198cd46e098a5$require$Buffer.from(password);
        if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
        if (typeof iv === 'string') iv = $68a198cd46e098a5$require$Buffer.from(iv);
        if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
        if (config.type === 'stream') return new $ecK7f(config.module, password, iv);
        else if (config.type === 'auth') return new $dsL7z(config.module, password, iv);
        return new $68a198cd46e098a5$var$Cipher(config.module, password, iv);
    }
    function $68a198cd46e098a5$var$createCipher(suite, password) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, config.key, config.iv);
        return $68a198cd46e098a5$var$createCipheriv(suite, keys.key, keys.iv);
    }
    $68a198cd46e098a5$export$2f64596b8cbf08b4 = $68a198cd46e098a5$var$createCipheriv;
    $68a198cd46e098a5$export$bdd223f16383713e = $68a198cd46e098a5$var$createCipher;
});
parcelRegister("6WLno", function(module, exports) {
    var $50ece8ccaacc95aa$var$modeModules = {
        ECB: (parcelRequire("2r4jQ")),
        CBC: (parcelRequire("171QV")),
        CFB: (parcelRequire("7gub3")),
        CFB8: (parcelRequire("hHOIy")),
        CFB1: (parcelRequire("hJx3X")),
        OFB: (parcelRequire("3PEE4")),
        CTR: (parcelRequire("5VEEg")),
        GCM: (parcelRequire("5VEEg"))
    };
    var $8DplL = parcelRequire("8DplL");
    for(var $50ece8ccaacc95aa$var$key in $8DplL)$8DplL[$50ece8ccaacc95aa$var$key].module = $50ece8ccaacc95aa$var$modeModules[$8DplL[$50ece8ccaacc95aa$var$key].mode];
    module.exports = $8DplL;
});
parcelRegister("2r4jQ", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$1c61741219819c7a$export$5b0f6292f11d1d18, (v)=>$1c61741219819c7a$export$5b0f6292f11d1d18 = v);
    $parcel$export(module.exports, "decrypt", ()=>$1c61741219819c7a$export$e85a0c9a1067c5d3, (v)=>$1c61741219819c7a$export$e85a0c9a1067c5d3 = v);
    var $1c61741219819c7a$export$5b0f6292f11d1d18;
    var $1c61741219819c7a$export$e85a0c9a1067c5d3;
    $1c61741219819c7a$export$5b0f6292f11d1d18 = function(self, block) {
        return self._cipher.encryptBlock(block);
    };
    $1c61741219819c7a$export$e85a0c9a1067c5d3 = function(self, block) {
        return self._cipher.decryptBlock(block);
    };
});
parcelRegister("171QV", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$0cf7e1c4789e90b1$export$5b0f6292f11d1d18, (v)=>$0cf7e1c4789e90b1$export$5b0f6292f11d1d18 = v);
    $parcel$export(module.exports, "decrypt", ()=>$0cf7e1c4789e90b1$export$e85a0c9a1067c5d3, (v)=>$0cf7e1c4789e90b1$export$e85a0c9a1067c5d3 = v);
    var $0cf7e1c4789e90b1$export$5b0f6292f11d1d18;
    var $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3;
    var $hWuQG = parcelRequire("hWuQG");
    $0cf7e1c4789e90b1$export$5b0f6292f11d1d18 = function(self, block) {
        var data = $hWuQG(block, self._prev);
        self._prev = self._cipher.encryptBlock(data);
        return self._prev;
    };
    $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3 = function(self, block) {
        var pad = self._prev;
        self._prev = block;
        var out = self._cipher.decryptBlock(block);
        return $hWuQG(out, pad);
    };
});
parcelRegister("hWuQG", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $d0ffc85ebd18b8c9$require$Buffer = $5k7LC.Buffer;
    module.exports = function xor(a, b) {
        var length = Math.min(a.length, b.length);
        var buffer = new $d0ffc85ebd18b8c9$require$Buffer(length);
        for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
        return buffer;
    };
});
parcelRegister("7gub3", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$54a16fa1fdb145af$export$5b0f6292f11d1d18, (v)=>$54a16fa1fdb145af$export$5b0f6292f11d1d18 = v);
    var $54a16fa1fdb145af$export$5b0f6292f11d1d18;
    var $Wth4q = parcelRequire("Wth4q");
    var $54a16fa1fdb145af$require$Buffer = $Wth4q.Buffer;
    var $hWuQG = parcelRequire("hWuQG");
    function $54a16fa1fdb145af$var$encryptStart(self, data, decrypt) {
        var len = data.length;
        var out = $hWuQG(data, self._cache);
        self._cache = self._cache.slice(len);
        self._prev = $54a16fa1fdb145af$require$Buffer.concat([
            self._prev,
            decrypt ? data : out
        ]);
        return out;
    }
    $54a16fa1fdb145af$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
        var out = $54a16fa1fdb145af$require$Buffer.allocUnsafe(0);
        var len;
        while(data.length){
            if (self._cache.length === 0) {
                self._cache = self._cipher.encryptBlock(self._prev);
                self._prev = $54a16fa1fdb145af$require$Buffer.allocUnsafe(0);
            }
            if (self._cache.length <= data.length) {
                len = self._cache.length;
                out = $54a16fa1fdb145af$require$Buffer.concat([
                    out,
                    $54a16fa1fdb145af$var$encryptStart(self, data.slice(0, len), decrypt)
                ]);
                data = data.slice(len);
            } else {
                out = $54a16fa1fdb145af$require$Buffer.concat([
                    out,
                    $54a16fa1fdb145af$var$encryptStart(self, data, decrypt)
                ]);
                break;
            }
        }
        return out;
    };
});
parcelRegister("hHOIy", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$ce3dcb4bc3fa3501$export$5b0f6292f11d1d18, (v)=>$ce3dcb4bc3fa3501$export$5b0f6292f11d1d18 = v);
    var $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18;
    var $Wth4q = parcelRequire("Wth4q");
    var $ce3dcb4bc3fa3501$require$Buffer = $Wth4q.Buffer;
    function $ce3dcb4bc3fa3501$var$encryptByte(self, byteParam, decrypt) {
        var pad = self._cipher.encryptBlock(self._prev);
        var out = pad[0] ^ byteParam;
        self._prev = $ce3dcb4bc3fa3501$require$Buffer.concat([
            self._prev.slice(1),
            $ce3dcb4bc3fa3501$require$Buffer.from([
                decrypt ? byteParam : out
            ])
        ]);
        return out;
    }
    $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
        var len = chunk.length;
        var out = $ce3dcb4bc3fa3501$require$Buffer.allocUnsafe(len);
        var i = -1;
        while(++i < len)out[i] = $ce3dcb4bc3fa3501$var$encryptByte(self, chunk[i], decrypt);
        return out;
    };
});
parcelRegister("hJx3X", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$ce90493eb3a7fe0a$export$5b0f6292f11d1d18, (v)=>$ce90493eb3a7fe0a$export$5b0f6292f11d1d18 = v);
    var $ce90493eb3a7fe0a$export$5b0f6292f11d1d18;
    var $Wth4q = parcelRequire("Wth4q");
    var $ce90493eb3a7fe0a$require$Buffer = $Wth4q.Buffer;
    function $ce90493eb3a7fe0a$var$encryptByte(self, byteParam, decrypt) {
        var pad;
        var i = -1;
        var len = 8;
        var out = 0;
        var bit, value;
        while(++i < len){
            pad = self._cipher.encryptBlock(self._prev);
            bit = byteParam & 1 << 7 - i ? 0x80 : 0;
            value = pad[0] ^ bit;
            out += (value & 0x80) >> i % 8;
            self._prev = $ce90493eb3a7fe0a$var$shiftIn(self._prev, decrypt ? bit : value);
        }
        return out;
    }
    function $ce90493eb3a7fe0a$var$shiftIn(buffer, value) {
        var len = buffer.length;
        var i = -1;
        var out = $ce90493eb3a7fe0a$require$Buffer.allocUnsafe(buffer.length);
        buffer = $ce90493eb3a7fe0a$require$Buffer.concat([
            buffer,
            $ce90493eb3a7fe0a$require$Buffer.from([
                value
            ])
        ]);
        while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
        return out;
    }
    $ce90493eb3a7fe0a$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
        var len = chunk.length;
        var out = $ce90493eb3a7fe0a$require$Buffer.allocUnsafe(len);
        var i = -1;
        while(++i < len)out[i] = $ce90493eb3a7fe0a$var$encryptByte(self, chunk[i], decrypt);
        return out;
    };
});
parcelRegister("3PEE4", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$2ca5a9cd9f4302f4$export$5b0f6292f11d1d18, (v)=>$2ca5a9cd9f4302f4$export$5b0f6292f11d1d18 = v);
    var $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18;
    var $5k7LC = parcelRequire("5k7LC");
    var $2ca5a9cd9f4302f4$require$Buffer = $5k7LC.Buffer;
    var $hWuQG = parcelRequire("hWuQG");
    function $2ca5a9cd9f4302f4$var$getBlock(self) {
        self._prev = self._cipher.encryptBlock(self._prev);
        return self._prev;
    }
    $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18 = function(self, chunk) {
        while(self._cache.length < chunk.length)self._cache = $2ca5a9cd9f4302f4$require$Buffer.concat([
            self._cache,
            $2ca5a9cd9f4302f4$var$getBlock(self)
        ]);
        var pad = self._cache.slice(0, chunk.length);
        self._cache = self._cache.slice(chunk.length);
        return $hWuQG(chunk, pad);
    };
});
parcelRegister("5VEEg", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$4511ce87a2b6ec4f$export$5b0f6292f11d1d18, (v)=>$4511ce87a2b6ec4f$export$5b0f6292f11d1d18 = v);
    var $4511ce87a2b6ec4f$export$5b0f6292f11d1d18;
    var $hWuQG = parcelRequire("hWuQG");
    var $Wth4q = parcelRequire("Wth4q");
    var $4511ce87a2b6ec4f$require$Buffer = $Wth4q.Buffer;
    var $eYeWA = parcelRequire("eYeWA");
    function $4511ce87a2b6ec4f$var$getBlock(self) {
        var out = self._cipher.encryptBlockRaw(self._prev);
        $eYeWA(self._prev);
        return out;
    }
    var $4511ce87a2b6ec4f$var$blockSize = 16;
    $4511ce87a2b6ec4f$export$5b0f6292f11d1d18 = function(self, chunk) {
        var chunkNum = Math.ceil(chunk.length / $4511ce87a2b6ec4f$var$blockSize);
        var start = self._cache.length;
        self._cache = $4511ce87a2b6ec4f$require$Buffer.concat([
            self._cache,
            $4511ce87a2b6ec4f$require$Buffer.allocUnsafe(chunkNum * $4511ce87a2b6ec4f$var$blockSize)
        ]);
        for(var i = 0; i < chunkNum; i++){
            var out = $4511ce87a2b6ec4f$var$getBlock(self);
            var offset = start + i * $4511ce87a2b6ec4f$var$blockSize;
            self._cache.writeUInt32BE(out[0], offset + 0);
            self._cache.writeUInt32BE(out[1], offset + 4);
            self._cache.writeUInt32BE(out[2], offset + 8);
            self._cache.writeUInt32BE(out[3], offset + 12);
        }
        var pad = self._cache.slice(0, chunk.length);
        self._cache = self._cache.slice(chunk.length);
        return $hWuQG(chunk, pad);
    };
});
parcelRegister("eYeWA", function(module, exports) {
    function $ae6242d5e2554d0f$var$incr32(iv) {
        var len = iv.length;
        var item;
        while(len--){
            item = iv.readUInt8(len);
            if (item === 255) iv.writeUInt8(0, len);
            else {
                item++;
                iv.writeUInt8(item, len);
                break;
            }
        }
    }
    module.exports = $ae6242d5e2554d0f$var$incr32;
});
parcelRegister("8DplL", function(module, exports) {
    module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");
});
parcelRegister("dsL7z", function(module, exports) {
    var $h0C5b = parcelRequire("h0C5b");
    var $Wth4q = parcelRequire("Wth4q");
    var $9cd2712b02891133$require$Buffer = $Wth4q.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $v3bBu = parcelRequire("v3bBu");
    var $3wyrd = parcelRequire("3wyrd");
    var $hWuQG = parcelRequire("hWuQG");
    var $eYeWA = parcelRequire("eYeWA");
    function $9cd2712b02891133$var$xorTest(a, b) {
        var out = 0;
        if (a.length !== b.length) out++;
        var len = Math.min(a.length, b.length);
        for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
        return out;
    }
    function $9cd2712b02891133$var$calcIv(self, iv, ck) {
        if (iv.length === 12) {
            self._finID = $9cd2712b02891133$require$Buffer.concat([
                iv,
                $9cd2712b02891133$require$Buffer.from([
                    0,
                    0,
                    0,
                    1
                ])
            ]);
            return $9cd2712b02891133$require$Buffer.concat([
                iv,
                $9cd2712b02891133$require$Buffer.from([
                    0,
                    0,
                    0,
                    2
                ])
            ]);
        }
        var ghash = new $3wyrd(ck);
        var len = iv.length;
        var toPad = len % 16;
        ghash.update(iv);
        if (toPad) {
            toPad = 16 - toPad;
            ghash.update($9cd2712b02891133$require$Buffer.alloc(toPad, 0));
        }
        ghash.update($9cd2712b02891133$require$Buffer.alloc(8, 0));
        var ivBits = len * 8;
        var tail = $9cd2712b02891133$require$Buffer.alloc(8);
        tail.writeUIntBE(ivBits, 0, 8);
        ghash.update(tail);
        self._finID = ghash.state;
        var out = $9cd2712b02891133$require$Buffer.from(self._finID);
        $eYeWA(out);
        return out;
    }
    function $9cd2712b02891133$var$StreamCipher(mode, key, iv, decrypt) {
        $77fwb.call(this);
        var h = $9cd2712b02891133$require$Buffer.alloc(4, 0);
        this._cipher = new $h0C5b.AES(key);
        var ck = this._cipher.encryptBlock(h);
        this._ghash = new $3wyrd(ck);
        iv = $9cd2712b02891133$var$calcIv(this, iv, ck);
        this._prev = $9cd2712b02891133$require$Buffer.from(iv);
        this._cache = $9cd2712b02891133$require$Buffer.allocUnsafe(0);
        this._secCache = $9cd2712b02891133$require$Buffer.allocUnsafe(0);
        this._decrypt = decrypt;
        this._alen = 0;
        this._len = 0;
        this._mode = mode;
        this._authTag = null;
        this._called = false;
    }
    $v3bBu($9cd2712b02891133$var$StreamCipher, $77fwb);
    $9cd2712b02891133$var$StreamCipher.prototype._update = function(chunk) {
        if (!this._called && this._alen) {
            var rump = 16 - this._alen % 16;
            if (rump < 16) {
                rump = $9cd2712b02891133$require$Buffer.alloc(rump, 0);
                this._ghash.update(rump);
            }
        }
        this._called = true;
        var out = this._mode.encrypt(this, chunk);
        if (this._decrypt) this._ghash.update(chunk);
        else this._ghash.update(out);
        this._len += chunk.length;
        return out;
    };
    $9cd2712b02891133$var$StreamCipher.prototype._final = function() {
        if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
        var tag = $hWuQG(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
        if (this._decrypt && $9cd2712b02891133$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
        this._authTag = tag;
        this._cipher.scrub();
    };
    $9cd2712b02891133$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
        if (this._decrypt || !$9cd2712b02891133$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
        return this._authTag;
    };
    $9cd2712b02891133$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
        if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
        this._authTag = tag;
    };
    $9cd2712b02891133$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
        if (this._called) throw new Error('Attempting to set AAD in unsupported state');
        this._ghash.update(buf);
        this._alen += buf.length;
    };
    module.exports = $9cd2712b02891133$var$StreamCipher;
});
parcelRegister("h0C5b", function(module, exports) {
    $parcel$export(module.exports, "AES", ()=>$c61ffa2be163e1f3$export$b80fbe1c3a2b92b5, (v)=>$c61ffa2be163e1f3$export$b80fbe1c3a2b92b5 = v);
    var $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5;
    var $Wth4q = parcelRequire("Wth4q");
    var $c61ffa2be163e1f3$require$Buffer = $Wth4q.Buffer;
    function $c61ffa2be163e1f3$var$asUInt32Array(buf) {
        if (!$c61ffa2be163e1f3$require$Buffer.isBuffer(buf)) buf = $c61ffa2be163e1f3$require$Buffer.from(buf);
        var len = buf.length / 4 | 0;
        var out = new Array(len);
        for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
        return out;
    }
    function $c61ffa2be163e1f3$var$scrubVec(v) {
        for(var i = 0; i < v.length; v++)v[i] = 0;
    }
    function $c61ffa2be163e1f3$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
        var SUB_MIX0 = SUB_MIX[0];
        var SUB_MIX1 = SUB_MIX[1];
        var SUB_MIX2 = SUB_MIX[2];
        var SUB_MIX3 = SUB_MIX[3];
        var s0 = M[0] ^ keySchedule[0];
        var s1 = M[1] ^ keySchedule[1];
        var s2 = M[2] ^ keySchedule[2];
        var s3 = M[3] ^ keySchedule[3];
        var t0, t1, t2, t3;
        var ksRow = 4;
        for(var round = 1; round < nRounds; round++){
            t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
            t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
            t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
            t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
            s0 = t0;
            s1 = t1;
            s2 = t2;
            s3 = t3;
        }
        t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
        t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
        t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
        t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
        t0 = t0 >>> 0;
        t1 = t1 >>> 0;
        t2 = t2 >>> 0;
        t3 = t3 >>> 0;
        return [
            t0,
            t1,
            t2,
            t3
        ];
    }
    var $c61ffa2be163e1f3$var$RCON = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36
    ];
    var $c61ffa2be163e1f3$var$G = function() {
        var d = new Array(256);
        for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
        else d[j] = j << 1 ^ 0x11b;
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX = [
            [],
            [],
            [],
            []
        ];
        var INV_SUB_MIX = [
            [],
            [],
            [],
            []
        ];
        var x = 0;
        var xi = 0;
        for(var i = 0; i < 256; ++i){
            var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            SBOX[x] = sx;
            INV_SBOX[sx] = x;
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];
            var t = d[sx] * 0x101 ^ sx * 0x1010100;
            SUB_MIX[0][x] = t << 24 | t >>> 8;
            SUB_MIX[1][x] = t << 16 | t >>> 16;
            SUB_MIX[2][x] = t << 8 | t >>> 24;
            SUB_MIX[3][x] = t;
            t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
            INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
            INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
            INV_SUB_MIX[3][sx] = t;
            if (x === 0) x = xi = 1;
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
        return {
            SBOX: SBOX,
            INV_SBOX: INV_SBOX,
            SUB_MIX: SUB_MIX,
            INV_SUB_MIX: INV_SUB_MIX
        };
    }();
    function $c61ffa2be163e1f3$var$AES(key) {
        this._key = $c61ffa2be163e1f3$var$asUInt32Array(key);
        this._reset();
    }
    $c61ffa2be163e1f3$var$AES.blockSize = 16;
    $c61ffa2be163e1f3$var$AES.keySize = 32;
    $c61ffa2be163e1f3$var$AES.prototype.blockSize = $c61ffa2be163e1f3$var$AES.blockSize;
    $c61ffa2be163e1f3$var$AES.prototype.keySize = $c61ffa2be163e1f3$var$AES.keySize;
    $c61ffa2be163e1f3$var$AES.prototype._reset = function() {
        var keyWords = this._key;
        var keySize = keyWords.length;
        var nRounds = keySize + 6;
        var ksRows = (nRounds + 1) * 4;
        var keySchedule = [];
        for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
        for(k = keySize; k < ksRows; k++){
            var t = keySchedule[k - 1];
            if (k % keySize === 0) {
                t = t << 8 | t >>> 24;
                t = $c61ffa2be163e1f3$var$G.SBOX[t >>> 24] << 24 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c61ffa2be163e1f3$var$G.SBOX[t & 0xff];
                t ^= $c61ffa2be163e1f3$var$RCON[k / keySize | 0] << 24;
            } else if (keySize > 6 && k % keySize === 4) t = $c61ffa2be163e1f3$var$G.SBOX[t >>> 24] << 24 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c61ffa2be163e1f3$var$G.SBOX[t & 0xff];
            keySchedule[k] = keySchedule[k - keySize] ^ t;
        }
        var invKeySchedule = [];
        for(var ik = 0; ik < ksRows; ik++){
            var ksR = ksRows - ik;
            var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
            if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
            else invKeySchedule[ik] = $c61ffa2be163e1f3$var$G.INV_SUB_MIX[0][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 24]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[1][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 16 & 0xff]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[2][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 8 & 0xff]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[3][$c61ffa2be163e1f3$var$G.SBOX[tt & 0xff]];
        }
        this._nRounds = nRounds;
        this._keySchedule = keySchedule;
        this._invKeySchedule = invKeySchedule;
    };
    $c61ffa2be163e1f3$var$AES.prototype.encryptBlockRaw = function(M) {
        M = $c61ffa2be163e1f3$var$asUInt32Array(M);
        return $c61ffa2be163e1f3$var$cryptBlock(M, this._keySchedule, $c61ffa2be163e1f3$var$G.SUB_MIX, $c61ffa2be163e1f3$var$G.SBOX, this._nRounds);
    };
    $c61ffa2be163e1f3$var$AES.prototype.encryptBlock = function(M) {
        var out = this.encryptBlockRaw(M);
        var buf = $c61ffa2be163e1f3$require$Buffer.allocUnsafe(16);
        buf.writeUInt32BE(out[0], 0);
        buf.writeUInt32BE(out[1], 4);
        buf.writeUInt32BE(out[2], 8);
        buf.writeUInt32BE(out[3], 12);
        return buf;
    };
    $c61ffa2be163e1f3$var$AES.prototype.decryptBlock = function(M) {
        M = $c61ffa2be163e1f3$var$asUInt32Array(M);
        var m1 = M[1];
        M[1] = M[3];
        M[3] = m1;
        var out = $c61ffa2be163e1f3$var$cryptBlock(M, this._invKeySchedule, $c61ffa2be163e1f3$var$G.INV_SUB_MIX, $c61ffa2be163e1f3$var$G.INV_SBOX, this._nRounds);
        var buf = $c61ffa2be163e1f3$require$Buffer.allocUnsafe(16);
        buf.writeUInt32BE(out[0], 0);
        buf.writeUInt32BE(out[3], 4);
        buf.writeUInt32BE(out[2], 8);
        buf.writeUInt32BE(out[1], 12);
        return buf;
    };
    $c61ffa2be163e1f3$var$AES.prototype.scrub = function() {
        $c61ffa2be163e1f3$var$scrubVec(this._keySchedule);
        $c61ffa2be163e1f3$var$scrubVec(this._invKeySchedule);
        $c61ffa2be163e1f3$var$scrubVec(this._key);
    };
    $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5 = $c61ffa2be163e1f3$var$AES;
});
parcelRegister("3wyrd", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $290f12eeb62fc0f2$require$Buffer = $Wth4q.Buffer;
    var $290f12eeb62fc0f2$var$ZEROES = $290f12eeb62fc0f2$require$Buffer.alloc(16, 0);
    function $290f12eeb62fc0f2$var$toArray(buf) {
        return [
            buf.readUInt32BE(0),
            buf.readUInt32BE(4),
            buf.readUInt32BE(8),
            buf.readUInt32BE(12)
        ];
    }
    function $290f12eeb62fc0f2$var$fromArray(out) {
        var buf = $290f12eeb62fc0f2$require$Buffer.allocUnsafe(16);
        buf.writeUInt32BE(out[0] >>> 0, 0);
        buf.writeUInt32BE(out[1] >>> 0, 4);
        buf.writeUInt32BE(out[2] >>> 0, 8);
        buf.writeUInt32BE(out[3] >>> 0, 12);
        return buf;
    }
    function $290f12eeb62fc0f2$var$GHASH(key) {
        this.h = key;
        this.state = $290f12eeb62fc0f2$require$Buffer.alloc(16, 0);
        this.cache = $290f12eeb62fc0f2$require$Buffer.allocUnsafe(0);
    }
    $290f12eeb62fc0f2$var$GHASH.prototype.ghash = function(block) {
        var i = -1;
        while(++i < block.length)this.state[i] ^= block[i];
        this._multiply();
    };
    $290f12eeb62fc0f2$var$GHASH.prototype._multiply = function() {
        var Vi = $290f12eeb62fc0f2$var$toArray(this.h);
        var Zi = [
            0,
            0,
            0,
            0
        ];
        var j, xi, lsbVi;
        var i = -1;
        while(++i < 128){
            xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
            if (xi) {
                Zi[0] ^= Vi[0];
                Zi[1] ^= Vi[1];
                Zi[2] ^= Vi[2];
                Zi[3] ^= Vi[3];
            }
            lsbVi = (Vi[3] & 1) !== 0;
            for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
            Vi[0] = Vi[0] >>> 1;
            if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
        }
        this.state = $290f12eeb62fc0f2$var$fromArray(Zi);
    };
    $290f12eeb62fc0f2$var$GHASH.prototype.update = function(buf) {
        this.cache = $290f12eeb62fc0f2$require$Buffer.concat([
            this.cache,
            buf
        ]);
        var chunk;
        while(this.cache.length >= 16){
            chunk = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            this.ghash(chunk);
        }
    };
    $290f12eeb62fc0f2$var$GHASH.prototype.final = function(abl, bl) {
        if (this.cache.length) this.ghash($290f12eeb62fc0f2$require$Buffer.concat([
            this.cache,
            $290f12eeb62fc0f2$var$ZEROES
        ], 16));
        this.ghash($290f12eeb62fc0f2$var$fromArray([
            0,
            abl,
            0,
            bl
        ]));
        return this.state;
    };
    module.exports = $290f12eeb62fc0f2$var$GHASH;
});
parcelRegister("ecK7f", function(module, exports) {
    var $h0C5b = parcelRequire("h0C5b");
    var $Wth4q = parcelRequire("Wth4q");
    var $a575f54f3a1f9ff7$require$Buffer = $Wth4q.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $v3bBu = parcelRequire("v3bBu");
    function $a575f54f3a1f9ff7$var$StreamCipher(mode, key, iv, decrypt) {
        $77fwb.call(this);
        this._cipher = new $h0C5b.AES(key);
        this._prev = $a575f54f3a1f9ff7$require$Buffer.from(iv);
        this._cache = $a575f54f3a1f9ff7$require$Buffer.allocUnsafe(0);
        this._secCache = $a575f54f3a1f9ff7$require$Buffer.allocUnsafe(0);
        this._decrypt = decrypt;
        this._mode = mode;
    }
    $v3bBu($a575f54f3a1f9ff7$var$StreamCipher, $77fwb);
    $a575f54f3a1f9ff7$var$StreamCipher.prototype._update = function(chunk) {
        return this._mode.encrypt(this, chunk, this._decrypt);
    };
    $a575f54f3a1f9ff7$var$StreamCipher.prototype._final = function() {
        this._cipher.scrub();
    };
    module.exports = $a575f54f3a1f9ff7$var$StreamCipher;
});
parcelRegister("55KiC", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $3b515579f6a05835$require$Buffer = $Wth4q.Buffer;
    var $8ZJxF = parcelRequire("8ZJxF");
    function $3b515579f6a05835$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
        if (!$3b515579f6a05835$require$Buffer.isBuffer(password)) password = $3b515579f6a05835$require$Buffer.from(password, 'binary');
        if (salt) {
            if (!$3b515579f6a05835$require$Buffer.isBuffer(salt)) salt = $3b515579f6a05835$require$Buffer.from(salt, 'binary');
            if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
        }
        var keyLen = keyBits / 8;
        var key = $3b515579f6a05835$require$Buffer.alloc(keyLen);
        var iv = $3b515579f6a05835$require$Buffer.alloc(ivLen || 0);
        var tmp = $3b515579f6a05835$require$Buffer.alloc(0);
        while(keyLen > 0 || ivLen > 0){
            var hash = new $8ZJxF();
            hash.update(tmp);
            hash.update(password);
            if (salt) hash.update(salt);
            tmp = hash.digest();
            var used = 0;
            if (keyLen > 0) {
                var keyStart = key.length - keyLen;
                used = Math.min(keyLen, tmp.length);
                tmp.copy(key, keyStart, 0, used);
                keyLen -= used;
            }
            if (used < tmp.length && ivLen > 0) {
                var ivStart = iv.length - ivLen;
                var length = Math.min(ivLen, tmp.length - used);
                tmp.copy(iv, ivStart, used, used + length);
                ivLen -= length;
            }
        }
        tmp.fill(0);
        return {
            key: key,
            iv: iv
        };
    }
    module.exports = $3b515579f6a05835$var$EVP_BytesToKey;
});
parcelRegister("i9P5q", function(module, exports) {
    $parcel$export(module.exports, "createDecipher", ()=>$d380b1fbce65edb7$export$12ada9414fbc594c, (v)=>$d380b1fbce65edb7$export$12ada9414fbc594c = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$d380b1fbce65edb7$export$36b6d6ef312eab39, (v)=>$d380b1fbce65edb7$export$36b6d6ef312eab39 = v);
    var $d380b1fbce65edb7$export$12ada9414fbc594c;
    var $d380b1fbce65edb7$export$36b6d6ef312eab39;
    var $dsL7z = parcelRequire("dsL7z");
    var $Wth4q = parcelRequire("Wth4q");
    var $d380b1fbce65edb7$require$Buffer = $Wth4q.Buffer;
    var $6WLno = parcelRequire("6WLno");
    var $ecK7f = parcelRequire("ecK7f");
    var $77fwb = parcelRequire("77fwb");
    var $h0C5b = parcelRequire("h0C5b");
    var $55KiC = parcelRequire("55KiC");
    var $v3bBu = parcelRequire("v3bBu");
    function $d380b1fbce65edb7$var$Decipher(mode, key, iv) {
        $77fwb.call(this);
        this._cache = new $d380b1fbce65edb7$var$Splitter();
        this._last = void 0;
        this._cipher = new $h0C5b.AES(key);
        this._prev = $d380b1fbce65edb7$require$Buffer.from(iv);
        this._mode = mode;
        this._autopadding = true;
    }
    $v3bBu($d380b1fbce65edb7$var$Decipher, $77fwb);
    $d380b1fbce65edb7$var$Decipher.prototype._update = function(data) {
        this._cache.add(data);
        var chunk;
        var thing;
        var out = [];
        while(chunk = this._cache.get(this._autopadding)){
            thing = this._mode.decrypt(this, chunk);
            out.push(thing);
        }
        return $d380b1fbce65edb7$require$Buffer.concat(out);
    };
    $d380b1fbce65edb7$var$Decipher.prototype._final = function() {
        var chunk = this._cache.flush();
        if (this._autopadding) return $d380b1fbce65edb7$var$unpad(this._mode.decrypt(this, chunk));
        else if (chunk) throw new Error('data not multiple of block length');
    };
    $d380b1fbce65edb7$var$Decipher.prototype.setAutoPadding = function(setTo) {
        this._autopadding = !!setTo;
        return this;
    };
    function $d380b1fbce65edb7$var$Splitter() {
        this.cache = $d380b1fbce65edb7$require$Buffer.allocUnsafe(0);
    }
    $d380b1fbce65edb7$var$Splitter.prototype.add = function(data) {
        this.cache = $d380b1fbce65edb7$require$Buffer.concat([
            this.cache,
            data
        ]);
    };
    $d380b1fbce65edb7$var$Splitter.prototype.get = function(autoPadding) {
        var out;
        if (autoPadding) {
            if (this.cache.length > 16) {
                out = this.cache.slice(0, 16);
                this.cache = this.cache.slice(16);
                return out;
            }
        } else if (this.cache.length >= 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
        return null;
    };
    $d380b1fbce65edb7$var$Splitter.prototype.flush = function() {
        if (this.cache.length) return this.cache;
    };
    function $d380b1fbce65edb7$var$unpad(last) {
        var padded = last[15];
        if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
        var i = -1;
        while(++i < padded){
            if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
        }
        if (padded === 16) return;
        return last.slice(0, 16 - padded);
    }
    function $d380b1fbce65edb7$var$createDecipheriv(suite, password, iv) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        if (typeof iv === 'string') iv = $d380b1fbce65edb7$require$Buffer.from(iv);
        if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
        if (typeof password === 'string') password = $d380b1fbce65edb7$require$Buffer.from(password);
        if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
        if (config.type === 'stream') return new $ecK7f(config.module, password, iv, true);
        else if (config.type === 'auth') return new $dsL7z(config.module, password, iv, true);
        return new $d380b1fbce65edb7$var$Decipher(config.module, password, iv);
    }
    function $d380b1fbce65edb7$var$createDecipher(suite, password) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, config.key, config.iv);
        return $d380b1fbce65edb7$var$createDecipheriv(suite, keys.key, keys.iv);
    }
    $d380b1fbce65edb7$export$12ada9414fbc594c = $d380b1fbce65edb7$var$createDecipher;
    $d380b1fbce65edb7$export$36b6d6ef312eab39 = $d380b1fbce65edb7$var$createDecipheriv;
});
parcelRegister("dQ4TD", function(module, exports) {
    $parcel$export(module.exports, "des-ecb", ()=>$a133ee05e0543499$export$116f8a5cee447347, (v)=>$a133ee05e0543499$export$116f8a5cee447347 = v);
    $parcel$export(module.exports, "des-cbc", ()=>$a133ee05e0543499$export$7483c4066bfb7ae9, (v)=>$a133ee05e0543499$export$7483c4066bfb7ae9 = v);
    $parcel$export(module.exports, "des", ()=>$a133ee05e0543499$export$e7a565d2e588bb06, (v)=>$a133ee05e0543499$export$e7a565d2e588bb06 = v);
    $parcel$export(module.exports, "des-ede3-cbc", ()=>$a133ee05e0543499$export$aaa2f54a426f3eb8, (v)=>$a133ee05e0543499$export$aaa2f54a426f3eb8 = v);
    $parcel$export(module.exports, "des3", ()=>$a133ee05e0543499$export$eba20568dde4ada, (v)=>$a133ee05e0543499$export$eba20568dde4ada = v);
    $parcel$export(module.exports, "des-ede3", ()=>$a133ee05e0543499$export$d3b5e5996938f5ae, (v)=>$a133ee05e0543499$export$d3b5e5996938f5ae = v);
    $parcel$export(module.exports, "des-ede-cbc", ()=>$a133ee05e0543499$export$57c08356130bc99b, (v)=>$a133ee05e0543499$export$57c08356130bc99b = v);
    $parcel$export(module.exports, "des-ede", ()=>$a133ee05e0543499$export$c7169791d5c1e65d, (v)=>$a133ee05e0543499$export$c7169791d5c1e65d = v);
    var $a133ee05e0543499$export$116f8a5cee447347;
    var $a133ee05e0543499$export$7483c4066bfb7ae9;
    var $a133ee05e0543499$export$e7a565d2e588bb06;
    var $a133ee05e0543499$export$aaa2f54a426f3eb8;
    var $a133ee05e0543499$export$eba20568dde4ada;
    var $a133ee05e0543499$export$d3b5e5996938f5ae;
    var $a133ee05e0543499$export$57c08356130bc99b;
    var $a133ee05e0543499$export$c7169791d5c1e65d;
    $a133ee05e0543499$export$116f8a5cee447347 = {
        key: 8,
        iv: 0
    };
    $a133ee05e0543499$export$7483c4066bfb7ae9 = $a133ee05e0543499$export$e7a565d2e588bb06 = {
        key: 8,
        iv: 8
    };
    $a133ee05e0543499$export$aaa2f54a426f3eb8 = $a133ee05e0543499$export$eba20568dde4ada = {
        key: 24,
        iv: 8
    };
    $a133ee05e0543499$export$d3b5e5996938f5ae = {
        key: 24,
        iv: 0
    };
    $a133ee05e0543499$export$57c08356130bc99b = {
        key: 16,
        iv: 8
    };
    $a133ee05e0543499$export$c7169791d5c1e65d = {
        key: 16,
        iv: 0
    };
});
parcelRegister("ilRwV", function(module, exports) {
    $parcel$export(module.exports, "DiffieHellmanGroup", ()=>$d5c3b620b637e62c$export$971862a2fcb1bb40, (v)=>$d5c3b620b637e62c$export$971862a2fcb1bb40 = v);
    $parcel$export(module.exports, "createDiffieHellmanGroup", ()=>$d5c3b620b637e62c$export$c6ff6a88acbeaf40, (v)=>$d5c3b620b637e62c$export$c6ff6a88acbeaf40 = v);
    $parcel$export(module.exports, "getDiffieHellman", ()=>$d5c3b620b637e62c$export$fdc27893e98845cc, (v)=>$d5c3b620b637e62c$export$fdc27893e98845cc = v);
    $parcel$export(module.exports, "createDiffieHellman", ()=>$d5c3b620b637e62c$export$6671fb9a1323bed, (v)=>$d5c3b620b637e62c$export$6671fb9a1323bed = v);
    $parcel$export(module.exports, "DiffieHellman", ()=>$d5c3b620b637e62c$export$d74daf141a551db, (v)=>$d5c3b620b637e62c$export$d74daf141a551db = v);
    var $d5c3b620b637e62c$export$971862a2fcb1bb40;
    var $d5c3b620b637e62c$export$c6ff6a88acbeaf40;
    var $d5c3b620b637e62c$export$fdc27893e98845cc;
    var $d5c3b620b637e62c$export$6671fb9a1323bed;
    var $d5c3b620b637e62c$export$d74daf141a551db;
    var $5k7LC = parcelRequire("5k7LC");
    var $d5c3b620b637e62c$require$Buffer = $5k7LC.Buffer;
    var $iQ4lm = parcelRequire("iQ4lm");
    var $9TmmS = parcelRequire("9TmmS");
    var $9UDry = parcelRequire("9UDry");
    function $d5c3b620b637e62c$var$getDiffieHellman(mod) {
        var prime = new $d5c3b620b637e62c$require$Buffer($9TmmS[mod].prime, 'hex');
        var gen = new $d5c3b620b637e62c$require$Buffer($9TmmS[mod].gen, 'hex');
        return new $9UDry(prime, gen);
    }
    var $d5c3b620b637e62c$var$ENCODINGS = {
        'binary': true,
        'hex': true,
        'base64': true
    };
    function $d5c3b620b637e62c$var$createDiffieHellman(prime, enc, generator, genc) {
        if ($d5c3b620b637e62c$require$Buffer.isBuffer(enc) || $d5c3b620b637e62c$var$ENCODINGS[enc] === undefined) return $d5c3b620b637e62c$var$createDiffieHellman(prime, 'binary', enc, generator);
        enc = enc || 'binary';
        genc = genc || 'binary';
        generator = generator || new $d5c3b620b637e62c$require$Buffer([
            2
        ]);
        if (!$d5c3b620b637e62c$require$Buffer.isBuffer(generator)) generator = new $d5c3b620b637e62c$require$Buffer(generator, genc);
        if (typeof prime === 'number') return new $9UDry($iQ4lm(prime, generator), generator, true);
        if (!$d5c3b620b637e62c$require$Buffer.isBuffer(prime)) prime = new $d5c3b620b637e62c$require$Buffer(prime, enc);
        return new $9UDry(prime, generator, true);
    }
    $d5c3b620b637e62c$export$971862a2fcb1bb40 = $d5c3b620b637e62c$export$c6ff6a88acbeaf40 = $d5c3b620b637e62c$export$fdc27893e98845cc = $d5c3b620b637e62c$var$getDiffieHellman;
    $d5c3b620b637e62c$export$6671fb9a1323bed = $d5c3b620b637e62c$export$d74daf141a551db = $d5c3b620b637e62c$var$createDiffieHellman;
});
parcelRegister("iQ4lm", function(module, exports) {
    var $1DyI6 = parcelRequire("1DyI6");
    module.exports = $db7073d92ed84da3$var$findPrime;
    $db7073d92ed84da3$var$findPrime.simpleSieve = $db7073d92ed84da3$var$simpleSieve;
    $db7073d92ed84da3$var$findPrime.fermatTest = $db7073d92ed84da3$var$fermatTest;
    var $9pbIC = parcelRequire("9pbIC");
    var $db7073d92ed84da3$var$TWENTYFOUR = new $9pbIC(24);
    var $j2pYc = parcelRequire("j2pYc");
    var $db7073d92ed84da3$var$millerRabin = new $j2pYc();
    var $db7073d92ed84da3$var$ONE = new $9pbIC(1);
    var $db7073d92ed84da3$var$TWO = new $9pbIC(2);
    var $db7073d92ed84da3$var$FIVE = new $9pbIC(5);
    var $db7073d92ed84da3$var$SIXTEEN = new $9pbIC(16);
    var $db7073d92ed84da3$var$EIGHT = new $9pbIC(8);
    var $db7073d92ed84da3$var$TEN = new $9pbIC(10);
    var $db7073d92ed84da3$var$THREE = new $9pbIC(3);
    var $db7073d92ed84da3$var$SEVEN = new $9pbIC(7);
    var $db7073d92ed84da3$var$ELEVEN = new $9pbIC(11);
    var $db7073d92ed84da3$var$FOUR = new $9pbIC(4);
    var $db7073d92ed84da3$var$TWELVE = new $9pbIC(12);
    var $db7073d92ed84da3$var$primes = null;
    function $db7073d92ed84da3$var$_getPrimes() {
        if ($db7073d92ed84da3$var$primes !== null) return $db7073d92ed84da3$var$primes;
        var limit = 0x100000;
        var res = [];
        res[0] = 2;
        for(var i = 1, k = 3; k < limit; k += 2){
            var sqrt = Math.ceil(Math.sqrt(k));
            for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
            if (i !== j && res[j] <= sqrt) continue;
            res[i++] = k;
        }
        $db7073d92ed84da3$var$primes = res;
        return res;
    }
    function $db7073d92ed84da3$var$simpleSieve(p) {
        var primes = $db7073d92ed84da3$var$_getPrimes();
        for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
            if (p.cmpn(primes[i]) === 0) return true;
            else return false;
        }
        return true;
    }
    function $db7073d92ed84da3$var$fermatTest(p) {
        var red = $9pbIC.mont(p);
        return $db7073d92ed84da3$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
    }
    function $db7073d92ed84da3$var$findPrime(bits, gen) {
        if (bits < 16) {
            if (gen === 2 || gen === 5) return new $9pbIC([
                0x8c,
                0x7b
            ]);
            else return new $9pbIC([
                0x8c,
                0x27
            ]);
        }
        gen = new $9pbIC(gen);
        var num, n2;
        while(true){
            num = new $9pbIC($1DyI6(Math.ceil(bits / 8)));
            while(num.bitLength() > bits)num.ishrn(1);
            if (num.isEven()) num.iadd($db7073d92ed84da3$var$ONE);
            if (!num.testn(1)) num.iadd($db7073d92ed84da3$var$TWO);
            if (!gen.cmp($db7073d92ed84da3$var$TWO)) while(num.mod($db7073d92ed84da3$var$TWENTYFOUR).cmp($db7073d92ed84da3$var$ELEVEN))num.iadd($db7073d92ed84da3$var$FOUR);
            else if (!gen.cmp($db7073d92ed84da3$var$FIVE)) while(num.mod($db7073d92ed84da3$var$TEN).cmp($db7073d92ed84da3$var$THREE))num.iadd($db7073d92ed84da3$var$FOUR);
            n2 = num.shrn(1);
            if ($db7073d92ed84da3$var$simpleSieve(n2) && $db7073d92ed84da3$var$simpleSieve(num) && $db7073d92ed84da3$var$fermatTest(n2) && $db7073d92ed84da3$var$fermatTest(num) && $db7073d92ed84da3$var$millerRabin.test(n2) && $db7073d92ed84da3$var$millerRabin.test(num)) return num;
        }
    }
});
parcelRegister("9pbIC", function(module, exports) {
    (function(module1, exports) {
        'use strict';
        function assert(val, msg) {
            if (!val) throw new Error(msg || 'Assertion failed');
        }
        function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
        function BN(number, base, endian) {
            if (BN.isBN(number)) return number;
            this.negative = 0;
            this.words = null;
            this.length = 0;
            this.red = null;
            if (number !== null) {
                if (base === 'le' || base === 'be') {
                    endian = base;
                    base = 10;
                }
                this._init(number || 0, base || 10, endian || 'be');
            }
        }
        if (typeof module1 === 'object') module1.exports = BN;
        else exports.BN = BN;
        BN.BN = BN;
        BN.wordSize = 26;
        var Buffer;
        try {
            if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
            else Buffer = (parcelRequire("3gWwf")).Buffer;
        } catch (e) {}
        BN.isBN = function isBN(num) {
            if (num instanceof BN) return true;
            return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };
        BN.max = function max(left, right) {
            if (left.cmp(right) > 0) return left;
            return right;
        };
        BN.min = function min(left, right) {
            if (left.cmp(right) < 0) return left;
            return right;
        };
        BN.prototype._init = function init(number, base, endian) {
            if (typeof number === 'number') return this._initNumber(number, base, endian);
            if (typeof number === 'object') return this._initArray(number, base, endian);
            if (base === 'hex') base = 16;
            assert(base === (base | 0) && base >= 2 && base <= 36);
            number = number.toString().replace(/\s+/g, '');
            var start = 0;
            if (number[0] === '-') {
                start++;
                this.negative = 1;
            }
            if (start < number.length) {
                if (base === 16) this._parseHex(number, start, endian);
                else {
                    this._parseBase(number, base, start);
                    if (endian === 'le') this._initArray(this.toArray(), base, endian);
                }
            }
        };
        BN.prototype._initNumber = function _initNumber(number, base, endian) {
            if (number < 0) {
                this.negative = 1;
                number = -number;
            }
            if (number < 0x4000000) {
                this.words = [
                    number & 0x3ffffff
                ];
                this.length = 1;
            } else if (number < 0x10000000000000) {
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff
                ];
                this.length = 2;
            } else {
                assert(number < 0x20000000000000);
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff,
                    1
                ];
                this.length = 3;
            }
            if (endian !== 'le') return;
            this._initArray(this.toArray(), base, endian);
        };
        BN.prototype._initArray = function _initArray(number, base, endian) {
            assert(typeof number.length === 'number');
            if (number.length <= 0) {
                this.words = [
                    0
                ];
                this.length = 1;
                return this;
            }
            this.length = Math.ceil(number.length / 3);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var j, w;
            var off = 0;
            if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            return this.strip();
        };
        function parseHex4Bits(string, index) {
            var c = string.charCodeAt(index);
            if (c >= 65 && c <= 70) return c - 55;
            else if (c >= 97 && c <= 102) return c - 87;
            else return c - 48 & 0xf;
        }
        function parseHexByte(string, lowerBound, index) {
            var r = parseHex4Bits(string, index);
            if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
            return r;
        }
        BN.prototype._parseHex = function _parseHex(number, start, endian) {
            this.length = Math.ceil((number.length - start) / 6);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var off = 0;
            var j = 0;
            var w;
            if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
            else {
                var parseLength = number.length - start;
                for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                    w = parseHexByte(number, start, i) << off;
                    this.words[j] |= w & 0x3ffffff;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
            }
            this.strip();
        };
        function parseBase(str, start, end, mul) {
            var r = 0;
            var len = Math.min(str.length, end);
            for(var i = start; i < len; i++){
                var c = str.charCodeAt(i) - 48;
                r *= mul;
                if (c >= 49) r += c - 49 + 0xa;
                else if (c >= 17) r += c - 17 + 0xa;
                else r += c;
            }
            return r;
        }
        BN.prototype._parseBase = function _parseBase(number, base, start) {
            this.words = [
                0
            ];
            this.length = 1;
            for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
            limbLen--;
            limbPow = limbPow / base | 0;
            var total = number.length - start;
            var mod = total % limbLen;
            var end = Math.min(total, total - mod) + start;
            var word = 0;
            for(var i = start; i < end; i += limbLen){
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for(i = 0; i < mod; i++)pow *= base;
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            this.strip();
        };
        BN.prototype.copy = function copy(dest) {
            dest.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
            dest.length = this.length;
            dest.negative = this.negative;
            dest.red = this.red;
        };
        BN.prototype.clone = function clone() {
            var r = new BN(null);
            this.copy(r);
            return r;
        };
        BN.prototype._expand = function _expand(size) {
            while(this.length < size)this.words[this.length++] = 0;
            return this;
        };
        BN.prototype.strip = function strip() {
            while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
            return this._normSign();
        };
        BN.prototype._normSign = function _normSign() {
            if (this.length === 1 && this.words[0] === 0) this.negative = 0;
            return this;
        };
        BN.prototype.inspect = function inspect() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        };
        var zeros = [
            '',
            '0',
            '00',
            '000',
            '0000',
            '00000',
            '000000',
            '0000000',
            '00000000',
            '000000000',
            '0000000000',
            '00000000000',
            '000000000000',
            '0000000000000',
            '00000000000000',
            '000000000000000',
            '0000000000000000',
            '00000000000000000',
            '000000000000000000',
            '0000000000000000000',
            '00000000000000000000',
            '000000000000000000000',
            '0000000000000000000000',
            '00000000000000000000000',
            '000000000000000000000000',
            '0000000000000000000000000'
        ];
        var groupSizes = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ];
        var groupBases = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            10000000,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64000000,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            24300000,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        BN.prototype.toString = function toString(base, padding) {
            base = base || 10;
            padding = padding | 0 || 1;
            var out;
            if (base === 16 || base === 'hex') {
                out = '';
                var off = 0;
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = this.words[i];
                    var word = ((w << off | carry) & 0xffffff).toString(16);
                    carry = w >>> 24 - off & 0xffffff;
                    off += 2;
                    if (off >= 26) {
                        off -= 26;
                        i--;
                    }
                    if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                    else out = word + out;
                }
                if (carry !== 0) out = carry.toString(16) + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            if (base === (base | 0) && base >= 2 && base <= 36) {
                var groupSize = groupSizes[base];
                var groupBase = groupBases[base];
                out = '';
                var c = this.clone();
                c.negative = 0;
                while(!c.isZero()){
                    var r = c.modn(groupBase).toString(base);
                    c = c.idivn(groupBase);
                    if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                    else out = r + out;
                }
                if (this.isZero()) out = '0' + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            assert(false, 'Base should be between 2 and 36');
        };
        BN.prototype.toNumber = function toNumber() {
            var ret = this.words[0];
            if (this.length === 2) ret += this.words[1] * 0x4000000;
            else if (this.length === 3 && this.words[2] === 0x01) ret += 0x10000000000000 + this.words[1] * 0x4000000;
            else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
            return this.negative !== 0 ? -ret : ret;
        };
        BN.prototype.toJSON = function toJSON() {
            return this.toString(16);
        };
        BN.prototype.toBuffer = function toBuffer(endian, length) {
            assert(typeof Buffer !== 'undefined');
            return this.toArrayLike(Buffer, endian, length);
        };
        BN.prototype.toArray = function toArray(endian, length) {
            return this.toArrayLike(Array, endian, length);
        };
        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
            var byteLength = this.byteLength();
            var reqLength = length || Math.max(1, byteLength);
            assert(byteLength <= reqLength, 'byte array longer than desired length');
            assert(reqLength > 0, 'Requested array length <= 0');
            this.strip();
            var littleEndian = endian === 'le';
            var res = new ArrayType(reqLength);
            var b, i;
            var q = this.clone();
            if (!littleEndian) {
                for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
                for(i = 0; !q.isZero(); i++){
                    b = q.andln(0xff);
                    q.iushrn(8);
                    res[reqLength - i - 1] = b;
                }
            } else {
                for(i = 0; !q.isZero(); i++){
                    b = q.andln(0xff);
                    q.iushrn(8);
                    res[i] = b;
                }
                for(; i < reqLength; i++)res[i] = 0;
            }
            return res;
        };
        if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
        };
        else BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
                r += 13;
                t >>>= 13;
            }
            if (t >= 0x40) {
                r += 7;
                t >>>= 7;
            }
            if (t >= 0x8) {
                r += 4;
                t >>>= 4;
            }
            if (t >= 0x02) {
                r += 2;
                t >>>= 2;
            }
            return r + t;
        };
        BN.prototype._zeroBits = function _zeroBits(w) {
            if (w === 0) return 26;
            var t = w;
            var r = 0;
            if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
            }
            if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
            }
            if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
            }
            if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
            }
            if ((t & 0x1) === 0) r++;
            return r;
        };
        BN.prototype.bitLength = function bitLength() {
            var w = this.words[this.length - 1];
            var hi = this._countBits(w);
            return (this.length - 1) * 26 + hi;
        };
        function toBitArray(num) {
            var w = new Array(num.bitLength());
            for(var bit = 0; bit < w.length; bit++){
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
            }
            return w;
        }
        BN.prototype.zeroBits = function zeroBits() {
            if (this.isZero()) return 0;
            var r = 0;
            for(var i = 0; i < this.length; i++){
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
            }
            return r;
        };
        BN.prototype.byteLength = function byteLength() {
            return Math.ceil(this.bitLength() / 8);
        };
        BN.prototype.toTwos = function toTwos(width) {
            if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
            return this.clone();
        };
        BN.prototype.fromTwos = function fromTwos(width) {
            if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
            return this.clone();
        };
        BN.prototype.isNeg = function isNeg() {
            return this.negative !== 0;
        };
        BN.prototype.neg = function neg() {
            return this.clone().ineg();
        };
        BN.prototype.ineg = function ineg() {
            if (!this.isZero()) this.negative ^= 1;
            return this;
        };
        BN.prototype.iuor = function iuor(num) {
            while(this.length < num.length)this.words[this.length++] = 0;
            for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
            return this.strip();
        };
        BN.prototype.ior = function ior(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuor(num);
        };
        BN.prototype.or = function or(num) {
            if (this.length > num.length) return this.clone().ior(num);
            return num.clone().ior(this);
        };
        BN.prototype.uor = function uor(num) {
            if (this.length > num.length) return this.clone().iuor(num);
            return num.clone().iuor(this);
        };
        BN.prototype.iuand = function iuand(num) {
            var b;
            if (this.length > num.length) b = num;
            else b = this;
            for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
            this.length = b.length;
            return this.strip();
        };
        BN.prototype.iand = function iand(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuand(num);
        };
        BN.prototype.and = function and(num) {
            if (this.length > num.length) return this.clone().iand(num);
            return num.clone().iand(this);
        };
        BN.prototype.uand = function uand(num) {
            if (this.length > num.length) return this.clone().iuand(num);
            return num.clone().iuand(this);
        };
        BN.prototype.iuxor = function iuxor(num) {
            var a;
            var b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
            if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = a.length;
            return this.strip();
        };
        BN.prototype.ixor = function ixor(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuxor(num);
        };
        BN.prototype.xor = function xor(num) {
            if (this.length > num.length) return this.clone().ixor(num);
            return num.clone().ixor(this);
        };
        BN.prototype.uxor = function uxor(num) {
            if (this.length > num.length) return this.clone().iuxor(num);
            return num.clone().iuxor(this);
        };
        BN.prototype.inotn = function inotn(width) {
            assert(typeof width === 'number' && width >= 0);
            var bytesNeeded = Math.ceil(width / 26) | 0;
            var bitsLeft = width % 26;
            this._expand(bytesNeeded);
            if (bitsLeft > 0) bytesNeeded--;
            for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
            if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            return this.strip();
        };
        BN.prototype.notn = function notn(width) {
            return this.clone().inotn(width);
        };
        BN.prototype.setn = function setn(bit, val) {
            assert(typeof bit === 'number' && bit >= 0);
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            this._expand(off + 1);
            if (val) this.words[off] = this.words[off] | 1 << wbit;
            else this.words[off] = this.words[off] & ~(1 << wbit);
            return this.strip();
        };
        BN.prototype.iadd = function iadd(num) {
            var r;
            if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign();
            } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
            }
            var a, b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            this.length = a.length;
            if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++;
            } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            return this;
        };
        BN.prototype.add = function add(num) {
            var res;
            if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
            } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
            }
            if (this.length > num.length) return this.clone().iadd(num);
            return num.clone().iadd(this);
        };
        BN.prototype.isub = function isub(num) {
            if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign();
            } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
            }
            var cmp = this.cmp(num);
            if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
            }
            var a, b;
            if (cmp > 0) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = Math.max(this.length, i);
            if (a !== this) this.negative = 1;
            return this.strip();
        };
        BN.prototype.sub = function sub(num) {
            return this.clone().isub(num);
        };
        function smallMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            var len = self.length + num.length | 0;
            out.length = len;
            len = len - 1 | 0;
            var a = self.words[0] | 0;
            var b = num.words[0] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            var carry = r / 0x4000000 | 0;
            out.words[0] = lo;
            for(var k = 1; k < len; k++){
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j | 0;
                    a = self.words[i] | 0;
                    b = num.words[j] | 0;
                    r = a * b + rword;
                    ncarry += r / 0x4000000 | 0;
                    rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
            }
            if (carry !== 0) out.words[k] = carry | 0;
            else out.length--;
            return out.strip();
        }
        var comb10MulTo = function comb10MulTo(self, num, out) {
            var a = self.words;
            var b = num.words;
            var o = out.words;
            var c = 0;
            var lo;
            var mid;
            var hi;
            var a0 = a[0] | 0;
            var al0 = a0 & 0x1fff;
            var ah0 = a0 >>> 13;
            var a1 = a[1] | 0;
            var al1 = a1 & 0x1fff;
            var ah1 = a1 >>> 13;
            var a2 = a[2] | 0;
            var al2 = a2 & 0x1fff;
            var ah2 = a2 >>> 13;
            var a3 = a[3] | 0;
            var al3 = a3 & 0x1fff;
            var ah3 = a3 >>> 13;
            var a4 = a[4] | 0;
            var al4 = a4 & 0x1fff;
            var ah4 = a4 >>> 13;
            var a5 = a[5] | 0;
            var al5 = a5 & 0x1fff;
            var ah5 = a5 >>> 13;
            var a6 = a[6] | 0;
            var al6 = a6 & 0x1fff;
            var ah6 = a6 >>> 13;
            var a7 = a[7] | 0;
            var al7 = a7 & 0x1fff;
            var ah7 = a7 >>> 13;
            var a8 = a[8] | 0;
            var al8 = a8 & 0x1fff;
            var ah8 = a8 >>> 13;
            var a9 = a[9] | 0;
            var al9 = a9 & 0x1fff;
            var ah9 = a9 >>> 13;
            var b0 = b[0] | 0;
            var bl0 = b0 & 0x1fff;
            var bh0 = b0 >>> 13;
            var b1 = b[1] | 0;
            var bl1 = b1 & 0x1fff;
            var bh1 = b1 >>> 13;
            var b2 = b[2] | 0;
            var bl2 = b2 & 0x1fff;
            var bh2 = b2 >>> 13;
            var b3 = b[3] | 0;
            var bl3 = b3 & 0x1fff;
            var bh3 = b3 >>> 13;
            var b4 = b[4] | 0;
            var bl4 = b4 & 0x1fff;
            var bh4 = b4 >>> 13;
            var b5 = b[5] | 0;
            var bl5 = b5 & 0x1fff;
            var bh5 = b5 >>> 13;
            var b6 = b[6] | 0;
            var bl6 = b6 & 0x1fff;
            var bh6 = b6 >>> 13;
            var b7 = b[7] | 0;
            var bl7 = b7 & 0x1fff;
            var bh7 = b7 >>> 13;
            var b8 = b[8] | 0;
            var bl8 = b8 & 0x1fff;
            var bh8 = b8 >>> 13;
            var b9 = b[9] | 0;
            var bl9 = b9 & 0x1fff;
            var bh9 = b9 >>> 13;
            out.negative = self.negative ^ num.negative;
            out.length = 19;
            lo = Math.imul(al0, bl0);
            mid = Math.imul(al0, bh0);
            mid = mid + Math.imul(ah0, bl0) | 0;
            hi = Math.imul(ah0, bh0);
            var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
            w0 &= 0x3ffffff;
            lo = Math.imul(al1, bl0);
            mid = Math.imul(al1, bh0);
            mid = mid + Math.imul(ah1, bl0) | 0;
            hi = Math.imul(ah1, bh0);
            lo = lo + Math.imul(al0, bl1) | 0;
            mid = mid + Math.imul(al0, bh1) | 0;
            mid = mid + Math.imul(ah0, bl1) | 0;
            hi = hi + Math.imul(ah0, bh1) | 0;
            var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
            w1 &= 0x3ffffff;
            lo = Math.imul(al2, bl0);
            mid = Math.imul(al2, bh0);
            mid = mid + Math.imul(ah2, bl0) | 0;
            hi = Math.imul(ah2, bh0);
            lo = lo + Math.imul(al1, bl1) | 0;
            mid = mid + Math.imul(al1, bh1) | 0;
            mid = mid + Math.imul(ah1, bl1) | 0;
            hi = hi + Math.imul(ah1, bh1) | 0;
            lo = lo + Math.imul(al0, bl2) | 0;
            mid = mid + Math.imul(al0, bh2) | 0;
            mid = mid + Math.imul(ah0, bl2) | 0;
            hi = hi + Math.imul(ah0, bh2) | 0;
            var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
            w2 &= 0x3ffffff;
            lo = Math.imul(al3, bl0);
            mid = Math.imul(al3, bh0);
            mid = mid + Math.imul(ah3, bl0) | 0;
            hi = Math.imul(ah3, bh0);
            lo = lo + Math.imul(al2, bl1) | 0;
            mid = mid + Math.imul(al2, bh1) | 0;
            mid = mid + Math.imul(ah2, bl1) | 0;
            hi = hi + Math.imul(ah2, bh1) | 0;
            lo = lo + Math.imul(al1, bl2) | 0;
            mid = mid + Math.imul(al1, bh2) | 0;
            mid = mid + Math.imul(ah1, bl2) | 0;
            hi = hi + Math.imul(ah1, bh2) | 0;
            lo = lo + Math.imul(al0, bl3) | 0;
            mid = mid + Math.imul(al0, bh3) | 0;
            mid = mid + Math.imul(ah0, bl3) | 0;
            hi = hi + Math.imul(ah0, bh3) | 0;
            var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
            w3 &= 0x3ffffff;
            lo = Math.imul(al4, bl0);
            mid = Math.imul(al4, bh0);
            mid = mid + Math.imul(ah4, bl0) | 0;
            hi = Math.imul(ah4, bh0);
            lo = lo + Math.imul(al3, bl1) | 0;
            mid = mid + Math.imul(al3, bh1) | 0;
            mid = mid + Math.imul(ah3, bl1) | 0;
            hi = hi + Math.imul(ah3, bh1) | 0;
            lo = lo + Math.imul(al2, bl2) | 0;
            mid = mid + Math.imul(al2, bh2) | 0;
            mid = mid + Math.imul(ah2, bl2) | 0;
            hi = hi + Math.imul(ah2, bh2) | 0;
            lo = lo + Math.imul(al1, bl3) | 0;
            mid = mid + Math.imul(al1, bh3) | 0;
            mid = mid + Math.imul(ah1, bl3) | 0;
            hi = hi + Math.imul(ah1, bh3) | 0;
            lo = lo + Math.imul(al0, bl4) | 0;
            mid = mid + Math.imul(al0, bh4) | 0;
            mid = mid + Math.imul(ah0, bl4) | 0;
            hi = hi + Math.imul(ah0, bh4) | 0;
            var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
            w4 &= 0x3ffffff;
            lo = Math.imul(al5, bl0);
            mid = Math.imul(al5, bh0);
            mid = mid + Math.imul(ah5, bl0) | 0;
            hi = Math.imul(ah5, bh0);
            lo = lo + Math.imul(al4, bl1) | 0;
            mid = mid + Math.imul(al4, bh1) | 0;
            mid = mid + Math.imul(ah4, bl1) | 0;
            hi = hi + Math.imul(ah4, bh1) | 0;
            lo = lo + Math.imul(al3, bl2) | 0;
            mid = mid + Math.imul(al3, bh2) | 0;
            mid = mid + Math.imul(ah3, bl2) | 0;
            hi = hi + Math.imul(ah3, bh2) | 0;
            lo = lo + Math.imul(al2, bl3) | 0;
            mid = mid + Math.imul(al2, bh3) | 0;
            mid = mid + Math.imul(ah2, bl3) | 0;
            hi = hi + Math.imul(ah2, bh3) | 0;
            lo = lo + Math.imul(al1, bl4) | 0;
            mid = mid + Math.imul(al1, bh4) | 0;
            mid = mid + Math.imul(ah1, bl4) | 0;
            hi = hi + Math.imul(ah1, bh4) | 0;
            lo = lo + Math.imul(al0, bl5) | 0;
            mid = mid + Math.imul(al0, bh5) | 0;
            mid = mid + Math.imul(ah0, bl5) | 0;
            hi = hi + Math.imul(ah0, bh5) | 0;
            var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
            w5 &= 0x3ffffff;
            lo = Math.imul(al6, bl0);
            mid = Math.imul(al6, bh0);
            mid = mid + Math.imul(ah6, bl0) | 0;
            hi = Math.imul(ah6, bh0);
            lo = lo + Math.imul(al5, bl1) | 0;
            mid = mid + Math.imul(al5, bh1) | 0;
            mid = mid + Math.imul(ah5, bl1) | 0;
            hi = hi + Math.imul(ah5, bh1) | 0;
            lo = lo + Math.imul(al4, bl2) | 0;
            mid = mid + Math.imul(al4, bh2) | 0;
            mid = mid + Math.imul(ah4, bl2) | 0;
            hi = hi + Math.imul(ah4, bh2) | 0;
            lo = lo + Math.imul(al3, bl3) | 0;
            mid = mid + Math.imul(al3, bh3) | 0;
            mid = mid + Math.imul(ah3, bl3) | 0;
            hi = hi + Math.imul(ah3, bh3) | 0;
            lo = lo + Math.imul(al2, bl4) | 0;
            mid = mid + Math.imul(al2, bh4) | 0;
            mid = mid + Math.imul(ah2, bl4) | 0;
            hi = hi + Math.imul(ah2, bh4) | 0;
            lo = lo + Math.imul(al1, bl5) | 0;
            mid = mid + Math.imul(al1, bh5) | 0;
            mid = mid + Math.imul(ah1, bl5) | 0;
            hi = hi + Math.imul(ah1, bh5) | 0;
            lo = lo + Math.imul(al0, bl6) | 0;
            mid = mid + Math.imul(al0, bh6) | 0;
            mid = mid + Math.imul(ah0, bl6) | 0;
            hi = hi + Math.imul(ah0, bh6) | 0;
            var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
            w6 &= 0x3ffffff;
            lo = Math.imul(al7, bl0);
            mid = Math.imul(al7, bh0);
            mid = mid + Math.imul(ah7, bl0) | 0;
            hi = Math.imul(ah7, bh0);
            lo = lo + Math.imul(al6, bl1) | 0;
            mid = mid + Math.imul(al6, bh1) | 0;
            mid = mid + Math.imul(ah6, bl1) | 0;
            hi = hi + Math.imul(ah6, bh1) | 0;
            lo = lo + Math.imul(al5, bl2) | 0;
            mid = mid + Math.imul(al5, bh2) | 0;
            mid = mid + Math.imul(ah5, bl2) | 0;
            hi = hi + Math.imul(ah5, bh2) | 0;
            lo = lo + Math.imul(al4, bl3) | 0;
            mid = mid + Math.imul(al4, bh3) | 0;
            mid = mid + Math.imul(ah4, bl3) | 0;
            hi = hi + Math.imul(ah4, bh3) | 0;
            lo = lo + Math.imul(al3, bl4) | 0;
            mid = mid + Math.imul(al3, bh4) | 0;
            mid = mid + Math.imul(ah3, bl4) | 0;
            hi = hi + Math.imul(ah3, bh4) | 0;
            lo = lo + Math.imul(al2, bl5) | 0;
            mid = mid + Math.imul(al2, bh5) | 0;
            mid = mid + Math.imul(ah2, bl5) | 0;
            hi = hi + Math.imul(ah2, bh5) | 0;
            lo = lo + Math.imul(al1, bl6) | 0;
            mid = mid + Math.imul(al1, bh6) | 0;
            mid = mid + Math.imul(ah1, bl6) | 0;
            hi = hi + Math.imul(ah1, bh6) | 0;
            lo = lo + Math.imul(al0, bl7) | 0;
            mid = mid + Math.imul(al0, bh7) | 0;
            mid = mid + Math.imul(ah0, bl7) | 0;
            hi = hi + Math.imul(ah0, bh7) | 0;
            var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
            w7 &= 0x3ffffff;
            lo = Math.imul(al8, bl0);
            mid = Math.imul(al8, bh0);
            mid = mid + Math.imul(ah8, bl0) | 0;
            hi = Math.imul(ah8, bh0);
            lo = lo + Math.imul(al7, bl1) | 0;
            mid = mid + Math.imul(al7, bh1) | 0;
            mid = mid + Math.imul(ah7, bl1) | 0;
            hi = hi + Math.imul(ah7, bh1) | 0;
            lo = lo + Math.imul(al6, bl2) | 0;
            mid = mid + Math.imul(al6, bh2) | 0;
            mid = mid + Math.imul(ah6, bl2) | 0;
            hi = hi + Math.imul(ah6, bh2) | 0;
            lo = lo + Math.imul(al5, bl3) | 0;
            mid = mid + Math.imul(al5, bh3) | 0;
            mid = mid + Math.imul(ah5, bl3) | 0;
            hi = hi + Math.imul(ah5, bh3) | 0;
            lo = lo + Math.imul(al4, bl4) | 0;
            mid = mid + Math.imul(al4, bh4) | 0;
            mid = mid + Math.imul(ah4, bl4) | 0;
            hi = hi + Math.imul(ah4, bh4) | 0;
            lo = lo + Math.imul(al3, bl5) | 0;
            mid = mid + Math.imul(al3, bh5) | 0;
            mid = mid + Math.imul(ah3, bl5) | 0;
            hi = hi + Math.imul(ah3, bh5) | 0;
            lo = lo + Math.imul(al2, bl6) | 0;
            mid = mid + Math.imul(al2, bh6) | 0;
            mid = mid + Math.imul(ah2, bl6) | 0;
            hi = hi + Math.imul(ah2, bh6) | 0;
            lo = lo + Math.imul(al1, bl7) | 0;
            mid = mid + Math.imul(al1, bh7) | 0;
            mid = mid + Math.imul(ah1, bl7) | 0;
            hi = hi + Math.imul(ah1, bh7) | 0;
            lo = lo + Math.imul(al0, bl8) | 0;
            mid = mid + Math.imul(al0, bh8) | 0;
            mid = mid + Math.imul(ah0, bl8) | 0;
            hi = hi + Math.imul(ah0, bh8) | 0;
            var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
            w8 &= 0x3ffffff;
            lo = Math.imul(al9, bl0);
            mid = Math.imul(al9, bh0);
            mid = mid + Math.imul(ah9, bl0) | 0;
            hi = Math.imul(ah9, bh0);
            lo = lo + Math.imul(al8, bl1) | 0;
            mid = mid + Math.imul(al8, bh1) | 0;
            mid = mid + Math.imul(ah8, bl1) | 0;
            hi = hi + Math.imul(ah8, bh1) | 0;
            lo = lo + Math.imul(al7, bl2) | 0;
            mid = mid + Math.imul(al7, bh2) | 0;
            mid = mid + Math.imul(ah7, bl2) | 0;
            hi = hi + Math.imul(ah7, bh2) | 0;
            lo = lo + Math.imul(al6, bl3) | 0;
            mid = mid + Math.imul(al6, bh3) | 0;
            mid = mid + Math.imul(ah6, bl3) | 0;
            hi = hi + Math.imul(ah6, bh3) | 0;
            lo = lo + Math.imul(al5, bl4) | 0;
            mid = mid + Math.imul(al5, bh4) | 0;
            mid = mid + Math.imul(ah5, bl4) | 0;
            hi = hi + Math.imul(ah5, bh4) | 0;
            lo = lo + Math.imul(al4, bl5) | 0;
            mid = mid + Math.imul(al4, bh5) | 0;
            mid = mid + Math.imul(ah4, bl5) | 0;
            hi = hi + Math.imul(ah4, bh5) | 0;
            lo = lo + Math.imul(al3, bl6) | 0;
            mid = mid + Math.imul(al3, bh6) | 0;
            mid = mid + Math.imul(ah3, bl6) | 0;
            hi = hi + Math.imul(ah3, bh6) | 0;
            lo = lo + Math.imul(al2, bl7) | 0;
            mid = mid + Math.imul(al2, bh7) | 0;
            mid = mid + Math.imul(ah2, bl7) | 0;
            hi = hi + Math.imul(ah2, bh7) | 0;
            lo = lo + Math.imul(al1, bl8) | 0;
            mid = mid + Math.imul(al1, bh8) | 0;
            mid = mid + Math.imul(ah1, bl8) | 0;
            hi = hi + Math.imul(ah1, bh8) | 0;
            lo = lo + Math.imul(al0, bl9) | 0;
            mid = mid + Math.imul(al0, bh9) | 0;
            mid = mid + Math.imul(ah0, bl9) | 0;
            hi = hi + Math.imul(ah0, bh9) | 0;
            var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
            w9 &= 0x3ffffff;
            lo = Math.imul(al9, bl1);
            mid = Math.imul(al9, bh1);
            mid = mid + Math.imul(ah9, bl1) | 0;
            hi = Math.imul(ah9, bh1);
            lo = lo + Math.imul(al8, bl2) | 0;
            mid = mid + Math.imul(al8, bh2) | 0;
            mid = mid + Math.imul(ah8, bl2) | 0;
            hi = hi + Math.imul(ah8, bh2) | 0;
            lo = lo + Math.imul(al7, bl3) | 0;
            mid = mid + Math.imul(al7, bh3) | 0;
            mid = mid + Math.imul(ah7, bl3) | 0;
            hi = hi + Math.imul(ah7, bh3) | 0;
            lo = lo + Math.imul(al6, bl4) | 0;
            mid = mid + Math.imul(al6, bh4) | 0;
            mid = mid + Math.imul(ah6, bl4) | 0;
            hi = hi + Math.imul(ah6, bh4) | 0;
            lo = lo + Math.imul(al5, bl5) | 0;
            mid = mid + Math.imul(al5, bh5) | 0;
            mid = mid + Math.imul(ah5, bl5) | 0;
            hi = hi + Math.imul(ah5, bh5) | 0;
            lo = lo + Math.imul(al4, bl6) | 0;
            mid = mid + Math.imul(al4, bh6) | 0;
            mid = mid + Math.imul(ah4, bl6) | 0;
            hi = hi + Math.imul(ah4, bh6) | 0;
            lo = lo + Math.imul(al3, bl7) | 0;
            mid = mid + Math.imul(al3, bh7) | 0;
            mid = mid + Math.imul(ah3, bl7) | 0;
            hi = hi + Math.imul(ah3, bh7) | 0;
            lo = lo + Math.imul(al2, bl8) | 0;
            mid = mid + Math.imul(al2, bh8) | 0;
            mid = mid + Math.imul(ah2, bl8) | 0;
            hi = hi + Math.imul(ah2, bh8) | 0;
            lo = lo + Math.imul(al1, bl9) | 0;
            mid = mid + Math.imul(al1, bh9) | 0;
            mid = mid + Math.imul(ah1, bl9) | 0;
            hi = hi + Math.imul(ah1, bh9) | 0;
            var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
            w10 &= 0x3ffffff;
            lo = Math.imul(al9, bl2);
            mid = Math.imul(al9, bh2);
            mid = mid + Math.imul(ah9, bl2) | 0;
            hi = Math.imul(ah9, bh2);
            lo = lo + Math.imul(al8, bl3) | 0;
            mid = mid + Math.imul(al8, bh3) | 0;
            mid = mid + Math.imul(ah8, bl3) | 0;
            hi = hi + Math.imul(ah8, bh3) | 0;
            lo = lo + Math.imul(al7, bl4) | 0;
            mid = mid + Math.imul(al7, bh4) | 0;
            mid = mid + Math.imul(ah7, bl4) | 0;
            hi = hi + Math.imul(ah7, bh4) | 0;
            lo = lo + Math.imul(al6, bl5) | 0;
            mid = mid + Math.imul(al6, bh5) | 0;
            mid = mid + Math.imul(ah6, bl5) | 0;
            hi = hi + Math.imul(ah6, bh5) | 0;
            lo = lo + Math.imul(al5, bl6) | 0;
            mid = mid + Math.imul(al5, bh6) | 0;
            mid = mid + Math.imul(ah5, bl6) | 0;
            hi = hi + Math.imul(ah5, bh6) | 0;
            lo = lo + Math.imul(al4, bl7) | 0;
            mid = mid + Math.imul(al4, bh7) | 0;
            mid = mid + Math.imul(ah4, bl7) | 0;
            hi = hi + Math.imul(ah4, bh7) | 0;
            lo = lo + Math.imul(al3, bl8) | 0;
            mid = mid + Math.imul(al3, bh8) | 0;
            mid = mid + Math.imul(ah3, bl8) | 0;
            hi = hi + Math.imul(ah3, bh8) | 0;
            lo = lo + Math.imul(al2, bl9) | 0;
            mid = mid + Math.imul(al2, bh9) | 0;
            mid = mid + Math.imul(ah2, bl9) | 0;
            hi = hi + Math.imul(ah2, bh9) | 0;
            var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
            w11 &= 0x3ffffff;
            lo = Math.imul(al9, bl3);
            mid = Math.imul(al9, bh3);
            mid = mid + Math.imul(ah9, bl3) | 0;
            hi = Math.imul(ah9, bh3);
            lo = lo + Math.imul(al8, bl4) | 0;
            mid = mid + Math.imul(al8, bh4) | 0;
            mid = mid + Math.imul(ah8, bl4) | 0;
            hi = hi + Math.imul(ah8, bh4) | 0;
            lo = lo + Math.imul(al7, bl5) | 0;
            mid = mid + Math.imul(al7, bh5) | 0;
            mid = mid + Math.imul(ah7, bl5) | 0;
            hi = hi + Math.imul(ah7, bh5) | 0;
            lo = lo + Math.imul(al6, bl6) | 0;
            mid = mid + Math.imul(al6, bh6) | 0;
            mid = mid + Math.imul(ah6, bl6) | 0;
            hi = hi + Math.imul(ah6, bh6) | 0;
            lo = lo + Math.imul(al5, bl7) | 0;
            mid = mid + Math.imul(al5, bh7) | 0;
            mid = mid + Math.imul(ah5, bl7) | 0;
            hi = hi + Math.imul(ah5, bh7) | 0;
            lo = lo + Math.imul(al4, bl8) | 0;
            mid = mid + Math.imul(al4, bh8) | 0;
            mid = mid + Math.imul(ah4, bl8) | 0;
            hi = hi + Math.imul(ah4, bh8) | 0;
            lo = lo + Math.imul(al3, bl9) | 0;
            mid = mid + Math.imul(al3, bh9) | 0;
            mid = mid + Math.imul(ah3, bl9) | 0;
            hi = hi + Math.imul(ah3, bh9) | 0;
            var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
            w12 &= 0x3ffffff;
            lo = Math.imul(al9, bl4);
            mid = Math.imul(al9, bh4);
            mid = mid + Math.imul(ah9, bl4) | 0;
            hi = Math.imul(ah9, bh4);
            lo = lo + Math.imul(al8, bl5) | 0;
            mid = mid + Math.imul(al8, bh5) | 0;
            mid = mid + Math.imul(ah8, bl5) | 0;
            hi = hi + Math.imul(ah8, bh5) | 0;
            lo = lo + Math.imul(al7, bl6) | 0;
            mid = mid + Math.imul(al7, bh6) | 0;
            mid = mid + Math.imul(ah7, bl6) | 0;
            hi = hi + Math.imul(ah7, bh6) | 0;
            lo = lo + Math.imul(al6, bl7) | 0;
            mid = mid + Math.imul(al6, bh7) | 0;
            mid = mid + Math.imul(ah6, bl7) | 0;
            hi = hi + Math.imul(ah6, bh7) | 0;
            lo = lo + Math.imul(al5, bl8) | 0;
            mid = mid + Math.imul(al5, bh8) | 0;
            mid = mid + Math.imul(ah5, bl8) | 0;
            hi = hi + Math.imul(ah5, bh8) | 0;
            lo = lo + Math.imul(al4, bl9) | 0;
            mid = mid + Math.imul(al4, bh9) | 0;
            mid = mid + Math.imul(ah4, bl9) | 0;
            hi = hi + Math.imul(ah4, bh9) | 0;
            var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
            w13 &= 0x3ffffff;
            lo = Math.imul(al9, bl5);
            mid = Math.imul(al9, bh5);
            mid = mid + Math.imul(ah9, bl5) | 0;
            hi = Math.imul(ah9, bh5);
            lo = lo + Math.imul(al8, bl6) | 0;
            mid = mid + Math.imul(al8, bh6) | 0;
            mid = mid + Math.imul(ah8, bl6) | 0;
            hi = hi + Math.imul(ah8, bh6) | 0;
            lo = lo + Math.imul(al7, bl7) | 0;
            mid = mid + Math.imul(al7, bh7) | 0;
            mid = mid + Math.imul(ah7, bl7) | 0;
            hi = hi + Math.imul(ah7, bh7) | 0;
            lo = lo + Math.imul(al6, bl8) | 0;
            mid = mid + Math.imul(al6, bh8) | 0;
            mid = mid + Math.imul(ah6, bl8) | 0;
            hi = hi + Math.imul(ah6, bh8) | 0;
            lo = lo + Math.imul(al5, bl9) | 0;
            mid = mid + Math.imul(al5, bh9) | 0;
            mid = mid + Math.imul(ah5, bl9) | 0;
            hi = hi + Math.imul(ah5, bh9) | 0;
            var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
            w14 &= 0x3ffffff;
            lo = Math.imul(al9, bl6);
            mid = Math.imul(al9, bh6);
            mid = mid + Math.imul(ah9, bl6) | 0;
            hi = Math.imul(ah9, bh6);
            lo = lo + Math.imul(al8, bl7) | 0;
            mid = mid + Math.imul(al8, bh7) | 0;
            mid = mid + Math.imul(ah8, bl7) | 0;
            hi = hi + Math.imul(ah8, bh7) | 0;
            lo = lo + Math.imul(al7, bl8) | 0;
            mid = mid + Math.imul(al7, bh8) | 0;
            mid = mid + Math.imul(ah7, bl8) | 0;
            hi = hi + Math.imul(ah7, bh8) | 0;
            lo = lo + Math.imul(al6, bl9) | 0;
            mid = mid + Math.imul(al6, bh9) | 0;
            mid = mid + Math.imul(ah6, bl9) | 0;
            hi = hi + Math.imul(ah6, bh9) | 0;
            var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
            w15 &= 0x3ffffff;
            lo = Math.imul(al9, bl7);
            mid = Math.imul(al9, bh7);
            mid = mid + Math.imul(ah9, bl7) | 0;
            hi = Math.imul(ah9, bh7);
            lo = lo + Math.imul(al8, bl8) | 0;
            mid = mid + Math.imul(al8, bh8) | 0;
            mid = mid + Math.imul(ah8, bl8) | 0;
            hi = hi + Math.imul(ah8, bh8) | 0;
            lo = lo + Math.imul(al7, bl9) | 0;
            mid = mid + Math.imul(al7, bh9) | 0;
            mid = mid + Math.imul(ah7, bl9) | 0;
            hi = hi + Math.imul(ah7, bh9) | 0;
            var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
            w16 &= 0x3ffffff;
            lo = Math.imul(al9, bl8);
            mid = Math.imul(al9, bh8);
            mid = mid + Math.imul(ah9, bl8) | 0;
            hi = Math.imul(ah9, bh8);
            lo = lo + Math.imul(al8, bl9) | 0;
            mid = mid + Math.imul(al8, bh9) | 0;
            mid = mid + Math.imul(ah8, bl9) | 0;
            hi = hi + Math.imul(ah8, bh9) | 0;
            var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
            w17 &= 0x3ffffff;
            lo = Math.imul(al9, bl9);
            mid = Math.imul(al9, bh9);
            mid = mid + Math.imul(ah9, bl9) | 0;
            hi = Math.imul(ah9, bh9);
            var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
            w18 &= 0x3ffffff;
            o[0] = w0;
            o[1] = w1;
            o[2] = w2;
            o[3] = w3;
            o[4] = w4;
            o[5] = w5;
            o[6] = w6;
            o[7] = w7;
            o[8] = w8;
            o[9] = w9;
            o[10] = w10;
            o[11] = w11;
            o[12] = w12;
            o[13] = w13;
            o[14] = w14;
            o[15] = w15;
            o[16] = w16;
            o[17] = w17;
            o[18] = w18;
            if (c !== 0) {
                o[19] = c;
                out.length++;
            }
            return out;
        };
        if (!Math.imul) comb10MulTo = smallMulTo;
        function bigMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            out.length = self.length + num.length;
            var carry = 0;
            var hncarry = 0;
            for(var k = 0; k < out.length - 1; k++){
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j;
                    var a = self.words[i] | 0;
                    var b = num.words[j] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                    lo = lo + rword | 0;
                    rword = lo & 0x3ffffff;
                    ncarry = ncarry + (lo >>> 26) | 0;
                    hncarry += ncarry >>> 26;
                    ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
            }
            if (carry !== 0) out.words[k] = carry;
            else out.length--;
            return out.strip();
        }
        function jumboMulTo(self, num, out) {
            var fftm = new FFTM();
            return fftm.mulp(self, num, out);
        }
        BN.prototype.mulTo = function mulTo(num, out) {
            var res;
            var len = this.length + num.length;
            if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
            else if (len < 63) res = smallMulTo(this, num, out);
            else if (len < 1024) res = bigMulTo(this, num, out);
            else res = jumboMulTo(this, num, out);
            return res;
        };
        function FFTM(x, y) {
            this.x = x;
            this.y = y;
        }
        FFTM.prototype.makeRBT = function makeRBT(N) {
            var t = new Array(N);
            var l = BN.prototype._countBits(N) - 1;
            for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
            return t;
        };
        FFTM.prototype.revBin = function revBin(x, l, N) {
            if (x === 0 || x === N - 1) return x;
            var rb = 0;
            for(var i = 0; i < l; i++){
                rb |= (x & 1) << l - i - 1;
                x >>= 1;
            }
            return rb;
        };
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
            for(var i = 0; i < N; i++){
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
            }
        };
        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
            this.permute(rbt, rws, iws, rtws, itws, N);
            for(var s = 1; s < N; s <<= 1){
                var l = s << 1;
                var rtwdf = Math.cos(2 * Math.PI / l);
                var itwdf = Math.sin(2 * Math.PI / l);
                for(var p = 0; p < N; p += l){
                    var rtwdf_ = rtwdf;
                    var itwdf_ = itwdf;
                    for(var j = 0; j < s; j++){
                        var re = rtws[p + j];
                        var ie = itws[p + j];
                        var ro = rtws[p + j + s];
                        var io = itws[p + j + s];
                        var rx = rtwdf_ * ro - itwdf_ * io;
                        io = rtwdf_ * io + itwdf_ * ro;
                        ro = rx;
                        rtws[p + j] = re + ro;
                        itws[p + j] = ie + io;
                        rtws[p + j + s] = re - ro;
                        itws[p + j + s] = ie - io;
                        if (j !== l) {
                            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                            rtwdf_ = rx;
                        }
                    }
                }
            }
        };
        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
            var N = Math.max(m, n) | 1;
            var odd = N & 1;
            var i = 0;
            for(N = N / 2 | 0; N; N = N >>> 1)i++;
            return 1 << i + 1 + odd;
        };
        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
            if (N <= 1) return;
            for(var i = 0; i < N / 2; i++){
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
            }
        };
        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
            var carry = 0;
            for(var i = 0; i < N / 2; i++){
                var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) carry = 0;
                else carry = w / 0x4000000 | 0;
            }
            return ws;
        };
        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
            var carry = 0;
            for(var i = 0; i < len; i++){
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
            }
            for(i = 2 * len; i < N; ++i)rws[i] = 0;
            assert(carry === 0);
            assert((carry & -8192) === 0);
        };
        FFTM.prototype.stub = function stub(N) {
            var ph = new Array(N);
            for(var i = 0; i < N; i++)ph[i] = 0;
            return ph;
        };
        FFTM.prototype.mulp = function mulp(x, y, out) {
            var N = 2 * this.guessLen13b(x.length, y.length);
            var rbt = this.makeRBT(N);
            var _ = this.stub(N);
            var rws = new Array(N);
            var rwst = new Array(N);
            var iwst = new Array(N);
            var nrws = new Array(N);
            var nrwst = new Array(N);
            var niwst = new Array(N);
            var rmws = out.words;
            rmws.length = N;
            this.convert13b(x.words, x.length, rws, N);
            this.convert13b(y.words, y.length, nrws, N);
            this.transform(rws, _, rwst, iwst, N, rbt);
            this.transform(nrws, _, nrwst, niwst, N, rbt);
            for(var i = 0; i < N; i++){
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
            }
            this.conjugate(rwst, iwst, N);
            this.transform(rwst, iwst, rmws, _, N, rbt);
            this.conjugate(rmws, _, N);
            this.normalize13b(rmws, N);
            out.negative = x.negative ^ y.negative;
            out.length = x.length + y.length;
            return out.strip();
        };
        BN.prototype.mul = function mul(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return this.mulTo(num, out);
        };
        BN.prototype.mulf = function mulf(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return jumboMulTo(this, num, out);
        };
        BN.prototype.imul = function imul(num) {
            return this.clone().mulTo(num, this);
        };
        BN.prototype.imuln = function imuln(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += w / 0x4000000 | 0;
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.muln = function muln(num) {
            return this.clone().imuln(num);
        };
        BN.prototype.sqr = function sqr() {
            return this.mul(this);
        };
        BN.prototype.isqr = function isqr() {
            return this.imul(this.clone());
        };
        BN.prototype.pow = function pow(num) {
            var w = toBitArray(num);
            if (w.length === 0) return new BN(1);
            var res = this;
            for(var i = 0; i < w.length; i++, res = res.sqr()){
                if (w[i] !== 0) break;
            }
            if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                if (w[i] === 0) continue;
                res = res.mul(q);
            }
            return res;
        };
        BN.prototype.iushln = function iushln(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
            var i;
            if (r !== 0) {
                var carry = 0;
                for(i = 0; i < this.length; i++){
                    var newCarry = this.words[i] & carryMask;
                    var c = (this.words[i] | 0) - newCarry << r;
                    this.words[i] = c | carry;
                    carry = newCarry >>> 26 - r;
                }
                if (carry) {
                    this.words[i] = carry;
                    this.length++;
                }
            }
            if (s !== 0) {
                for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                for(i = 0; i < s; i++)this.words[i] = 0;
                this.length += s;
            }
            return this.strip();
        };
        BN.prototype.ishln = function ishln(bits) {
            assert(this.negative === 0);
            return this.iushln(bits);
        };
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
            assert(typeof bits === 'number' && bits >= 0);
            var h;
            if (hint) h = (hint - hint % 26) / 26;
            else h = 0;
            var r = bits % 26;
            var s = Math.min((bits - r) / 26, this.length);
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            var maskedWords = extended;
            h -= s;
            h = Math.max(0, h);
            if (maskedWords) {
                for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                maskedWords.length = s;
            }
            if (s === 0) ;
            else if (this.length > s) {
                this.length -= s;
                for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
            } else {
                this.words[0] = 0;
                this.length = 1;
            }
            var carry = 0;
            for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                var word = this.words[i] | 0;
                this.words[i] = carry << 26 - r | word >>> r;
                carry = word & mask;
            }
            if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
            if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
            }
            return this.strip();
        };
        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
            assert(this.negative === 0);
            return this.iushrn(bits, hint, extended);
        };
        BN.prototype.shln = function shln(bits) {
            return this.clone().ishln(bits);
        };
        BN.prototype.ushln = function ushln(bits) {
            return this.clone().iushln(bits);
        };
        BN.prototype.shrn = function shrn(bits) {
            return this.clone().ishrn(bits);
        };
        BN.prototype.ushrn = function ushrn(bits) {
            return this.clone().iushrn(bits);
        };
        BN.prototype.testn = function testn(bit) {
            assert(typeof bit === 'number' && bit >= 0);
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) return false;
            var w = this.words[s];
            return !!(w & q);
        };
        BN.prototype.imaskn = function imaskn(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            assert(this.negative === 0, 'imaskn works only with positive numbers');
            if (this.length <= s) return this;
            if (r !== 0) s++;
            this.length = Math.min(s, this.length);
            if (r !== 0) {
                var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                this.words[this.length - 1] &= mask;
            }
            return this.strip();
        };
        BN.prototype.maskn = function maskn(bits) {
            return this.clone().imaskn(bits);
        };
        BN.prototype.iaddn = function iaddn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.isubn(-num);
            if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) < num) {
                    this.words[0] = num - (this.words[0] | 0);
                    this.negative = 0;
                    return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
            }
            return this._iaddn(num);
        };
        BN.prototype._iaddn = function _iaddn(num) {
            this.words[0] += num;
            for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) this.words[i + 1] = 1;
                else this.words[i + 1]++;
            }
            this.length = Math.max(this.length, i + 1);
            return this;
        };
        BN.prototype.isubn = function isubn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.iaddn(-num);
            if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
            }
            this.words[0] -= num;
            if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
            } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                this.words[i] += 0x4000000;
                this.words[i + 1] -= 1;
            }
            return this.strip();
        };
        BN.prototype.addn = function addn(num) {
            return this.clone().iaddn(num);
        };
        BN.prototype.subn = function subn(num) {
            return this.clone().isubn(num);
        };
        BN.prototype.iabs = function iabs() {
            this.negative = 0;
            return this;
        };
        BN.prototype.abs = function abs() {
            return this.clone().iabs();
        };
        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
            var len = num.length + shift;
            var i;
            this._expand(len);
            var w;
            var carry = 0;
            for(i = 0; i < num.length; i++){
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - (right / 0x4000000 | 0);
                this.words[i + shift] = w & 0x3ffffff;
            }
            for(; i < this.length - shift; i++){
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
            }
            if (carry === 0) return this.strip();
            assert(carry === -1);
            carry = 0;
            for(i = 0; i < this.length; i++){
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
            }
            this.negative = 1;
            return this.strip();
        };
        BN.prototype._wordDiv = function _wordDiv(num, mode) {
            var shift = this.length - num.length;
            var a = this.clone();
            var b = num;
            var bhi = b.words[b.length - 1] | 0;
            var bhiBits = this._countBits(bhi);
            shift = 26 - bhiBits;
            if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
            }
            var m = a.length - b.length;
            var q;
            if (mode !== 'mod') {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for(var i = 0; i < q.length; i++)q.words[i] = 0;
            }
            var diff = a.clone()._ishlnsubmul(b, 1, m);
            if (diff.negative === 0) {
                a = diff;
                if (q) q.words[m] = 1;
            }
            for(var j = m - 1; j >= 0; j--){
                var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                qj = Math.min(qj / bhi | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while(a.negative !== 0){
                    qj--;
                    a.negative = 0;
                    a._ishlnsubmul(b, 1, j);
                    if (!a.isZero()) a.negative ^= 1;
                }
                if (q) q.words[j] = qj;
            }
            if (q) q.strip();
            a.strip();
            if (mode !== 'div' && shift !== 0) a.iushrn(shift);
            return {
                div: q || null,
                mod: a
            };
        };
        BN.prototype.divmod = function divmod(num, mode, positive) {
            assert(!num.isZero());
            if (this.isZero()) return {
                div: new BN(0),
                mod: new BN(0)
            };
            var div, mod, res;
            if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== 'mod') div = res.div.neg();
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.iadd(num);
                }
                return {
                    div: div,
                    mod: mod
                };
            }
            if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== 'mod') div = res.div.neg();
                return {
                    div: div,
                    mod: res.mod
                };
            }
            if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.isub(num);
                }
                return {
                    div: res.div,
                    mod: mod
                };
            }
            if (num.length > this.length || this.cmp(num) < 0) return {
                div: new BN(0),
                mod: this
            };
            if (num.length === 1) {
                if (mode === 'div') return {
                    div: this.divn(num.words[0]),
                    mod: null
                };
                if (mode === 'mod') return {
                    div: null,
                    mod: new BN(this.modn(num.words[0]))
                };
                return {
                    div: this.divn(num.words[0]),
                    mod: new BN(this.modn(num.words[0]))
                };
            }
            return this._wordDiv(num, mode);
        };
        BN.prototype.div = function div(num) {
            return this.divmod(num, 'div', false).div;
        };
        BN.prototype.mod = function mod(num) {
            return this.divmod(num, 'mod', false).mod;
        };
        BN.prototype.umod = function umod(num) {
            return this.divmod(num, 'mod', true).mod;
        };
        BN.prototype.divRound = function divRound(num) {
            var dm = this.divmod(num);
            if (dm.mod.isZero()) return dm.div;
            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
            var half = num.ushrn(1);
            var r2 = num.andln(1);
            var cmp = mod.cmp(half);
            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };
        BN.prototype.modn = function modn(num) {
            assert(num <= 0x3ffffff);
            var p = 67108864 % num;
            var acc = 0;
            for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
            return acc;
        };
        BN.prototype.idivn = function idivn(num) {
            assert(num <= 0x3ffffff);
            var carry = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = w / num | 0;
                carry = w % num;
            }
            return this.strip();
        };
        BN.prototype.divn = function divn(num) {
            return this.clone().idivn(num);
        };
        BN.prototype.egcd = function egcd(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var x = this;
            var y = p.clone();
            if (x.negative !== 0) x = x.umod(p);
            else x = x.clone();
            var A = new BN(1);
            var B = new BN(0);
            var C = new BN(0);
            var D = new BN(1);
            var g = 0;
            while(x.isEven() && y.isEven()){
                x.iushrn(1);
                y.iushrn(1);
                ++g;
            }
            var yp = y.clone();
            var xp = x.clone();
            while(!x.isZero()){
                for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    x.iushrn(i);
                    while(i-- > 0){
                        if (A.isOdd() || B.isOdd()) {
                            A.iadd(yp);
                            B.isub(xp);
                        }
                        A.iushrn(1);
                        B.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    y.iushrn(j);
                    while(j-- > 0){
                        if (C.isOdd() || D.isOdd()) {
                            C.iadd(yp);
                            D.isub(xp);
                        }
                        C.iushrn(1);
                        D.iushrn(1);
                    }
                }
                if (x.cmp(y) >= 0) {
                    x.isub(y);
                    A.isub(C);
                    B.isub(D);
                } else {
                    y.isub(x);
                    C.isub(A);
                    D.isub(B);
                }
            }
            return {
                a: C,
                b: D,
                gcd: y.iushln(g)
            };
        };
        BN.prototype._invmp = function _invmp(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var a = this;
            var b = p.clone();
            if (a.negative !== 0) a = a.umod(p);
            else a = a.clone();
            var x1 = new BN(1);
            var x2 = new BN(0);
            var delta = b.clone();
            while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    a.iushrn(i);
                    while(i-- > 0){
                        if (x1.isOdd()) x1.iadd(delta);
                        x1.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    b.iushrn(j);
                    while(j-- > 0){
                        if (x2.isOdd()) x2.iadd(delta);
                        x2.iushrn(1);
                    }
                }
                if (a.cmp(b) >= 0) {
                    a.isub(b);
                    x1.isub(x2);
                } else {
                    b.isub(a);
                    x2.isub(x1);
                }
            }
            var res;
            if (a.cmpn(1) === 0) res = x1;
            else res = x2;
            if (res.cmpn(0) < 0) res.iadd(p);
            return res;
        };
        BN.prototype.gcd = function gcd(num) {
            if (this.isZero()) return num.abs();
            if (num.isZero()) return this.abs();
            var a = this.clone();
            var b = num.clone();
            a.negative = 0;
            b.negative = 0;
            for(var shift = 0; a.isEven() && b.isEven(); shift++){
                a.iushrn(1);
                b.iushrn(1);
            }
            do {
                while(a.isEven())a.iushrn(1);
                while(b.isEven())b.iushrn(1);
                var r = a.cmp(b);
                if (r < 0) {
                    var t = a;
                    a = b;
                    b = t;
                } else if (r === 0 || b.cmpn(1) === 0) break;
                a.isub(b);
            }while (true)
            return b.iushln(shift);
        };
        BN.prototype.invm = function invm(num) {
            return this.egcd(num).a.umod(num);
        };
        BN.prototype.isEven = function isEven() {
            return (this.words[0] & 1) === 0;
        };
        BN.prototype.isOdd = function isOdd() {
            return (this.words[0] & 1) === 1;
        };
        BN.prototype.andln = function andln(num) {
            return this.words[0] & num;
        };
        BN.prototype.bincn = function bincn(bit) {
            assert(typeof bit === 'number');
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
            }
            var carry = q;
            for(var i = s; carry !== 0 && i < this.length; i++){
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.isZero = function isZero() {
            return this.length === 1 && this.words[0] === 0;
        };
        BN.prototype.cmpn = function cmpn(num) {
            var negative = num < 0;
            if (this.negative !== 0 && !negative) return -1;
            if (this.negative === 0 && negative) return 1;
            this.strip();
            var res;
            if (this.length > 1) res = 1;
            else {
                if (negative) num = -num;
                assert(num <= 0x3ffffff, 'Number is too big');
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
            }
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.cmp = function cmp(num) {
            if (this.negative !== 0 && num.negative === 0) return -1;
            if (this.negative === 0 && num.negative !== 0) return 1;
            var res = this.ucmp(num);
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.ucmp = function ucmp(num) {
            if (this.length > num.length) return 1;
            if (this.length < num.length) return -1;
            var res = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) res = -1;
                else if (a > b) res = 1;
                break;
            }
            return res;
        };
        BN.prototype.gtn = function gtn(num) {
            return this.cmpn(num) === 1;
        };
        BN.prototype.gt = function gt(num) {
            return this.cmp(num) === 1;
        };
        BN.prototype.gten = function gten(num) {
            return this.cmpn(num) >= 0;
        };
        BN.prototype.gte = function gte(num) {
            return this.cmp(num) >= 0;
        };
        BN.prototype.ltn = function ltn(num) {
            return this.cmpn(num) === -1;
        };
        BN.prototype.lt = function lt(num) {
            return this.cmp(num) === -1;
        };
        BN.prototype.lten = function lten(num) {
            return this.cmpn(num) <= 0;
        };
        BN.prototype.lte = function lte(num) {
            return this.cmp(num) <= 0;
        };
        BN.prototype.eqn = function eqn(num) {
            return this.cmpn(num) === 0;
        };
        BN.prototype.eq = function eq(num) {
            return this.cmp(num) === 0;
        };
        BN.red = function red(num) {
            return new Red(num);
        };
        BN.prototype.toRed = function toRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            assert(this.negative === 0, 'red works only with positives');
            return ctx.convertTo(this)._forceRed(ctx);
        };
        BN.prototype.fromRed = function fromRed() {
            assert(this.red, 'fromRed works only with numbers in reduction context');
            return this.red.convertFrom(this);
        };
        BN.prototype._forceRed = function _forceRed(ctx) {
            this.red = ctx;
            return this;
        };
        BN.prototype.forceRed = function forceRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            return this._forceRed(ctx);
        };
        BN.prototype.redAdd = function redAdd(num) {
            assert(this.red, 'redAdd works only with red numbers');
            return this.red.add(this, num);
        };
        BN.prototype.redIAdd = function redIAdd(num) {
            assert(this.red, 'redIAdd works only with red numbers');
            return this.red.iadd(this, num);
        };
        BN.prototype.redSub = function redSub(num) {
            assert(this.red, 'redSub works only with red numbers');
            return this.red.sub(this, num);
        };
        BN.prototype.redISub = function redISub(num) {
            assert(this.red, 'redISub works only with red numbers');
            return this.red.isub(this, num);
        };
        BN.prototype.redShl = function redShl(num) {
            assert(this.red, 'redShl works only with red numbers');
            return this.red.shl(this, num);
        };
        BN.prototype.redMul = function redMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.mul(this, num);
        };
        BN.prototype.redIMul = function redIMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.imul(this, num);
        };
        BN.prototype.redSqr = function redSqr() {
            assert(this.red, 'redSqr works only with red numbers');
            this.red._verify1(this);
            return this.red.sqr(this);
        };
        BN.prototype.redISqr = function redISqr() {
            assert(this.red, 'redISqr works only with red numbers');
            this.red._verify1(this);
            return this.red.isqr(this);
        };
        BN.prototype.redSqrt = function redSqrt() {
            assert(this.red, 'redSqrt works only with red numbers');
            this.red._verify1(this);
            return this.red.sqrt(this);
        };
        BN.prototype.redInvm = function redInvm() {
            assert(this.red, 'redInvm works only with red numbers');
            this.red._verify1(this);
            return this.red.invm(this);
        };
        BN.prototype.redNeg = function redNeg() {
            assert(this.red, 'redNeg works only with red numbers');
            this.red._verify1(this);
            return this.red.neg(this);
        };
        BN.prototype.redPow = function redPow(num) {
            assert(this.red && !num.red, 'redPow(normalNum)');
            this.red._verify1(this);
            return this.red.pow(this, num);
        };
        var primes = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function MPrime(name, p) {
            this.name = name;
            this.p = new BN(p, 16);
            this.n = this.p.bitLength();
            this.k = new BN(1).iushln(this.n).isub(this.p);
            this.tmp = this._tmp();
        }
        MPrime.prototype._tmp = function _tmp() {
            var tmp = new BN(null);
            tmp.words = new Array(Math.ceil(this.n / 13));
            return tmp;
        };
        MPrime.prototype.ireduce = function ireduce(num) {
            var r = num;
            var rlen;
            do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
            }while (rlen > this.n)
            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
            if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
            } else if (cmp > 0) r.isub(this.p);
            else if (r.strip !== undefined) r.strip();
            else r._strip();
            return r;
        };
        MPrime.prototype.split = function split(input, out) {
            input.iushrn(this.n, 0, out);
        };
        MPrime.prototype.imulK = function imulK(num) {
            return num.imul(this.k);
        };
        function K256() {
            MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);
        K256.prototype.split = function split(input, output) {
            var mask = 0x3fffff;
            var outLen = Math.min(input.length, 9);
            for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
            output.length = outLen;
            if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
            }
            var prev = input.words[9];
            output.words[output.length++] = prev & mask;
            for(i = 10; i < input.length; i++){
                var next = input.words[i] | 0;
                input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                prev = next;
            }
            prev >>>= 22;
            input.words[i - 10] = prev;
            if (prev === 0 && input.length > 10) input.length -= 10;
            else input.length -= 9;
        };
        K256.prototype.imulK = function imulK(num) {
            num.words[num.length] = 0;
            num.words[num.length + 1] = 0;
            num.length += 2;
            var lo = 0;
            for(var i = 0; i < num.length; i++){
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + (lo / 0x4000000 | 0);
            }
            if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) num.length--;
            }
            return num;
        };
        function P224() {
            MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);
        function P192() {
            MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);
        function P25519() {
            MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);
        P25519.prototype.imulK = function imulK(num) {
            var carry = 0;
            for(var i = 0; i < num.length; i++){
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
            }
            if (carry !== 0) num.words[num.length++] = carry;
            return num;
        };
        BN._prime = function prime(name) {
            if (primes[name]) return primes[name];
            var prime;
            if (name === 'k256') prime = new K256();
            else if (name === 'p224') prime = new P224();
            else if (name === 'p192') prime = new P192();
            else if (name === 'p25519') prime = new P25519();
            else throw new Error('Unknown prime ' + name);
            primes[name] = prime;
            return prime;
        };
        function Red(m) {
            if (typeof m === 'string') {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
            } else {
                assert(m.gtn(1), 'modulus must be greater than 1');
                this.m = m;
                this.prime = null;
            }
        }
        Red.prototype._verify1 = function _verify1(a) {
            assert(a.negative === 0, 'red works only with positives');
            assert(a.red, 'red works only with red numbers');
        };
        Red.prototype._verify2 = function _verify2(a, b) {
            assert((a.negative | b.negative) === 0, 'red works only with positives');
            assert(a.red && a.red === b.red, 'red works only with red numbers');
        };
        Red.prototype.imod = function imod(a) {
            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
            return a.umod(this.m)._forceRed(this);
        };
        Red.prototype.neg = function neg(a) {
            if (a.isZero()) return a.clone();
            return this.m.sub(a)._forceRed(this);
        };
        Red.prototype.add = function add(a, b) {
            this._verify2(a, b);
            var res = a.add(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res._forceRed(this);
        };
        Red.prototype.iadd = function iadd(a, b) {
            this._verify2(a, b);
            var res = a.iadd(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res;
        };
        Red.prototype.sub = function sub(a, b) {
            this._verify2(a, b);
            var res = a.sub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res._forceRed(this);
        };
        Red.prototype.isub = function isub(a, b) {
            this._verify2(a, b);
            var res = a.isub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res;
        };
        Red.prototype.shl = function shl(a, num) {
            this._verify1(a);
            return this.imod(a.ushln(num));
        };
        Red.prototype.imul = function imul(a, b) {
            this._verify2(a, b);
            return this.imod(a.imul(b));
        };
        Red.prototype.mul = function mul(a, b) {
            this._verify2(a, b);
            return this.imod(a.mul(b));
        };
        Red.prototype.isqr = function isqr(a) {
            return this.imul(a, a.clone());
        };
        Red.prototype.sqr = function sqr(a) {
            return this.mul(a, a);
        };
        Red.prototype.sqrt = function sqrt(a) {
            if (a.isZero()) return a.clone();
            var mod3 = this.m.andln(3);
            assert(mod3 % 2 === 1);
            if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
            }
            var q = this.m.subn(1);
            var s = 0;
            while(!q.isZero() && q.andln(1) === 0){
                s++;
                q.iushrn(1);
            }
            assert(!q.isZero());
            var one = new BN(1).toRed(this);
            var nOne = one.redNeg();
            var lpow = this.m.subn(1).iushrn(1);
            var z = this.m.bitLength();
            z = new BN(2 * z * z).toRed(this);
            while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
            var c = this.pow(z, q);
            var r = this.pow(a, q.addn(1).iushrn(1));
            var t = this.pow(a, q);
            var m = s;
            while(t.cmp(one) !== 0){
                var tmp = t;
                for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
            }
            return r;
        };
        Red.prototype.invm = function invm(a) {
            var inv = a._invmp(this.m);
            if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
            } else return this.imod(inv);
        };
        Red.prototype.pow = function pow(a, num) {
            if (num.isZero()) return new BN(1).toRed(this);
            if (num.cmpn(1) === 0) return a.clone();
            var windowSize = 4;
            var wnd = new Array(1 << windowSize);
            wnd[0] = new BN(1).toRed(this);
            wnd[1] = a;
            for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
            var res = wnd[0];
            var current = 0;
            var currentLen = 0;
            var start = num.bitLength() % 26;
            if (start === 0) start = 26;
            for(i = num.length - 1; i >= 0; i--){
                var word = num.words[i];
                for(var j = start - 1; j >= 0; j--){
                    var bit = word >> j & 1;
                    if (res !== wnd[0]) res = this.sqr(res);
                    if (bit === 0 && current === 0) {
                        currentLen = 0;
                        continue;
                    }
                    current <<= 1;
                    current |= bit;
                    currentLen++;
                    if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                    res = this.mul(res, wnd[current]);
                    currentLen = 0;
                    current = 0;
                }
                start = 26;
            }
            return res;
        };
        Red.prototype.convertTo = function convertTo(num) {
            var r = num.umod(this.m);
            return r === num ? r.clone() : r;
        };
        Red.prototype.convertFrom = function convertFrom(num) {
            var res = num.clone();
            res.red = null;
            return res;
        };
        BN.mont = function mont(num) {
            return new Mont(num);
        };
        function Mont(m) {
            Red.call(this, m);
            this.shift = this.m.bitLength();
            if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
            this.r = new BN(1).iushln(this.shift);
            this.r2 = this.imod(this.r.sqr());
            this.rinv = this.r._invmp(this.m);
            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
            this.minv = this.minv.umod(this.r);
            this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);
        Mont.prototype.convertTo = function convertTo(num) {
            return this.imod(num.ushln(this.shift));
        };
        Mont.prototype.convertFrom = function convertFrom(num) {
            var r = this.imod(num.mul(this.rinv));
            r.red = null;
            return r;
        };
        Mont.prototype.imul = function imul(a, b) {
            if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
            }
            var t = a.imul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.mul = function mul(a, b) {
            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
            var t = a.mul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.invm = function invm(a) {
            var res = this.imod(a._invmp(this.m).mul(this.r2));
            return res._forceRed(this);
        };
    })(module, this);
});
parcelRegister("j2pYc", function(module, exports) {
    var $9pbIC = parcelRequire("9pbIC");
    var $9D8YT = parcelRequire("9D8YT");
    function $ddc2594cff22236f$var$MillerRabin(rand) {
        this.rand = rand || new $9D8YT.Rand();
    }
    module.exports = $ddc2594cff22236f$var$MillerRabin;
    $ddc2594cff22236f$var$MillerRabin.create = function create(rand) {
        return new $ddc2594cff22236f$var$MillerRabin(rand);
    };
    $ddc2594cff22236f$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
        var len = n.bitLength();
        var min_bytes = Math.ceil(len / 8);
        do var a = new $9pbIC(this.rand.generate(min_bytes));
        while (a.cmp(n) >= 0)
        return a;
    };
    $ddc2594cff22236f$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
        var size = stop.sub(start);
        return start.add(this._randbelow(size));
    };
    $ddc2594cff22236f$var$MillerRabin.prototype.test = function test(n, k, cb) {
        var len = n.bitLength();
        var red = $9pbIC.mont(n);
        var rone = new $9pbIC(1).toRed(red);
        if (!k) k = Math.max(1, len / 48 | 0);
        var n1 = n.subn(1);
        for(var s = 0; !n1.testn(s); s++);
        var d = n.shrn(s);
        var rn1 = n1.toRed(red);
        var prime = true;
        for(; k > 0; k--){
            var a = this._randrange(new $9pbIC(2), n1);
            if (cb) cb(a);
            var x = a.toRed(red).redPow(d);
            if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
            for(var i = 1; i < s; i++){
                x = x.redSqr();
                if (x.cmp(rone) === 0) return false;
                if (x.cmp(rn1) === 0) break;
            }
            if (i === s) return false;
        }
        return prime;
    };
    $ddc2594cff22236f$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
        var len = n.bitLength();
        var red = $9pbIC.mont(n);
        var rone = new $9pbIC(1).toRed(red);
        if (!k) k = Math.max(1, len / 48 | 0);
        var n1 = n.subn(1);
        for(var s = 0; !n1.testn(s); s++);
        var d = n.shrn(s);
        var rn1 = n1.toRed(red);
        for(; k > 0; k--){
            var a = this._randrange(new $9pbIC(2), n1);
            var g = n.gcd(a);
            if (g.cmpn(1) !== 0) return g;
            var x = a.toRed(red).redPow(d);
            if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
            for(var i = 1; i < s; i++){
                x = x.redSqr();
                if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
                if (x.cmp(rn1) === 0) break;
            }
            if (i === s) {
                x = x.redSqr();
                return x.fromRed().subn(1).gcd(n);
            }
        }
        return false;
    };
});
parcelRegister("9D8YT", function(module, exports) {
    var $01cf348867612932$var$r;
    module.exports = function rand(len) {
        if (!$01cf348867612932$var$r) $01cf348867612932$var$r = new $01cf348867612932$var$Rand(null);
        return $01cf348867612932$var$r.generate(len);
    };
    function $01cf348867612932$var$Rand(rand) {
        this.rand = rand;
    }
    module.exports.Rand = $01cf348867612932$var$Rand;
    $01cf348867612932$var$Rand.prototype.generate = function generate(len) {
        return this._rand(len);
    };
    $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
        if (this.rand.getBytes) return this.rand.getBytes(n);
        var res = new Uint8Array(n);
        for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
        return res;
    };
    if (typeof self === 'object') {
        if (self.crypto && self.crypto.getRandomValues) $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
            var arr = new Uint8Array(n);
            self.crypto.getRandomValues(arr);
            return arr;
        };
        else if (self.msCrypto && self.msCrypto.getRandomValues) $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
            var arr = new Uint8Array(n);
            self.msCrypto.getRandomValues(arr);
            return arr;
        };
        else if (typeof window === 'object') $01cf348867612932$var$Rand.prototype._rand = function() {
            throw new Error('Not implemented yet');
        };
    } else try {
        var $01cf348867612932$var$crypto = (parcelRequire("3gWwf"));
        if (typeof $01cf348867612932$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
        $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
            return $01cf348867612932$var$crypto.randomBytes(n);
        };
    } catch (e) {}
});
parcelRegister("9TmmS", function(module, exports) {
    module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");
});
parcelRegister("9UDry", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $7377f0aaf3b8b68d$require$Buffer = $5k7LC.Buffer;
    var $9pbIC = parcelRequire("9pbIC");
    var $j2pYc = parcelRequire("j2pYc");
    var $7377f0aaf3b8b68d$var$millerRabin = new $j2pYc();
    var $7377f0aaf3b8b68d$var$TWENTYFOUR = new $9pbIC(24);
    var $7377f0aaf3b8b68d$var$ELEVEN = new $9pbIC(11);
    var $7377f0aaf3b8b68d$var$TEN = new $9pbIC(10);
    var $7377f0aaf3b8b68d$var$THREE = new $9pbIC(3);
    var $7377f0aaf3b8b68d$var$SEVEN = new $9pbIC(7);
    var $iQ4lm = parcelRequire("iQ4lm");
    var $1DyI6 = parcelRequire("1DyI6");
    module.exports = $7377f0aaf3b8b68d$var$DH;
    function $7377f0aaf3b8b68d$var$setPublicKey(pub, enc) {
        enc = enc || 'utf8';
        if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(pub)) pub = new $7377f0aaf3b8b68d$require$Buffer(pub, enc);
        this._pub = new $9pbIC(pub);
        return this;
    }
    function $7377f0aaf3b8b68d$var$setPrivateKey(priv, enc) {
        enc = enc || 'utf8';
        if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(priv)) priv = new $7377f0aaf3b8b68d$require$Buffer(priv, enc);
        this._priv = new $9pbIC(priv);
        return this;
    }
    var $7377f0aaf3b8b68d$var$primeCache = {};
    function $7377f0aaf3b8b68d$var$checkPrime(prime, generator) {
        var gen = generator.toString('hex');
        var hex = [
            gen,
            prime.toString(16)
        ].join('_');
        if (hex in $7377f0aaf3b8b68d$var$primeCache) return $7377f0aaf3b8b68d$var$primeCache[hex];
        var error = 0;
        if (prime.isEven() || !$iQ4lm.simpleSieve || !$iQ4lm.fermatTest(prime) || !$7377f0aaf3b8b68d$var$millerRabin.test(prime)) {
            error += 1;
            if (gen === '02' || gen === '05') error += 8;
            else error += 4;
            $7377f0aaf3b8b68d$var$primeCache[hex] = error;
            return error;
        }
        if (!$7377f0aaf3b8b68d$var$millerRabin.test(prime.shrn(1))) error += 2;
        var rem;
        switch(gen){
            case '02':
                if (prime.mod($7377f0aaf3b8b68d$var$TWENTYFOUR).cmp($7377f0aaf3b8b68d$var$ELEVEN)) error += 8;
                break;
            case '05':
                rem = prime.mod($7377f0aaf3b8b68d$var$TEN);
                if (rem.cmp($7377f0aaf3b8b68d$var$THREE) && rem.cmp($7377f0aaf3b8b68d$var$SEVEN)) error += 8;
                break;
            default:
                error += 4;
        }
        $7377f0aaf3b8b68d$var$primeCache[hex] = error;
        return error;
    }
    function $7377f0aaf3b8b68d$var$DH(prime, generator, malleable) {
        this.setGenerator(generator);
        this.__prime = new $9pbIC(prime);
        this._prime = $9pbIC.mont(this.__prime);
        this._primeLen = prime.length;
        this._pub = undefined;
        this._priv = undefined;
        this._primeCode = undefined;
        if (malleable) {
            this.setPublicKey = $7377f0aaf3b8b68d$var$setPublicKey;
            this.setPrivateKey = $7377f0aaf3b8b68d$var$setPrivateKey;
        } else this._primeCode = 8;
    }
    Object.defineProperty($7377f0aaf3b8b68d$var$DH.prototype, 'verifyError', {
        enumerable: true,
        get: function() {
            if (typeof this._primeCode !== 'number') this._primeCode = $7377f0aaf3b8b68d$var$checkPrime(this.__prime, this.__gen);
            return this._primeCode;
        }
    });
    $7377f0aaf3b8b68d$var$DH.prototype.generateKeys = function() {
        if (!this._priv) this._priv = new $9pbIC($1DyI6(this._primeLen));
        this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
        return this.getPublicKey();
    };
    $7377f0aaf3b8b68d$var$DH.prototype.computeSecret = function(other) {
        other = new $9pbIC(other);
        other = other.toRed(this._prime);
        var secret = other.redPow(this._priv).fromRed();
        var out = new $7377f0aaf3b8b68d$require$Buffer(secret.toArray());
        var prime = this.getPrime();
        if (out.length < prime.length) {
            var front = new $7377f0aaf3b8b68d$require$Buffer(prime.length - out.length);
            front.fill(0);
            out = $7377f0aaf3b8b68d$require$Buffer.concat([
                front,
                out
            ]);
        }
        return out;
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this._pub, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this._priv, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getPrime = function(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this.__prime, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getGenerator = function(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this._gen, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.setGenerator = function(gen, enc) {
        enc = enc || 'utf8';
        if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(gen)) gen = new $7377f0aaf3b8b68d$require$Buffer(gen, enc);
        this.__gen = gen;
        this._gen = new $9pbIC(gen);
        return this;
    };
    function $7377f0aaf3b8b68d$var$formatReturnValue(bn, enc) {
        var buf = new $7377f0aaf3b8b68d$require$Buffer(bn.toArray());
        if (!enc) return buf;
        else return buf.toString(enc);
    }
});
parcelRegister("kqxVX", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $edf08eeced55ab26$require$Buffer = $Wth4q.Buffer;
    var $7K4uY = parcelRequire("7K4uY");
    var $67Fhe = parcelRequire("67Fhe");
    var $v3bBu = parcelRequire("v3bBu");
    var $kYhYb = parcelRequire("kYhYb");
    var $1LYL6 = parcelRequire("1LYL6");
    var $5kFDZ = parcelRequire("5kFDZ");
    Object.keys($5kFDZ).forEach(function(key) {
        $5kFDZ[key].id = $edf08eeced55ab26$require$Buffer.from($5kFDZ[key].id, 'hex');
        $5kFDZ[key.toLowerCase()] = $5kFDZ[key];
    });
    function $edf08eeced55ab26$var$Sign(algorithm) {
        $67Fhe.Writable.call(this);
        var data = $5kFDZ[algorithm];
        if (!data) throw new Error('Unknown message digest');
        this._hashType = data.hash;
        this._hash = $7K4uY(data.hash);
        this._tag = data.id;
        this._signType = data.sign;
    }
    $v3bBu($edf08eeced55ab26$var$Sign, $67Fhe.Writable);
    $edf08eeced55ab26$var$Sign.prototype._write = function _write(data, _, done) {
        this._hash.update(data);
        done();
    };
    $edf08eeced55ab26$var$Sign.prototype.update = function update(data, enc) {
        this._hash.update(typeof data === 'string' ? $edf08eeced55ab26$require$Buffer.from(data, enc) : data);
        return this;
    };
    $edf08eeced55ab26$var$Sign.prototype.sign = function signMethod(key, enc) {
        this.end();
        var hash = this._hash.digest();
        var sig = $kYhYb(hash, key, this._hashType, this._signType, this._tag);
        return enc ? sig.toString(enc) : sig;
    };
    function $edf08eeced55ab26$var$Verify(algorithm) {
        $67Fhe.Writable.call(this);
        var data = $5kFDZ[algorithm];
        if (!data) throw new Error('Unknown message digest');
        this._hash = $7K4uY(data.hash);
        this._tag = data.id;
        this._signType = data.sign;
    }
    $v3bBu($edf08eeced55ab26$var$Verify, $67Fhe.Writable);
    $edf08eeced55ab26$var$Verify.prototype._write = function _write(data, _, done) {
        this._hash.update(data);
        done();
    };
    $edf08eeced55ab26$var$Verify.prototype.update = function update(data, enc) {
        this._hash.update(typeof data === 'string' ? $edf08eeced55ab26$require$Buffer.from(data, enc) : data);
        return this;
    };
    $edf08eeced55ab26$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
        var sigBuffer = typeof sig === 'string' ? $edf08eeced55ab26$require$Buffer.from(sig, enc) : sig;
        this.end();
        var hash = this._hash.digest();
        return $1LYL6(sigBuffer, hash, key, this._signType, this._tag);
    };
    function $edf08eeced55ab26$var$createSign(algorithm) {
        return new $edf08eeced55ab26$var$Sign(algorithm);
    }
    function $edf08eeced55ab26$var$createVerify(algorithm) {
        return new $edf08eeced55ab26$var$Verify(algorithm);
    }
    module.exports = {
        Sign: $edf08eeced55ab26$var$createSign,
        Verify: $edf08eeced55ab26$var$createVerify,
        createSign: $edf08eeced55ab26$var$createSign,
        createVerify: $edf08eeced55ab26$var$createVerify
    };
});
parcelRegister("67Fhe", function(module, exports) {
    exports = module.exports = (parcelRequire("hVjIO"));
    exports.Stream = exports;
    exports.Readable = exports;
    exports.Writable = (parcelRequire("3YGVr"));
    exports.Duplex = (parcelRequire("fAlCy"));
    exports.Transform = (parcelRequire("8iQyH"));
    exports.PassThrough = (parcelRequire("WEefO"));
});
parcelRegister("hVjIO", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    module.exports = $d0c70edb1200ac87$var$Readable;
    var $4phNF = parcelRequire("4phNF");
    var $d0c70edb1200ac87$var$Duplex;
    $d0c70edb1200ac87$var$Readable.ReadableState = $d0c70edb1200ac87$var$ReadableState;
    var $6Oghe = parcelRequire("6Oghe");
    var $d0c70edb1200ac87$require$EE = $6Oghe.EventEmitter;
    var $d0c70edb1200ac87$var$EElistenerCount = function(emitter, type) {
        return emitter.listeners(type).length;
    };
    var $4t6fq = parcelRequire("4t6fq");
    var $cmRjm = parcelRequire("cmRjm");
    var $d0c70edb1200ac87$require$Buffer = $cmRjm.Buffer;
    var $d0c70edb1200ac87$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $d0c70edb1200ac87$var$_uint8ArrayToBuffer(chunk) {
        return $d0c70edb1200ac87$require$Buffer.from(chunk);
    }
    function $d0c70edb1200ac87$var$_isUint8Array(obj) {
        return $d0c70edb1200ac87$require$Buffer.isBuffer(obj) || obj instanceof $d0c70edb1200ac87$var$OurUint8Array;
    }
    var $d0c70edb1200ac87$var$util = Object.create((parcelRequire("fvDPy")));
    $d0c70edb1200ac87$var$util.inherits = (parcelRequire("v3bBu"));
    var $3gWwf = parcelRequire("3gWwf");
    var $d0c70edb1200ac87$var$debug = void 0;
    if ($3gWwf && $3gWwf.debuglog) $d0c70edb1200ac87$var$debug = $3gWwf.debuglog('stream');
    else $d0c70edb1200ac87$var$debug = function() {};
    var $ZaRag = parcelRequire("ZaRag");
    var $9tGJn = parcelRequire("9tGJn");
    var $d0c70edb1200ac87$var$StringDecoder;
    $d0c70edb1200ac87$var$util.inherits($d0c70edb1200ac87$var$Readable, $4t6fq);
    var $d0c70edb1200ac87$var$kProxyEvents = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    function $d0c70edb1200ac87$var$prependListener(emitter, event, fn) {
        if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if ($4phNF(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
    function $d0c70edb1200ac87$var$ReadableState(options, stream) {
        $d0c70edb1200ac87$var$Duplex = $d0c70edb1200ac87$var$Duplex || (parcelRequire("fAlCy"));
        options = options || {};
        var isDuplex = stream instanceof $d0c70edb1200ac87$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
        var hwm = options.highWaterMark;
        var readableHwm = options.readableHighWaterMark;
        var defaultHwm = this.objectMode ? 16 : 16384;
        if (hwm || hwm === 0) this.highWaterMark = hwm;
        else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
        else this.highWaterMark = defaultHwm;
        this.highWaterMark = Math.floor(this.highWaterMark);
        this.buffer = new $ZaRag();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        this.sync = true;
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        this.destroyed = false;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.awaitDrain = 0;
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options.encoding) {
            if (!$d0c70edb1200ac87$var$StringDecoder) $d0c70edb1200ac87$var$StringDecoder = (parcelRequire("6ayCS")).StringDecoder;
            this.decoder = new $d0c70edb1200ac87$var$StringDecoder(options.encoding);
            this.encoding = options.encoding;
        }
    }
    function $d0c70edb1200ac87$var$Readable(options) {
        $d0c70edb1200ac87$var$Duplex = $d0c70edb1200ac87$var$Duplex || (parcelRequire("fAlCy"));
        if (!(this instanceof $d0c70edb1200ac87$var$Readable)) return new $d0c70edb1200ac87$var$Readable(options);
        this._readableState = new $d0c70edb1200ac87$var$ReadableState(options, this);
        this.readable = true;
        if (options) {
            if (typeof options.read === 'function') this._read = options.read;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
        }
        $4t6fq.call(this);
    }
    Object.defineProperty($d0c70edb1200ac87$var$Readable.prototype, 'destroyed', {
        get: function() {
            if (this._readableState === undefined) return false;
            return this._readableState.destroyed;
        },
        set: function(value) {
            if (!this._readableState) return;
            this._readableState.destroyed = value;
        }
    });
    $d0c70edb1200ac87$var$Readable.prototype.destroy = $9tGJn.destroy;
    $d0c70edb1200ac87$var$Readable.prototype._undestroy = $9tGJn.undestroy;
    $d0c70edb1200ac87$var$Readable.prototype._destroy = function(err, cb) {
        this.push(null);
        cb(err);
    };
    $d0c70edb1200ac87$var$Readable.prototype.push = function(chunk, encoding) {
        var state = this._readableState;
        var skipChunkCheck;
        if (!state.objectMode) {
            if (typeof chunk === 'string') {
                encoding = encoding || state.defaultEncoding;
                if (encoding !== state.encoding) {
                    chunk = $d0c70edb1200ac87$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
                skipChunkCheck = true;
            }
        } else skipChunkCheck = true;
        return $d0c70edb1200ac87$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };
    $d0c70edb1200ac87$var$Readable.prototype.unshift = function(chunk) {
        return $d0c70edb1200ac87$var$readableAddChunk(this, chunk, null, true, false);
    };
    function $d0c70edb1200ac87$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
        var state = stream._readableState;
        if (chunk === null) {
            state.reading = false;
            $d0c70edb1200ac87$var$onEofChunk(stream, state);
        } else {
            var er;
            if (!skipChunkCheck) er = $d0c70edb1200ac87$var$chunkInvalid(state, chunk);
            if (er) stream.emit('error', er);
            else if (state.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $d0c70edb1200ac87$require$Buffer.prototype) chunk = $d0c70edb1200ac87$var$_uint8ArrayToBuffer(chunk);
                if (addToFront) {
                    if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                    else $d0c70edb1200ac87$var$addChunk(stream, state, chunk, true);
                } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
                else {
                    state.reading = false;
                    if (state.decoder && !encoding) {
                        chunk = state.decoder.write(chunk);
                        if (state.objectMode || chunk.length !== 0) $d0c70edb1200ac87$var$addChunk(stream, state, chunk, false);
                        else $d0c70edb1200ac87$var$maybeReadMore(stream, state);
                    } else $d0c70edb1200ac87$var$addChunk(stream, state, chunk, false);
                }
            } else if (!addToFront) state.reading = false;
        }
        return $d0c70edb1200ac87$var$needMoreData(state);
    }
    function $d0c70edb1200ac87$var$addChunk(stream, state, chunk, addToFront) {
        if (state.flowing && state.length === 0 && !state.sync) {
            stream.emit('data', chunk);
            stream.read(0);
        } else {
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);
            else state.buffer.push(chunk);
            if (state.needReadable) $d0c70edb1200ac87$var$emitReadable(stream);
        }
        $d0c70edb1200ac87$var$maybeReadMore(stream, state);
    }
    function $d0c70edb1200ac87$var$chunkInvalid(state, chunk) {
        var er;
        if (!$d0c70edb1200ac87$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
        return er;
    }
    function $d0c70edb1200ac87$var$needMoreData(state) {
        return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
    }
    $d0c70edb1200ac87$var$Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    $d0c70edb1200ac87$var$Readable.prototype.setEncoding = function(enc) {
        if (!$d0c70edb1200ac87$var$StringDecoder) $d0c70edb1200ac87$var$StringDecoder = (parcelRequire("6ayCS")).StringDecoder;
        this._readableState.decoder = new $d0c70edb1200ac87$var$StringDecoder(enc);
        this._readableState.encoding = enc;
        return this;
    };
    var $d0c70edb1200ac87$var$MAX_HWM = 0x800000;
    function $d0c70edb1200ac87$var$computeNewHighWaterMark(n) {
        if (n >= $d0c70edb1200ac87$var$MAX_HWM) n = $d0c70edb1200ac87$var$MAX_HWM;
        else {
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    function $d0c70edb1200ac87$var$howMuchToRead(n, state) {
        if (n <= 0 || state.length === 0 && state.ended) return 0;
        if (state.objectMode) return 1;
        if (n !== n) {
            if (state.flowing && state.length) return state.buffer.head.data.length;
            else return state.length;
        }
        if (n > state.highWaterMark) state.highWaterMark = $d0c70edb1200ac87$var$computeNewHighWaterMark(n);
        if (n <= state.length) return n;
        if (!state.ended) {
            state.needReadable = true;
            return 0;
        }
        return state.length;
    }
    $d0c70edb1200ac87$var$Readable.prototype.read = function(n) {
        $d0c70edb1200ac87$var$debug('read', n);
        n = parseInt(n, 10);
        var state = this._readableState;
        var nOrig = n;
        if (n !== 0) state.emittedReadable = false;
        if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
            $d0c70edb1200ac87$var$debug('read: emitReadable', state.length, state.ended);
            if (state.length === 0 && state.ended) $d0c70edb1200ac87$var$endReadable(this);
            else $d0c70edb1200ac87$var$emitReadable(this);
            return null;
        }
        n = $d0c70edb1200ac87$var$howMuchToRead(n, state);
        if (n === 0 && state.ended) {
            if (state.length === 0) $d0c70edb1200ac87$var$endReadable(this);
            return null;
        }
        var doRead = state.needReadable;
        $d0c70edb1200ac87$var$debug('need readable', doRead);
        if (state.length === 0 || state.length - n < state.highWaterMark) {
            doRead = true;
            $d0c70edb1200ac87$var$debug('length less than watermark', doRead);
        }
        if (state.ended || state.reading) {
            doRead = false;
            $d0c70edb1200ac87$var$debug('reading or ended', doRead);
        } else if (doRead) {
            $d0c70edb1200ac87$var$debug('do read');
            state.reading = true;
            state.sync = true;
            if (state.length === 0) state.needReadable = true;
            this._read(state.highWaterMark);
            state.sync = false;
            if (!state.reading) n = $d0c70edb1200ac87$var$howMuchToRead(nOrig, state);
        }
        var ret;
        if (n > 0) ret = $d0c70edb1200ac87$var$fromList(n, state);
        else ret = null;
        if (ret === null) {
            state.needReadable = true;
            n = 0;
        } else state.length -= n;
        if (state.length === 0) {
            if (!state.ended) state.needReadable = true;
            if (nOrig !== n && state.ended) $d0c70edb1200ac87$var$endReadable(this);
        }
        if (ret !== null) this.emit('data', ret);
        return ret;
    };
    function $d0c70edb1200ac87$var$onEofChunk(stream, state) {
        if (state.ended) return;
        if (state.decoder) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
            }
        }
        state.ended = true;
        $d0c70edb1200ac87$var$emitReadable(stream);
    }
    function $d0c70edb1200ac87$var$emitReadable(stream) {
        var state = stream._readableState;
        state.needReadable = false;
        if (!state.emittedReadable) {
            $d0c70edb1200ac87$var$debug('emitReadable', state.flowing);
            state.emittedReadable = true;
            if (state.sync) $iWV9i.nextTick($d0c70edb1200ac87$var$emitReadable_, stream);
            else $d0c70edb1200ac87$var$emitReadable_(stream);
        }
    }
    function $d0c70edb1200ac87$var$emitReadable_(stream) {
        $d0c70edb1200ac87$var$debug('emit readable');
        stream.emit('readable');
        $d0c70edb1200ac87$var$flow(stream);
    }
    function $d0c70edb1200ac87$var$maybeReadMore(stream, state) {
        if (!state.readingMore) {
            state.readingMore = true;
            $iWV9i.nextTick($d0c70edb1200ac87$var$maybeReadMore_, stream, state);
        }
    }
    function $d0c70edb1200ac87$var$maybeReadMore_(stream, state) {
        var len = state.length;
        while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
            $d0c70edb1200ac87$var$debug('maybeReadMore read 0');
            stream.read(0);
            if (len === state.length) break;
            else len = state.length;
        }
        state.readingMore = false;
    }
    $d0c70edb1200ac87$var$Readable.prototype._read = function(n) {
        this.emit('error', new Error('_read() is not implemented'));
    };
    $d0c70edb1200ac87$var$Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state = this._readableState;
        switch(state.pipesCount){
            case 0:
                state.pipes = dest;
                break;
            case 1:
                state.pipes = [
                    state.pipes,
                    dest
                ];
                break;
            default:
                state.pipes.push(dest);
                break;
        }
        state.pipesCount += 1;
        $d0c70edb1200ac87$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
        var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6cAn5.stdout && dest !== $6cAn5.stderr;
        var endFn = doEnd ? onend : unpipe;
        if (state.endEmitted) $iWV9i.nextTick(endFn);
        else src.once('end', endFn);
        dest.on('unpipe', onunpipe);
        function onunpipe(readable, unpipeInfo) {
            $d0c70edb1200ac87$var$debug('onunpipe');
            if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                    unpipeInfo.hasUnpiped = true;
                    cleanup();
                }
            }
        }
        function onend() {
            $d0c70edb1200ac87$var$debug('onend');
            dest.end();
        }
        var ondrain = $d0c70edb1200ac87$var$pipeOnDrain(src);
        dest.on('drain', ondrain);
        var cleanedUp = false;
        function cleanup() {
            $d0c70edb1200ac87$var$debug('cleanup');
            dest.removeListener('close', onclose);
            dest.removeListener('finish', onfinish);
            dest.removeListener('drain', ondrain);
            dest.removeListener('error', onerror);
            dest.removeListener('unpipe', onunpipe);
            src.removeListener('end', onend);
            src.removeListener('end', unpipe);
            src.removeListener('data', ondata);
            cleanedUp = true;
            if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        var increasedAwaitDrain = false;
        src.on('data', ondata);
        function ondata(chunk) {
            $d0c70edb1200ac87$var$debug('ondata');
            increasedAwaitDrain = false;
            var ret = dest.write(chunk);
            if (false === ret && !increasedAwaitDrain) {
                if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d0c70edb1200ac87$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                    $d0c70edb1200ac87$var$debug('false write response, pause', state.awaitDrain);
                    state.awaitDrain++;
                    increasedAwaitDrain = true;
                }
                src.pause();
            }
        }
        function onerror(er) {
            $d0c70edb1200ac87$var$debug('onerror', er);
            unpipe();
            dest.removeListener('error', onerror);
            if ($d0c70edb1200ac87$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
        }
        $d0c70edb1200ac87$var$prependListener(dest, 'error', onerror);
        function onclose() {
            dest.removeListener('finish', onfinish);
            unpipe();
        }
        dest.once('close', onclose);
        function onfinish() {
            $d0c70edb1200ac87$var$debug('onfinish');
            dest.removeListener('close', onclose);
            unpipe();
        }
        dest.once('finish', onfinish);
        function unpipe() {
            $d0c70edb1200ac87$var$debug('unpipe');
            src.unpipe(dest);
        }
        dest.emit('pipe', src);
        if (!state.flowing) {
            $d0c70edb1200ac87$var$debug('pipe resume');
            src.resume();
        }
        return dest;
    };
    function $d0c70edb1200ac87$var$pipeOnDrain(src) {
        return function() {
            var state = src._readableState;
            $d0c70edb1200ac87$var$debug('pipeOnDrain', state.awaitDrain);
            if (state.awaitDrain) state.awaitDrain--;
            if (state.awaitDrain === 0 && $d0c70edb1200ac87$var$EElistenerCount(src, 'data')) {
                state.flowing = true;
                $d0c70edb1200ac87$var$flow(src);
            }
        };
    }
    $d0c70edb1200ac87$var$Readable.prototype.unpipe = function(dest) {
        var state = this._readableState;
        var unpipeInfo = {
            hasUnpiped: false
        };
        if (state.pipesCount === 0) return this;
        if (state.pipesCount === 1) {
            if (dest && dest !== state.pipes) return this;
            if (!dest) dest = state.pipes;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            if (dest) dest.emit('unpipe', this, unpipeInfo);
            return this;
        }
        if (!dest) {
            var dests = state.pipes;
            var len = state.pipesCount;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
                hasUnpiped: false
            });
            return this;
        }
        var index = $d0c70edb1200ac87$var$indexOf(state.pipes, dest);
        if (index === -1) return this;
        state.pipes.splice(index, 1);
        state.pipesCount -= 1;
        if (state.pipesCount === 1) state.pipes = state.pipes[0];
        dest.emit('unpipe', this, unpipeInfo);
        return this;
    };
    $d0c70edb1200ac87$var$Readable.prototype.on = function(ev, fn) {
        var res = $4t6fq.prototype.on.call(this, ev, fn);
        if (ev === 'data') {
            if (this._readableState.flowing !== false) this.resume();
        } else if (ev === 'readable') {
            var state = this._readableState;
            if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.emittedReadable = false;
                if (!state.reading) $iWV9i.nextTick($d0c70edb1200ac87$var$nReadingNextTick, this);
                else if (state.length) $d0c70edb1200ac87$var$emitReadable(this);
            }
        }
        return res;
    };
    $d0c70edb1200ac87$var$Readable.prototype.addListener = $d0c70edb1200ac87$var$Readable.prototype.on;
    function $d0c70edb1200ac87$var$nReadingNextTick(self1) {
        $d0c70edb1200ac87$var$debug('readable nexttick read 0');
        self1.read(0);
    }
    $d0c70edb1200ac87$var$Readable.prototype.resume = function() {
        var state = this._readableState;
        if (!state.flowing) {
            $d0c70edb1200ac87$var$debug('resume');
            state.flowing = true;
            $d0c70edb1200ac87$var$resume(this, state);
        }
        return this;
    };
    function $d0c70edb1200ac87$var$resume(stream, state) {
        if (!state.resumeScheduled) {
            state.resumeScheduled = true;
            $iWV9i.nextTick($d0c70edb1200ac87$var$resume_, stream, state);
        }
    }
    function $d0c70edb1200ac87$var$resume_(stream, state) {
        if (!state.reading) {
            $d0c70edb1200ac87$var$debug('resume read 0');
            stream.read(0);
        }
        state.resumeScheduled = false;
        state.awaitDrain = 0;
        stream.emit('resume');
        $d0c70edb1200ac87$var$flow(stream);
        if (state.flowing && !state.reading) stream.read(0);
    }
    $d0c70edb1200ac87$var$Readable.prototype.pause = function() {
        $d0c70edb1200ac87$var$debug('call pause flowing=%j', this._readableState.flowing);
        if (false !== this._readableState.flowing) {
            $d0c70edb1200ac87$var$debug('pause');
            this._readableState.flowing = false;
            this.emit('pause');
        }
        return this;
    };
    function $d0c70edb1200ac87$var$flow(stream) {
        var state = stream._readableState;
        $d0c70edb1200ac87$var$debug('flow', state.flowing);
        while(state.flowing && stream.read() !== null);
    }
    $d0c70edb1200ac87$var$Readable.prototype.wrap = function(stream) {
        var _this = this;
        var state = this._readableState;
        var paused = false;
        stream.on('end', function() {
            $d0c70edb1200ac87$var$debug('wrapped end');
            if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
            }
            _this.push(null);
        });
        stream.on('data', function(chunk) {
            $d0c70edb1200ac87$var$debug('wrapped data');
            if (state.decoder) chunk = state.decoder.write(chunk);
            if (state.objectMode && (chunk === null || chunk === undefined)) return;
            else if (!state.objectMode && (!chunk || !chunk.length)) return;
            var ret = _this.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
            return function() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        for(var n = 0; n < $d0c70edb1200ac87$var$kProxyEvents.length; n++)stream.on($d0c70edb1200ac87$var$kProxyEvents[n], this.emit.bind(this, $d0c70edb1200ac87$var$kProxyEvents[n]));
        this._read = function(n) {
            $d0c70edb1200ac87$var$debug('wrapped _read', n);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return this;
    };
    Object.defineProperty($d0c70edb1200ac87$var$Readable.prototype, 'readableHighWaterMark', {
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    });
    $d0c70edb1200ac87$var$Readable._fromList = $d0c70edb1200ac87$var$fromList;
    function $d0c70edb1200ac87$var$fromList(n, state) {
        if (state.length === 0) return null;
        var ret;
        if (state.objectMode) ret = state.buffer.shift();
        else if (!n || n >= state.length) {
            if (state.decoder) ret = state.buffer.join('');
            else if (state.buffer.length === 1) ret = state.buffer.head.data;
            else ret = state.buffer.concat(state.length);
            state.buffer.clear();
        } else ret = $d0c70edb1200ac87$var$fromListPartial(n, state.buffer, state.decoder);
        return ret;
    }
    function $d0c70edb1200ac87$var$fromListPartial(n, list, hasStrings) {
        var ret;
        if (n < list.head.data.length) {
            ret = list.head.data.slice(0, n);
            list.head.data = list.head.data.slice(n);
        } else if (n === list.head.data.length) ret = list.shift();
        else ret = hasStrings ? $d0c70edb1200ac87$var$copyFromBufferString(n, list) : $d0c70edb1200ac87$var$copyFromBuffer(n, list);
        return ret;
    }
    function $d0c70edb1200ac87$var$copyFromBufferString(n, list) {
        var p = list.head;
        var c = 1;
        var ret = p.data;
        n -= ret.length;
        while(p = p.next){
            var str = p.data;
            var nb = n > str.length ? str.length : n;
            if (nb === str.length) ret += str;
            else ret += str.slice(0, n);
            n -= nb;
            if (n === 0) {
                if (nb === str.length) {
                    ++c;
                    if (p.next) list.head = p.next;
                    else list.head = list.tail = null;
                } else {
                    list.head = p;
                    p.data = str.slice(nb);
                }
                break;
            }
            ++c;
        }
        list.length -= c;
        return ret;
    }
    function $d0c70edb1200ac87$var$copyFromBuffer(n, list) {
        var ret = $d0c70edb1200ac87$require$Buffer.allocUnsafe(n);
        var p = list.head;
        var c = 1;
        p.data.copy(ret);
        n -= p.data.length;
        while(p = p.next){
            var buf = p.data;
            var nb = n > buf.length ? buf.length : n;
            buf.copy(ret, ret.length - n, 0, nb);
            n -= nb;
            if (n === 0) {
                if (nb === buf.length) {
                    ++c;
                    if (p.next) list.head = p.next;
                    else list.head = list.tail = null;
                } else {
                    list.head = p;
                    p.data = buf.slice(nb);
                }
                break;
            }
            ++c;
        }
        list.length -= c;
        return ret;
    }
    function $d0c70edb1200ac87$var$endReadable(stream) {
        var state = stream._readableState;
        if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        if (!state.endEmitted) {
            state.ended = true;
            $iWV9i.nextTick($d0c70edb1200ac87$var$endReadableNT, state, stream);
        }
    }
    function $d0c70edb1200ac87$var$endReadableNT(state, stream) {
        if (!state.endEmitted && state.length === 0) {
            state.endEmitted = true;
            stream.readable = false;
            stream.emit('end');
        }
    }
    function $d0c70edb1200ac87$var$indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
});
parcelRegister("iWV9i", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    if (typeof $6cAn5 === 'undefined' || !$6cAn5.version || $6cAn5.version.indexOf('v0.') === 0 || $6cAn5.version.indexOf('v1.') === 0 && $6cAn5.version.indexOf('v1.8.') !== 0) module.exports = {
        nextTick: $dcb9f95cdc97f624$var$nextTick
    };
    else module.exports = $6cAn5;
    function $dcb9f95cdc97f624$var$nextTick(fn, arg1, arg2, arg3) {
        if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
        var len = arguments.length;
        var args, i;
        switch(len){
            case 0:
            case 1:
                return $6cAn5.nextTick(fn);
            case 2:
                return $6cAn5.nextTick(function afterTickOne() {
                    fn.call(null, arg1);
                });
            case 3:
                return $6cAn5.nextTick(function afterTickTwo() {
                    fn.call(null, arg1, arg2);
                });
            case 4:
                return $6cAn5.nextTick(function afterTickThree() {
                    fn.call(null, arg1, arg2, arg3);
                });
            default:
                args = new Array(len - 1);
                i = 0;
                while(i < args.length)args[i++] = arguments[i];
                return $6cAn5.nextTick(function afterTick() {
                    fn.apply(null, args);
                });
        }
    }
});
parcelRegister("4phNF", function(module, exports) {
    var $33574df078d04d7d$var$toString = {}.toString;
    module.exports = Array.isArray || function(arr) {
        return $33574df078d04d7d$var$toString.call(arr) == '[object Array]';
    };
});
parcelRegister("4t6fq", function(module, exports) {
    module.exports = (parcelRequire("6Oghe")).EventEmitter;
});
parcelRegister("cmRjm", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $9010e498dbe0c8b2$var$Buffer = $5k7LC.Buffer;
    function $9010e498dbe0c8b2$var$copyProps(src, dst) {
        for(var key in src)dst[key] = src[key];
    }
    if ($9010e498dbe0c8b2$var$Buffer.from && $9010e498dbe0c8b2$var$Buffer.alloc && $9010e498dbe0c8b2$var$Buffer.allocUnsafe && $9010e498dbe0c8b2$var$Buffer.allocUnsafeSlow) module.exports = $5k7LC;
    else {
        $9010e498dbe0c8b2$var$copyProps($5k7LC, module.exports);
        module.exports.Buffer = $9010e498dbe0c8b2$var$SafeBuffer;
    }
    function $9010e498dbe0c8b2$var$SafeBuffer(arg, encodingOrOffset, length) {
        return $9010e498dbe0c8b2$var$Buffer(arg, encodingOrOffset, length);
    }
    $9010e498dbe0c8b2$var$copyProps($9010e498dbe0c8b2$var$Buffer, $9010e498dbe0c8b2$var$SafeBuffer);
    $9010e498dbe0c8b2$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
        return $9010e498dbe0c8b2$var$Buffer(arg, encodingOrOffset, length);
    };
    $9010e498dbe0c8b2$var$SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        var buf = $9010e498dbe0c8b2$var$Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === 'string') buf.fill(fill, encoding);
            else buf.fill(fill);
        } else buf.fill(0);
        return buf;
    };
    $9010e498dbe0c8b2$var$SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $9010e498dbe0c8b2$var$Buffer(size);
    };
    $9010e498dbe0c8b2$var$SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $5k7LC.SlowBuffer(size);
    };
});
parcelRegister("fvDPy", function(module, exports) {
    $parcel$export(module.exports, "isArray", ()=>$b4a8a5c310566eb2$export$43bee75e5e14138e, (v)=>$b4a8a5c310566eb2$export$43bee75e5e14138e = v);
    $parcel$export(module.exports, "isBoolean", ()=>$b4a8a5c310566eb2$export$f9ce7b637dfbe238, (v)=>$b4a8a5c310566eb2$export$f9ce7b637dfbe238 = v);
    $parcel$export(module.exports, "isNull", ()=>$b4a8a5c310566eb2$export$630801d484da15df, (v)=>$b4a8a5c310566eb2$export$630801d484da15df = v);
    $parcel$export(module.exports, "isNullOrUndefined", ()=>$b4a8a5c310566eb2$export$bedb7023a7733221, (v)=>$b4a8a5c310566eb2$export$bedb7023a7733221 = v);
    $parcel$export(module.exports, "isNumber", ()=>$b4a8a5c310566eb2$export$7e4aa119212bc614, (v)=>$b4a8a5c310566eb2$export$7e4aa119212bc614 = v);
    $parcel$export(module.exports, "isString", ()=>$b4a8a5c310566eb2$export$844ec244b1367d54, (v)=>$b4a8a5c310566eb2$export$844ec244b1367d54 = v);
    $parcel$export(module.exports, "isSymbol", ()=>$b4a8a5c310566eb2$export$a244864fd9645c7f, (v)=>$b4a8a5c310566eb2$export$a244864fd9645c7f = v);
    $parcel$export(module.exports, "isUndefined", ()=>$b4a8a5c310566eb2$export$fce6876652108ab, (v)=>$b4a8a5c310566eb2$export$fce6876652108ab = v);
    $parcel$export(module.exports, "isRegExp", ()=>$b4a8a5c310566eb2$export$49841c62b9eff15, (v)=>$b4a8a5c310566eb2$export$49841c62b9eff15 = v);
    $parcel$export(module.exports, "isObject", ()=>$b4a8a5c310566eb2$export$a6cdc56e425d0d0a, (v)=>$b4a8a5c310566eb2$export$a6cdc56e425d0d0a = v);
    $parcel$export(module.exports, "isDate", ()=>$b4a8a5c310566eb2$export$871608497c498473, (v)=>$b4a8a5c310566eb2$export$871608497c498473 = v);
    $parcel$export(module.exports, "isError", ()=>$b4a8a5c310566eb2$export$e6127cc7fe7395c3, (v)=>$b4a8a5c310566eb2$export$e6127cc7fe7395c3 = v);
    $parcel$export(module.exports, "isFunction", ()=>$b4a8a5c310566eb2$export$f6e2535fb5126e54, (v)=>$b4a8a5c310566eb2$export$f6e2535fb5126e54 = v);
    $parcel$export(module.exports, "isPrimitive", ()=>$b4a8a5c310566eb2$export$c3825b437cbdea5c, (v)=>$b4a8a5c310566eb2$export$c3825b437cbdea5c = v);
    $parcel$export(module.exports, "isBuffer", ()=>$b4a8a5c310566eb2$export$a7884ebc965f8f54, (v)=>$b4a8a5c310566eb2$export$a7884ebc965f8f54 = v);
    var $b4a8a5c310566eb2$export$43bee75e5e14138e;
    var $b4a8a5c310566eb2$export$f9ce7b637dfbe238;
    var $b4a8a5c310566eb2$export$630801d484da15df;
    var $b4a8a5c310566eb2$export$bedb7023a7733221;
    var $b4a8a5c310566eb2$export$7e4aa119212bc614;
    var $b4a8a5c310566eb2$export$844ec244b1367d54;
    var $b4a8a5c310566eb2$export$a244864fd9645c7f;
    var $b4a8a5c310566eb2$export$fce6876652108ab;
    var $b4a8a5c310566eb2$export$49841c62b9eff15;
    var $b4a8a5c310566eb2$export$a6cdc56e425d0d0a;
    var $b4a8a5c310566eb2$export$871608497c498473;
    var $b4a8a5c310566eb2$export$e6127cc7fe7395c3;
    var $b4a8a5c310566eb2$export$f6e2535fb5126e54;
    var $b4a8a5c310566eb2$export$c3825b437cbdea5c;
    var $b4a8a5c310566eb2$export$a7884ebc965f8f54;
    function $b4a8a5c310566eb2$var$isArray(arg) {
        if (Array.isArray) return Array.isArray(arg);
        return $b4a8a5c310566eb2$var$objectToString(arg) === '[object Array]';
    }
    $b4a8a5c310566eb2$export$43bee75e5e14138e = $b4a8a5c310566eb2$var$isArray;
    function $b4a8a5c310566eb2$var$isBoolean(arg) {
        return typeof arg === 'boolean';
    }
    $b4a8a5c310566eb2$export$f9ce7b637dfbe238 = $b4a8a5c310566eb2$var$isBoolean;
    function $b4a8a5c310566eb2$var$isNull(arg) {
        return arg === null;
    }
    $b4a8a5c310566eb2$export$630801d484da15df = $b4a8a5c310566eb2$var$isNull;
    function $b4a8a5c310566eb2$var$isNullOrUndefined(arg) {
        return arg == null;
    }
    $b4a8a5c310566eb2$export$bedb7023a7733221 = $b4a8a5c310566eb2$var$isNullOrUndefined;
    function $b4a8a5c310566eb2$var$isNumber(arg) {
        return typeof arg === 'number';
    }
    $b4a8a5c310566eb2$export$7e4aa119212bc614 = $b4a8a5c310566eb2$var$isNumber;
    function $b4a8a5c310566eb2$var$isString(arg) {
        return typeof arg === 'string';
    }
    $b4a8a5c310566eb2$export$844ec244b1367d54 = $b4a8a5c310566eb2$var$isString;
    function $b4a8a5c310566eb2$var$isSymbol(arg) {
        return typeof arg === 'symbol';
    }
    $b4a8a5c310566eb2$export$a244864fd9645c7f = $b4a8a5c310566eb2$var$isSymbol;
    function $b4a8a5c310566eb2$var$isUndefined(arg) {
        return arg === void 0;
    }
    $b4a8a5c310566eb2$export$fce6876652108ab = $b4a8a5c310566eb2$var$isUndefined;
    function $b4a8a5c310566eb2$var$isRegExp(re) {
        return $b4a8a5c310566eb2$var$objectToString(re) === '[object RegExp]';
    }
    $b4a8a5c310566eb2$export$49841c62b9eff15 = $b4a8a5c310566eb2$var$isRegExp;
    function $b4a8a5c310566eb2$var$isObject(arg) {
        return typeof arg === 'object' && arg !== null;
    }
    $b4a8a5c310566eb2$export$a6cdc56e425d0d0a = $b4a8a5c310566eb2$var$isObject;
    function $b4a8a5c310566eb2$var$isDate(d) {
        return $b4a8a5c310566eb2$var$objectToString(d) === '[object Date]';
    }
    $b4a8a5c310566eb2$export$871608497c498473 = $b4a8a5c310566eb2$var$isDate;
    function $b4a8a5c310566eb2$var$isError(e) {
        return $b4a8a5c310566eb2$var$objectToString(e) === '[object Error]' || e instanceof Error;
    }
    $b4a8a5c310566eb2$export$e6127cc7fe7395c3 = $b4a8a5c310566eb2$var$isError;
    function $b4a8a5c310566eb2$var$isFunction(arg) {
        return typeof arg === 'function';
    }
    $b4a8a5c310566eb2$export$f6e2535fb5126e54 = $b4a8a5c310566eb2$var$isFunction;
    function $b4a8a5c310566eb2$var$isPrimitive(arg) {
        return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined';
    }
    $b4a8a5c310566eb2$export$c3825b437cbdea5c = $b4a8a5c310566eb2$var$isPrimitive;
    $b4a8a5c310566eb2$export$a7884ebc965f8f54 = (parcelRequire("5k7LC")).Buffer.isBuffer;
    function $b4a8a5c310566eb2$var$objectToString(o) {
        return Object.prototype.toString.call(o);
    }
});
parcelRegister("ZaRag", function(module, exports) {
    'use strict';
    function $0b7e1e7e4868f65f$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $cmRjm = parcelRequire("cmRjm");
    var $0b7e1e7e4868f65f$require$Buffer = $cmRjm.Buffer;
    var $3gWwf = parcelRequire("3gWwf");
    function $0b7e1e7e4868f65f$var$copyBuffer(src, target, offset) {
        src.copy(target, offset);
    }
    module.exports = function() {
        function BufferList() {
            $0b7e1e7e4868f65f$var$_classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        BufferList.prototype.push = function push(v) {
            var entry = {
                data: v,
                next: null
            };
            if (this.length > 0) this.tail.next = entry;
            else this.head = entry;
            this.tail = entry;
            ++this.length;
        };
        BufferList.prototype.unshift = function unshift(v) {
            var entry = {
                data: v,
                next: this.head
            };
            if (this.length === 0) this.tail = entry;
            this.head = entry;
            ++this.length;
        };
        BufferList.prototype.shift = function shift() {
            if (this.length === 0) return;
            var ret = this.head.data;
            if (this.length === 1) this.head = this.tail = null;
            else this.head = this.head.next;
            --this.length;
            return ret;
        };
        BufferList.prototype.clear = function clear() {
            this.head = this.tail = null;
            this.length = 0;
        };
        BufferList.prototype.join = function join(s) {
            if (this.length === 0) return '';
            var p = this.head;
            var ret = '' + p.data;
            while(p = p.next)ret += s + p.data;
            return ret;
        };
        BufferList.prototype.concat = function concat(n) {
            if (this.length === 0) return $0b7e1e7e4868f65f$require$Buffer.alloc(0);
            var ret = $0b7e1e7e4868f65f$require$Buffer.allocUnsafe(n >>> 0);
            var p = this.head;
            var i = 0;
            while(p){
                $0b7e1e7e4868f65f$var$copyBuffer(p.data, ret, i);
                i += p.data.length;
                p = p.next;
            }
            return ret;
        };
        return BufferList;
    }();
    if ($3gWwf && $3gWwf.inspect && $3gWwf.inspect.custom) module.exports.prototype[$3gWwf.inspect.custom] = function() {
        var obj = $3gWwf.inspect({
            length: this.length
        });
        return this.constructor.name + ' ' + obj;
    };
});
parcelRegister("9tGJn", function(module, exports) {
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    function $6e67f7f8fc7376f2$var$destroy(err, cb) {
        var _this = this;
        var readableDestroyed = this._readableState && this._readableState.destroyed;
        var writableDestroyed = this._writableState && this._writableState.destroyed;
        if (readableDestroyed || writableDestroyed) {
            if (cb) cb(err);
            else if (err) {
                if (!this._writableState) $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, this, err);
                else if (!this._writableState.errorEmitted) {
                    this._writableState.errorEmitted = true;
                    $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, this, err);
                }
            }
            return this;
        }
        if (this._readableState) this._readableState.destroyed = true;
        if (this._writableState) this._writableState.destroyed = true;
        this._destroy(err || null, function(err) {
            if (!cb && err) {
                if (!_this._writableState) $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, _this, err);
                else if (!_this._writableState.errorEmitted) {
                    _this._writableState.errorEmitted = true;
                    $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, _this, err);
                }
            } else if (cb) cb(err);
        });
        return this;
    }
    function $6e67f7f8fc7376f2$var$undestroy() {
        if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
        }
        if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
        }
    }
    function $6e67f7f8fc7376f2$var$emitErrorNT(self, err) {
        self.emit('error', err);
    }
    module.exports = {
        destroy: $6e67f7f8fc7376f2$var$destroy,
        undestroy: $6e67f7f8fc7376f2$var$undestroy
    };
});
parcelRegister("fAlCy", function(module, exports) {
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    var $b58afd4655d03bd4$var$objectKeys = Object.keys || function(obj) {
        var keys = [];
        for(var key in obj)keys.push(key);
        return keys;
    };
    module.exports = $b58afd4655d03bd4$var$Duplex;
    var $b58afd4655d03bd4$var$util = Object.create((parcelRequire("fvDPy")));
    $b58afd4655d03bd4$var$util.inherits = (parcelRequire("v3bBu"));
    var $hVjIO = parcelRequire("hVjIO");
    var $3YGVr = parcelRequire("3YGVr");
    $b58afd4655d03bd4$var$util.inherits($b58afd4655d03bd4$var$Duplex, $hVjIO);
    var $b58afd4655d03bd4$var$keys = $b58afd4655d03bd4$var$objectKeys($3YGVr.prototype);
    for(var $b58afd4655d03bd4$var$v = 0; $b58afd4655d03bd4$var$v < $b58afd4655d03bd4$var$keys.length; $b58afd4655d03bd4$var$v++){
        var $b58afd4655d03bd4$var$method = $b58afd4655d03bd4$var$keys[$b58afd4655d03bd4$var$v];
        if (!$b58afd4655d03bd4$var$Duplex.prototype[$b58afd4655d03bd4$var$method]) $b58afd4655d03bd4$var$Duplex.prototype[$b58afd4655d03bd4$var$method] = $3YGVr.prototype[$b58afd4655d03bd4$var$method];
    }
    function $b58afd4655d03bd4$var$Duplex(options) {
        if (!(this instanceof $b58afd4655d03bd4$var$Duplex)) return new $b58afd4655d03bd4$var$Duplex(options);
        $hVjIO.call(this, options);
        $3YGVr.call(this, options);
        if (options && options.readable === false) this.readable = false;
        if (options && options.writable === false) this.writable = false;
        this.allowHalfOpen = true;
        if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
        this.once('end', $b58afd4655d03bd4$var$onend);
    }
    Object.defineProperty($b58afd4655d03bd4$var$Duplex.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function() {
            return this._writableState.highWaterMark;
        }
    });
    function $b58afd4655d03bd4$var$onend() {
        if (this.allowHalfOpen || this._writableState.ended) return;
        $iWV9i.nextTick($b58afd4655d03bd4$var$onEndNT, this);
    }
    function $b58afd4655d03bd4$var$onEndNT(self) {
        self.end();
    }
    Object.defineProperty($b58afd4655d03bd4$var$Duplex.prototype, 'destroyed', {
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            if (this._readableState === undefined || this._writableState === undefined) return;
            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
        }
    });
    $b58afd4655d03bd4$var$Duplex.prototype._destroy = function(err, cb) {
        this.push(null);
        this.end();
        $iWV9i.nextTick(cb, err);
    };
});
parcelRegister("3YGVr", function(module, exports) {
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    module.exports = $2e5845c95b44c650$var$Writable;
    function $2e5845c95b44c650$var$WriteReq(chunk, encoding, cb) {
        this.chunk = chunk;
        this.encoding = encoding;
        this.callback = cb;
        this.next = null;
    }
    function $2e5845c95b44c650$var$CorkedRequest(state) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function() {
            $2e5845c95b44c650$var$onCorkedFinish(_this, state);
        };
    }
    var $2e5845c95b44c650$var$asyncWrite = (0, $iWV9i.nextTick);
    var $2e5845c95b44c650$var$Duplex;
    $2e5845c95b44c650$var$Writable.WritableState = $2e5845c95b44c650$var$WritableState;
    var $2e5845c95b44c650$var$util = Object.create((parcelRequire("fvDPy")));
    $2e5845c95b44c650$var$util.inherits = (parcelRequire("v3bBu"));
    var $2e5845c95b44c650$var$internalUtil = {
        deprecate: (parcelRequire("geQ6V"))
    };
    var $4t6fq = parcelRequire("4t6fq");
    var $cmRjm = parcelRequire("cmRjm");
    var $2e5845c95b44c650$require$Buffer = $cmRjm.Buffer;
    var $2e5845c95b44c650$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $2e5845c95b44c650$var$_uint8ArrayToBuffer(chunk) {
        return $2e5845c95b44c650$require$Buffer.from(chunk);
    }
    function $2e5845c95b44c650$var$_isUint8Array(obj) {
        return $2e5845c95b44c650$require$Buffer.isBuffer(obj) || obj instanceof $2e5845c95b44c650$var$OurUint8Array;
    }
    var $9tGJn = parcelRequire("9tGJn");
    $2e5845c95b44c650$var$util.inherits($2e5845c95b44c650$var$Writable, $4t6fq);
    function $2e5845c95b44c650$var$nop() {}
    function $2e5845c95b44c650$var$WritableState(options, stream) {
        $2e5845c95b44c650$var$Duplex = $2e5845c95b44c650$var$Duplex || (parcelRequire("fAlCy"));
        options = options || {};
        var isDuplex = stream instanceof $2e5845c95b44c650$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
        var hwm = options.highWaterMark;
        var writableHwm = options.writableHighWaterMark;
        var defaultHwm = this.objectMode ? 16 : 16384;
        if (hwm || hwm === 0) this.highWaterMark = hwm;
        else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
        else this.highWaterMark = defaultHwm;
        this.highWaterMark = Math.floor(this.highWaterMark);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        var noDecode = options.decodeStrings === false;
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = function(er) {
            $2e5845c95b44c650$var$onwrite(stream, er);
        };
        this.writecb = null;
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        this.pendingcb = 0;
        this.prefinished = false;
        this.errorEmitted = false;
        this.bufferedRequestCount = 0;
        this.corkedRequestsFree = new $2e5845c95b44c650$var$CorkedRequest(this);
    }
    $2e5845c95b44c650$var$WritableState.prototype.getBuffer = function getBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    (function() {
        try {
            Object.defineProperty($2e5845c95b44c650$var$WritableState.prototype, 'buffer', {
                get: $2e5845c95b44c650$var$internalUtil.deprecate(function() {
                    return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
            });
        } catch (_) {}
    })();
    var $2e5845c95b44c650$var$realHasInstance;
    if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
        $2e5845c95b44c650$var$realHasInstance = Function.prototype[Symbol.hasInstance];
        Object.defineProperty($2e5845c95b44c650$var$Writable, Symbol.hasInstance, {
            value: function(object) {
                if ($2e5845c95b44c650$var$realHasInstance.call(this, object)) return true;
                if (this !== $2e5845c95b44c650$var$Writable) return false;
                return object && object._writableState instanceof $2e5845c95b44c650$var$WritableState;
            }
        });
    } else $2e5845c95b44c650$var$realHasInstance = function(object) {
        return object instanceof this;
    };
    function $2e5845c95b44c650$var$Writable(options) {
        $2e5845c95b44c650$var$Duplex = $2e5845c95b44c650$var$Duplex || (parcelRequire("fAlCy"));
        if (!$2e5845c95b44c650$var$realHasInstance.call($2e5845c95b44c650$var$Writable, this) && !(this instanceof $2e5845c95b44c650$var$Duplex)) return new $2e5845c95b44c650$var$Writable(options);
        this._writableState = new $2e5845c95b44c650$var$WritableState(options, this);
        this.writable = true;
        if (options) {
            if (typeof options.write === 'function') this._write = options.write;
            if (typeof options.writev === 'function') this._writev = options.writev;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
            if (typeof options.final === 'function') this._final = options.final;
        }
        $4t6fq.call(this);
    }
    $2e5845c95b44c650$var$Writable.prototype.pipe = function() {
        this.emit('error', new Error('Cannot pipe, not readable'));
    };
    function $2e5845c95b44c650$var$writeAfterEnd(stream, cb) {
        var er = new Error('write after end');
        stream.emit('error', er);
        $iWV9i.nextTick(cb, er);
    }
    function $2e5845c95b44c650$var$validChunk(stream, state, chunk, cb) {
        var valid = true;
        var er = false;
        if (chunk === null) er = new TypeError('May not write null values to stream');
        else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
        if (er) {
            stream.emit('error', er);
            $iWV9i.nextTick(cb, er);
            valid = false;
        }
        return valid;
    }
    $2e5845c95b44c650$var$Writable.prototype.write = function(chunk, encoding, cb) {
        var state = this._writableState;
        var ret = false;
        var isBuf = !state.objectMode && $2e5845c95b44c650$var$_isUint8Array(chunk);
        if (isBuf && !$2e5845c95b44c650$require$Buffer.isBuffer(chunk)) chunk = $2e5845c95b44c650$var$_uint8ArrayToBuffer(chunk);
        if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (isBuf) encoding = 'buffer';
        else if (!encoding) encoding = state.defaultEncoding;
        if (typeof cb !== 'function') cb = $2e5845c95b44c650$var$nop;
        if (state.ended) $2e5845c95b44c650$var$writeAfterEnd(this, cb);
        else if (isBuf || $2e5845c95b44c650$var$validChunk(this, state, chunk, cb)) {
            state.pendingcb++;
            ret = $2e5845c95b44c650$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
        }
        return ret;
    };
    $2e5845c95b44c650$var$Writable.prototype.cork = function() {
        var state = this._writableState;
        state.corked++;
    };
    $2e5845c95b44c650$var$Writable.prototype.uncork = function() {
        var state = this._writableState;
        if (state.corked) {
            state.corked--;
            if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2e5845c95b44c650$var$clearBuffer(this, state);
        }
    };
    $2e5845c95b44c650$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === 'string') encoding = encoding.toLowerCase();
        if (!([
            'hex',
            'utf8',
            'utf-8',
            'ascii',
            'binary',
            'base64',
            'ucs2',
            'ucs-2',
            'utf16le',
            'utf-16le',
            'raw'
        ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    function $2e5845c95b44c650$var$decodeChunk(state, chunk, encoding) {
        if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2e5845c95b44c650$require$Buffer.from(chunk, encoding);
        return chunk;
    }
    Object.defineProperty($2e5845c95b44c650$var$Writable.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function() {
            return this._writableState.highWaterMark;
        }
    });
    function $2e5845c95b44c650$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
        if (!isBuf) {
            var newChunk = $2e5845c95b44c650$var$decodeChunk(state, chunk, encoding);
            if (chunk !== newChunk) {
                isBuf = true;
                encoding = 'buffer';
                chunk = newChunk;
            }
        }
        var len = state.objectMode ? 1 : chunk.length;
        state.length += len;
        var ret = state.length < state.highWaterMark;
        if (!ret) state.needDrain = true;
        if (state.writing || state.corked) {
            var last = state.lastBufferedRequest;
            state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
            };
            if (last) last.next = state.lastBufferedRequest;
            else state.bufferedRequest = state.lastBufferedRequest;
            state.bufferedRequestCount += 1;
        } else $2e5845c95b44c650$var$doWrite(stream, state, false, len, chunk, encoding, cb);
        return ret;
    }
    function $2e5845c95b44c650$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
        state.writelen = len;
        state.writecb = cb;
        state.writing = true;
        state.sync = true;
        if (writev) stream._writev(chunk, state.onwrite);
        else stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    function $2e5845c95b44c650$var$onwriteError(stream, state, sync, er, cb) {
        --state.pendingcb;
        if (sync) {
            $iWV9i.nextTick(cb, er);
            $iWV9i.nextTick($2e5845c95b44c650$var$finishMaybe, stream, state);
            stream._writableState.errorEmitted = true;
            stream.emit('error', er);
        } else {
            cb(er);
            stream._writableState.errorEmitted = true;
            stream.emit('error', er);
            $2e5845c95b44c650$var$finishMaybe(stream, state);
        }
    }
    function $2e5845c95b44c650$var$onwriteStateUpdate(state) {
        state.writing = false;
        state.writecb = null;
        state.length -= state.writelen;
        state.writelen = 0;
    }
    function $2e5845c95b44c650$var$onwrite(stream, er) {
        var state = stream._writableState;
        var sync = state.sync;
        var cb = state.writecb;
        $2e5845c95b44c650$var$onwriteStateUpdate(state);
        if (er) $2e5845c95b44c650$var$onwriteError(stream, state, sync, er, cb);
        else {
            var finished = $2e5845c95b44c650$var$needFinish(state);
            if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2e5845c95b44c650$var$clearBuffer(stream, state);
            if (sync) $2e5845c95b44c650$var$asyncWrite($2e5845c95b44c650$var$afterWrite, stream, state, finished, cb);
            else $2e5845c95b44c650$var$afterWrite(stream, state, finished, cb);
        }
    }
    function $2e5845c95b44c650$var$afterWrite(stream, state, finished, cb) {
        if (!finished) $2e5845c95b44c650$var$onwriteDrain(stream, state);
        state.pendingcb--;
        cb();
        $2e5845c95b44c650$var$finishMaybe(stream, state);
    }
    function $2e5845c95b44c650$var$onwriteDrain(stream, state) {
        if (state.length === 0 && state.needDrain) {
            state.needDrain = false;
            stream.emit('drain');
        }
    }
    function $2e5845c95b44c650$var$clearBuffer(stream, state) {
        state.bufferProcessing = true;
        var entry = state.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            var l = state.bufferedRequestCount;
            var buffer = new Array(l);
            var holder = state.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            var allBuffers = true;
            while(entry){
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
            }
            buffer.allBuffers = allBuffers;
            $2e5845c95b44c650$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
            state.pendingcb++;
            state.lastBufferedRequest = null;
            if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state.corkedRequestsFree = new $2e5845c95b44c650$var$CorkedRequest(state);
            state.bufferedRequestCount = 0;
        } else {
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                $2e5845c95b44c650$var$doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--;
                if (state.writing) break;
            }
            if (entry === null) state.lastBufferedRequest = null;
        }
        state.bufferedRequest = entry;
        state.bufferProcessing = false;
    }
    $2e5845c95b44c650$var$Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new Error('_write() is not implemented'));
    };
    $2e5845c95b44c650$var$Writable.prototype._writev = null;
    $2e5845c95b44c650$var$Writable.prototype.end = function(chunk, encoding, cb) {
        var state = this._writableState;
        if (typeof chunk === 'function') {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
        if (state.corked) {
            state.corked = 1;
            this.uncork();
        }
        if (!state.ending) $2e5845c95b44c650$var$endWritable(this, state, cb);
    };
    function $2e5845c95b44c650$var$needFinish(state) {
        return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }
    function $2e5845c95b44c650$var$callFinal(stream, state) {
        stream._final(function(err) {
            state.pendingcb--;
            if (err) stream.emit('error', err);
            state.prefinished = true;
            stream.emit('prefinish');
            $2e5845c95b44c650$var$finishMaybe(stream, state);
        });
    }
    function $2e5845c95b44c650$var$prefinish(stream, state) {
        if (!state.prefinished && !state.finalCalled) {
            if (typeof stream._final === 'function') {
                state.pendingcb++;
                state.finalCalled = true;
                $iWV9i.nextTick($2e5845c95b44c650$var$callFinal, stream, state);
            } else {
                state.prefinished = true;
                stream.emit('prefinish');
            }
        }
    }
    function $2e5845c95b44c650$var$finishMaybe(stream, state) {
        var need = $2e5845c95b44c650$var$needFinish(state);
        if (need) {
            $2e5845c95b44c650$var$prefinish(stream, state);
            if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit('finish');
            }
        }
        return need;
    }
    function $2e5845c95b44c650$var$endWritable(stream, state, cb) {
        state.ending = true;
        $2e5845c95b44c650$var$finishMaybe(stream, state);
        if (cb) {
            if (state.finished) $iWV9i.nextTick(cb);
            else stream.once('finish', cb);
        }
        state.ended = true;
        stream.writable = false;
    }
    function $2e5845c95b44c650$var$onCorkedFinish(corkReq, state, err) {
        var entry = corkReq.entry;
        corkReq.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        state.corkedRequestsFree.next = corkReq;
    }
    Object.defineProperty($2e5845c95b44c650$var$Writable.prototype, 'destroyed', {
        get: function() {
            if (this._writableState === undefined) return false;
            return this._writableState.destroyed;
        },
        set: function(value) {
            if (!this._writableState) return;
            this._writableState.destroyed = value;
        }
    });
    $2e5845c95b44c650$var$Writable.prototype.destroy = $9tGJn.destroy;
    $2e5845c95b44c650$var$Writable.prototype._undestroy = $9tGJn.undestroy;
    $2e5845c95b44c650$var$Writable.prototype._destroy = function(err, cb) {
        this.end();
        cb(err);
    };
});
parcelRegister("6ayCS", function(module, exports) {
    $parcel$export(module.exports, "StringDecoder", ()=>$0128c026524ba8eb$export$63a7aa211a91ed69, (v)=>$0128c026524ba8eb$export$63a7aa211a91ed69 = v);
    var $0128c026524ba8eb$export$63a7aa211a91ed69;
    'use strict';
    var $cmRjm = parcelRequire("cmRjm");
    var $0128c026524ba8eb$require$Buffer = $cmRjm.Buffer;
    var $0128c026524ba8eb$var$isEncoding = $0128c026524ba8eb$require$Buffer.isEncoding || function(encoding) {
        encoding = '' + encoding;
        switch(encoding && encoding.toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
            case 'raw':
                return true;
            default:
                return false;
        }
    };
    function $0128c026524ba8eb$var$_normalizeEncoding(enc) {
        if (!enc) return 'utf8';
        var retried;
        while(true)switch(enc){
            case 'utf8':
            case 'utf-8':
                return 'utf8';
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return 'utf16le';
            case 'latin1':
            case 'binary':
                return 'latin1';
            case 'base64':
            case 'ascii':
            case 'hex':
                return enc;
            default:
                if (retried) return;
                enc = ('' + enc).toLowerCase();
                retried = true;
        }
    }
    function $0128c026524ba8eb$var$normalizeEncoding(enc) {
        var nenc = $0128c026524ba8eb$var$_normalizeEncoding(enc);
        if (typeof nenc !== 'string' && ($0128c026524ba8eb$require$Buffer.isEncoding === $0128c026524ba8eb$var$isEncoding || !$0128c026524ba8eb$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
        return nenc || enc;
    }
    $0128c026524ba8eb$export$63a7aa211a91ed69 = $0128c026524ba8eb$var$StringDecoder;
    function $0128c026524ba8eb$var$StringDecoder(encoding) {
        this.encoding = $0128c026524ba8eb$var$normalizeEncoding(encoding);
        var nb;
        switch(this.encoding){
            case 'utf16le':
                this.text = $0128c026524ba8eb$var$utf16Text;
                this.end = $0128c026524ba8eb$var$utf16End;
                nb = 4;
                break;
            case 'utf8':
                this.fillLast = $0128c026524ba8eb$var$utf8FillLast;
                nb = 4;
                break;
            case 'base64':
                this.text = $0128c026524ba8eb$var$base64Text;
                this.end = $0128c026524ba8eb$var$base64End;
                nb = 3;
                break;
            default:
                this.write = $0128c026524ba8eb$var$simpleWrite;
                this.end = $0128c026524ba8eb$var$simpleEnd;
                return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = $0128c026524ba8eb$require$Buffer.allocUnsafe(nb);
    }
    $0128c026524ba8eb$var$StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return '';
        var r;
        var i;
        if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === undefined) return '';
            i = this.lastNeed;
            this.lastNeed = 0;
        } else i = 0;
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || '';
    };
    $0128c026524ba8eb$var$StringDecoder.prototype.end = $0128c026524ba8eb$var$utf8End;
    $0128c026524ba8eb$var$StringDecoder.prototype.text = $0128c026524ba8eb$var$utf8Text;
    $0128c026524ba8eb$var$StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
    };
    function $0128c026524ba8eb$var$utf8CheckByte(byte) {
        if (byte <= 0x7F) return 0;
        else if (byte >> 5 === 0x06) return 2;
        else if (byte >> 4 === 0x0E) return 3;
        else if (byte >> 3 === 0x1E) return 4;
        return byte >> 6 === 0x02 ? -1 : -2;
    }
    function $0128c026524ba8eb$var$utf8CheckIncomplete(self, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 1;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 2;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) {
                if (nb === 2) nb = 0;
                else self.lastNeed = nb - 3;
            }
            return nb;
        }
        return 0;
    }
    function $0128c026524ba8eb$var$utf8CheckExtraBytes(self, buf, p) {
        if ((buf[0] & 0xC0) !== 0x80) {
            self.lastNeed = 0;
            return '\ufffd';
        }
        if (self.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 0xC0) !== 0x80) {
                self.lastNeed = 1;
                return '\ufffd';
            }
            if (self.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 0xC0) !== 0x80) {
                    self.lastNeed = 2;
                    return '\ufffd';
                }
            }
        }
    }
    function $0128c026524ba8eb$var$utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = $0128c026524ba8eb$var$utf8CheckExtraBytes(this, buf, p);
        if (r !== undefined) return r;
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
    }
    function $0128c026524ba8eb$var$utf8Text(buf, i) {
        var total = $0128c026524ba8eb$var$utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString('utf8', i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString('utf8', i, end);
    }
    function $0128c026524ba8eb$var$utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + '\ufffd';
        return r;
    }
    function $0128c026524ba8eb$var$utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
            var r = buf.toString('utf16le', i);
            if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 0xD800 && c <= 0xDBFF) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                }
            }
            return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString('utf16le', i, buf.length - 1);
    }
    function $0128c026524ba8eb$var$utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) {
            var end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString('utf16le', 0, end);
        }
        return r;
    }
    function $0128c026524ba8eb$var$base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString('base64', i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) this.lastChar[0] = buf[buf.length - 1];
        else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString('base64', i, buf.length - n);
    }
    function $0128c026524ba8eb$var$base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
        return r;
    }
    function $0128c026524ba8eb$var$simpleWrite(buf) {
        return buf.toString(this.encoding);
    }
    function $0128c026524ba8eb$var$simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : '';
    }
});
parcelRegister("8iQyH", function(module, exports) {
    'use strict';
    module.exports = $60b8c636590317a6$var$Transform;
    var $fAlCy = parcelRequire("fAlCy");
    var $60b8c636590317a6$var$util = Object.create((parcelRequire("fvDPy")));
    $60b8c636590317a6$var$util.inherits = (parcelRequire("v3bBu"));
    $60b8c636590317a6$var$util.inherits($60b8c636590317a6$var$Transform, $fAlCy);
    function $60b8c636590317a6$var$afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (!cb) return this.emit('error', new Error('write callback called multiple times'));
        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
    function $60b8c636590317a6$var$Transform(options) {
        if (!(this instanceof $60b8c636590317a6$var$Transform)) return new $60b8c636590317a6$var$Transform(options);
        $fAlCy.call(this, options);
        this._transformState = {
            afterTransform: $60b8c636590317a6$var$afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null
        };
        this._readableState.needReadable = true;
        this._readableState.sync = false;
        if (options) {
            if (typeof options.transform === 'function') this._transform = options.transform;
            if (typeof options.flush === 'function') this._flush = options.flush;
        }
        this.on('prefinish', $60b8c636590317a6$var$prefinish);
    }
    function $60b8c636590317a6$var$prefinish() {
        var _this = this;
        if (typeof this._flush === 'function') this._flush(function(er, data) {
            $60b8c636590317a6$var$done(_this, er, data);
        });
        else $60b8c636590317a6$var$done(this, null, null);
    }
    $60b8c636590317a6$var$Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return $fAlCy.prototype.push.call(this, chunk, encoding);
    };
    $60b8c636590317a6$var$Transform.prototype._transform = function(chunk, encoding, cb) {
        throw new Error('_transform() is not implemented');
    };
    $60b8c636590317a6$var$Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    $60b8c636590317a6$var$Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else ts.needTransform = true;
    };
    $60b8c636590317a6$var$Transform.prototype._destroy = function(err, cb) {
        var _this2 = this;
        $fAlCy.prototype._destroy.call(this, err, function(err2) {
            cb(err2);
            _this2.emit('close');
        });
    };
    function $60b8c636590317a6$var$done(stream, er, data) {
        if (er) return stream.emit('error', er);
        if (data != null) stream.push(data);
        if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
        if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
        return stream.push(null);
    }
});
parcelRegister("WEefO", function(module, exports) {
    'use strict';
    module.exports = $0b049f8430f02ec4$var$PassThrough;
    var $8iQyH = parcelRequire("8iQyH");
    var $0b049f8430f02ec4$var$util = Object.create((parcelRequire("fvDPy")));
    $0b049f8430f02ec4$var$util.inherits = (parcelRequire("v3bBu"));
    $0b049f8430f02ec4$var$util.inherits($0b049f8430f02ec4$var$PassThrough, $8iQyH);
    function $0b049f8430f02ec4$var$PassThrough(options) {
        if (!(this instanceof $0b049f8430f02ec4$var$PassThrough)) return new $0b049f8430f02ec4$var$PassThrough(options);
        $8iQyH.call(this, options);
    }
    $0b049f8430f02ec4$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
});
parcelRegister("kYhYb", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $f44759abe9feb4ae$require$Buffer = $Wth4q.Buffer;
    var $j65bP = parcelRequire("j65bP");
    var $cfrZu;
    var $8JoQd = parcelRequire("8JoQd");
    var $f44759abe9feb4ae$require$EC = $8JoQd.ec;
    var $bxS53 = parcelRequire("bxS53");
    var $ejFGc = parcelRequire("ejFGc");
    var $jf5f0 = parcelRequire("jf5f0");
    var $f44759abe9feb4ae$var$RSA_PKCS1_PADDING = 1;
    function $f44759abe9feb4ae$var$sign(hash, key, hashType, signType, tag) {
        var priv = $ejFGc(key);
        if (priv.curve) {
            if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
            return $f44759abe9feb4ae$var$ecSign(hash, priv);
        } else if (priv.type === 'dsa') {
            if (signType !== 'dsa') throw new Error('wrong private key type');
            return $f44759abe9feb4ae$var$dsaSign(hash, priv, hashType);
        }
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        if (key.padding !== undefined && key.padding !== $f44759abe9feb4ae$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
        hash = $f44759abe9feb4ae$require$Buffer.concat([
            tag,
            hash
        ]);
        var len = priv.modulus.byteLength();
        var pad = [
            0,
            1
        ];
        while(hash.length + pad.length + 1 < len)pad.push(0xff);
        pad.push(0x00);
        var i = -1;
        while(++i < hash.length)pad.push(hash[i]);
        var out = (0, parcelRequire("cfrZu"))(pad, priv);
        return out;
    }
    function $f44759abe9feb4ae$var$ecSign(hash, priv) {
        var curveId = $jf5f0[priv.curve.join('.')];
        if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
        var curve = new $f44759abe9feb4ae$require$EC(curveId);
        var key = curve.keyFromPrivate(priv.privateKey);
        var out = key.sign(hash);
        return $f44759abe9feb4ae$require$Buffer.from(out.toDER());
    }
    function $f44759abe9feb4ae$var$dsaSign(hash, priv, algo) {
        var x = priv.params.priv_key;
        var p = priv.params.p;
        var q = priv.params.q;
        var g = priv.params.g;
        var r = new $bxS53(0);
        var k;
        var H = $f44759abe9feb4ae$var$bits2int(hash, q).mod(q);
        var s = false;
        var kv = $f44759abe9feb4ae$var$getKey(x, q, hash, algo);
        while(s === false){
            k = $f44759abe9feb4ae$var$makeKey(q, kv, algo);
            r = $f44759abe9feb4ae$var$makeR(g, k, p, q);
            s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
            if (s.cmpn(0) === 0) {
                s = false;
                r = new $bxS53(0);
            }
        }
        return $f44759abe9feb4ae$var$toDER(r, s);
    }
    function $f44759abe9feb4ae$var$toDER(r, s) {
        r = r.toArray();
        s = s.toArray();
        if (r[0] & 0x80) r = [
            0
        ].concat(r);
        if (s[0] & 0x80) s = [
            0
        ].concat(s);
        var total = r.length + s.length + 4;
        var res = [
            0x30,
            total,
            0x02,
            r.length
        ];
        res = res.concat(r, [
            0x02,
            s.length
        ], s);
        return $f44759abe9feb4ae$require$Buffer.from(res);
    }
    function $f44759abe9feb4ae$var$getKey(x, q, hash, algo) {
        x = $f44759abe9feb4ae$require$Buffer.from(x.toArray());
        if (x.length < q.byteLength()) {
            var zeros = $f44759abe9feb4ae$require$Buffer.alloc(q.byteLength() - x.length);
            x = $f44759abe9feb4ae$require$Buffer.concat([
                zeros,
                x
            ]);
        }
        var hlen = hash.length;
        var hbits = $f44759abe9feb4ae$var$bits2octets(hash, q);
        var v = $f44759abe9feb4ae$require$Buffer.alloc(hlen);
        v.fill(1);
        var k = $f44759abe9feb4ae$require$Buffer.alloc(hlen);
        k = $j65bP(algo, k).update(v).update($f44759abe9feb4ae$require$Buffer.from([
            0
        ])).update(x).update(hbits).digest();
        v = $j65bP(algo, k).update(v).digest();
        k = $j65bP(algo, k).update(v).update($f44759abe9feb4ae$require$Buffer.from([
            1
        ])).update(x).update(hbits).digest();
        v = $j65bP(algo, k).update(v).digest();
        return {
            k: k,
            v: v
        };
    }
    function $f44759abe9feb4ae$var$bits2int(obits, q) {
        var bits = new $bxS53(obits);
        var shift = (obits.length << 3) - q.bitLength();
        if (shift > 0) bits.ishrn(shift);
        return bits;
    }
    function $f44759abe9feb4ae$var$bits2octets(bits, q) {
        bits = $f44759abe9feb4ae$var$bits2int(bits, q);
        bits = bits.mod(q);
        var out = $f44759abe9feb4ae$require$Buffer.from(bits.toArray());
        if (out.length < q.byteLength()) {
            var zeros = $f44759abe9feb4ae$require$Buffer.alloc(q.byteLength() - out.length);
            out = $f44759abe9feb4ae$require$Buffer.concat([
                zeros,
                out
            ]);
        }
        return out;
    }
    function $f44759abe9feb4ae$var$makeKey(q, kv, algo) {
        var t;
        var k;
        do {
            t = $f44759abe9feb4ae$require$Buffer.alloc(0);
            while(t.length * 8 < q.bitLength()){
                kv.v = $j65bP(algo, kv.k).update(kv.v).digest();
                t = $f44759abe9feb4ae$require$Buffer.concat([
                    t,
                    kv.v
                ]);
            }
            k = $f44759abe9feb4ae$var$bits2int(t, q);
            kv.k = $j65bP(algo, kv.k).update(kv.v).update($f44759abe9feb4ae$require$Buffer.from([
                0
            ])).digest();
            kv.v = $j65bP(algo, kv.k).update(kv.v).digest();
        }while (k.cmp(q) !== -1)
        return k;
    }
    function $f44759abe9feb4ae$var$makeR(g, k, p, q) {
        return g.toRed($bxS53.mont(p)).redPow(k).fromRed().mod(q);
    }
    module.exports = $f44759abe9feb4ae$var$sign;
    module.exports.getKey = $f44759abe9feb4ae$var$getKey;
    module.exports.makeKey = $f44759abe9feb4ae$var$makeKey;
});
parcelRegister("cfrZu", function(module, exports) {
    'use strict';
    var $bSSUf = parcelRequire("bSSUf");
    var $1DyI6 = parcelRequire("1DyI6");
    var $Wth4q = parcelRequire("Wth4q");
    var $8eac99241a98d6c0$require$Buffer = $Wth4q.Buffer;
    function $8eac99241a98d6c0$var$getr(priv) {
        var len = priv.modulus.byteLength();
        var r;
        do r = new $bSSUf($1DyI6(len));
        while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
        return r;
    }
    function $8eac99241a98d6c0$var$blind(priv) {
        var r = $8eac99241a98d6c0$var$getr(priv);
        var blinder = r.toRed($bSSUf.mont(priv.modulus)).redPow(new $bSSUf(priv.publicExponent)).fromRed();
        return {
            blinder: blinder,
            unblinder: r.invm(priv.modulus)
        };
    }
    function $8eac99241a98d6c0$var$crt(msg, priv) {
        var blinds = $8eac99241a98d6c0$var$blind(priv);
        var len = priv.modulus.byteLength();
        var blinded = new $bSSUf(msg).mul(blinds.blinder).umod(priv.modulus);
        var c1 = blinded.toRed($bSSUf.mont(priv.prime1));
        var c2 = blinded.toRed($bSSUf.mont(priv.prime2));
        var qinv = priv.coefficient;
        var p = priv.prime1;
        var q = priv.prime2;
        var m1 = c1.redPow(priv.exponent1).fromRed();
        var m2 = c2.redPow(priv.exponent2).fromRed();
        var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
        return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($8eac99241a98d6c0$require$Buffer, 'be', len);
    }
    $8eac99241a98d6c0$var$crt.getr = $8eac99241a98d6c0$var$getr;
    module.exports = $8eac99241a98d6c0$var$crt;
});
parcelRegister("bSSUf", function(module, exports) {
    (function(module1, exports) {
        'use strict';
        function assert(val, msg) {
            if (!val) throw new Error(msg || 'Assertion failed');
        }
        function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
        function BN(number, base, endian) {
            if (BN.isBN(number)) return number;
            this.negative = 0;
            this.words = null;
            this.length = 0;
            this.red = null;
            if (number !== null) {
                if (base === 'le' || base === 'be') {
                    endian = base;
                    base = 10;
                }
                this._init(number || 0, base || 10, endian || 'be');
            }
        }
        if (typeof module1 === 'object') module1.exports = BN;
        else exports.BN = BN;
        BN.BN = BN;
        BN.wordSize = 26;
        var Buffer;
        try {
            if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
            else Buffer = (parcelRequire("3gWwf")).Buffer;
        } catch (e) {}
        BN.isBN = function isBN(num) {
            if (num instanceof BN) return true;
            return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };
        BN.max = function max(left, right) {
            if (left.cmp(right) > 0) return left;
            return right;
        };
        BN.min = function min(left, right) {
            if (left.cmp(right) < 0) return left;
            return right;
        };
        BN.prototype._init = function init(number, base, endian) {
            if (typeof number === 'number') return this._initNumber(number, base, endian);
            if (typeof number === 'object') return this._initArray(number, base, endian);
            if (base === 'hex') base = 16;
            assert(base === (base | 0) && base >= 2 && base <= 36);
            number = number.toString().replace(/\s+/g, '');
            var start = 0;
            if (number[0] === '-') {
                start++;
                this.negative = 1;
            }
            if (start < number.length) {
                if (base === 16) this._parseHex(number, start, endian);
                else {
                    this._parseBase(number, base, start);
                    if (endian === 'le') this._initArray(this.toArray(), base, endian);
                }
            }
        };
        BN.prototype._initNumber = function _initNumber(number, base, endian) {
            if (number < 0) {
                this.negative = 1;
                number = -number;
            }
            if (number < 0x4000000) {
                this.words = [
                    number & 0x3ffffff
                ];
                this.length = 1;
            } else if (number < 0x10000000000000) {
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff
                ];
                this.length = 2;
            } else {
                assert(number < 0x20000000000000);
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff,
                    1
                ];
                this.length = 3;
            }
            if (endian !== 'le') return;
            this._initArray(this.toArray(), base, endian);
        };
        BN.prototype._initArray = function _initArray(number, base, endian) {
            assert(typeof number.length === 'number');
            if (number.length <= 0) {
                this.words = [
                    0
                ];
                this.length = 1;
                return this;
            }
            this.length = Math.ceil(number.length / 3);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var j, w;
            var off = 0;
            if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            return this._strip();
        };
        function parseHex4Bits(string, index) {
            var c = string.charCodeAt(index);
            if (c >= 48 && c <= 57) return c - 48;
            else if (c >= 65 && c <= 70) return c - 55;
            else if (c >= 97 && c <= 102) return c - 87;
            else assert(false, 'Invalid character in ' + string);
        }
        function parseHexByte(string, lowerBound, index) {
            var r = parseHex4Bits(string, index);
            if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
            return r;
        }
        BN.prototype._parseHex = function _parseHex(number, start, endian) {
            this.length = Math.ceil((number.length - start) / 6);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var off = 0;
            var j = 0;
            var w;
            if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
            else {
                var parseLength = number.length - start;
                for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                    w = parseHexByte(number, start, i) << off;
                    this.words[j] |= w & 0x3ffffff;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
            }
            this._strip();
        };
        function parseBase(str, start, end, mul) {
            var r = 0;
            var b = 0;
            var len = Math.min(str.length, end);
            for(var i = start; i < len; i++){
                var c = str.charCodeAt(i) - 48;
                r *= mul;
                if (c >= 49) b = c - 49 + 0xa;
                else if (c >= 17) b = c - 17 + 0xa;
                else b = c;
                assert(c >= 0 && b < mul, 'Invalid character');
                r += b;
            }
            return r;
        }
        BN.prototype._parseBase = function _parseBase(number, base, start) {
            this.words = [
                0
            ];
            this.length = 1;
            for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
            limbLen--;
            limbPow = limbPow / base | 0;
            var total = number.length - start;
            var mod = total % limbLen;
            var end = Math.min(total, total - mod) + start;
            var word = 0;
            for(var i = start; i < end; i += limbLen){
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for(i = 0; i < mod; i++)pow *= base;
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            this._strip();
        };
        BN.prototype.copy = function copy(dest) {
            dest.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
            dest.length = this.length;
            dest.negative = this.negative;
            dest.red = this.red;
        };
        function move(dest, src) {
            dest.words = src.words;
            dest.length = src.length;
            dest.negative = src.negative;
            dest.red = src.red;
        }
        BN.prototype._move = function _move(dest) {
            move(dest, this);
        };
        BN.prototype.clone = function clone() {
            var r = new BN(null);
            this.copy(r);
            return r;
        };
        BN.prototype._expand = function _expand(size) {
            while(this.length < size)this.words[this.length++] = 0;
            return this;
        };
        BN.prototype._strip = function strip() {
            while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
            return this._normSign();
        };
        BN.prototype._normSign = function _normSign() {
            if (this.length === 1 && this.words[0] === 0) this.negative = 0;
            return this;
        };
        if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
            BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
        } catch (e) {
            BN.prototype.inspect = inspect;
        }
        else BN.prototype.inspect = inspect;
        function inspect() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        }
        var zeros = [
            '',
            '0',
            '00',
            '000',
            '0000',
            '00000',
            '000000',
            '0000000',
            '00000000',
            '000000000',
            '0000000000',
            '00000000000',
            '000000000000',
            '0000000000000',
            '00000000000000',
            '000000000000000',
            '0000000000000000',
            '00000000000000000',
            '000000000000000000',
            '0000000000000000000',
            '00000000000000000000',
            '000000000000000000000',
            '0000000000000000000000',
            '00000000000000000000000',
            '000000000000000000000000',
            '0000000000000000000000000'
        ];
        var groupSizes = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ];
        var groupBases = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            10000000,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64000000,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            24300000,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        BN.prototype.toString = function toString(base, padding) {
            base = base || 10;
            padding = padding | 0 || 1;
            var out;
            if (base === 16 || base === 'hex') {
                out = '';
                var off = 0;
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = this.words[i];
                    var word = ((w << off | carry) & 0xffffff).toString(16);
                    carry = w >>> 24 - off & 0xffffff;
                    off += 2;
                    if (off >= 26) {
                        off -= 26;
                        i--;
                    }
                    if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                    else out = word + out;
                }
                if (carry !== 0) out = carry.toString(16) + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            if (base === (base | 0) && base >= 2 && base <= 36) {
                var groupSize = groupSizes[base];
                var groupBase = groupBases[base];
                out = '';
                var c = this.clone();
                c.negative = 0;
                while(!c.isZero()){
                    var r = c.modrn(groupBase).toString(base);
                    c = c.idivn(groupBase);
                    if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                    else out = r + out;
                }
                if (this.isZero()) out = '0' + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            assert(false, 'Base should be between 2 and 36');
        };
        BN.prototype.toNumber = function toNumber() {
            var ret = this.words[0];
            if (this.length === 2) ret += this.words[1] * 0x4000000;
            else if (this.length === 3 && this.words[2] === 0x01) ret += 0x10000000000000 + this.words[1] * 0x4000000;
            else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
            return this.negative !== 0 ? -ret : ret;
        };
        BN.prototype.toJSON = function toJSON() {
            return this.toString(16, 2);
        };
        if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
            return this.toArrayLike(Buffer, endian, length);
        };
        BN.prototype.toArray = function toArray(endian, length) {
            return this.toArrayLike(Array, endian, length);
        };
        var allocate = function allocate(ArrayType, size) {
            if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
            return new ArrayType(size);
        };
        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
            this._strip();
            var byteLength = this.byteLength();
            var reqLength = length || Math.max(1, byteLength);
            assert(byteLength <= reqLength, 'byte array longer than desired length');
            assert(reqLength > 0, 'Requested array length <= 0');
            var res = allocate(ArrayType, reqLength);
            var postfix = endian === 'le' ? 'LE' : 'BE';
            this['_toArrayLike' + postfix](res, byteLength);
            return res;
        };
        BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
            var position = 0;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position++] = word & 0xff;
                if (position < res.length) res[position++] = word >> 8 & 0xff;
                if (position < res.length) res[position++] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position < res.length) res[position++] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position < res.length) {
                res[position++] = carry;
                while(position < res.length)res[position++] = 0;
            }
        };
        BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
            var position = res.length - 1;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position--] = word & 0xff;
                if (position >= 0) res[position--] = word >> 8 & 0xff;
                if (position >= 0) res[position--] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position >= 0) res[position--] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position >= 0) {
                res[position--] = carry;
                while(position >= 0)res[position--] = 0;
            }
        };
        if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
        };
        else BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
                r += 13;
                t >>>= 13;
            }
            if (t >= 0x40) {
                r += 7;
                t >>>= 7;
            }
            if (t >= 0x8) {
                r += 4;
                t >>>= 4;
            }
            if (t >= 0x02) {
                r += 2;
                t >>>= 2;
            }
            return r + t;
        };
        BN.prototype._zeroBits = function _zeroBits(w) {
            if (w === 0) return 26;
            var t = w;
            var r = 0;
            if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
            }
            if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
            }
            if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
            }
            if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
            }
            if ((t & 0x1) === 0) r++;
            return r;
        };
        BN.prototype.bitLength = function bitLength() {
            var w = this.words[this.length - 1];
            var hi = this._countBits(w);
            return (this.length - 1) * 26 + hi;
        };
        function toBitArray(num) {
            var w = new Array(num.bitLength());
            for(var bit = 0; bit < w.length; bit++){
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                w[bit] = num.words[off] >>> wbit & 0x01;
            }
            return w;
        }
        BN.prototype.zeroBits = function zeroBits() {
            if (this.isZero()) return 0;
            var r = 0;
            for(var i = 0; i < this.length; i++){
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
            }
            return r;
        };
        BN.prototype.byteLength = function byteLength() {
            return Math.ceil(this.bitLength() / 8);
        };
        BN.prototype.toTwos = function toTwos(width) {
            if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
            return this.clone();
        };
        BN.prototype.fromTwos = function fromTwos(width) {
            if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
            return this.clone();
        };
        BN.prototype.isNeg = function isNeg() {
            return this.negative !== 0;
        };
        BN.prototype.neg = function neg() {
            return this.clone().ineg();
        };
        BN.prototype.ineg = function ineg() {
            if (!this.isZero()) this.negative ^= 1;
            return this;
        };
        BN.prototype.iuor = function iuor(num) {
            while(this.length < num.length)this.words[this.length++] = 0;
            for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
            return this._strip();
        };
        BN.prototype.ior = function ior(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuor(num);
        };
        BN.prototype.or = function or(num) {
            if (this.length > num.length) return this.clone().ior(num);
            return num.clone().ior(this);
        };
        BN.prototype.uor = function uor(num) {
            if (this.length > num.length) return this.clone().iuor(num);
            return num.clone().iuor(this);
        };
        BN.prototype.iuand = function iuand(num) {
            var b;
            if (this.length > num.length) b = num;
            else b = this;
            for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
            this.length = b.length;
            return this._strip();
        };
        BN.prototype.iand = function iand(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuand(num);
        };
        BN.prototype.and = function and(num) {
            if (this.length > num.length) return this.clone().iand(num);
            return num.clone().iand(this);
        };
        BN.prototype.uand = function uand(num) {
            if (this.length > num.length) return this.clone().iuand(num);
            return num.clone().iuand(this);
        };
        BN.prototype.iuxor = function iuxor(num) {
            var a;
            var b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
            if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = a.length;
            return this._strip();
        };
        BN.prototype.ixor = function ixor(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuxor(num);
        };
        BN.prototype.xor = function xor(num) {
            if (this.length > num.length) return this.clone().ixor(num);
            return num.clone().ixor(this);
        };
        BN.prototype.uxor = function uxor(num) {
            if (this.length > num.length) return this.clone().iuxor(num);
            return num.clone().iuxor(this);
        };
        BN.prototype.inotn = function inotn(width) {
            assert(typeof width === 'number' && width >= 0);
            var bytesNeeded = Math.ceil(width / 26) | 0;
            var bitsLeft = width % 26;
            this._expand(bytesNeeded);
            if (bitsLeft > 0) bytesNeeded--;
            for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
            if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            return this._strip();
        };
        BN.prototype.notn = function notn(width) {
            return this.clone().inotn(width);
        };
        BN.prototype.setn = function setn(bit, val) {
            assert(typeof bit === 'number' && bit >= 0);
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            this._expand(off + 1);
            if (val) this.words[off] = this.words[off] | 1 << wbit;
            else this.words[off] = this.words[off] & ~(1 << wbit);
            return this._strip();
        };
        BN.prototype.iadd = function iadd(num) {
            var r;
            if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign();
            } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
            }
            var a, b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            this.length = a.length;
            if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++;
            } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            return this;
        };
        BN.prototype.add = function add(num) {
            var res;
            if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
            } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
            }
            if (this.length > num.length) return this.clone().iadd(num);
            return num.clone().iadd(this);
        };
        BN.prototype.isub = function isub(num) {
            if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign();
            } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
            }
            var cmp = this.cmp(num);
            if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
            }
            var a, b;
            if (cmp > 0) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = Math.max(this.length, i);
            if (a !== this) this.negative = 1;
            return this._strip();
        };
        BN.prototype.sub = function sub(num) {
            return this.clone().isub(num);
        };
        function smallMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            var len = self.length + num.length | 0;
            out.length = len;
            len = len - 1 | 0;
            var a = self.words[0] | 0;
            var b = num.words[0] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            var carry = r / 0x4000000 | 0;
            out.words[0] = lo;
            for(var k = 1; k < len; k++){
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j | 0;
                    a = self.words[i] | 0;
                    b = num.words[j] | 0;
                    r = a * b + rword;
                    ncarry += r / 0x4000000 | 0;
                    rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
            }
            if (carry !== 0) out.words[k] = carry | 0;
            else out.length--;
            return out._strip();
        }
        var comb10MulTo = function comb10MulTo(self, num, out) {
            var a = self.words;
            var b = num.words;
            var o = out.words;
            var c = 0;
            var lo;
            var mid;
            var hi;
            var a0 = a[0] | 0;
            var al0 = a0 & 0x1fff;
            var ah0 = a0 >>> 13;
            var a1 = a[1] | 0;
            var al1 = a1 & 0x1fff;
            var ah1 = a1 >>> 13;
            var a2 = a[2] | 0;
            var al2 = a2 & 0x1fff;
            var ah2 = a2 >>> 13;
            var a3 = a[3] | 0;
            var al3 = a3 & 0x1fff;
            var ah3 = a3 >>> 13;
            var a4 = a[4] | 0;
            var al4 = a4 & 0x1fff;
            var ah4 = a4 >>> 13;
            var a5 = a[5] | 0;
            var al5 = a5 & 0x1fff;
            var ah5 = a5 >>> 13;
            var a6 = a[6] | 0;
            var al6 = a6 & 0x1fff;
            var ah6 = a6 >>> 13;
            var a7 = a[7] | 0;
            var al7 = a7 & 0x1fff;
            var ah7 = a7 >>> 13;
            var a8 = a[8] | 0;
            var al8 = a8 & 0x1fff;
            var ah8 = a8 >>> 13;
            var a9 = a[9] | 0;
            var al9 = a9 & 0x1fff;
            var ah9 = a9 >>> 13;
            var b0 = b[0] | 0;
            var bl0 = b0 & 0x1fff;
            var bh0 = b0 >>> 13;
            var b1 = b[1] | 0;
            var bl1 = b1 & 0x1fff;
            var bh1 = b1 >>> 13;
            var b2 = b[2] | 0;
            var bl2 = b2 & 0x1fff;
            var bh2 = b2 >>> 13;
            var b3 = b[3] | 0;
            var bl3 = b3 & 0x1fff;
            var bh3 = b3 >>> 13;
            var b4 = b[4] | 0;
            var bl4 = b4 & 0x1fff;
            var bh4 = b4 >>> 13;
            var b5 = b[5] | 0;
            var bl5 = b5 & 0x1fff;
            var bh5 = b5 >>> 13;
            var b6 = b[6] | 0;
            var bl6 = b6 & 0x1fff;
            var bh6 = b6 >>> 13;
            var b7 = b[7] | 0;
            var bl7 = b7 & 0x1fff;
            var bh7 = b7 >>> 13;
            var b8 = b[8] | 0;
            var bl8 = b8 & 0x1fff;
            var bh8 = b8 >>> 13;
            var b9 = b[9] | 0;
            var bl9 = b9 & 0x1fff;
            var bh9 = b9 >>> 13;
            out.negative = self.negative ^ num.negative;
            out.length = 19;
            lo = Math.imul(al0, bl0);
            mid = Math.imul(al0, bh0);
            mid = mid + Math.imul(ah0, bl0) | 0;
            hi = Math.imul(ah0, bh0);
            var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
            w0 &= 0x3ffffff;
            lo = Math.imul(al1, bl0);
            mid = Math.imul(al1, bh0);
            mid = mid + Math.imul(ah1, bl0) | 0;
            hi = Math.imul(ah1, bh0);
            lo = lo + Math.imul(al0, bl1) | 0;
            mid = mid + Math.imul(al0, bh1) | 0;
            mid = mid + Math.imul(ah0, bl1) | 0;
            hi = hi + Math.imul(ah0, bh1) | 0;
            var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
            w1 &= 0x3ffffff;
            lo = Math.imul(al2, bl0);
            mid = Math.imul(al2, bh0);
            mid = mid + Math.imul(ah2, bl0) | 0;
            hi = Math.imul(ah2, bh0);
            lo = lo + Math.imul(al1, bl1) | 0;
            mid = mid + Math.imul(al1, bh1) | 0;
            mid = mid + Math.imul(ah1, bl1) | 0;
            hi = hi + Math.imul(ah1, bh1) | 0;
            lo = lo + Math.imul(al0, bl2) | 0;
            mid = mid + Math.imul(al0, bh2) | 0;
            mid = mid + Math.imul(ah0, bl2) | 0;
            hi = hi + Math.imul(ah0, bh2) | 0;
            var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
            w2 &= 0x3ffffff;
            lo = Math.imul(al3, bl0);
            mid = Math.imul(al3, bh0);
            mid = mid + Math.imul(ah3, bl0) | 0;
            hi = Math.imul(ah3, bh0);
            lo = lo + Math.imul(al2, bl1) | 0;
            mid = mid + Math.imul(al2, bh1) | 0;
            mid = mid + Math.imul(ah2, bl1) | 0;
            hi = hi + Math.imul(ah2, bh1) | 0;
            lo = lo + Math.imul(al1, bl2) | 0;
            mid = mid + Math.imul(al1, bh2) | 0;
            mid = mid + Math.imul(ah1, bl2) | 0;
            hi = hi + Math.imul(ah1, bh2) | 0;
            lo = lo + Math.imul(al0, bl3) | 0;
            mid = mid + Math.imul(al0, bh3) | 0;
            mid = mid + Math.imul(ah0, bl3) | 0;
            hi = hi + Math.imul(ah0, bh3) | 0;
            var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
            w3 &= 0x3ffffff;
            lo = Math.imul(al4, bl0);
            mid = Math.imul(al4, bh0);
            mid = mid + Math.imul(ah4, bl0) | 0;
            hi = Math.imul(ah4, bh0);
            lo = lo + Math.imul(al3, bl1) | 0;
            mid = mid + Math.imul(al3, bh1) | 0;
            mid = mid + Math.imul(ah3, bl1) | 0;
            hi = hi + Math.imul(ah3, bh1) | 0;
            lo = lo + Math.imul(al2, bl2) | 0;
            mid = mid + Math.imul(al2, bh2) | 0;
            mid = mid + Math.imul(ah2, bl2) | 0;
            hi = hi + Math.imul(ah2, bh2) | 0;
            lo = lo + Math.imul(al1, bl3) | 0;
            mid = mid + Math.imul(al1, bh3) | 0;
            mid = mid + Math.imul(ah1, bl3) | 0;
            hi = hi + Math.imul(ah1, bh3) | 0;
            lo = lo + Math.imul(al0, bl4) | 0;
            mid = mid + Math.imul(al0, bh4) | 0;
            mid = mid + Math.imul(ah0, bl4) | 0;
            hi = hi + Math.imul(ah0, bh4) | 0;
            var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
            w4 &= 0x3ffffff;
            lo = Math.imul(al5, bl0);
            mid = Math.imul(al5, bh0);
            mid = mid + Math.imul(ah5, bl0) | 0;
            hi = Math.imul(ah5, bh0);
            lo = lo + Math.imul(al4, bl1) | 0;
            mid = mid + Math.imul(al4, bh1) | 0;
            mid = mid + Math.imul(ah4, bl1) | 0;
            hi = hi + Math.imul(ah4, bh1) | 0;
            lo = lo + Math.imul(al3, bl2) | 0;
            mid = mid + Math.imul(al3, bh2) | 0;
            mid = mid + Math.imul(ah3, bl2) | 0;
            hi = hi + Math.imul(ah3, bh2) | 0;
            lo = lo + Math.imul(al2, bl3) | 0;
            mid = mid + Math.imul(al2, bh3) | 0;
            mid = mid + Math.imul(ah2, bl3) | 0;
            hi = hi + Math.imul(ah2, bh3) | 0;
            lo = lo + Math.imul(al1, bl4) | 0;
            mid = mid + Math.imul(al1, bh4) | 0;
            mid = mid + Math.imul(ah1, bl4) | 0;
            hi = hi + Math.imul(ah1, bh4) | 0;
            lo = lo + Math.imul(al0, bl5) | 0;
            mid = mid + Math.imul(al0, bh5) | 0;
            mid = mid + Math.imul(ah0, bl5) | 0;
            hi = hi + Math.imul(ah0, bh5) | 0;
            var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
            w5 &= 0x3ffffff;
            lo = Math.imul(al6, bl0);
            mid = Math.imul(al6, bh0);
            mid = mid + Math.imul(ah6, bl0) | 0;
            hi = Math.imul(ah6, bh0);
            lo = lo + Math.imul(al5, bl1) | 0;
            mid = mid + Math.imul(al5, bh1) | 0;
            mid = mid + Math.imul(ah5, bl1) | 0;
            hi = hi + Math.imul(ah5, bh1) | 0;
            lo = lo + Math.imul(al4, bl2) | 0;
            mid = mid + Math.imul(al4, bh2) | 0;
            mid = mid + Math.imul(ah4, bl2) | 0;
            hi = hi + Math.imul(ah4, bh2) | 0;
            lo = lo + Math.imul(al3, bl3) | 0;
            mid = mid + Math.imul(al3, bh3) | 0;
            mid = mid + Math.imul(ah3, bl3) | 0;
            hi = hi + Math.imul(ah3, bh3) | 0;
            lo = lo + Math.imul(al2, bl4) | 0;
            mid = mid + Math.imul(al2, bh4) | 0;
            mid = mid + Math.imul(ah2, bl4) | 0;
            hi = hi + Math.imul(ah2, bh4) | 0;
            lo = lo + Math.imul(al1, bl5) | 0;
            mid = mid + Math.imul(al1, bh5) | 0;
            mid = mid + Math.imul(ah1, bl5) | 0;
            hi = hi + Math.imul(ah1, bh5) | 0;
            lo = lo + Math.imul(al0, bl6) | 0;
            mid = mid + Math.imul(al0, bh6) | 0;
            mid = mid + Math.imul(ah0, bl6) | 0;
            hi = hi + Math.imul(ah0, bh6) | 0;
            var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
            w6 &= 0x3ffffff;
            lo = Math.imul(al7, bl0);
            mid = Math.imul(al7, bh0);
            mid = mid + Math.imul(ah7, bl0) | 0;
            hi = Math.imul(ah7, bh0);
            lo = lo + Math.imul(al6, bl1) | 0;
            mid = mid + Math.imul(al6, bh1) | 0;
            mid = mid + Math.imul(ah6, bl1) | 0;
            hi = hi + Math.imul(ah6, bh1) | 0;
            lo = lo + Math.imul(al5, bl2) | 0;
            mid = mid + Math.imul(al5, bh2) | 0;
            mid = mid + Math.imul(ah5, bl2) | 0;
            hi = hi + Math.imul(ah5, bh2) | 0;
            lo = lo + Math.imul(al4, bl3) | 0;
            mid = mid + Math.imul(al4, bh3) | 0;
            mid = mid + Math.imul(ah4, bl3) | 0;
            hi = hi + Math.imul(ah4, bh3) | 0;
            lo = lo + Math.imul(al3, bl4) | 0;
            mid = mid + Math.imul(al3, bh4) | 0;
            mid = mid + Math.imul(ah3, bl4) | 0;
            hi = hi + Math.imul(ah3, bh4) | 0;
            lo = lo + Math.imul(al2, bl5) | 0;
            mid = mid + Math.imul(al2, bh5) | 0;
            mid = mid + Math.imul(ah2, bl5) | 0;
            hi = hi + Math.imul(ah2, bh5) | 0;
            lo = lo + Math.imul(al1, bl6) | 0;
            mid = mid + Math.imul(al1, bh6) | 0;
            mid = mid + Math.imul(ah1, bl6) | 0;
            hi = hi + Math.imul(ah1, bh6) | 0;
            lo = lo + Math.imul(al0, bl7) | 0;
            mid = mid + Math.imul(al0, bh7) | 0;
            mid = mid + Math.imul(ah0, bl7) | 0;
            hi = hi + Math.imul(ah0, bh7) | 0;
            var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
            w7 &= 0x3ffffff;
            lo = Math.imul(al8, bl0);
            mid = Math.imul(al8, bh0);
            mid = mid + Math.imul(ah8, bl0) | 0;
            hi = Math.imul(ah8, bh0);
            lo = lo + Math.imul(al7, bl1) | 0;
            mid = mid + Math.imul(al7, bh1) | 0;
            mid = mid + Math.imul(ah7, bl1) | 0;
            hi = hi + Math.imul(ah7, bh1) | 0;
            lo = lo + Math.imul(al6, bl2) | 0;
            mid = mid + Math.imul(al6, bh2) | 0;
            mid = mid + Math.imul(ah6, bl2) | 0;
            hi = hi + Math.imul(ah6, bh2) | 0;
            lo = lo + Math.imul(al5, bl3) | 0;
            mid = mid + Math.imul(al5, bh3) | 0;
            mid = mid + Math.imul(ah5, bl3) | 0;
            hi = hi + Math.imul(ah5, bh3) | 0;
            lo = lo + Math.imul(al4, bl4) | 0;
            mid = mid + Math.imul(al4, bh4) | 0;
            mid = mid + Math.imul(ah4, bl4) | 0;
            hi = hi + Math.imul(ah4, bh4) | 0;
            lo = lo + Math.imul(al3, bl5) | 0;
            mid = mid + Math.imul(al3, bh5) | 0;
            mid = mid + Math.imul(ah3, bl5) | 0;
            hi = hi + Math.imul(ah3, bh5) | 0;
            lo = lo + Math.imul(al2, bl6) | 0;
            mid = mid + Math.imul(al2, bh6) | 0;
            mid = mid + Math.imul(ah2, bl6) | 0;
            hi = hi + Math.imul(ah2, bh6) | 0;
            lo = lo + Math.imul(al1, bl7) | 0;
            mid = mid + Math.imul(al1, bh7) | 0;
            mid = mid + Math.imul(ah1, bl7) | 0;
            hi = hi + Math.imul(ah1, bh7) | 0;
            lo = lo + Math.imul(al0, bl8) | 0;
            mid = mid + Math.imul(al0, bh8) | 0;
            mid = mid + Math.imul(ah0, bl8) | 0;
            hi = hi + Math.imul(ah0, bh8) | 0;
            var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
            w8 &= 0x3ffffff;
            lo = Math.imul(al9, bl0);
            mid = Math.imul(al9, bh0);
            mid = mid + Math.imul(ah9, bl0) | 0;
            hi = Math.imul(ah9, bh0);
            lo = lo + Math.imul(al8, bl1) | 0;
            mid = mid + Math.imul(al8, bh1) | 0;
            mid = mid + Math.imul(ah8, bl1) | 0;
            hi = hi + Math.imul(ah8, bh1) | 0;
            lo = lo + Math.imul(al7, bl2) | 0;
            mid = mid + Math.imul(al7, bh2) | 0;
            mid = mid + Math.imul(ah7, bl2) | 0;
            hi = hi + Math.imul(ah7, bh2) | 0;
            lo = lo + Math.imul(al6, bl3) | 0;
            mid = mid + Math.imul(al6, bh3) | 0;
            mid = mid + Math.imul(ah6, bl3) | 0;
            hi = hi + Math.imul(ah6, bh3) | 0;
            lo = lo + Math.imul(al5, bl4) | 0;
            mid = mid + Math.imul(al5, bh4) | 0;
            mid = mid + Math.imul(ah5, bl4) | 0;
            hi = hi + Math.imul(ah5, bh4) | 0;
            lo = lo + Math.imul(al4, bl5) | 0;
            mid = mid + Math.imul(al4, bh5) | 0;
            mid = mid + Math.imul(ah4, bl5) | 0;
            hi = hi + Math.imul(ah4, bh5) | 0;
            lo = lo + Math.imul(al3, bl6) | 0;
            mid = mid + Math.imul(al3, bh6) | 0;
            mid = mid + Math.imul(ah3, bl6) | 0;
            hi = hi + Math.imul(ah3, bh6) | 0;
            lo = lo + Math.imul(al2, bl7) | 0;
            mid = mid + Math.imul(al2, bh7) | 0;
            mid = mid + Math.imul(ah2, bl7) | 0;
            hi = hi + Math.imul(ah2, bh7) | 0;
            lo = lo + Math.imul(al1, bl8) | 0;
            mid = mid + Math.imul(al1, bh8) | 0;
            mid = mid + Math.imul(ah1, bl8) | 0;
            hi = hi + Math.imul(ah1, bh8) | 0;
            lo = lo + Math.imul(al0, bl9) | 0;
            mid = mid + Math.imul(al0, bh9) | 0;
            mid = mid + Math.imul(ah0, bl9) | 0;
            hi = hi + Math.imul(ah0, bh9) | 0;
            var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
            w9 &= 0x3ffffff;
            lo = Math.imul(al9, bl1);
            mid = Math.imul(al9, bh1);
            mid = mid + Math.imul(ah9, bl1) | 0;
            hi = Math.imul(ah9, bh1);
            lo = lo + Math.imul(al8, bl2) | 0;
            mid = mid + Math.imul(al8, bh2) | 0;
            mid = mid + Math.imul(ah8, bl2) | 0;
            hi = hi + Math.imul(ah8, bh2) | 0;
            lo = lo + Math.imul(al7, bl3) | 0;
            mid = mid + Math.imul(al7, bh3) | 0;
            mid = mid + Math.imul(ah7, bl3) | 0;
            hi = hi + Math.imul(ah7, bh3) | 0;
            lo = lo + Math.imul(al6, bl4) | 0;
            mid = mid + Math.imul(al6, bh4) | 0;
            mid = mid + Math.imul(ah6, bl4) | 0;
            hi = hi + Math.imul(ah6, bh4) | 0;
            lo = lo + Math.imul(al5, bl5) | 0;
            mid = mid + Math.imul(al5, bh5) | 0;
            mid = mid + Math.imul(ah5, bl5) | 0;
            hi = hi + Math.imul(ah5, bh5) | 0;
            lo = lo + Math.imul(al4, bl6) | 0;
            mid = mid + Math.imul(al4, bh6) | 0;
            mid = mid + Math.imul(ah4, bl6) | 0;
            hi = hi + Math.imul(ah4, bh6) | 0;
            lo = lo + Math.imul(al3, bl7) | 0;
            mid = mid + Math.imul(al3, bh7) | 0;
            mid = mid + Math.imul(ah3, bl7) | 0;
            hi = hi + Math.imul(ah3, bh7) | 0;
            lo = lo + Math.imul(al2, bl8) | 0;
            mid = mid + Math.imul(al2, bh8) | 0;
            mid = mid + Math.imul(ah2, bl8) | 0;
            hi = hi + Math.imul(ah2, bh8) | 0;
            lo = lo + Math.imul(al1, bl9) | 0;
            mid = mid + Math.imul(al1, bh9) | 0;
            mid = mid + Math.imul(ah1, bl9) | 0;
            hi = hi + Math.imul(ah1, bh9) | 0;
            var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
            w10 &= 0x3ffffff;
            lo = Math.imul(al9, bl2);
            mid = Math.imul(al9, bh2);
            mid = mid + Math.imul(ah9, bl2) | 0;
            hi = Math.imul(ah9, bh2);
            lo = lo + Math.imul(al8, bl3) | 0;
            mid = mid + Math.imul(al8, bh3) | 0;
            mid = mid + Math.imul(ah8, bl3) | 0;
            hi = hi + Math.imul(ah8, bh3) | 0;
            lo = lo + Math.imul(al7, bl4) | 0;
            mid = mid + Math.imul(al7, bh4) | 0;
            mid = mid + Math.imul(ah7, bl4) | 0;
            hi = hi + Math.imul(ah7, bh4) | 0;
            lo = lo + Math.imul(al6, bl5) | 0;
            mid = mid + Math.imul(al6, bh5) | 0;
            mid = mid + Math.imul(ah6, bl5) | 0;
            hi = hi + Math.imul(ah6, bh5) | 0;
            lo = lo + Math.imul(al5, bl6) | 0;
            mid = mid + Math.imul(al5, bh6) | 0;
            mid = mid + Math.imul(ah5, bl6) | 0;
            hi = hi + Math.imul(ah5, bh6) | 0;
            lo = lo + Math.imul(al4, bl7) | 0;
            mid = mid + Math.imul(al4, bh7) | 0;
            mid = mid + Math.imul(ah4, bl7) | 0;
            hi = hi + Math.imul(ah4, bh7) | 0;
            lo = lo + Math.imul(al3, bl8) | 0;
            mid = mid + Math.imul(al3, bh8) | 0;
            mid = mid + Math.imul(ah3, bl8) | 0;
            hi = hi + Math.imul(ah3, bh8) | 0;
            lo = lo + Math.imul(al2, bl9) | 0;
            mid = mid + Math.imul(al2, bh9) | 0;
            mid = mid + Math.imul(ah2, bl9) | 0;
            hi = hi + Math.imul(ah2, bh9) | 0;
            var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
            w11 &= 0x3ffffff;
            lo = Math.imul(al9, bl3);
            mid = Math.imul(al9, bh3);
            mid = mid + Math.imul(ah9, bl3) | 0;
            hi = Math.imul(ah9, bh3);
            lo = lo + Math.imul(al8, bl4) | 0;
            mid = mid + Math.imul(al8, bh4) | 0;
            mid = mid + Math.imul(ah8, bl4) | 0;
            hi = hi + Math.imul(ah8, bh4) | 0;
            lo = lo + Math.imul(al7, bl5) | 0;
            mid = mid + Math.imul(al7, bh5) | 0;
            mid = mid + Math.imul(ah7, bl5) | 0;
            hi = hi + Math.imul(ah7, bh5) | 0;
            lo = lo + Math.imul(al6, bl6) | 0;
            mid = mid + Math.imul(al6, bh6) | 0;
            mid = mid + Math.imul(ah6, bl6) | 0;
            hi = hi + Math.imul(ah6, bh6) | 0;
            lo = lo + Math.imul(al5, bl7) | 0;
            mid = mid + Math.imul(al5, bh7) | 0;
            mid = mid + Math.imul(ah5, bl7) | 0;
            hi = hi + Math.imul(ah5, bh7) | 0;
            lo = lo + Math.imul(al4, bl8) | 0;
            mid = mid + Math.imul(al4, bh8) | 0;
            mid = mid + Math.imul(ah4, bl8) | 0;
            hi = hi + Math.imul(ah4, bh8) | 0;
            lo = lo + Math.imul(al3, bl9) | 0;
            mid = mid + Math.imul(al3, bh9) | 0;
            mid = mid + Math.imul(ah3, bl9) | 0;
            hi = hi + Math.imul(ah3, bh9) | 0;
            var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
            w12 &= 0x3ffffff;
            lo = Math.imul(al9, bl4);
            mid = Math.imul(al9, bh4);
            mid = mid + Math.imul(ah9, bl4) | 0;
            hi = Math.imul(ah9, bh4);
            lo = lo + Math.imul(al8, bl5) | 0;
            mid = mid + Math.imul(al8, bh5) | 0;
            mid = mid + Math.imul(ah8, bl5) | 0;
            hi = hi + Math.imul(ah8, bh5) | 0;
            lo = lo + Math.imul(al7, bl6) | 0;
            mid = mid + Math.imul(al7, bh6) | 0;
            mid = mid + Math.imul(ah7, bl6) | 0;
            hi = hi + Math.imul(ah7, bh6) | 0;
            lo = lo + Math.imul(al6, bl7) | 0;
            mid = mid + Math.imul(al6, bh7) | 0;
            mid = mid + Math.imul(ah6, bl7) | 0;
            hi = hi + Math.imul(ah6, bh7) | 0;
            lo = lo + Math.imul(al5, bl8) | 0;
            mid = mid + Math.imul(al5, bh8) | 0;
            mid = mid + Math.imul(ah5, bl8) | 0;
            hi = hi + Math.imul(ah5, bh8) | 0;
            lo = lo + Math.imul(al4, bl9) | 0;
            mid = mid + Math.imul(al4, bh9) | 0;
            mid = mid + Math.imul(ah4, bl9) | 0;
            hi = hi + Math.imul(ah4, bh9) | 0;
            var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
            w13 &= 0x3ffffff;
            lo = Math.imul(al9, bl5);
            mid = Math.imul(al9, bh5);
            mid = mid + Math.imul(ah9, bl5) | 0;
            hi = Math.imul(ah9, bh5);
            lo = lo + Math.imul(al8, bl6) | 0;
            mid = mid + Math.imul(al8, bh6) | 0;
            mid = mid + Math.imul(ah8, bl6) | 0;
            hi = hi + Math.imul(ah8, bh6) | 0;
            lo = lo + Math.imul(al7, bl7) | 0;
            mid = mid + Math.imul(al7, bh7) | 0;
            mid = mid + Math.imul(ah7, bl7) | 0;
            hi = hi + Math.imul(ah7, bh7) | 0;
            lo = lo + Math.imul(al6, bl8) | 0;
            mid = mid + Math.imul(al6, bh8) | 0;
            mid = mid + Math.imul(ah6, bl8) | 0;
            hi = hi + Math.imul(ah6, bh8) | 0;
            lo = lo + Math.imul(al5, bl9) | 0;
            mid = mid + Math.imul(al5, bh9) | 0;
            mid = mid + Math.imul(ah5, bl9) | 0;
            hi = hi + Math.imul(ah5, bh9) | 0;
            var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
            w14 &= 0x3ffffff;
            lo = Math.imul(al9, bl6);
            mid = Math.imul(al9, bh6);
            mid = mid + Math.imul(ah9, bl6) | 0;
            hi = Math.imul(ah9, bh6);
            lo = lo + Math.imul(al8, bl7) | 0;
            mid = mid + Math.imul(al8, bh7) | 0;
            mid = mid + Math.imul(ah8, bl7) | 0;
            hi = hi + Math.imul(ah8, bh7) | 0;
            lo = lo + Math.imul(al7, bl8) | 0;
            mid = mid + Math.imul(al7, bh8) | 0;
            mid = mid + Math.imul(ah7, bl8) | 0;
            hi = hi + Math.imul(ah7, bh8) | 0;
            lo = lo + Math.imul(al6, bl9) | 0;
            mid = mid + Math.imul(al6, bh9) | 0;
            mid = mid + Math.imul(ah6, bl9) | 0;
            hi = hi + Math.imul(ah6, bh9) | 0;
            var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
            w15 &= 0x3ffffff;
            lo = Math.imul(al9, bl7);
            mid = Math.imul(al9, bh7);
            mid = mid + Math.imul(ah9, bl7) | 0;
            hi = Math.imul(ah9, bh7);
            lo = lo + Math.imul(al8, bl8) | 0;
            mid = mid + Math.imul(al8, bh8) | 0;
            mid = mid + Math.imul(ah8, bl8) | 0;
            hi = hi + Math.imul(ah8, bh8) | 0;
            lo = lo + Math.imul(al7, bl9) | 0;
            mid = mid + Math.imul(al7, bh9) | 0;
            mid = mid + Math.imul(ah7, bl9) | 0;
            hi = hi + Math.imul(ah7, bh9) | 0;
            var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
            w16 &= 0x3ffffff;
            lo = Math.imul(al9, bl8);
            mid = Math.imul(al9, bh8);
            mid = mid + Math.imul(ah9, bl8) | 0;
            hi = Math.imul(ah9, bh8);
            lo = lo + Math.imul(al8, bl9) | 0;
            mid = mid + Math.imul(al8, bh9) | 0;
            mid = mid + Math.imul(ah8, bl9) | 0;
            hi = hi + Math.imul(ah8, bh9) | 0;
            var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
            w17 &= 0x3ffffff;
            lo = Math.imul(al9, bl9);
            mid = Math.imul(al9, bh9);
            mid = mid + Math.imul(ah9, bl9) | 0;
            hi = Math.imul(ah9, bh9);
            var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
            w18 &= 0x3ffffff;
            o[0] = w0;
            o[1] = w1;
            o[2] = w2;
            o[3] = w3;
            o[4] = w4;
            o[5] = w5;
            o[6] = w6;
            o[7] = w7;
            o[8] = w8;
            o[9] = w9;
            o[10] = w10;
            o[11] = w11;
            o[12] = w12;
            o[13] = w13;
            o[14] = w14;
            o[15] = w15;
            o[16] = w16;
            o[17] = w17;
            o[18] = w18;
            if (c !== 0) {
                o[19] = c;
                out.length++;
            }
            return out;
        };
        if (!Math.imul) comb10MulTo = smallMulTo;
        function bigMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            out.length = self.length + num.length;
            var carry = 0;
            var hncarry = 0;
            for(var k = 0; k < out.length - 1; k++){
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j;
                    var a = self.words[i] | 0;
                    var b = num.words[j] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                    lo = lo + rword | 0;
                    rword = lo & 0x3ffffff;
                    ncarry = ncarry + (lo >>> 26) | 0;
                    hncarry += ncarry >>> 26;
                    ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
            }
            if (carry !== 0) out.words[k] = carry;
            else out.length--;
            return out._strip();
        }
        function jumboMulTo(self, num, out) {
            return bigMulTo(self, num, out);
        }
        BN.prototype.mulTo = function mulTo(num, out) {
            var res;
            var len = this.length + num.length;
            if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
            else if (len < 63) res = smallMulTo(this, num, out);
            else if (len < 1024) res = bigMulTo(this, num, out);
            else res = jumboMulTo(this, num, out);
            return res;
        };
        function FFTM(x, y) {
            this.x = x;
            this.y = y;
        }
        FFTM.prototype.makeRBT = function makeRBT(N) {
            var t = new Array(N);
            var l = BN.prototype._countBits(N) - 1;
            for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
            return t;
        };
        FFTM.prototype.revBin = function revBin(x, l, N) {
            if (x === 0 || x === N - 1) return x;
            var rb = 0;
            for(var i = 0; i < l; i++){
                rb |= (x & 1) << l - i - 1;
                x >>= 1;
            }
            return rb;
        };
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
            for(var i = 0; i < N; i++){
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
            }
        };
        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
            this.permute(rbt, rws, iws, rtws, itws, N);
            for(var s = 1; s < N; s <<= 1){
                var l = s << 1;
                var rtwdf = Math.cos(2 * Math.PI / l);
                var itwdf = Math.sin(2 * Math.PI / l);
                for(var p = 0; p < N; p += l){
                    var rtwdf_ = rtwdf;
                    var itwdf_ = itwdf;
                    for(var j = 0; j < s; j++){
                        var re = rtws[p + j];
                        var ie = itws[p + j];
                        var ro = rtws[p + j + s];
                        var io = itws[p + j + s];
                        var rx = rtwdf_ * ro - itwdf_ * io;
                        io = rtwdf_ * io + itwdf_ * ro;
                        ro = rx;
                        rtws[p + j] = re + ro;
                        itws[p + j] = ie + io;
                        rtws[p + j + s] = re - ro;
                        itws[p + j + s] = ie - io;
                        if (j !== l) {
                            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                            rtwdf_ = rx;
                        }
                    }
                }
            }
        };
        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
            var N = Math.max(m, n) | 1;
            var odd = N & 1;
            var i = 0;
            for(N = N / 2 | 0; N; N = N >>> 1)i++;
            return 1 << i + 1 + odd;
        };
        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
            if (N <= 1) return;
            for(var i = 0; i < N / 2; i++){
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
            }
        };
        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
            var carry = 0;
            for(var i = 0; i < N / 2; i++){
                var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) carry = 0;
                else carry = w / 0x4000000 | 0;
            }
            return ws;
        };
        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
            var carry = 0;
            for(var i = 0; i < len; i++){
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
            }
            for(i = 2 * len; i < N; ++i)rws[i] = 0;
            assert(carry === 0);
            assert((carry & -8192) === 0);
        };
        FFTM.prototype.stub = function stub(N) {
            var ph = new Array(N);
            for(var i = 0; i < N; i++)ph[i] = 0;
            return ph;
        };
        FFTM.prototype.mulp = function mulp(x, y, out) {
            var N = 2 * this.guessLen13b(x.length, y.length);
            var rbt = this.makeRBT(N);
            var _ = this.stub(N);
            var rws = new Array(N);
            var rwst = new Array(N);
            var iwst = new Array(N);
            var nrws = new Array(N);
            var nrwst = new Array(N);
            var niwst = new Array(N);
            var rmws = out.words;
            rmws.length = N;
            this.convert13b(x.words, x.length, rws, N);
            this.convert13b(y.words, y.length, nrws, N);
            this.transform(rws, _, rwst, iwst, N, rbt);
            this.transform(nrws, _, nrwst, niwst, N, rbt);
            for(var i = 0; i < N; i++){
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
            }
            this.conjugate(rwst, iwst, N);
            this.transform(rwst, iwst, rmws, _, N, rbt);
            this.conjugate(rmws, _, N);
            this.normalize13b(rmws, N);
            out.negative = x.negative ^ y.negative;
            out.length = x.length + y.length;
            return out._strip();
        };
        BN.prototype.mul = function mul(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return this.mulTo(num, out);
        };
        BN.prototype.mulf = function mulf(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return jumboMulTo(this, num, out);
        };
        BN.prototype.imul = function imul(num) {
            return this.clone().mulTo(num, this);
        };
        BN.prototype.imuln = function imuln(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += w / 0x4000000 | 0;
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.muln = function muln(num) {
            return this.clone().imuln(num);
        };
        BN.prototype.sqr = function sqr() {
            return this.mul(this);
        };
        BN.prototype.isqr = function isqr() {
            return this.imul(this.clone());
        };
        BN.prototype.pow = function pow(num) {
            var w = toBitArray(num);
            if (w.length === 0) return new BN(1);
            var res = this;
            for(var i = 0; i < w.length; i++, res = res.sqr()){
                if (w[i] !== 0) break;
            }
            if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                if (w[i] === 0) continue;
                res = res.mul(q);
            }
            return res;
        };
        BN.prototype.iushln = function iushln(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
            var i;
            if (r !== 0) {
                var carry = 0;
                for(i = 0; i < this.length; i++){
                    var newCarry = this.words[i] & carryMask;
                    var c = (this.words[i] | 0) - newCarry << r;
                    this.words[i] = c | carry;
                    carry = newCarry >>> 26 - r;
                }
                if (carry) {
                    this.words[i] = carry;
                    this.length++;
                }
            }
            if (s !== 0) {
                for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                for(i = 0; i < s; i++)this.words[i] = 0;
                this.length += s;
            }
            return this._strip();
        };
        BN.prototype.ishln = function ishln(bits) {
            assert(this.negative === 0);
            return this.iushln(bits);
        };
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
            assert(typeof bits === 'number' && bits >= 0);
            var h;
            if (hint) h = (hint - hint % 26) / 26;
            else h = 0;
            var r = bits % 26;
            var s = Math.min((bits - r) / 26, this.length);
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            var maskedWords = extended;
            h -= s;
            h = Math.max(0, h);
            if (maskedWords) {
                for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                maskedWords.length = s;
            }
            if (s === 0) ;
            else if (this.length > s) {
                this.length -= s;
                for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
            } else {
                this.words[0] = 0;
                this.length = 1;
            }
            var carry = 0;
            for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                var word = this.words[i] | 0;
                this.words[i] = carry << 26 - r | word >>> r;
                carry = word & mask;
            }
            if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
            if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
            }
            return this._strip();
        };
        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
            assert(this.negative === 0);
            return this.iushrn(bits, hint, extended);
        };
        BN.prototype.shln = function shln(bits) {
            return this.clone().ishln(bits);
        };
        BN.prototype.ushln = function ushln(bits) {
            return this.clone().iushln(bits);
        };
        BN.prototype.shrn = function shrn(bits) {
            return this.clone().ishrn(bits);
        };
        BN.prototype.ushrn = function ushrn(bits) {
            return this.clone().iushrn(bits);
        };
        BN.prototype.testn = function testn(bit) {
            assert(typeof bit === 'number' && bit >= 0);
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) return false;
            var w = this.words[s];
            return !!(w & q);
        };
        BN.prototype.imaskn = function imaskn(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            assert(this.negative === 0, 'imaskn works only with positive numbers');
            if (this.length <= s) return this;
            if (r !== 0) s++;
            this.length = Math.min(s, this.length);
            if (r !== 0) {
                var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                this.words[this.length - 1] &= mask;
            }
            return this._strip();
        };
        BN.prototype.maskn = function maskn(bits) {
            return this.clone().imaskn(bits);
        };
        BN.prototype.iaddn = function iaddn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.isubn(-num);
            if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) <= num) {
                    this.words[0] = num - (this.words[0] | 0);
                    this.negative = 0;
                    return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
            }
            return this._iaddn(num);
        };
        BN.prototype._iaddn = function _iaddn(num) {
            this.words[0] += num;
            for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) this.words[i + 1] = 1;
                else this.words[i + 1]++;
            }
            this.length = Math.max(this.length, i + 1);
            return this;
        };
        BN.prototype.isubn = function isubn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.iaddn(-num);
            if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
            }
            this.words[0] -= num;
            if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
            } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                this.words[i] += 0x4000000;
                this.words[i + 1] -= 1;
            }
            return this._strip();
        };
        BN.prototype.addn = function addn(num) {
            return this.clone().iaddn(num);
        };
        BN.prototype.subn = function subn(num) {
            return this.clone().isubn(num);
        };
        BN.prototype.iabs = function iabs() {
            this.negative = 0;
            return this;
        };
        BN.prototype.abs = function abs() {
            return this.clone().iabs();
        };
        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
            var len = num.length + shift;
            var i;
            this._expand(len);
            var w;
            var carry = 0;
            for(i = 0; i < num.length; i++){
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - (right / 0x4000000 | 0);
                this.words[i + shift] = w & 0x3ffffff;
            }
            for(; i < this.length - shift; i++){
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
            }
            if (carry === 0) return this._strip();
            assert(carry === -1);
            carry = 0;
            for(i = 0; i < this.length; i++){
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
            }
            this.negative = 1;
            return this._strip();
        };
        BN.prototype._wordDiv = function _wordDiv(num, mode) {
            var shift = this.length - num.length;
            var a = this.clone();
            var b = num;
            var bhi = b.words[b.length - 1] | 0;
            var bhiBits = this._countBits(bhi);
            shift = 26 - bhiBits;
            if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
            }
            var m = a.length - b.length;
            var q;
            if (mode !== 'mod') {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for(var i = 0; i < q.length; i++)q.words[i] = 0;
            }
            var diff = a.clone()._ishlnsubmul(b, 1, m);
            if (diff.negative === 0) {
                a = diff;
                if (q) q.words[m] = 1;
            }
            for(var j = m - 1; j >= 0; j--){
                var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                qj = Math.min(qj / bhi | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while(a.negative !== 0){
                    qj--;
                    a.negative = 0;
                    a._ishlnsubmul(b, 1, j);
                    if (!a.isZero()) a.negative ^= 1;
                }
                if (q) q.words[j] = qj;
            }
            if (q) q._strip();
            a._strip();
            if (mode !== 'div' && shift !== 0) a.iushrn(shift);
            return {
                div: q || null,
                mod: a
            };
        };
        BN.prototype.divmod = function divmod(num, mode, positive) {
            assert(!num.isZero());
            if (this.isZero()) return {
                div: new BN(0),
                mod: new BN(0)
            };
            var div, mod, res;
            if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== 'mod') div = res.div.neg();
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.iadd(num);
                }
                return {
                    div: div,
                    mod: mod
                };
            }
            if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== 'mod') div = res.div.neg();
                return {
                    div: div,
                    mod: res.mod
                };
            }
            if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.isub(num);
                }
                return {
                    div: res.div,
                    mod: mod
                };
            }
            if (num.length > this.length || this.cmp(num) < 0) return {
                div: new BN(0),
                mod: this
            };
            if (num.length === 1) {
                if (mode === 'div') return {
                    div: this.divn(num.words[0]),
                    mod: null
                };
                if (mode === 'mod') return {
                    div: null,
                    mod: new BN(this.modrn(num.words[0]))
                };
                return {
                    div: this.divn(num.words[0]),
                    mod: new BN(this.modrn(num.words[0]))
                };
            }
            return this._wordDiv(num, mode);
        };
        BN.prototype.div = function div(num) {
            return this.divmod(num, 'div', false).div;
        };
        BN.prototype.mod = function mod(num) {
            return this.divmod(num, 'mod', false).mod;
        };
        BN.prototype.umod = function umod(num) {
            return this.divmod(num, 'mod', true).mod;
        };
        BN.prototype.divRound = function divRound(num) {
            var dm = this.divmod(num);
            if (dm.mod.isZero()) return dm.div;
            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
            var half = num.ushrn(1);
            var r2 = num.andln(1);
            var cmp = mod.cmp(half);
            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };
        BN.prototype.modrn = function modrn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var p = 67108864 % num;
            var acc = 0;
            for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
            return isNegNum ? -acc : acc;
        };
        BN.prototype.modn = function modn(num) {
            return this.modrn(num);
        };
        BN.prototype.idivn = function idivn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var carry = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = w / num | 0;
                carry = w % num;
            }
            this._strip();
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.divn = function divn(num) {
            return this.clone().idivn(num);
        };
        BN.prototype.egcd = function egcd(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var x = this;
            var y = p.clone();
            if (x.negative !== 0) x = x.umod(p);
            else x = x.clone();
            var A = new BN(1);
            var B = new BN(0);
            var C = new BN(0);
            var D = new BN(1);
            var g = 0;
            while(x.isEven() && y.isEven()){
                x.iushrn(1);
                y.iushrn(1);
                ++g;
            }
            var yp = y.clone();
            var xp = x.clone();
            while(!x.isZero()){
                for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    x.iushrn(i);
                    while(i-- > 0){
                        if (A.isOdd() || B.isOdd()) {
                            A.iadd(yp);
                            B.isub(xp);
                        }
                        A.iushrn(1);
                        B.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    y.iushrn(j);
                    while(j-- > 0){
                        if (C.isOdd() || D.isOdd()) {
                            C.iadd(yp);
                            D.isub(xp);
                        }
                        C.iushrn(1);
                        D.iushrn(1);
                    }
                }
                if (x.cmp(y) >= 0) {
                    x.isub(y);
                    A.isub(C);
                    B.isub(D);
                } else {
                    y.isub(x);
                    C.isub(A);
                    D.isub(B);
                }
            }
            return {
                a: C,
                b: D,
                gcd: y.iushln(g)
            };
        };
        BN.prototype._invmp = function _invmp(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var a = this;
            var b = p.clone();
            if (a.negative !== 0) a = a.umod(p);
            else a = a.clone();
            var x1 = new BN(1);
            var x2 = new BN(0);
            var delta = b.clone();
            while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    a.iushrn(i);
                    while(i-- > 0){
                        if (x1.isOdd()) x1.iadd(delta);
                        x1.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    b.iushrn(j);
                    while(j-- > 0){
                        if (x2.isOdd()) x2.iadd(delta);
                        x2.iushrn(1);
                    }
                }
                if (a.cmp(b) >= 0) {
                    a.isub(b);
                    x1.isub(x2);
                } else {
                    b.isub(a);
                    x2.isub(x1);
                }
            }
            var res;
            if (a.cmpn(1) === 0) res = x1;
            else res = x2;
            if (res.cmpn(0) < 0) res.iadd(p);
            return res;
        };
        BN.prototype.gcd = function gcd(num) {
            if (this.isZero()) return num.abs();
            if (num.isZero()) return this.abs();
            var a = this.clone();
            var b = num.clone();
            a.negative = 0;
            b.negative = 0;
            for(var shift = 0; a.isEven() && b.isEven(); shift++){
                a.iushrn(1);
                b.iushrn(1);
            }
            do {
                while(a.isEven())a.iushrn(1);
                while(b.isEven())b.iushrn(1);
                var r = a.cmp(b);
                if (r < 0) {
                    var t = a;
                    a = b;
                    b = t;
                } else if (r === 0 || b.cmpn(1) === 0) break;
                a.isub(b);
            }while (true)
            return b.iushln(shift);
        };
        BN.prototype.invm = function invm(num) {
            return this.egcd(num).a.umod(num);
        };
        BN.prototype.isEven = function isEven() {
            return (this.words[0] & 1) === 0;
        };
        BN.prototype.isOdd = function isOdd() {
            return (this.words[0] & 1) === 1;
        };
        BN.prototype.andln = function andln(num) {
            return this.words[0] & num;
        };
        BN.prototype.bincn = function bincn(bit) {
            assert(typeof bit === 'number');
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
            }
            var carry = q;
            for(var i = s; carry !== 0 && i < this.length; i++){
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.isZero = function isZero() {
            return this.length === 1 && this.words[0] === 0;
        };
        BN.prototype.cmpn = function cmpn(num) {
            var negative = num < 0;
            if (this.negative !== 0 && !negative) return -1;
            if (this.negative === 0 && negative) return 1;
            this._strip();
            var res;
            if (this.length > 1) res = 1;
            else {
                if (negative) num = -num;
                assert(num <= 0x3ffffff, 'Number is too big');
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
            }
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.cmp = function cmp(num) {
            if (this.negative !== 0 && num.negative === 0) return -1;
            if (this.negative === 0 && num.negative !== 0) return 1;
            var res = this.ucmp(num);
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.ucmp = function ucmp(num) {
            if (this.length > num.length) return 1;
            if (this.length < num.length) return -1;
            var res = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) res = -1;
                else if (a > b) res = 1;
                break;
            }
            return res;
        };
        BN.prototype.gtn = function gtn(num) {
            return this.cmpn(num) === 1;
        };
        BN.prototype.gt = function gt(num) {
            return this.cmp(num) === 1;
        };
        BN.prototype.gten = function gten(num) {
            return this.cmpn(num) >= 0;
        };
        BN.prototype.gte = function gte(num) {
            return this.cmp(num) >= 0;
        };
        BN.prototype.ltn = function ltn(num) {
            return this.cmpn(num) === -1;
        };
        BN.prototype.lt = function lt(num) {
            return this.cmp(num) === -1;
        };
        BN.prototype.lten = function lten(num) {
            return this.cmpn(num) <= 0;
        };
        BN.prototype.lte = function lte(num) {
            return this.cmp(num) <= 0;
        };
        BN.prototype.eqn = function eqn(num) {
            return this.cmpn(num) === 0;
        };
        BN.prototype.eq = function eq(num) {
            return this.cmp(num) === 0;
        };
        BN.red = function red(num) {
            return new Red(num);
        };
        BN.prototype.toRed = function toRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            assert(this.negative === 0, 'red works only with positives');
            return ctx.convertTo(this)._forceRed(ctx);
        };
        BN.prototype.fromRed = function fromRed() {
            assert(this.red, 'fromRed works only with numbers in reduction context');
            return this.red.convertFrom(this);
        };
        BN.prototype._forceRed = function _forceRed(ctx) {
            this.red = ctx;
            return this;
        };
        BN.prototype.forceRed = function forceRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            return this._forceRed(ctx);
        };
        BN.prototype.redAdd = function redAdd(num) {
            assert(this.red, 'redAdd works only with red numbers');
            return this.red.add(this, num);
        };
        BN.prototype.redIAdd = function redIAdd(num) {
            assert(this.red, 'redIAdd works only with red numbers');
            return this.red.iadd(this, num);
        };
        BN.prototype.redSub = function redSub(num) {
            assert(this.red, 'redSub works only with red numbers');
            return this.red.sub(this, num);
        };
        BN.prototype.redISub = function redISub(num) {
            assert(this.red, 'redISub works only with red numbers');
            return this.red.isub(this, num);
        };
        BN.prototype.redShl = function redShl(num) {
            assert(this.red, 'redShl works only with red numbers');
            return this.red.shl(this, num);
        };
        BN.prototype.redMul = function redMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.mul(this, num);
        };
        BN.prototype.redIMul = function redIMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.imul(this, num);
        };
        BN.prototype.redSqr = function redSqr() {
            assert(this.red, 'redSqr works only with red numbers');
            this.red._verify1(this);
            return this.red.sqr(this);
        };
        BN.prototype.redISqr = function redISqr() {
            assert(this.red, 'redISqr works only with red numbers');
            this.red._verify1(this);
            return this.red.isqr(this);
        };
        BN.prototype.redSqrt = function redSqrt() {
            assert(this.red, 'redSqrt works only with red numbers');
            this.red._verify1(this);
            return this.red.sqrt(this);
        };
        BN.prototype.redInvm = function redInvm() {
            assert(this.red, 'redInvm works only with red numbers');
            this.red._verify1(this);
            return this.red.invm(this);
        };
        BN.prototype.redNeg = function redNeg() {
            assert(this.red, 'redNeg works only with red numbers');
            this.red._verify1(this);
            return this.red.neg(this);
        };
        BN.prototype.redPow = function redPow(num) {
            assert(this.red && !num.red, 'redPow(normalNum)');
            this.red._verify1(this);
            return this.red.pow(this, num);
        };
        var primes = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function MPrime(name, p) {
            this.name = name;
            this.p = new BN(p, 16);
            this.n = this.p.bitLength();
            this.k = new BN(1).iushln(this.n).isub(this.p);
            this.tmp = this._tmp();
        }
        MPrime.prototype._tmp = function _tmp() {
            var tmp = new BN(null);
            tmp.words = new Array(Math.ceil(this.n / 13));
            return tmp;
        };
        MPrime.prototype.ireduce = function ireduce(num) {
            var r = num;
            var rlen;
            do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
            }while (rlen > this.n)
            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
            if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
            } else if (cmp > 0) r.isub(this.p);
            else if (r.strip !== undefined) r.strip();
            else r._strip();
            return r;
        };
        MPrime.prototype.split = function split(input, out) {
            input.iushrn(this.n, 0, out);
        };
        MPrime.prototype.imulK = function imulK(num) {
            return num.imul(this.k);
        };
        function K256() {
            MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);
        K256.prototype.split = function split(input, output) {
            var mask = 0x3fffff;
            var outLen = Math.min(input.length, 9);
            for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
            output.length = outLen;
            if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
            }
            var prev = input.words[9];
            output.words[output.length++] = prev & mask;
            for(i = 10; i < input.length; i++){
                var next = input.words[i] | 0;
                input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                prev = next;
            }
            prev >>>= 22;
            input.words[i - 10] = prev;
            if (prev === 0 && input.length > 10) input.length -= 10;
            else input.length -= 9;
        };
        K256.prototype.imulK = function imulK(num) {
            num.words[num.length] = 0;
            num.words[num.length + 1] = 0;
            num.length += 2;
            var lo = 0;
            for(var i = 0; i < num.length; i++){
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + (lo / 0x4000000 | 0);
            }
            if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) num.length--;
            }
            return num;
        };
        function P224() {
            MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);
        function P192() {
            MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);
        function P25519() {
            MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);
        P25519.prototype.imulK = function imulK(num) {
            var carry = 0;
            for(var i = 0; i < num.length; i++){
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
            }
            if (carry !== 0) num.words[num.length++] = carry;
            return num;
        };
        BN._prime = function prime(name) {
            if (primes[name]) return primes[name];
            var prime;
            if (name === 'k256') prime = new K256();
            else if (name === 'p224') prime = new P224();
            else if (name === 'p192') prime = new P192();
            else if (name === 'p25519') prime = new P25519();
            else throw new Error('Unknown prime ' + name);
            primes[name] = prime;
            return prime;
        };
        function Red(m) {
            if (typeof m === 'string') {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
            } else {
                assert(m.gtn(1), 'modulus must be greater than 1');
                this.m = m;
                this.prime = null;
            }
        }
        Red.prototype._verify1 = function _verify1(a) {
            assert(a.negative === 0, 'red works only with positives');
            assert(a.red, 'red works only with red numbers');
        };
        Red.prototype._verify2 = function _verify2(a, b) {
            assert((a.negative | b.negative) === 0, 'red works only with positives');
            assert(a.red && a.red === b.red, 'red works only with red numbers');
        };
        Red.prototype.imod = function imod(a) {
            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
            move(a, a.umod(this.m)._forceRed(this));
            return a;
        };
        Red.prototype.neg = function neg(a) {
            if (a.isZero()) return a.clone();
            return this.m.sub(a)._forceRed(this);
        };
        Red.prototype.add = function add(a, b) {
            this._verify2(a, b);
            var res = a.add(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res._forceRed(this);
        };
        Red.prototype.iadd = function iadd(a, b) {
            this._verify2(a, b);
            var res = a.iadd(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res;
        };
        Red.prototype.sub = function sub(a, b) {
            this._verify2(a, b);
            var res = a.sub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res._forceRed(this);
        };
        Red.prototype.isub = function isub(a, b) {
            this._verify2(a, b);
            var res = a.isub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res;
        };
        Red.prototype.shl = function shl(a, num) {
            this._verify1(a);
            return this.imod(a.ushln(num));
        };
        Red.prototype.imul = function imul(a, b) {
            this._verify2(a, b);
            return this.imod(a.imul(b));
        };
        Red.prototype.mul = function mul(a, b) {
            this._verify2(a, b);
            return this.imod(a.mul(b));
        };
        Red.prototype.isqr = function isqr(a) {
            return this.imul(a, a.clone());
        };
        Red.prototype.sqr = function sqr(a) {
            return this.mul(a, a);
        };
        Red.prototype.sqrt = function sqrt(a) {
            if (a.isZero()) return a.clone();
            var mod3 = this.m.andln(3);
            assert(mod3 % 2 === 1);
            if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
            }
            var q = this.m.subn(1);
            var s = 0;
            while(!q.isZero() && q.andln(1) === 0){
                s++;
                q.iushrn(1);
            }
            assert(!q.isZero());
            var one = new BN(1).toRed(this);
            var nOne = one.redNeg();
            var lpow = this.m.subn(1).iushrn(1);
            var z = this.m.bitLength();
            z = new BN(2 * z * z).toRed(this);
            while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
            var c = this.pow(z, q);
            var r = this.pow(a, q.addn(1).iushrn(1));
            var t = this.pow(a, q);
            var m = s;
            while(t.cmp(one) !== 0){
                var tmp = t;
                for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
            }
            return r;
        };
        Red.prototype.invm = function invm(a) {
            var inv = a._invmp(this.m);
            if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
            } else return this.imod(inv);
        };
        Red.prototype.pow = function pow(a, num) {
            if (num.isZero()) return new BN(1).toRed(this);
            if (num.cmpn(1) === 0) return a.clone();
            var windowSize = 4;
            var wnd = new Array(1 << windowSize);
            wnd[0] = new BN(1).toRed(this);
            wnd[1] = a;
            for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
            var res = wnd[0];
            var current = 0;
            var currentLen = 0;
            var start = num.bitLength() % 26;
            if (start === 0) start = 26;
            for(i = num.length - 1; i >= 0; i--){
                var word = num.words[i];
                for(var j = start - 1; j >= 0; j--){
                    var bit = word >> j & 1;
                    if (res !== wnd[0]) res = this.sqr(res);
                    if (bit === 0 && current === 0) {
                        currentLen = 0;
                        continue;
                    }
                    current <<= 1;
                    current |= bit;
                    currentLen++;
                    if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                    res = this.mul(res, wnd[current]);
                    currentLen = 0;
                    current = 0;
                }
                start = 26;
            }
            return res;
        };
        Red.prototype.convertTo = function convertTo(num) {
            var r = num.umod(this.m);
            return r === num ? r.clone() : r;
        };
        Red.prototype.convertFrom = function convertFrom(num) {
            var res = num.clone();
            res.red = null;
            return res;
        };
        BN.mont = function mont(num) {
            return new Mont(num);
        };
        function Mont(m) {
            Red.call(this, m);
            this.shift = this.m.bitLength();
            if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
            this.r = new BN(1).iushln(this.shift);
            this.r2 = this.imod(this.r.sqr());
            this.rinv = this.r._invmp(this.m);
            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
            this.minv = this.minv.umod(this.r);
            this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);
        Mont.prototype.convertTo = function convertTo(num) {
            return this.imod(num.ushln(this.shift));
        };
        Mont.prototype.convertFrom = function convertFrom(num) {
            var r = this.imod(num.mul(this.rinv));
            r.red = null;
            return r;
        };
        Mont.prototype.imul = function imul(a, b) {
            if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
            }
            var t = a.imul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.mul = function mul(a, b) {
            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
            var t = a.mul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.invm = function invm(a) {
            var res = this.imod(a._invmp(this.m).mul(this.r2));
            return res._forceRed(this);
        };
    })(module, this);
});
parcelRegister("8JoQd", function(module, exports) {
    'use strict';
    var $65b5cb9dd0661cc3$var$elliptic = module.exports;
    $65b5cb9dd0661cc3$var$elliptic.version = (parcelRequire("gkWIM")).version;
    $65b5cb9dd0661cc3$var$elliptic.utils = (parcelRequire("onO0l"));
    $65b5cb9dd0661cc3$var$elliptic.rand = (parcelRequire("9D8YT"));
    $65b5cb9dd0661cc3$var$elliptic.curve = (parcelRequire("9QOKF"));
    $65b5cb9dd0661cc3$var$elliptic.curves = (parcelRequire("gli5y"));
    $65b5cb9dd0661cc3$var$elliptic.ec = (parcelRequire("9Cxq1"));
    $65b5cb9dd0661cc3$var$elliptic.eddsa = (parcelRequire("5xIaV"));
});
parcelRegister("gkWIM", function(module, exports) {
    module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");
});
parcelRegister("onO0l", function(module, exports) {
    'use strict';
    var $0494b54965d0d2c4$var$utils = module.exports;
    var $9pbIC = parcelRequire("9pbIC");
    var $gxaFy = parcelRequire("gxaFy");
    var $2WqN6 = parcelRequire("2WqN6");
    $0494b54965d0d2c4$var$utils.assert = $gxaFy;
    $0494b54965d0d2c4$var$utils.toArray = $2WqN6.toArray;
    $0494b54965d0d2c4$var$utils.zero2 = $2WqN6.zero2;
    $0494b54965d0d2c4$var$utils.toHex = $2WqN6.toHex;
    $0494b54965d0d2c4$var$utils.encode = $2WqN6.encode;
    function $0494b54965d0d2c4$var$getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        var i;
        for(i = 0; i < naf.length; i += 1)naf[i] = 0;
        var ws = 1 << w + 1;
        var k = num.clone();
        for(i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    $0494b54965d0d2c4$var$utils.getNAF = $0494b54965d0d2c4$var$getNAF;
    function $0494b54965d0d2c4$var$getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    $0494b54965d0d2c4$var$utils.getJSF = $0494b54965d0d2c4$var$getJSF;
    function $0494b54965d0d2c4$var$cachedProperty(obj, name, computer) {
        var key = '_' + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    $0494b54965d0d2c4$var$utils.cachedProperty = $0494b54965d0d2c4$var$cachedProperty;
    function $0494b54965d0d2c4$var$parseBytes(bytes) {
        return typeof bytes === 'string' ? $0494b54965d0d2c4$var$utils.toArray(bytes, 'hex') : bytes;
    }
    $0494b54965d0d2c4$var$utils.parseBytes = $0494b54965d0d2c4$var$parseBytes;
    function $0494b54965d0d2c4$var$intFromLE(bytes) {
        return new $9pbIC(bytes, 'hex', 'le');
    }
    $0494b54965d0d2c4$var$utils.intFromLE = $0494b54965d0d2c4$var$intFromLE;
});
parcelRegister("2WqN6", function(module, exports) {
    'use strict';
    var $2245c7a9bbd83d59$var$utils = module.exports;
    function $2245c7a9bbd83d59$var$toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== 'string') {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    $2245c7a9bbd83d59$var$utils.toArray = $2245c7a9bbd83d59$var$toArray;
    function $2245c7a9bbd83d59$var$zero2(word) {
        if (word.length === 1) return '0' + word;
        else return word;
    }
    $2245c7a9bbd83d59$var$utils.zero2 = $2245c7a9bbd83d59$var$zero2;
    function $2245c7a9bbd83d59$var$toHex(msg) {
        var res = '';
        for(var i = 0; i < msg.length; i++)res += $2245c7a9bbd83d59$var$zero2(msg[i].toString(16));
        return res;
    }
    $2245c7a9bbd83d59$var$utils.toHex = $2245c7a9bbd83d59$var$toHex;
    $2245c7a9bbd83d59$var$utils.encode = function encode(arr, enc) {
        if (enc === 'hex') return $2245c7a9bbd83d59$var$toHex(arr);
        else return arr;
    };
});
parcelRegister("9QOKF", function(module, exports) {
    'use strict';
    var $72c056a3dd9c1fd5$var$curve = module.exports;
    $72c056a3dd9c1fd5$var$curve.base = (parcelRequire("5DDDX"));
    $72c056a3dd9c1fd5$var$curve.short = (parcelRequire("adWZB"));
    $72c056a3dd9c1fd5$var$curve.mont = (parcelRequire("8yFev"));
    $72c056a3dd9c1fd5$var$curve.edwards = (parcelRequire("4wgwz"));
});
parcelRegister("5DDDX", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $41af58a397e0e961$var$getNAF = $onO0l.getNAF;
    var $41af58a397e0e961$var$getJSF = $onO0l.getJSF;
    var $41af58a397e0e961$var$assert = $onO0l.assert;
    function $41af58a397e0e961$var$BaseCurve(type, conf) {
        this.type = type;
        this.p = new $9pbIC(conf.p, 16);
        this.red = conf.prime ? $9pbIC.red(conf.prime) : $9pbIC.mont(this.p);
        this.zero = new $9pbIC(0).toRed(this.red);
        this.one = new $9pbIC(1).toRed(this.red);
        this.two = new $9pbIC(2).toRed(this.red);
        this.n = conf.n && new $9pbIC(conf.n, 16);
        this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
        this._wnafT1 = new Array(4);
        this._wnafT2 = new Array(4);
        this._wnafT3 = new Array(4);
        this._wnafT4 = new Array(4);
        this._bitLength = this.n ? this.n.bitLength() : 0;
        var adjustCount = this.n && this.p.div(this.n);
        if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
        else {
            this._maxwellTrick = true;
            this.redN = this.n.toRed(this.red);
        }
    }
    module.exports = $41af58a397e0e961$var$BaseCurve;
    $41af58a397e0e961$var$BaseCurve.prototype.point = function point() {
        throw new Error('Not implemented');
    };
    $41af58a397e0e961$var$BaseCurve.prototype.validate = function validate() {
        throw new Error('Not implemented');
    };
    $41af58a397e0e961$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
        $41af58a397e0e961$var$assert(p.precomputed);
        var doubles = p._getDoubles();
        var naf = $41af58a397e0e961$var$getNAF(k, 1, this._bitLength);
        var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
        I /= 3;
        var repr = [];
        var j;
        var nafW;
        for(j = 0; j < naf.length; j += doubles.step){
            nafW = 0;
            for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
            repr.push(nafW);
        }
        var a = this.jpoint(null, null, null);
        var b = this.jpoint(null, null, null);
        for(var i = I; i > 0; i--){
            for(j = 0; j < repr.length; j++){
                nafW = repr[j];
                if (nafW === i) b = b.mixedAdd(doubles.points[j]);
                else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
            }
            a = a.add(b);
        }
        return a.toP();
    };
    $41af58a397e0e961$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
        var w = 4;
        var nafPoints = p._getNAFPoints(w);
        w = nafPoints.wnd;
        var wnd = nafPoints.points;
        var naf = $41af58a397e0e961$var$getNAF(k, w, this._bitLength);
        var acc = this.jpoint(null, null, null);
        for(var i = naf.length - 1; i >= 0; i--){
            for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
            if (i >= 0) l++;
            acc = acc.dblp(l);
            if (i < 0) break;
            var z = naf[i];
            $41af58a397e0e961$var$assert(z !== 0);
            if (p.type === 'affine') {
                if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
                else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
            } else if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
            else acc = acc.add(wnd[-z - 1 >> 1].neg());
        }
        return p.type === 'affine' ? acc.toP() : acc;
    };
    $41af58a397e0e961$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
        var wndWidth = this._wnafT1;
        var wnd = this._wnafT2;
        var naf = this._wnafT3;
        var max = 0;
        var i;
        var j;
        var p;
        for(i = 0; i < len; i++){
            p = points[i];
            var nafPoints = p._getNAFPoints(defW);
            wndWidth[i] = nafPoints.wnd;
            wnd[i] = nafPoints.points;
        }
        for(i = len - 1; i >= 1; i -= 2){
            var a = i - 1;
            var b = i;
            if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
                naf[a] = $41af58a397e0e961$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
                naf[b] = $41af58a397e0e961$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
                max = Math.max(naf[a].length, max);
                max = Math.max(naf[b].length, max);
                continue;
            }
            var comb = [
                points[a],
                null,
                null,
                points[b]
            ];
            if (points[a].y.cmp(points[b].y) === 0) {
                comb[1] = points[a].add(points[b]);
                comb[2] = points[a].toJ().mixedAdd(points[b].neg());
            } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
                comb[1] = points[a].toJ().mixedAdd(points[b]);
                comb[2] = points[a].add(points[b].neg());
            } else {
                comb[1] = points[a].toJ().mixedAdd(points[b]);
                comb[2] = points[a].toJ().mixedAdd(points[b].neg());
            }
            var index = [
                -3,
                -1,
                -5,
                -7,
                0,
                7,
                5,
                1,
                3
            ];
            var jsf = $41af58a397e0e961$var$getJSF(coeffs[a], coeffs[b]);
            max = Math.max(jsf[0].length, max);
            naf[a] = new Array(max);
            naf[b] = new Array(max);
            for(j = 0; j < max; j++){
                var ja = jsf[0][j] | 0;
                var jb = jsf[1][j] | 0;
                naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
                naf[b][j] = 0;
                wnd[a] = comb;
            }
        }
        var acc = this.jpoint(null, null, null);
        var tmp = this._wnafT4;
        for(i = max; i >= 0; i--){
            var k = 0;
            while(i >= 0){
                var zero = true;
                for(j = 0; j < len; j++){
                    tmp[j] = naf[j][i] | 0;
                    if (tmp[j] !== 0) zero = false;
                }
                if (!zero) break;
                k++;
                i--;
            }
            if (i >= 0) k++;
            acc = acc.dblp(k);
            if (i < 0) break;
            for(j = 0; j < len; j++){
                var z = tmp[j];
                p;
                if (z === 0) continue;
                else if (z > 0) p = wnd[j][z - 1 >> 1];
                else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
                if (p.type === 'affine') acc = acc.mixedAdd(p);
                else acc = acc.add(p);
            }
        }
        for(i = 0; i < len; i++)wnd[i] = null;
        if (jacobianResult) return acc;
        else return acc.toP();
    };
    function $41af58a397e0e961$var$BasePoint(curve, type) {
        this.curve = curve;
        this.type = type;
        this.precomputed = null;
    }
    $41af58a397e0e961$var$BaseCurve.BasePoint = $41af58a397e0e961$var$BasePoint;
    $41af58a397e0e961$var$BasePoint.prototype.eq = function eq() {
        throw new Error('Not implemented');
    };
    $41af58a397e0e961$var$BasePoint.prototype.validate = function validate() {
        return this.curve.validate(this);
    };
    $41af58a397e0e961$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
        bytes = $onO0l.toArray(bytes, enc);
        var len = this.p.byteLength();
        if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
            if (bytes[0] === 0x06) $41af58a397e0e961$var$assert(bytes[bytes.length - 1] % 2 === 0);
            else if (bytes[0] === 0x07) $41af58a397e0e961$var$assert(bytes[bytes.length - 1] % 2 === 1);
            var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
            return res;
        } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
        throw new Error('Unknown point format');
    };
    $41af58a397e0e961$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
        return this.encode(enc, true);
    };
    $41af58a397e0e961$var$BasePoint.prototype._encode = function _encode(compact) {
        var len = this.curve.p.byteLength();
        var x = this.getX().toArray('be', len);
        if (compact) return [
            this.getY().isEven() ? 0x02 : 0x03
        ].concat(x);
        return [
            0x04
        ].concat(x, this.getY().toArray('be', len));
    };
    $41af58a397e0e961$var$BasePoint.prototype.encode = function encode(enc, compact) {
        return $onO0l.encode(this._encode(compact), enc);
    };
    $41af58a397e0e961$var$BasePoint.prototype.precompute = function precompute(power) {
        if (this.precomputed) return this;
        var precomputed = {
            doubles: null,
            naf: null,
            beta: null
        };
        precomputed.naf = this._getNAFPoints(8);
        precomputed.doubles = this._getDoubles(4, power);
        precomputed.beta = this._getBeta();
        this.precomputed = precomputed;
        return this;
    };
    $41af58a397e0e961$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
        if (!this.precomputed) return false;
        var doubles = this.precomputed.doubles;
        if (!doubles) return false;
        return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
    };
    $41af58a397e0e961$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
        if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
        var doubles = [
            this
        ];
        var acc = this;
        for(var i = 0; i < power; i += step){
            for(var j = 0; j < step; j++)acc = acc.dbl();
            doubles.push(acc);
        }
        return {
            step: step,
            points: doubles
        };
    };
    $41af58a397e0e961$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
        if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
        var res = [
            this
        ];
        var max = (1 << wnd) - 1;
        var dbl = max === 1 ? null : this.dbl();
        for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
        return {
            wnd: wnd,
            points: res
        };
    };
    $41af58a397e0e961$var$BasePoint.prototype._getBeta = function _getBeta() {
        return null;
    };
    $41af58a397e0e961$var$BasePoint.prototype.dblp = function dblp(k) {
        var r = this;
        for(var i = 0; i < k; i++)r = r.dbl();
        return r;
    };
});
parcelRegister("adWZB", function(module, exports) {
    'use strict';
    var $onO0l = parcelRequire("onO0l");
    var $9pbIC = parcelRequire("9pbIC");
    var $v3bBu = parcelRequire("v3bBu");
    var $5DDDX = parcelRequire("5DDDX");
    var $7718e0f8fe39ea5b$var$assert = $onO0l.assert;
    function $7718e0f8fe39ea5b$var$ShortCurve(conf) {
        $5DDDX.call(this, 'short', conf);
        this.a = new $9pbIC(conf.a, 16).toRed(this.red);
        this.b = new $9pbIC(conf.b, 16).toRed(this.red);
        this.tinv = this.two.redInvm();
        this.zeroA = this.a.fromRed().cmpn(0) === 0;
        this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
        this.endo = this._getEndomorphism(conf);
        this._endoWnafT1 = new Array(4);
        this._endoWnafT2 = new Array(4);
    }
    $v3bBu($7718e0f8fe39ea5b$var$ShortCurve, $5DDDX);
    module.exports = $7718e0f8fe39ea5b$var$ShortCurve;
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
        if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
        var beta;
        var lambda;
        if (conf.beta) beta = new $9pbIC(conf.beta, 16).toRed(this.red);
        else {
            var betas = this._getEndoRoots(this.p);
            beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
            beta = beta.toRed(this.red);
        }
        if (conf.lambda) lambda = new $9pbIC(conf.lambda, 16);
        else {
            var lambdas = this._getEndoRoots(this.n);
            if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
            else {
                lambda = lambdas[1];
                $7718e0f8fe39ea5b$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
            }
        }
        var basis;
        if (conf.basis) basis = conf.basis.map(function(vec) {
            return {
                a: new $9pbIC(vec.a, 16),
                b: new $9pbIC(vec.b, 16)
            };
        });
        else basis = this._getEndoBasis(lambda);
        return {
            beta: beta,
            lambda: lambda,
            basis: basis
        };
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
        var red = num === this.p ? this.red : $9pbIC.mont(num);
        var tinv = new $9pbIC(2).toRed(red).redInvm();
        var ntinv = tinv.redNeg();
        var s = new $9pbIC(3).toRed(red).redNeg().redSqrt().redMul(tinv);
        var l1 = ntinv.redAdd(s).fromRed();
        var l2 = ntinv.redSub(s).fromRed();
        return [
            l1,
            l2
        ];
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
        var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
        var u = lambda;
        var v = this.n.clone();
        var x1 = new $9pbIC(1);
        var y1 = new $9pbIC(0);
        var x2 = new $9pbIC(0);
        var y2 = new $9pbIC(1);
        var a0;
        var b0;
        var a1;
        var b1;
        var a2;
        var b2;
        var prevR;
        var i = 0;
        var r;
        var x;
        while(u.cmpn(0) !== 0){
            var q = v.div(u);
            r = v.sub(q.mul(u));
            x = x2.sub(q.mul(x1));
            var y = y2.sub(q.mul(y1));
            if (!a1 && r.cmp(aprxSqrt) < 0) {
                a0 = prevR.neg();
                b0 = x1;
                a1 = r.neg();
                b1 = x;
            } else if (a1 && ++i === 2) break;
            prevR = r;
            v = u;
            u = r;
            x2 = x1;
            x1 = x;
            y2 = y1;
            y1 = y;
        }
        a2 = r.neg();
        b2 = x;
        var len1 = a1.sqr().add(b1.sqr());
        var len2 = a2.sqr().add(b2.sqr());
        if (len2.cmp(len1) >= 0) {
            a2 = a0;
            b2 = b0;
        }
        if (a1.negative) {
            a1 = a1.neg();
            b1 = b1.neg();
        }
        if (a2.negative) {
            a2 = a2.neg();
            b2 = b2.neg();
        }
        return [
            {
                a: a1,
                b: b1
            },
            {
                a: a2,
                b: b2
            }
        ];
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
        var basis = this.endo.basis;
        var v1 = basis[0];
        var v2 = basis[1];
        var c1 = v2.b.mul(k).divRound(this.n);
        var c2 = v1.b.neg().mul(k).divRound(this.n);
        var p1 = c1.mul(v1.a);
        var p2 = c2.mul(v2.a);
        var q1 = c1.mul(v1.b);
        var q2 = c2.mul(v2.b);
        var k1 = k.sub(p1).sub(p2);
        var k2 = q1.add(q2).neg();
        return {
            k1: k1,
            k2: k2
        };
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
        x = new $9pbIC(x, 16);
        if (!x.red) x = x.toRed(this.red);
        var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
        var y = y2.redSqrt();
        if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
        var isOdd = y.fromRed().isOdd();
        if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
        return this.point(x, y);
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.validate = function validate(point) {
        if (point.inf) return true;
        var x = point.x;
        var y = point.y;
        var ax = this.a.redMul(x);
        var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
        return y.redSqr().redISub(rhs).cmpn(0) === 0;
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
        var npoints = this._endoWnafT1;
        var ncoeffs = this._endoWnafT2;
        for(var i = 0; i < points.length; i++){
            var split = this._endoSplit(coeffs[i]);
            var p = points[i];
            var beta = p._getBeta();
            if (split.k1.negative) {
                split.k1.ineg();
                p = p.neg(true);
            }
            if (split.k2.negative) {
                split.k2.ineg();
                beta = beta.neg(true);
            }
            npoints[i * 2] = p;
            npoints[i * 2 + 1] = beta;
            ncoeffs[i * 2] = split.k1;
            ncoeffs[i * 2 + 1] = split.k2;
        }
        var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
        for(var j = 0; j < i * 2; j++){
            npoints[j] = null;
            ncoeffs[j] = null;
        }
        return res;
    };
    function $7718e0f8fe39ea5b$var$Point(curve, x, y, isRed) {
        $5DDDX.BasePoint.call(this, curve, 'affine');
        if (x === null && y === null) {
            this.x = null;
            this.y = null;
            this.inf = true;
        } else {
            this.x = new $9pbIC(x, 16);
            this.y = new $9pbIC(y, 16);
            if (isRed) {
                this.x.forceRed(this.curve.red);
                this.y.forceRed(this.curve.red);
            }
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.y.red) this.y = this.y.toRed(this.curve.red);
            this.inf = false;
        }
    }
    $v3bBu($7718e0f8fe39ea5b$var$Point, $5DDDX.BasePoint);
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
        return new $7718e0f8fe39ea5b$var$Point(this, x, y, isRed);
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
        return $7718e0f8fe39ea5b$var$Point.fromJSON(this, obj, red);
    };
    $7718e0f8fe39ea5b$var$Point.prototype._getBeta = function _getBeta() {
        if (!this.curve.endo) return;
        var pre = this.precomputed;
        if (pre && pre.beta) return pre.beta;
        var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (pre) {
            var curve = this.curve;
            var endoMul = function(p) {
                return curve.point(p.x.redMul(curve.endo.beta), p.y);
            };
            pre.beta = beta;
            beta.precomputed = {
                beta: null,
                naf: pre.naf && {
                    wnd: pre.naf.wnd,
                    points: pre.naf.points.map(endoMul)
                },
                doubles: pre.doubles && {
                    step: pre.doubles.step,
                    points: pre.doubles.points.map(endoMul)
                }
            };
        }
        return beta;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.toJSON = function toJSON() {
        if (!this.precomputed) return [
            this.x,
            this.y
        ];
        return [
            this.x,
            this.y,
            this.precomputed && {
                doubles: this.precomputed.doubles && {
                    step: this.precomputed.doubles.step,
                    points: this.precomputed.doubles.points.slice(1)
                },
                naf: this.precomputed.naf && {
                    wnd: this.precomputed.naf.wnd,
                    points: this.precomputed.naf.points.slice(1)
                }
            }
        ];
    };
    $7718e0f8fe39ea5b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
        if (typeof obj === 'string') obj = JSON.parse(obj);
        var res = curve.point(obj[0], obj[1], red);
        if (!obj[2]) return res;
        function obj2point(obj) {
            return curve.point(obj[0], obj[1], red);
        }
        var pre = obj[2];
        res.precomputed = {
            beta: null,
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: [
                    res
                ].concat(pre.doubles.points.map(obj2point))
            },
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: [
                    res
                ].concat(pre.naf.points.map(obj2point))
            }
        };
        return res;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
    };
    $7718e0f8fe39ea5b$var$Point.prototype.isInfinity = function isInfinity() {
        return this.inf;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.add = function add(p) {
        if (this.inf) return p;
        if (p.inf) return this;
        if (this.eq(p)) return this.dbl();
        if (this.neg().eq(p)) return this.curve.point(null, null);
        if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
        var c = this.y.redSub(p.y);
        if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
        var nx = c.redSqr().redISub(this.x).redISub(p.x);
        var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
        return this.curve.point(nx, ny);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.dbl = function dbl() {
        if (this.inf) return this;
        var ys1 = this.y.redAdd(this.y);
        if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
        var a = this.curve.a;
        var x2 = this.x.redSqr();
        var dyinv = ys1.redInvm();
        var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
        var nx = c.redSqr().redISub(this.x.redAdd(this.x));
        var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
        return this.curve.point(nx, ny);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.getX = function getX() {
        return this.x.fromRed();
    };
    $7718e0f8fe39ea5b$var$Point.prototype.getY = function getY() {
        return this.y.fromRed();
    };
    $7718e0f8fe39ea5b$var$Point.prototype.mul = function mul(k) {
        k = new $9pbIC(k, 16);
        if (this.isInfinity()) return this;
        else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
        else if (this.curve.endo) return this.curve._endoWnafMulAdd([
            this
        ], [
            k
        ]);
        else return this.curve._wnafMul(this, k);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
        var points = [
            this,
            p2
        ];
        var coeffs = [
            k1,
            k2
        ];
        if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
        else return this.curve._wnafMulAdd(1, points, coeffs, 2);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
        var points = [
            this,
            p2
        ];
        var coeffs = [
            k1,
            k2
        ];
        if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
        else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.eq = function eq(p) {
        return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.neg = function neg(_precompute) {
        if (this.inf) return this;
        var res = this.curve.point(this.x, this.y.redNeg());
        if (_precompute && this.precomputed) {
            var pre = this.precomputed;
            var negate = function(p) {
                return p.neg();
            };
            res.precomputed = {
                naf: pre.naf && {
                    wnd: pre.naf.wnd,
                    points: pre.naf.points.map(negate)
                },
                doubles: pre.doubles && {
                    step: pre.doubles.step,
                    points: pre.doubles.points.map(negate)
                }
            };
        }
        return res;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.toJ = function toJ() {
        if (this.inf) return this.curve.jpoint(null, null, null);
        var res = this.curve.jpoint(this.x, this.y, this.curve.one);
        return res;
    };
    function $7718e0f8fe39ea5b$var$JPoint(curve, x, y, z) {
        $5DDDX.BasePoint.call(this, curve, 'jacobian');
        if (x === null && y === null && z === null) {
            this.x = this.curve.one;
            this.y = this.curve.one;
            this.z = new $9pbIC(0);
        } else {
            this.x = new $9pbIC(x, 16);
            this.y = new $9pbIC(y, 16);
            this.z = new $9pbIC(z, 16);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
    }
    $v3bBu($7718e0f8fe39ea5b$var$JPoint, $5DDDX.BasePoint);
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
        return new $7718e0f8fe39ea5b$var$JPoint(this, x, y, z);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.toP = function toP() {
        if (this.isInfinity()) return this.curve.point(null, null);
        var zinv = this.z.redInvm();
        var zinv2 = zinv.redSqr();
        var ax = this.x.redMul(zinv2);
        var ay = this.y.redMul(zinv2).redMul(zinv);
        return this.curve.point(ax, ay);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.neg = function neg() {
        return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.add = function add(p) {
        if (this.isInfinity()) return p;
        if (p.isInfinity()) return this;
        var pz2 = p.z.redSqr();
        var z2 = this.z.redSqr();
        var u1 = this.x.redMul(pz2);
        var u2 = p.x.redMul(z2);
        var s1 = this.y.redMul(pz2.redMul(p.z));
        var s2 = p.y.redMul(z2.redMul(this.z));
        var h = u1.redSub(u2);
        var r = s1.redSub(s2);
        if (h.cmpn(0) === 0) {
            if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
            else return this.dbl();
        }
        var h2 = h.redSqr();
        var h3 = h2.redMul(h);
        var v = u1.redMul(h2);
        var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
        var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
        var nz = this.z.redMul(p.z).redMul(h);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
        if (this.isInfinity()) return p.toJ();
        if (p.isInfinity()) return this;
        var z2 = this.z.redSqr();
        var u1 = this.x;
        var u2 = p.x.redMul(z2);
        var s1 = this.y;
        var s2 = p.y.redMul(z2).redMul(this.z);
        var h = u1.redSub(u2);
        var r = s1.redSub(s2);
        if (h.cmpn(0) === 0) {
            if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
            else return this.dbl();
        }
        var h2 = h.redSqr();
        var h3 = h2.redMul(h);
        var v = u1.redMul(h2);
        var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
        var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
        var nz = this.z.redMul(h);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.dblp = function dblp(pow) {
        if (pow === 0) return this;
        if (this.isInfinity()) return this;
        if (!pow) return this.dbl();
        var i;
        if (this.curve.zeroA || this.curve.threeA) {
            var r = this;
            for(i = 0; i < pow; i++)r = r.dbl();
            return r;
        }
        var a = this.curve.a;
        var tinv = this.curve.tinv;
        var jx = this.x;
        var jy = this.y;
        var jz = this.z;
        var jz4 = jz.redSqr().redSqr();
        var jyd = jy.redAdd(jy);
        for(i = 0; i < pow; i++){
            var jx2 = jx.redSqr();
            var jyd2 = jyd.redSqr();
            var jyd4 = jyd2.redSqr();
            var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
            var t1 = jx.redMul(jyd2);
            var nx = c.redSqr().redISub(t1.redAdd(t1));
            var t2 = t1.redISub(nx);
            var dny = c.redMul(t2);
            dny = dny.redIAdd(dny).redISub(jyd4);
            var nz = jyd.redMul(jz);
            if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
            jx = nx;
            jz = nz;
            jyd = dny;
        }
        return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.dbl = function dbl() {
        if (this.isInfinity()) return this;
        if (this.curve.zeroA) return this._zeroDbl();
        else if (this.curve.threeA) return this._threeDbl();
        else return this._dbl();
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
        var nx;
        var ny;
        var nz;
        if (this.zOne) {
            var xx = this.x.redSqr();
            var yy = this.y.redSqr();
            var yyyy = yy.redSqr();
            var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
            s = s.redIAdd(s);
            var m = xx.redAdd(xx).redIAdd(xx);
            var t = m.redSqr().redISub(s).redISub(s);
            var yyyy8 = yyyy.redIAdd(yyyy);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            nx = t;
            ny = m.redMul(s.redISub(t)).redISub(yyyy8);
            nz = this.y.redAdd(this.y);
        } else {
            var a = this.x.redSqr();
            var b = this.y.redSqr();
            var c = b.redSqr();
            var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
            d = d.redIAdd(d);
            var e = a.redAdd(a).redIAdd(a);
            var f = e.redSqr();
            var c8 = c.redIAdd(c);
            c8 = c8.redIAdd(c8);
            c8 = c8.redIAdd(c8);
            nx = f.redISub(d).redISub(d);
            ny = e.redMul(d.redISub(nx)).redISub(c8);
            nz = this.y.redMul(this.z);
            nz = nz.redIAdd(nz);
        }
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype._threeDbl = function _threeDbl() {
        var nx;
        var ny;
        var nz;
        if (this.zOne) {
            var xx = this.x.redSqr();
            var yy = this.y.redSqr();
            var yyyy = yy.redSqr();
            var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
            s = s.redIAdd(s);
            var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
            var t = m.redSqr().redISub(s).redISub(s);
            nx = t;
            var yyyy8 = yyyy.redIAdd(yyyy);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            ny = m.redMul(s.redISub(t)).redISub(yyyy8);
            nz = this.y.redAdd(this.y);
        } else {
            var delta = this.z.redSqr();
            var gamma = this.y.redSqr();
            var beta = this.x.redMul(gamma);
            var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
            alpha = alpha.redAdd(alpha).redIAdd(alpha);
            var beta4 = beta.redIAdd(beta);
            beta4 = beta4.redIAdd(beta4);
            var beta8 = beta4.redAdd(beta4);
            nx = alpha.redSqr().redISub(beta8);
            nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
            var ggamma8 = gamma.redSqr();
            ggamma8 = ggamma8.redIAdd(ggamma8);
            ggamma8 = ggamma8.redIAdd(ggamma8);
            ggamma8 = ggamma8.redIAdd(ggamma8);
            ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
        }
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype._dbl = function _dbl() {
        var a = this.curve.a;
        var jx = this.x;
        var jy = this.y;
        var jz = this.z;
        var jz4 = jz.redSqr().redSqr();
        var jx2 = jx.redSqr();
        var jy2 = jy.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var jxd4 = jx.redAdd(jx);
        jxd4 = jxd4.redIAdd(jxd4);
        var t1 = jxd4.redMul(jy2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var jyd8 = jy2.redSqr();
        jyd8 = jyd8.redIAdd(jyd8);
        jyd8 = jyd8.redIAdd(jyd8);
        jyd8 = jyd8.redIAdd(jyd8);
        var ny = c.redMul(t2).redISub(jyd8);
        var nz = jy.redAdd(jy).redMul(jz);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.trpl = function trpl() {
        if (!this.curve.zeroA) return this.dbl().add(this);
        var xx = this.x.redSqr();
        var yy = this.y.redSqr();
        var zz = this.z.redSqr();
        var yyyy = yy.redSqr();
        var m = xx.redAdd(xx).redIAdd(xx);
        var mm = m.redSqr();
        var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        e = e.redIAdd(e);
        e = e.redAdd(e).redIAdd(e);
        e = e.redISub(mm);
        var ee = e.redSqr();
        var t = yyyy.redIAdd(yyyy);
        t = t.redIAdd(t);
        t = t.redIAdd(t);
        t = t.redIAdd(t);
        var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
        var yyu4 = yy.redMul(u);
        yyu4 = yyu4.redIAdd(yyu4);
        yyu4 = yyu4.redIAdd(yyu4);
        var nx = this.x.redMul(ee).redISub(yyu4);
        nx = nx.redIAdd(nx);
        nx = nx.redIAdd(nx);
        var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
        ny = ny.redIAdd(ny);
        ny = ny.redIAdd(ny);
        ny = ny.redIAdd(ny);
        var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.mul = function mul(k, kbase) {
        k = new $9pbIC(k, kbase);
        return this.curve._wnafMul(this, k);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.eq = function eq(p) {
        if (p.type === 'affine') return this.eq(p.toJ());
        if (this === p) return true;
        var z2 = this.z.redSqr();
        var pz2 = p.z.redSqr();
        if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
        var z3 = z2.redMul(this.z);
        var pz3 = pz2.redMul(p.z);
        return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
        var zs = this.z.redSqr();
        var rx = x.toRed(this.curve.red).redMul(zs);
        if (this.x.cmp(rx) === 0) return true;
        var xc = x.clone();
        var t = this.curve.redN.redMul(zs);
        for(;;){
            xc.iadd(this.curve.n);
            if (xc.cmp(this.curve.p) >= 0) return false;
            rx.redIAdd(t);
            if (this.x.cmp(rx) === 0) return true;
        }
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC JPoint Infinity>';
        return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.isInfinity = function isInfinity() {
        return this.z.cmpn(0) === 0;
    };
});
parcelRegister("8yFev", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $v3bBu = parcelRequire("v3bBu");
    var $5DDDX = parcelRequire("5DDDX");
    var $onO0l = parcelRequire("onO0l");
    function $63b17bb79b50781b$var$MontCurve(conf) {
        $5DDDX.call(this, 'mont', conf);
        this.a = new $9pbIC(conf.a, 16).toRed(this.red);
        this.b = new $9pbIC(conf.b, 16).toRed(this.red);
        this.i4 = new $9pbIC(4).toRed(this.red).redInvm();
        this.two = new $9pbIC(2).toRed(this.red);
        this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }
    $v3bBu($63b17bb79b50781b$var$MontCurve, $5DDDX);
    module.exports = $63b17bb79b50781b$var$MontCurve;
    $63b17bb79b50781b$var$MontCurve.prototype.validate = function validate(point) {
        var x = point.normalize().x;
        var x2 = x.redSqr();
        var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
        var y = rhs.redSqrt();
        return y.redSqr().cmp(rhs) === 0;
    };
    function $63b17bb79b50781b$var$Point(curve, x, z) {
        $5DDDX.BasePoint.call(this, curve, 'projective');
        if (x === null && z === null) {
            this.x = this.curve.one;
            this.z = this.curve.zero;
        } else {
            this.x = new $9pbIC(x, 16);
            this.z = new $9pbIC(z, 16);
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        }
    }
    $v3bBu($63b17bb79b50781b$var$Point, $5DDDX.BasePoint);
    $63b17bb79b50781b$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
        return this.point($onO0l.toArray(bytes, enc), 1);
    };
    $63b17bb79b50781b$var$MontCurve.prototype.point = function point(x, z) {
        return new $63b17bb79b50781b$var$Point(this, x, z);
    };
    $63b17bb79b50781b$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
        return $63b17bb79b50781b$var$Point.fromJSON(this, obj);
    };
    $63b17bb79b50781b$var$Point.prototype.precompute = function precompute() {};
    $63b17bb79b50781b$var$Point.prototype._encode = function _encode() {
        return this.getX().toArray('be', this.curve.p.byteLength());
    };
    $63b17bb79b50781b$var$Point.fromJSON = function fromJSON(curve, obj) {
        return new $63b17bb79b50781b$var$Point(curve, obj[0], obj[1] || curve.one);
    };
    $63b17bb79b50781b$var$Point.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    };
    $63b17bb79b50781b$var$Point.prototype.isInfinity = function isInfinity() {
        return this.z.cmpn(0) === 0;
    };
    $63b17bb79b50781b$var$Point.prototype.dbl = function dbl() {
        var a = this.x.redAdd(this.z);
        var aa = a.redSqr();
        var b = this.x.redSub(this.z);
        var bb = b.redSqr();
        var c = aa.redSub(bb);
        var nx = aa.redMul(bb);
        var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
        return this.curve.point(nx, nz);
    };
    $63b17bb79b50781b$var$Point.prototype.add = function add() {
        throw new Error('Not supported on Montgomery curve');
    };
    $63b17bb79b50781b$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
        var a = this.x.redAdd(this.z);
        var b = this.x.redSub(this.z);
        var c = p.x.redAdd(p.z);
        var d = p.x.redSub(p.z);
        var da = d.redMul(a);
        var cb = c.redMul(b);
        var nx = diff.z.redMul(da.redAdd(cb).redSqr());
        var nz = diff.x.redMul(da.redISub(cb).redSqr());
        return this.curve.point(nx, nz);
    };
    $63b17bb79b50781b$var$Point.prototype.mul = function mul(k) {
        var t = k.clone();
        var a = this;
        var b = this.curve.point(null, null);
        var c = this;
        for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
        for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
            a = a.diffAdd(b, c);
            b = b.dbl();
        } else {
            b = a.diffAdd(b, c);
            a = a.dbl();
        }
        return b;
    };
    $63b17bb79b50781b$var$Point.prototype.mulAdd = function mulAdd() {
        throw new Error('Not supported on Montgomery curve');
    };
    $63b17bb79b50781b$var$Point.prototype.jumlAdd = function jumlAdd() {
        throw new Error('Not supported on Montgomery curve');
    };
    $63b17bb79b50781b$var$Point.prototype.eq = function eq(other) {
        return this.getX().cmp(other.getX()) === 0;
    };
    $63b17bb79b50781b$var$Point.prototype.normalize = function normalize() {
        this.x = this.x.redMul(this.z.redInvm());
        this.z = this.curve.one;
        return this;
    };
    $63b17bb79b50781b$var$Point.prototype.getX = function getX() {
        this.normalize();
        return this.x.fromRed();
    };
});
parcelRegister("4wgwz", function(module, exports) {
    'use strict';
    var $onO0l = parcelRequire("onO0l");
    var $9pbIC = parcelRequire("9pbIC");
    var $v3bBu = parcelRequire("v3bBu");
    var $5DDDX = parcelRequire("5DDDX");
    var $34a6f7f58efb73a0$var$assert = $onO0l.assert;
    function $34a6f7f58efb73a0$var$EdwardsCurve(conf) {
        this.twisted = (conf.a | 0) !== 1;
        this.mOneA = this.twisted && (conf.a | 0) === -1;
        this.extended = this.mOneA;
        $5DDDX.call(this, 'edwards', conf);
        this.a = new $9pbIC(conf.a, 16).umod(this.red.m);
        this.a = this.a.toRed(this.red);
        this.c = new $9pbIC(conf.c, 16).toRed(this.red);
        this.c2 = this.c.redSqr();
        this.d = new $9pbIC(conf.d, 16).toRed(this.red);
        this.dd = this.d.redAdd(this.d);
        $34a6f7f58efb73a0$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
        this.oneC = (conf.c | 0) === 1;
    }
    $v3bBu($34a6f7f58efb73a0$var$EdwardsCurve, $5DDDX);
    module.exports = $34a6f7f58efb73a0$var$EdwardsCurve;
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
        if (this.mOneA) return num.redNeg();
        else return this.a.redMul(num);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
        if (this.oneC) return num;
        else return this.c.redMul(num);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
        return this.point(x, y, z, t);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
        x = new $9pbIC(x, 16);
        if (!x.red) x = x.toRed(this.red);
        var x2 = x.redSqr();
        var rhs = this.c2.redSub(this.a.redMul(x2));
        var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
        var y2 = rhs.redMul(lhs.redInvm());
        var y = y2.redSqrt();
        if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
        var isOdd = y.fromRed().isOdd();
        if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
        return this.point(x, y);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
        y = new $9pbIC(y, 16);
        if (!y.red) y = y.toRed(this.red);
        var y2 = y.redSqr();
        var lhs = y2.redSub(this.c2);
        var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
        var x2 = lhs.redMul(rhs.redInvm());
        if (x2.cmp(this.zero) === 0) {
            if (odd) throw new Error('invalid point');
            else return this.point(this.zero, y);
        }
        var x = x2.redSqrt();
        if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
        if (x.fromRed().isOdd() !== odd) x = x.redNeg();
        return this.point(x, y);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.validate = function validate(point) {
        if (point.isInfinity()) return true;
        point.normalize();
        var x2 = point.x.redSqr();
        var y2 = point.y.redSqr();
        var lhs = x2.redMul(this.a).redAdd(y2);
        var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
        return lhs.cmp(rhs) === 0;
    };
    function $34a6f7f58efb73a0$var$Point(curve, x, y, z, t) {
        $5DDDX.BasePoint.call(this, curve, 'projective');
        if (x === null && y === null && z === null) {
            this.x = this.curve.zero;
            this.y = this.curve.one;
            this.z = this.curve.one;
            this.t = this.curve.zero;
            this.zOne = true;
        } else {
            this.x = new $9pbIC(x, 16);
            this.y = new $9pbIC(y, 16);
            this.z = z ? new $9pbIC(z, 16) : this.curve.one;
            this.t = t && new $9pbIC(t, 16);
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.y.red) this.y = this.y.toRed(this.curve.red);
            if (!this.z.red) this.z = this.z.toRed(this.curve.red);
            if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
            this.zOne = this.z === this.curve.one;
            if (this.curve.extended && !this.t) {
                this.t = this.x.redMul(this.y);
                if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
            }
        }
    }
    $v3bBu($34a6f7f58efb73a0$var$Point, $5DDDX.BasePoint);
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
        return $34a6f7f58efb73a0$var$Point.fromJSON(this, obj);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
        return new $34a6f7f58efb73a0$var$Point(this, x, y, z, t);
    };
    $34a6f7f58efb73a0$var$Point.fromJSON = function fromJSON(curve, obj) {
        return new $34a6f7f58efb73a0$var$Point(curve, obj[0], obj[1], obj[2]);
    };
    $34a6f7f58efb73a0$var$Point.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    };
    $34a6f7f58efb73a0$var$Point.prototype.isInfinity = function isInfinity() {
        return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
    };
    $34a6f7f58efb73a0$var$Point.prototype._extDbl = function _extDbl() {
        var a = this.x.redSqr();
        var b = this.y.redSqr();
        var c = this.z.redSqr();
        c = c.redIAdd(c);
        var d = this.curve._mulA(a);
        var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
        var g = d.redAdd(b);
        var f = g.redSub(c);
        var h = d.redSub(b);
        var nx = e.redMul(f);
        var ny = g.redMul(h);
        var nt = e.redMul(h);
        var nz = f.redMul(g);
        return this.curve.point(nx, ny, nz, nt);
    };
    $34a6f7f58efb73a0$var$Point.prototype._projDbl = function _projDbl() {
        var b = this.x.redAdd(this.y).redSqr();
        var c = this.x.redSqr();
        var d = this.y.redSqr();
        var nx;
        var ny;
        var nz;
        var e;
        var h;
        var j;
        if (this.curve.twisted) {
            e = this.curve._mulA(c);
            var f = e.redAdd(d);
            if (this.zOne) {
                nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
                ny = f.redMul(e.redSub(d));
                nz = f.redSqr().redSub(f).redSub(f);
            } else {
                h = this.z.redSqr();
                j = f.redSub(h).redISub(h);
                nx = b.redSub(c).redISub(d).redMul(j);
                ny = f.redMul(e.redSub(d));
                nz = f.redMul(j);
            }
        } else {
            e = c.redAdd(d);
            h = this.curve._mulC(this.z).redSqr();
            j = e.redSub(h).redSub(h);
            nx = this.curve._mulC(b.redISub(e)).redMul(j);
            ny = this.curve._mulC(e).redMul(c.redISub(d));
            nz = e.redMul(j);
        }
        return this.curve.point(nx, ny, nz);
    };
    $34a6f7f58efb73a0$var$Point.prototype.dbl = function dbl() {
        if (this.isInfinity()) return this;
        if (this.curve.extended) return this._extDbl();
        else return this._projDbl();
    };
    $34a6f7f58efb73a0$var$Point.prototype._extAdd = function _extAdd(p) {
        var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
        var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
        var c = this.t.redMul(this.curve.dd).redMul(p.t);
        var d = this.z.redMul(p.z.redAdd(p.z));
        var e = b.redSub(a);
        var f = d.redSub(c);
        var g = d.redAdd(c);
        var h = b.redAdd(a);
        var nx = e.redMul(f);
        var ny = g.redMul(h);
        var nt = e.redMul(h);
        var nz = f.redMul(g);
        return this.curve.point(nx, ny, nz, nt);
    };
    $34a6f7f58efb73a0$var$Point.prototype._projAdd = function _projAdd(p) {
        var a = this.z.redMul(p.z);
        var b = a.redSqr();
        var c = this.x.redMul(p.x);
        var d = this.y.redMul(p.y);
        var e = this.curve.d.redMul(c).redMul(d);
        var f = b.redSub(e);
        var g = b.redAdd(e);
        var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
        var nx = a.redMul(f).redMul(tmp);
        var ny;
        var nz;
        if (this.curve.twisted) {
            ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
            nz = f.redMul(g);
        } else {
            ny = a.redMul(g).redMul(d.redSub(c));
            nz = this.curve._mulC(f).redMul(g);
        }
        return this.curve.point(nx, ny, nz);
    };
    $34a6f7f58efb73a0$var$Point.prototype.add = function add(p) {
        if (this.isInfinity()) return p;
        if (p.isInfinity()) return this;
        if (this.curve.extended) return this._extAdd(p);
        else return this._projAdd(p);
    };
    $34a6f7f58efb73a0$var$Point.prototype.mul = function mul(k) {
        if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
        else return this.curve._wnafMul(this, k);
    };
    $34a6f7f58efb73a0$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
        return this.curve._wnafMulAdd(1, [
            this,
            p
        ], [
            k1,
            k2
        ], 2, false);
    };
    $34a6f7f58efb73a0$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
        return this.curve._wnafMulAdd(1, [
            this,
            p
        ], [
            k1,
            k2
        ], 2, true);
    };
    $34a6f7f58efb73a0$var$Point.prototype.normalize = function normalize() {
        if (this.zOne) return this;
        var zi = this.z.redInvm();
        this.x = this.x.redMul(zi);
        this.y = this.y.redMul(zi);
        if (this.t) this.t = this.t.redMul(zi);
        this.z = this.curve.one;
        this.zOne = true;
        return this;
    };
    $34a6f7f58efb73a0$var$Point.prototype.neg = function neg() {
        return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    };
    $34a6f7f58efb73a0$var$Point.prototype.getX = function getX() {
        this.normalize();
        return this.x.fromRed();
    };
    $34a6f7f58efb73a0$var$Point.prototype.getY = function getY() {
        this.normalize();
        return this.y.fromRed();
    };
    $34a6f7f58efb73a0$var$Point.prototype.eq = function eq(other) {
        return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
    };
    $34a6f7f58efb73a0$var$Point.prototype.eqXToP = function eqXToP(x) {
        var rx = x.toRed(this.curve.red).redMul(this.z);
        if (this.x.cmp(rx) === 0) return true;
        var xc = x.clone();
        var t = this.curve.redN.redMul(this.z);
        for(;;){
            xc.iadd(this.curve.n);
            if (xc.cmp(this.curve.p) >= 0) return false;
            rx.redIAdd(t);
            if (this.x.cmp(rx) === 0) return true;
        }
    };
    $34a6f7f58efb73a0$var$Point.prototype.toP = $34a6f7f58efb73a0$var$Point.prototype.normalize;
    $34a6f7f58efb73a0$var$Point.prototype.mixedAdd = $34a6f7f58efb73a0$var$Point.prototype.add;
});
parcelRegister("gli5y", function(module, exports) {
    'use strict';
    var $be5ca37f73d5b5bb$var$curves = module.exports;
    var $hx0iN = parcelRequire("hx0iN");
    var $9QOKF = parcelRequire("9QOKF");
    var $onO0l = parcelRequire("onO0l");
    var $be5ca37f73d5b5bb$var$assert = $onO0l.assert;
    function $be5ca37f73d5b5bb$var$PresetCurve(options) {
        if (options.type === 'short') this.curve = new $9QOKF.short(options);
        else if (options.type === 'edwards') this.curve = new $9QOKF.edwards(options);
        else this.curve = new $9QOKF.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        $be5ca37f73d5b5bb$var$assert(this.g.validate(), 'Invalid curve');
        $be5ca37f73d5b5bb$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    }
    $be5ca37f73d5b5bb$var$curves.PresetCurve = $be5ca37f73d5b5bb$var$PresetCurve;
    function $be5ca37f73d5b5bb$var$defineCurve(name, options) {
        Object.defineProperty($be5ca37f73d5b5bb$var$curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new $be5ca37f73d5b5bb$var$PresetCurve(options);
                Object.defineProperty($be5ca37f73d5b5bb$var$curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    $be5ca37f73d5b5bb$var$defineCurve('p192', {
        type: 'short',
        prime: 'p192',
        p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
        b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
        n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
            '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p224', {
        type: 'short',
        prime: 'p224',
        p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
        b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
        n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
            'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p256', {
        type: 'short',
        prime: null,
        p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
        a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
        b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
        n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
            '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p384', {
        type: 'short',
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $hx0iN.sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p521', {
        type: 'short',
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $hx0iN.sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('curve25519', {
        type: 'mont',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '76d06',
        b: '1',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '9'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('ed25519', {
        type: 'edwards',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '-1',
        c: '1',
        d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
            '6666666666666666666666666666666666666666666666666666666666666658'
        ]
    });
    var $be5ca37f73d5b5bb$var$pre;
    try {
        $be5ca37f73d5b5bb$var$pre = (parcelRequire("6pt7M"));
    } catch (e) {
        $be5ca37f73d5b5bb$var$pre = undefined;
    }
    $be5ca37f73d5b5bb$var$defineCurve('secp256k1', {
        type: 'short',
        prime: 'k256',
        p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
        a: '0',
        b: '7',
        n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
        h: '1',
        hash: $hx0iN.sha256,
        beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
        lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
        basis: [
            {
                a: '3086d221a7d46bcde86c90e49284eb15',
                b: '-e4437ed6010e88286f547fa90abfe4c3'
            },
            {
                a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
                b: '3086d221a7d46bcde86c90e49284eb15'
            }
        ],
        gRed: false,
        g: [
            '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
            '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
            $be5ca37f73d5b5bb$var$pre
        ]
    });
});
parcelRegister("hx0iN", function(module, exports) {
    var $cc35c0beabff9706$var$hash = module.exports;
    $cc35c0beabff9706$var$hash.utils = (parcelRequire("3OMi8"));
    $cc35c0beabff9706$var$hash.common = (parcelRequire("37Fr9"));
    $cc35c0beabff9706$var$hash.sha = (parcelRequire("h6ox1"));
    $cc35c0beabff9706$var$hash.ripemd = (parcelRequire("7uO26"));
    $cc35c0beabff9706$var$hash.hmac = (parcelRequire("aFtrN"));
    $cc35c0beabff9706$var$hash.sha1 = $cc35c0beabff9706$var$hash.sha.sha1;
    $cc35c0beabff9706$var$hash.sha256 = $cc35c0beabff9706$var$hash.sha.sha256;
    $cc35c0beabff9706$var$hash.sha224 = $cc35c0beabff9706$var$hash.sha.sha224;
    $cc35c0beabff9706$var$hash.sha384 = $cc35c0beabff9706$var$hash.sha.sha384;
    $cc35c0beabff9706$var$hash.sha512 = $cc35c0beabff9706$var$hash.sha.sha512;
    $cc35c0beabff9706$var$hash.ripemd160 = $cc35c0beabff9706$var$hash.ripemd.ripemd160;
});
parcelRegister("3OMi8", function(module, exports) {
    $parcel$export(module.exports, "inherits", ()=>$2c7b8050559f98bf$export$69f1b2dcda23c5f8, (v)=>$2c7b8050559f98bf$export$69f1b2dcda23c5f8 = v);
    $parcel$export(module.exports, "toArray", ()=>$2c7b8050559f98bf$export$45b10814cc054894, (v)=>$2c7b8050559f98bf$export$45b10814cc054894 = v);
    $parcel$export(module.exports, "toHex", ()=>$2c7b8050559f98bf$export$7ea66e3774a60b67, (v)=>$2c7b8050559f98bf$export$7ea66e3774a60b67 = v);
    $parcel$export(module.exports, "htonl", ()=>$2c7b8050559f98bf$export$34a52f00f601f6f1, (v)=>$2c7b8050559f98bf$export$34a52f00f601f6f1 = v);
    $parcel$export(module.exports, "toHex32", ()=>$2c7b8050559f98bf$export$812b0cbd5e8a72ab, (v)=>$2c7b8050559f98bf$export$812b0cbd5e8a72ab = v);
    $parcel$export(module.exports, "zero2", ()=>$2c7b8050559f98bf$export$f24f9e11d63bb314, (v)=>$2c7b8050559f98bf$export$f24f9e11d63bb314 = v);
    $parcel$export(module.exports, "zero8", ()=>$2c7b8050559f98bf$export$b71357c7e07ca1f1, (v)=>$2c7b8050559f98bf$export$b71357c7e07ca1f1 = v);
    $parcel$export(module.exports, "join32", ()=>$2c7b8050559f98bf$export$2e58a4b541fdcbe8, (v)=>$2c7b8050559f98bf$export$2e58a4b541fdcbe8 = v);
    $parcel$export(module.exports, "split32", ()=>$2c7b8050559f98bf$export$183b950bde9faab8, (v)=>$2c7b8050559f98bf$export$183b950bde9faab8 = v);
    $parcel$export(module.exports, "rotr32", ()=>$2c7b8050559f98bf$export$4785c77169fea59e, (v)=>$2c7b8050559f98bf$export$4785c77169fea59e = v);
    $parcel$export(module.exports, "rotl32", ()=>$2c7b8050559f98bf$export$242a185dfcffac5b, (v)=>$2c7b8050559f98bf$export$242a185dfcffac5b = v);
    $parcel$export(module.exports, "sum32", ()=>$2c7b8050559f98bf$export$58c04ae0ae31877d, (v)=>$2c7b8050559f98bf$export$58c04ae0ae31877d = v);
    $parcel$export(module.exports, "sum32_3", ()=>$2c7b8050559f98bf$export$d058ca695f8c6f11, (v)=>$2c7b8050559f98bf$export$d058ca695f8c6f11 = v);
    $parcel$export(module.exports, "sum32_4", ()=>$2c7b8050559f98bf$export$a1efd7fc3e986367, (v)=>$2c7b8050559f98bf$export$a1efd7fc3e986367 = v);
    $parcel$export(module.exports, "sum32_5", ()=>$2c7b8050559f98bf$export$bbfea4a2b5abaab4, (v)=>$2c7b8050559f98bf$export$bbfea4a2b5abaab4 = v);
    $parcel$export(module.exports, "sum64", ()=>$2c7b8050559f98bf$export$97ad4afc7de86152, (v)=>$2c7b8050559f98bf$export$97ad4afc7de86152 = v);
    $parcel$export(module.exports, "sum64_hi", ()=>$2c7b8050559f98bf$export$ce4673d9a79f6a4b, (v)=>$2c7b8050559f98bf$export$ce4673d9a79f6a4b = v);
    $parcel$export(module.exports, "sum64_lo", ()=>$2c7b8050559f98bf$export$786cc99fc6eedc0b, (v)=>$2c7b8050559f98bf$export$786cc99fc6eedc0b = v);
    $parcel$export(module.exports, "sum64_4_hi", ()=>$2c7b8050559f98bf$export$45c59b9a1848dd0, (v)=>$2c7b8050559f98bf$export$45c59b9a1848dd0 = v);
    $parcel$export(module.exports, "sum64_4_lo", ()=>$2c7b8050559f98bf$export$50d8f613e76d3034, (v)=>$2c7b8050559f98bf$export$50d8f613e76d3034 = v);
    $parcel$export(module.exports, "sum64_5_hi", ()=>$2c7b8050559f98bf$export$b8e83683c60ee162, (v)=>$2c7b8050559f98bf$export$b8e83683c60ee162 = v);
    $parcel$export(module.exports, "sum64_5_lo", ()=>$2c7b8050559f98bf$export$aeeb51790d1bcc4a, (v)=>$2c7b8050559f98bf$export$aeeb51790d1bcc4a = v);
    $parcel$export(module.exports, "rotr64_hi", ()=>$2c7b8050559f98bf$export$bb7c616f719ad9c, (v)=>$2c7b8050559f98bf$export$bb7c616f719ad9c = v);
    $parcel$export(module.exports, "rotr64_lo", ()=>$2c7b8050559f98bf$export$4d63290824f9d7df, (v)=>$2c7b8050559f98bf$export$4d63290824f9d7df = v);
    $parcel$export(module.exports, "shr64_hi", ()=>$2c7b8050559f98bf$export$2f64ceb90ef28ea1, (v)=>$2c7b8050559f98bf$export$2f64ceb90ef28ea1 = v);
    $parcel$export(module.exports, "shr64_lo", ()=>$2c7b8050559f98bf$export$8d2089d465f6d10d, (v)=>$2c7b8050559f98bf$export$8d2089d465f6d10d = v);
    var $2c7b8050559f98bf$export$69f1b2dcda23c5f8;
    var $2c7b8050559f98bf$export$45b10814cc054894;
    var $2c7b8050559f98bf$export$7ea66e3774a60b67;
    var $2c7b8050559f98bf$export$34a52f00f601f6f1;
    var $2c7b8050559f98bf$export$812b0cbd5e8a72ab;
    var $2c7b8050559f98bf$export$f24f9e11d63bb314;
    var $2c7b8050559f98bf$export$b71357c7e07ca1f1;
    var $2c7b8050559f98bf$export$2e58a4b541fdcbe8;
    var $2c7b8050559f98bf$export$183b950bde9faab8;
    var $2c7b8050559f98bf$export$4785c77169fea59e;
    var $2c7b8050559f98bf$export$242a185dfcffac5b;
    var $2c7b8050559f98bf$export$58c04ae0ae31877d;
    var $2c7b8050559f98bf$export$d058ca695f8c6f11;
    var $2c7b8050559f98bf$export$a1efd7fc3e986367;
    var $2c7b8050559f98bf$export$bbfea4a2b5abaab4;
    var $2c7b8050559f98bf$export$97ad4afc7de86152;
    var $2c7b8050559f98bf$export$ce4673d9a79f6a4b;
    var $2c7b8050559f98bf$export$786cc99fc6eedc0b;
    var $2c7b8050559f98bf$export$45c59b9a1848dd0;
    var $2c7b8050559f98bf$export$50d8f613e76d3034;
    var $2c7b8050559f98bf$export$b8e83683c60ee162;
    var $2c7b8050559f98bf$export$aeeb51790d1bcc4a;
    var $2c7b8050559f98bf$export$bb7c616f719ad9c;
    var $2c7b8050559f98bf$export$4d63290824f9d7df;
    var $2c7b8050559f98bf$export$2f64ceb90ef28ea1;
    var $2c7b8050559f98bf$export$8d2089d465f6d10d;
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    $2c7b8050559f98bf$export$69f1b2dcda23c5f8 = $v3bBu;
    function $2c7b8050559f98bf$var$toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg === 'string') {
            if (!enc) for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                var hi = c >> 8;
                var lo = c & 0xff;
                if (hi) res.push(hi, lo);
                else res.push(lo);
            }
            else if (enc === 'hex') {
                msg = msg.replace(/[^a-z0-9]+/ig, '');
                if (msg.length % 2 !== 0) msg = '0' + msg;
                for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
            }
        } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    $2c7b8050559f98bf$export$45b10814cc054894 = $2c7b8050559f98bf$var$toArray;
    function $2c7b8050559f98bf$var$toHex(msg) {
        var res = '';
        for(var i = 0; i < msg.length; i++)res += $2c7b8050559f98bf$var$zero2(msg[i].toString(16));
        return res;
    }
    $2c7b8050559f98bf$export$7ea66e3774a60b67 = $2c7b8050559f98bf$var$toHex;
    function $2c7b8050559f98bf$var$htonl(w) {
        var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
        return res >>> 0;
    }
    $2c7b8050559f98bf$export$34a52f00f601f6f1 = $2c7b8050559f98bf$var$htonl;
    function $2c7b8050559f98bf$var$toHex32(msg, endian) {
        var res = '';
        for(var i = 0; i < msg.length; i++){
            var w = msg[i];
            if (endian === 'little') w = $2c7b8050559f98bf$var$htonl(w);
            res += $2c7b8050559f98bf$var$zero8(w.toString(16));
        }
        return res;
    }
    $2c7b8050559f98bf$export$812b0cbd5e8a72ab = $2c7b8050559f98bf$var$toHex32;
    function $2c7b8050559f98bf$var$zero2(word) {
        if (word.length === 1) return '0' + word;
        else return word;
    }
    $2c7b8050559f98bf$export$f24f9e11d63bb314 = $2c7b8050559f98bf$var$zero2;
    function $2c7b8050559f98bf$var$zero8(word) {
        if (word.length === 7) return '0' + word;
        else if (word.length === 6) return '00' + word;
        else if (word.length === 5) return '000' + word;
        else if (word.length === 4) return '0000' + word;
        else if (word.length === 3) return '00000' + word;
        else if (word.length === 2) return '000000' + word;
        else if (word.length === 1) return '0000000' + word;
        else return word;
    }
    $2c7b8050559f98bf$export$b71357c7e07ca1f1 = $2c7b8050559f98bf$var$zero8;
    function $2c7b8050559f98bf$var$join32(msg, start, end, endian) {
        var len = end - start;
        $gxaFy(len % 4 === 0);
        var res = new Array(len / 4);
        for(var i = 0, k = start; i < res.length; i++, k += 4){
            var w;
            if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
            else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
            res[i] = w >>> 0;
        }
        return res;
    }
    $2c7b8050559f98bf$export$2e58a4b541fdcbe8 = $2c7b8050559f98bf$var$join32;
    function $2c7b8050559f98bf$var$split32(msg, endian) {
        var res = new Array(msg.length * 4);
        for(var i = 0, k = 0; i < msg.length; i++, k += 4){
            var m = msg[i];
            if (endian === 'big') {
                res[k] = m >>> 24;
                res[k + 1] = m >>> 16 & 0xff;
                res[k + 2] = m >>> 8 & 0xff;
                res[k + 3] = m & 0xff;
            } else {
                res[k + 3] = m >>> 24;
                res[k + 2] = m >>> 16 & 0xff;
                res[k + 1] = m >>> 8 & 0xff;
                res[k] = m & 0xff;
            }
        }
        return res;
    }
    $2c7b8050559f98bf$export$183b950bde9faab8 = $2c7b8050559f98bf$var$split32;
    function $2c7b8050559f98bf$var$rotr32(w, b) {
        return w >>> b | w << 32 - b;
    }
    $2c7b8050559f98bf$export$4785c77169fea59e = $2c7b8050559f98bf$var$rotr32;
    function $2c7b8050559f98bf$var$rotl32(w, b) {
        return w << b | w >>> 32 - b;
    }
    $2c7b8050559f98bf$export$242a185dfcffac5b = $2c7b8050559f98bf$var$rotl32;
    function $2c7b8050559f98bf$var$sum32(a, b) {
        return a + b >>> 0;
    }
    $2c7b8050559f98bf$export$58c04ae0ae31877d = $2c7b8050559f98bf$var$sum32;
    function $2c7b8050559f98bf$var$sum32_3(a, b, c) {
        return a + b + c >>> 0;
    }
    $2c7b8050559f98bf$export$d058ca695f8c6f11 = $2c7b8050559f98bf$var$sum32_3;
    function $2c7b8050559f98bf$var$sum32_4(a, b, c, d) {
        return a + b + c + d >>> 0;
    }
    $2c7b8050559f98bf$export$a1efd7fc3e986367 = $2c7b8050559f98bf$var$sum32_4;
    function $2c7b8050559f98bf$var$sum32_5(a, b, c, d, e) {
        return a + b + c + d + e >>> 0;
    }
    $2c7b8050559f98bf$export$bbfea4a2b5abaab4 = $2c7b8050559f98bf$var$sum32_5;
    function $2c7b8050559f98bf$var$sum64(buf, pos, ah, al) {
        var bh = buf[pos];
        var bl = buf[pos + 1];
        var lo = al + bl >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        buf[pos] = hi >>> 0;
        buf[pos + 1] = lo;
    }
    $2c7b8050559f98bf$export$97ad4afc7de86152 = $2c7b8050559f98bf$var$sum64;
    function $2c7b8050559f98bf$var$sum64_hi(ah, al, bh, bl) {
        var lo = al + bl >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        return hi >>> 0;
    }
    $2c7b8050559f98bf$export$ce4673d9a79f6a4b = $2c7b8050559f98bf$var$sum64_hi;
    function $2c7b8050559f98bf$var$sum64_lo(ah, al, bh, bl) {
        var lo = al + bl;
        return lo >>> 0;
    }
    $2c7b8050559f98bf$export$786cc99fc6eedc0b = $2c7b8050559f98bf$var$sum64_lo;
    function $2c7b8050559f98bf$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
        var carry = 0;
        var lo = al;
        lo = lo + bl >>> 0;
        carry += lo < al ? 1 : 0;
        lo = lo + cl >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = lo + dl >>> 0;
        carry += lo < dl ? 1 : 0;
        var hi = ah + bh + ch + dh + carry;
        return hi >>> 0;
    }
    $2c7b8050559f98bf$export$45c59b9a1848dd0 = $2c7b8050559f98bf$var$sum64_4_hi;
    function $2c7b8050559f98bf$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
        var lo = al + bl + cl + dl;
        return lo >>> 0;
    }
    $2c7b8050559f98bf$export$50d8f613e76d3034 = $2c7b8050559f98bf$var$sum64_4_lo;
    function $2c7b8050559f98bf$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var carry = 0;
        var lo = al;
        lo = lo + bl >>> 0;
        carry += lo < al ? 1 : 0;
        lo = lo + cl >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = lo + dl >>> 0;
        carry += lo < dl ? 1 : 0;
        lo = lo + el >>> 0;
        carry += lo < el ? 1 : 0;
        var hi = ah + bh + ch + dh + eh + carry;
        return hi >>> 0;
    }
    $2c7b8050559f98bf$export$b8e83683c60ee162 = $2c7b8050559f98bf$var$sum64_5_hi;
    function $2c7b8050559f98bf$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var lo = al + bl + cl + dl + el;
        return lo >>> 0;
    }
    $2c7b8050559f98bf$export$aeeb51790d1bcc4a = $2c7b8050559f98bf$var$sum64_5_lo;
    function $2c7b8050559f98bf$var$rotr64_hi(ah, al, num) {
        var r = al << 32 - num | ah >>> num;
        return r >>> 0;
    }
    $2c7b8050559f98bf$export$bb7c616f719ad9c = $2c7b8050559f98bf$var$rotr64_hi;
    function $2c7b8050559f98bf$var$rotr64_lo(ah, al, num) {
        var r = ah << 32 - num | al >>> num;
        return r >>> 0;
    }
    $2c7b8050559f98bf$export$4d63290824f9d7df = $2c7b8050559f98bf$var$rotr64_lo;
    function $2c7b8050559f98bf$var$shr64_hi(ah, al, num) {
        return ah >>> num;
    }
    $2c7b8050559f98bf$export$2f64ceb90ef28ea1 = $2c7b8050559f98bf$var$shr64_hi;
    function $2c7b8050559f98bf$var$shr64_lo(ah, al, num) {
        var r = ah << 32 - num | al >>> num;
        return r >>> 0;
    }
    $2c7b8050559f98bf$export$8d2089d465f6d10d = $2c7b8050559f98bf$var$shr64_lo;
});
parcelRegister("37Fr9", function(module, exports) {
    $parcel$export(module.exports, "BlockHash", ()=>$24622b0c2a9af610$export$8687658379b577e6, (v)=>$24622b0c2a9af610$export$8687658379b577e6 = v);
    var $24622b0c2a9af610$export$8687658379b577e6;
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $gxaFy = parcelRequire("gxaFy");
    function $24622b0c2a9af610$var$BlockHash() {
        this.pending = null;
        this.pendingTotal = 0;
        this.blockSize = this.constructor.blockSize;
        this.outSize = this.constructor.outSize;
        this.hmacStrength = this.constructor.hmacStrength;
        this.padLength = this.constructor.padLength / 8;
        this.endian = 'big';
        this._delta8 = this.blockSize / 8;
        this._delta32 = this.blockSize / 32;
    }
    $24622b0c2a9af610$export$8687658379b577e6 = $24622b0c2a9af610$var$BlockHash;
    $24622b0c2a9af610$var$BlockHash.prototype.update = function update(msg, enc) {
        msg = $3OMi8.toArray(msg, enc);
        if (!this.pending) this.pending = msg;
        else this.pending = this.pending.concat(msg);
        this.pendingTotal += msg.length;
        if (this.pending.length >= this._delta8) {
            msg = this.pending;
            var r = msg.length % this._delta8;
            this.pending = msg.slice(msg.length - r, msg.length);
            if (this.pending.length === 0) this.pending = null;
            msg = $3OMi8.join32(msg, 0, msg.length - r, this.endian);
            for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
        }
        return this;
    };
    $24622b0c2a9af610$var$BlockHash.prototype.digest = function digest(enc) {
        this.update(this._pad());
        $gxaFy(this.pending === null);
        return this._digest(enc);
    };
    $24622b0c2a9af610$var$BlockHash.prototype._pad = function pad() {
        var len = this.pendingTotal;
        var bytes = this._delta8;
        var k = bytes - (len + this.padLength) % bytes;
        var res = new Array(k + this.padLength);
        res[0] = 0x80;
        for(var i = 1; i < k; i++)res[i] = 0;
        len <<= 3;
        if (this.endian === 'big') {
            for(var t = 8; t < this.padLength; t++)res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = len >>> 24 & 0xff;
            res[i++] = len >>> 16 & 0xff;
            res[i++] = len >>> 8 & 0xff;
            res[i++] = len & 0xff;
        } else {
            res[i++] = len & 0xff;
            res[i++] = len >>> 8 & 0xff;
            res[i++] = len >>> 16 & 0xff;
            res[i++] = len >>> 24 & 0xff;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            for(t = 8; t < this.padLength; t++)res[i++] = 0;
        }
        return res;
    };
});
parcelRegister("h6ox1", function(module, exports) {
    $parcel$export(module.exports, "sha1", ()=>$c73606a9c2933b70$export$5091bdda49ba90f5, (v)=>$c73606a9c2933b70$export$5091bdda49ba90f5 = v);
    $parcel$export(module.exports, "sha224", ()=>$c73606a9c2933b70$export$97b70509d4e397ea, (v)=>$c73606a9c2933b70$export$97b70509d4e397ea = v);
    $parcel$export(module.exports, "sha256", ()=>$c73606a9c2933b70$export$bced8d2aada2d1c9, (v)=>$c73606a9c2933b70$export$bced8d2aada2d1c9 = v);
    $parcel$export(module.exports, "sha384", ()=>$c73606a9c2933b70$export$612d47d55dedde45, (v)=>$c73606a9c2933b70$export$612d47d55dedde45 = v);
    $parcel$export(module.exports, "sha512", ()=>$c73606a9c2933b70$export$a888d2532e6dc7bb, (v)=>$c73606a9c2933b70$export$a888d2532e6dc7bb = v);
    var $c73606a9c2933b70$export$5091bdda49ba90f5;
    var $c73606a9c2933b70$export$97b70509d4e397ea;
    var $c73606a9c2933b70$export$bced8d2aada2d1c9;
    var $c73606a9c2933b70$export$612d47d55dedde45;
    var $c73606a9c2933b70$export$a888d2532e6dc7bb;
    'use strict';
    $c73606a9c2933b70$export$5091bdda49ba90f5 = (parcelRequire("fjde1"));
    $c73606a9c2933b70$export$97b70509d4e397ea = (parcelRequire("9SOcT"));
    $c73606a9c2933b70$export$bced8d2aada2d1c9 = (parcelRequire("56TG7"));
    $c73606a9c2933b70$export$612d47d55dedde45 = (parcelRequire("bmcCc"));
    $c73606a9c2933b70$export$a888d2532e6dc7bb = (parcelRequire("5EQvK"));
});
parcelRegister("fjde1", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $35KxV = parcelRequire("35KxV");
    var $02e04dfe542928ee$var$rotl32 = $3OMi8.rotl32;
    var $02e04dfe542928ee$var$sum32 = $3OMi8.sum32;
    var $02e04dfe542928ee$var$sum32_5 = $3OMi8.sum32_5;
    var $02e04dfe542928ee$var$ft_1 = $35KxV.ft_1;
    var $02e04dfe542928ee$var$BlockHash = $37Fr9.BlockHash;
    var $02e04dfe542928ee$var$sha1_K = [
        0x5A827999,
        0x6ED9EBA1,
        0x8F1BBCDC,
        0xCA62C1D6
    ];
    function $02e04dfe542928ee$var$SHA1() {
        if (!(this instanceof $02e04dfe542928ee$var$SHA1)) return new $02e04dfe542928ee$var$SHA1();
        $02e04dfe542928ee$var$BlockHash.call(this);
        this.h = [
            0x67452301,
            0xefcdab89,
            0x98badcfe,
            0x10325476,
            0xc3d2e1f0
        ];
        this.W = new Array(80);
    }
    $3OMi8.inherits($02e04dfe542928ee$var$SHA1, $02e04dfe542928ee$var$BlockHash);
    module.exports = $02e04dfe542928ee$var$SHA1;
    $02e04dfe542928ee$var$SHA1.blockSize = 512;
    $02e04dfe542928ee$var$SHA1.outSize = 160;
    $02e04dfe542928ee$var$SHA1.hmacStrength = 80;
    $02e04dfe542928ee$var$SHA1.padLength = 64;
    $02e04dfe542928ee$var$SHA1.prototype._update = function _update(msg, start) {
        var W = this.W;
        for(var i = 0; i < 16; i++)W[i] = msg[start + i];
        for(; i < W.length; i++)W[i] = $02e04dfe542928ee$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        for(i = 0; i < W.length; i++){
            var s = ~~(i / 20);
            var t = $02e04dfe542928ee$var$sum32_5($02e04dfe542928ee$var$rotl32(a, 5), $02e04dfe542928ee$var$ft_1(s, b, c, d), e, W[i], $02e04dfe542928ee$var$sha1_K[s]);
            e = d;
            d = c;
            c = $02e04dfe542928ee$var$rotl32(b, 30);
            b = a;
            a = t;
        }
        this.h[0] = $02e04dfe542928ee$var$sum32(this.h[0], a);
        this.h[1] = $02e04dfe542928ee$var$sum32(this.h[1], b);
        this.h[2] = $02e04dfe542928ee$var$sum32(this.h[2], c);
        this.h[3] = $02e04dfe542928ee$var$sum32(this.h[3], d);
        this.h[4] = $02e04dfe542928ee$var$sum32(this.h[4], e);
    };
    $02e04dfe542928ee$var$SHA1.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
        else return $3OMi8.split32(this.h, 'big');
    };
});
parcelRegister("35KxV", function(module, exports) {
    $parcel$export(module.exports, "ft_1", ()=>$2405f1d094d8bdf3$export$5a92649d7ddb9f63, (v)=>$2405f1d094d8bdf3$export$5a92649d7ddb9f63 = v);
    $parcel$export(module.exports, "ch32", ()=>$2405f1d094d8bdf3$export$c6d0d020c3a6269, (v)=>$2405f1d094d8bdf3$export$c6d0d020c3a6269 = v);
    $parcel$export(module.exports, "maj32", ()=>$2405f1d094d8bdf3$export$eb90c27fca05f956, (v)=>$2405f1d094d8bdf3$export$eb90c27fca05f956 = v);
    $parcel$export(module.exports, "s0_256", ()=>$2405f1d094d8bdf3$export$14a4a98e063b1999, (v)=>$2405f1d094d8bdf3$export$14a4a98e063b1999 = v);
    $parcel$export(module.exports, "s1_256", ()=>$2405f1d094d8bdf3$export$d20cecfa1564c686, (v)=>$2405f1d094d8bdf3$export$d20cecfa1564c686 = v);
    $parcel$export(module.exports, "g0_256", ()=>$2405f1d094d8bdf3$export$44fd472a12fc6db, (v)=>$2405f1d094d8bdf3$export$44fd472a12fc6db = v);
    $parcel$export(module.exports, "g1_256", ()=>$2405f1d094d8bdf3$export$1ed238bb6ea1dd47, (v)=>$2405f1d094d8bdf3$export$1ed238bb6ea1dd47 = v);
    var $2405f1d094d8bdf3$export$5a92649d7ddb9f63;
    var $2405f1d094d8bdf3$export$c6d0d020c3a6269;
    var $2405f1d094d8bdf3$export$eb90c27fca05f956;
    var $2405f1d094d8bdf3$export$cc992891a14496a1;
    var $2405f1d094d8bdf3$export$14a4a98e063b1999;
    var $2405f1d094d8bdf3$export$d20cecfa1564c686;
    var $2405f1d094d8bdf3$export$44fd472a12fc6db;
    var $2405f1d094d8bdf3$export$1ed238bb6ea1dd47;
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $2405f1d094d8bdf3$var$rotr32 = $3OMi8.rotr32;
    function $2405f1d094d8bdf3$var$ft_1(s, x, y, z) {
        if (s === 0) return $2405f1d094d8bdf3$var$ch32(x, y, z);
        if (s === 1 || s === 3) return $2405f1d094d8bdf3$var$p32(x, y, z);
        if (s === 2) return $2405f1d094d8bdf3$var$maj32(x, y, z);
    }
    $2405f1d094d8bdf3$export$5a92649d7ddb9f63 = $2405f1d094d8bdf3$var$ft_1;
    function $2405f1d094d8bdf3$var$ch32(x, y, z) {
        return x & y ^ ~x & z;
    }
    $2405f1d094d8bdf3$export$c6d0d020c3a6269 = $2405f1d094d8bdf3$var$ch32;
    function $2405f1d094d8bdf3$var$maj32(x, y, z) {
        return x & y ^ x & z ^ y & z;
    }
    $2405f1d094d8bdf3$export$eb90c27fca05f956 = $2405f1d094d8bdf3$var$maj32;
    function $2405f1d094d8bdf3$var$p32(x, y, z) {
        return x ^ y ^ z;
    }
    $2405f1d094d8bdf3$export$cc992891a14496a1 = $2405f1d094d8bdf3$var$p32;
    function $2405f1d094d8bdf3$var$s0_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 2) ^ $2405f1d094d8bdf3$var$rotr32(x, 13) ^ $2405f1d094d8bdf3$var$rotr32(x, 22);
    }
    $2405f1d094d8bdf3$export$14a4a98e063b1999 = $2405f1d094d8bdf3$var$s0_256;
    function $2405f1d094d8bdf3$var$s1_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 6) ^ $2405f1d094d8bdf3$var$rotr32(x, 11) ^ $2405f1d094d8bdf3$var$rotr32(x, 25);
    }
    $2405f1d094d8bdf3$export$d20cecfa1564c686 = $2405f1d094d8bdf3$var$s1_256;
    function $2405f1d094d8bdf3$var$g0_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 7) ^ $2405f1d094d8bdf3$var$rotr32(x, 18) ^ x >>> 3;
    }
    $2405f1d094d8bdf3$export$44fd472a12fc6db = $2405f1d094d8bdf3$var$g0_256;
    function $2405f1d094d8bdf3$var$g1_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 17) ^ $2405f1d094d8bdf3$var$rotr32(x, 19) ^ x >>> 10;
    }
    $2405f1d094d8bdf3$export$1ed238bb6ea1dd47 = $2405f1d094d8bdf3$var$g1_256;
});
parcelRegister("9SOcT", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $56TG7 = parcelRequire("56TG7");
    function $73201a428a00b147$var$SHA224() {
        if (!(this instanceof $73201a428a00b147$var$SHA224)) return new $73201a428a00b147$var$SHA224();
        $56TG7.call(this);
        this.h = [
            0xc1059ed8,
            0x367cd507,
            0x3070dd17,
            0xf70e5939,
            0xffc00b31,
            0x68581511,
            0x64f98fa7,
            0xbefa4fa4
        ];
    }
    $3OMi8.inherits($73201a428a00b147$var$SHA224, $56TG7);
    module.exports = $73201a428a00b147$var$SHA224;
    $73201a428a00b147$var$SHA224.blockSize = 512;
    $73201a428a00b147$var$SHA224.outSize = 224;
    $73201a428a00b147$var$SHA224.hmacStrength = 192;
    $73201a428a00b147$var$SHA224.padLength = 64;
    $73201a428a00b147$var$SHA224.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h.slice(0, 7), 'big');
        else return $3OMi8.split32(this.h.slice(0, 7), 'big');
    };
});
parcelRegister("56TG7", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $35KxV = parcelRequire("35KxV");
    var $gxaFy = parcelRequire("gxaFy");
    var $3b88b3dcc017da11$var$sum32 = $3OMi8.sum32;
    var $3b88b3dcc017da11$var$sum32_4 = $3OMi8.sum32_4;
    var $3b88b3dcc017da11$var$sum32_5 = $3OMi8.sum32_5;
    var $3b88b3dcc017da11$var$ch32 = $35KxV.ch32;
    var $3b88b3dcc017da11$var$maj32 = $35KxV.maj32;
    var $3b88b3dcc017da11$var$s0_256 = $35KxV.s0_256;
    var $3b88b3dcc017da11$var$s1_256 = $35KxV.s1_256;
    var $3b88b3dcc017da11$var$g0_256 = $35KxV.g0_256;
    var $3b88b3dcc017da11$var$g1_256 = $35KxV.g1_256;
    var $3b88b3dcc017da11$var$BlockHash = $37Fr9.BlockHash;
    var $3b88b3dcc017da11$var$sha256_K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    function $3b88b3dcc017da11$var$SHA256() {
        if (!(this instanceof $3b88b3dcc017da11$var$SHA256)) return new $3b88b3dcc017da11$var$SHA256();
        $3b88b3dcc017da11$var$BlockHash.call(this);
        this.h = [
            0x6a09e667,
            0xbb67ae85,
            0x3c6ef372,
            0xa54ff53a,
            0x510e527f,
            0x9b05688c,
            0x1f83d9ab,
            0x5be0cd19
        ];
        this.k = $3b88b3dcc017da11$var$sha256_K;
        this.W = new Array(64);
    }
    $3OMi8.inherits($3b88b3dcc017da11$var$SHA256, $3b88b3dcc017da11$var$BlockHash);
    module.exports = $3b88b3dcc017da11$var$SHA256;
    $3b88b3dcc017da11$var$SHA256.blockSize = 512;
    $3b88b3dcc017da11$var$SHA256.outSize = 256;
    $3b88b3dcc017da11$var$SHA256.hmacStrength = 192;
    $3b88b3dcc017da11$var$SHA256.padLength = 64;
    $3b88b3dcc017da11$var$SHA256.prototype._update = function _update(msg, start) {
        var W = this.W;
        for(var i = 0; i < 16; i++)W[i] = msg[start + i];
        for(; i < W.length; i++)W[i] = $3b88b3dcc017da11$var$sum32_4($3b88b3dcc017da11$var$g1_256(W[i - 2]), W[i - 7], $3b88b3dcc017da11$var$g0_256(W[i - 15]), W[i - 16]);
        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        var f = this.h[5];
        var g = this.h[6];
        var h = this.h[7];
        $gxaFy(this.k.length === W.length);
        for(i = 0; i < W.length; i++){
            var T1 = $3b88b3dcc017da11$var$sum32_5(h, $3b88b3dcc017da11$var$s1_256(e), $3b88b3dcc017da11$var$ch32(e, f, g), this.k[i], W[i]);
            var T2 = $3b88b3dcc017da11$var$sum32($3b88b3dcc017da11$var$s0_256(a), $3b88b3dcc017da11$var$maj32(a, b, c));
            h = g;
            g = f;
            f = e;
            e = $3b88b3dcc017da11$var$sum32(d, T1);
            d = c;
            c = b;
            b = a;
            a = $3b88b3dcc017da11$var$sum32(T1, T2);
        }
        this.h[0] = $3b88b3dcc017da11$var$sum32(this.h[0], a);
        this.h[1] = $3b88b3dcc017da11$var$sum32(this.h[1], b);
        this.h[2] = $3b88b3dcc017da11$var$sum32(this.h[2], c);
        this.h[3] = $3b88b3dcc017da11$var$sum32(this.h[3], d);
        this.h[4] = $3b88b3dcc017da11$var$sum32(this.h[4], e);
        this.h[5] = $3b88b3dcc017da11$var$sum32(this.h[5], f);
        this.h[6] = $3b88b3dcc017da11$var$sum32(this.h[6], g);
        this.h[7] = $3b88b3dcc017da11$var$sum32(this.h[7], h);
    };
    $3b88b3dcc017da11$var$SHA256.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
        else return $3OMi8.split32(this.h, 'big');
    };
});
parcelRegister("bmcCc", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $5EQvK = parcelRequire("5EQvK");
    function $844b88dda8a6facd$var$SHA384() {
        if (!(this instanceof $844b88dda8a6facd$var$SHA384)) return new $844b88dda8a6facd$var$SHA384();
        $5EQvK.call(this);
        this.h = [
            0xcbbb9d5d,
            0xc1059ed8,
            0x629a292a,
            0x367cd507,
            0x9159015a,
            0x3070dd17,
            0x152fecd8,
            0xf70e5939,
            0x67332667,
            0xffc00b31,
            0x8eb44a87,
            0x68581511,
            0xdb0c2e0d,
            0x64f98fa7,
            0x47b5481d,
            0xbefa4fa4
        ];
    }
    $3OMi8.inherits($844b88dda8a6facd$var$SHA384, $5EQvK);
    module.exports = $844b88dda8a6facd$var$SHA384;
    $844b88dda8a6facd$var$SHA384.blockSize = 1024;
    $844b88dda8a6facd$var$SHA384.outSize = 384;
    $844b88dda8a6facd$var$SHA384.hmacStrength = 192;
    $844b88dda8a6facd$var$SHA384.padLength = 128;
    $844b88dda8a6facd$var$SHA384.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h.slice(0, 12), 'big');
        else return $3OMi8.split32(this.h.slice(0, 12), 'big');
    };
});
parcelRegister("5EQvK", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $gxaFy = parcelRequire("gxaFy");
    var $41e96bc7d61a2263$var$rotr64_hi = $3OMi8.rotr64_hi;
    var $41e96bc7d61a2263$var$rotr64_lo = $3OMi8.rotr64_lo;
    var $41e96bc7d61a2263$var$shr64_hi = $3OMi8.shr64_hi;
    var $41e96bc7d61a2263$var$shr64_lo = $3OMi8.shr64_lo;
    var $41e96bc7d61a2263$var$sum64 = $3OMi8.sum64;
    var $41e96bc7d61a2263$var$sum64_hi = $3OMi8.sum64_hi;
    var $41e96bc7d61a2263$var$sum64_lo = $3OMi8.sum64_lo;
    var $41e96bc7d61a2263$var$sum64_4_hi = $3OMi8.sum64_4_hi;
    var $41e96bc7d61a2263$var$sum64_4_lo = $3OMi8.sum64_4_lo;
    var $41e96bc7d61a2263$var$sum64_5_hi = $3OMi8.sum64_5_hi;
    var $41e96bc7d61a2263$var$sum64_5_lo = $3OMi8.sum64_5_lo;
    var $41e96bc7d61a2263$var$BlockHash = $37Fr9.BlockHash;
    var $41e96bc7d61a2263$var$sha512_K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function $41e96bc7d61a2263$var$SHA512() {
        if (!(this instanceof $41e96bc7d61a2263$var$SHA512)) return new $41e96bc7d61a2263$var$SHA512();
        $41e96bc7d61a2263$var$BlockHash.call(this);
        this.h = [
            0x6a09e667,
            0xf3bcc908,
            0xbb67ae85,
            0x84caa73b,
            0x3c6ef372,
            0xfe94f82b,
            0xa54ff53a,
            0x5f1d36f1,
            0x510e527f,
            0xade682d1,
            0x9b05688c,
            0x2b3e6c1f,
            0x1f83d9ab,
            0xfb41bd6b,
            0x5be0cd19,
            0x137e2179
        ];
        this.k = $41e96bc7d61a2263$var$sha512_K;
        this.W = new Array(160);
    }
    $3OMi8.inherits($41e96bc7d61a2263$var$SHA512, $41e96bc7d61a2263$var$BlockHash);
    module.exports = $41e96bc7d61a2263$var$SHA512;
    $41e96bc7d61a2263$var$SHA512.blockSize = 1024;
    $41e96bc7d61a2263$var$SHA512.outSize = 512;
    $41e96bc7d61a2263$var$SHA512.hmacStrength = 192;
    $41e96bc7d61a2263$var$SHA512.padLength = 128;
    $41e96bc7d61a2263$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
        var W = this.W;
        for(var i = 0; i < 32; i++)W[i] = msg[start + i];
        for(; i < W.length; i += 2){
            var c0_hi = $41e96bc7d61a2263$var$g1_512_hi(W[i - 4], W[i - 3]);
            var c0_lo = $41e96bc7d61a2263$var$g1_512_lo(W[i - 4], W[i - 3]);
            var c1_hi = W[i - 14];
            var c1_lo = W[i - 13];
            var c2_hi = $41e96bc7d61a2263$var$g0_512_hi(W[i - 30], W[i - 29]);
            var c2_lo = $41e96bc7d61a2263$var$g0_512_lo(W[i - 30], W[i - 29]);
            var c3_hi = W[i - 32];
            var c3_lo = W[i - 31];
            W[i] = $41e96bc7d61a2263$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
            W[i + 1] = $41e96bc7d61a2263$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        }
    };
    $41e96bc7d61a2263$var$SHA512.prototype._update = function _update(msg, start) {
        this._prepareBlock(msg, start);
        var W = this.W;
        var ah = this.h[0];
        var al = this.h[1];
        var bh = this.h[2];
        var bl = this.h[3];
        var ch = this.h[4];
        var cl = this.h[5];
        var dh = this.h[6];
        var dl = this.h[7];
        var eh = this.h[8];
        var el = this.h[9];
        var fh = this.h[10];
        var fl = this.h[11];
        var gh = this.h[12];
        var gl = this.h[13];
        var hh = this.h[14];
        var hl = this.h[15];
        $gxaFy(this.k.length === W.length);
        for(var i = 0; i < W.length; i += 2){
            var c0_hi = hh;
            var c0_lo = hl;
            var c1_hi = $41e96bc7d61a2263$var$s1_512_hi(eh, el);
            var c1_lo = $41e96bc7d61a2263$var$s1_512_lo(eh, el);
            var c2_hi = $41e96bc7d61a2263$var$ch64_hi(eh, el, fh, fl, gh, gl);
            var c2_lo = $41e96bc7d61a2263$var$ch64_lo(eh, el, fh, fl, gh, gl);
            var c3_hi = this.k[i];
            var c3_lo = this.k[i + 1];
            var c4_hi = W[i];
            var c4_lo = W[i + 1];
            var T1_hi = $41e96bc7d61a2263$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
            var T1_lo = $41e96bc7d61a2263$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
            c0_hi = $41e96bc7d61a2263$var$s0_512_hi(ah, al);
            c0_lo = $41e96bc7d61a2263$var$s0_512_lo(ah, al);
            c1_hi = $41e96bc7d61a2263$var$maj64_hi(ah, al, bh, bl, ch, cl);
            c1_lo = $41e96bc7d61a2263$var$maj64_lo(ah, al, bh, bl, ch, cl);
            var T2_hi = $41e96bc7d61a2263$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
            var T2_lo = $41e96bc7d61a2263$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
            hh = gh;
            hl = gl;
            gh = fh;
            gl = fl;
            fh = eh;
            fl = el;
            eh = $41e96bc7d61a2263$var$sum64_hi(dh, dl, T1_hi, T1_lo);
            el = $41e96bc7d61a2263$var$sum64_lo(dl, dl, T1_hi, T1_lo);
            dh = ch;
            dl = cl;
            ch = bh;
            cl = bl;
            bh = ah;
            bl = al;
            ah = $41e96bc7d61a2263$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
            al = $41e96bc7d61a2263$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
        }
        $41e96bc7d61a2263$var$sum64(this.h, 0, ah, al);
        $41e96bc7d61a2263$var$sum64(this.h, 2, bh, bl);
        $41e96bc7d61a2263$var$sum64(this.h, 4, ch, cl);
        $41e96bc7d61a2263$var$sum64(this.h, 6, dh, dl);
        $41e96bc7d61a2263$var$sum64(this.h, 8, eh, el);
        $41e96bc7d61a2263$var$sum64(this.h, 10, fh, fl);
        $41e96bc7d61a2263$var$sum64(this.h, 12, gh, gl);
        $41e96bc7d61a2263$var$sum64(this.h, 14, hh, hl);
    };
    $41e96bc7d61a2263$var$SHA512.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
        else return $3OMi8.split32(this.h, 'big');
    };
    function $41e96bc7d61a2263$var$ch64_hi(xh, xl, yh, yl, zh) {
        var r = xh & yh ^ ~xh & zh;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
        var r = xl & yl ^ ~xl & zl;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$maj64_hi(xh, xl, yh, yl, zh) {
        var r = xh & yh ^ xh & zh ^ yh & zh;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
        var r = xl & yl ^ xl & zl ^ yl & zl;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s0_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 28);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 2);
        var c2_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 7);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s0_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 28);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 2);
        var c2_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 7);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s1_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 14);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 18);
        var c2_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 9);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s1_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 14);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 18);
        var c2_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 9);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g0_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 1);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 8);
        var c2_hi = $41e96bc7d61a2263$var$shr64_hi(xh, xl, 7);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g0_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 1);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 8);
        var c2_lo = $41e96bc7d61a2263$var$shr64_lo(xh, xl, 7);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g1_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 19);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 29);
        var c2_hi = $41e96bc7d61a2263$var$shr64_hi(xh, xl, 6);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g1_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 19);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 29);
        var c2_lo = $41e96bc7d61a2263$var$shr64_lo(xh, xl, 6);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
});
parcelRegister("7uO26", function(module, exports) {
    $parcel$export(module.exports, "ripemd160", ()=>$575225433f68bc9a$export$d1cea0ee4e3f0d3e, (v)=>$575225433f68bc9a$export$d1cea0ee4e3f0d3e = v);
    var $575225433f68bc9a$export$d1cea0ee4e3f0d3e;
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $575225433f68bc9a$var$rotl32 = $3OMi8.rotl32;
    var $575225433f68bc9a$var$sum32 = $3OMi8.sum32;
    var $575225433f68bc9a$var$sum32_3 = $3OMi8.sum32_3;
    var $575225433f68bc9a$var$sum32_4 = $3OMi8.sum32_4;
    var $575225433f68bc9a$var$BlockHash = $37Fr9.BlockHash;
    function $575225433f68bc9a$var$RIPEMD160() {
        if (!(this instanceof $575225433f68bc9a$var$RIPEMD160)) return new $575225433f68bc9a$var$RIPEMD160();
        $575225433f68bc9a$var$BlockHash.call(this);
        this.h = [
            0x67452301,
            0xefcdab89,
            0x98badcfe,
            0x10325476,
            0xc3d2e1f0
        ];
        this.endian = 'little';
    }
    $3OMi8.inherits($575225433f68bc9a$var$RIPEMD160, $575225433f68bc9a$var$BlockHash);
    $575225433f68bc9a$export$d1cea0ee4e3f0d3e = $575225433f68bc9a$var$RIPEMD160;
    $575225433f68bc9a$var$RIPEMD160.blockSize = 512;
    $575225433f68bc9a$var$RIPEMD160.outSize = 160;
    $575225433f68bc9a$var$RIPEMD160.hmacStrength = 192;
    $575225433f68bc9a$var$RIPEMD160.padLength = 64;
    $575225433f68bc9a$var$RIPEMD160.prototype._update = function update(msg, start) {
        var A = this.h[0];
        var B = this.h[1];
        var C = this.h[2];
        var D = this.h[3];
        var E = this.h[4];
        var Ah = A;
        var Bh = B;
        var Ch = C;
        var Dh = D;
        var Eh = E;
        for(var j = 0; j < 80; j++){
            var T = $575225433f68bc9a$var$sum32($575225433f68bc9a$var$rotl32($575225433f68bc9a$var$sum32_4(A, $575225433f68bc9a$var$f(j, B, C, D), msg[$575225433f68bc9a$var$r[j] + start], $575225433f68bc9a$var$K(j)), $575225433f68bc9a$var$s[j]), E);
            A = E;
            E = D;
            D = $575225433f68bc9a$var$rotl32(C, 10);
            C = B;
            B = T;
            T = $575225433f68bc9a$var$sum32($575225433f68bc9a$var$rotl32($575225433f68bc9a$var$sum32_4(Ah, $575225433f68bc9a$var$f(79 - j, Bh, Ch, Dh), msg[$575225433f68bc9a$var$rh[j] + start], $575225433f68bc9a$var$Kh(j)), $575225433f68bc9a$var$sh[j]), Eh);
            Ah = Eh;
            Eh = Dh;
            Dh = $575225433f68bc9a$var$rotl32(Ch, 10);
            Ch = Bh;
            Bh = T;
        }
        T = $575225433f68bc9a$var$sum32_3(this.h[1], C, Dh);
        this.h[1] = $575225433f68bc9a$var$sum32_3(this.h[2], D, Eh);
        this.h[2] = $575225433f68bc9a$var$sum32_3(this.h[3], E, Ah);
        this.h[3] = $575225433f68bc9a$var$sum32_3(this.h[4], A, Bh);
        this.h[4] = $575225433f68bc9a$var$sum32_3(this.h[0], B, Ch);
        this.h[0] = T;
    };
    $575225433f68bc9a$var$RIPEMD160.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'little');
        else return $3OMi8.split32(this.h, 'little');
    };
    function $575225433f68bc9a$var$f(j, x, y, z) {
        if (j <= 15) return x ^ y ^ z;
        else if (j <= 31) return x & y | ~x & z;
        else if (j <= 47) return (x | ~y) ^ z;
        else if (j <= 63) return x & z | y & ~z;
        else return x ^ (y | ~z);
    }
    function $575225433f68bc9a$var$K(j) {
        if (j <= 15) return 0x00000000;
        else if (j <= 31) return 0x5a827999;
        else if (j <= 47) return 0x6ed9eba1;
        else if (j <= 63) return 0x8f1bbcdc;
        else return 0xa953fd4e;
    }
    function $575225433f68bc9a$var$Kh(j) {
        if (j <= 15) return 0x50a28be6;
        else if (j <= 31) return 0x5c4dd124;
        else if (j <= 47) return 0x6d703ef3;
        else if (j <= 63) return 0x7a6d76e9;
        else return 0x00000000;
    }
    var $575225433f68bc9a$var$r = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        7,
        4,
        13,
        1,
        10,
        6,
        15,
        3,
        12,
        0,
        9,
        5,
        2,
        14,
        11,
        8,
        3,
        10,
        14,
        4,
        9,
        15,
        8,
        1,
        2,
        7,
        0,
        6,
        13,
        11,
        5,
        12,
        1,
        9,
        11,
        10,
        0,
        8,
        12,
        4,
        13,
        3,
        7,
        15,
        14,
        5,
        6,
        2,
        4,
        0,
        5,
        9,
        7,
        12,
        2,
        10,
        14,
        1,
        3,
        8,
        11,
        6,
        15,
        13
    ];
    var $575225433f68bc9a$var$rh = [
        5,
        14,
        7,
        0,
        9,
        2,
        11,
        4,
        13,
        6,
        15,
        8,
        1,
        10,
        3,
        12,
        6,
        11,
        3,
        7,
        0,
        13,
        5,
        10,
        14,
        15,
        8,
        12,
        4,
        9,
        1,
        2,
        15,
        5,
        1,
        3,
        7,
        14,
        6,
        9,
        11,
        8,
        12,
        2,
        10,
        0,
        4,
        13,
        8,
        6,
        4,
        1,
        3,
        11,
        15,
        0,
        5,
        12,
        2,
        13,
        9,
        7,
        10,
        14,
        12,
        15,
        10,
        4,
        1,
        5,
        8,
        7,
        6,
        2,
        13,
        14,
        0,
        3,
        9,
        11
    ];
    var $575225433f68bc9a$var$s = [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8,
        7,
        6,
        8,
        13,
        11,
        9,
        7,
        15,
        7,
        12,
        15,
        9,
        11,
        7,
        13,
        12,
        11,
        13,
        6,
        7,
        14,
        9,
        13,
        15,
        14,
        8,
        13,
        6,
        5,
        12,
        7,
        5,
        11,
        12,
        14,
        15,
        14,
        15,
        9,
        8,
        9,
        14,
        5,
        6,
        8,
        6,
        5,
        12,
        9,
        15,
        5,
        11,
        6,
        8,
        13,
        12,
        5,
        12,
        13,
        14,
        11,
        8,
        5,
        6
    ];
    var $575225433f68bc9a$var$sh = [
        8,
        9,
        9,
        11,
        13,
        15,
        15,
        5,
        7,
        7,
        8,
        11,
        14,
        14,
        12,
        6,
        9,
        13,
        15,
        7,
        12,
        8,
        9,
        11,
        7,
        7,
        12,
        7,
        6,
        15,
        13,
        11,
        9,
        7,
        15,
        11,
        8,
        6,
        6,
        14,
        12,
        13,
        5,
        14,
        13,
        13,
        7,
        5,
        15,
        5,
        8,
        11,
        14,
        14,
        6,
        14,
        6,
        9,
        12,
        9,
        12,
        5,
        15,
        8,
        8,
        5,
        12,
        9,
        12,
        5,
        14,
        6,
        8,
        13,
        6,
        5,
        15,
        13,
        11,
        11
    ];
});
parcelRegister("aFtrN", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $gxaFy = parcelRequire("gxaFy");
    function $7c44935cedad0a05$var$Hmac(hash, key, enc) {
        if (!(this instanceof $7c44935cedad0a05$var$Hmac)) return new $7c44935cedad0a05$var$Hmac(hash, key, enc);
        this.Hash = hash;
        this.blockSize = hash.blockSize / 8;
        this.outSize = hash.outSize / 8;
        this.inner = null;
        this.outer = null;
        this._init($3OMi8.toArray(key, enc));
    }
    module.exports = $7c44935cedad0a05$var$Hmac;
    $7c44935cedad0a05$var$Hmac.prototype._init = function init(key) {
        if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
        $gxaFy(key.length <= this.blockSize);
        for(var i = key.length; i < this.blockSize; i++)key.push(0);
        for(i = 0; i < key.length; i++)key[i] ^= 0x36;
        this.inner = new this.Hash().update(key);
        for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
        this.outer = new this.Hash().update(key);
    };
    $7c44935cedad0a05$var$Hmac.prototype.update = function update(msg, enc) {
        this.inner.update(msg, enc);
        return this;
    };
    $7c44935cedad0a05$var$Hmac.prototype.digest = function digest(enc) {
        this.outer.update(this.inner.digest());
        return this.outer.digest(enc);
    };
});
parcelRegister("6pt7M", function(module, exports) {
    module.exports = {
        doubles: {
            step: 4,
            points: [
                [
                    'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                    'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
                ],
                [
                    '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                    '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
                ],
                [
                    '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                    'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
                ],
                [
                    '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                    '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
                ],
                [
                    '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                    '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
                ],
                [
                    '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                    '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
                ],
                [
                    'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                    '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
                ],
                [
                    '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                    'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
                ],
                [
                    'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                    '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
                ],
                [
                    'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                    'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
                ],
                [
                    'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                    '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
                ],
                [
                    '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                    '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
                ],
                [
                    '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                    '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
                ],
                [
                    '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                    '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
                ],
                [
                    '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                    '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
                ],
                [
                    '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                    '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
                ],
                [
                    '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                    '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
                ],
                [
                    '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                    '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
                ],
                [
                    '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                    'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
                ],
                [
                    'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                    '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
                ],
                [
                    'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                    '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
                ],
                [
                    '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                    '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
                ],
                [
                    '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                    '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
                ],
                [
                    'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                    '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
                ],
                [
                    '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                    'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
                ],
                [
                    'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                    '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
                ],
                [
                    'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                    'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
                ],
                [
                    'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                    '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
                ],
                [
                    'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                    'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
                ],
                [
                    'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                    '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
                ],
                [
                    '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                    'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
                ],
                [
                    '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                    '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
                ],
                [
                    'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                    '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
                ],
                [
                    '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                    'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
                ],
                [
                    'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                    '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
                ],
                [
                    'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                    '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
                ],
                [
                    'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                    'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
                ],
                [
                    '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                    '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
                ],
                [
                    '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                    '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
                ],
                [
                    '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                    'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
                ],
                [
                    '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                    '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
                ],
                [
                    'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                    '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
                ],
                [
                    '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                    '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
                ],
                [
                    '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                    'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
                ],
                [
                    '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                    '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
                ],
                [
                    'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                    '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
                ],
                [
                    '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                    'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
                ],
                [
                    'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                    'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
                ],
                [
                    'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                    '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
                ],
                [
                    '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                    'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
                ],
                [
                    '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                    'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
                ],
                [
                    'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                    '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
                ],
                [
                    'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                    '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
                ],
                [
                    'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                    '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
                ],
                [
                    '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                    'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
                ],
                [
                    '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                    '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
                ],
                [
                    'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                    'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
                ],
                [
                    '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                    'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
                ],
                [
                    '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                    '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
                ],
                [
                    '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                    '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
                ],
                [
                    'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                    'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
                ],
                [
                    '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                    '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
                ],
                [
                    '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                    '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
                ],
                [
                    'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                    '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
                ],
                [
                    'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                    'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
                ]
            ]
        },
        naf: {
            wnd: 7,
            points: [
                [
                    'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                    '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
                ],
                [
                    '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                    'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
                ],
                [
                    '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                    '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
                ],
                [
                    'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                    'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
                ],
                [
                    '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                    'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
                ],
                [
                    'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                    'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
                ],
                [
                    'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                    '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
                ],
                [
                    'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                    '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
                ],
                [
                    '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                    '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
                ],
                [
                    '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                    '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
                ],
                [
                    '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                    '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
                ],
                [
                    '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                    '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
                ],
                [
                    'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                    'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
                ],
                [
                    'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                    '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
                ],
                [
                    '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                    'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
                ],
                [
                    '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                    'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
                ],
                [
                    '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                    '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
                ],
                [
                    '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                    '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
                ],
                [
                    '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                    '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
                ],
                [
                    '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                    'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
                ],
                [
                    'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                    'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
                ],
                [
                    '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                    '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
                ],
                [
                    '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                    '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
                ],
                [
                    'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                    'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
                ],
                [
                    '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                    '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
                ],
                [
                    'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                    'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
                ],
                [
                    'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                    'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
                ],
                [
                    '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                    '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
                ],
                [
                    '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                    '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
                ],
                [
                    '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                    '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
                ],
                [
                    'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                    '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
                ],
                [
                    '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                    '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
                ],
                [
                    'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                    '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
                ],
                [
                    '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                    'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
                ],
                [
                    '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                    'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
                ],
                [
                    'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                    'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
                ],
                [
                    '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                    '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
                ],
                [
                    '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                    'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
                ],
                [
                    'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                    'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
                ],
                [
                    '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                    '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
                ],
                [
                    '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                    'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
                ],
                [
                    '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                    '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
                ],
                [
                    '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                    'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
                ],
                [
                    'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                    '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
                ],
                [
                    '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                    '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
                ],
                [
                    '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                    'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
                ],
                [
                    '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                    'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
                ],
                [
                    'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                    'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
                ],
                [
                    'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                    'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
                ],
                [
                    '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                    '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
                ],
                [
                    '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                    '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
                ],
                [
                    'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                    '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
                ],
                [
                    'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                    'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
                ],
                [
                    '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                    '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
                ],
                [
                    '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                    '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
                ],
                [
                    'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                    '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
                ],
                [
                    '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                    '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
                ],
                [
                    'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                    'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
                ],
                [
                    '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                    'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
                ],
                [
                    '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                    '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
                ],
                [
                    'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                    '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
                ],
                [
                    'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                    '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
                ],
                [
                    '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                    '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
                ],
                [
                    '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                    '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
                ],
                [
                    '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                    'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
                ],
                [
                    '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                    'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
                ],
                [
                    '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                    '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
                ],
                [
                    '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                    '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
                ],
                [
                    '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                    '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
                ],
                [
                    '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                    'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
                ],
                [
                    'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                    'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
                ],
                [
                    '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                    'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
                ],
                [
                    'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                    '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
                ],
                [
                    'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                    '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
                ],
                [
                    'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                    '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
                ],
                [
                    'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                    '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
                ],
                [
                    '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                    'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
                ],
                [
                    '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                    '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
                ],
                [
                    '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                    'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
                ],
                [
                    'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                    'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
                ],
                [
                    'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                    '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
                ],
                [
                    'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                    'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
                ],
                [
                    'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                    '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
                ],
                [
                    '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                    '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
                ],
                [
                    'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                    '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
                ],
                [
                    'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                    '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
                ],
                [
                    '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                    '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
                ],
                [
                    '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                    'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
                ],
                [
                    'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                    '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
                ],
                [
                    'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                    '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
                ],
                [
                    'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                    '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
                ],
                [
                    '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                    '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
                ],
                [
                    'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                    'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
                ],
                [
                    '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                    'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
                ],
                [
                    'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                    'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
                ],
                [
                    'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                    '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
                ],
                [
                    '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                    'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
                ],
                [
                    'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                    '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
                ],
                [
                    'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                    '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
                ],
                [
                    'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                    '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
                ],
                [
                    '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                    'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
                ],
                [
                    '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                    'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
                ],
                [
                    'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                    '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
                ],
                [
                    '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                    'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
                ],
                [
                    '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                    '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
                ],
                [
                    '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                    'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
                ],
                [
                    'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                    'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
                ],
                [
                    '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                    'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
                ],
                [
                    '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                    '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
                ],
                [
                    '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                    'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
                ],
                [
                    '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                    '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
                ],
                [
                    'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                    'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
                ],
                [
                    '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                    '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
                ],
                [
                    'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                    '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
                ],
                [
                    '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                    '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
                ],
                [
                    'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                    'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
                ],
                [
                    'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                    '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
                ],
                [
                    'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                    'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
                ],
                [
                    '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                    'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
                ],
                [
                    '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                    '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
                ],
                [
                    '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                    'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
                ],
                [
                    '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                    '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
                ],
                [
                    '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                    '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
                ],
                [
                    '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                    'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
                ],
                [
                    '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                    '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
                ],
                [
                    '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                    '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
                ],
                [
                    '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                    '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
                ]
            ]
        }
    };
});
parcelRegister("9Cxq1", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $kj2Mi = parcelRequire("kj2Mi");
    var $onO0l = parcelRequire("onO0l");
    var $gli5y = parcelRequire("gli5y");
    var $9D8YT = parcelRequire("9D8YT");
    var $701195e88ddcfeac$var$assert = $onO0l.assert;
    var $1h5tm = parcelRequire("1h5tm");
    var $hKBzv = parcelRequire("hKBzv");
    function $701195e88ddcfeac$var$EC(options) {
        if (!(this instanceof $701195e88ddcfeac$var$EC)) return new $701195e88ddcfeac$var$EC(options);
        if (typeof options === 'string') {
            $701195e88ddcfeac$var$assert(Object.prototype.hasOwnProperty.call($gli5y, options), 'Unknown curve ' + options);
            options = $gli5y[options];
        }
        if (options instanceof $gli5y.PresetCurve) options = {
            curve: options
        };
        this.curve = options.curve.curve;
        this.n = this.curve.n;
        this.nh = this.n.ushrn(1);
        this.g = this.curve.g;
        this.g = options.curve.g;
        this.g.precompute(options.curve.n.bitLength() + 1);
        this.hash = options.hash || options.curve.hash;
    }
    module.exports = $701195e88ddcfeac$var$EC;
    $701195e88ddcfeac$var$EC.prototype.keyPair = function keyPair(options) {
        return new $1h5tm(this, options);
    };
    $701195e88ddcfeac$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
        return $1h5tm.fromPrivate(this, priv, enc);
    };
    $701195e88ddcfeac$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
        return $1h5tm.fromPublic(this, pub, enc);
    };
    $701195e88ddcfeac$var$EC.prototype.genKeyPair = function genKeyPair(options) {
        if (!options) options = {};
        var drbg = new $kj2Mi({
            hash: this.hash,
            pers: options.pers,
            persEnc: options.persEnc || 'utf8',
            entropy: options.entropy || $9D8YT(this.hash.hmacStrength),
            entropyEnc: options.entropy && options.entropyEnc || 'utf8',
            nonce: this.n.toArray()
        });
        var bytes = this.n.byteLength();
        var ns2 = this.n.sub(new $9pbIC(2));
        for(;;){
            var priv = new $9pbIC(drbg.generate(bytes));
            if (priv.cmp(ns2) > 0) continue;
            priv.iaddn(1);
            return this.keyFromPrivate(priv);
        }
    };
    $701195e88ddcfeac$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
        var byteLength;
        if ($9pbIC.isBN(msg) || typeof msg === 'number') {
            msg = new $9pbIC(msg, 16);
            byteLength = msg.byteLength();
        } else if (typeof msg === 'object') {
            byteLength = msg.length;
            msg = new $9pbIC(msg, 16);
        } else {
            var str = msg.toString();
            byteLength = str.length + 1 >>> 1;
            msg = new $9pbIC(str, 16);
        }
        if (typeof bitLength !== 'number') bitLength = byteLength * 8;
        var delta = bitLength - this.n.bitLength();
        if (delta > 0) msg = msg.ushrn(delta);
        if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
        else return msg;
    };
    $701195e88ddcfeac$var$EC.prototype.sign = function sign(msg, key, enc, options) {
        if (typeof enc === 'object') {
            options = enc;
            enc = null;
        }
        if (!options) options = {};
        if (typeof msg !== 'string' && typeof msg !== 'number' && !$9pbIC.isBN(msg)) {
            $701195e88ddcfeac$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
            $701195e88ddcfeac$var$assert(msg.length >>> 0 === msg.length);
            for(var i = 0; i < msg.length; i++)$701195e88ddcfeac$var$assert((msg[i] & 255) === msg[i]);
        }
        key = this.keyFromPrivate(key, enc);
        msg = this._truncateToN(msg, false, options.msgBitLength);
        $701195e88ddcfeac$var$assert(!msg.isNeg(), 'Can not sign a negative message');
        var bytes = this.n.byteLength();
        var bkey = key.getPrivate().toArray('be', bytes);
        var nonce = msg.toArray('be', bytes);
        $701195e88ddcfeac$var$assert(new $9pbIC(nonce).eq(msg), 'Can not sign message');
        var drbg = new $kj2Mi({
            hash: this.hash,
            entropy: bkey,
            nonce: nonce,
            pers: options.pers,
            persEnc: options.persEnc || 'utf8'
        });
        var ns1 = this.n.sub(new $9pbIC(1));
        for(var iter = 0;; iter++){
            var k = options.k ? options.k(iter) : new $9pbIC(drbg.generate(this.n.byteLength()));
            k = this._truncateToN(k, true);
            if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
            var kp = this.g.mul(k);
            if (kp.isInfinity()) continue;
            var kpX = kp.getX();
            var r = kpX.umod(this.n);
            if (r.cmpn(0) === 0) continue;
            var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
            s = s.umod(this.n);
            if (s.cmpn(0) === 0) continue;
            var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
            if (options.canonical && s.cmp(this.nh) > 0) {
                s = this.n.sub(s);
                recoveryParam ^= 1;
            }
            return new $hKBzv({
                r: r,
                s: s,
                recoveryParam: recoveryParam
            });
        }
    };
    $701195e88ddcfeac$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
        if (!options) options = {};
        msg = this._truncateToN(msg, false, options.msgBitLength);
        key = this.keyFromPublic(key, enc);
        signature = new $hKBzv(signature, 'hex');
        var r = signature.r;
        var s = signature.s;
        if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
        if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
        var sinv = s.invm(this.n);
        var u1 = sinv.mul(msg).umod(this.n);
        var u2 = sinv.mul(r).umod(this.n);
        var p;
        if (!this.curve._maxwellTrick) {
            p = this.g.mulAdd(u1, key.getPublic(), u2);
            if (p.isInfinity()) return false;
            return p.getX().umod(this.n).cmp(r) === 0;
        }
        p = this.g.jmulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.eqXToP(r);
    };
    $701195e88ddcfeac$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
        $701195e88ddcfeac$var$assert((3 & j) === j, 'The recovery param is more than two bits');
        signature = new $hKBzv(signature, enc);
        var n = this.n;
        var e = new $9pbIC(msg);
        var r = signature.r;
        var s = signature.s;
        var isYOdd = j & 1;
        var isSecondKey = j >> 1;
        if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
        if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
        else r = this.curve.pointFromX(r, isYOdd);
        var rInv = signature.r.invm(n);
        var s1 = n.sub(e).mul(rInv).umod(n);
        var s2 = s.mul(rInv).umod(n);
        return this.g.mulAdd(s1, r, s2);
    };
    $701195e88ddcfeac$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
        signature = new $hKBzv(signature, enc);
        if (signature.recoveryParam !== null) return signature.recoveryParam;
        for(var i = 0; i < 4; i++){
            var Qprime;
            try {
                Qprime = this.recoverPubKey(e, signature, i);
            } catch (e) {
                continue;
            }
            if (Qprime.eq(Q)) return i;
        }
        throw new Error('Unable to find valid recovery factor');
    };
});
parcelRegister("kj2Mi", function(module, exports) {
    'use strict';
    var $hx0iN = parcelRequire("hx0iN");
    var $2WqN6 = parcelRequire("2WqN6");
    var $gxaFy = parcelRequire("gxaFy");
    function $ec87bca0fe3c0ec7$var$HmacDRBG(options) {
        if (!(this instanceof $ec87bca0fe3c0ec7$var$HmacDRBG)) return new $ec87bca0fe3c0ec7$var$HmacDRBG(options);
        this.hash = options.hash;
        this.predResist = !!options.predResist;
        this.outLen = this.hash.outSize;
        this.minEntropy = options.minEntropy || this.hash.hmacStrength;
        this._reseed = null;
        this.reseedInterval = null;
        this.K = null;
        this.V = null;
        var entropy = $2WqN6.toArray(options.entropy, options.entropyEnc || 'hex');
        var nonce = $2WqN6.toArray(options.nonce, options.nonceEnc || 'hex');
        var pers = $2WqN6.toArray(options.pers, options.persEnc || 'hex');
        $gxaFy(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._init(entropy, nonce, pers);
    }
    module.exports = $ec87bca0fe3c0ec7$var$HmacDRBG;
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
        var seed = entropy.concat(nonce).concat(pers);
        this.K = new Array(this.outLen / 8);
        this.V = new Array(this.outLen / 8);
        for(var i = 0; i < this.V.length; i++){
            this.K[i] = 0x00;
            this.V[i] = 0x01;
        }
        this._update(seed);
        this._reseed = 1;
        this.reseedInterval = 0x1000000000000;
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype._hmac = function hmac() {
        return new $hx0iN.hmac(this.hash, this.K);
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype._update = function update(seed) {
        var kmac = this._hmac().update(this.V).update([
            0x00
        ]);
        if (seed) kmac = kmac.update(seed);
        this.K = kmac.digest();
        this.V = this._hmac().update(this.V).digest();
        if (!seed) return;
        this.K = this._hmac().update(this.V).update([
            0x01
        ]).update(seed).digest();
        this.V = this._hmac().update(this.V).digest();
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
        if (typeof entropyEnc !== 'string') {
            addEnc = add;
            add = entropyEnc;
            entropyEnc = null;
        }
        entropy = $2WqN6.toArray(entropy, entropyEnc);
        add = $2WqN6.toArray(add, addEnc);
        $gxaFy(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._update(entropy.concat(add || []));
        this._reseed = 1;
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
        if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
        if (typeof enc !== 'string') {
            addEnc = add;
            add = enc;
            enc = null;
        }
        if (add) {
            add = $2WqN6.toArray(add, addEnc || 'hex');
            this._update(add);
        }
        var temp = [];
        while(temp.length < len){
            this.V = this._hmac().update(this.V).digest();
            temp = temp.concat(this.V);
        }
        var res = temp.slice(0, len);
        this._update(add);
        this._reseed++;
        return $2WqN6.encode(res, enc);
    };
});
parcelRegister("1h5tm", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $0edb9fb4895d148b$var$assert = $onO0l.assert;
    function $0edb9fb4895d148b$var$KeyPair(ec, options) {
        this.ec = ec;
        this.priv = null;
        this.pub = null;
        if (options.priv) this._importPrivate(options.priv, options.privEnc);
        if (options.pub) this._importPublic(options.pub, options.pubEnc);
    }
    module.exports = $0edb9fb4895d148b$var$KeyPair;
    $0edb9fb4895d148b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
        if (pub instanceof $0edb9fb4895d148b$var$KeyPair) return pub;
        return new $0edb9fb4895d148b$var$KeyPair(ec, {
            pub: pub,
            pubEnc: enc
        });
    };
    $0edb9fb4895d148b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
        if (priv instanceof $0edb9fb4895d148b$var$KeyPair) return priv;
        return new $0edb9fb4895d148b$var$KeyPair(ec, {
            priv: priv,
            privEnc: enc
        });
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.validate = function validate() {
        var pub = this.getPublic();
        if (pub.isInfinity()) return {
            result: false,
            reason: 'Invalid public key'
        };
        if (!pub.validate()) return {
            result: false,
            reason: 'Public key is not a point'
        };
        if (!pub.mul(this.ec.curve.n).isInfinity()) return {
            result: false,
            reason: 'Public key * N != O'
        };
        return {
            result: true,
            reason: null
        };
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
        if (typeof compact === 'string') {
            enc = compact;
            compact = null;
        }
        if (!this.pub) this.pub = this.ec.g.mul(this.priv);
        if (!enc) return this.pub;
        return this.pub.encode(enc, compact);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
        if (enc === 'hex') return this.priv.toString(16, 2);
        else return this.priv;
    };
    $0edb9fb4895d148b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
        this.priv = new $9pbIC(key, enc || 16);
        this.priv = this.priv.umod(this.ec.curve.n);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
        if (key.x || key.y) {
            if (this.ec.curve.type === 'mont') $0edb9fb4895d148b$var$assert(key.x, 'Need x coordinate');
            else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $0edb9fb4895d148b$var$assert(key.x && key.y, 'Need both x and y coordinate');
            this.pub = this.ec.curve.point(key.x, key.y);
            return;
        }
        this.pub = this.ec.curve.decodePoint(key, enc);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.derive = function derive(pub) {
        if (!pub.validate()) $0edb9fb4895d148b$var$assert(pub.validate(), 'public point not validated');
        return pub.mul(this.priv).getX();
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
        return this.ec.sign(msg, this, enc, options);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
        return this.ec.verify(msg, signature, this, undefined, options);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.inspect = function inspect() {
        return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
    };
});
parcelRegister("hKBzv", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $cec3e07d0e69d400$var$assert = $onO0l.assert;
    function $cec3e07d0e69d400$var$Signature(options, enc) {
        if (options instanceof $cec3e07d0e69d400$var$Signature) return options;
        if (this._importDER(options, enc)) return;
        $cec3e07d0e69d400$var$assert(options.r && options.s, 'Signature without r or s');
        this.r = new $9pbIC(options.r, 16);
        this.s = new $9pbIC(options.s, 16);
        if (options.recoveryParam === undefined) this.recoveryParam = null;
        else this.recoveryParam = options.recoveryParam;
    }
    module.exports = $cec3e07d0e69d400$var$Signature;
    function $cec3e07d0e69d400$var$Position() {
        this.place = 0;
    }
    function $cec3e07d0e69d400$var$getLength(buf, p) {
        var initial = buf[p.place++];
        if (!(initial & 0x80)) return initial;
        var octetLen = initial & 0xf;
        if (octetLen === 0 || octetLen > 4) return false;
        if (buf[p.place] === 0x00) return false;
        var val = 0;
        for(var i = 0, off = p.place; i < octetLen; i++, off++){
            val <<= 8;
            val |= buf[off];
            val >>>= 0;
        }
        if (val <= 0x7f) return false;
        p.place = off;
        return val;
    }
    function $cec3e07d0e69d400$var$rmPadding(buf) {
        var i = 0;
        var len = buf.length - 1;
        while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
        if (i === 0) return buf;
        return buf.slice(i);
    }
    $cec3e07d0e69d400$var$Signature.prototype._importDER = function _importDER(data, enc) {
        data = $onO0l.toArray(data, enc);
        var p = new $cec3e07d0e69d400$var$Position();
        if (data[p.place++] !== 0x30) return false;
        var len = $cec3e07d0e69d400$var$getLength(data, p);
        if (len === false) return false;
        if (len + p.place !== data.length) return false;
        if (data[p.place++] !== 0x02) return false;
        var rlen = $cec3e07d0e69d400$var$getLength(data, p);
        if (rlen === false) return false;
        if ((data[p.place] & 128) !== 0) return false;
        var r = data.slice(p.place, rlen + p.place);
        p.place += rlen;
        if (data[p.place++] !== 0x02) return false;
        var slen = $cec3e07d0e69d400$var$getLength(data, p);
        if (slen === false) return false;
        if (data.length !== slen + p.place) return false;
        if ((data[p.place] & 128) !== 0) return false;
        var s = data.slice(p.place, slen + p.place);
        if (r[0] === 0) {
            if (r[1] & 0x80) r = r.slice(1);
            else return false;
        }
        if (s[0] === 0) {
            if (s[1] & 0x80) s = s.slice(1);
            else return false;
        }
        this.r = new $9pbIC(r);
        this.s = new $9pbIC(s);
        this.recoveryParam = null;
        return true;
    };
    function $cec3e07d0e69d400$var$constructLength(arr, len) {
        if (len < 0x80) {
            arr.push(len);
            return;
        }
        var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
        arr.push(octets | 0x80);
        while(--octets)arr.push(len >>> (octets << 3) & 0xff);
        arr.push(len);
    }
    $cec3e07d0e69d400$var$Signature.prototype.toDER = function toDER(enc) {
        var r = this.r.toArray();
        var s = this.s.toArray();
        if (r[0] & 0x80) r = [
            0
        ].concat(r);
        if (s[0] & 0x80) s = [
            0
        ].concat(s);
        r = $cec3e07d0e69d400$var$rmPadding(r);
        s = $cec3e07d0e69d400$var$rmPadding(s);
        while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
        var arr = [
            0x02
        ];
        $cec3e07d0e69d400$var$constructLength(arr, r.length);
        arr = arr.concat(r);
        arr.push(0x02);
        $cec3e07d0e69d400$var$constructLength(arr, s.length);
        var backHalf = arr.concat(s);
        var res = [
            0x30
        ];
        $cec3e07d0e69d400$var$constructLength(res, backHalf.length);
        res = res.concat(backHalf);
        return $onO0l.encode(res, enc);
    };
});
parcelRegister("5xIaV", function(module, exports) {
    'use strict';
    var $hx0iN = parcelRequire("hx0iN");
    var $gli5y = parcelRequire("gli5y");
    var $onO0l = parcelRequire("onO0l");
    var $40924d19a5087ed3$var$assert = $onO0l.assert;
    var $40924d19a5087ed3$var$parseBytes = $onO0l.parseBytes;
    var $jMnN9 = parcelRequire("jMnN9");
    var $4AHiD = parcelRequire("4AHiD");
    function $40924d19a5087ed3$var$EDDSA(curve) {
        $40924d19a5087ed3$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
        if (!(this instanceof $40924d19a5087ed3$var$EDDSA)) return new $40924d19a5087ed3$var$EDDSA(curve);
        curve = $gli5y[curve].curve;
        this.curve = curve;
        this.g = curve.g;
        this.g.precompute(curve.n.bitLength() + 1);
        this.pointClass = curve.point().constructor;
        this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
        this.hash = $hx0iN.sha512;
    }
    module.exports = $40924d19a5087ed3$var$EDDSA;
    $40924d19a5087ed3$var$EDDSA.prototype.sign = function sign(message, secret) {
        message = $40924d19a5087ed3$var$parseBytes(message);
        var key = this.keyFromSecret(secret);
        var r = this.hashInt(key.messagePrefix(), message);
        var R = this.g.mul(r);
        var Rencoded = this.encodePoint(R);
        var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
        var S = r.add(s_).umod(this.curve.n);
        return this.makeSignature({
            R: R,
            S: S,
            Rencoded: Rencoded
        });
    };
    $40924d19a5087ed3$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
        message = $40924d19a5087ed3$var$parseBytes(message);
        sig = this.makeSignature(sig);
        if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
        var key = this.keyFromPublic(pub);
        var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
        var SG = this.g.mul(sig.S());
        var RplusAh = sig.R().add(key.pub().mul(h));
        return RplusAh.eq(SG);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.hashInt = function hashInt() {
        var hash = this.hash();
        for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
        return $onO0l.intFromLE(hash.digest()).umod(this.curve.n);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
        return $jMnN9.fromPublic(this, pub);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
        return $jMnN9.fromSecret(this, secret);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
        if (sig instanceof $4AHiD) return sig;
        return new $4AHiD(this, sig);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
        var enc = point.getY().toArray('le', this.encodingLength);
        enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
        return enc;
    };
    $40924d19a5087ed3$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
        bytes = $onO0l.parseBytes(bytes);
        var lastIx = bytes.length - 1;
        var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
        var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
        var y = $onO0l.intFromLE(normed);
        return this.curve.pointFromY(y, xIsOdd);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
        return num.toArray('le', this.encodingLength);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
        return $onO0l.intFromLE(bytes);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.isPoint = function isPoint(val) {
        return val instanceof this.pointClass;
    };
});
parcelRegister("jMnN9", function(module, exports) {
    'use strict';
    var $onO0l = parcelRequire("onO0l");
    var $e664f48c9a4229a6$var$assert = $onO0l.assert;
    var $e664f48c9a4229a6$var$parseBytes = $onO0l.parseBytes;
    var $e664f48c9a4229a6$var$cachedProperty = $onO0l.cachedProperty;
    function $e664f48c9a4229a6$var$KeyPair(eddsa, params) {
        this.eddsa = eddsa;
        this._secret = $e664f48c9a4229a6$var$parseBytes(params.secret);
        if (eddsa.isPoint(params.pub)) this._pub = params.pub;
        else this._pubBytes = $e664f48c9a4229a6$var$parseBytes(params.pub);
    }
    $e664f48c9a4229a6$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
        if (pub instanceof $e664f48c9a4229a6$var$KeyPair) return pub;
        return new $e664f48c9a4229a6$var$KeyPair(eddsa, {
            pub: pub
        });
    };
    $e664f48c9a4229a6$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
        if (secret instanceof $e664f48c9a4229a6$var$KeyPair) return secret;
        return new $e664f48c9a4229a6$var$KeyPair(eddsa, {
            secret: secret
        });
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.secret = function secret() {
        return this._secret;
    };
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'pubBytes', function pubBytes() {
        return this.eddsa.encodePoint(this.pub());
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'pub', function pub() {
        if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
        return this.eddsa.g.mul(this.priv());
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'privBytes', function privBytes() {
        var eddsa = this.eddsa;
        var hash = this.hash();
        var lastIx = eddsa.encodingLength - 1;
        var a = hash.slice(0, eddsa.encodingLength);
        a[0] &= 248;
        a[lastIx] &= 127;
        a[lastIx] |= 64;
        return a;
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'priv', function priv() {
        return this.eddsa.decodeInt(this.privBytes());
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'hash', function hash() {
        return this.eddsa.hash().update(this.secret()).digest();
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'messagePrefix', function messagePrefix() {
        return this.hash().slice(this.eddsa.encodingLength);
    });
    $e664f48c9a4229a6$var$KeyPair.prototype.sign = function sign(message) {
        $e664f48c9a4229a6$var$assert(this._secret, 'KeyPair can only verify');
        return this.eddsa.sign(message, this);
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.verify = function verify(message, sig) {
        return this.eddsa.verify(message, sig, this);
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.getSecret = function getSecret(enc) {
        $e664f48c9a4229a6$var$assert(this._secret, 'KeyPair is public only');
        return $onO0l.encode(this.secret(), enc);
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.getPublic = function getPublic(enc) {
        return $onO0l.encode(this.pubBytes(), enc);
    };
    module.exports = $e664f48c9a4229a6$var$KeyPair;
});
parcelRegister("4AHiD", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $357c1ca1a96c331d$var$assert = $onO0l.assert;
    var $357c1ca1a96c331d$var$cachedProperty = $onO0l.cachedProperty;
    var $357c1ca1a96c331d$var$parseBytes = $onO0l.parseBytes;
    function $357c1ca1a96c331d$var$Signature(eddsa, sig) {
        this.eddsa = eddsa;
        if (typeof sig !== 'object') sig = $357c1ca1a96c331d$var$parseBytes(sig);
        if (Array.isArray(sig)) {
            $357c1ca1a96c331d$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
            sig = {
                R: sig.slice(0, eddsa.encodingLength),
                S: sig.slice(eddsa.encodingLength)
            };
        }
        $357c1ca1a96c331d$var$assert(sig.R && sig.S, 'Signature without R or S');
        if (eddsa.isPoint(sig.R)) this._R = sig.R;
        if (sig.S instanceof $9pbIC) this._S = sig.S;
        this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
        this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
    }
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'S', function S() {
        return this.eddsa.decodeInt(this.Sencoded());
    });
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'R', function R() {
        return this.eddsa.decodePoint(this.Rencoded());
    });
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'Rencoded', function Rencoded() {
        return this.eddsa.encodePoint(this.R());
    });
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'Sencoded', function Sencoded() {
        return this.eddsa.encodeInt(this.S());
    });
    $357c1ca1a96c331d$var$Signature.prototype.toBytes = function toBytes() {
        return this.Rencoded().concat(this.Sencoded());
    };
    $357c1ca1a96c331d$var$Signature.prototype.toHex = function toHex() {
        return $onO0l.encode(this.toBytes(), 'hex').toUpperCase();
    };
    module.exports = $357c1ca1a96c331d$var$Signature;
});
parcelRegister("bxS53", function(module, exports) {
    (function(module1, exports) {
        'use strict';
        function assert(val, msg) {
            if (!val) throw new Error(msg || 'Assertion failed');
        }
        function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
        function BN(number, base, endian) {
            if (BN.isBN(number)) return number;
            this.negative = 0;
            this.words = null;
            this.length = 0;
            this.red = null;
            if (number !== null) {
                if (base === 'le' || base === 'be') {
                    endian = base;
                    base = 10;
                }
                this._init(number || 0, base || 10, endian || 'be');
            }
        }
        if (typeof module1 === 'object') module1.exports = BN;
        else exports.BN = BN;
        BN.BN = BN;
        BN.wordSize = 26;
        var Buffer;
        try {
            if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
            else Buffer = (parcelRequire("3gWwf")).Buffer;
        } catch (e) {}
        BN.isBN = function isBN(num) {
            if (num instanceof BN) return true;
            return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };
        BN.max = function max(left, right) {
            if (left.cmp(right) > 0) return left;
            return right;
        };
        BN.min = function min(left, right) {
            if (left.cmp(right) < 0) return left;
            return right;
        };
        BN.prototype._init = function init(number, base, endian) {
            if (typeof number === 'number') return this._initNumber(number, base, endian);
            if (typeof number === 'object') return this._initArray(number, base, endian);
            if (base === 'hex') base = 16;
            assert(base === (base | 0) && base >= 2 && base <= 36);
            number = number.toString().replace(/\s+/g, '');
            var start = 0;
            if (number[0] === '-') {
                start++;
                this.negative = 1;
            }
            if (start < number.length) {
                if (base === 16) this._parseHex(number, start, endian);
                else {
                    this._parseBase(number, base, start);
                    if (endian === 'le') this._initArray(this.toArray(), base, endian);
                }
            }
        };
        BN.prototype._initNumber = function _initNumber(number, base, endian) {
            if (number < 0) {
                this.negative = 1;
                number = -number;
            }
            if (number < 0x4000000) {
                this.words = [
                    number & 0x3ffffff
                ];
                this.length = 1;
            } else if (number < 0x10000000000000) {
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff
                ];
                this.length = 2;
            } else {
                assert(number < 0x20000000000000);
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff,
                    1
                ];
                this.length = 3;
            }
            if (endian !== 'le') return;
            this._initArray(this.toArray(), base, endian);
        };
        BN.prototype._initArray = function _initArray(number, base, endian) {
            assert(typeof number.length === 'number');
            if (number.length <= 0) {
                this.words = [
                    0
                ];
                this.length = 1;
                return this;
            }
            this.length = Math.ceil(number.length / 3);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var j, w;
            var off = 0;
            if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            return this._strip();
        };
        function parseHex4Bits(string, index) {
            var c = string.charCodeAt(index);
            if (c >= 48 && c <= 57) return c - 48;
            else if (c >= 65 && c <= 70) return c - 55;
            else if (c >= 97 && c <= 102) return c - 87;
            else assert(false, 'Invalid character in ' + string);
        }
        function parseHexByte(string, lowerBound, index) {
            var r = parseHex4Bits(string, index);
            if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
            return r;
        }
        BN.prototype._parseHex = function _parseHex(number, start, endian) {
            this.length = Math.ceil((number.length - start) / 6);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var off = 0;
            var j = 0;
            var w;
            if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
            else {
                var parseLength = number.length - start;
                for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                    w = parseHexByte(number, start, i) << off;
                    this.words[j] |= w & 0x3ffffff;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
            }
            this._strip();
        };
        function parseBase(str, start, end, mul) {
            var r = 0;
            var b = 0;
            var len = Math.min(str.length, end);
            for(var i = start; i < len; i++){
                var c = str.charCodeAt(i) - 48;
                r *= mul;
                if (c >= 49) b = c - 49 + 0xa;
                else if (c >= 17) b = c - 17 + 0xa;
                else b = c;
                assert(c >= 0 && b < mul, 'Invalid character');
                r += b;
            }
            return r;
        }
        BN.prototype._parseBase = function _parseBase(number, base, start) {
            this.words = [
                0
            ];
            this.length = 1;
            for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
            limbLen--;
            limbPow = limbPow / base | 0;
            var total = number.length - start;
            var mod = total % limbLen;
            var end = Math.min(total, total - mod) + start;
            var word = 0;
            for(var i = start; i < end; i += limbLen){
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for(i = 0; i < mod; i++)pow *= base;
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            this._strip();
        };
        BN.prototype.copy = function copy(dest) {
            dest.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
            dest.length = this.length;
            dest.negative = this.negative;
            dest.red = this.red;
        };
        function move(dest, src) {
            dest.words = src.words;
            dest.length = src.length;
            dest.negative = src.negative;
            dest.red = src.red;
        }
        BN.prototype._move = function _move(dest) {
            move(dest, this);
        };
        BN.prototype.clone = function clone() {
            var r = new BN(null);
            this.copy(r);
            return r;
        };
        BN.prototype._expand = function _expand(size) {
            while(this.length < size)this.words[this.length++] = 0;
            return this;
        };
        BN.prototype._strip = function strip() {
            while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
            return this._normSign();
        };
        BN.prototype._normSign = function _normSign() {
            if (this.length === 1 && this.words[0] === 0) this.negative = 0;
            return this;
        };
        if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
            BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
        } catch (e) {
            BN.prototype.inspect = inspect;
        }
        else BN.prototype.inspect = inspect;
        function inspect() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        }
        var zeros = [
            '',
            '0',
            '00',
            '000',
            '0000',
            '00000',
            '000000',
            '0000000',
            '00000000',
            '000000000',
            '0000000000',
            '00000000000',
            '000000000000',
            '0000000000000',
            '00000000000000',
            '000000000000000',
            '0000000000000000',
            '00000000000000000',
            '000000000000000000',
            '0000000000000000000',
            '00000000000000000000',
            '000000000000000000000',
            '0000000000000000000000',
            '00000000000000000000000',
            '000000000000000000000000',
            '0000000000000000000000000'
        ];
        var groupSizes = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ];
        var groupBases = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            10000000,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64000000,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            24300000,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        BN.prototype.toString = function toString(base, padding) {
            base = base || 10;
            padding = padding | 0 || 1;
            var out;
            if (base === 16 || base === 'hex') {
                out = '';
                var off = 0;
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = this.words[i];
                    var word = ((w << off | carry) & 0xffffff).toString(16);
                    carry = w >>> 24 - off & 0xffffff;
                    off += 2;
                    if (off >= 26) {
                        off -= 26;
                        i--;
                    }
                    if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                    else out = word + out;
                }
                if (carry !== 0) out = carry.toString(16) + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            if (base === (base | 0) && base >= 2 && base <= 36) {
                var groupSize = groupSizes[base];
                var groupBase = groupBases[base];
                out = '';
                var c = this.clone();
                c.negative = 0;
                while(!c.isZero()){
                    var r = c.modrn(groupBase).toString(base);
                    c = c.idivn(groupBase);
                    if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                    else out = r + out;
                }
                if (this.isZero()) out = '0' + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            assert(false, 'Base should be between 2 and 36');
        };
        BN.prototype.toNumber = function toNumber() {
            var ret = this.words[0];
            if (this.length === 2) ret += this.words[1] * 0x4000000;
            else if (this.length === 3 && this.words[2] === 0x01) ret += 0x10000000000000 + this.words[1] * 0x4000000;
            else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
            return this.negative !== 0 ? -ret : ret;
        };
        BN.prototype.toJSON = function toJSON() {
            return this.toString(16, 2);
        };
        if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
            return this.toArrayLike(Buffer, endian, length);
        };
        BN.prototype.toArray = function toArray(endian, length) {
            return this.toArrayLike(Array, endian, length);
        };
        var allocate = function allocate(ArrayType, size) {
            if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
            return new ArrayType(size);
        };
        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
            this._strip();
            var byteLength = this.byteLength();
            var reqLength = length || Math.max(1, byteLength);
            assert(byteLength <= reqLength, 'byte array longer than desired length');
            assert(reqLength > 0, 'Requested array length <= 0');
            var res = allocate(ArrayType, reqLength);
            var postfix = endian === 'le' ? 'LE' : 'BE';
            this['_toArrayLike' + postfix](res, byteLength);
            return res;
        };
        BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
            var position = 0;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position++] = word & 0xff;
                if (position < res.length) res[position++] = word >> 8 & 0xff;
                if (position < res.length) res[position++] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position < res.length) res[position++] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position < res.length) {
                res[position++] = carry;
                while(position < res.length)res[position++] = 0;
            }
        };
        BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
            var position = res.length - 1;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position--] = word & 0xff;
                if (position >= 0) res[position--] = word >> 8 & 0xff;
                if (position >= 0) res[position--] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position >= 0) res[position--] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position >= 0) {
                res[position--] = carry;
                while(position >= 0)res[position--] = 0;
            }
        };
        if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
        };
        else BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
                r += 13;
                t >>>= 13;
            }
            if (t >= 0x40) {
                r += 7;
                t >>>= 7;
            }
            if (t >= 0x8) {
                r += 4;
                t >>>= 4;
            }
            if (t >= 0x02) {
                r += 2;
                t >>>= 2;
            }
            return r + t;
        };
        BN.prototype._zeroBits = function _zeroBits(w) {
            if (w === 0) return 26;
            var t = w;
            var r = 0;
            if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
            }
            if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
            }
            if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
            }
            if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
            }
            if ((t & 0x1) === 0) r++;
            return r;
        };
        BN.prototype.bitLength = function bitLength() {
            var w = this.words[this.length - 1];
            var hi = this._countBits(w);
            return (this.length - 1) * 26 + hi;
        };
        function toBitArray(num) {
            var w = new Array(num.bitLength());
            for(var bit = 0; bit < w.length; bit++){
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                w[bit] = num.words[off] >>> wbit & 0x01;
            }
            return w;
        }
        BN.prototype.zeroBits = function zeroBits() {
            if (this.isZero()) return 0;
            var r = 0;
            for(var i = 0; i < this.length; i++){
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
            }
            return r;
        };
        BN.prototype.byteLength = function byteLength() {
            return Math.ceil(this.bitLength() / 8);
        };
        BN.prototype.toTwos = function toTwos(width) {
            if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
            return this.clone();
        };
        BN.prototype.fromTwos = function fromTwos(width) {
            if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
            return this.clone();
        };
        BN.prototype.isNeg = function isNeg() {
            return this.negative !== 0;
        };
        BN.prototype.neg = function neg() {
            return this.clone().ineg();
        };
        BN.prototype.ineg = function ineg() {
            if (!this.isZero()) this.negative ^= 1;
            return this;
        };
        BN.prototype.iuor = function iuor(num) {
            while(this.length < num.length)this.words[this.length++] = 0;
            for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
            return this._strip();
        };
        BN.prototype.ior = function ior(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuor(num);
        };
        BN.prototype.or = function or(num) {
            if (this.length > num.length) return this.clone().ior(num);
            return num.clone().ior(this);
        };
        BN.prototype.uor = function uor(num) {
            if (this.length > num.length) return this.clone().iuor(num);
            return num.clone().iuor(this);
        };
        BN.prototype.iuand = function iuand(num) {
            var b;
            if (this.length > num.length) b = num;
            else b = this;
            for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
            this.length = b.length;
            return this._strip();
        };
        BN.prototype.iand = function iand(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuand(num);
        };
        BN.prototype.and = function and(num) {
            if (this.length > num.length) return this.clone().iand(num);
            return num.clone().iand(this);
        };
        BN.prototype.uand = function uand(num) {
            if (this.length > num.length) return this.clone().iuand(num);
            return num.clone().iuand(this);
        };
        BN.prototype.iuxor = function iuxor(num) {
            var a;
            var b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
            if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = a.length;
            return this._strip();
        };
        BN.prototype.ixor = function ixor(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuxor(num);
        };
        BN.prototype.xor = function xor(num) {
            if (this.length > num.length) return this.clone().ixor(num);
            return num.clone().ixor(this);
        };
        BN.prototype.uxor = function uxor(num) {
            if (this.length > num.length) return this.clone().iuxor(num);
            return num.clone().iuxor(this);
        };
        BN.prototype.inotn = function inotn(width) {
            assert(typeof width === 'number' && width >= 0);
            var bytesNeeded = Math.ceil(width / 26) | 0;
            var bitsLeft = width % 26;
            this._expand(bytesNeeded);
            if (bitsLeft > 0) bytesNeeded--;
            for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
            if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            return this._strip();
        };
        BN.prototype.notn = function notn(width) {
            return this.clone().inotn(width);
        };
        BN.prototype.setn = function setn(bit, val) {
            assert(typeof bit === 'number' && bit >= 0);
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            this._expand(off + 1);
            if (val) this.words[off] = this.words[off] | 1 << wbit;
            else this.words[off] = this.words[off] & ~(1 << wbit);
            return this._strip();
        };
        BN.prototype.iadd = function iadd(num) {
            var r;
            if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign();
            } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
            }
            var a, b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            this.length = a.length;
            if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++;
            } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            return this;
        };
        BN.prototype.add = function add(num) {
            var res;
            if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
            } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
            }
            if (this.length > num.length) return this.clone().iadd(num);
            return num.clone().iadd(this);
        };
        BN.prototype.isub = function isub(num) {
            if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign();
            } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
            }
            var cmp = this.cmp(num);
            if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
            }
            var a, b;
            if (cmp > 0) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = Math.max(this.length, i);
            if (a !== this) this.negative = 1;
            return this._strip();
        };
        BN.prototype.sub = function sub(num) {
            return this.clone().isub(num);
        };
        function smallMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            var len = self.length + num.length | 0;
            out.length = len;
            len = len - 1 | 0;
            var a = self.words[0] | 0;
            var b = num.words[0] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            var carry = r / 0x4000000 | 0;
            out.words[0] = lo;
            for(var k = 1; k < len; k++){
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j | 0;
                    a = self.words[i] | 0;
                    b = num.words[j] | 0;
                    r = a * b + rword;
                    ncarry += r / 0x4000000 | 0;
                    rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
            }
            if (carry !== 0) out.words[k] = carry | 0;
            else out.length--;
            return out._strip();
        }
        var comb10MulTo = function comb10MulTo(self, num, out) {
            var a = self.words;
            var b = num.words;
            var o = out.words;
            var c = 0;
            var lo;
            var mid;
            var hi;
            var a0 = a[0] | 0;
            var al0 = a0 & 0x1fff;
            var ah0 = a0 >>> 13;
            var a1 = a[1] | 0;
            var al1 = a1 & 0x1fff;
            var ah1 = a1 >>> 13;
            var a2 = a[2] | 0;
            var al2 = a2 & 0x1fff;
            var ah2 = a2 >>> 13;
            var a3 = a[3] | 0;
            var al3 = a3 & 0x1fff;
            var ah3 = a3 >>> 13;
            var a4 = a[4] | 0;
            var al4 = a4 & 0x1fff;
            var ah4 = a4 >>> 13;
            var a5 = a[5] | 0;
            var al5 = a5 & 0x1fff;
            var ah5 = a5 >>> 13;
            var a6 = a[6] | 0;
            var al6 = a6 & 0x1fff;
            var ah6 = a6 >>> 13;
            var a7 = a[7] | 0;
            var al7 = a7 & 0x1fff;
            var ah7 = a7 >>> 13;
            var a8 = a[8] | 0;
            var al8 = a8 & 0x1fff;
            var ah8 = a8 >>> 13;
            var a9 = a[9] | 0;
            var al9 = a9 & 0x1fff;
            var ah9 = a9 >>> 13;
            var b0 = b[0] | 0;
            var bl0 = b0 & 0x1fff;
            var bh0 = b0 >>> 13;
            var b1 = b[1] | 0;
            var bl1 = b1 & 0x1fff;
            var bh1 = b1 >>> 13;
            var b2 = b[2] | 0;
            var bl2 = b2 & 0x1fff;
            var bh2 = b2 >>> 13;
            var b3 = b[3] | 0;
            var bl3 = b3 & 0x1fff;
            var bh3 = b3 >>> 13;
            var b4 = b[4] | 0;
            var bl4 = b4 & 0x1fff;
            var bh4 = b4 >>> 13;
            var b5 = b[5] | 0;
            var bl5 = b5 & 0x1fff;
            var bh5 = b5 >>> 13;
            var b6 = b[6] | 0;
            var bl6 = b6 & 0x1fff;
            var bh6 = b6 >>> 13;
            var b7 = b[7] | 0;
            var bl7 = b7 & 0x1fff;
            var bh7 = b7 >>> 13;
            var b8 = b[8] | 0;
            var bl8 = b8 & 0x1fff;
            var bh8 = b8 >>> 13;
            var b9 = b[9] | 0;
            var bl9 = b9 & 0x1fff;
            var bh9 = b9 >>> 13;
            out.negative = self.negative ^ num.negative;
            out.length = 19;
            lo = Math.imul(al0, bl0);
            mid = Math.imul(al0, bh0);
            mid = mid + Math.imul(ah0, bl0) | 0;
            hi = Math.imul(ah0, bh0);
            var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
            w0 &= 0x3ffffff;
            lo = Math.imul(al1, bl0);
            mid = Math.imul(al1, bh0);
            mid = mid + Math.imul(ah1, bl0) | 0;
            hi = Math.imul(ah1, bh0);
            lo = lo + Math.imul(al0, bl1) | 0;
            mid = mid + Math.imul(al0, bh1) | 0;
            mid = mid + Math.imul(ah0, bl1) | 0;
            hi = hi + Math.imul(ah0, bh1) | 0;
            var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
            w1 &= 0x3ffffff;
            lo = Math.imul(al2, bl0);
            mid = Math.imul(al2, bh0);
            mid = mid + Math.imul(ah2, bl0) | 0;
            hi = Math.imul(ah2, bh0);
            lo = lo + Math.imul(al1, bl1) | 0;
            mid = mid + Math.imul(al1, bh1) | 0;
            mid = mid + Math.imul(ah1, bl1) | 0;
            hi = hi + Math.imul(ah1, bh1) | 0;
            lo = lo + Math.imul(al0, bl2) | 0;
            mid = mid + Math.imul(al0, bh2) | 0;
            mid = mid + Math.imul(ah0, bl2) | 0;
            hi = hi + Math.imul(ah0, bh2) | 0;
            var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
            w2 &= 0x3ffffff;
            lo = Math.imul(al3, bl0);
            mid = Math.imul(al3, bh0);
            mid = mid + Math.imul(ah3, bl0) | 0;
            hi = Math.imul(ah3, bh0);
            lo = lo + Math.imul(al2, bl1) | 0;
            mid = mid + Math.imul(al2, bh1) | 0;
            mid = mid + Math.imul(ah2, bl1) | 0;
            hi = hi + Math.imul(ah2, bh1) | 0;
            lo = lo + Math.imul(al1, bl2) | 0;
            mid = mid + Math.imul(al1, bh2) | 0;
            mid = mid + Math.imul(ah1, bl2) | 0;
            hi = hi + Math.imul(ah1, bh2) | 0;
            lo = lo + Math.imul(al0, bl3) | 0;
            mid = mid + Math.imul(al0, bh3) | 0;
            mid = mid + Math.imul(ah0, bl3) | 0;
            hi = hi + Math.imul(ah0, bh3) | 0;
            var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
            w3 &= 0x3ffffff;
            lo = Math.imul(al4, bl0);
            mid = Math.imul(al4, bh0);
            mid = mid + Math.imul(ah4, bl0) | 0;
            hi = Math.imul(ah4, bh0);
            lo = lo + Math.imul(al3, bl1) | 0;
            mid = mid + Math.imul(al3, bh1) | 0;
            mid = mid + Math.imul(ah3, bl1) | 0;
            hi = hi + Math.imul(ah3, bh1) | 0;
            lo = lo + Math.imul(al2, bl2) | 0;
            mid = mid + Math.imul(al2, bh2) | 0;
            mid = mid + Math.imul(ah2, bl2) | 0;
            hi = hi + Math.imul(ah2, bh2) | 0;
            lo = lo + Math.imul(al1, bl3) | 0;
            mid = mid + Math.imul(al1, bh3) | 0;
            mid = mid + Math.imul(ah1, bl3) | 0;
            hi = hi + Math.imul(ah1, bh3) | 0;
            lo = lo + Math.imul(al0, bl4) | 0;
            mid = mid + Math.imul(al0, bh4) | 0;
            mid = mid + Math.imul(ah0, bl4) | 0;
            hi = hi + Math.imul(ah0, bh4) | 0;
            var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
            w4 &= 0x3ffffff;
            lo = Math.imul(al5, bl0);
            mid = Math.imul(al5, bh0);
            mid = mid + Math.imul(ah5, bl0) | 0;
            hi = Math.imul(ah5, bh0);
            lo = lo + Math.imul(al4, bl1) | 0;
            mid = mid + Math.imul(al4, bh1) | 0;
            mid = mid + Math.imul(ah4, bl1) | 0;
            hi = hi + Math.imul(ah4, bh1) | 0;
            lo = lo + Math.imul(al3, bl2) | 0;
            mid = mid + Math.imul(al3, bh2) | 0;
            mid = mid + Math.imul(ah3, bl2) | 0;
            hi = hi + Math.imul(ah3, bh2) | 0;
            lo = lo + Math.imul(al2, bl3) | 0;
            mid = mid + Math.imul(al2, bh3) | 0;
            mid = mid + Math.imul(ah2, bl3) | 0;
            hi = hi + Math.imul(ah2, bh3) | 0;
            lo = lo + Math.imul(al1, bl4) | 0;
            mid = mid + Math.imul(al1, bh4) | 0;
            mid = mid + Math.imul(ah1, bl4) | 0;
            hi = hi + Math.imul(ah1, bh4) | 0;
            lo = lo + Math.imul(al0, bl5) | 0;
            mid = mid + Math.imul(al0, bh5) | 0;
            mid = mid + Math.imul(ah0, bl5) | 0;
            hi = hi + Math.imul(ah0, bh5) | 0;
            var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
            w5 &= 0x3ffffff;
            lo = Math.imul(al6, bl0);
            mid = Math.imul(al6, bh0);
            mid = mid + Math.imul(ah6, bl0) | 0;
            hi = Math.imul(ah6, bh0);
            lo = lo + Math.imul(al5, bl1) | 0;
            mid = mid + Math.imul(al5, bh1) | 0;
            mid = mid + Math.imul(ah5, bl1) | 0;
            hi = hi + Math.imul(ah5, bh1) | 0;
            lo = lo + Math.imul(al4, bl2) | 0;
            mid = mid + Math.imul(al4, bh2) | 0;
            mid = mid + Math.imul(ah4, bl2) | 0;
            hi = hi + Math.imul(ah4, bh2) | 0;
            lo = lo + Math.imul(al3, bl3) | 0;
            mid = mid + Math.imul(al3, bh3) | 0;
            mid = mid + Math.imul(ah3, bl3) | 0;
            hi = hi + Math.imul(ah3, bh3) | 0;
            lo = lo + Math.imul(al2, bl4) | 0;
            mid = mid + Math.imul(al2, bh4) | 0;
            mid = mid + Math.imul(ah2, bl4) | 0;
            hi = hi + Math.imul(ah2, bh4) | 0;
            lo = lo + Math.imul(al1, bl5) | 0;
            mid = mid + Math.imul(al1, bh5) | 0;
            mid = mid + Math.imul(ah1, bl5) | 0;
            hi = hi + Math.imul(ah1, bh5) | 0;
            lo = lo + Math.imul(al0, bl6) | 0;
            mid = mid + Math.imul(al0, bh6) | 0;
            mid = mid + Math.imul(ah0, bl6) | 0;
            hi = hi + Math.imul(ah0, bh6) | 0;
            var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
            w6 &= 0x3ffffff;
            lo = Math.imul(al7, bl0);
            mid = Math.imul(al7, bh0);
            mid = mid + Math.imul(ah7, bl0) | 0;
            hi = Math.imul(ah7, bh0);
            lo = lo + Math.imul(al6, bl1) | 0;
            mid = mid + Math.imul(al6, bh1) | 0;
            mid = mid + Math.imul(ah6, bl1) | 0;
            hi = hi + Math.imul(ah6, bh1) | 0;
            lo = lo + Math.imul(al5, bl2) | 0;
            mid = mid + Math.imul(al5, bh2) | 0;
            mid = mid + Math.imul(ah5, bl2) | 0;
            hi = hi + Math.imul(ah5, bh2) | 0;
            lo = lo + Math.imul(al4, bl3) | 0;
            mid = mid + Math.imul(al4, bh3) | 0;
            mid = mid + Math.imul(ah4, bl3) | 0;
            hi = hi + Math.imul(ah4, bh3) | 0;
            lo = lo + Math.imul(al3, bl4) | 0;
            mid = mid + Math.imul(al3, bh4) | 0;
            mid = mid + Math.imul(ah3, bl4) | 0;
            hi = hi + Math.imul(ah3, bh4) | 0;
            lo = lo + Math.imul(al2, bl5) | 0;
            mid = mid + Math.imul(al2, bh5) | 0;
            mid = mid + Math.imul(ah2, bl5) | 0;
            hi = hi + Math.imul(ah2, bh5) | 0;
            lo = lo + Math.imul(al1, bl6) | 0;
            mid = mid + Math.imul(al1, bh6) | 0;
            mid = mid + Math.imul(ah1, bl6) | 0;
            hi = hi + Math.imul(ah1, bh6) | 0;
            lo = lo + Math.imul(al0, bl7) | 0;
            mid = mid + Math.imul(al0, bh7) | 0;
            mid = mid + Math.imul(ah0, bl7) | 0;
            hi = hi + Math.imul(ah0, bh7) | 0;
            var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
            w7 &= 0x3ffffff;
            lo = Math.imul(al8, bl0);
            mid = Math.imul(al8, bh0);
            mid = mid + Math.imul(ah8, bl0) | 0;
            hi = Math.imul(ah8, bh0);
            lo = lo + Math.imul(al7, bl1) | 0;
            mid = mid + Math.imul(al7, bh1) | 0;
            mid = mid + Math.imul(ah7, bl1) | 0;
            hi = hi + Math.imul(ah7, bh1) | 0;
            lo = lo + Math.imul(al6, bl2) | 0;
            mid = mid + Math.imul(al6, bh2) | 0;
            mid = mid + Math.imul(ah6, bl2) | 0;
            hi = hi + Math.imul(ah6, bh2) | 0;
            lo = lo + Math.imul(al5, bl3) | 0;
            mid = mid + Math.imul(al5, bh3) | 0;
            mid = mid + Math.imul(ah5, bl3) | 0;
            hi = hi + Math.imul(ah5, bh3) | 0;
            lo = lo + Math.imul(al4, bl4) | 0;
            mid = mid + Math.imul(al4, bh4) | 0;
            mid = mid + Math.imul(ah4, bl4) | 0;
            hi = hi + Math.imul(ah4, bh4) | 0;
            lo = lo + Math.imul(al3, bl5) | 0;
            mid = mid + Math.imul(al3, bh5) | 0;
            mid = mid + Math.imul(ah3, bl5) | 0;
            hi = hi + Math.imul(ah3, bh5) | 0;
            lo = lo + Math.imul(al2, bl6) | 0;
            mid = mid + Math.imul(al2, bh6) | 0;
            mid = mid + Math.imul(ah2, bl6) | 0;
            hi = hi + Math.imul(ah2, bh6) | 0;
            lo = lo + Math.imul(al1, bl7) | 0;
            mid = mid + Math.imul(al1, bh7) | 0;
            mid = mid + Math.imul(ah1, bl7) | 0;
            hi = hi + Math.imul(ah1, bh7) | 0;
            lo = lo + Math.imul(al0, bl8) | 0;
            mid = mid + Math.imul(al0, bh8) | 0;
            mid = mid + Math.imul(ah0, bl8) | 0;
            hi = hi + Math.imul(ah0, bh8) | 0;
            var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
            w8 &= 0x3ffffff;
            lo = Math.imul(al9, bl0);
            mid = Math.imul(al9, bh0);
            mid = mid + Math.imul(ah9, bl0) | 0;
            hi = Math.imul(ah9, bh0);
            lo = lo + Math.imul(al8, bl1) | 0;
            mid = mid + Math.imul(al8, bh1) | 0;
            mid = mid + Math.imul(ah8, bl1) | 0;
            hi = hi + Math.imul(ah8, bh1) | 0;
            lo = lo + Math.imul(al7, bl2) | 0;
            mid = mid + Math.imul(al7, bh2) | 0;
            mid = mid + Math.imul(ah7, bl2) | 0;
            hi = hi + Math.imul(ah7, bh2) | 0;
            lo = lo + Math.imul(al6, bl3) | 0;
            mid = mid + Math.imul(al6, bh3) | 0;
            mid = mid + Math.imul(ah6, bl3) | 0;
            hi = hi + Math.imul(ah6, bh3) | 0;
            lo = lo + Math.imul(al5, bl4) | 0;
            mid = mid + Math.imul(al5, bh4) | 0;
            mid = mid + Math.imul(ah5, bl4) | 0;
            hi = hi + Math.imul(ah5, bh4) | 0;
            lo = lo + Math.imul(al4, bl5) | 0;
            mid = mid + Math.imul(al4, bh5) | 0;
            mid = mid + Math.imul(ah4, bl5) | 0;
            hi = hi + Math.imul(ah4, bh5) | 0;
            lo = lo + Math.imul(al3, bl6) | 0;
            mid = mid + Math.imul(al3, bh6) | 0;
            mid = mid + Math.imul(ah3, bl6) | 0;
            hi = hi + Math.imul(ah3, bh6) | 0;
            lo = lo + Math.imul(al2, bl7) | 0;
            mid = mid + Math.imul(al2, bh7) | 0;
            mid = mid + Math.imul(ah2, bl7) | 0;
            hi = hi + Math.imul(ah2, bh7) | 0;
            lo = lo + Math.imul(al1, bl8) | 0;
            mid = mid + Math.imul(al1, bh8) | 0;
            mid = mid + Math.imul(ah1, bl8) | 0;
            hi = hi + Math.imul(ah1, bh8) | 0;
            lo = lo + Math.imul(al0, bl9) | 0;
            mid = mid + Math.imul(al0, bh9) | 0;
            mid = mid + Math.imul(ah0, bl9) | 0;
            hi = hi + Math.imul(ah0, bh9) | 0;
            var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
            w9 &= 0x3ffffff;
            lo = Math.imul(al9, bl1);
            mid = Math.imul(al9, bh1);
            mid = mid + Math.imul(ah9, bl1) | 0;
            hi = Math.imul(ah9, bh1);
            lo = lo + Math.imul(al8, bl2) | 0;
            mid = mid + Math.imul(al8, bh2) | 0;
            mid = mid + Math.imul(ah8, bl2) | 0;
            hi = hi + Math.imul(ah8, bh2) | 0;
            lo = lo + Math.imul(al7, bl3) | 0;
            mid = mid + Math.imul(al7, bh3) | 0;
            mid = mid + Math.imul(ah7, bl3) | 0;
            hi = hi + Math.imul(ah7, bh3) | 0;
            lo = lo + Math.imul(al6, bl4) | 0;
            mid = mid + Math.imul(al6, bh4) | 0;
            mid = mid + Math.imul(ah6, bl4) | 0;
            hi = hi + Math.imul(ah6, bh4) | 0;
            lo = lo + Math.imul(al5, bl5) | 0;
            mid = mid + Math.imul(al5, bh5) | 0;
            mid = mid + Math.imul(ah5, bl5) | 0;
            hi = hi + Math.imul(ah5, bh5) | 0;
            lo = lo + Math.imul(al4, bl6) | 0;
            mid = mid + Math.imul(al4, bh6) | 0;
            mid = mid + Math.imul(ah4, bl6) | 0;
            hi = hi + Math.imul(ah4, bh6) | 0;
            lo = lo + Math.imul(al3, bl7) | 0;
            mid = mid + Math.imul(al3, bh7) | 0;
            mid = mid + Math.imul(ah3, bl7) | 0;
            hi = hi + Math.imul(ah3, bh7) | 0;
            lo = lo + Math.imul(al2, bl8) | 0;
            mid = mid + Math.imul(al2, bh8) | 0;
            mid = mid + Math.imul(ah2, bl8) | 0;
            hi = hi + Math.imul(ah2, bh8) | 0;
            lo = lo + Math.imul(al1, bl9) | 0;
            mid = mid + Math.imul(al1, bh9) | 0;
            mid = mid + Math.imul(ah1, bl9) | 0;
            hi = hi + Math.imul(ah1, bh9) | 0;
            var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
            w10 &= 0x3ffffff;
            lo = Math.imul(al9, bl2);
            mid = Math.imul(al9, bh2);
            mid = mid + Math.imul(ah9, bl2) | 0;
            hi = Math.imul(ah9, bh2);
            lo = lo + Math.imul(al8, bl3) | 0;
            mid = mid + Math.imul(al8, bh3) | 0;
            mid = mid + Math.imul(ah8, bl3) | 0;
            hi = hi + Math.imul(ah8, bh3) | 0;
            lo = lo + Math.imul(al7, bl4) | 0;
            mid = mid + Math.imul(al7, bh4) | 0;
            mid = mid + Math.imul(ah7, bl4) | 0;
            hi = hi + Math.imul(ah7, bh4) | 0;
            lo = lo + Math.imul(al6, bl5) | 0;
            mid = mid + Math.imul(al6, bh5) | 0;
            mid = mid + Math.imul(ah6, bl5) | 0;
            hi = hi + Math.imul(ah6, bh5) | 0;
            lo = lo + Math.imul(al5, bl6) | 0;
            mid = mid + Math.imul(al5, bh6) | 0;
            mid = mid + Math.imul(ah5, bl6) | 0;
            hi = hi + Math.imul(ah5, bh6) | 0;
            lo = lo + Math.imul(al4, bl7) | 0;
            mid = mid + Math.imul(al4, bh7) | 0;
            mid = mid + Math.imul(ah4, bl7) | 0;
            hi = hi + Math.imul(ah4, bh7) | 0;
            lo = lo + Math.imul(al3, bl8) | 0;
            mid = mid + Math.imul(al3, bh8) | 0;
            mid = mid + Math.imul(ah3, bl8) | 0;
            hi = hi + Math.imul(ah3, bh8) | 0;
            lo = lo + Math.imul(al2, bl9) | 0;
            mid = mid + Math.imul(al2, bh9) | 0;
            mid = mid + Math.imul(ah2, bl9) | 0;
            hi = hi + Math.imul(ah2, bh9) | 0;
            var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
            w11 &= 0x3ffffff;
            lo = Math.imul(al9, bl3);
            mid = Math.imul(al9, bh3);
            mid = mid + Math.imul(ah9, bl3) | 0;
            hi = Math.imul(ah9, bh3);
            lo = lo + Math.imul(al8, bl4) | 0;
            mid = mid + Math.imul(al8, bh4) | 0;
            mid = mid + Math.imul(ah8, bl4) | 0;
            hi = hi + Math.imul(ah8, bh4) | 0;
            lo = lo + Math.imul(al7, bl5) | 0;
            mid = mid + Math.imul(al7, bh5) | 0;
            mid = mid + Math.imul(ah7, bl5) | 0;
            hi = hi + Math.imul(ah7, bh5) | 0;
            lo = lo + Math.imul(al6, bl6) | 0;
            mid = mid + Math.imul(al6, bh6) | 0;
            mid = mid + Math.imul(ah6, bl6) | 0;
            hi = hi + Math.imul(ah6, bh6) | 0;
            lo = lo + Math.imul(al5, bl7) | 0;
            mid = mid + Math.imul(al5, bh7) | 0;
            mid = mid + Math.imul(ah5, bl7) | 0;
            hi = hi + Math.imul(ah5, bh7) | 0;
            lo = lo + Math.imul(al4, bl8) | 0;
            mid = mid + Math.imul(al4, bh8) | 0;
            mid = mid + Math.imul(ah4, bl8) | 0;
            hi = hi + Math.imul(ah4, bh8) | 0;
            lo = lo + Math.imul(al3, bl9) | 0;
            mid = mid + Math.imul(al3, bh9) | 0;
            mid = mid + Math.imul(ah3, bl9) | 0;
            hi = hi + Math.imul(ah3, bh9) | 0;
            var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
            w12 &= 0x3ffffff;
            lo = Math.imul(al9, bl4);
            mid = Math.imul(al9, bh4);
            mid = mid + Math.imul(ah9, bl4) | 0;
            hi = Math.imul(ah9, bh4);
            lo = lo + Math.imul(al8, bl5) | 0;
            mid = mid + Math.imul(al8, bh5) | 0;
            mid = mid + Math.imul(ah8, bl5) | 0;
            hi = hi + Math.imul(ah8, bh5) | 0;
            lo = lo + Math.imul(al7, bl6) | 0;
            mid = mid + Math.imul(al7, bh6) | 0;
            mid = mid + Math.imul(ah7, bl6) | 0;
            hi = hi + Math.imul(ah7, bh6) | 0;
            lo = lo + Math.imul(al6, bl7) | 0;
            mid = mid + Math.imul(al6, bh7) | 0;
            mid = mid + Math.imul(ah6, bl7) | 0;
            hi = hi + Math.imul(ah6, bh7) | 0;
            lo = lo + Math.imul(al5, bl8) | 0;
            mid = mid + Math.imul(al5, bh8) | 0;
            mid = mid + Math.imul(ah5, bl8) | 0;
            hi = hi + Math.imul(ah5, bh8) | 0;
            lo = lo + Math.imul(al4, bl9) | 0;
            mid = mid + Math.imul(al4, bh9) | 0;
            mid = mid + Math.imul(ah4, bl9) | 0;
            hi = hi + Math.imul(ah4, bh9) | 0;
            var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
            w13 &= 0x3ffffff;
            lo = Math.imul(al9, bl5);
            mid = Math.imul(al9, bh5);
            mid = mid + Math.imul(ah9, bl5) | 0;
            hi = Math.imul(ah9, bh5);
            lo = lo + Math.imul(al8, bl6) | 0;
            mid = mid + Math.imul(al8, bh6) | 0;
            mid = mid + Math.imul(ah8, bl6) | 0;
            hi = hi + Math.imul(ah8, bh6) | 0;
            lo = lo + Math.imul(al7, bl7) | 0;
            mid = mid + Math.imul(al7, bh7) | 0;
            mid = mid + Math.imul(ah7, bl7) | 0;
            hi = hi + Math.imul(ah7, bh7) | 0;
            lo = lo + Math.imul(al6, bl8) | 0;
            mid = mid + Math.imul(al6, bh8) | 0;
            mid = mid + Math.imul(ah6, bl8) | 0;
            hi = hi + Math.imul(ah6, bh8) | 0;
            lo = lo + Math.imul(al5, bl9) | 0;
            mid = mid + Math.imul(al5, bh9) | 0;
            mid = mid + Math.imul(ah5, bl9) | 0;
            hi = hi + Math.imul(ah5, bh9) | 0;
            var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
            w14 &= 0x3ffffff;
            lo = Math.imul(al9, bl6);
            mid = Math.imul(al9, bh6);
            mid = mid + Math.imul(ah9, bl6) | 0;
            hi = Math.imul(ah9, bh6);
            lo = lo + Math.imul(al8, bl7) | 0;
            mid = mid + Math.imul(al8, bh7) | 0;
            mid = mid + Math.imul(ah8, bl7) | 0;
            hi = hi + Math.imul(ah8, bh7) | 0;
            lo = lo + Math.imul(al7, bl8) | 0;
            mid = mid + Math.imul(al7, bh8) | 0;
            mid = mid + Math.imul(ah7, bl8) | 0;
            hi = hi + Math.imul(ah7, bh8) | 0;
            lo = lo + Math.imul(al6, bl9) | 0;
            mid = mid + Math.imul(al6, bh9) | 0;
            mid = mid + Math.imul(ah6, bl9) | 0;
            hi = hi + Math.imul(ah6, bh9) | 0;
            var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
            w15 &= 0x3ffffff;
            lo = Math.imul(al9, bl7);
            mid = Math.imul(al9, bh7);
            mid = mid + Math.imul(ah9, bl7) | 0;
            hi = Math.imul(ah9, bh7);
            lo = lo + Math.imul(al8, bl8) | 0;
            mid = mid + Math.imul(al8, bh8) | 0;
            mid = mid + Math.imul(ah8, bl8) | 0;
            hi = hi + Math.imul(ah8, bh8) | 0;
            lo = lo + Math.imul(al7, bl9) | 0;
            mid = mid + Math.imul(al7, bh9) | 0;
            mid = mid + Math.imul(ah7, bl9) | 0;
            hi = hi + Math.imul(ah7, bh9) | 0;
            var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
            w16 &= 0x3ffffff;
            lo = Math.imul(al9, bl8);
            mid = Math.imul(al9, bh8);
            mid = mid + Math.imul(ah9, bl8) | 0;
            hi = Math.imul(ah9, bh8);
            lo = lo + Math.imul(al8, bl9) | 0;
            mid = mid + Math.imul(al8, bh9) | 0;
            mid = mid + Math.imul(ah8, bl9) | 0;
            hi = hi + Math.imul(ah8, bh9) | 0;
            var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
            w17 &= 0x3ffffff;
            lo = Math.imul(al9, bl9);
            mid = Math.imul(al9, bh9);
            mid = mid + Math.imul(ah9, bl9) | 0;
            hi = Math.imul(ah9, bh9);
            var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
            w18 &= 0x3ffffff;
            o[0] = w0;
            o[1] = w1;
            o[2] = w2;
            o[3] = w3;
            o[4] = w4;
            o[5] = w5;
            o[6] = w6;
            o[7] = w7;
            o[8] = w8;
            o[9] = w9;
            o[10] = w10;
            o[11] = w11;
            o[12] = w12;
            o[13] = w13;
            o[14] = w14;
            o[15] = w15;
            o[16] = w16;
            o[17] = w17;
            o[18] = w18;
            if (c !== 0) {
                o[19] = c;
                out.length++;
            }
            return out;
        };
        if (!Math.imul) comb10MulTo = smallMulTo;
        function bigMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            out.length = self.length + num.length;
            var carry = 0;
            var hncarry = 0;
            for(var k = 0; k < out.length - 1; k++){
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j;
                    var a = self.words[i] | 0;
                    var b = num.words[j] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                    lo = lo + rword | 0;
                    rword = lo & 0x3ffffff;
                    ncarry = ncarry + (lo >>> 26) | 0;
                    hncarry += ncarry >>> 26;
                    ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
            }
            if (carry !== 0) out.words[k] = carry;
            else out.length--;
            return out._strip();
        }
        function jumboMulTo(self, num, out) {
            return bigMulTo(self, num, out);
        }
        BN.prototype.mulTo = function mulTo(num, out) {
            var res;
            var len = this.length + num.length;
            if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
            else if (len < 63) res = smallMulTo(this, num, out);
            else if (len < 1024) res = bigMulTo(this, num, out);
            else res = jumboMulTo(this, num, out);
            return res;
        };
        function FFTM(x, y) {
            this.x = x;
            this.y = y;
        }
        FFTM.prototype.makeRBT = function makeRBT(N) {
            var t = new Array(N);
            var l = BN.prototype._countBits(N) - 1;
            for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
            return t;
        };
        FFTM.prototype.revBin = function revBin(x, l, N) {
            if (x === 0 || x === N - 1) return x;
            var rb = 0;
            for(var i = 0; i < l; i++){
                rb |= (x & 1) << l - i - 1;
                x >>= 1;
            }
            return rb;
        };
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
            for(var i = 0; i < N; i++){
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
            }
        };
        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
            this.permute(rbt, rws, iws, rtws, itws, N);
            for(var s = 1; s < N; s <<= 1){
                var l = s << 1;
                var rtwdf = Math.cos(2 * Math.PI / l);
                var itwdf = Math.sin(2 * Math.PI / l);
                for(var p = 0; p < N; p += l){
                    var rtwdf_ = rtwdf;
                    var itwdf_ = itwdf;
                    for(var j = 0; j < s; j++){
                        var re = rtws[p + j];
                        var ie = itws[p + j];
                        var ro = rtws[p + j + s];
                        var io = itws[p + j + s];
                        var rx = rtwdf_ * ro - itwdf_ * io;
                        io = rtwdf_ * io + itwdf_ * ro;
                        ro = rx;
                        rtws[p + j] = re + ro;
                        itws[p + j] = ie + io;
                        rtws[p + j + s] = re - ro;
                        itws[p + j + s] = ie - io;
                        if (j !== l) {
                            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                            rtwdf_ = rx;
                        }
                    }
                }
            }
        };
        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
            var N = Math.max(m, n) | 1;
            var odd = N & 1;
            var i = 0;
            for(N = N / 2 | 0; N; N = N >>> 1)i++;
            return 1 << i + 1 + odd;
        };
        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
            if (N <= 1) return;
            for(var i = 0; i < N / 2; i++){
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
            }
        };
        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
            var carry = 0;
            for(var i = 0; i < N / 2; i++){
                var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) carry = 0;
                else carry = w / 0x4000000 | 0;
            }
            return ws;
        };
        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
            var carry = 0;
            for(var i = 0; i < len; i++){
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
            }
            for(i = 2 * len; i < N; ++i)rws[i] = 0;
            assert(carry === 0);
            assert((carry & -8192) === 0);
        };
        FFTM.prototype.stub = function stub(N) {
            var ph = new Array(N);
            for(var i = 0; i < N; i++)ph[i] = 0;
            return ph;
        };
        FFTM.prototype.mulp = function mulp(x, y, out) {
            var N = 2 * this.guessLen13b(x.length, y.length);
            var rbt = this.makeRBT(N);
            var _ = this.stub(N);
            var rws = new Array(N);
            var rwst = new Array(N);
            var iwst = new Array(N);
            var nrws = new Array(N);
            var nrwst = new Array(N);
            var niwst = new Array(N);
            var rmws = out.words;
            rmws.length = N;
            this.convert13b(x.words, x.length, rws, N);
            this.convert13b(y.words, y.length, nrws, N);
            this.transform(rws, _, rwst, iwst, N, rbt);
            this.transform(nrws, _, nrwst, niwst, N, rbt);
            for(var i = 0; i < N; i++){
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
            }
            this.conjugate(rwst, iwst, N);
            this.transform(rwst, iwst, rmws, _, N, rbt);
            this.conjugate(rmws, _, N);
            this.normalize13b(rmws, N);
            out.negative = x.negative ^ y.negative;
            out.length = x.length + y.length;
            return out._strip();
        };
        BN.prototype.mul = function mul(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return this.mulTo(num, out);
        };
        BN.prototype.mulf = function mulf(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return jumboMulTo(this, num, out);
        };
        BN.prototype.imul = function imul(num) {
            return this.clone().mulTo(num, this);
        };
        BN.prototype.imuln = function imuln(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += w / 0x4000000 | 0;
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.muln = function muln(num) {
            return this.clone().imuln(num);
        };
        BN.prototype.sqr = function sqr() {
            return this.mul(this);
        };
        BN.prototype.isqr = function isqr() {
            return this.imul(this.clone());
        };
        BN.prototype.pow = function pow(num) {
            var w = toBitArray(num);
            if (w.length === 0) return new BN(1);
            var res = this;
            for(var i = 0; i < w.length; i++, res = res.sqr()){
                if (w[i] !== 0) break;
            }
            if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                if (w[i] === 0) continue;
                res = res.mul(q);
            }
            return res;
        };
        BN.prototype.iushln = function iushln(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
            var i;
            if (r !== 0) {
                var carry = 0;
                for(i = 0; i < this.length; i++){
                    var newCarry = this.words[i] & carryMask;
                    var c = (this.words[i] | 0) - newCarry << r;
                    this.words[i] = c | carry;
                    carry = newCarry >>> 26 - r;
                }
                if (carry) {
                    this.words[i] = carry;
                    this.length++;
                }
            }
            if (s !== 0) {
                for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                for(i = 0; i < s; i++)this.words[i] = 0;
                this.length += s;
            }
            return this._strip();
        };
        BN.prototype.ishln = function ishln(bits) {
            assert(this.negative === 0);
            return this.iushln(bits);
        };
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
            assert(typeof bits === 'number' && bits >= 0);
            var h;
            if (hint) h = (hint - hint % 26) / 26;
            else h = 0;
            var r = bits % 26;
            var s = Math.min((bits - r) / 26, this.length);
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            var maskedWords = extended;
            h -= s;
            h = Math.max(0, h);
            if (maskedWords) {
                for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                maskedWords.length = s;
            }
            if (s === 0) ;
            else if (this.length > s) {
                this.length -= s;
                for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
            } else {
                this.words[0] = 0;
                this.length = 1;
            }
            var carry = 0;
            for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                var word = this.words[i] | 0;
                this.words[i] = carry << 26 - r | word >>> r;
                carry = word & mask;
            }
            if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
            if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
            }
            return this._strip();
        };
        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
            assert(this.negative === 0);
            return this.iushrn(bits, hint, extended);
        };
        BN.prototype.shln = function shln(bits) {
            return this.clone().ishln(bits);
        };
        BN.prototype.ushln = function ushln(bits) {
            return this.clone().iushln(bits);
        };
        BN.prototype.shrn = function shrn(bits) {
            return this.clone().ishrn(bits);
        };
        BN.prototype.ushrn = function ushrn(bits) {
            return this.clone().iushrn(bits);
        };
        BN.prototype.testn = function testn(bit) {
            assert(typeof bit === 'number' && bit >= 0);
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) return false;
            var w = this.words[s];
            return !!(w & q);
        };
        BN.prototype.imaskn = function imaskn(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            assert(this.negative === 0, 'imaskn works only with positive numbers');
            if (this.length <= s) return this;
            if (r !== 0) s++;
            this.length = Math.min(s, this.length);
            if (r !== 0) {
                var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                this.words[this.length - 1] &= mask;
            }
            return this._strip();
        };
        BN.prototype.maskn = function maskn(bits) {
            return this.clone().imaskn(bits);
        };
        BN.prototype.iaddn = function iaddn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.isubn(-num);
            if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) <= num) {
                    this.words[0] = num - (this.words[0] | 0);
                    this.negative = 0;
                    return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
            }
            return this._iaddn(num);
        };
        BN.prototype._iaddn = function _iaddn(num) {
            this.words[0] += num;
            for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) this.words[i + 1] = 1;
                else this.words[i + 1]++;
            }
            this.length = Math.max(this.length, i + 1);
            return this;
        };
        BN.prototype.isubn = function isubn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.iaddn(-num);
            if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
            }
            this.words[0] -= num;
            if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
            } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                this.words[i] += 0x4000000;
                this.words[i + 1] -= 1;
            }
            return this._strip();
        };
        BN.prototype.addn = function addn(num) {
            return this.clone().iaddn(num);
        };
        BN.prototype.subn = function subn(num) {
            return this.clone().isubn(num);
        };
        BN.prototype.iabs = function iabs() {
            this.negative = 0;
            return this;
        };
        BN.prototype.abs = function abs() {
            return this.clone().iabs();
        };
        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
            var len = num.length + shift;
            var i;
            this._expand(len);
            var w;
            var carry = 0;
            for(i = 0; i < num.length; i++){
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - (right / 0x4000000 | 0);
                this.words[i + shift] = w & 0x3ffffff;
            }
            for(; i < this.length - shift; i++){
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
            }
            if (carry === 0) return this._strip();
            assert(carry === -1);
            carry = 0;
            for(i = 0; i < this.length; i++){
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
            }
            this.negative = 1;
            return this._strip();
        };
        BN.prototype._wordDiv = function _wordDiv(num, mode) {
            var shift = this.length - num.length;
            var a = this.clone();
            var b = num;
            var bhi = b.words[b.length - 1] | 0;
            var bhiBits = this._countBits(bhi);
            shift = 26 - bhiBits;
            if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
            }
            var m = a.length - b.length;
            var q;
            if (mode !== 'mod') {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for(var i = 0; i < q.length; i++)q.words[i] = 0;
            }
            var diff = a.clone()._ishlnsubmul(b, 1, m);
            if (diff.negative === 0) {
                a = diff;
                if (q) q.words[m] = 1;
            }
            for(var j = m - 1; j >= 0; j--){
                var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                qj = Math.min(qj / bhi | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while(a.negative !== 0){
                    qj--;
                    a.negative = 0;
                    a._ishlnsubmul(b, 1, j);
                    if (!a.isZero()) a.negative ^= 1;
                }
                if (q) q.words[j] = qj;
            }
            if (q) q._strip();
            a._strip();
            if (mode !== 'div' && shift !== 0) a.iushrn(shift);
            return {
                div: q || null,
                mod: a
            };
        };
        BN.prototype.divmod = function divmod(num, mode, positive) {
            assert(!num.isZero());
            if (this.isZero()) return {
                div: new BN(0),
                mod: new BN(0)
            };
            var div, mod, res;
            if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== 'mod') div = res.div.neg();
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.iadd(num);
                }
                return {
                    div: div,
                    mod: mod
                };
            }
            if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== 'mod') div = res.div.neg();
                return {
                    div: div,
                    mod: res.mod
                };
            }
            if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.isub(num);
                }
                return {
                    div: res.div,
                    mod: mod
                };
            }
            if (num.length > this.length || this.cmp(num) < 0) return {
                div: new BN(0),
                mod: this
            };
            if (num.length === 1) {
                if (mode === 'div') return {
                    div: this.divn(num.words[0]),
                    mod: null
                };
                if (mode === 'mod') return {
                    div: null,
                    mod: new BN(this.modrn(num.words[0]))
                };
                return {
                    div: this.divn(num.words[0]),
                    mod: new BN(this.modrn(num.words[0]))
                };
            }
            return this._wordDiv(num, mode);
        };
        BN.prototype.div = function div(num) {
            return this.divmod(num, 'div', false).div;
        };
        BN.prototype.mod = function mod(num) {
            return this.divmod(num, 'mod', false).mod;
        };
        BN.prototype.umod = function umod(num) {
            return this.divmod(num, 'mod', true).mod;
        };
        BN.prototype.divRound = function divRound(num) {
            var dm = this.divmod(num);
            if (dm.mod.isZero()) return dm.div;
            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
            var half = num.ushrn(1);
            var r2 = num.andln(1);
            var cmp = mod.cmp(half);
            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };
        BN.prototype.modrn = function modrn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var p = 67108864 % num;
            var acc = 0;
            for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
            return isNegNum ? -acc : acc;
        };
        BN.prototype.modn = function modn(num) {
            return this.modrn(num);
        };
        BN.prototype.idivn = function idivn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var carry = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = w / num | 0;
                carry = w % num;
            }
            this._strip();
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.divn = function divn(num) {
            return this.clone().idivn(num);
        };
        BN.prototype.egcd = function egcd(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var x = this;
            var y = p.clone();
            if (x.negative !== 0) x = x.umod(p);
            else x = x.clone();
            var A = new BN(1);
            var B = new BN(0);
            var C = new BN(0);
            var D = new BN(1);
            var g = 0;
            while(x.isEven() && y.isEven()){
                x.iushrn(1);
                y.iushrn(1);
                ++g;
            }
            var yp = y.clone();
            var xp = x.clone();
            while(!x.isZero()){
                for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    x.iushrn(i);
                    while(i-- > 0){
                        if (A.isOdd() || B.isOdd()) {
                            A.iadd(yp);
                            B.isub(xp);
                        }
                        A.iushrn(1);
                        B.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    y.iushrn(j);
                    while(j-- > 0){
                        if (C.isOdd() || D.isOdd()) {
                            C.iadd(yp);
                            D.isub(xp);
                        }
                        C.iushrn(1);
                        D.iushrn(1);
                    }
                }
                if (x.cmp(y) >= 0) {
                    x.isub(y);
                    A.isub(C);
                    B.isub(D);
                } else {
                    y.isub(x);
                    C.isub(A);
                    D.isub(B);
                }
            }
            return {
                a: C,
                b: D,
                gcd: y.iushln(g)
            };
        };
        BN.prototype._invmp = function _invmp(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var a = this;
            var b = p.clone();
            if (a.negative !== 0) a = a.umod(p);
            else a = a.clone();
            var x1 = new BN(1);
            var x2 = new BN(0);
            var delta = b.clone();
            while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    a.iushrn(i);
                    while(i-- > 0){
                        if (x1.isOdd()) x1.iadd(delta);
                        x1.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    b.iushrn(j);
                    while(j-- > 0){
                        if (x2.isOdd()) x2.iadd(delta);
                        x2.iushrn(1);
                    }
                }
                if (a.cmp(b) >= 0) {
                    a.isub(b);
                    x1.isub(x2);
                } else {
                    b.isub(a);
                    x2.isub(x1);
                }
            }
            var res;
            if (a.cmpn(1) === 0) res = x1;
            else res = x2;
            if (res.cmpn(0) < 0) res.iadd(p);
            return res;
        };
        BN.prototype.gcd = function gcd(num) {
            if (this.isZero()) return num.abs();
            if (num.isZero()) return this.abs();
            var a = this.clone();
            var b = num.clone();
            a.negative = 0;
            b.negative = 0;
            for(var shift = 0; a.isEven() && b.isEven(); shift++){
                a.iushrn(1);
                b.iushrn(1);
            }
            do {
                while(a.isEven())a.iushrn(1);
                while(b.isEven())b.iushrn(1);
                var r = a.cmp(b);
                if (r < 0) {
                    var t = a;
                    a = b;
                    b = t;
                } else if (r === 0 || b.cmpn(1) === 0) break;
                a.isub(b);
            }while (true)
            return b.iushln(shift);
        };
        BN.prototype.invm = function invm(num) {
            return this.egcd(num).a.umod(num);
        };
        BN.prototype.isEven = function isEven() {
            return (this.words[0] & 1) === 0;
        };
        BN.prototype.isOdd = function isOdd() {
            return (this.words[0] & 1) === 1;
        };
        BN.prototype.andln = function andln(num) {
            return this.words[0] & num;
        };
        BN.prototype.bincn = function bincn(bit) {
            assert(typeof bit === 'number');
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
            }
            var carry = q;
            for(var i = s; carry !== 0 && i < this.length; i++){
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.isZero = function isZero() {
            return this.length === 1 && this.words[0] === 0;
        };
        BN.prototype.cmpn = function cmpn(num) {
            var negative = num < 0;
            if (this.negative !== 0 && !negative) return -1;
            if (this.negative === 0 && negative) return 1;
            this._strip();
            var res;
            if (this.length > 1) res = 1;
            else {
                if (negative) num = -num;
                assert(num <= 0x3ffffff, 'Number is too big');
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
            }
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.cmp = function cmp(num) {
            if (this.negative !== 0 && num.negative === 0) return -1;
            if (this.negative === 0 && num.negative !== 0) return 1;
            var res = this.ucmp(num);
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.ucmp = function ucmp(num) {
            if (this.length > num.length) return 1;
            if (this.length < num.length) return -1;
            var res = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) res = -1;
                else if (a > b) res = 1;
                break;
            }
            return res;
        };
        BN.prototype.gtn = function gtn(num) {
            return this.cmpn(num) === 1;
        };
        BN.prototype.gt = function gt(num) {
            return this.cmp(num) === 1;
        };
        BN.prototype.gten = function gten(num) {
            return this.cmpn(num) >= 0;
        };
        BN.prototype.gte = function gte(num) {
            return this.cmp(num) >= 0;
        };
        BN.prototype.ltn = function ltn(num) {
            return this.cmpn(num) === -1;
        };
        BN.prototype.lt = function lt(num) {
            return this.cmp(num) === -1;
        };
        BN.prototype.lten = function lten(num) {
            return this.cmpn(num) <= 0;
        };
        BN.prototype.lte = function lte(num) {
            return this.cmp(num) <= 0;
        };
        BN.prototype.eqn = function eqn(num) {
            return this.cmpn(num) === 0;
        };
        BN.prototype.eq = function eq(num) {
            return this.cmp(num) === 0;
        };
        BN.red = function red(num) {
            return new Red(num);
        };
        BN.prototype.toRed = function toRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            assert(this.negative === 0, 'red works only with positives');
            return ctx.convertTo(this)._forceRed(ctx);
        };
        BN.prototype.fromRed = function fromRed() {
            assert(this.red, 'fromRed works only with numbers in reduction context');
            return this.red.convertFrom(this);
        };
        BN.prototype._forceRed = function _forceRed(ctx) {
            this.red = ctx;
            return this;
        };
        BN.prototype.forceRed = function forceRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            return this._forceRed(ctx);
        };
        BN.prototype.redAdd = function redAdd(num) {
            assert(this.red, 'redAdd works only with red numbers');
            return this.red.add(this, num);
        };
        BN.prototype.redIAdd = function redIAdd(num) {
            assert(this.red, 'redIAdd works only with red numbers');
            return this.red.iadd(this, num);
        };
        BN.prototype.redSub = function redSub(num) {
            assert(this.red, 'redSub works only with red numbers');
            return this.red.sub(this, num);
        };
        BN.prototype.redISub = function redISub(num) {
            assert(this.red, 'redISub works only with red numbers');
            return this.red.isub(this, num);
        };
        BN.prototype.redShl = function redShl(num) {
            assert(this.red, 'redShl works only with red numbers');
            return this.red.shl(this, num);
        };
        BN.prototype.redMul = function redMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.mul(this, num);
        };
        BN.prototype.redIMul = function redIMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.imul(this, num);
        };
        BN.prototype.redSqr = function redSqr() {
            assert(this.red, 'redSqr works only with red numbers');
            this.red._verify1(this);
            return this.red.sqr(this);
        };
        BN.prototype.redISqr = function redISqr() {
            assert(this.red, 'redISqr works only with red numbers');
            this.red._verify1(this);
            return this.red.isqr(this);
        };
        BN.prototype.redSqrt = function redSqrt() {
            assert(this.red, 'redSqrt works only with red numbers');
            this.red._verify1(this);
            return this.red.sqrt(this);
        };
        BN.prototype.redInvm = function redInvm() {
            assert(this.red, 'redInvm works only with red numbers');
            this.red._verify1(this);
            return this.red.invm(this);
        };
        BN.prototype.redNeg = function redNeg() {
            assert(this.red, 'redNeg works only with red numbers');
            this.red._verify1(this);
            return this.red.neg(this);
        };
        BN.prototype.redPow = function redPow(num) {
            assert(this.red && !num.red, 'redPow(normalNum)');
            this.red._verify1(this);
            return this.red.pow(this, num);
        };
        var primes = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function MPrime(name, p) {
            this.name = name;
            this.p = new BN(p, 16);
            this.n = this.p.bitLength();
            this.k = new BN(1).iushln(this.n).isub(this.p);
            this.tmp = this._tmp();
        }
        MPrime.prototype._tmp = function _tmp() {
            var tmp = new BN(null);
            tmp.words = new Array(Math.ceil(this.n / 13));
            return tmp;
        };
        MPrime.prototype.ireduce = function ireduce(num) {
            var r = num;
            var rlen;
            do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
            }while (rlen > this.n)
            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
            if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
            } else if (cmp > 0) r.isub(this.p);
            else if (r.strip !== undefined) r.strip();
            else r._strip();
            return r;
        };
        MPrime.prototype.split = function split(input, out) {
            input.iushrn(this.n, 0, out);
        };
        MPrime.prototype.imulK = function imulK(num) {
            return num.imul(this.k);
        };
        function K256() {
            MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);
        K256.prototype.split = function split(input, output) {
            var mask = 0x3fffff;
            var outLen = Math.min(input.length, 9);
            for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
            output.length = outLen;
            if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
            }
            var prev = input.words[9];
            output.words[output.length++] = prev & mask;
            for(i = 10; i < input.length; i++){
                var next = input.words[i] | 0;
                input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                prev = next;
            }
            prev >>>= 22;
            input.words[i - 10] = prev;
            if (prev === 0 && input.length > 10) input.length -= 10;
            else input.length -= 9;
        };
        K256.prototype.imulK = function imulK(num) {
            num.words[num.length] = 0;
            num.words[num.length + 1] = 0;
            num.length += 2;
            var lo = 0;
            for(var i = 0; i < num.length; i++){
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + (lo / 0x4000000 | 0);
            }
            if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) num.length--;
            }
            return num;
        };
        function P224() {
            MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);
        function P192() {
            MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);
        function P25519() {
            MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);
        P25519.prototype.imulK = function imulK(num) {
            var carry = 0;
            for(var i = 0; i < num.length; i++){
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
            }
            if (carry !== 0) num.words[num.length++] = carry;
            return num;
        };
        BN._prime = function prime(name) {
            if (primes[name]) return primes[name];
            var prime;
            if (name === 'k256') prime = new K256();
            else if (name === 'p224') prime = new P224();
            else if (name === 'p192') prime = new P192();
            else if (name === 'p25519') prime = new P25519();
            else throw new Error('Unknown prime ' + name);
            primes[name] = prime;
            return prime;
        };
        function Red(m) {
            if (typeof m === 'string') {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
            } else {
                assert(m.gtn(1), 'modulus must be greater than 1');
                this.m = m;
                this.prime = null;
            }
        }
        Red.prototype._verify1 = function _verify1(a) {
            assert(a.negative === 0, 'red works only with positives');
            assert(a.red, 'red works only with red numbers');
        };
        Red.prototype._verify2 = function _verify2(a, b) {
            assert((a.negative | b.negative) === 0, 'red works only with positives');
            assert(a.red && a.red === b.red, 'red works only with red numbers');
        };
        Red.prototype.imod = function imod(a) {
            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
            move(a, a.umod(this.m)._forceRed(this));
            return a;
        };
        Red.prototype.neg = function neg(a) {
            if (a.isZero()) return a.clone();
            return this.m.sub(a)._forceRed(this);
        };
        Red.prototype.add = function add(a, b) {
            this._verify2(a, b);
            var res = a.add(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res._forceRed(this);
        };
        Red.prototype.iadd = function iadd(a, b) {
            this._verify2(a, b);
            var res = a.iadd(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res;
        };
        Red.prototype.sub = function sub(a, b) {
            this._verify2(a, b);
            var res = a.sub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res._forceRed(this);
        };
        Red.prototype.isub = function isub(a, b) {
            this._verify2(a, b);
            var res = a.isub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res;
        };
        Red.prototype.shl = function shl(a, num) {
            this._verify1(a);
            return this.imod(a.ushln(num));
        };
        Red.prototype.imul = function imul(a, b) {
            this._verify2(a, b);
            return this.imod(a.imul(b));
        };
        Red.prototype.mul = function mul(a, b) {
            this._verify2(a, b);
            return this.imod(a.mul(b));
        };
        Red.prototype.isqr = function isqr(a) {
            return this.imul(a, a.clone());
        };
        Red.prototype.sqr = function sqr(a) {
            return this.mul(a, a);
        };
        Red.prototype.sqrt = function sqrt(a) {
            if (a.isZero()) return a.clone();
            var mod3 = this.m.andln(3);
            assert(mod3 % 2 === 1);
            if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
            }
            var q = this.m.subn(1);
            var s = 0;
            while(!q.isZero() && q.andln(1) === 0){
                s++;
                q.iushrn(1);
            }
            assert(!q.isZero());
            var one = new BN(1).toRed(this);
            var nOne = one.redNeg();
            var lpow = this.m.subn(1).iushrn(1);
            var z = this.m.bitLength();
            z = new BN(2 * z * z).toRed(this);
            while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
            var c = this.pow(z, q);
            var r = this.pow(a, q.addn(1).iushrn(1));
            var t = this.pow(a, q);
            var m = s;
            while(t.cmp(one) !== 0){
                var tmp = t;
                for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
            }
            return r;
        };
        Red.prototype.invm = function invm(a) {
            var inv = a._invmp(this.m);
            if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
            } else return this.imod(inv);
        };
        Red.prototype.pow = function pow(a, num) {
            if (num.isZero()) return new BN(1).toRed(this);
            if (num.cmpn(1) === 0) return a.clone();
            var windowSize = 4;
            var wnd = new Array(1 << windowSize);
            wnd[0] = new BN(1).toRed(this);
            wnd[1] = a;
            for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
            var res = wnd[0];
            var current = 0;
            var currentLen = 0;
            var start = num.bitLength() % 26;
            if (start === 0) start = 26;
            for(i = num.length - 1; i >= 0; i--){
                var word = num.words[i];
                for(var j = start - 1; j >= 0; j--){
                    var bit = word >> j & 1;
                    if (res !== wnd[0]) res = this.sqr(res);
                    if (bit === 0 && current === 0) {
                        currentLen = 0;
                        continue;
                    }
                    current <<= 1;
                    current |= bit;
                    currentLen++;
                    if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                    res = this.mul(res, wnd[current]);
                    currentLen = 0;
                    current = 0;
                }
                start = 26;
            }
            return res;
        };
        Red.prototype.convertTo = function convertTo(num) {
            var r = num.umod(this.m);
            return r === num ? r.clone() : r;
        };
        Red.prototype.convertFrom = function convertFrom(num) {
            var res = num.clone();
            res.red = null;
            return res;
        };
        BN.mont = function mont(num) {
            return new Mont(num);
        };
        function Mont(m) {
            Red.call(this, m);
            this.shift = this.m.bitLength();
            if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
            this.r = new BN(1).iushln(this.shift);
            this.r2 = this.imod(this.r.sqr());
            this.rinv = this.r._invmp(this.m);
            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
            this.minv = this.minv.umod(this.r);
            this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);
        Mont.prototype.convertTo = function convertTo(num) {
            return this.imod(num.ushln(this.shift));
        };
        Mont.prototype.convertFrom = function convertFrom(num) {
            var r = this.imod(num.mul(this.rinv));
            r.red = null;
            return r;
        };
        Mont.prototype.imul = function imul(a, b) {
            if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
            }
            var t = a.imul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.mul = function mul(a, b) {
            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
            var t = a.mul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.invm = function invm(a) {
            var res = this.imod(a._invmp(this.m).mul(this.r2));
            return res._forceRed(this);
        };
    })(module, this);
});
parcelRegister("ejFGc", function(module, exports) {
    'use strict';
    var $6SLbO = parcelRequire("6SLbO");
    var $h9FlO = parcelRequire("h9FlO");
    var $gIBLw = parcelRequire("gIBLw");
    var $gcaJj = parcelRequire("gcaJj");
    var $fS6zE = parcelRequire("fS6zE");
    var $Wth4q = parcelRequire("Wth4q");
    var $a6c32bc236201271$require$Buffer = $Wth4q.Buffer;
    function $a6c32bc236201271$var$decrypt(data, password) {
        var salt = data.algorithm.decrypt.kde.kdeparams.salt;
        var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
        var algo = $h9FlO[data.algorithm.decrypt.cipher.algo.join('.')];
        var iv = data.algorithm.decrypt.cipher.iv;
        var cipherText = data.subjectPrivateKey;
        var keylen = parseInt(algo.split('-')[1], 10) / 8;
        var key = $fS6zE.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
        var cipher = $gcaJj.createDecipheriv(algo, key, iv);
        var out = [];
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        return $a6c32bc236201271$require$Buffer.concat(out);
    }
    function $a6c32bc236201271$var$parseKeys(buffer) {
        var password;
        if (typeof buffer === 'object' && !$a6c32bc236201271$require$Buffer.isBuffer(buffer)) {
            password = buffer.passphrase;
            buffer = buffer.key;
        }
        if (typeof buffer === 'string') buffer = $a6c32bc236201271$require$Buffer.from(buffer);
        var stripped = $gIBLw(buffer, password);
        var type = stripped.tag;
        var data = stripped.data;
        var subtype, ndata;
        switch(type){
            case 'CERTIFICATE':
                ndata = $6SLbO.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
            case 'PUBLIC KEY':
                if (!ndata) ndata = $6SLbO.PublicKey.decode(data, 'der');
                subtype = ndata.algorithm.algorithm.join('.');
                switch(subtype){
                    case '1.2.840.113549.1.1.1':
                        return $6SLbO.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                    case '1.2.840.10045.2.1':
                        ndata.subjectPrivateKey = ndata.subjectPublicKey;
                        return {
                            type: 'ec',
                            data: ndata
                        };
                    case '1.2.840.10040.4.1':
                        ndata.algorithm.params.pub_key = $6SLbO.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                        return {
                            type: 'dsa',
                            data: ndata.algorithm.params
                        };
                    default:
                        throw new Error('unknown key id ' + subtype);
                }
            case 'ENCRYPTED PRIVATE KEY':
                data = $6SLbO.EncryptedPrivateKey.decode(data, 'der');
                data = $a6c32bc236201271$var$decrypt(data, password);
            case 'PRIVATE KEY':
                ndata = $6SLbO.PrivateKey.decode(data, 'der');
                subtype = ndata.algorithm.algorithm.join('.');
                switch(subtype){
                    case '1.2.840.113549.1.1.1':
                        return $6SLbO.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                    case '1.2.840.10045.2.1':
                        return {
                            curve: ndata.algorithm.curve,
                            privateKey: $6SLbO.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                        };
                    case '1.2.840.10040.4.1':
                        ndata.algorithm.params.priv_key = $6SLbO.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                        return {
                            type: 'dsa',
                            params: ndata.algorithm.params
                        };
                    default:
                        throw new Error('unknown key id ' + subtype);
                }
            case 'RSA PUBLIC KEY':
                return $6SLbO.RSAPublicKey.decode(data, 'der');
            case 'RSA PRIVATE KEY':
                return $6SLbO.RSAPrivateKey.decode(data, 'der');
            case 'DSA PRIVATE KEY':
                return {
                    type: 'dsa',
                    params: $6SLbO.DSAPrivateKey.decode(data, 'der')
                };
            case 'EC PRIVATE KEY':
                data = $6SLbO.ECPrivateKey.decode(data, 'der');
                return {
                    curve: data.parameters.value,
                    privateKey: data.privateKey
                };
            default:
                throw new Error('unknown key type ' + type);
        }
    }
    $a6c32bc236201271$var$parseKeys.signature = $6SLbO.signature;
    module.exports = $a6c32bc236201271$var$parseKeys;
});
parcelRegister("6SLbO", function(module, exports) {
    $parcel$export(module.exports, "certificate", ()=>$502c641ac9e0adc8$export$c98397a6eb8d0678, (v)=>$502c641ac9e0adc8$export$c98397a6eb8d0678 = v);
    $parcel$export(module.exports, "RSAPrivateKey", ()=>$502c641ac9e0adc8$export$f4aab6816f64fa6b, (v)=>$502c641ac9e0adc8$export$f4aab6816f64fa6b = v);
    $parcel$export(module.exports, "RSAPublicKey", ()=>$502c641ac9e0adc8$export$4471f5c65d097c11, (v)=>$502c641ac9e0adc8$export$4471f5c65d097c11 = v);
    $parcel$export(module.exports, "PublicKey", ()=>$502c641ac9e0adc8$export$ca8b6604d6ce14de, (v)=>$502c641ac9e0adc8$export$ca8b6604d6ce14de = v);
    $parcel$export(module.exports, "PrivateKey", ()=>$502c641ac9e0adc8$export$8f54525b330fd87b, (v)=>$502c641ac9e0adc8$export$8f54525b330fd87b = v);
    $parcel$export(module.exports, "EncryptedPrivateKey", ()=>$502c641ac9e0adc8$export$23cd2842b44ca3e7, (v)=>$502c641ac9e0adc8$export$23cd2842b44ca3e7 = v);
    $parcel$export(module.exports, "DSAPrivateKey", ()=>$502c641ac9e0adc8$export$245c9aaa9f5ce4ce, (v)=>$502c641ac9e0adc8$export$245c9aaa9f5ce4ce = v);
    $parcel$export(module.exports, "DSAparam", ()=>$502c641ac9e0adc8$export$8ad762e3e6399afe, (v)=>$502c641ac9e0adc8$export$8ad762e3e6399afe = v);
    $parcel$export(module.exports, "ECPrivateKey", ()=>$502c641ac9e0adc8$export$32ef6f92e22c6ab0, (v)=>$502c641ac9e0adc8$export$32ef6f92e22c6ab0 = v);
    $parcel$export(module.exports, "signature", ()=>$502c641ac9e0adc8$export$c9cd164b539ebb63, (v)=>$502c641ac9e0adc8$export$c9cd164b539ebb63 = v);
    var $502c641ac9e0adc8$export$c98397a6eb8d0678;
    var $502c641ac9e0adc8$export$f4aab6816f64fa6b;
    var $502c641ac9e0adc8$export$4471f5c65d097c11;
    var $502c641ac9e0adc8$export$ca8b6604d6ce14de;
    var $502c641ac9e0adc8$export$8f54525b330fd87b;
    var $502c641ac9e0adc8$export$23cd2842b44ca3e7;
    var $502c641ac9e0adc8$export$245c9aaa9f5ce4ce;
    var $502c641ac9e0adc8$export$8ad762e3e6399afe;
    var $502c641ac9e0adc8$export$32ef6f92e22c6ab0;
    var $502c641ac9e0adc8$export$c9cd164b539ebb63;
    'use strict';
    var $4YrAW = parcelRequire("4YrAW");
    $502c641ac9e0adc8$export$c98397a6eb8d0678 = (parcelRequire("eqV2A"));
    var $502c641ac9e0adc8$var$RSAPrivateKey = $4YrAW.define('RSAPrivateKey', function() {
        this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
    });
    $502c641ac9e0adc8$export$f4aab6816f64fa6b = $502c641ac9e0adc8$var$RSAPrivateKey;
    var $502c641ac9e0adc8$var$RSAPublicKey = $4YrAW.define('RSAPublicKey', function() {
        this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
    });
    $502c641ac9e0adc8$export$4471f5c65d097c11 = $502c641ac9e0adc8$var$RSAPublicKey;
    var $502c641ac9e0adc8$var$AlgorithmIdentifier = $4YrAW.define('AlgorithmIdentifier', function() {
        this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
    });
    var $502c641ac9e0adc8$var$PublicKey = $4YrAW.define('SubjectPublicKeyInfo', function() {
        this.seq().obj(this.key('algorithm').use($502c641ac9e0adc8$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
    });
    $502c641ac9e0adc8$export$ca8b6604d6ce14de = $502c641ac9e0adc8$var$PublicKey;
    var $502c641ac9e0adc8$var$PrivateKeyInfo = $4YrAW.define('PrivateKeyInfo', function() {
        this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($502c641ac9e0adc8$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
    });
    $502c641ac9e0adc8$export$8f54525b330fd87b = $502c641ac9e0adc8$var$PrivateKeyInfo;
    var $502c641ac9e0adc8$var$EncryptedPrivateKeyInfo = $4YrAW.define('EncryptedPrivateKeyInfo', function() {
        this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
    });
    $502c641ac9e0adc8$export$23cd2842b44ca3e7 = $502c641ac9e0adc8$var$EncryptedPrivateKeyInfo;
    var $502c641ac9e0adc8$var$DSAPrivateKey = $4YrAW.define('DSAPrivateKey', function() {
        this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
    });
    $502c641ac9e0adc8$export$245c9aaa9f5ce4ce = $502c641ac9e0adc8$var$DSAPrivateKey;
    $502c641ac9e0adc8$export$8ad762e3e6399afe = $4YrAW.define('DSAparam', function() {
        this['int']();
    });
    var $502c641ac9e0adc8$var$ECParameters = $4YrAW.define('ECParameters', function() {
        this.choice({
            namedCurve: this.objid()
        });
    });
    var $502c641ac9e0adc8$var$ECPrivateKey = $4YrAW.define('ECPrivateKey', function() {
        this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($502c641ac9e0adc8$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
    });
    $502c641ac9e0adc8$export$32ef6f92e22c6ab0 = $502c641ac9e0adc8$var$ECPrivateKey;
    $502c641ac9e0adc8$export$c9cd164b539ebb63 = $4YrAW.define('signature', function() {
        this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
    });
});
parcelRegister("4YrAW", function(module, exports) {
    var $39f22bc6452e58d0$var$asn1 = module.exports;
    $39f22bc6452e58d0$var$asn1.bignum = (parcelRequire("9pbIC"));
    $39f22bc6452e58d0$var$asn1.define = (parcelRequire("ceLSt")).define;
    $39f22bc6452e58d0$var$asn1.base = (parcelRequire("7pROP"));
    $39f22bc6452e58d0$var$asn1.constants = (parcelRequire("9Gn7M"));
    $39f22bc6452e58d0$var$asn1.decoders = (parcelRequire("jgiMU"));
    $39f22bc6452e58d0$var$asn1.encoders = (parcelRequire("4mVZW"));
});
parcelRegister("ceLSt", function(module, exports) {
    var $4YrAW = parcelRequire("4YrAW");
    var $v3bBu = parcelRequire("v3bBu");
    var $8e8bee50c1965a65$var$api = module.exports;
    $8e8bee50c1965a65$var$api.define = function define(name, body) {
        return new $8e8bee50c1965a65$var$Entity(name, body);
    };
    function $8e8bee50c1965a65$var$Entity(name, body) {
        this.name = name;
        this.body = body;
        this.decoders = {};
        this.encoders = {};
    }
    $8e8bee50c1965a65$var$Entity.prototype._createNamed = function createNamed(base) {
        var named;
        try {
            named = (parcelRequire("203s9")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
        } catch (e) {
            named = function(entity) {
                this._initNamed(entity);
            };
        }
        $v3bBu(named, base);
        named.prototype._initNamed = function initnamed(entity) {
            base.call(this, entity);
        };
        return new named(this);
    };
    $8e8bee50c1965a65$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
        enc = enc || 'der';
        if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($4YrAW.decoders[enc]);
        return this.decoders[enc];
    };
    $8e8bee50c1965a65$var$Entity.prototype.decode = function decode(data, enc, options) {
        return this._getDecoder(enc).decode(data, options);
    };
    $8e8bee50c1965a65$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
        enc = enc || 'der';
        if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($4YrAW.encoders[enc]);
        return this.encoders[enc];
    };
    $8e8bee50c1965a65$var$Entity.prototype.encode = function encode(data, enc, reporter) {
        return this._getEncoder(enc).encode(data, reporter);
    };
});
parcelRegister("203s9", function(module, exports) {
    var indexOf = function(xs, item) {
        if (xs.indexOf) return xs.indexOf(item);
        else for(var i = 0; i < xs.length; i++){
            if (xs[i] === item) return i;
        }
        return -1;
    };
    var Object_keys = function(obj) {
        if (Object.keys) return Object.keys(obj);
        else {
            var res = [];
            for(var key in obj)res.push(key);
            return res;
        }
    };
    var forEach = function(xs, fn) {
        if (xs.forEach) return xs.forEach(fn);
        else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
    };
    var defineProp = function() {
        try {
            Object.defineProperty({}, '_', {});
            return function(obj, name, value) {
                Object.defineProperty(obj, name, {
                    writable: true,
                    enumerable: false,
                    configurable: true,
                    value: value
                });
            };
        } catch (e) {
            return function(obj, name, value) {
                obj[name] = value;
            };
        }
    }();
    var globals = [
        'Array',
        'Boolean',
        'Date',
        'Error',
        'EvalError',
        'Function',
        'Infinity',
        'JSON',
        'Math',
        'NaN',
        'Number',
        'Object',
        'RangeError',
        'ReferenceError',
        'RegExp',
        'String',
        'SyntaxError',
        'TypeError',
        'URIError',
        'decodeURI',
        'decodeURIComponent',
        'encodeURI',
        'encodeURIComponent',
        'escape',
        'eval',
        'isFinite',
        'isNaN',
        'parseFloat',
        'parseInt',
        'undefined',
        'unescape'
    ];
    function Context() {}
    Context.prototype = {};
    var Script = exports.Script = function NodeScript(code) {
        if (!(this instanceof Script)) return new Script(code);
        this.code = code;
    };
    Script.prototype.runInContext = function(context) {
        if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
        var iframe = document.createElement('iframe');
        if (!iframe.style) iframe.style = {};
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        var win = iframe.contentWindow;
        var wEval = win.eval, wExecScript = win.execScript;
        if (!wEval && wExecScript) {
            wExecScript.call(win, 'null');
            wEval = win.eval;
        }
        forEach(Object_keys(context), function(key) {
            win[key] = context[key];
        });
        forEach(globals, function(key) {
            if (context[key]) win[key] = context[key];
        });
        var winKeys = Object_keys(win);
        var res = wEval.call(win, this.code);
        forEach(Object_keys(win), function(key) {
            if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
        });
        forEach(globals, function(key) {
            if (!(key in context)) defineProp(context, key, win[key]);
        });
        document.body.removeChild(iframe);
        return res;
    };
    Script.prototype.runInThisContext = function() {
        return eval(this.code);
    };
    Script.prototype.runInNewContext = function(context) {
        var ctx = Script.createContext(context);
        var res = this.runInContext(ctx);
        if (context) forEach(Object_keys(ctx), function(key) {
            context[key] = ctx[key];
        });
        return res;
    };
    forEach(Object_keys(Script.prototype), function(name) {
        exports[name] = Script[name] = function(code) {
            var s = Script(code);
            return s[name].apply(s, [].slice.call(arguments, 1));
        };
    });
    exports.isContext = function(context) {
        return context instanceof Context;
    };
    exports.createScript = function(code) {
        return exports.Script(code);
    };
    exports.createContext = Script.createContext = function(context) {
        var copy = new Context();
        if (typeof context === 'object') forEach(Object_keys(context), function(key) {
            copy[key] = context[key];
        });
        return copy;
    };
});
parcelRegister("7pROP", function(module, exports) {
    var $56649d7a438b1476$var$base = module.exports;
    $56649d7a438b1476$var$base.Reporter = (parcelRequire("9Mcka")).Reporter;
    $56649d7a438b1476$var$base.DecoderBuffer = (parcelRequire("8BbkO")).DecoderBuffer;
    $56649d7a438b1476$var$base.EncoderBuffer = (parcelRequire("8BbkO")).EncoderBuffer;
    $56649d7a438b1476$var$base.Node = (parcelRequire("8pyk3"));
});
parcelRegister("9Mcka", function(module, exports) {
    $parcel$export(module.exports, "Reporter", ()=>$71e22815ba47f766$export$957313a2f485e5ed, (v)=>$71e22815ba47f766$export$957313a2f485e5ed = v);
    var $71e22815ba47f766$export$957313a2f485e5ed;
    var $v3bBu = parcelRequire("v3bBu");
    function $71e22815ba47f766$var$Reporter(options) {
        this._reporterState = {
            obj: null,
            path: [],
            options: options || {},
            errors: []
        };
    }
    $71e22815ba47f766$export$957313a2f485e5ed = $71e22815ba47f766$var$Reporter;
    $71e22815ba47f766$var$Reporter.prototype.isError = function isError(obj) {
        return obj instanceof $71e22815ba47f766$var$ReporterError;
    };
    $71e22815ba47f766$var$Reporter.prototype.save = function save() {
        var state = this._reporterState;
        return {
            obj: state.obj,
            pathLen: state.path.length
        };
    };
    $71e22815ba47f766$var$Reporter.prototype.restore = function restore(data) {
        var state = this._reporterState;
        state.obj = data.obj;
        state.path = state.path.slice(0, data.pathLen);
    };
    $71e22815ba47f766$var$Reporter.prototype.enterKey = function enterKey(key) {
        return this._reporterState.path.push(key);
    };
    $71e22815ba47f766$var$Reporter.prototype.exitKey = function exitKey(index) {
        var state = this._reporterState;
        state.path = state.path.slice(0, index - 1);
    };
    $71e22815ba47f766$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
        var state = this._reporterState;
        this.exitKey(index);
        if (state.obj !== null) state.obj[key] = value;
    };
    $71e22815ba47f766$var$Reporter.prototype.path = function path() {
        return this._reporterState.path.join('/');
    };
    $71e22815ba47f766$var$Reporter.prototype.enterObject = function enterObject() {
        var state = this._reporterState;
        var prev = state.obj;
        state.obj = {};
        return prev;
    };
    $71e22815ba47f766$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
        var state = this._reporterState;
        var now = state.obj;
        state.obj = prev;
        return now;
    };
    $71e22815ba47f766$var$Reporter.prototype.error = function error(msg) {
        var err;
        var state = this._reporterState;
        var inherited = msg instanceof $71e22815ba47f766$var$ReporterError;
        if (inherited) err = msg;
        else err = new $71e22815ba47f766$var$ReporterError(state.path.map(function(elem) {
            return '[' + JSON.stringify(elem) + ']';
        }).join(''), msg.message || msg, msg.stack);
        if (!state.options.partial) throw err;
        if (!inherited) state.errors.push(err);
        return err;
    };
    $71e22815ba47f766$var$Reporter.prototype.wrapResult = function wrapResult(result) {
        var state = this._reporterState;
        if (!state.options.partial) return result;
        return {
            result: this.isError(result) ? null : result,
            errors: state.errors
        };
    };
    function $71e22815ba47f766$var$ReporterError(path, msg) {
        this.path = path;
        this.rethrow(msg);
    }
    $v3bBu($71e22815ba47f766$var$ReporterError, Error);
    $71e22815ba47f766$var$ReporterError.prototype.rethrow = function rethrow(msg) {
        this.message = msg + ' at: ' + (this.path || '(shallow)');
        if (Error.captureStackTrace) Error.captureStackTrace(this, $71e22815ba47f766$var$ReporterError);
        if (!this.stack) try {
            throw new Error(this.message);
        } catch (e) {
            this.stack = e.stack;
        }
        return this;
    };
});
parcelRegister("8BbkO", function(module, exports) {
    $parcel$export(module.exports, "DecoderBuffer", ()=>$642a923f98967a64$export$bf9f79cdc4a49163, (v)=>$642a923f98967a64$export$bf9f79cdc4a49163 = v);
    $parcel$export(module.exports, "EncoderBuffer", ()=>$642a923f98967a64$export$8ff24f7760c7a78e, (v)=>$642a923f98967a64$export$8ff24f7760c7a78e = v);
    var $642a923f98967a64$export$bf9f79cdc4a49163;
    var $642a923f98967a64$export$8ff24f7760c7a78e;
    var $v3bBu = parcelRequire("v3bBu");
    var $7pROP = parcelRequire("7pROP");
    var $642a923f98967a64$require$Reporter = $7pROP.Reporter;
    var $5k7LC = parcelRequire("5k7LC");
    var $642a923f98967a64$require$Buffer = $5k7LC.Buffer;
    function $642a923f98967a64$var$DecoderBuffer(base, options) {
        $642a923f98967a64$require$Reporter.call(this, options);
        if (!$642a923f98967a64$require$Buffer.isBuffer(base)) {
            this.error('Input not Buffer');
            return;
        }
        this.base = base;
        this.offset = 0;
        this.length = base.length;
    }
    $v3bBu($642a923f98967a64$var$DecoderBuffer, $642a923f98967a64$require$Reporter);
    $642a923f98967a64$export$bf9f79cdc4a49163 = $642a923f98967a64$var$DecoderBuffer;
    $642a923f98967a64$var$DecoderBuffer.prototype.save = function save() {
        return {
            offset: this.offset,
            reporter: $642a923f98967a64$require$Reporter.prototype.save.call(this)
        };
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.restore = function restore(save) {
        var res = new $642a923f98967a64$var$DecoderBuffer(this.base);
        res.offset = save.offset;
        res.length = this.offset;
        this.offset = save.offset;
        $642a923f98967a64$require$Reporter.prototype.restore.call(this, save.reporter);
        return res;
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
        return this.offset === this.length;
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
        if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
        else return this.error(fail || 'DecoderBuffer overrun');
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
        if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
        var res = new $642a923f98967a64$var$DecoderBuffer(this.base);
        res._reporterState = this._reporterState;
        res.offset = this.offset;
        res.length = this.offset + bytes;
        this.offset += bytes;
        return res;
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.raw = function raw(save) {
        return this.base.slice(save ? save.offset : this.offset, this.length);
    };
    function $642a923f98967a64$var$EncoderBuffer(value, reporter) {
        if (Array.isArray(value)) {
            this.length = 0;
            this.value = value.map(function(item) {
                if (!(item instanceof $642a923f98967a64$var$EncoderBuffer)) item = new $642a923f98967a64$var$EncoderBuffer(item, reporter);
                this.length += item.length;
                return item;
            }, this);
        } else if (typeof value === 'number') {
            if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
            this.value = value;
            this.length = 1;
        } else if (typeof value === 'string') {
            this.value = value;
            this.length = $642a923f98967a64$require$Buffer.byteLength(value);
        } else if ($642a923f98967a64$require$Buffer.isBuffer(value)) {
            this.value = value;
            this.length = value.length;
        } else return reporter.error('Unsupported type: ' + typeof value);
    }
    $642a923f98967a64$export$8ff24f7760c7a78e = $642a923f98967a64$var$EncoderBuffer;
    $642a923f98967a64$var$EncoderBuffer.prototype.join = function join(out, offset) {
        if (!out) out = new $642a923f98967a64$require$Buffer(this.length);
        if (!offset) offset = 0;
        if (this.length === 0) return out;
        if (Array.isArray(this.value)) this.value.forEach(function(item) {
            item.join(out, offset);
            offset += item.length;
        });
        else {
            if (typeof this.value === 'number') out[offset] = this.value;
            else if (typeof this.value === 'string') out.write(this.value, offset);
            else if ($642a923f98967a64$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
            offset += this.length;
        }
        return out;
    };
});
parcelRegister("8pyk3", function(module, exports) {
    var $7pROP = parcelRequire("7pROP");
    var $61fb48423d223fb4$require$Reporter = $7pROP.Reporter;
    var $7pROP = parcelRequire("7pROP");
    var $61fb48423d223fb4$require$EncoderBuffer = $7pROP.EncoderBuffer;
    var $7pROP = parcelRequire("7pROP");
    var $61fb48423d223fb4$require$DecoderBuffer = $7pROP.DecoderBuffer;
    var $gxaFy = parcelRequire("gxaFy");
    var $61fb48423d223fb4$var$tags = [
        'seq',
        'seqof',
        'set',
        'setof',
        'objid',
        'bool',
        'gentime',
        'utctime',
        'null_',
        'enum',
        'int',
        'objDesc',
        'bitstr',
        'bmpstr',
        'charstr',
        'genstr',
        'graphstr',
        'ia5str',
        'iso646str',
        'numstr',
        'octstr',
        'printstr',
        't61str',
        'unistr',
        'utf8str',
        'videostr'
    ];
    var $61fb48423d223fb4$var$methods = [
        'key',
        'obj',
        'use',
        'optional',
        'explicit',
        'implicit',
        'def',
        'choice',
        'any',
        'contains'
    ].concat($61fb48423d223fb4$var$tags);
    var $61fb48423d223fb4$var$overrided = [
        '_peekTag',
        '_decodeTag',
        '_use',
        '_decodeStr',
        '_decodeObjid',
        '_decodeTime',
        '_decodeNull',
        '_decodeInt',
        '_decodeBool',
        '_decodeList',
        '_encodeComposite',
        '_encodeStr',
        '_encodeObjid',
        '_encodeTime',
        '_encodeNull',
        '_encodeInt',
        '_encodeBool'
    ];
    function $61fb48423d223fb4$var$Node(enc, parent) {
        var state = {};
        this._baseState = state;
        state.enc = enc;
        state.parent = parent || null;
        state.children = null;
        state.tag = null;
        state.args = null;
        state.reverseArgs = null;
        state.choice = null;
        state.optional = false;
        state.any = false;
        state.obj = false;
        state.use = null;
        state.useDecoder = null;
        state.key = null;
        state['default'] = null;
        state.explicit = null;
        state.implicit = null;
        state.contains = null;
        if (!state.parent) {
            state.children = [];
            this._wrap();
        }
    }
    module.exports = $61fb48423d223fb4$var$Node;
    var $61fb48423d223fb4$var$stateProps = [
        'enc',
        'parent',
        'children',
        'tag',
        'args',
        'reverseArgs',
        'choice',
        'optional',
        'any',
        'obj',
        'use',
        'alteredUse',
        'key',
        'default',
        'explicit',
        'implicit',
        'contains'
    ];
    $61fb48423d223fb4$var$Node.prototype.clone = function clone() {
        var state = this._baseState;
        var cstate = {};
        $61fb48423d223fb4$var$stateProps.forEach(function(prop) {
            cstate[prop] = state[prop];
        });
        var res = new this.constructor(cstate.parent);
        res._baseState = cstate;
        return res;
    };
    $61fb48423d223fb4$var$Node.prototype._wrap = function wrap() {
        var state = this._baseState;
        $61fb48423d223fb4$var$methods.forEach(function(method) {
            this[method] = function _wrappedMethod() {
                var clone = new this.constructor(this);
                state.children.push(clone);
                return clone[method].apply(clone, arguments);
            };
        }, this);
    };
    $61fb48423d223fb4$var$Node.prototype._init = function init(body) {
        var state = this._baseState;
        $gxaFy(state.parent === null);
        body.call(this);
        state.children = state.children.filter(function(child) {
            return child._baseState.parent === this;
        }, this);
        $gxaFy.equal(state.children.length, 1, 'Root node can have only one child');
    };
    $61fb48423d223fb4$var$Node.prototype._useArgs = function useArgs(args) {
        var state = this._baseState;
        var children = args.filter(function(arg) {
            return arg instanceof this.constructor;
        }, this);
        args = args.filter(function(arg) {
            return !(arg instanceof this.constructor);
        }, this);
        if (children.length !== 0) {
            $gxaFy(state.children === null);
            state.children = children;
            children.forEach(function(child) {
                child._baseState.parent = this;
            }, this);
        }
        if (args.length !== 0) {
            $gxaFy(state.args === null);
            state.args = args;
            state.reverseArgs = args.map(function(arg) {
                if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
                var res = {};
                Object.keys(arg).forEach(function(key) {
                    if (key == (key | 0)) key |= 0;
                    var value = arg[key];
                    res[value] = key;
                });
                return res;
            });
        }
    };
    $61fb48423d223fb4$var$overrided.forEach(function(method) {
        $61fb48423d223fb4$var$Node.prototype[method] = function _overrided() {
            var state = this._baseState;
            throw new Error(method + ' not implemented for encoding: ' + state.enc);
        };
    });
    $61fb48423d223fb4$var$tags.forEach(function(tag) {
        $61fb48423d223fb4$var$Node.prototype[tag] = function _tagMethod() {
            var state = this._baseState;
            var args = Array.prototype.slice.call(arguments);
            $gxaFy(state.tag === null);
            state.tag = tag;
            this._useArgs(args);
            return this;
        };
    });
    $61fb48423d223fb4$var$Node.prototype.use = function use(item) {
        $gxaFy(item);
        var state = this._baseState;
        $gxaFy(state.use === null);
        state.use = item;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.optional = function optional() {
        var state = this._baseState;
        state.optional = true;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.def = function def(val) {
        var state = this._baseState;
        $gxaFy(state['default'] === null);
        state['default'] = val;
        state.optional = true;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.explicit = function explicit(num) {
        var state = this._baseState;
        $gxaFy(state.explicit === null && state.implicit === null);
        state.explicit = num;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.implicit = function implicit(num) {
        var state = this._baseState;
        $gxaFy(state.explicit === null && state.implicit === null);
        state.implicit = num;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.obj = function obj() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        state.obj = true;
        if (args.length !== 0) this._useArgs(args);
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.key = function key(newKey) {
        var state = this._baseState;
        $gxaFy(state.key === null);
        state.key = newKey;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.any = function any() {
        var state = this._baseState;
        state.any = true;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.choice = function choice(obj) {
        var state = this._baseState;
        $gxaFy(state.choice === null);
        state.choice = obj;
        this._useArgs(Object.keys(obj).map(function(key) {
            return obj[key];
        }));
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.contains = function contains(item) {
        var state = this._baseState;
        $gxaFy(state.use === null);
        state.contains = item;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype._decode = function decode(input, options) {
        var state = this._baseState;
        if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
        var result = state['default'];
        var present = true;
        var prevKey = null;
        if (state.key !== null) prevKey = input.enterKey(state.key);
        if (state.optional) {
            var tag = null;
            if (state.explicit !== null) tag = state.explicit;
            else if (state.implicit !== null) tag = state.implicit;
            else if (state.tag !== null) tag = state.tag;
            if (tag === null && !state.any) {
                var save = input.save();
                try {
                    if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                    else this._decodeChoice(input, options);
                    present = true;
                } catch (e) {
                    present = false;
                }
                input.restore(save);
            } else {
                present = this._peekTag(input, tag, state.any);
                if (input.isError(present)) return present;
            }
        }
        var prevObj;
        if (state.obj && present) prevObj = input.enterObject();
        if (present) {
            if (state.explicit !== null) {
                var explicit = this._decodeTag(input, state.explicit);
                if (input.isError(explicit)) return explicit;
                input = explicit;
            }
            var start = input.offset;
            if (state.use === null && state.choice === null) {
                if (state.any) var save = input.save();
                var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
                if (input.isError(body)) return body;
                if (state.any) result = input.raw(save);
                else input = body;
            }
            if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
            if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
            if (state.any) result;
            else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
            else result = this._decodeChoice(input, options);
            if (input.isError(result)) return result;
            if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
                child._decode(input, options);
            });
            if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
                var data = new $61fb48423d223fb4$require$DecoderBuffer(result);
                result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
            }
        }
        if (state.obj && present) result = input.leaveObject(prevObj);
        if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
        else if (prevKey !== null) input.exitKey(prevKey);
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
        var state = this._baseState;
        if (tag === 'seq' || tag === 'set') return null;
        if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
        else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
        else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
        else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
        else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
        else if (tag === 'null_') return this._decodeNull(input, options);
        else if (tag === 'bool') return this._decodeBool(input, options);
        else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
        else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
        if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
        else return input.error('unknown tag: ' + tag);
    };
    $61fb48423d223fb4$var$Node.prototype._getUse = function _getUse(entity, obj) {
        var state = this._baseState;
        state.useDecoder = this._use(entity, obj);
        $gxaFy(state.useDecoder._baseState.parent === null);
        state.useDecoder = state.useDecoder._baseState.children[0];
        if (state.implicit !== state.useDecoder._baseState.implicit) {
            state.useDecoder = state.useDecoder.clone();
            state.useDecoder._baseState.implicit = state.implicit;
        }
        return state.useDecoder;
    };
    $61fb48423d223fb4$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
        var state = this._baseState;
        var result = null;
        var match = false;
        Object.keys(state.choice).some(function(key) {
            var save = input.save();
            var node = state.choice[key];
            try {
                var value = node._decode(input, options);
                if (input.isError(value)) return false;
                result = {
                    type: key,
                    value: value
                };
                match = true;
            } catch (e) {
                input.restore(save);
                return false;
            }
            return true;
        }, this);
        if (!match) return input.error('Choice not matched');
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
        return new $61fb48423d223fb4$require$EncoderBuffer(data, this.reporter);
    };
    $61fb48423d223fb4$var$Node.prototype._encode = function encode(data, reporter, parent) {
        var state = this._baseState;
        if (state['default'] !== null && state['default'] === data) return;
        var result = this._encodeValue(data, reporter, parent);
        if (result === undefined) return;
        if (this._skipDefault(result, reporter, parent)) return;
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
        var state = this._baseState;
        if (state.parent === null) return state.children[0]._encode(data, reporter || new $61fb48423d223fb4$require$Reporter());
        var result = null;
        this.reporter = reporter;
        if (state.optional && data === undefined) {
            if (state['default'] !== null) data = state['default'];
            else return;
        }
        var content = null;
        var primitive = false;
        if (state.any) result = this._createEncoderBuffer(data);
        else if (state.choice) result = this._encodeChoice(data, reporter);
        else if (state.contains) {
            content = this._getUse(state.contains, parent)._encode(data, reporter);
            primitive = true;
        } else if (state.children) {
            content = state.children.map(function(child) {
                if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
                if (child._baseState.key === null) return reporter.error('Child should have a key');
                var prevKey = reporter.enterKey(child._baseState.key);
                if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
                var res = child._encode(data[child._baseState.key], reporter, data);
                reporter.leaveKey(prevKey);
                return res;
            }, this).filter(function(child) {
                return child;
            });
            content = this._createEncoderBuffer(content);
        } else {
            if (state.tag === 'seqof' || state.tag === 'setof') {
                if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
                if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
                var child = this.clone();
                child._baseState.implicit = null;
                content = this._createEncoderBuffer(data.map(function(item) {
                    var state = this._baseState;
                    return this._getUse(state.args[0], data)._encode(item, reporter);
                }, child));
            } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
            else {
                content = this._encodePrimitive(state.tag, data);
                primitive = true;
            }
        }
        var result;
        if (!state.any && state.choice === null) {
            var tag = state.implicit !== null ? state.implicit : state.tag;
            var cls = state.implicit === null ? 'universal' : 'context';
            if (tag === null) {
                if (state.use === null) reporter.error('Tag could be omitted only for .use()');
            } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
        }
        if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
        var state = this._baseState;
        var node = state.choice[data.type];
        if (!node) $gxaFy(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
        return node._encode(data.value, reporter);
    };
    $61fb48423d223fb4$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
        var state = this._baseState;
        if (/str$/.test(tag)) return this._encodeStr(data, tag);
        else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
        else if (tag === 'objid') return this._encodeObjid(data, null, null);
        else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
        else if (tag === 'null_') return this._encodeNull();
        else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
        else if (tag === 'bool') return this._encodeBool(data);
        else if (tag === 'objDesc') return this._encodeStr(data, tag);
        else throw new Error('Unsupported tag: ' + tag);
    };
    $61fb48423d223fb4$var$Node.prototype._isNumstr = function isNumstr(str) {
        return /^[0-9 ]*$/.test(str);
    };
    $61fb48423d223fb4$var$Node.prototype._isPrintstr = function isPrintstr(str) {
        return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
    };
});
parcelRegister("9Gn7M", function(module, exports) {
    var $70c9f95905a88f58$var$constants = module.exports;
    $70c9f95905a88f58$var$constants._reverse = function reverse(map) {
        var res = {};
        Object.keys(map).forEach(function(key) {
            if ((key | 0) == key) key = key | 0;
            var value = map[key];
            res[value] = key;
        });
        return res;
    };
    $70c9f95905a88f58$var$constants.der = (parcelRequire("lpBh5"));
});
parcelRegister("lpBh5", function(module, exports) {
    $parcel$export(module.exports, "tagClass", ()=>$f968d8c070be10cd$export$3584c46ed60baee8, (v)=>$f968d8c070be10cd$export$3584c46ed60baee8 = v);
    $parcel$export(module.exports, "tagClassByName", ()=>$f968d8c070be10cd$export$f18596ef8d632e49, (v)=>$f968d8c070be10cd$export$f18596ef8d632e49 = v);
    $parcel$export(module.exports, "tag", ()=>$f968d8c070be10cd$export$2b067c6666111485, (v)=>$f968d8c070be10cd$export$2b067c6666111485 = v);
    $parcel$export(module.exports, "tagByName", ()=>$f968d8c070be10cd$export$f17df38a421ab9e3, (v)=>$f968d8c070be10cd$export$f17df38a421ab9e3 = v);
    var $f968d8c070be10cd$export$3584c46ed60baee8;
    var $f968d8c070be10cd$export$f18596ef8d632e49;
    var $f968d8c070be10cd$export$2b067c6666111485;
    var $f968d8c070be10cd$export$f17df38a421ab9e3;
    var $9Gn7M = parcelRequire("9Gn7M");
    $f968d8c070be10cd$export$3584c46ed60baee8 = {
        0: 'universal',
        1: 'application',
        2: 'context',
        3: 'private'
    };
    $f968d8c070be10cd$export$f18596ef8d632e49 = $9Gn7M._reverse($f968d8c070be10cd$export$3584c46ed60baee8);
    $f968d8c070be10cd$export$2b067c6666111485 = {
        0x00: 'end',
        0x01: 'bool',
        0x02: 'int',
        0x03: 'bitstr',
        0x04: 'octstr',
        0x05: 'null_',
        0x06: 'objid',
        0x07: 'objDesc',
        0x08: 'external',
        0x09: 'real',
        0x0a: 'enum',
        0x0b: 'embed',
        0x0c: 'utf8str',
        0x0d: 'relativeOid',
        0x10: 'seq',
        0x11: 'set',
        0x12: 'numstr',
        0x13: 'printstr',
        0x14: 't61str',
        0x15: 'videostr',
        0x16: 'ia5str',
        0x17: 'utctime',
        0x18: 'gentime',
        0x19: 'graphstr',
        0x1a: 'iso646str',
        0x1b: 'genstr',
        0x1c: 'unistr',
        0x1d: 'charstr',
        0x1e: 'bmpstr'
    };
    $f968d8c070be10cd$export$f17df38a421ab9e3 = $9Gn7M._reverse($f968d8c070be10cd$export$2b067c6666111485);
});
parcelRegister("jgiMU", function(module, exports) {
    var $e05e15d54de3c556$var$decoders = module.exports;
    $e05e15d54de3c556$var$decoders.der = (parcelRequire("hhhbu"));
    $e05e15d54de3c556$var$decoders.pem = (parcelRequire("bSW3A"));
});
parcelRegister("hhhbu", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $4YrAW = parcelRequire("4YrAW");
    var $c9415aa2b27c8979$var$base = $4YrAW.base;
    var $c9415aa2b27c8979$var$bignum = $4YrAW.bignum;
    var $c9415aa2b27c8979$var$der = $4YrAW.constants.der;
    function $c9415aa2b27c8979$var$DERDecoder(entity) {
        this.enc = 'der';
        this.name = entity.name;
        this.entity = entity;
        this.tree = new $c9415aa2b27c8979$var$DERNode();
        this.tree._init(entity.body);
    }
    module.exports = $c9415aa2b27c8979$var$DERDecoder;
    $c9415aa2b27c8979$var$DERDecoder.prototype.decode = function decode(data, options) {
        if (!(data instanceof $c9415aa2b27c8979$var$base.DecoderBuffer)) data = new $c9415aa2b27c8979$var$base.DecoderBuffer(data, options);
        return this.tree._decode(data, options);
    };
    function $c9415aa2b27c8979$var$DERNode(parent) {
        $c9415aa2b27c8979$var$base.Node.call(this, 'der', parent);
    }
    $v3bBu($c9415aa2b27c8979$var$DERNode, $c9415aa2b27c8979$var$base.Node);
    $c9415aa2b27c8979$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
        if (buffer.isEmpty()) return false;
        var state = buffer.save();
        var decodedTag = $c9415aa2b27c8979$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
        if (buffer.isError(decodedTag)) return decodedTag;
        buffer.restore(state);
        return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
        var decodedTag = $c9415aa2b27c8979$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
        if (buffer.isError(decodedTag)) return decodedTag;
        var len = $c9415aa2b27c8979$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
        if (buffer.isError(len)) return len;
        if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
        if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
        var state = buffer.save();
        var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
        if (buffer.isError(res)) return res;
        len = buffer.offset - state.offset;
        buffer.restore(state);
        return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    };
    $c9415aa2b27c8979$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
        while(true){
            var tag = $c9415aa2b27c8979$var$derDecodeTag(buffer, fail);
            if (buffer.isError(tag)) return tag;
            var len = $c9415aa2b27c8979$var$derDecodeLen(buffer, tag.primitive, fail);
            if (buffer.isError(len)) return len;
            var res;
            if (tag.primitive || len !== null) res = buffer.skip(len);
            else res = this._skipUntilEnd(buffer, fail);
            if (buffer.isError(res)) return res;
            if (tag.tagStr === 'end') break;
        }
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
        var result = [];
        while(!buffer.isEmpty()){
            var possibleEnd = this._peekTag(buffer, 'end');
            if (buffer.isError(possibleEnd)) return possibleEnd;
            var res = decoder.decode(buffer, 'der', options);
            if (buffer.isError(res) && possibleEnd) break;
            result.push(res);
        }
        return result;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
        if (tag === 'bitstr') {
            var unused = buffer.readUInt8();
            if (buffer.isError(unused)) return unused;
            return {
                unused: unused,
                data: buffer.raw()
            };
        } else if (tag === 'bmpstr') {
            var raw = buffer.raw();
            if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
            var str = '';
            for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
            return str;
        } else if (tag === 'numstr') {
            var numstr = buffer.raw().toString('ascii');
            if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
            return numstr;
        } else if (tag === 'octstr') return buffer.raw();
        else if (tag === 'objDesc') return buffer.raw();
        else if (tag === 'printstr') {
            var printstr = buffer.raw().toString('ascii');
            if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
            return printstr;
        } else if (/str$/.test(tag)) return buffer.raw().toString();
        else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
        var result;
        var identifiers = [];
        var ident = 0;
        while(!buffer.isEmpty()){
            var subident = buffer.readUInt8();
            ident <<= 7;
            ident |= subident & 0x7f;
            if ((subident & 0x80) === 0) {
                identifiers.push(ident);
                ident = 0;
            }
        }
        if (subident & 0x80) identifiers.push(ident);
        var first = identifiers[0] / 40 | 0;
        var second = identifiers[0] % 40;
        if (relative) result = identifiers;
        else result = [
            first,
            second
        ].concat(identifiers.slice(1));
        if (values) {
            var tmp = values[result.join(' ')];
            if (tmp === undefined) tmp = values[result.join('.')];
            if (tmp !== undefined) result = tmp;
        }
        return result;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
        var str = buffer.raw().toString();
        if (tag === 'gentime') {
            var year = str.slice(0, 4) | 0;
            var mon = str.slice(4, 6) | 0;
            var day = str.slice(6, 8) | 0;
            var hour = str.slice(8, 10) | 0;
            var min = str.slice(10, 12) | 0;
            var sec = str.slice(12, 14) | 0;
        } else if (tag === 'utctime') {
            var year = str.slice(0, 2) | 0;
            var mon = str.slice(2, 4) | 0;
            var day = str.slice(4, 6) | 0;
            var hour = str.slice(6, 8) | 0;
            var min = str.slice(8, 10) | 0;
            var sec = str.slice(10, 12) | 0;
            if (year < 70) year = 2000 + year;
            else year = 1900 + year;
        } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
        return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
        return null;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
        var res = buffer.readUInt8();
        if (buffer.isError(res)) return res;
        else return res !== 0;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
        var raw = buffer.raw();
        var res = new $c9415aa2b27c8979$var$bignum(raw);
        if (values) res = values[res.toString(10)] || res;
        return res;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._use = function use(entity, obj) {
        if (typeof entity === 'function') entity = entity(obj);
        return entity._getDecoder('der').tree;
    };
    function $c9415aa2b27c8979$var$derDecodeTag(buf, fail) {
        var tag = buf.readUInt8(fail);
        if (buf.isError(tag)) return tag;
        var cls = $c9415aa2b27c8979$var$der.tagClass[tag >> 6];
        var primitive = (tag & 0x20) === 0;
        if ((tag & 0x1f) === 0x1f) {
            var oct = tag;
            tag = 0;
            while((oct & 0x80) === 0x80){
                oct = buf.readUInt8(fail);
                if (buf.isError(oct)) return oct;
                tag <<= 7;
                tag |= oct & 0x7f;
            }
        } else tag &= 0x1f;
        var tagStr = $c9415aa2b27c8979$var$der.tag[tag];
        return {
            cls: cls,
            primitive: primitive,
            tag: tag,
            tagStr: tagStr
        };
    }
    function $c9415aa2b27c8979$var$derDecodeLen(buf, primitive, fail) {
        var len = buf.readUInt8(fail);
        if (buf.isError(len)) return len;
        if (!primitive && len === 0x80) return null;
        if ((len & 0x80) === 0) return len;
        var num = len & 0x7f;
        if (num > 4) return buf.error('length octect is too long');
        len = 0;
        for(var i = 0; i < num; i++){
            len <<= 8;
            var j = buf.readUInt8(fail);
            if (buf.isError(j)) return j;
            len |= j;
        }
        return len;
    }
});
parcelRegister("bSW3A", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $5k7LC = parcelRequire("5k7LC");
    var $8a71c5b853c3ea19$require$Buffer = $5k7LC.Buffer;
    var $hhhbu = parcelRequire("hhhbu");
    function $8a71c5b853c3ea19$var$PEMDecoder(entity) {
        $hhhbu.call(this, entity);
        this.enc = 'pem';
    }
    $v3bBu($8a71c5b853c3ea19$var$PEMDecoder, $hhhbu);
    module.exports = $8a71c5b853c3ea19$var$PEMDecoder;
    $8a71c5b853c3ea19$var$PEMDecoder.prototype.decode = function decode(data, options) {
        var lines = data.toString().split(/[\r\n]+/g);
        var label = options.label.toUpperCase();
        var re = /^-----(BEGIN|END) ([^-]+)-----$/;
        var start = -1;
        var end = -1;
        for(var i = 0; i < lines.length; i++){
            var match = lines[i].match(re);
            if (match === null) continue;
            if (match[2] !== label) continue;
            if (start === -1) {
                if (match[1] !== 'BEGIN') break;
                start = i;
            } else {
                if (match[1] !== 'END') break;
                end = i;
                break;
            }
        }
        if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
        var base64 = lines.slice(start + 1, end).join('');
        base64.replace(/[^a-z0-9\+\/=]+/gi, '');
        var input = new $8a71c5b853c3ea19$require$Buffer(base64, 'base64');
        return $hhhbu.prototype.decode.call(this, input, options);
    };
});
parcelRegister("4mVZW", function(module, exports) {
    var $32e634ba5c9f5903$var$encoders = module.exports;
    $32e634ba5c9f5903$var$encoders.der = (parcelRequire("7TTIj"));
    $32e634ba5c9f5903$var$encoders.pem = (parcelRequire("6IIig"));
});
parcelRegister("7TTIj", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $5k7LC = parcelRequire("5k7LC");
    var $5c08e30abebc6b49$require$Buffer = $5k7LC.Buffer;
    var $4YrAW = parcelRequire("4YrAW");
    var $5c08e30abebc6b49$var$base = $4YrAW.base;
    var $5c08e30abebc6b49$var$der = $4YrAW.constants.der;
    function $5c08e30abebc6b49$var$DEREncoder(entity) {
        this.enc = 'der';
        this.name = entity.name;
        this.entity = entity;
        this.tree = new $5c08e30abebc6b49$var$DERNode();
        this.tree._init(entity.body);
    }
    module.exports = $5c08e30abebc6b49$var$DEREncoder;
    $5c08e30abebc6b49$var$DEREncoder.prototype.encode = function encode(data, reporter) {
        return this.tree._encode(data, reporter).join();
    };
    function $5c08e30abebc6b49$var$DERNode(parent) {
        $5c08e30abebc6b49$var$base.Node.call(this, 'der', parent);
    }
    $v3bBu($5c08e30abebc6b49$var$DERNode, $5c08e30abebc6b49$var$base.Node);
    $5c08e30abebc6b49$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
        var encodedTag = $5c08e30abebc6b49$var$encodeTag(tag, primitive, cls, this.reporter);
        if (content.length < 0x80) {
            var header = new $5c08e30abebc6b49$require$Buffer(2);
            header[0] = encodedTag;
            header[1] = content.length;
            return this._createEncoderBuffer([
                header,
                content
            ]);
        }
        var lenOctets = 1;
        for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
        var header = new $5c08e30abebc6b49$require$Buffer(2 + lenOctets);
        header[0] = encodedTag;
        header[1] = 0x80 | lenOctets;
        for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
        if (tag === 'bitstr') return this._createEncoderBuffer([
            str.unused | 0,
            str.data
        ]);
        else if (tag === 'bmpstr') {
            var buf = new $5c08e30abebc6b49$require$Buffer(str.length * 2);
            for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
            return this._createEncoderBuffer(buf);
        } else if (tag === 'numstr') {
            if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
            return this._createEncoderBuffer(str);
        } else if (tag === 'printstr') {
            if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
            return this._createEncoderBuffer(str);
        } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
        else if (tag === 'objDesc') return this._createEncoderBuffer(str);
        else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
        if (typeof id === 'string') {
            if (!values) return this.reporter.error('string objid given, but no values map found');
            if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
            id = values[id].split(/[\s\.]+/g);
            for(var i = 0; i < id.length; i++)id[i] |= 0;
        } else if (Array.isArray(id)) {
            id = id.slice();
            for(var i = 0; i < id.length; i++)id[i] |= 0;
        }
        if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
        if (!relative) {
            if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
            id.splice(0, 2, id[0] * 40 + id[1]);
        }
        var size = 0;
        for(var i = 0; i < id.length; i++){
            var ident = id[i];
            for(size++; ident >= 0x80; ident >>= 7)size++;
        }
        var objid = new $5c08e30abebc6b49$require$Buffer(size);
        var offset = objid.length - 1;
        for(var i = id.length - 1; i >= 0; i--){
            var ident = id[i];
            objid[offset--] = ident & 0x7f;
            while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
        }
        return this._createEncoderBuffer(objid);
    };
    function $5c08e30abebc6b49$var$two(num) {
        if (num < 10) return '0' + num;
        else return num;
    }
    $5c08e30abebc6b49$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
        var str;
        var date = new Date(time);
        if (tag === 'gentime') str = [
            $5c08e30abebc6b49$var$two(date.getFullYear()),
            $5c08e30abebc6b49$var$two(date.getUTCMonth() + 1),
            $5c08e30abebc6b49$var$two(date.getUTCDate()),
            $5c08e30abebc6b49$var$two(date.getUTCHours()),
            $5c08e30abebc6b49$var$two(date.getUTCMinutes()),
            $5c08e30abebc6b49$var$two(date.getUTCSeconds()),
            'Z'
        ].join('');
        else if (tag === 'utctime') str = [
            $5c08e30abebc6b49$var$two(date.getFullYear() % 100),
            $5c08e30abebc6b49$var$two(date.getUTCMonth() + 1),
            $5c08e30abebc6b49$var$two(date.getUTCDate()),
            $5c08e30abebc6b49$var$two(date.getUTCHours()),
            $5c08e30abebc6b49$var$two(date.getUTCMinutes()),
            $5c08e30abebc6b49$var$two(date.getUTCSeconds()),
            'Z'
        ].join('');
        else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
        return this._encodeStr(str, 'octstr');
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeNull = function encodeNull() {
        return this._createEncoderBuffer('');
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
        if (typeof num === 'string') {
            if (!values) return this.reporter.error('String int or enum given, but no values map');
            if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
            num = values[num];
        }
        if (typeof num !== 'number' && !$5c08e30abebc6b49$require$Buffer.isBuffer(num)) {
            var numArray = num.toArray();
            if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
            num = new $5c08e30abebc6b49$require$Buffer(numArray);
        }
        if ($5c08e30abebc6b49$require$Buffer.isBuffer(num)) {
            var size = num.length;
            if (num.length === 0) size++;
            var out = new $5c08e30abebc6b49$require$Buffer(size);
            num.copy(out);
            if (num.length === 0) out[0] = 0;
            return this._createEncoderBuffer(out);
        }
        if (num < 0x80) return this._createEncoderBuffer(num);
        if (num < 0x100) return this._createEncoderBuffer([
            0,
            num
        ]);
        var size = 1;
        for(var i = num; i >= 0x100; i >>= 8)size++;
        var out = new Array(size);
        for(var i = out.length - 1; i >= 0; i--){
            out[i] = num & 0xff;
            num >>= 8;
        }
        if (out[0] & 0x80) out.unshift(0);
        return this._createEncoderBuffer(new $5c08e30abebc6b49$require$Buffer(out));
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeBool = function encodeBool(value) {
        return this._createEncoderBuffer(value ? 0xff : 0);
    };
    $5c08e30abebc6b49$var$DERNode.prototype._use = function use(entity, obj) {
        if (typeof entity === 'function') entity = entity(obj);
        return entity._getEncoder('der').tree;
    };
    $5c08e30abebc6b49$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
        var state = this._baseState;
        var i;
        if (state['default'] === null) return false;
        var data = dataBuffer.join();
        if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
        if (data.length !== state.defaultBuffer.length) return false;
        for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
        return true;
    };
    function $5c08e30abebc6b49$var$encodeTag(tag, primitive, cls, reporter) {
        var res;
        if (tag === 'seqof') tag = 'seq';
        else if (tag === 'setof') tag = 'set';
        if ($5c08e30abebc6b49$var$der.tagByName.hasOwnProperty(tag)) res = $5c08e30abebc6b49$var$der.tagByName[tag];
        else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
        else return reporter.error('Unknown tag: ' + tag);
        if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
        if (!primitive) res |= 0x20;
        res |= $5c08e30abebc6b49$var$der.tagClassByName[cls || 'universal'] << 6;
        return res;
    }
});
parcelRegister("6IIig", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $7TTIj = parcelRequire("7TTIj");
    function $4e4935f09ee49d47$var$PEMEncoder(entity) {
        $7TTIj.call(this, entity);
        this.enc = 'pem';
    }
    $v3bBu($4e4935f09ee49d47$var$PEMEncoder, $7TTIj);
    module.exports = $4e4935f09ee49d47$var$PEMEncoder;
    $4e4935f09ee49d47$var$PEMEncoder.prototype.encode = function encode(data, options) {
        var buf = $7TTIj.prototype.encode.call(this, data);
        var p = buf.toString('base64');
        var out = [
            '-----BEGIN ' + options.label + '-----'
        ];
        for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
        out.push('-----END ' + options.label + '-----');
        return out.join('\n');
    };
});
parcelRegister("eqV2A", function(module, exports) {
    'use strict';
    var $4YrAW = parcelRequire("4YrAW");
    var $a81fbd81d3c72dea$var$Time = $4YrAW.define('Time', function() {
        this.choice({
            utcTime: this.utctime(),
            generalTime: this.gentime()
        });
    });
    var $a81fbd81d3c72dea$var$AttributeTypeValue = $4YrAW.define('AttributeTypeValue', function() {
        this.seq().obj(this.key('type').objid(), this.key('value').any());
    });
    var $a81fbd81d3c72dea$var$AlgorithmIdentifier = $4YrAW.define('AlgorithmIdentifier', function() {
        this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
    });
    var $a81fbd81d3c72dea$var$SubjectPublicKeyInfo = $4YrAW.define('SubjectPublicKeyInfo', function() {
        this.seq().obj(this.key('algorithm').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
    });
    var $a81fbd81d3c72dea$var$RelativeDistinguishedName = $4YrAW.define('RelativeDistinguishedName', function() {
        this.setof($a81fbd81d3c72dea$var$AttributeTypeValue);
    });
    var $a81fbd81d3c72dea$var$RDNSequence = $4YrAW.define('RDNSequence', function() {
        this.seqof($a81fbd81d3c72dea$var$RelativeDistinguishedName);
    });
    var $a81fbd81d3c72dea$var$Name = $4YrAW.define('Name', function() {
        this.choice({
            rdnSequence: this.use($a81fbd81d3c72dea$var$RDNSequence)
        });
    });
    var $a81fbd81d3c72dea$var$Validity = $4YrAW.define('Validity', function() {
        this.seq().obj(this.key('notBefore').use($a81fbd81d3c72dea$var$Time), this.key('notAfter').use($a81fbd81d3c72dea$var$Time));
    });
    var $a81fbd81d3c72dea$var$Extension = $4YrAW.define('Extension', function() {
        this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
    });
    var $a81fbd81d3c72dea$var$TBSCertificate = $4YrAW.define('TBSCertificate', function() {
        this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('issuer').use($a81fbd81d3c72dea$var$Name), this.key('validity').use($a81fbd81d3c72dea$var$Validity), this.key('subject').use($a81fbd81d3c72dea$var$Name), this.key('subjectPublicKeyInfo').use($a81fbd81d3c72dea$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($a81fbd81d3c72dea$var$Extension).optional());
    });
    var $a81fbd81d3c72dea$var$X509Certificate = $4YrAW.define('X509Certificate', function() {
        this.seq().obj(this.key('tbsCertificate').use($a81fbd81d3c72dea$var$TBSCertificate), this.key('signatureAlgorithm').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
    });
    module.exports = $a81fbd81d3c72dea$var$X509Certificate;
});
parcelRegister("h9FlO", function(module, exports) {
    module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");
});
parcelRegister("gIBLw", function(module, exports) {
    'use strict';
    var $c2be0cd28f0ce65b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
    var $c2be0cd28f0ce65b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
    var $c2be0cd28f0ce65b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
    var $55KiC = parcelRequire("55KiC");
    var $gcaJj = parcelRequire("gcaJj");
    var $Wth4q = parcelRequire("Wth4q");
    var $c2be0cd28f0ce65b$require$Buffer = $Wth4q.Buffer;
    module.exports = function(okey, password) {
        var key = okey.toString();
        var match = key.match($c2be0cd28f0ce65b$var$findProc);
        var decrypted;
        if (!match) {
            var match2 = key.match($c2be0cd28f0ce65b$var$fullRegex);
            decrypted = $c2be0cd28f0ce65b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
        } else {
            var suite = 'aes' + match[1];
            var iv = $c2be0cd28f0ce65b$require$Buffer.from(match[2], 'hex');
            var cipherText = $c2be0cd28f0ce65b$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
            var cipherKey = $55KiC(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
            var out = [];
            var cipher = $gcaJj.createDecipheriv(suite, cipherKey, iv);
            out.push(cipher.update(cipherText));
            out.push(cipher['final']());
            decrypted = $c2be0cd28f0ce65b$require$Buffer.concat(out);
        }
        var tag = key.match($c2be0cd28f0ce65b$var$startRegex)[1];
        return {
            tag: tag,
            data: decrypted
        };
    };
});
parcelRegister("jf5f0", function(module, exports) {
    module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");
});
parcelRegister("1LYL6", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $14a94faaa2710991$require$Buffer = $Wth4q.Buffer;
    var $bxS53 = parcelRequire("bxS53");
    var $8JoQd = parcelRequire("8JoQd");
    var $14a94faaa2710991$require$EC = $8JoQd.ec;
    var $ejFGc = parcelRequire("ejFGc");
    var $jf5f0 = parcelRequire("jf5f0");
    function $14a94faaa2710991$var$verify(sig, hash, key, signType, tag) {
        var pub = $ejFGc(key);
        if (pub.type === 'ec') {
            if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
            return $14a94faaa2710991$var$ecVerify(sig, hash, pub);
        } else if (pub.type === 'dsa') {
            if (signType !== 'dsa') throw new Error('wrong public key type');
            return $14a94faaa2710991$var$dsaVerify(sig, hash, pub);
        }
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        hash = $14a94faaa2710991$require$Buffer.concat([
            tag,
            hash
        ]);
        var len = pub.modulus.byteLength();
        var pad = [
            1
        ];
        var padNum = 0;
        while(hash.length + pad.length + 2 < len){
            pad.push(0xff);
            padNum += 1;
        }
        pad.push(0x00);
        var i = -1;
        while(++i < hash.length)pad.push(hash[i]);
        pad = $14a94faaa2710991$require$Buffer.from(pad);
        var red = $bxS53.mont(pub.modulus);
        sig = new $bxS53(sig).toRed(red);
        sig = sig.redPow(new $bxS53(pub.publicExponent));
        sig = $14a94faaa2710991$require$Buffer.from(sig.fromRed().toArray());
        var out = padNum < 8 ? 1 : 0;
        len = Math.min(sig.length, pad.length);
        if (sig.length !== pad.length) out = 1;
        i = -1;
        while(++i < len)out |= sig[i] ^ pad[i];
        return out === 0;
    }
    function $14a94faaa2710991$var$ecVerify(sig, hash, pub) {
        var curveId = $jf5f0[pub.data.algorithm.curve.join('.')];
        if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
        var curve = new $14a94faaa2710991$require$EC(curveId);
        var pubkey = pub.data.subjectPrivateKey.data;
        return curve.verify(hash, sig, pubkey);
    }
    function $14a94faaa2710991$var$dsaVerify(sig, hash, pub) {
        var p = pub.data.p;
        var q = pub.data.q;
        var g = pub.data.g;
        var y = pub.data.pub_key;
        var unpacked = $ejFGc.signature.decode(sig, 'der');
        var s = unpacked.s;
        var r = unpacked.r;
        $14a94faaa2710991$var$checkValue(s, q);
        $14a94faaa2710991$var$checkValue(r, q);
        var montp = $bxS53.mont(p);
        var w = s.invm(q);
        var v = g.toRed(montp).redPow(new $bxS53(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
        return v.cmp(r) === 0;
    }
    function $14a94faaa2710991$var$checkValue(b, q) {
        if (b.cmpn(0) <= 0) throw new Error('invalid sig');
        if (b.cmp(q) >= 0) throw new Error('invalid sig');
    }
    module.exports = $14a94faaa2710991$var$verify;
});
parcelRegister("bsZLy", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $859238ac8a186043$require$Buffer = $5k7LC.Buffer;
    var $8JoQd = parcelRequire("8JoQd");
    var $9pbIC = parcelRequire("9pbIC");
    module.exports = function createECDH(curve) {
        return new $859238ac8a186043$var$ECDH(curve);
    };
    var $859238ac8a186043$var$aliases = {
        secp256k1: {
            name: 'secp256k1',
            byteLength: 32
        },
        secp224r1: {
            name: 'p224',
            byteLength: 28
        },
        prime256v1: {
            name: 'p256',
            byteLength: 32
        },
        prime192v1: {
            name: 'p192',
            byteLength: 24
        },
        ed25519: {
            name: 'ed25519',
            byteLength: 32
        },
        secp384r1: {
            name: 'p384',
            byteLength: 48
        },
        secp521r1: {
            name: 'p521',
            byteLength: 66
        }
    };
    $859238ac8a186043$var$aliases.p224 = $859238ac8a186043$var$aliases.secp224r1;
    $859238ac8a186043$var$aliases.p256 = $859238ac8a186043$var$aliases.secp256r1 = $859238ac8a186043$var$aliases.prime256v1;
    $859238ac8a186043$var$aliases.p192 = $859238ac8a186043$var$aliases.secp192r1 = $859238ac8a186043$var$aliases.prime192v1;
    $859238ac8a186043$var$aliases.p384 = $859238ac8a186043$var$aliases.secp384r1;
    $859238ac8a186043$var$aliases.p521 = $859238ac8a186043$var$aliases.secp521r1;
    function $859238ac8a186043$var$ECDH(curve) {
        this.curveType = $859238ac8a186043$var$aliases[curve];
        if (!this.curveType) this.curveType = {
            name: curve
        };
        this.curve = new $8JoQd.ec(this.curveType.name);
        this.keys = void 0;
    }
    $859238ac8a186043$var$ECDH.prototype.generateKeys = function(enc, format) {
        this.keys = this.curve.genKeyPair();
        return this.getPublicKey(enc, format);
    };
    $859238ac8a186043$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
        inenc = inenc || 'utf8';
        if (!$859238ac8a186043$require$Buffer.isBuffer(other)) other = new $859238ac8a186043$require$Buffer(other, inenc);
        var otherPub = this.curve.keyFromPublic(other).getPublic();
        var out = otherPub.mul(this.keys.getPrivate()).getX();
        return $859238ac8a186043$var$formatReturnValue(out, enc, this.curveType.byteLength);
    };
    $859238ac8a186043$var$ECDH.prototype.getPublicKey = function(enc, format) {
        var key = this.keys.getPublic(format === 'compressed', true);
        if (format === 'hybrid') {
            if (key[key.length - 1] % 2) key[0] = 7;
            else key[0] = 6;
        }
        return $859238ac8a186043$var$formatReturnValue(key, enc);
    };
    $859238ac8a186043$var$ECDH.prototype.getPrivateKey = function(enc) {
        return $859238ac8a186043$var$formatReturnValue(this.keys.getPrivate(), enc);
    };
    $859238ac8a186043$var$ECDH.prototype.setPublicKey = function(pub, enc) {
        enc = enc || 'utf8';
        if (!$859238ac8a186043$require$Buffer.isBuffer(pub)) pub = new $859238ac8a186043$require$Buffer(pub, enc);
        this.keys._importPublic(pub);
        return this;
    };
    $859238ac8a186043$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
        enc = enc || 'utf8';
        if (!$859238ac8a186043$require$Buffer.isBuffer(priv)) priv = new $859238ac8a186043$require$Buffer(priv, enc);
        var _priv = new $9pbIC(priv);
        _priv = _priv.toString(16);
        this.keys = this.curve.genKeyPair();
        this.keys._importPrivate(_priv);
        return this;
    };
    function $859238ac8a186043$var$formatReturnValue(bn, enc, len) {
        if (!Array.isArray(bn)) bn = bn.toArray();
        var buf = new $859238ac8a186043$require$Buffer(bn);
        if (len && buf.length < len) {
            var zeros = new $859238ac8a186043$require$Buffer(len - buf.length);
            zeros.fill(0);
            buf = $859238ac8a186043$require$Buffer.concat([
                zeros,
                buf
            ]);
        }
        if (!enc) return buf;
        else return buf.toString(enc);
    }
});
parcelRegister("bIasb", function(module, exports) {
    $parcel$export(module.exports, "publicEncrypt", ()=>$886be99faec3bef9$export$512823e338ddb1b7, (v)=>$886be99faec3bef9$export$512823e338ddb1b7 = v);
    $parcel$export(module.exports, "privateDecrypt", ()=>$886be99faec3bef9$export$7efb24e2fddf99b9, (v)=>$886be99faec3bef9$export$7efb24e2fddf99b9 = v);
    $parcel$export(module.exports, "privateEncrypt", ()=>$886be99faec3bef9$export$9d0e0c0c4a8d30f3, (v)=>$886be99faec3bef9$export$9d0e0c0c4a8d30f3 = v);
    $parcel$export(module.exports, "publicDecrypt", ()=>$886be99faec3bef9$export$b9d55ff329113abd, (v)=>$886be99faec3bef9$export$b9d55ff329113abd = v);
    var $886be99faec3bef9$export$512823e338ddb1b7;
    var $886be99faec3bef9$export$7efb24e2fddf99b9;
    var $886be99faec3bef9$export$9d0e0c0c4a8d30f3;
    var $886be99faec3bef9$export$b9d55ff329113abd;
    $886be99faec3bef9$export$512823e338ddb1b7 = (parcelRequire("fZDr0"));
    $886be99faec3bef9$export$7efb24e2fddf99b9 = (parcelRequire("3p2ND"));
    $886be99faec3bef9$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
        return $886be99faec3bef9$export$512823e338ddb1b7(key, buf, true);
    };
    $886be99faec3bef9$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
        return $886be99faec3bef9$export$7efb24e2fddf99b9(key, buf, true);
    };
});
parcelRegister("fZDr0", function(module, exports) {
    var $ejFGc = parcelRequire("ejFGc");
    var $1DyI6 = parcelRequire("1DyI6");
    var $7K4uY = parcelRequire("7K4uY");
    var $5g0NR = parcelRequire("5g0NR");
    var $ixBc1 = parcelRequire("ixBc1");
    var $9pbIC = parcelRequire("9pbIC");
    var $fr5TT = parcelRequire("fr5TT");
    var $cfrZu;
    var $Wth4q = parcelRequire("Wth4q");
    var $ba4b246a6106fed1$require$Buffer = $Wth4q.Buffer;
    module.exports = function publicEncrypt(publicKey, msg, reverse) {
        var padding;
        if (publicKey.padding) padding = publicKey.padding;
        else if (reverse) padding = 1;
        else padding = 4;
        var key = $ejFGc(publicKey);
        var paddedMsg;
        if (padding === 4) paddedMsg = $ba4b246a6106fed1$var$oaep(key, msg);
        else if (padding === 1) paddedMsg = $ba4b246a6106fed1$var$pkcs1(key, msg, reverse);
        else if (padding === 3) {
            paddedMsg = new $9pbIC(msg);
            if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
        } else throw new Error('unknown padding');
        if (reverse) return (0, parcelRequire("cfrZu"))(paddedMsg, key);
        else return $fr5TT(paddedMsg, key);
    };
    function $ba4b246a6106fed1$var$oaep(key, msg) {
        var k = key.modulus.byteLength();
        var mLen = msg.length;
        var iHash = $7K4uY('sha1').update($ba4b246a6106fed1$require$Buffer.alloc(0)).digest();
        var hLen = iHash.length;
        var hLen2 = 2 * hLen;
        if (mLen > k - hLen2 - 2) throw new Error('message too long');
        var ps = $ba4b246a6106fed1$require$Buffer.alloc(k - mLen - hLen2 - 2);
        var dblen = k - hLen - 1;
        var seed = $1DyI6(hLen);
        var maskedDb = $ixBc1($ba4b246a6106fed1$require$Buffer.concat([
            iHash,
            ps,
            $ba4b246a6106fed1$require$Buffer.alloc(1, 1),
            msg
        ], dblen), $5g0NR(seed, dblen));
        var maskedSeed = $ixBc1(seed, $5g0NR(maskedDb, hLen));
        return new $9pbIC($ba4b246a6106fed1$require$Buffer.concat([
            $ba4b246a6106fed1$require$Buffer.alloc(1),
            maskedSeed,
            maskedDb
        ], k));
    }
    function $ba4b246a6106fed1$var$pkcs1(key, msg, reverse) {
        var mLen = msg.length;
        var k = key.modulus.byteLength();
        if (mLen > k - 11) throw new Error('message too long');
        var ps;
        if (reverse) ps = $ba4b246a6106fed1$require$Buffer.alloc(k - mLen - 3, 0xff);
        else ps = $ba4b246a6106fed1$var$nonZero(k - mLen - 3);
        return new $9pbIC($ba4b246a6106fed1$require$Buffer.concat([
            $ba4b246a6106fed1$require$Buffer.from([
                0,
                reverse ? 1 : 2
            ]),
            ps,
            $ba4b246a6106fed1$require$Buffer.alloc(1),
            msg
        ], k));
    }
    function $ba4b246a6106fed1$var$nonZero(len) {
        var out = $ba4b246a6106fed1$require$Buffer.allocUnsafe(len);
        var i = 0;
        var cache = $1DyI6(len * 2);
        var cur = 0;
        var num;
        while(i < len){
            if (cur === cache.length) {
                cache = $1DyI6(len * 2);
                cur = 0;
            }
            num = cache[cur++];
            if (num) out[i++] = num;
        }
        return out;
    }
});
parcelRegister("5g0NR", function(module, exports) {
    var $7K4uY = parcelRequire("7K4uY");
    var $Wth4q = parcelRequire("Wth4q");
    var $3d3f11d98f131928$require$Buffer = $Wth4q.Buffer;
    module.exports = function(seed, len) {
        var t = $3d3f11d98f131928$require$Buffer.alloc(0);
        var i = 0;
        var c;
        while(t.length < len){
            c = $3d3f11d98f131928$var$i2ops(i++);
            t = $3d3f11d98f131928$require$Buffer.concat([
                t,
                $7K4uY('sha1').update(seed).update(c).digest()
            ]);
        }
        return t.slice(0, len);
    };
    function $3d3f11d98f131928$var$i2ops(c) {
        var out = $3d3f11d98f131928$require$Buffer.allocUnsafe(4);
        out.writeUInt32BE(c, 0);
        return out;
    }
});
parcelRegister("ixBc1", function(module, exports) {
    module.exports = function xor(a, b) {
        var len = a.length;
        var i = -1;
        while(++i < len)a[i] ^= b[i];
        return a;
    };
});
parcelRegister("fr5TT", function(module, exports) {
    var $9pbIC = parcelRequire("9pbIC");
    var $Wth4q = parcelRequire("Wth4q");
    var $b3cdf455bc7e4e8e$require$Buffer = $Wth4q.Buffer;
    function $b3cdf455bc7e4e8e$var$withPublic(paddedMsg, key) {
        return $b3cdf455bc7e4e8e$require$Buffer.from(paddedMsg.toRed($9pbIC.mont(key.modulus)).redPow(new $9pbIC(key.publicExponent)).fromRed().toArray());
    }
    module.exports = $b3cdf455bc7e4e8e$var$withPublic;
});
parcelRegister("3p2ND", function(module, exports) {
    var $ejFGc = parcelRequire("ejFGc");
    var $5g0NR = parcelRequire("5g0NR");
    var $ixBc1 = parcelRequire("ixBc1");
    var $9pbIC = parcelRequire("9pbIC");
    var $cfrZu;
    var $7K4uY = parcelRequire("7K4uY");
    var $fr5TT = parcelRequire("fr5TT");
    var $Wth4q = parcelRequire("Wth4q");
    var $27a5e0d2e6fe9775$require$Buffer = $Wth4q.Buffer;
    module.exports = function privateDecrypt(privateKey, enc, reverse) {
        var padding;
        if (privateKey.padding) padding = privateKey.padding;
        else if (reverse) padding = 1;
        else padding = 4;
        var key = $ejFGc(privateKey);
        var k = key.modulus.byteLength();
        if (enc.length > k || new $9pbIC(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
        var msg;
        if (reverse) msg = $fr5TT(new $9pbIC(enc), key);
        else msg = (0, parcelRequire("cfrZu"))(enc, key);
        var zBuffer = $27a5e0d2e6fe9775$require$Buffer.alloc(k - msg.length);
        msg = $27a5e0d2e6fe9775$require$Buffer.concat([
            zBuffer,
            msg
        ], k);
        if (padding === 4) return $27a5e0d2e6fe9775$var$oaep(key, msg);
        else if (padding === 1) return $27a5e0d2e6fe9775$var$pkcs1(key, msg, reverse);
        else if (padding === 3) return msg;
        else throw new Error('unknown padding');
    };
    function $27a5e0d2e6fe9775$var$oaep(key, msg) {
        var k = key.modulus.byteLength();
        var iHash = $7K4uY('sha1').update($27a5e0d2e6fe9775$require$Buffer.alloc(0)).digest();
        var hLen = iHash.length;
        if (msg[0] !== 0) throw new Error('decryption error');
        var maskedSeed = msg.slice(1, hLen + 1);
        var maskedDb = msg.slice(hLen + 1);
        var seed = $ixBc1(maskedSeed, $5g0NR(maskedDb, hLen));
        var db = $ixBc1(maskedDb, $5g0NR(seed, k - hLen - 1));
        if ($27a5e0d2e6fe9775$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
        var i = hLen;
        while(db[i] === 0)i++;
        if (db[i++] !== 1) throw new Error('decryption error');
        return db.slice(i);
    }
    function $27a5e0d2e6fe9775$var$pkcs1(key, msg, reverse) {
        var p1 = msg.slice(0, 2);
        var i = 2;
        var status = 0;
        while(msg[i++] !== 0)if (i >= msg.length) {
            status++;
            break;
        }
        var ps = msg.slice(2, i - 1);
        if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
        if (ps.length < 8) status++;
        if (status) throw new Error('decryption error');
        return msg.slice(i);
    }
    function $27a5e0d2e6fe9775$var$compare(a, b) {
        a = $27a5e0d2e6fe9775$require$Buffer.from(a);
        b = $27a5e0d2e6fe9775$require$Buffer.from(b);
        var dif = 0;
        var len = a.length;
        if (a.length !== b.length) {
            dif++;
            len = Math.min(a.length, b.length);
        }
        var i = -1;
        while(++i < len)dif += a[i] ^ b[i];
        return dif;
    }
});
parcelRegister("9hQRv", function(module, exports) {
    $parcel$export(module.exports, "randomFill", ()=>$6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8, (v)=>$6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = v);
    $parcel$export(module.exports, "randomFillSync", ()=>$6c2eb4e5b7b6051e$export$2f7171e78e524d5e, (v)=>$6c2eb4e5b7b6051e$export$2f7171e78e524d5e = v);
    var $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8;
    var $6c2eb4e5b7b6051e$export$2f7171e78e524d5e;
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $6c2eb4e5b7b6051e$var$oldBrowser() {
        throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
    }
    var $Wth4q = parcelRequire("Wth4q");
    var $1DyI6 = parcelRequire("1DyI6");
    var $6c2eb4e5b7b6051e$var$Buffer = $Wth4q.Buffer;
    var $6c2eb4e5b7b6051e$var$kBufferMaxLength = $Wth4q.kMaxLength;
    var $6c2eb4e5b7b6051e$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
    var $6c2eb4e5b7b6051e$var$kMaxUint32 = Math.pow(2, 32) - 1;
    function $6c2eb4e5b7b6051e$var$assertOffset(offset, length) {
        if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
        if (offset > $6c2eb4e5b7b6051e$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
        if (offset > $6c2eb4e5b7b6051e$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
    }
    function $6c2eb4e5b7b6051e$var$assertSize(size, offset, length) {
        if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
        if (size > $6c2eb4e5b7b6051e$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
        if (size + offset > length || size > $6c2eb4e5b7b6051e$var$kBufferMaxLength) throw new RangeError('buffer too small');
    }
    if ($6c2eb4e5b7b6051e$var$crypto && $6c2eb4e5b7b6051e$var$crypto.getRandomValues || false) {
        $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = $6c2eb4e5b7b6051e$var$randomFill;
        $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = $6c2eb4e5b7b6051e$var$randomFillSync;
    } else {
        $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = $6c2eb4e5b7b6051e$var$oldBrowser;
        $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = $6c2eb4e5b7b6051e$var$oldBrowser;
    }
    function $6c2eb4e5b7b6051e$var$randomFill(buf, offset, size, cb) {
        if (!$6c2eb4e5b7b6051e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        if (typeof offset === 'function') {
            cb = offset;
            offset = 0;
            size = buf.length;
        } else if (typeof size === 'function') {
            cb = size;
            size = buf.length - offset;
        } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
        $6c2eb4e5b7b6051e$var$assertOffset(offset, buf.length);
        $6c2eb4e5b7b6051e$var$assertSize(size, offset, buf.length);
        return $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size, cb);
    }
    function $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size, cb) {
        var ourBuf = buf.buffer;
        var uint = new Uint8Array(ourBuf, offset, size);
        $6c2eb4e5b7b6051e$var$crypto.getRandomValues(uint);
        if (cb) {
            $6cAn5.nextTick(function() {
                cb(null, buf);
            });
            return;
        }
        return buf;
        if (cb) {
            $1DyI6(size, function(err, bytes) {
                if (err) return cb(err);
                bytes.copy(buf, offset);
                cb(null, buf);
            });
            return;
        }
        var bytes = $1DyI6(size);
        bytes.copy(buf, offset);
        return buf;
    }
    function $6c2eb4e5b7b6051e$var$randomFillSync(buf, offset, size) {
        if (typeof offset === 'undefined') offset = 0;
        if (!$6c2eb4e5b7b6051e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        $6c2eb4e5b7b6051e$var$assertOffset(offset, buf.length);
        if (size === undefined) size = buf.length - offset;
        $6c2eb4e5b7b6051e$var$assertSize(size, offset, buf.length);
        return $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size);
    }
});
parcelRegister("75NXP", function(module, exports) {
    $parcel$export(module.exports, "useAnalytics", ()=>$bcab3434b73de5c0$export$e955abb82869dc84);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $3FqY6;
    const $bcab3434b73de5c0$export$e955abb82869dc84 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return {
            fireAnalyticsEvent: (0, ($parcel$interopDefault($5uXOq))).useCallback((payload)=>createAnalyticsEvent(payload).fire((0, (0, parcelRequire("3FqY6")).DEFAULT_GAS_CHANNEL)), [
                createAnalyticsEvent
            ])
        };
    };
});
parcelRegister("8TPno", function(module, exports) {
    $parcel$export(module.exports, "CenteredAdvancedSearchGroup", ()=>$31bf11d0c8ded2af$export$5d708f1c4bba7ac3);
    $parcel$export(module.exports, "StyledAdvancedSearch", ()=>$31bf11d0c8ded2af$export$ffb3e5c7f83e1d2f);
    $parcel$export(module.exports, "AdvancedSearchContent", ()=>$31bf11d0c8ded2af$export$aa7c31826bbddc7b);
    var $3RZIb;
    var $kCMvS;
    var $bWGt6 = parcelRequire("bWGt6");
    function $31bf11d0c8ded2af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $31bf11d0c8ded2af$export$5d708f1c4bba7ac3 = (0, $bWGt6.default)("div", {
        target: "e1fpfwrr2"
    })({
        name: "s5xdrg",
        styles: "display:flex;align-items:center"
    });
    const $31bf11d0c8ded2af$var$outlineWidth = 2;
    const $31bf11d0c8ded2af$export$ffb3e5c7f83e1d2f = (0, $bWGt6.default)((0, (0, parcelRequire("kCMvS")).Link), {
        target: "e1fpfwrr1"
    })((props)=>({
            alignItems: 'center',
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            padding: `${"var(--ds-space-075, 6px)"} ${16 - $31bf11d0c8ded2af$var$outlineWidth}px`,
            border: `${$31bf11d0c8ded2af$var$outlineWidth}px solid transparent`,
            '&:hover': {
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
                backgroundColor: `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                textDecoration: 'none'
            },
            '&:visited': {
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&:focus': {
                outline: 'none',
                border: `${$31bf11d0c8ded2af$var$outlineWidth}px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})`}`
            },
            backgroundColor: props.isKeyboardHighlighted ? `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
        }));
    const $31bf11d0c8ded2af$export$aa7c31826bbddc7b = (0, $bWGt6.default)("span", {
        target: "e1fpfwrr0"
    })({
        font: `var(--ds-font-body, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.medium})`,
        paddingLeft: "var(--ds-space-200, 16px)",
        display: 'flex',
        alignItems: 'center'
    });
});
parcelRegister("kCMvS", function(module, exports) {
    $parcel$export(module.exports, "Link", ()=>$33c994828df19c61$export$a6c7ac8248d6e38a);
    var $5uXOq = parcelRequire("5uXOq");
    const $33c994828df19c61$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
        const Component = linkComponent || 'a';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props);
    };
});
parcelRegister("hN1kQ", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSearchLink", ()=>$f402b6a126e5d093$export$3f63855034354a21);
    var $5uXOq = parcelRequire("5uXOq");
    var $8TPno;
    const $f402b6a126e5d093$export$3f63855034354a21 = ({ href: href, linkComponent: linkComponent, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TPno")).StyledAdvancedSearch), {
            linkComponent: linkComponent,
            "data-test-id": "search-dialog-advanced-search-link",
            href: href,
            ...rest
        });
});
parcelRegister("kv2Va", function(module, exports) {
    $parcel$export(module.exports, "ProductRouter", ()=>$0ccc3d4c76eeace6$export$36d5c2ec3fe68eef);
    $parcel$export(module.exports, "useProductContext", ()=>$0ccc3d4c76eeace6$export$b5aab9e12d92574f);
    $parcel$export(module.exports, "withProductContext", ()=>$0ccc3d4c76eeace6$export$a1f708a69696ca95);
    var $5uXOq = parcelRequire("5uXOq");
    var $6SBvm = parcelRequire("6SBvm");
    var $i5cPn;
    var $8iCbm;
    const $0ccc3d4c76eeace6$var$ProductContext = (0, $5uXOq.createContext)({
        getProduct: (id)=>undefined,
        getActiveProduct: ()=>undefined,
        getPrimaryProduct: ()=>undefined,
        addProduct: ()=>undefined,
        updateProduct: ()=>undefined,
        removeProduct: ()=>undefined,
        showProduct: ()=>undefined,
        getDefaultAIConfig: ()=>undefined,
        products: []
    });
    const $0ccc3d4c76eeace6$export$36d5c2ec3fe68eef = ({ primaryProduct: primaryProduct, __initialProducts: __initialProducts = (0, (0, parcelRequire("8iCbm")).INITIAL_STATE), children: children })=>{
        const [products, dispatch] = (0, $5uXOq.useReducer)((0, (0, parcelRequire("8iCbm")).reducer), __initialProducts);
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isExpanded) dispatch({
                type: 'HIDE_ALL'
            });
        }, [
            isExpanded
        ]);
        const addProduct = (0, $5uXOq.useCallback)((payload)=>{
            return dispatch({
                type: 'ADD',
                payload: payload
            });
        }, [
            dispatch
        ]);
        const updateProduct = (0, $5uXOq.useCallback)((payload)=>{
            return dispatch({
                type: 'UPDATE',
                payload: payload
            });
        }, [
            dispatch
        ]);
        const removeProduct = (0, $5uXOq.useCallback)((id)=>{
            return dispatch({
                type: 'REMOVE',
                payload: {
                    id: id
                }
            });
        }, [
            dispatch
        ]);
        const showProduct = (0, $5uXOq.useCallback)((id)=>dispatch({
                type: 'SHOW',
                payload: {
                    id: id
                }
            }), [
            dispatch
        ]);
        const getActiveProduct = (0, $5uXOq.useCallback)(()=>{
            return products.find((product)=>product.isDisplayed);
        }, [
            products
        ]);
        const productsRef = (0, $5uXOq.useRef)({});
        const getProduct = (0, $5uXOq.useCallback)((id)=>{
            const product = products.find((product)=>product.id === id);
            const productRef = productsRef.current[id];
            if (!(0, ($parcel$interopDefault($6SBvm)))(product, productRef)) productsRef.current[id] = product;
            return productsRef.current[id];
        }, [
            products
        ]);
        const getPrimaryProduct = (0, $5uXOq.useCallback)(()=>{
            const nominatedPrimaryProduct = primaryProduct && getProduct(primaryProduct);
            const firstRegisteredProduct = products.length > 0 && products[0];
            return nominatedPrimaryProduct || firstRegisteredProduct || undefined;
        }, [
            getProduct,
            primaryProduct,
            products
        ]);
        const getDefaultAIConfig = (0, $5uXOq.useCallback)(()=>{
            const primaryProduct = getPrimaryProduct();
            if (primaryProduct?.aiSearchConfig) return primaryProduct.aiSearchConfig;
            else return products.filter((product)=>product.aiSearchConfig)[0]?.aiSearchConfig;
        }, [
            products,
            getPrimaryProduct
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0ccc3d4c76eeace6$var$ProductContext.Provider, {
            value: {
                getProduct: getProduct,
                getActiveProduct: getActiveProduct,
                getPrimaryProduct: getPrimaryProduct,
                addProduct: addProduct,
                updateProduct: updateProduct,
                removeProduct: removeProduct,
                showProduct: showProduct,
                products: products,
                getDefaultAIConfig: getDefaultAIConfig
            }
        }, children);
    };
    const $0ccc3d4c76eeace6$export$b5aab9e12d92574f = ()=>(0, $5uXOq.useContext)($0ccc3d4c76eeace6$var$ProductContext);
    const $0ccc3d4c76eeace6$export$a1f708a69696ca95 = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                ...$0ccc3d4c76eeace6$export$b5aab9e12d92574f()
            });
    };
});
parcelRegister("i5cPn", function(module, exports) {
    $parcel$export(module.exports, "DialogExpansionContextProvider", ()=>$fc7cc3c84112fd09$export$4a9c91610a2bc03);
    $parcel$export(module.exports, "useDialogExpansionContext", ()=>$fc7cc3c84112fd09$export$124a7aa8f9a7a608);
    $parcel$export(module.exports, "withDialogExpansionContext", ()=>$fc7cc3c84112fd09$export$be366799d3426bb9);
    var $5uXOq = parcelRequire("5uXOq");
    const $fc7cc3c84112fd09$export$5d07de159ce5026c = (0, ($parcel$interopDefault($5uXOq))).createContext({
        isExpanded: false,
        setIsExpanded: (isExpanded)=>{},
        allowChangeExpand: (expand)=>{}
    });
    const $fc7cc3c84112fd09$export$4a9c91610a2bc03 = ({ children: children, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
        const [changeExpand, setChangeExpand] = (0, $5uXOq.useState)(true);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fc7cc3c84112fd09$export$5d07de159ce5026c.Provider, {
            value: {
                isExpanded: isExpanded,
                setIsExpanded: changeExpand ? setIsExpanded : ()=>{},
                allowChangeExpand: setChangeExpand
            }
        }, children);
    };
    const $fc7cc3c84112fd09$export$124a7aa8f9a7a608 = ()=>{
        return (0, $5uXOq.useContext)($fc7cc3c84112fd09$export$5d07de159ce5026c);
    };
    const $fc7cc3c84112fd09$export$be366799d3426bb9 = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                ...$fc7cc3c84112fd09$export$124a7aa8f9a7a608()
            });
    };
});
parcelRegister("8iCbm", function(module, exports) {
    $parcel$export(module.exports, "INITIAL_STATE", ()=>$7833e33069541c80$export$36d128238e6b60f5);
    $parcel$export(module.exports, "reducer", ()=>$7833e33069541c80$export$1650419e431d3ba3);
    const $7833e33069541c80$export$36d128238e6b60f5 = [];
    const $7833e33069541c80$export$1650419e431d3ba3 = (state, action)=>{
        switch(action.type){
            case 'ADD':
                {
                    const { payload: newProduct } = action;
                    return $7833e33069541c80$export$7caf006d7b64ee15(state, newProduct);
                }
            case 'UPDATE':
                {
                    const { payload: updatePayload } = action;
                    return $7833e33069541c80$export$8d590d0c8872145e(state, updatePayload);
                }
            case 'SHOW':
                {
                    const productIdToShow = action.payload.id;
                    return $7833e33069541c80$export$821c121fea76e4f5(state, productIdToShow);
                }
            case 'REMOVE':
                {
                    const productIdToRemove = action.payload.id;
                    return $7833e33069541c80$export$86a330d9a979afdd(state, productIdToRemove);
                }
            case 'HIDE_ALL':
                return $7833e33069541c80$export$b6d3947c481ec009(state);
            default:
                return state;
        }
    };
    function $7833e33069541c80$export$7caf006d7b64ee15(products, addPayload) {
        if (products.filter((product)=>product.id === addPayload.id).length) return products;
        const duplicateOrder = products.find(({ order: order })=>order === addPayload.order);
        if (duplicateOrder) console.error(`product-search-dialog: Duplicate order of ${addPayload.order} has been set for the products of ${duplicateOrder.id} and ${addPayload.id}`);
        const newProduct = {
            ...addPayload,
            isDisplayed: false
        };
        const unsorted = [
            ...products,
            newProduct
        ];
        const sorted = unsorted.sort((a, b)=>a.order - b.order);
        return sorted;
    }
    function $7833e33069541c80$export$8d590d0c8872145e(products, updatePayload) {
        const productToUpdate = products.find((p)=>p.id === updatePayload.id);
        if (!productToUpdate) throw new Error(`Cannot update ${updatePayload.id} before being added`);
        const validUpdateKeys = [
            'generateAdvancedSearchUrl',
            'tabRenderer'
        ];
        const validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(([key])=>validUpdateKeys.includes(key)));
        Object.assign(productToUpdate, validUpdatePayload);
        return products;
    }
    function $7833e33069541c80$export$821c121fea76e4f5(products, productIdToShow) {
        return products.map((product)=>({
                ...product,
                isDisplayed: product.id === productIdToShow
            }));
    }
    function $7833e33069541c80$export$86a330d9a979afdd(products, productIdToRemove) {
        return products.filter((product)=>product.id !== productIdToRemove);
    }
    function $7833e33069541c80$export$b6d3947c481ec009(products) {
        return products.map((product)=>({
                ...product,
                isDisplayed: false
            }));
    }
});
parcelRegister("2dI5H", function(module, exports) {
    $parcel$export(module.exports, "QueryContextProvider", ()=>$dac671db1ba592e6$export$96e4d538f00fbce1);
    $parcel$export(module.exports, "useQuery", ()=>$dac671db1ba592e6$export$dd0a697e1782aedd);
    var $5uXOq = parcelRequire("5uXOq");
    var $2k6eV;
    var $tUDIN;
    var $e5JCl;
    var $i5cPn;
    const $dac671db1ba592e6$var$QueryContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        query: '',
        queryVersion: 0,
        isLoading: false,
        setQuery: (ignore)=>{},
        setQueryOnly: (ignore)=>{},
        setAdditionalAnalyticsContext: (ignore)=>({})
    });
    const $dac671db1ba592e6$export$96e4d538f00fbce1 = ({ children: children })=>{
        const [stateQuery, setStateQuery] = (0, $5uXOq.useState)('');
        const { stickySearchEnabled: stickySearchEnabled, query: sessionQuery, showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog, storeQuery: storeQuery } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const query = stickySearchEnabled ? sessionQuery : stateQuery;
        const setQuery = (0, $5uXOq.useCallback)((value)=>{
            if (showSearchAIDialog) toggleShowSearchAIDialog(false);
            stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
        }, [
            showSearchAIDialog,
            toggleShowSearchAIDialog,
            stickySearchEnabled,
            storeQuery
        ]);
        const setQueryOnly = (0, $5uXOq.useCallback)((value)=>{
            stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
        }, [
            stickySearchEnabled,
            storeQuery
        ]);
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { isLoading: isLoading, setAdditionalAnalyticsContext: setAdditionalAnalyticsContext, addAnalyticContext: addAnalyticContext, nonPrivacySafeContext: nonPrivacySafeContext, queryVersion: queryVersion } = (0, (0, parcelRequire("e5JCl")).useAnalyticsContext)(query);
        (0, $5uXOq.useEffect)(()=>{
            if (!isExpanded) {
                if (!stickySearchEnabled) setQuery('');
                setAdditionalAnalyticsContext({
                    type: 'reset'
                });
            }
        }, [
            isExpanded,
            setAdditionalAnalyticsContext,
            stickySearchEnabled,
            setQuery
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dac671db1ba592e6$var$QueryContext.Provider, {
            value: {
                query: query,
                queryVersion: queryVersion,
                setQuery: setQuery,
                setQueryOnly: setQueryOnly,
                setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
                isLoading: isLoading
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: addAnalyticContext,
            nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeContext
        }, children));
    };
    const $dac671db1ba592e6$export$dd0a697e1782aedd = ()=>{
        return (0, $5uXOq.useContext)($dac671db1ba592e6$var$QueryContext);
    };
});
parcelRegister("2k6eV", function(module, exports) {
    $parcel$export(module.exports, "UserInputContextProvider", ()=>$2425567f2928b10c$export$dab413a8570d1ac4);
    $parcel$export(module.exports, "useSessionUserInput", ()=>$2425567f2928b10c$export$296c1552a8cb35a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ZeOg;
    var $3FqY6;
    var $tUDIN;
    var $75NXP;
    const $2425567f2928b10c$var$noop = ()=>{};
    const $2425567f2928b10c$var$SESSION_RESET_TIMEOUT_MS = 300000;
    const $2425567f2928b10c$var$anyConfluenceFiltersChecked = (filters)=>{
        const confluencefilters = filters.confluence;
        if (confluencefilters) {
            const hasSpaceFilterChecked = confluencefilters.space?.length ? confluencefilters.space?.some((filter)=>{
                return filter.isChecked;
            }) : false;
            const hasPeopleFilterChecked = confluencefilters.people?.length ? confluencefilters.people?.some((filter)=>{
                return filter.isChecked;
            }) : false;
            const hasSiteFilterChecked = confluencefilters.site?.length ? confluencefilters.site?.some((filter)=>{
                return filter.isChecked;
            }) : false;
            return hasSpaceFilterChecked || hasPeopleFilterChecked || hasSiteFilterChecked;
        }
        return false;
    };
    const $2425567f2928b10c$export$c87c231bb0fb0228 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        stickySearchEnabled: false,
        query: '',
        showSearchAIDialog: false,
        storeQuery: $2425567f2928b10c$var$noop,
        toggleShowSearchAIDialog: $2425567f2928b10c$var$noop,
        readFilters: $2425567f2928b10c$var$noop,
        storeFilters: $2425567f2928b10c$var$noop,
        resetSearchSession: $2425567f2928b10c$var$noop,
        resetConfluenceFiltersRef: undefined,
        resetExtensibleFiltersRef: undefined
    });
    const $2425567f2928b10c$export$dab413a8570d1ac4 = ({ stickySearchEnabled: stickySearchEnabled = false, sessionResetIdleTime: sessionResetIdleTime = $2425567f2928b10c$var$SESSION_RESET_TIMEOUT_MS, isExpanded: isExpanded = false, resetStickySearchRef: resetStickySearchRef, children: children })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const [query, setQuery] = (0, $5uXOq.useState)((0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_QUERY_KEY)) || '');
        const [isStickyUpdated, setIsStickyUpdated] = (0, $5uXOq.useState)(false);
        const [stickyQueryUpdated, setStickyQueryUpdated] = (0, $5uXOq.useState)(false);
        const queryFirstUpdatedRef = (0, $5uXOq.useRef)(undefined);
        const lastExpandRef = (0, $5uXOq.useRef)(false);
        const lastQueryRef = (0, $5uXOq.useRef)('');
        const timeoutRef = (0, $5uXOq.useRef)();
        const resetConfluenceFiltersRef = (0, $5uXOq.useRef)();
        const resetExtensibleFiltersRef = (0, $5uXOq.useRef)();
        const sessionShowSearchAIDialogStr = (0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_SHOW_AI_DIALOG_KEY));
        const sessionShowSearchAIDialog = sessionShowSearchAIDialogStr ? JSON.parse(sessionShowSearchAIDialogStr) : false;
        const [showSearchAIDialog, setShowSearchAIDialog] = (0, $5uXOq.useState)(sessionShowSearchAIDialog);
        const resetSearchSession = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("3ZeOg")).deleteSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_QUERY_KEY));
            (0, (0, parcelRequire("3ZeOg")).deleteSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_FILTERS_KEY));
            (0, (0, parcelRequire("3ZeOg")).deleteSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_SHOW_AI_DIALOG_KEY));
            resetConfluenceFiltersRef.current?.();
            resetExtensibleFiltersRef.current?.();
            setQuery('');
            setShowSearchAIDialog(false);
            queryFirstUpdatedRef.current = undefined;
            lastQueryRef.current = '';
        }, [
            resetConfluenceFiltersRef,
            resetExtensibleFiltersRef
        ]);
        const readFilters = (0, $5uXOq.useCallback)((productId)=>{
            const searchFilterString = (0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_FILTERS_KEY));
            const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
            if (productId in filters) return filters[productId];
            return {};
        }, []);
        const updateSessionResetTimeout = (0, $5uXOq.useCallback)(()=>{
            if (timeoutRef?.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                if (timeoutRef?.current) clearTimeout(timeoutRef.current);
                const searchFilterString = (0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_FILTERS_KEY));
                const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
                if (query === '' && !$2425567f2928b10c$var$anyConfluenceFiltersChecked(filters)) return;
                resetSearchSession();
                fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onStickySearchCleared)({
                    timeout: sessionResetIdleTime
                }));
            }, sessionResetIdleTime);
        }, [
            query,
            sessionResetIdleTime,
            resetSearchSession,
            fireAnalyticsEvent
        ]);
        const storeQuery = (0, $5uXOq.useCallback)((query)=>{
            setQuery(query);
            (0, (0, parcelRequire("3ZeOg")).setSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_QUERY_KEY), query);
            updateSessionResetTimeout();
            if (queryFirstUpdatedRef.current === undefined) queryFirstUpdatedRef.current = Date.now();
            if (lastQueryRef.current) setStickyQueryUpdated(query !== lastQueryRef.current);
        }, [
            updateSessionResetTimeout
        ]);
        const toggleShowSearchAIDialog = (0, $5uXOq.useCallback)((showSearchAIDialog)=>{
            setShowSearchAIDialog(showSearchAIDialog);
            (0, (0, parcelRequire("3ZeOg")).setSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_SHOW_AI_DIALOG_KEY), showSearchAIDialog.toString());
        }, []);
        const storeFilters = (0, $5uXOq.useCallback)((productId, value)=>{
            const searchFilterString = (0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_FILTERS_KEY));
            const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
            filters[productId] = value;
            (0, (0, parcelRequire("3ZeOg")).setSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_FILTERS_KEY), JSON.stringify(filters));
            if (lastExpandRef.current) updateSessionResetTimeout;
        }, [
            lastExpandRef,
            updateSessionResetTimeout
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (resetStickySearchRef) resetStickySearchRef.current = resetSearchSession;
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!lastExpandRef.current && isExpanded) updateSessionResetTimeout();
            if (lastExpandRef.current && !isExpanded) updateSessionResetTimeout();
        }, [
            lastExpandRef,
            isExpanded,
            updateSessionResetTimeout
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!lastExpandRef.current && isExpanded) {
                setIsStickyUpdated(query !== '');
                lastQueryRef.current = query;
                setStickyQueryUpdated(false);
            }
            lastExpandRef.current = isExpanded;
        }, [
            isExpanded,
            lastExpandRef,
            lastQueryRef,
            query
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2425567f2928b10c$export$c87c231bb0fb0228.Provider, {
            value: {
                stickySearchEnabled: stickySearchEnabled,
                query: query,
                showSearchAIDialog: showSearchAIDialog,
                storeQuery: stickySearchEnabled ? storeQuery : $2425567f2928b10c$var$noop,
                toggleShowSearchAIDialog: toggleShowSearchAIDialog,
                readFilters: stickySearchEnabled ? readFilters : $2425567f2928b10c$var$noop,
                storeFilters: stickySearchEnabled ? storeFilters : $2425567f2928b10c$var$noop,
                resetSearchSession: stickySearchEnabled ? resetSearchSession : $2425567f2928b10c$var$noop,
                resetConfluenceFiltersRef: stickySearchEnabled ? resetConfluenceFiltersRef : undefined,
                resetExtensibleFiltersRef: stickySearchEnabled ? resetExtensibleFiltersRef : undefined
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: stickySearchEnabled ? {
                isSticky: true,
                isStickyUpdated: isStickyUpdated,
                stickyQueryUpdated: stickyQueryUpdated,
                queryUpdatedAgo: queryFirstUpdatedRef.current ? Date.now() - queryFirstUpdatedRef.current : undefined
            } : {
                isSticky: false
            }
        }, children));
    };
    const $2425567f2928b10c$export$296c1552a8cb35a5 = ()=>{
        return (0, $5uXOq.useContext)($2425567f2928b10c$export$c87c231bb0fb0228);
    };
});
parcelRegister("3ZeOg", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_QUERY_KEY", ()=>$ec26c0406ff6caf4$export$240cb7dc75f6cac2);
    $parcel$export(module.exports, "SEARCH_FILTERS_KEY", ()=>$ec26c0406ff6caf4$export$978fb20afa14aaa7);
    $parcel$export(module.exports, "SEARCH_SHOW_AI_DIALOG_KEY", ()=>$ec26c0406ff6caf4$export$f4dca218ecb5824a);
    $parcel$export(module.exports, "getSessionItem", ()=>$ec26c0406ff6caf4$export$fdf7104ff19cc288);
    $parcel$export(module.exports, "setSessionItem", ()=>$ec26c0406ff6caf4$export$a5376dd4adeb0fbf);
    $parcel$export(module.exports, "deleteSessionItem", ()=>$ec26c0406ff6caf4$export$5896963da935fdc4);
    const $ec26c0406ff6caf4$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
    const $ec26c0406ff6caf4$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
    const $ec26c0406ff6caf4$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
    const $ec26c0406ff6caf4$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
    const $ec26c0406ff6caf4$export$fdf7104ff19cc288 = (key)=>{
        return window.sessionStorage.getItem(key);
    };
    const $ec26c0406ff6caf4$export$a5376dd4adeb0fbf = (key, value)=>{
        try {
            window.sessionStorage.setItem(key, value);
        } catch (error) {
            error.code, DOMException.QUOTA_EXCEEDED_ERR;
        }
    };
    const $ec26c0406ff6caf4$export$5896963da935fdc4 = (key)=>{
        window.sessionStorage.removeItem(key);
    };
});
parcelRegister("e5JCl", function(module, exports) {
    $parcel$export(module.exports, "useAnalyticsContext", ()=>$f0b2b2e052773c1b$export$d1f587f82ad51c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oG5R;
    const $f0b2b2e052773c1b$var$defaultAnalyticsContextState = {
        queryVersion: 0,
        isLoading: false
    };
    const $f0b2b2e052773c1b$var$analyticsContextReducer = (state, action)=>{
        switch(action.type){
            case 'queryVersion':
                return {
                    ...state,
                    queryVersion: action.value
                };
            case 'isLoading':
                return {
                    ...state,
                    isLoading: action.value
                };
            case 'reset':
                return $f0b2b2e052773c1b$var$defaultAnalyticsContextState;
            default:
                throw new Error();
        }
    };
    const $f0b2b2e052773c1b$export$d1f587f82ad51c4 = (query)=>{
        const [{ queryVersion: queryVersion, isLoading: isLoading }, setAdditionalAnalyticsContext] = (0, $5uXOq.useReducer)($f0b2b2e052773c1b$var$analyticsContextReducer, $f0b2b2e052773c1b$var$defaultAnalyticsContextState);
        const addAnalyticContext = (0, $5uXOq.useCallback)(()=>{
            return {
                wordCount: (0, (0, parcelRequire("8oG5R")).getWordCount)(query),
                queryLength: query.length,
                queryHash: (0, (0, parcelRequire("8oG5R")).sha256Hash)(query),
                queryHashSHA256: (0, (0, parcelRequire("8oG5R")).sha256Hash)(query),
                queryVersion: queryVersion
            };
        }, [
            query,
            queryVersion
        ]);
        const nonPrivacySafeContext = (0, $5uXOq.useCallback)(()=>{
            return {
                query: query
            };
        }, [
            query
        ]);
        return {
            isLoading: isLoading,
            setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
            addAnalyticContext: addAnalyticContext,
            nonPrivacySafeContext: nonPrivacySafeContext,
            queryVersion: queryVersion
        };
    };
});
parcelRegister("dV2Gy", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSearchLinkWrapper", ()=>$a51e2d4a0639c8f2$export$8e79650dab255425);
    var $bWGt6 = parcelRequire("bWGt6");
    function $a51e2d4a0639c8f2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a51e2d4a0639c8f2$export$8e79650dab255425 = (0, $bWGt6.default)("span", {
        target: "ecy8ma0"
    })({
        name: "7whenc",
        styles: "display:flex;width:100%"
    });
});
parcelRegister("8Xs9r", function(module, exports) {
    $parcel$export(module.exports, "SearchDialogProduct", ()=>$e6bd28963f80b135$export$bea8d7c130bb15c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lgJ2n;
    var $dh6Py;
    var $i5cPn;
    var $1CzPM;
    var $2QmdW;
    const $e6bd28963f80b135$export$bea8d7c130bb15c8 = ({ generateAdvancedSearchUrl: genUrl, ...rest })=>{
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const generateAdvancedSearchUrl = (0, (0, parcelRequire("2QmdW")).useGenerateAdvancedSearchUrl)(genUrl);
        const props = {
            ...rest,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dh6Py")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lgJ2n")).AsyncProduct), {
            ...props,
            fallback: !isExpanded ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null) : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1CzPM")).AsyncProvider), props)));
    };
});
parcelRegister("lgJ2n", function(module, exports) {
    $parcel$export(module.exports, "AsyncProduct", ()=>$ab8b897c5f6791e8$export$ea887de8bd536d84);
    var $5uXOq = parcelRequire("5uXOq");
    var $cRsyH;
    var $edfe8;
    var $kv2Va;
    var $hedKk;
    var $kfPLS;
    class $ab8b897c5f6791e8$export$6bc62c4e30aa3c0a extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            const { removeProduct: removeProduct, id: id } = this.props;
            removeProduct(id);
        }
        render() {
            const { fallback: FallbackComponent, id: id, children: children } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kfPLS")).ActiveProduct), {
                    id: id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cRsyH")).TimeLazyLoad), {
                    product: id
                }, FallbackComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(FallbackComponent, null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("edfe8")).LoadingSpinner), null)))
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hedKk")).InitialisationExperienceSuccess), this.props), children);
        }
    }
    const $ab8b897c5f6791e8$export$ea887de8bd536d84 = (0, (0, parcelRequire("kv2Va")).withProductContext)($ab8b897c5f6791e8$export$6bc62c4e30aa3c0a);
});
parcelRegister("cRsyH", function(module, exports) {
    $parcel$export(module.exports, "TimeLazyLoad", ()=>$87190a03e27263a5$export$5a31ea5680c95894);
    var $5uXOq = parcelRequire("5uXOq");
    var $75NXP;
    var $3FqY6;
    const $87190a03e27263a5$export$5a31ea5680c95894 = ({ children: children, product: product })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            const start = Date.now();
            return ()=>{
                fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onPaneLoadComplete)(product, Date.now() - start));
            };
        }, [
            fireAnalyticsEvent,
            product
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("edfe8", function(module, exports) {
    $parcel$export(module.exports, "LoadingSpinner", ()=>$8dfc4f16120049f8$export$b08b517936747730);
    var $5uXOq = parcelRequire("5uXOq");
    var $dOTq1;
    var $eZJjh;
    const $8dfc4f16120049f8$export$b08b517936747730 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOTq1")).SpinnerContainer), {
            "data-testid": "search-dialog-loading-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOTq1")).HorizontalCenteredContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)));
});
parcelRegister("dOTq1", function(module, exports) {
    $parcel$export(module.exports, "HorizontalCenteredContainer", ()=>$81c9a6fe69fc2e72$export$574c01fef92380ae);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$81c9a6fe69fc2e72$export$a5e06607a5ac6158);
    var $k5uoT;
    var $bWGt6 = parcelRequire("bWGt6");
    function $81c9a6fe69fc2e72$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $81c9a6fe69fc2e72$export$574c01fef92380ae = (0, $bWGt6.default)("div", {
        target: "eh93uzp1"
    })({
        name: "9th5i",
        styles: "margin:0 auto"
    });
    const $81c9a6fe69fc2e72$export$a5e06607a5ac6158 = (0, $bWGt6.default)("div", {
        target: "eh93uzp0"
    })({
        height: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 12}px`,
        width: '100%',
        display: 'flex',
        alignItems: 'center'
    });
});
parcelRegister("hedKk", function(module, exports) {
    $parcel$export(module.exports, "InitialisationExperienceSuccess", ()=>$46f0cfaf913ce736$export$12ba87fc0c8ef4e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $4tuQr;
    var $kv2Va;
    var $9Mho6;
    const $46f0cfaf913ce736$export$7f8c86254a9e879c = ({ id: id, abTest: abTest, getPrimaryProduct: getPrimaryProduct })=>{
        const [successCalled, setSuccessCalled] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (successCalled) return;
            const primaryProduct = getPrimaryProduct();
            if (abTest && primaryProduct && primaryProduct.id === id) {
                (0, (0, parcelRequire("9Mho6")).initialisationExperience).success();
                setSuccessCalled(true);
            }
        }, [
            abTest,
            getPrimaryProduct,
            id,
            successCalled
        ]);
        return null;
    };
    const $46f0cfaf913ce736$export$12ba87fc0c8ef4e3 = (0, (0, parcelRequire("4tuQr")).withABTestContext)((0, (0, parcelRequire("kv2Va")).withProductContext)($46f0cfaf913ce736$export$7f8c86254a9e879c));
});
parcelRegister("4tuQr", function(module, exports) {
    $parcel$export(module.exports, "ABTestContextProvider", ()=>$62a14a729926e68c$export$e7d53dc13567ec0e);
    $parcel$export(module.exports, "useABTest", ()=>$62a14a729926e68c$export$14279a3fbdb52451);
    $parcel$export(module.exports, "withABTestContext", ()=>$62a14a729926e68c$export$5124bc23083a567d);
    var $5uXOq = parcelRequire("5uXOq");
    var $tUDIN;
    var $75NXP;
    var $3FqY6;
    var $jKEl7;
    var $lvCts;
    var $kv2Va;
    var $j97IK;
    const $62a14a729926e68c$export$22966a5ebf51ce99 = {
        abTestId: 'default',
        controlId: 'default',
        experimentId: 'default'
    };
    const $62a14a729926e68c$var$ABTestContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        abTest: null
    });
    const $62a14a729926e68c$var$ABTestContextProviderStateless = ({ isMultiProduct: isMultiProduct, searchClient: searchClient, scope: scope, children: children, primaryProductId: primaryProductId, experience: experience })=>{
        const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, (0, parcelRequire("j97IK")).useExperiments)();
        const [abTest, setAbTest] = (0, $5uXOq.useState)(backendExperiment || null);
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            const now = Date.now();
            if (!searchClient || !scope || abTest) return;
            searchClient.getAbTestData(scope, experience ?? (0, (0, parcelRequire("jKEl7")).PLACEHOLDER_EXPERIENCE), primaryProductId).then((abTestResponse)=>{
                const duration = Date.now() - now;
                const abTestWithDefault = abTestResponse || $62a14a729926e68c$export$22966a5ebf51ce99;
                setAbTest(abTestWithDefault);
                fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onExperimentLoaded)(abTestWithDefault, duration, !!isMultiProduct));
            }).catch((e)=>{
                setAbTest($62a14a729926e68c$export$22966a5ebf51ce99);
            });
        }, [
            searchClient,
            fireAnalyticsEvent,
            isMultiProduct,
            scope,
            abTest,
            primaryProductId,
            experience,
            backendExperiment
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($62a14a729926e68c$var$ABTestContext.Provider, {
            value: {
                abTest: abTest
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: {
                abTest: abTest || undefined,
                frontendExperiments: {
                    activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                    ...frontendExperiments
                }
            },
            nonPrivacySafeAnalyticContext: {}
        }, children));
    };
    const $62a14a729926e68c$export$e7d53dc13567ec0e = (props)=>{
        const { getPrimaryProduct: getPrimaryProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const searchClient = (0, (0, parcelRequire("lvCts")).useAggregatorClient)();
        const primaryProduct = getPrimaryProduct();
        const { sectionIds: sectionIds } = primaryProduct || {};
        const scope = (0, $5uXOq.useMemo)(()=>sectionIds && sectionIds.length > 0 ? sectionIds[0] : undefined, [
            sectionIds
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($62a14a729926e68c$var$ABTestContextProviderStateless, {
            ...props,
            scope: scope,
            searchClient: searchClient,
            primaryProductId: primaryProduct?.id
        });
    };
    const $62a14a729926e68c$export$14279a3fbdb52451 = ()=>{
        const { abTest: abTest } = (0, $5uXOq.useContext)($62a14a729926e68c$var$ABTestContext);
        return abTest;
    };
    const $62a14a729926e68c$export$5124bc23083a567d = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                ...(0, $5uXOq.useContext)($62a14a729926e68c$var$ABTestContext)
            });
    };
});
parcelRegister("9Mho6", function(module, exports) {
    $parcel$export(module.exports, "COMPONENT", ()=>$e32e5db0ac5f4101$export$af1e30ebbae9df3b);
    $parcel$export(module.exports, "initialisationExperience", ()=>$e32e5db0ac5f4101$export$e5b98327036a989d);
    var $atdLB;
    var $duUGa;
    const $e32e5db0ac5f4101$export$af1e30ebbae9df3b = 'search-dialog';
    const $e32e5db0ac5f4101$export$e5b98327036a989d = new (0, (0, parcelRequire("duUGa")).UFOExperience)('intialisation', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: $e32e5db0ac5f4101$export$af1e30ebbae9df3b
        }
    });
});
parcelRegister("kfPLS", function(module, exports) {
    $parcel$export(module.exports, "ActiveProduct", ()=>$0bc97596379e2299$export$13224c53a1606253);
    var $5uXOq = parcelRequire("5uXOq");
    var $kv2Va;
    const $0bc97596379e2299$export$13224c53a1606253 = ({ children: children, id: id })=>{
        const { getProduct: getProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const product = getProduct(id);
        if (!product?.isDisplayed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("dh6Py", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ae1fd540ac967a4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jKEl7;
    var $lvCts;
    var $kv2Va;
    var $97Hug;
    const $5ae1fd540ac967a4$export$8e8702b7c6f58328 = ({ children: children, permissionSupplier: permissionSupplier, id: id, title: title, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter })=>{
        const invokePostQuerySearchRef = (0, $5uXOq.useRef)(()=>{});
        const [allowedSections, setAllowedSections] = (0, $5uXOq.useState)([]);
        const searchClient = (0, (0, parcelRequire("lvCts")).useAggregatorClient)();
        (0, $5uXOq.useEffect)(()=>{
            if (allowedSections.length === 0) {
                const promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
                    productIds: [
                        id
                    ],
                    experience: (0, (0, parcelRequire("jKEl7")).PLACEHOLDER_EXPERIENCE)
                }) : Promise.resolve([]);
                promise.then((response)=>{
                    setAllowedSections(response);
                });
            }
        }, []);
        return allowedSections.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("97Hug")).default), {
            allowedSections: allowedSections,
            sections: sections,
            id: id,
            title: title,
            order: order,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            expandedStateInputPlaceholder: expandedStateInputPlaceholder,
            workspaces: workspaces,
            autocorrectEnabled: autocorrectEnabled,
            showViewAllFiltersLink: showViewAllFiltersLink,
            tabRenderer: tabRenderer,
            aiSearchConfig: aiSearchConfig,
            showSearchOnEnter: showSearchOnEnter,
            invokePostQuerySearchRef: invokePostQuerySearchRef
        }, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    var $5ae1fd540ac967a4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("kv2Va")).withProductContext)($5ae1fd540ac967a4$export$8e8702b7c6f58328);
});
parcelRegister("97Hug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c06cca48547accb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kv2Va;
    const $3c06cca48547accb$export$90be722c085777fe = ({ addProduct: addProduct, updateProduct: updateProduct, id: id, title: title, children: children, allowedSections: allowedSections, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter, invokePostQuerySearchRef: invokePostQuerySearchRef })=>{
        const [originalId] = (0, $5uXOq.useState)(id);
        const [registeredProduct, setRegisteredProduct] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (allowedSections.length > 0) {
                const allowedSectionString = allowedSections.join(' ');
                const allowedRegisteredSections = sections.map((sec)=>sec.id).filter((sectionId)=>{
                    const sectionIds = sectionId.replace(id, '').replace('.', '').split(',');
                    let allowed = true;
                    sectionIds.forEach((section)=>{
                        if (allowedSectionString.indexOf(section) === -1) allowed = false;
                    });
                    return allowed;
                });
                if (allowedRegisteredSections.length > 0) {
                    addProduct({
                        id: id,
                        title: title,
                        sectionIds: sections.map((sec)=>sec.id),
                        order: order,
                        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
                        expandedStateInputPlaceholder: expandedStateInputPlaceholder,
                        workspaces: workspaces,
                        autocorrectEnabled: autocorrectEnabled,
                        showViewAllFiltersLink: showViewAllFiltersLink,
                        tabRenderer: tabRenderer,
                        aiSearchConfig: aiSearchConfig,
                        showSearchOnEnter: showSearchOnEnter,
                        invokePostQuerySearchRef: invokePostQuerySearchRef
                    });
                    setRegisteredProduct(true);
                }
            }
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!registeredProduct) return;
            if (id !== originalId) {
                console.error("product-search-dialog: Cannot update a different product's properties. Did you change accidentally change a product's id?");
                return;
            }
            updateProduct({
                id: id,
                generateAdvancedSearchUrl: generateAdvancedSearchUrl,
                tabRenderer: tabRenderer
            });
        }, [
            registeredProduct,
            id,
            originalId,
            updateProduct,
            generateAdvancedSearchUrl,
            tabRenderer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    var $3c06cca48547accb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("kv2Va")).withProductContext)($3c06cca48547accb$export$90be722c085777fe);
});
parcelRegister("1CzPM", function(module, exports) {
    $parcel$export(module.exports, "AsyncProvider", ()=>$64f4abae63d25af6$export$2f9c5c9733d48598);
    var $5uXOq = parcelRequire("5uXOq");
    const $64f4abae63d25af6$var$AsyncResultProvider = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("ePXOQ")).then(({ ResultProvider: ResultProvider })=>({
                default: ResultProvider
            })));
    const $64f4abae63d25af6$export$2f9c5c9733d48598 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($64f4abae63d25af6$var$AsyncResultProvider, props, props.children);
});
parcelRegister("ePXOQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gAUB6").then(()=>parcelRequire('83lE1'));
});
parcelRegister("2QmdW", function(module, exports) {
    $parcel$export(module.exports, "useGenerateAdvancedSearchUrl", ()=>$a9c90e41ea87daaa$export$25a2b20022e2a01a);
    var $5uXOq = parcelRequire("5uXOq");
    var $hNXQY;
    var $4QKbG;
    const $a9c90e41ea87daaa$export$25a2b20022e2a01a = (genUrl)=>{
        const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        const { queryParams: queryParams } = (0, (0, parcelRequire("4QKbG")).useQueryParams)();
        return (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
            const advancedSearchUrl = genUrl?.(query, baseUrl, usage) || '';
            if (isGriffinNavEnabled) {
                const urlParts = advancedSearchUrl.split('?');
                const { text: text, originalQuery: originalQuery, ...rest } = queryParams || {};
                return `${urlParts[0]}?${new URLSearchParams({
                    ...rest,
                    ...query !== '' && {
                        text: query
                    }
                }).toString()}`;
            }
            return advancedSearchUrl;
        }, [
            genUrl,
            isGriffinNavEnabled,
            queryParams
        ]);
    };
});
parcelRegister("hNXQY", function(module, exports) {
    $parcel$export(module.exports, "FeaturesProvider", ()=>$b912e1fafdf2e976$export$502d46f2366b5b43);
    $parcel$export(module.exports, "useFeaturesContext", ()=>$b912e1fafdf2e976$export$38c566c0640fb69a);
    var $5uXOq = parcelRequire("5uXOq");
    var $4QKbG;
    const $b912e1fafdf2e976$export$98552201007e6417 = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    const $b912e1fafdf2e976$export$502d46f2366b5b43 = ({ dialogFeatures: dialogFeatures = {}, children: children })=>{
        const { queryParams: queryParams } = (0, (0, parcelRequire("4QKbG")).useQueryParams)();
        const isGriffinNavEnabled = (0, $5uXOq.useMemo)(()=>dialogFeatures.isGriffinNavEnabled === true && queryParams !== undefined, [
            dialogFeatures.isGriffinNavEnabled,
            queryParams
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($b912e1fafdf2e976$export$98552201007e6417.Provider, {
            value: {
                ...dialogFeatures,
                isGriffinNavEnabled: isGriffinNavEnabled
            }
        }, children));
    };
    const $b912e1fafdf2e976$export$38c566c0640fb69a = ()=>{
        return (0, $5uXOq.useContext)($b912e1fafdf2e976$export$98552201007e6417);
    };
});
parcelRegister("4QKbG", function(module, exports) {
    $parcel$export(module.exports, "QueryParamsProvider", ()=>$02989d7843adadc2$export$90a656ad86ba2e2);
    $parcel$export(module.exports, "useQueryParams", ()=>$02989d7843adadc2$export$b37ee0d76c6d2fbc);
    var $5uXOq = parcelRequire("5uXOq");
    const $02989d7843adadc2$var$Context = (0, ($parcel$interopDefault($5uXOq))).createContext({
        queryParams: undefined
    });
    const $02989d7843adadc2$export$90a656ad86ba2e2 = ({ queryParams: queryParams, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($02989d7843adadc2$var$Context.Provider, {
            value: {
                queryParams: queryParams
            }
        }, children);
    };
    const $02989d7843adadc2$export$b37ee0d76c6d2fbc = ()=>{
        return (0, $5uXOq.useContext)($02989d7843adadc2$var$Context);
    };
});
parcelRegister("kbhX0", function(module, exports) {
    $parcel$export(module.exports, "useBitbucketPermissionSupplier", ()=>$840e389fc265c74e$export$e0a27ecb613d1aab);
    var $5uXOq = parcelRequire("5uXOq");
    var $jKEl7;
    var $lvCts;
    var $b1ovj;
    const $840e389fc265c74e$export$e0a27ecb613d1aab = (overridenPermissionsSupplier)=>{
        const client = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        return (0, $5uXOq.useMemo)(()=>{
            if (overridenPermissionsSupplier) return overridenPermissionsSupplier;
            return ()=>client?.getProductScopes((0, (0, parcelRequire("b1ovj")).BITBUCKET_PRODUCT_ID), (0, (0, parcelRequire("jKEl7")).PLACEHOLDER_EXPERIENCE)) || [];
        }, [
            client,
            overridenPermissionsSupplier
        ]);
    };
});
parcelRegister("b1ovj", function(module, exports) {
    $parcel$export(module.exports, "BitbucketScope", ()=>$e605897f10838a92$export$30e31f52a81be3c8);
    $parcel$export(module.exports, "BITBUCKET_PRODUCT_ID", ()=>$e605897f10838a92$export$49fc3e2141fc5779);
    var $e605897f10838a92$export$30e31f52a81be3c8;
    (function(BitbucketScope) {
        BitbucketScope["BitbucketRepostitory"] = "bitbucket.repository";
    })($e605897f10838a92$export$30e31f52a81be3c8 || ($e605897f10838a92$export$30e31f52a81be3c8 = {}));
    const $e605897f10838a92$export$49fc3e2141fc5779 = 'bitbucket';
});
parcelRegister("hEvMC", function(module, exports) {
    $parcel$export(module.exports, "bitbucketURLGenerators", ()=>$76ef6489237afc4f$export$8f020ef2e5947a78);
    const $76ef6489237afc4f$var$getBitbucketBaseURL = ()=>{
        const hostname = window.location.hostname;
        if (hostname.includes('jira-dev.com') || hostname.startsWith('localhost')) return 'https://staging.bb-inf.net';
        return 'https://bitbucket.org';
    };
    const $76ef6489237afc4f$export$8f020ef2e5947a78 = (overrides)=>{
        const viewAllLinkGenerator = (query)=>`${$76ef6489237afc4f$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}`;
        const urlGeneratorForNoResultsScreen = (query)=>query ? `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}` : `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/dashboard/repositories`;
        const codeSearchUrlGenerator = (query)=>query ? `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/search?q=${encodeURIComponent(query)}` : `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/search`;
        const codeSearchContextualUrlGenerator = (query, context)=>{
            const { repository: repository, workspace: workspace } = context;
            let fullModifier = query || repository ? '?q=' : '';
            if (repository) {
                const repoSlug = encodeURIComponent(`repo:${repository.slug} `);
                fullModifier = `${fullModifier}${repoSlug}`;
            }
            if (query) fullModifier = `${fullModifier}${encodeURIComponent(query)}`;
            const workspaceUUID = repository?.workspace?.uuid || workspace?.uuid;
            if (workspaceUUID) fullModifier = fullModifier ? `${fullModifier}&account=${encodeURIComponent(workspaceUUID)}` : `?account=${encodeURIComponent(workspaceUUID)}`;
            return `${$76ef6489237afc4f$var$getBitbucketBaseURL()}/search${fullModifier}`;
        };
        return {
            viewAllLinkGenerator: overrides?.viewAllLinkGenerator || viewAllLinkGenerator,
            urlGeneratorForNoResultsScreen: overrides?.urlGeneratorForNoResultsScreen || urlGeneratorForNoResultsScreen,
            codeSearchUrlGenerator: overrides?.codeSearchUrlGenerator || codeSearchUrlGenerator,
            codeSearchContextualUrlGenerator: overrides?.codeSearchContextualUrlGenerator || codeSearchContextualUrlGenerator
        };
    };
});
parcelRegister("gZ0uu", function(module, exports) {
    $parcel$export(module.exports, "CompassTab", ()=>$14370b7f16d72bd9$export$47b1e713578cc03f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $kwW3T;
    var $cxU5p;
    var $8Xs9r;
    var $azBuE;
    var $j1cmh;
    var $3R5l7;
    var $5OxSR;
    var $6zJmu;
    var $e53Rq;
    const $14370b7f16d72bd9$var$UpsellModal = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("eVJaE")).then((mod)=>({
                default: mod.UpsellModal
            })));
    const $14370b7f16d72bd9$var$upsellPermissionSupplier = ()=>{
        const response = Object.values((0, (0, parcelRequire("5OxSR")).CompassScope));
        return Promise.resolve(response);
    };
    const $14370b7f16d72bd9$var$CompassTabWithIntl = ({ baseUrl: baseUrl, crossFlowEnabled: crossFlowEnabled, intl: intl, isCompassActivated: isCompassActivated = false, isUserAnonymous: isUserAnonymous = false, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, sourceContext: sourceContext, upsellCtaButtonProps: upsellCtaButtonProps, userTeamConfig: userTeamConfig, ...rest })=>{
        const { advancedSearchLinkGenerator: advancedSearchLinkGenerator } = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("e53Rq")).compassURLGenerators)(baseUrl);
        }, [
            baseUrl
        ]);
        const sections = (0, (0, parcelRequire("j1cmh")).getSections)(intl);
        const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, (0, parcelRequire("3R5l7")).useCompassSuppliers)({
            userTeamConfig: userTeamConfig,
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        }, sections);
        const getAdvancedSearchButtonLabel = (0, $5uXOq.useCallback)((productState)=>{
            switch(productState){
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryLoading:
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess:
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryError:
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryNoResult:
                    return intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_view_all_components);
                default:
                    return intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_view_all_results);
            }
        }, [
            intl
        ]);
        const upsellTabRenderer = (0, $5uXOq.useCallback)(({ title: title })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6zJmu")).UpsellTab), {
                title: title
            });
        }, []);
        const shouldUpsell = !isUserAnonymous && crossFlowEnabled && !isCompassActivated;
        const permissionSupplier = shouldUpsell ? $14370b7f16d72bd9$var$upsellPermissionSupplier : rest.permissionSupplier;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            id: (0, (0, parcelRequire("3R5l7")).COMPASS_PRODUCT_ID),
            sections: sections,
            title: intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_tab_label),
            expandedStateInputPlaceholder: intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_expanded_input_placeholder),
            generateAdvancedSearchUrl: advancedSearchLinkGenerator,
            preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
            preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
            postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
            tabRenderer: shouldUpsell ? upsellTabRenderer : undefined,
            permissionSupplier: permissionSupplier,
            ...rest
        }, ({ linkComponent: linkComponent, productState: productState, query: query })=>{
            if (shouldUpsell) return {
                Body: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($14370b7f16d72bd9$var$UpsellModal, {
                        sourceContext: sourceContext ?? 'product search dialog',
                        ctaButtonProps: upsellCtaButtonProps
                    }),
                Footer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
            };
            const advancedSearchUrl = advancedSearchLinkGenerator(query);
            const message = getAdvancedSearchButtonLabel(productState);
            return {
                Header: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cxU5p")).AdvancedSearch), {
                        advancedSearchMessage: message,
                        advancedSearchUrl: advancedSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
            };
        });
    };
    const $14370b7f16d72bd9$export$47b1e713578cc03f = (0, (0, parcelRequire("8RXs9")).default)($14370b7f16d72bd9$var$CompassTabWithIntl);
});
parcelRegister("kwW3T", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$032c54b3b0adfc72$export$defe85febe8b728c);
    var $7VHMR;
    const $032c54b3b0adfc72$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        compass_tab_label: {
            id: 'product_search_dialog.compass.tab_label',
            defaultMessage: 'Compass',
            description: 'Label to display for the Compass search tab'
        },
        compass_components_section_heading: {
            id: 'product_search_dialog.compass.components_section_heading',
            defaultMessage: 'Components',
            description: 'Header for the components search flyout section'
        },
        compass_people_section_heading: {
            id: 'product_search_dialog.compass.people_section_heading',
            defaultMessage: 'People',
            description: 'People section header'
        },
        compass_teams_section_heading: {
            id: 'product_search_dialog.compass.teams_section_heading',
            defaultMessage: 'Teams',
            description: 'Teams section header'
        },
        compass_expanded_input_placeholder: {
            id: 'product_search_dialog.compass.expanded.input-placeholder',
            defaultMessage: 'Search Compass',
            description: 'The placeholder which is visible to the user when Compass tab is active '
        },
        compass_view_all_components: {
            id: 'product_search_dialog.compass.view_all_components_label',
            defaultMessage: 'View all components',
            description: 'Compass tab advanced search link text'
        },
        compass_view_all_results: {
            id: 'product_search_dialog.compass.view_all_results_label',
            defaultMessage: 'View all results',
            description: 'Compass tab advanced search link text for post query and error states'
        },
        compass_component_type_service: {
            id: 'product_search_dialog.compass.component_type.service',
            defaultMessage: 'Service',
            description: 'Tool tip shown for Service components'
        },
        compass_component_type_library: {
            id: 'product_search_dialog.compass.component_type.library',
            defaultMessage: 'Library',
            description: 'Tool tip shown for Library components'
        },
        compass_component_type_application: {
            id: 'product_search_dialog.compass.component_type.application',
            defaultMessage: 'Application',
            description: 'Tool tip shown for Application components'
        },
        compass_component_type_capability: {
            id: 'product_search_dialog.compass.component_type.capability',
            defaultMessage: 'Capability',
            description: 'Tool tip shown for Capability components'
        },
        compass_component_type_cloud_resource: {
            id: 'product_search_dialog.compass.component_type.cloud_resource',
            defaultMessage: 'Cloud resource',
            description: 'Tool tip shown for Cloud resource components'
        },
        compass_component_type_data_pipeline: {
            id: 'product_search_dialog.compass.component_type.data_pipeline',
            defaultMessage: 'Data pipeline',
            description: 'Tool tip shown for Data pipeline components'
        },
        compass_component_type_machine_learning_model: {
            id: 'product_search_dialog.compass.component_type.machine_learning_model',
            defaultMessage: 'Machine learning model',
            description: 'Tool tip shown for Machine learning model components'
        },
        compass_component_type_ui_element: {
            id: 'product_search_dialog.compass.component_type.ui_element',
            defaultMessage: 'UI element',
            description: 'Tool tip shown for UI element components'
        },
        compass_component_type_website: {
            id: 'product_search_dialog.compass.component_type.website',
            defaultMessage: 'Website',
            description: 'Tool tip shown for Website components'
        },
        compass_component_type_other: {
            id: 'product_search_dialog.compass.component_type.other',
            defaultMessage: 'Other',
            description: 'Tool tip shown for Other components'
        },
        compass_recently_viewed_components: {
            id: 'product_search_dialog.compass.recently_viewed_components',
            defaultMessage: 'Recently viewed components',
            description: 'Header for recently viewed components'
        },
        compass_recently_viewed_teams: {
            id: 'product_search_dialog.compass.recently_viewed_teams',
            defaultMessage: 'Recently viewed teams',
            description: 'Header for recently viewed teams'
        }
    });
});
parcelRegister("azBuE", function(module, exports) {
    $parcel$export(module.exports, "APIStates", ()=>$c05bd9c3eaf7d970$export$c701d1d8ac310aa0);
    $parcel$export(module.exports, "ProductStates", ()=>$c05bd9c3eaf7d970$export$212790b4ffec121f);
    var $c05bd9c3eaf7d970$export$c701d1d8ac310aa0;
    (function(APIStates) {
        APIStates["Typing"] = "typing";
        APIStates["Loading"] = "loading";
        APIStates["Error"] = "error";
        APIStates["NoResult"] = "noresult";
        APIStates["Success"] = "success";
    })($c05bd9c3eaf7d970$export$c701d1d8ac310aa0 || ($c05bd9c3eaf7d970$export$c701d1d8ac310aa0 = {}));
    var $c05bd9c3eaf7d970$export$212790b4ffec121f;
    (function(ProductStates) {
        ProductStates["PreQueryLoading"] = "PreQueryLoading";
        ProductStates["PostQueryLoading"] = "PostQueryLoading";
        ProductStates["PreQuerySuccess"] = "PreQuerySuccess";
        ProductStates["PostQuerySuccess"] = "PostQuerySuccess";
        ProductStates["PreQueryError"] = "PreQueryError";
        ProductStates["PostQueryError"] = "PostQueryError";
        ProductStates["PreQueryNoResult"] = "PreQueryNoResult";
        ProductStates["PostQueryNoResult"] = "PostQueryNoResult";
        ProductStates["PostQueryTyping"] = "PostQueryTyping";
        ProductStates["Invalid"] = "Invalid";
    })($c05bd9c3eaf7d970$export$212790b4ffec121f || ($c05bd9c3eaf7d970$export$212790b4ffec121f = {}));
});
parcelRegister("j1cmh", function(module, exports) {
    $parcel$export(module.exports, "getSections", ()=>$2e696b52ef5b358a$export$ddbcae0b0bd6b092);
    var $kwW3T;
    var $5OxSR;
    var $kFdjV;
    const $2e696b52ef5b358a$var$mapAggregatorResponseToSearchItem = (response)=>({
            title: response.title,
            id: response.id,
            meta: response.ownerId,
            url: response.url,
            icon: response.type,
            containerId: ''
        });
    const $2e696b52ef5b358a$export$ddbcae0b0bd6b092 = (intl)=>[
            {
                id: (0, (0, parcelRequire("5OxSR")).CompassScope).Component,
                title: intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_components_section_heading),
                scope: (0, (0, parcelRequire("5OxSR")).CompassScope).Component,
                showResultCount: true,
                resultRenderer: (0, (0, parcelRequire("kFdjV")).componentResultRenderer),
                resultMapper: ({ results: results })=>results.map((value)=>$2e696b52ef5b358a$var$mapAggregatorResponseToSearchItem(value))
            }
        ];
});
parcelRegister("5OxSR", function(module, exports) {
    $parcel$export(module.exports, "CompassScope", ()=>$78d0ffb73fa58faa$export$7dfd429914c57d74);
    $parcel$export(module.exports, "COMPONENT_TYPES", ()=>$78d0ffb73fa58faa$export$6349b6efda58d149);
    var $5uXOq = parcelRequire("5uXOq");
    var $kwW3T;
    var $78d0ffb73fa58faa$export$7dfd429914c57d74;
    (function(CompassScope) {
        CompassScope["Component"] = "compass.component";
        CompassScope["People"] = "compass.people";
        CompassScope["Teams"] = "compass.teams";
    })($78d0ffb73fa58faa$export$7dfd429914c57d74 || ($78d0ffb73fa58faa$export$7dfd429914c57d74 = {}));
    const $78d0ffb73fa58faa$export$6349b6efda58d149 = {
        SERVICE: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_service
        },
        LIBRARY: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$874739ea9e379ab6})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_library
        },
        APPLICATION: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$940e1f69e873f202})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_application
        },
        CAPABILITY: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$7090862dc3038a9f})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5145 6.15717C10.5145 6.97758 11.1796 7.64266 12 7.64266C12.8204 7.64266 13.4855 6.97758 13.4855 6.15717C13.4855 5.33676 12.8204 4.67168 12 4.67168C11.1796 4.67168 10.5145 5.33676 10.5145 6.15717ZM11.15 9.22799C10.8953 9.15765 10.6534 9.05647 10.4286 8.92873L8.93348 10.426C9.19656 10.8894 9.34679 11.4253 9.34679 11.9963C9.34679 13.7556 7.9206 15.1818 6.1613 15.1818C4.40201 15.1818 2.97581 13.7556 2.97581 11.9963C2.97581 10.237 4.40201 8.81083 6.1613 8.81083C6.73217 8.81083 7.26796 8.96099 7.73134 9.22398L9.22707 7.72612C8.96447 7.263 8.81454 6.72759 8.81454 6.15717C8.81454 4.39787 10.2407 2.97168 12 2.97168C13.7593 2.97168 15.1855 4.39787 15.1855 6.15717C15.1855 6.72831 15.0352 7.26434 14.772 7.72787L16.2683 9.22419C16.7318 8.96107 17.2677 8.81083 17.8387 8.81083C19.598 8.81083 21.0242 10.237 21.0242 11.9963C21.0242 13.7556 19.598 15.1818 17.8387 15.1818C16.0794 15.1818 14.6532 13.7556 14.6532 11.9963C14.6532 11.4255 14.8034 10.8897 15.0663 10.4264L13.5697 8.92972C13.3453 9.057 13.104 9.15784 12.85 9.228V14.7646C14.1966 15.1366 15.1855 16.3705 15.1855 17.8355C15.1855 19.5948 13.7593 21.021 12 21.021C10.2407 21.021 8.81454 19.5948 8.81454 17.8355C8.81454 16.3705 9.80338 15.1366 11.15 14.7646V9.22799ZM4.67581 11.9963C4.67581 12.8167 5.34089 13.4818 6.1613 13.4818C6.98172 13.4818 7.64679 12.8167 7.64679 11.9963C7.64679 11.1759 6.98172 10.5108 6.1613 10.5108C5.34089 10.5108 4.67581 11.1759 4.67581 11.9963ZM12 19.321C11.1796 19.321 10.5145 18.6559 10.5145 17.8355C10.5145 17.0151 11.1796 16.35 12 16.35C12.8204 16.35 13.4855 17.0151 13.4855 17.8355C13.4855 18.6559 12.8204 19.321 12 19.321ZM16.3532 11.9963C16.3532 12.8167 17.0183 13.4818 17.8387 13.4818C18.6591 13.4818 19.3242 12.8167 19.3242 11.9963C19.3242 11.1759 18.6591 10.5108 17.8387 10.5108C17.0183 10.5108 16.3532 11.1759 16.3532 11.9963Z"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_capability
        },
        CLOUD_RESOURCE: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                    stroke: "#fff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                    stroke: "#fff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_cloud_resource
        },
        DATA_PIPELINE: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$4a7404f376229999})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                    stroke: "#fff",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                    stroke: "#fff",
                    strokeWidth: "1.7",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                    stroke: "#fff",
                    strokeWidth: "1.8",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_data_pipeline
        },
        MACHINE_LEARNING_MODEL: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$4a7404f376229999})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                    stroke: "#fff",
                    strokeWidth: "1.5",
                    strokeLinejoin: "round"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M4.61222 7.89078L18.8696 16.1906",
                    stroke: "#fff",
                    strokeWidth: "1.5"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M4.85273 16.2901L19.0688 7.95921",
                    stroke: "#fff",
                    strokeWidth: "1.5"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "none",
                    d: "M11.7317 20.2989L11.7317 3.24756",
                    stroke: "#fff",
                    strokeWidth: "1.5"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "#FF5630",
                    d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                    stroke: "#fff",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_machine_learning_model
        },
        UI_ELEMENT: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$874739ea9e379ab6})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "path-1-inside-1_1403_23012",
                    fill: "white"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "2.83353",
                    y: "13.6489",
                    width: "6.97358",
                    height: "7.36887",
                    rx: "1"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    fill: "none",
                    x: "2.83353",
                    y: "13.6489",
                    width: "6.97358",
                    height: "7.36887",
                    rx: "1",
                    stroke: "#fff",
                    strokeWidth: "3.2",
                    mask: "url(#path-1-inside-1_1403_23012)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "path-2-inside-2_1403_23012",
                    fill: "white"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "2.83353",
                    y: "3.01807",
                    width: "18.5455",
                    height: "8.59702",
                    rx: "1"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    fill: "none",
                    x: "2.83353",
                    y: "3.01807",
                    width: "18.5455",
                    height: "8.59702",
                    rx: "1",
                    stroke: "#fff",
                    strokeWidth: "3.2",
                    mask: "url(#path-2-inside-2_1403_23012)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "path-3-inside-3_1403_23012",
                    fill: "white"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "11.5089",
                    y: "13.6489",
                    width: "9.87006",
                    height: "7.36887",
                    rx: "1"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    fill: "none",
                    x: "11.5089",
                    y: "13.6489",
                    width: "9.87006",
                    height: "7.36887",
                    rx: "1",
                    stroke: "#fff",
                    strokeWidth: "3.2",
                    mask: "url(#path-3-inside-3_1403_23012)"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_ui_element
        },
        WEBSITE: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$940e1f69e873f202})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: "fff",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.3319 20.9136C13.5069 20.9136 14.6704 20.6821 15.756 20.2325C16.8416 19.7828 17.828 19.1237 18.6589 18.2928C19.4898 17.462 20.1489 16.4756 20.5985 15.39C21.0482 14.3044 21.2796 13.1409 21.2796 11.9658C21.2796 10.7908 21.0482 9.62725 20.5985 8.54166C20.1489 7.45607 19.4898 6.46968 18.6589 5.6388C17.828 4.80793 16.8416 4.14884 15.756 3.69917C14.6704 3.24951 13.5069 3.01807 12.3319 3.01807C9.95879 3.01807 7.68289 3.96077 6.00486 5.6388C4.32683 7.31683 3.38412 9.59273 3.38412 11.9658C3.38412 14.3389 4.32683 16.6148 6.00486 18.2928C7.68289 19.9709 9.95879 20.9136 12.3319 20.9136V20.9136ZM11.4371 19.0614C9.70752 18.8456 8.11636 18.0054 6.96289 16.6987C5.80941 15.3919 5.17312 13.7088 5.17368 11.9658C5.17368 11.4111 5.24526 10.8831 5.36158 10.3642L9.64755 14.6501V15.5449C9.64755 16.5292 10.4529 17.3345 11.4371 17.3345V19.0614V19.0614ZM17.6111 16.7887C17.4975 16.427 17.2713 16.1113 16.9654 15.8875C16.6595 15.6637 16.29 15.5436 15.911 15.5449H15.0162V12.8606C15.0162 12.3685 14.6136 11.9658 14.1214 11.9658H8.75278V10.1763H10.5423C11.0345 10.1763 11.4371 9.77362 11.4371 9.28149V7.49194H13.2267C14.2109 7.49194 15.0162 6.68665 15.0162 5.70239V5.33553C17.6379 6.40032 19.4901 8.96832 19.4901 11.9658C19.4901 13.827 18.7743 15.5181 17.6111 16.7887V16.7887Z"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_website
        },
        OTHER: {
            color: `var(--ds-icon, ${$829f609a65d26a98$export$e62e8919cca44969})`,
            icon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z"
                })),
            message: (0, (0, parcelRequire("kwW3T")).messages).compass_component_type_other
        }
    };
});
parcelRegister("kFdjV", function(module, exports) {
    $parcel$export(module.exports, "componentResultRenderer", ()=>$351101053ea517bd$export$f2eed8836fc2639e);
    $parcel$export(module.exports, "peopleAndTeamsResultRenderer", ()=>$351101053ea517bd$export$3269347603d2224e);
    var $5uXOq = parcelRequire("5uXOq");
    var $azBuE;
    var $8UVcc;
    var $1KrIR;
    var $cvYmc;
    const $351101053ea517bd$export$f2eed8836fc2639e = (args)=>{
        const { productState: productState, searchResult: searchResult } = args;
        const iconSize = productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess ? 'small' : 'medium';
        const iconType = searchResult.icon?.toString() ?? '';
        return (0, (0, parcelRequire("cvYmc")).defaultResultRenderer)({
            ...args,
            searchResult: {
                ...searchResult,
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UVcc")).ResultIcon), {
                    type: iconType,
                    size: iconSize
                })
            }
        });
    };
    const $351101053ea517bd$export$3269347603d2224e = (args)=>{
        const { productState: productState, searchResult: searchResult } = args;
        const iconSize = productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess ? 'xsmall' : 'small';
        return (0, (0, parcelRequire("cvYmc")).defaultResultRenderer)({
            ...args,
            searchResult: {
                ...searchResult,
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1KrIR")).ResultAvatar), {
                    borderColor: "transparent",
                    src: searchResult.iconUrl,
                    appearance: "square",
                    size: iconSize,
                    testId: "result-avatar"
                })
            }
        });
    };
});
parcelRegister("8UVcc", function(module, exports) {
    $parcel$export(module.exports, "ResultIcon", ()=>$c2b7711fb91b88da$export$e8ec4da10aa3e6a6);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $5LWLA;
    var $3bDjY;
    var $5OxSR;
    var $hHEKF;
    const $c2b7711fb91b88da$export$e8ec4da10aa3e6a6 = ({ type: type, size: size = 'medium' })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const componentType = (0, (0, parcelRequire("5OxSR")).COMPONENT_TYPES)[type] ?? (0, (0, parcelRequire("5OxSR")).COMPONENT_TYPES).OTHER;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: intl.formatMessage(componentType.message)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hHEKF")).IconBackground), {
            color: componentType.color,
            size: size
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: type,
            glyph: componentType.icon,
            size: size
        })));
    };
});
parcelRegister("hHEKF", function(module, exports) {
    $parcel$export(module.exports, "IconBackground", ()=>$72df0fc32c73ced0$export$e320804e9cbf60f);
    var $5owSH;
    var $47bDC = parcelRequire("47bDC");
    const $72df0fc32c73ced0$export$e320804e9cbf60f = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1k2j4tj-0"
    })`display:flex;align-items:center;justify-content:center;width:${(props)=>(0, (0, parcelRequire("5owSH")).sizes)[props.size]};height:${(props)=>(0, (0, parcelRequire("5owSH")).sizes)[props.size]};background-color:${(props)=>props.color};border-radius:3px;& > svg,& > span[role='img'],& > span[role='presentation']{width:83.333333%;}`;
});
parcelRegister("1KrIR", function(module, exports) {
    $parcel$export(module.exports, "ResultAvatar", ()=>$b4c63e684429a304$export$d2397285980ae833);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $bWGt6 = parcelRequire("bWGt6");
    function $b4c63e684429a304$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b4c63e684429a304$var$NegativeMargin = (0, $bWGt6.default)("div", {
        target: "ez36xyc0"
    })({
        name: "l8jj6j",
        styles: "margin:var(--ds-space-negative-025, -2px);display:flex"
    });
    const $b4c63e684429a304$export$d2397285980ae833 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($b4c63e684429a304$var$NegativeMargin, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), props));
});
parcelRegister("cvYmc", function(module, exports) {
    $parcel$export(module.exports, "defaultResultRenderer", ()=>$be3af5bb83306dae$export$fa734eedc505eef7);
    var $fHgxq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1KrIR;
    const $be3af5bb83306dae$export$fa734eedc505eef7 = (args)=>{
        const { isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, screen: screen, searchResult: searchResult } = args;
        const icon = (0, ($parcel$interopDefault($5uXOq))).isValidElement(searchResult.icon) ? searchResult.icon : typeof searchResult.icon === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1KrIR")).ResultAvatar), {
            borderColor: "transparent",
            src: searchResult.icon,
            appearance: "square",
            size: "xsmall",
            testId: "result-avatar"
        }) : searchResult.iconRenderer ? searchResult.iconRenderer({
            screen: screen
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1KrIR")).ResultAvatar), {
            borderColor: "transparent",
            src: searchResult.iconUrl,
            appearance: "square",
            size: "xsmall",
            testId: "result-avatar"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHgxq")).SearchResultContent), {
            key: `item_${searchResult.id}`,
            isKeyboardHighlighted: isKeyboardHighlighted,
            title: searchResult.title,
            meta: searchResult.meta,
            additionalMeta: searchResult.additionalMeta,
            isCollapsed: isCollapsed,
            icon: icon
        });
    };
});
parcelRegister("fHgxq", function(module, exports) {
    $parcel$export(module.exports, "SearchResultContent", ()=>$8838fcb6e0179a11$export$b5fd7d6305bfbd3e);
    var $5uXOq = parcelRequire("5uXOq");
    var $cIQMR;
    var $eiKpf;
    const $8838fcb6e0179a11$export$595b9d59c3d65270 = '@@@hl@@@';
    const $8838fcb6e0179a11$export$eea8f6b95460c3c3 = '@@@endhl@@@';
    const $8838fcb6e0179a11$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
        const getResultContent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isCollapsed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultTitleContainer), {
                isCollapsed: true
            }, typeof label === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultLabel), {
                title: title
            }, label) : label, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                title: title,
                className: "SearchDialogResultTitle"
            }, title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultDetailWrapper), null, meta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultDetail), {
                title: title
            }, meta), additionalMeta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).DetailsSeparator), null, "\u2022"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultDetail), null, additionalMeta)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultTitleContainer), null, typeof label === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultLabel), {
                title: title
            }, label) : label, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                title: title,
                className: "SearchDialogResultTitle"
            }, title)), meta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultDetail), {
                title: typeof meta === 'string' ? meta : undefined
            }, meta), additionalMeta ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultDetail), {
                title: typeof additionalMeta === 'string' ? additionalMeta : undefined
            }, additionalMeta) : null));
        const contentRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
                behavior: 'auto',
                block: 'nearest'
            });
        }, [
            isKeyboardHighlighted
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultContentWrapper), {
            ref: contentRef,
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).IconContainer), null, icon), getResultContent(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ReturnIconContainer), {
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIQMR")).ReturnIcon), {
            inverted: true
        })));
    };
});
parcelRegister("eiKpf", function(module, exports) {
    $parcel$export(module.exports, "ResultLink", ()=>$160b324f70b6d5a8$export$d0a8235d2583609);
    $parcel$export(module.exports, "ResultContentWrapper", ()=>$160b324f70b6d5a8$export$87a308048e18f5d7);
    $parcel$export(module.exports, "EnlargedResultContentWrapper", ()=>$160b324f70b6d5a8$export$e10965f6350456f8);
    $parcel$export(module.exports, "ReturnIconContainer", ()=>$160b324f70b6d5a8$export$b7244afbfdf4cb9a);
    $parcel$export(module.exports, "EnlargedReturnIconContainer", ()=>$160b324f70b6d5a8$export$cc248e72bc9d7b85);
    $parcel$export(module.exports, "IconContainer", ()=>$160b324f70b6d5a8$export$8f314e512d92575f);
    $parcel$export(module.exports, "EnlargedIconContainer", ()=>$160b324f70b6d5a8$export$ca5c00fa71c2e27e);
    $parcel$export(module.exports, "ResultTitleContainer", ()=>$160b324f70b6d5a8$export$9c613d6c52df949a);
    $parcel$export(module.exports, "EnlargedResultTitleContainer", ()=>$160b324f70b6d5a8$export$e97ece467686c93c);
    $parcel$export(module.exports, "ResultLabel", ()=>$160b324f70b6d5a8$export$a999164f6ebc756c);
    $parcel$export(module.exports, "ResultDetail", ()=>$160b324f70b6d5a8$export$b695f824f00c1cb0);
    $parcel$export(module.exports, "CollapsedResultDetail", ()=>$160b324f70b6d5a8$export$addf7aa0f753bbe8);
    $parcel$export(module.exports, "EnlargedCollapsedResultDetail", ()=>$160b324f70b6d5a8$export$a44951d703db9a17);
    $parcel$export(module.exports, "EnlargedResultTitleContainerSkeleton", ()=>$160b324f70b6d5a8$export$c571ffd341b1e6fe);
    $parcel$export(module.exports, "EnlargedResultDetail", ()=>$160b324f70b6d5a8$export$c8ec38cc79b76eaa);
    $parcel$export(module.exports, "EnlargedResultDetailSkeleton", ()=>$160b324f70b6d5a8$export$a15ed502bc39849a);
    $parcel$export(module.exports, "CollapsedResultDetailWrapper", ()=>$160b324f70b6d5a8$export$43a2b5c94cb85d9c);
    $parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", ()=>$160b324f70b6d5a8$export$2dfb537c5a7f8cc3);
    $parcel$export(module.exports, "DetailsSeparator", ()=>$160b324f70b6d5a8$export$35507434feaa4496);
    $parcel$export(module.exports, "CollapsedResultContentWrapper", ()=>$160b324f70b6d5a8$export$ee32d1086c278cfc);
    $parcel$export(module.exports, "EnlargedSkeletonIcon", ()=>$160b324f70b6d5a8$export$3c77a9b2eee1dfc5);
    var $3JZ8k;
    var $kCMvS;
    var $bWGt6 = parcelRequire("bWGt6");
    function $160b324f70b6d5a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $160b324f70b6d5a8$export$d0a8235d2583609 = (0, $bWGt6.default)((0, (0, parcelRequire("kCMvS")).Link), {
        target: "e8crcwv22"
    })({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        color: (0, (0, parcelRequire("3JZ8k")).primaryTextColour),
        '&:hover': {
            textDecoration: 'none',
            color: (0, (0, parcelRequire("3JZ8k")).primaryTextColour)
        },
        '&:focus': {
            outlineOffset: '-2px'
        },
        '&:visited': {
            color: (0, (0, parcelRequire("3JZ8k")).primaryTextColour),
            '.SearchDialogResultTitle': {
                color: (0, (0, parcelRequire("3JZ8k")).visitedLinkColor)
            }
        }
    });
    const $160b324f70b6d5a8$export$87a308048e18f5d7 = (0, $bWGt6.default)("div", {
        target: "e8crcwv21"
    })((props)=>({
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            position: 'relative',
            boxSizing: 'border-box',
            height: (0, (0, parcelRequire("3JZ8k")).grid).multiple(props.isCollapsed ? 5 : 4).px,
            padding: `0 ${(0, (0, parcelRequire("3JZ8k")).grid).twice().px}`,
            backgroundColor: props.isKeyboardHighlighted ? (0, (0, parcelRequire("3JZ8k")).itemHighlightColor) : 'transparent',
            '&:hover': {
                backgroundColor: (0, (0, parcelRequire("3JZ8k")).itemHighlightColor)
            }
        }));
    const $160b324f70b6d5a8$export$e10965f6350456f8 = (0, $bWGt6.default)("div", {
        target: "e8crcwv20"
    })((props)=>({
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            position: 'relative',
            boxSizing: 'border-box',
            borderRadius: "var(--ds-space-075, 6px)",
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
            backgroundColor: props.isKeyboardHighlighted ? (0, (0, parcelRequire("3JZ8k")).itemHighlightColor) : 'transparent',
            '&:hover': {
                backgroundColor: (0, (0, parcelRequire("3JZ8k")).itemHighlightColor)
            }
        }));
    const $160b324f70b6d5a8$export$b7244afbfdf4cb9a = (0, $bWGt6.default)("div", {
        target: "e8crcwv19"
    })((props)=>({
            borderRadius: '3px',
            margin: (0, (0, parcelRequire("3JZ8k")).grid).half().px,
            marginRight: 0,
            width: (0, (0, parcelRequire("3JZ8k")).grid).multiple(3).px,
            height: (0, (0, parcelRequire("3JZ8k")).grid).twice().px,
            right: (0, (0, parcelRequire("3JZ8k")).grid).multiple(1.5).px,
            top: props.isCollapsed ? (0, (0, parcelRequire("3JZ8k")).grid).px : (0, (0, parcelRequire("3JZ8k")).grid).half().px,
            opacity: props.isKeyboardHighlighted ? 1 : 0
        }));
    const $160b324f70b6d5a8$export$cc248e72bc9d7b85 = (0, $bWGt6.default)("div", {
        target: "e8crcwv18"
    })({
        name: "qrg2ys",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
    });
    const $160b324f70b6d5a8$export$d84276b3ae03593f = (0, $bWGt6.default)($160b324f70b6d5a8$export$b7244afbfdf4cb9a, {
        target: "e8crcwv17"
    })({
        width: (0, (0, parcelRequire("3JZ8k")).grid).multiple(2.5).px,
        height: (0, (0, parcelRequire("3JZ8k")).grid).multiple(2.5).px,
        opacity: 1
    });
    const $160b324f70b6d5a8$export$8f314e512d92575f = (0, $bWGt6.default)("div", {
        target: "e8crcwv16"
    })({
        width: (0, (0, parcelRequire("3JZ8k")).grid).twice().px,
        marginRight: (0, (0, parcelRequire("3JZ8k")).grid).twice().px,
        flex: `0 0 ${(0, (0, parcelRequire("3JZ8k")).grid).twice().px}`,
        lineHeight: (0, (0, parcelRequire("3JZ8k")).grid).twice().px,
        display: 'flex',
        alignItems: 'center'
    });
    const $160b324f70b6d5a8$export$ca5c00fa71c2e27e = (0, $bWGt6.default)("div", {
        target: "e8crcwv15"
    })({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
        display: 'flex',
        alignItems: 'center'
    });
    const $160b324f70b6d5a8$export$9c613d6c52df949a = (0, $bWGt6.default)("div", {
        target: "e8crcwv14"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, (0, parcelRequire("3JZ8k")).grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, (0, parcelRequire("3JZ8k")).primaryTextColour), ";@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){width:100%;}");
    const $160b324f70b6d5a8$export$e97ece467686c93c = (0, $bWGt6.default)("div", {
        target: "e8crcwv13"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, (0, parcelRequire("3JZ8k")).primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){width:100%;}width:90%;");
    const $160b324f70b6d5a8$export$a999164f6ebc756c = (0, $bWGt6.default)("span", {
        target: "e8crcwv12"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        color: "var(--ds-text-subtle, #5E6C84)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '16px',
        marginRight: (0, (0, parcelRequire("3JZ8k")).grid).px
    });
    const $160b324f70b6d5a8$export$b695f824f00c1cb0 = (0, $bWGt6.default)("div", {
        target: "e8crcwv11"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '16px',
        color: (0, (0, parcelRequire("3JZ8k")).itemLinkSecondaryColor),
        marginLeft: (0, (0, parcelRequire("3JZ8k")).grid).multiple(3).px,
        width: (0, (0, parcelRequire("3JZ8k")).grid).multiple(19).px
    });
    const $160b324f70b6d5a8$export$addf7aa0f753bbe8 = (0, $bWGt6.default)("div", {
        target: "e8crcwv10"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '14px',
        color: (0, (0, parcelRequire("3JZ8k")).itemLinkSecondaryColor),
        maxWidth: "'initial'"
    });
    const $160b324f70b6d5a8$export$a44951d703db9a17 = (0, $bWGt6.default)("div", {
        target: "e8crcwv9"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '14px',
        color: (0, (0, parcelRequire("3JZ8k")).itemLinkSecondaryColor),
        maxWidth: "'initial'"
    });
    const $160b324f70b6d5a8$export$c571ffd341b1e6fe = (0, $bWGt6.default)("div", {
        target: "e8crcwv8"
    })({
        maxWidth: '100%',
        width: '256px',
        height: '14px',
        marginBottom: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-space-050, 4px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    });
    const $160b324f70b6d5a8$export$c8ec38cc79b76eaa = (0, $bWGt6.default)("div", {
        target: "e8crcwv7"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '14px',
        color: (0, (0, parcelRequire("3JZ8k")).itemLinkSecondaryColor),
        maxWidth: "'initial'",
        minWidth: 'fit-content',
        marginLeft: "var(--ds-space-150, 12px)"
    });
    const $160b324f70b6d5a8$export$a15ed502bc39849a = (0, $bWGt6.default)("div", {
        target: "e8crcwv6"
    })({
        maxWidth: '100%',
        width: '100px',
        height: '12px',
        borderRadius: "var(--ds-space-050, 4px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    });
    const $160b324f70b6d5a8$export$43a2b5c94cb85d9c = (0, $bWGt6.default)("div", {
        target: "e8crcwv5"
    })({
        display: 'flex',
        maxWidth: (0, (0, parcelRequire("3JZ8k")).grid).multiple(54).px
    });
    const $160b324f70b6d5a8$export$2dfb537c5a7f8cc3 = (0, $bWGt6.default)("div", {
        target: "e8crcwv4"
    })({
        name: "uy5e1i",
        styles: "display:flex;width:90%"
    });
    const $160b324f70b6d5a8$export$35507434feaa4496 = (0, $bWGt6.default)("div", {
        target: "e8crcwv3"
    })({
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '14px',
        color: (0, (0, parcelRequire("3JZ8k")).itemLinkSecondaryColor),
        padding: `0 ${(0, (0, parcelRequire("3JZ8k")).grid).px}`
    });
    const $160b324f70b6d5a8$export$ee32d1086c278cfc = (0, $bWGt6.default)("div", {
        target: "e8crcwv2"
    })({
        name: "1ls843y",
        styles: "display:block;min-width:0;flex-grow:1"
    });
    const $160b324f70b6d5a8$export$2cacbb382e8a2ce4 = (0, $bWGt6.default)("button", {
        target: "e8crcwv1"
    })({
        name: "ykaoo6",
        styles: "background-color:transparent;border:none;cursor:pointer;padding:0;width:100%;text-align:left"
    });
    const $160b324f70b6d5a8$export$3c77a9b2eee1dfc5 = (0, $bWGt6.default)("div", {
        target: "e8crcwv0"
    })({
        width: '100%',
        height: '100%',
        borderRadius: "var(--ds-space-050, 4px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    });
});
parcelRegister("3R5l7", function(module, exports) {
    $parcel$export(module.exports, "COMPASS_PRODUCT_ID", ()=>$a43055790ca3e7d9$export$29789a1990c8eafe);
    $parcel$export(module.exports, "useCompassSuppliers", ()=>$a43055790ca3e7d9$export$9b569c25a7f27268);
    var $koVbs;
    var $f4GCr;
    var $g12zs;
    var $kwW3T;
    var $8entA;
    var $5OxSR;
    var $e53Rq;
    var $kFdjV;
    const $a43055790ca3e7d9$export$29789a1990c8eafe = 'compass';
    const $a43055790ca3e7d9$var$NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
    const $a43055790ca3e7d9$export$9b569c25a7f27268 = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier }, sections)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)($a43055790ca3e7d9$export$29789a1990c8eafe, sections, {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        });
        const peopleAndTeamSupplier = (0, (0, parcelRequire("g12zs")).usePeopleAndTeamsQuery)({
            people: {
                id: (0, (0, parcelRequire("5OxSR")).CompassScope).People,
                title: intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_people_section_heading)
            },
            teams: {
                id: (0, (0, parcelRequire("5OxSR")).CompassScope).Teams,
                title: intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_teams_section_heading)
            }
        }, 3);
        const requestTeamMeta = async (teamId)=>{
            if (!userTeamConfig?.context.siteId || !teamId || teamId === $a43055790ca3e7d9$var$NO_OWNER_TEAM) return '';
            try {
                const team = await (0, (0, parcelRequire("8entA")).getTeamData)({
                    url: userTeamConfig?.baseUrl || '',
                    teamAri: teamId,
                    siteId: userTeamConfig?.context.siteId
                });
                return team.displayName;
            } catch (e) {
                return '';
            }
        };
        const userTeamConfigOverride = {
            context: userTeamConfig.context,
            baseUrl: userTeamConfig.baseUrl,
            resolveTeamUrl: userTeamConfig.resolveTeamUrl ?? (0, (0, parcelRequire("e53Rq")).compassURLGenerators)().teamUrlGenerator,
            resolveUserUrl: userTeamConfig.resolveUserUrl ?? (0, (0, parcelRequire("e53Rq")).compassURLGenerators)().userUrlGenerator
        };
        const hydrateOwnerMeta = async (items)=>{
            const promises = [];
            const compSection = items.sections.find((s)=>s.id === (0, (0, parcelRequire("5OxSR")).CompassScope).Component);
            if (compSection) compSection.searchResults.map(async (res)=>{
                promises.push(requestTeamMeta(res.meta).then((teamName)=>res.meta = teamName));
            });
            return Promise.all(promises).then(()=>items);
        };
        const preQueryItemSupplierWithTeamName = async (args)=>{
            const existingSections = await hydrateOwnerMeta(await itemSuppliers.preQueryItemSupplier(args));
            const teamSection = (await peopleAndTeamSupplier('', userTeamConfigOverride)).sections.find((section)=>section.id === (0, (0, parcelRequire("5OxSR")).CompassScope).Teams);
            return window.location.pathname.startsWith('/compass') ? existingSections : {
                size: existingSections.size,
                sections: [
                    ...existingSections.sections,
                    ...teamSection ? [
                        {
                            ...teamSection,
                            resultRenderer: (0, (0, parcelRequire("kFdjV")).peopleAndTeamsResultRenderer)
                        }
                    ] : []
                ]
            };
        };
        const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
            const existingSections = await hydrateOwnerMeta(await itemSuppliers.postQueryItemSupplier(args));
            const people = userTeamConfigOverride ? await peopleAndTeamSupplier(args.query, {
                ...userTeamConfigOverride,
                context: {
                    ...userTeamConfigOverride.context,
                    siteId: userTeamConfigOverride.context.siteId
                }
            }) : null;
            return {
                size: existingSections.size,
                sections: [
                    ...existingSections.sections,
                    ...people?.sections.map((section)=>({
                            ...section,
                            resultRenderer: (0, (0, parcelRequire("kFdjV")).peopleAndTeamsResultRenderer)
                        })) ?? []
                ]
            };
        };
        const preQuerySectionTitleGenerator = (section)=>{
            switch(section.id){
                case (0, (0, parcelRequire("5OxSR")).CompassScope).Component:
                    return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_recently_viewed_components) : intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_components_section_heading);
                case (0, (0, parcelRequire("5OxSR")).CompassScope).Teams:
                    return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_recently_viewed_teams) : intl.formatMessage((0, (0, parcelRequire("kwW3T")).messages).compass_teams_section_heading);
                default:
                    return '';
            }
        };
        return {
            preQueryItemSupplier: preQueryItemSupplierWithTeamName,
            postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
            preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
        };
    };
});
parcelRegister("g12zs", function(module, exports) {
    $parcel$export(module.exports, "usePeopleAndTeamsQuery", ()=>$af3136587b54c1cd$export$f16e39d5b6af63da);
    var $koVbs;
    const $af3136587b54c1cd$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
    const $af3136587b54c1cd$var$resolveRecommendationRequest = ({ baseUrl: baseUrl, context: context, includeUsers: includeUsers, includeTeams: includeTeams, query: query, maxNumberOfResults: maxNumberOfResults })=>({
            baseUrl: baseUrl,
            context: context,
            maxNumberOfResults: maxNumberOfResults,
            query: query ?? '',
            searchQueryFilter: $af3136587b54c1cd$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
            includeUsers: includeUsers ?? false,
            includeGroups: false,
            includeTeams: includeTeams ?? false
        });
    const $af3136587b54c1cd$var$asyncGetUserRecommendations = async (request, intl)=>{
        try {
            const { getUserRecommendations: getUserRecommendations } = await (parcelRequire("blsRW"));
            return getUserRecommendations(request, intl);
        } catch (e) {}
    };
    const $af3136587b54c1cd$export$f16e39d5b6af63da = (peopleAndTeamSections, maxItemsPerSection)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return async (query, { baseUrl: baseUrl, context: context, resolveTeamUrl: resolveTeamUrl, resolveUserUrl: resolveUserUrl })=>{
            const teamsRequest = $af3136587b54c1cd$var$resolveRecommendationRequest({
                includeTeams: true,
                baseUrl: baseUrl,
                context: context,
                query: query,
                maxNumberOfResults: 20
            });
            const usersRequest = $af3136587b54c1cd$var$resolveRecommendationRequest({
                includeUsers: true,
                baseUrl: baseUrl,
                context: context,
                query: query,
                maxNumberOfResults: 20
            });
            try {
                const [teams, users] = await Promise.all([
                    $af3136587b54c1cd$var$asyncGetUserRecommendations(teamsRequest, intl),
                    $af3136587b54c1cd$var$asyncGetUserRecommendations(usersRequest, intl)
                ]);
                const teamResults = teams?.map((team)=>{
                    return {
                        title: team.name,
                        id: team.id,
                        meta: '',
                        url: resolveTeamUrl ? resolveTeamUrl(team.id) : `/people/team/${team.id}`,
                        iconUrl: team.avatarUrl
                    };
                }) ?? [];
                const userResults = users?.map((user)=>{
                    return {
                        title: user.name,
                        id: user.id,
                        meta: user.title || '',
                        url: resolveUserUrl ? resolveUserUrl(user.id) : `/people/${user.id}`,
                        iconUrl: user.avatarUrl
                    };
                }) ?? [];
                return {
                    sections: [
                        {
                            ...peopleAndTeamSections.people,
                            searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
                        },
                        {
                            ...peopleAndTeamSections.teams,
                            searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
                        }
                    ]
                };
            } catch (error) {
                return {
                    sections: [
                        {
                            ...peopleAndTeamSections.people,
                            searchResults: []
                        },
                        {
                            ...peopleAndTeamSections.teams,
                            searchResults: []
                        }
                    ]
                };
            }
        };
    };
});
parcelRegister("blsRW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gF4ow")
    ]).then(()=>parcelRequire('jVMu6'));
});
parcelRegister("8entA", function(module, exports) {
    $parcel$export(module.exports, "getTeamData", ()=>$361c7e4e68dd06c6$export$c11a6707e0ba3a30);
    var $dS9cn = parcelRequire("dS9cn");
    const $361c7e4e68dd06c6$export$a637ff7dbe7c1532 = ({ teamId: teamId, siteId: siteId })=>{
        if (teamId === undefined || siteId === undefined) throw new Error('Missing some required parameters teamId and siteId');
        return `/gateway/api/v4/teams/${encodeURIComponent(teamId)}?siteId=${encodeURIComponent(siteId)}`;
    };
    const $361c7e4e68dd06c6$export$c11a6707e0ba3a30 = ({ url: url, teamAri: teamAri, siteId: siteId })=>{
        const parts = teamAri.split('/');
        const teamId = parts[parts.length - 1];
        const options = {
            path: $361c7e4e68dd06c6$export$a637ff7dbe7c1532({
                teamId: teamId,
                siteId: siteId
            }),
            requestInit: {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        };
        return (0, $dS9cn.utils).requestService({
            url: url
        }, options);
    };
});
parcelRegister("e53Rq", function(module, exports) {
    $parcel$export(module.exports, "compassURLGenerators", ()=>$f78a1d7e5ef82a0f$export$9dd4fd2059f2de3b);
    const $f78a1d7e5ef82a0f$var$getBaseURL = ()=>window.location.origin;
    const $f78a1d7e5ef82a0f$export$9dd4fd2059f2de3b = (searchUrlOverride)=>{
        const advancedSearchLinkGenerator = (query)=>`${searchUrlOverride || $f78a1d7e5ef82a0f$var$getBaseURL()}/compass/components?query=${encodeURIComponent(query)}`;
        const teamUrlGenerator = (teamId)=>`${$f78a1d7e5ef82a0f$var$getBaseURL()}/compass/people/team/${teamId}`;
        const userUrlGenerator = (userId)=>`${$f78a1d7e5ef82a0f$var$getBaseURL()}/people/${userId}`;
        return {
            advancedSearchLinkGenerator: advancedSearchLinkGenerator,
            teamUrlGenerator: teamUrlGenerator,
            userUrlGenerator: userUrlGenerator
        };
    };
});
parcelRegister("6zJmu", function(module, exports) {
    $parcel$export(module.exports, "UpsellTab", ()=>$77f5ac77ff5ac3e8$export$2570220d7265a66b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $75NXP;
    var $3H5gB;
    var $kgoHi;
    const $77f5ac77ff5ac3e8$var$Lozenge = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("a6kVO")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $77f5ac77ff5ac3e8$var$UpsellTabWithIntl = ({ intl: intl, title: title })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            fireAnalyticsEvent({
                eventType: 'track',
                action: 'exposed',
                actionSubject: 'compassSearchCrossFlowExperiment',
                source: 'searchDialog'
            });
        }, [
            fireAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            columnGap: "space.100",
            testId: "compass-upsell-modal-header"
        }, title, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($77f5ac77ff5ac3e8$var$Lozenge, {
            appearance: "new"
        }, intl.formatMessage((0, (0, parcelRequire("3H5gB")).messages).compass_upsell_tab_lozenge))));
    };
    const $77f5ac77ff5ac3e8$export$2570220d7265a66b = (0, (0, parcelRequire("8RXs9")).default)($77f5ac77ff5ac3e8$var$UpsellTabWithIntl);
});
parcelRegister("3H5gB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e6da5d64e2351011$export$defe85febe8b728c);
    var $7VHMR;
    const $e6da5d64e2351011$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        compass_upsell_tab_lozenge: {
            id: 'product_search_dialog.compass.upsell_tab_title_lozenge',
            defaultMessage: 'New',
            description: 'Lozenge next to Compass tab title indicating new functionality'
        },
        compass_upsell_heading: {
            id: 'product_search_dialog.compass.upsell_modal_heading',
            defaultMessage: 'Control your software sprawl, so developers can control their time',
            description: 'Upsell modal heading presented to users who do not have Compass activated'
        },
        compass_upsell_heading_bitbucket: {
            id: 'product_search_dialog.compass.upsell_modal_heading.bitbucket',
            defaultMessage: 'Bring more context to your code',
            description: 'Upsell modal heading presented to Bitbucket users who do not have Compass activated'
        },
        compass_upsell_description: {
            id: 'product_search_dialog.compass.upsell_modal_description',
            defaultMessage: "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
            description: 'Upsell modal description presented to users who don not have Compass activated'
        },
        compass_upsell_description_bitbucket: {
            id: 'product_search_dialog.compass.upsell_modal_description.bitbucket',
            defaultMessage: 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
            description: 'Upsell modal description presented to Bitbucket users who don not have Compass activated'
        },
        compass_upsell_learn_more_link: {
            id: 'product_search_dialog.compass.upsell_modal_learn_more_link',
            defaultMessage: 'Learn more',
            description: 'Text for the learn more about Compass link'
        },
        compass_upsell_learn_more_aria_label: {
            id: 'product_search_dialog.compass.upsell_modal_learn_more_aria_label',
            defaultMessage: 'Learn more about Compass',
            description: 'Arial label text for the learn more about Compass link'
        },
        compass_upsell_cta_button: {
            id: 'product_search_dialog.compass.upsell_modal_cta_text',
            defaultMessage: 'Get Compass free',
            description: 'Text for the button clicking which will navigate user to the sign up page'
        }
    });
});
parcelRegister("a6kVO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("trupQ").then(()=>parcelRequire('3u0c5'));
});
parcelRegister("eVJaE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("lI20R")
    ]).then(()=>parcelRequire('7y0yx'));
});
parcelRegister("dlQRr", function(module, exports) {
    $parcel$export(module.exports, "FilterContextProvider", ()=>$61296a19a0baeca4$export$eb71bf38f5ae0f9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $tUDIN;
    var $5uOu6;
    var $2k6eV;
    const $61296a19a0baeca4$export$5767e6ba1d152dc0 = ()=>{
        const lastModifiedDate = new Date();
        lastModifiedDate.setDate(lastModifiedDate.getDate() - 90);
        return lastModifiedDate.toISOString().split('T')[0];
    };
    const $61296a19a0baeca4$var$useFilters = (defaultFilters = [], storeFilters = (value)=>{})=>{
        const { filters: filters, dispatch: dispatch } = (0, (0, parcelRequire("5uOu6")).useFilter)(defaultFilters);
        (0, $5uXOq.useLayoutEffect)(()=>{
            storeFilters(filters);
        });
        const addFilters = (0, $5uXOq.useCallback)((newFilters)=>{
            dispatch((0, (0, parcelRequire("5uOu6")).addFilters)(newFilters));
            storeFilters(filters.concat(newFilters));
        }, [
            dispatch,
            filters,
            storeFilters
        ]);
        const updateFilter = (0, $5uXOq.useCallback)((id, isChecked)=>{
            dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(id, isChecked, true));
            const index = filters.findIndex((filter)=>filter.id === id);
            const newFilters = [
                ...filters
            ];
            newFilters[index] = {
                ...newFilters[index],
                isChecked: isChecked,
                isVisible: true
            };
            storeFilters(filters.concat(newFilters));
        }, [
            dispatch,
            filters,
            storeFilters
        ]);
        const clearFilter = (0, $5uXOq.useCallback)(()=>{
            filters.forEach((f)=>{
                dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(f.id, false));
            });
            const newFilters = filters.map((f)=>{
                const newF = {
                    ...f
                };
                newF.isChecked = false;
                return newF;
            });
            storeFilters(newFilters);
        }, [
            dispatch,
            filters,
            storeFilters
        ]);
        const resetFilter = (0, $5uXOq.useCallback)(()=>{
            dispatch((0, (0, parcelRequire("5uOu6")).replaceAllFilters)(defaultFilters));
        }, [
            defaultFilters,
            dispatch
        ]);
        return {
            availableFilters: filters,
            addFilters: addFilters,
            updateFilter: updateFilter,
            clearFilter: clearFilter,
            reset: resetFilter,
            dispatch: dispatch
        };
    };
    const $61296a19a0baeca4$var$DEFAULT_FILTER_STATE = {
        availableFilters: [],
        addFilters: ()=>{},
        updateFilter: ()=>{},
        clearFilter: ()=>{},
        reset: ()=>{},
        dispatch: ()=>{}
    };
    const $61296a19a0baeca4$var$FilterContext = (0, $5uXOq.createContext)({
        spaceFilters: $61296a19a0baeca4$var$DEFAULT_FILTER_STATE,
        peopleFilters: $61296a19a0baeca4$var$DEFAULT_FILTER_STATE,
        siteFilters: $61296a19a0baeca4$var$DEFAULT_FILTER_STATE,
        resetFilters: ()=>{},
        prequeryFiltersRef: {
            current: ''
        }
    });
    function $61296a19a0baeca4$export$5e1edcb3c154ab79(availableFilters) {
        const appliedFilters = availableFilters.map((availableFilter, index)=>({
                ...availableFilter,
                index: index
            })).filter((filterWithIndex)=>filterWithIndex.isChecked);
        return {
            applied: appliedFilters.map((appliedFilter)=>({
                    id: appliedFilter.id,
                    source: appliedFilter.filterSource,
                    index: appliedFilter.index
                })),
            recommendedIds: availableFilters.map((appliedFilter)=>({
                    id: appliedFilter.id,
                    source: appliedFilter.filterSource
                }))
        };
    }
    const $61296a19a0baeca4$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultSpaceFilters: defaultSpaceFilters, defaultPeopleFilters: defaultPeopleFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
        const previousEnabledState = (0, ($parcel$interopDefault($5uXOq))).useRef(isEnabled);
        const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters, resetConfluenceFiltersRef: resetConfluenceFiltersRef } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const [filters, setFilters] = (0, $5uXOq.useState)(readFilters('confluence'));
        const initialSpaceFilters = stickySearchEnabled ? filters?.space || defaultSpaceFilters : defaultSpaceFilters;
        const initialPeopleFilters = stickySearchEnabled ? filters?.people || defaultPeopleFilters : defaultPeopleFilters;
        const initialSiteFilters = stickySearchEnabled ? filters?.site || defaultSiteFilters : defaultSiteFilters;
        const getUpdateFilters = (0, $5uXOq.useCallback)((type)=>(options)=>{
                const filters = readFilters('confluence');
                switch(type){
                    case 'SPACE':
                        filters.space = options;
                        break;
                    case 'PEOPLE':
                        filters.people = options;
                        break;
                    case 'SITE':
                        filters.site = options;
                        break;
                }
                storeFilters('confluence', filters);
            }, [
            readFilters,
            storeFilters
        ]);
        const spaceFilterStore = $61296a19a0baeca4$var$useFilters(initialSpaceFilters, stickySearchEnabled ? getUpdateFilters('SPACE') : undefined);
        const peopleFilterStore = $61296a19a0baeca4$var$useFilters(initialPeopleFilters, stickySearchEnabled ? getUpdateFilters('PEOPLE') : undefined);
        const siteFilterStore = $61296a19a0baeca4$var$useFilters(initialSiteFilters, stickySearchEnabled ? getUpdateFilters('SITE') : undefined);
        const prequeryFiltersRef = (0, $5uXOq.useRef)('');
        const filtersAnalyticsContext = spaceFilterStore.availableFilters.length === 0 && peopleFilterStore.availableFilters.length === 0 ? {} : {
            container: $61296a19a0baeca4$export$5e1edcb3c154ab79(spaceFilterStore.availableFilters),
            contributor: $61296a19a0baeca4$export$5e1edcb3c154ab79(peopleFilterStore.availableFilters)
        };
        const resetFilters = (0, $5uXOq.useCallback)(()=>{
            spaceFilterStore.dispatch((0, (0, parcelRequire("5uOu6")).replaceAllFilters)(defaultSpaceFilters || []));
            peopleFilterStore.dispatch((0, (0, parcelRequire("5uOu6")).replaceAllFilters)(defaultPeopleFilters || []));
            siteFilterStore.dispatch((0, (0, parcelRequire("5uOu6")).replaceAllFilters)(defaultSiteFilters || []));
        }, [
            defaultPeopleFilters,
            defaultSiteFilters,
            defaultSpaceFilters,
            peopleFilterStore,
            siteFilterStore,
            spaceFilterStore
        ]);
        const clearFilters = (0, $5uXOq.useCallback)(()=>{
            spaceFilterStore.clearFilter();
            peopleFilterStore.clearFilter();
            siteFilterStore.clearFilter();
            if (stickySearchEnabled) setFilters(readFilters('confluence'));
        }, [
            spaceFilterStore,
            peopleFilterStore,
            siteFilterStore,
            stickySearchEnabled,
            readFilters
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (resetConfluenceFiltersRef) resetConfluenceFiltersRef.current = clearFilters;
        }, [
            clearFilters,
            resetConfluenceFiltersRef
        ]);
        if (previousEnabledState.current && !isEnabled && !stickySearchEnabled) resetFilters();
        previousEnabledState.current = isEnabled;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($61296a19a0baeca4$var$FilterContext.Provider, {
            value: {
                spaceFilters: spaceFilterStore,
                peopleFilters: peopleFilterStore,
                siteFilters: siteFilterStore,
                resetFilters: resetFilters,
                prequeryFiltersRef: prequeryFiltersRef
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext
        }, children));
    };
    const $61296a19a0baeca4$export$396ef541d9951d45 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).useContext($61296a19a0baeca4$var$FilterContext);
    };
});
parcelRegister("5uOu6", function(module, exports) {
    $parcel$export(module.exports, "addFilters", ()=>$90e82477d9a909f4$export$60c1905c6f855529);
    $parcel$export(module.exports, "replaceAllFilters", ()=>$90e82477d9a909f4$export$4dce09b3092bd5e8);
    $parcel$export(module.exports, "updateFilterState", ()=>$90e82477d9a909f4$export$e4269d58720a0c2c);
    $parcel$export(module.exports, "useFilter", ()=>$90e82477d9a909f4$export$3274cf84b703fff);
    var $5uXOq = parcelRequire("5uXOq");
    const $90e82477d9a909f4$export$60c1905c6f855529 = (filters, sortFunction)=>({
            type: 'ADD_FILTERS',
            newFilters: filters,
            sortFunction: sortFunction
        });
    const $90e82477d9a909f4$export$3be5fe9f09d6965 = (id)=>({
            type: 'REMOVE_FILTER',
            id: id
        });
    const $90e82477d9a909f4$export$4dce09b3092bd5e8 = (newFilters)=>({
            type: 'REPLACE_ALL_FILTERS',
            newFilters: newFilters
        });
    const $90e82477d9a909f4$export$e4269d58720a0c2c = (filterId, isChecked, isVisible)=>({
            type: 'UPDATE_FILTER_STATE',
            filterId: filterId,
            isChecked: isChecked,
            isVisible: isVisible
        });
    const $90e82477d9a909f4$export$234bf2a76076d85a = (newFilters)=>({
            type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
            newFilters: newFilters
        });
    function $90e82477d9a909f4$var$reducer(state, action) {
        switch(action.type){
            case 'ADD_FILTERS':
                {
                    if (action.newFilters.length === 0) return state;
                    let newState = [
                        ...state
                    ];
                    action.newFilters.forEach((f)=>{
                        const index = state.findIndex((filter)=>filter.id === f.id);
                        if (index === -1) newState.push(f);
                        else {
                            newState[index] = f;
                            return newState;
                        }
                    });
                    action.sortFunction && newState.sort(action.sortFunction);
                    return newState;
                }
            case 'UPDATE_FILTER_STATE':
                {
                    const index = state.findIndex((filter)=>filter.id === action.filterId);
                    if (index === -1) return state;
                    const newState = [
                        ...state
                    ];
                    newState[index] = {
                        ...newState[index],
                        isChecked: action.isChecked,
                        isVisible: action.isVisible === undefined || action.isVisible === null ? newState[index].isVisible : action.isVisible
                    };
                    return newState;
                }
            case 'REMOVE_FILTER':
                return [
                    ...state.filter((filter)=>filter.id !== action.id)
                ];
            case 'REPLACE_ALL_FILTERS':
                return [
                    ...action.newFilters
                ];
            case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
                {
                    const newState = action.newFilters.map((newFilter)=>{
                        const existingFilter = state.find((f)=>f.id === newFilter.id);
                        if (existingFilter && newFilter.isVisible) newFilter.isChecked = existingFilter.isChecked;
                        return newFilter;
                    });
                    return newState;
                }
            default:
                const _ = action;
                throw new Error(_);
        }
    }
    const $90e82477d9a909f4$export$3274cf84b703fff = (initialValues)=>{
        const [state, dispatch] = (0, ($parcel$interopDefault($5uXOq))).useReducer($90e82477d9a909f4$var$reducer, initialValues ? initialValues : []);
        const value = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                filters: state,
                dispatch: dispatch
            }), [
            state,
            dispatch
        ]);
        return value;
    };
});
parcelRegister("hynt0", function(module, exports) {
    $parcel$export(module.exports, "ExtensibleConfluenceTab", ()=>$ed6ea212d5cb6772$export$9afff4557e36fda3);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $VSDnB;
    var $k4hbD;
    var $8Xs9r;
    var $f4GCr;
    var $5S6Yv;
    var $iRI1s;
    var $3CuYo;
    var $3RKSV;
    var $3UF9C;
    var $gMpaQ;
    var $75NXP;
    var $3FqY6;
    var $azBuE;
    var $dVo7Y;
    var $9WUgS;
    var $lnyO0;
    var $4DehF;
    var $1A3ka;
    var $gQz3v;
    var $i5cPn;
    var $2dI5H;
    var $2k6eV;
    var $3HoVl;
    const $ed6ea212d5cb6772$var$InteractiveSearchAIOnboardingBanner = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("6CRRT")).then(({ InteractiveSearchAIOnboardingBanner: InteractiveSearchAIOnboardingBanner })=>({
                default: InteractiveSearchAIOnboardingBanner
            })));
    const $ed6ea212d5cb6772$export$9afff4557e36fda3 = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, aiSearchConfig: aiSearchConfig, formatDate: formatDate, children: children, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled = false, rendererOverride: rendererOverride, aiAdminNotificationHeader: aiAdminNotificationHeader, ...rest })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const { setQuery: setQuery } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const { confluenceSites: confluenceSites } = (0, (0, parcelRequire("dVo7Y")).useSearchConfigContext)();
        const { defineFilters: defineFilters } = (0, (0, parcelRequire("3UF9C")).useGenericFilters)();
        const { isUserAnonymous: isUserAnonymous } = recentClientConfig;
        const { searchClient: searchClient } = (0, (0, parcelRequire("3CuYo")).useRecentsClient)(recentClientConfig);
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const appendAnalyticsQueryParams = (0, (0, parcelRequire("3HoVl")).useQueryParams)();
        const isEnhancedSearchAnalyticsEnabled = (0, (0, parcelRequire("VSDnB")).fg)('cc_page_experiences_enhanced_search_analytics_conf');
        const appendQueryParams = isEnhancedSearchAnalyticsEnabled ? appendAnalyticsQueryParams : undefined;
        const siteFilterDefinition = (0, (0, parcelRequire("3UF9C")).useSiteFilterDefinition)(rest.workspaces || [], (0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID));
        const { confluenceTabDateFilter: confluenceTabDateFilter, appliedDateFilter: appliedDateFilter } = (0, (0, parcelRequire("gQz3v")).useConfluenceDateFilter)();
        const spaceFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)([], (0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID), (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).Space);
        const peopleFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)([], (0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID), (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).People);
        const { preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier } = (0, (0, parcelRequire("1A3ka")).useConfluenceSuppliers)({
            recentClientConfig: recentClientConfig,
            searchClientConfig: searchClientConfig,
            autocorrectEnabled: autocorrectEnabled,
            spaceFilterStore: spaceFilterStore,
            peopleFilterStore: peopleFilterStore,
            isExpanded: isExpanded,
            isUserAnonymous: isUserAnonymous,
            formatDate: formatDate,
            rendererOverride: rendererOverride,
            additionalContentTypesEnabled: additionalContentTypesEnabled
        });
        const sections = (0, (0, parcelRequire("4DehF")).useConfluenceSections)({
            formatDate: formatDate,
            autocorrectEnabled: autocorrectEnabled,
            additionalContentTypesEnabled: additionalContentTypesEnabled,
            rendererOverride: rendererOverride
        });
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)((0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID), sections, {
            preQueryItemSupplier: rest.preQueryItemSupplier || preQueryItemSupplier,
            postQueryItemSupplier: rest.postQueryItemSupplier || postQueryItemSupplier
        });
        const confluenceAdvancedSearchUrlFactory = (0, (0, parcelRequire("iRI1s")).useConfluenceAdvancedSearchUrlFactory)(recentClientConfig.url, {
            spaceFilters: spaceFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.spaceKey || ''),
            peopleFilters: peopleFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.id),
            dateFilter: !!appliedDateFilter ? [
                appliedDateFilter
            ] : []
        });
        const recentSectionTitleGenerator = (0, $5uXOq.useCallback)((section)=>{
            return section.title;
        }, []);
        const loadSpaceFilters = (0, $5uXOq.useCallback)((query)=>{
            return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
                query: query,
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Space
                ],
                modelParams: [],
                resultLimit: (0, (0, parcelRequire("5S6Yv")).SPACE_FILTER_LIMIT),
                experience: (0, (0, parcelRequire("5S6Yv")).NAVIGATION_V3_EXPERIENCE),
                sites: []
            }).then(({ response: response })=>{
                const results = response.retrieveScope((0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Space)?.results;
                return results?.map((result)=>({
                        value: {
                            id: result.id,
                            spaceKey: result.space?.key || '',
                            avatarUrl: `${result.baseUrl}${result.space.icon.path}`,
                            label: result.title,
                            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).SEARCH,
                            isChecked: false,
                            isVisible: true
                        },
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnyO0")).FilterOptionItem), {
                            label: result.title,
                            iconProps: {
                                src: `${result.baseUrl}${result.space.icon.path}`,
                                appearance: 'square'
                            }
                        })
                    })) || [];
            });
        }, [
            searchClient,
            isUserAnonymous
        ]);
        const loadPeopleFilters = (0, $5uXOq.useCallback)((query)=>{
            return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
                query: query,
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People
                ],
                modelParams: [],
                resultLimit: (0, (0, parcelRequire("5S6Yv")).PEOPLE_FILTER_LIMIT),
                experience: (0, (0, parcelRequire("5S6Yv")).NAVIGATION_V3_EXPERIENCE),
                sites: []
            }).then(({ response: response })=>{
                const results = response.retrieveScope((0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People)?.results;
                return results?.map((result)=>({
                        value: {
                            id: result.id,
                            avatarUrl: result.avatarUrl,
                            label: result.name,
                            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).SEARCH,
                            isChecked: false,
                            isVisible: true
                        },
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnyO0")).FilterOptionItem), {
                            label: result.name,
                            iconProps: {
                                src: result.avatarUrl
                            }
                        })
                    })) || [];
            });
        }, [
            searchClient,
            isUserAnonymous
        ]);
        const confluenceTabGenericFilters = (0, $5uXOq.useMemo)(()=>{
            return [
                {
                    ['@type']: (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).Space,
                    fieldName: 'spaceKeys',
                    store: spaceFilterStore,
                    loadFilterOptions: loadSpaceFilters,
                    sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).space_filters_title),
                    findMoreLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).space_filters_find_more)
                },
                {
                    ['@type']: (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).People,
                    fieldName: 'accountIds',
                    store: peopleFilterStore,
                    loadFilterOptions: loadPeopleFilters,
                    sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).contributor_filters_title),
                    findMoreLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).contributor_filters_find_more),
                    filterConfig: {
                        filterOptionIconShape: 'circle'
                    }
                }
            ];
        }, [
            formatMessage,
            loadPeopleFilters,
            loadSpaceFilters,
            peopleFilterStore,
            spaceFilterStore
        ]);
        const filtersToDefine = (0, $5uXOq.useMemo)(()=>{
            return [
                ...confluenceTabDateFilter,
                ...siteFilterDefinition,
                ...confluenceTabGenericFilters
            ];
        }, [
            confluenceTabGenericFilters,
            confluenceTabDateFilter,
            siteFilterDefinition
        ]);
        const onPrequeryBannerRender = (0, $5uXOq.useCallback)(()=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onPrequeryBannerShown)());
        }, [
            fireAnalyticsEvent
        ]);
        const onPromptSuggestionClick = (0, $5uXOq.useCallback)((prompt, promptId)=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onSuggestedPromptClick)(promptId));
            setQuery(prompt);
            toggleShowSearchAIDialog(true);
        }, [
            fireAnalyticsEvent,
            setQuery,
            toggleShowSearchAIDialog
        ]);
        const dismissOnboardingBanner = (0, $5uXOq.useCallback)(()=>{
            if (aiSearchConfig?.dismissPrequeryBanner) {
                fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onPrequeryBannerDismiss)());
                aiSearchConfig.dismissPrequeryBanner();
            }
        }, [
            aiSearchConfig,
            fireAnalyticsEvent
        ]);
        const initializeFilters = (0, $5uXOq.useCallback)(()=>{
            defineFilters((0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID), filtersToDefine);
        }, [
            defineFilters,
            filtersToDefine
        ]);
        initializeFilters();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            id: (0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID),
            expandedStateInputPlaceholder: !!aiSearchConfig ? formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_search_input_expanded_placeholder_ai) : formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_search_input_expanded_placeholder),
            title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_tab_label),
            autocorrectEnabled: autocorrectEnabled,
            sections: sections,
            generateAdvancedSearchUrl: confluenceAdvancedSearchUrlFactory,
            preQuerySectionTitleGenerator: recentSectionTitleGenerator,
            showViewAllFiltersLink: true,
            ...rest,
            ...itemSuppliers,
            aiSearchConfig: aiSearchConfig,
            permissionSupplier: confluenceSites.length > 0 ? (0, (0, parcelRequire("9WUgS")).defaultPermissionsSupplier) : rest.permissionSupplier,
            appendQueryParams: appendQueryParams
        }, ({ productState: productState })=>{
            if (productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess) {
                if (!!aiAdminNotificationHeader) return {
                    Header: aiAdminNotificationHeader
                };
                if (!!aiSearchConfig && aiSearchConfig.prequeryBannerEnabled) return {
                    Header: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($ed6ea212d5cb6772$var$InteractiveSearchAIOnboardingBanner, {
                            onPromptSuggestionClick: onPromptSuggestionClick,
                            onXButtonClick: dismissOnboardingBanner,
                            onBannerShown: onPrequeryBannerRender
                        })
                };
            }
            return {};
        });
    };
});
parcelRegister("5S6Yv", function(module, exports) {
    $parcel$export(module.exports, "CONFLUENCE_PRODUCT_ID", ()=>$37972a2792953ed7$export$661dd16d63ed8290);
    $parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", ()=>$37972a2792953ed7$export$4a204ebf24901f2e);
    $parcel$export(module.exports, "SPACE_FILTER_LIMIT", ()=>$37972a2792953ed7$export$10d5a4cb19960c6c);
    $parcel$export(module.exports, "PEOPLE_FILTER_LIMIT", ()=>$37972a2792953ed7$export$b41e7ecd9ba9baff);
    $parcel$export(module.exports, "ConfluenceFilters", ()=>$37972a2792953ed7$export$cf834bb06694a4e);
    $parcel$export(module.exports, "ConfluenceScope", ()=>$37972a2792953ed7$export$bb0f876d33576f3f);
    const $37972a2792953ed7$export$661dd16d63ed8290 = 'confluence';
    const $37972a2792953ed7$export$4a204ebf24901f2e = 'confluence.nav-v3';
    const $37972a2792953ed7$export$d4cf0635e2303166 = 250;
    const $37972a2792953ed7$export$10d5a4cb19960c6c = 10;
    const $37972a2792953ed7$export$b41e7ecd9ba9baff = 10;
    var $37972a2792953ed7$export$cf834bb06694a4e;
    (function(ConfluenceFilters) {
        ConfluenceFilters["Space"] = "spaces";
        ConfluenceFilters["People"] = "contributors";
        ConfluenceFilters["Date"] = "lastModified";
    })($37972a2792953ed7$export$cf834bb06694a4e || ($37972a2792953ed7$export$cf834bb06694a4e = {}));
    var $37972a2792953ed7$export$bb0f876d33576f3f;
    (function(ConfluenceScope) {
        ConfluenceScope["Item"] = "confluence.page,blogpost,attachment";
        ConfluenceScope["Space"] = "confluence.space";
        ConfluenceScope["People"] = "urs.user-confluence";
        ConfluenceScope["Content"] = "confluence.page,blogpost,attachment,whiteboard";
    })($37972a2792953ed7$export$bb0f876d33576f3f || ($37972a2792953ed7$export$bb0f876d33576f3f = {}));
});
parcelRegister("iRI1s", function(module, exports) {
    $parcel$export(module.exports, "useConfluenceAdvancedSearchUrlFactory", ()=>$845351b910327ad7$export$e189237de9f436c5);
    $parcel$export(module.exports, "defaultFormatDate", ()=>$845351b910327ad7$export$579a505f09fc5afa);
    var $5uXOq = parcelRequire("5uXOq");
    const $845351b910327ad7$var$CONFLUENCE_ADVANCED_SEARCH_URL = '/wiki/search';
    const $845351b910327ad7$var$removeDuplicateWikiInUrl = (siteUrl)=>{
        return siteUrl.replace(/\/wiki(\/)?$/, '');
    };
    function $845351b910327ad7$export$e189237de9f436c5(siteUrl, filters) {
        const trimmedSiteUrl = $845351b910327ad7$var$removeDuplicateWikiInUrl(siteUrl);
        const spaceFilterString = filters.spaceFilters.length > 0 ? `&spaces=${encodeURIComponent(filters.spaceFilters.join(','))}` : '';
        const peopleFilterString = filters.peopleFilters.length > 0 ? `&contributors=${encodeURIComponent(filters.peopleFilters.join(','))}` : '';
        const dateFilterString = filters.dateFilter.length > 0 ? `&lastModified=${filters.dateFilter[0]}` : '';
        return (0, $5uXOq.useCallback)((query, siteUrl)=>{
            const url = siteUrl ? $845351b910327ad7$var$removeDuplicateWikiInUrl(siteUrl) : trimmedSiteUrl;
            const trimmedQuery = query.trim();
            if (!trimmedQuery) return `${url}${$845351b910327ad7$var$CONFLUENCE_ADVANCED_SEARCH_URL}`;
            return `${url}${$845351b910327ad7$var$CONFLUENCE_ADVANCED_SEARCH_URL}?text=${encodeURIComponent(trimmedQuery)}${spaceFilterString}${peopleFilterString}${dateFilterString}`;
        }, [
            trimmedSiteUrl,
            spaceFilterString,
            peopleFilterString,
            dateFilterString
        ]);
    }
    const $845351b910327ad7$export$579a505f09fc5afa = (lastModified)=>{
        const date = new Date(lastModified);
        return date.toLocaleString();
    };
});
parcelRegister("3CuYo", function(module, exports) {
    $parcel$export(module.exports, "useRecentsClient", ()=>$57281abd856e23a8$export$2ac7f7e39d1eda48);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $8QpSo;
    var $6SBvm = parcelRequire("6SBvm");
    var $dS9cn = parcelRequire("dS9cn");
    var $5S6Yv;
    var $3GGIR;
    var $jFHlY;
    var $lQmoS;
    var $lFNae;
    var $lvCts;
    var $ckvH1;
    var $k7rsK;
    const $57281abd856e23a8$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
    const $57281abd856e23a8$var$RECENT_PAGES_PATH = 'rest/recentlyviewed/1.0/recent';
    const $57281abd856e23a8$var$RECENT_SPACE_PATH = 'rest/recentlyviewed/1.0/recent/spaces';
    const $57281abd856e23a8$var$DEFAULT_COLLAB_GRAPH_URL = 'gateway/api/collaboration';
    const $57281abd856e23a8$var$ACTIVITY_CLIENT_RETRY_MS = 250;
    const $57281abd856e23a8$var$RECENT_PAGES_LIMIT = 200;
    const $57281abd856e23a8$var$RECENT_SPACE_LIMIT = 10;
    const $57281abd856e23a8$var$RECENT_PEOPLE_LIMIT = 10;
    function $57281abd856e23a8$var$recentWorkItemToResult(recentItem) {
        const { object: object, containers: containers } = recentItem;
        return {
            resultId: object.id,
            containerName: containers[0].name,
            containerId: '',
            resultType: (0, (0, parcelRequire("3GGIR")).ConfluenceObjectResult),
            isRecentResult: true,
            name: object.name || '',
            href: object.url,
            contentType: `confluence-${object.type}`,
            lastModified: undefined,
            analyticsType: (0, (0, parcelRequire("3GGIR")).RecentConfluence)
        };
    }
    function $57281abd856e23a8$var$recentPageToResult(recentPage, baseUrl) {
        return {
            resultId: String(recentPage.id),
            name: recentPage.title || '',
            href: `${baseUrl}${recentPage.url}`,
            containerName: recentPage.space,
            analyticsType: (0, (0, parcelRequire("3GGIR")).RecentConfluence),
            resultType: (0, (0, parcelRequire("3GGIR")).ConfluenceObjectResult),
            contentType: `confluence-${recentPage.contentType}`,
            iconClass: recentPage.iconClass,
            containerId: recentPage.spaceId.toString(),
            isRecentResult: true,
            lastModified: undefined,
            spaceId: recentPage.spaceId?.toString()
        };
    }
    function $57281abd856e23a8$var$mapCollabGraphContainer(response) {
        const items = response.collaborationGraphEntities.map((item)=>({
                id: item.containerDetails?.id,
                key: item.containerDetails?.key,
                icon: item.containerDetails?.iconUrl,
                name: item.containerDetails?.name,
                url: item.containerDetails?.url
            })).filter((space)=>space.id !== undefined).map((space)=>$57281abd856e23a8$var$recentSpaceToResult(space, space.url));
        return {
            items: items,
            timings: response.timings
        };
    }
    function $57281abd856e23a8$var$recentSpaceToResult(recentSpace, href) {
        return {
            resultId: recentSpace.id,
            name: recentSpace.name,
            key: recentSpace.key,
            href: href,
            avatarUrl: recentSpace.icon,
            analyticsType: (0, (0, parcelRequire("3GGIR")).RecentConfluence),
            resultType: (0, (0, parcelRequire("3GGIR")).GenericContainerResult),
            contentType: (0, (0, parcelRequire("3GGIR")).ConfluenceSpace),
            id: recentSpace.id
        };
    }
    function $57281abd856e23a8$var$mapUrsPeople(response, timings, isMultiSite) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, (0, parcelRequire("3GGIR")).Scope).UserConfluence}`);
        if (response.error) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(response.error);
        const items = response.results.map((item)=>({
                resultType: (0, (0, parcelRequire("3GGIR")).PersonResult),
                resultId: `people-${item.id}`,
                userId: item.id,
                name: item.name,
                href: (0, (0, parcelRequire("ckvH1")).generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
                avatarUrl: item.avatarUrl,
                contentType: (0, (0, parcelRequire("3GGIR")).Person),
                analyticsType: (0, (0, parcelRequire("3GGIR")).ResultPerson),
                mentionName: item.nickname || '',
                presenceMessage: ''
            }));
        return {
            items: (0, ($parcel$interopDefault($3JOCw)))(items, (item)=>item.resultId),
            timings: timings
        };
    }
    class $57281abd856e23a8$var$RecentsCache {
        constructor(props){
            this.recentItemSupplier = async ()=>{
                if (!!this.recentCacheProps.recentWorkAPIUrl) try {
                    const { createActivityClient: createActivityClient } = await (parcelRequire("lljEA"));
                    const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentCacheProps.recentWorkAPIUrl);
                    const { viewed: viewed } = await activityClient.fetchActivities([
                        $57281abd856e23a8$var$ACTIVITY_CLIENT_RETRY_MS
                    ], {
                        products: [
                            'confluence'
                        ]
                    }, [
                        'viewed'
                    ]);
                    const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$57281abd856e23a8$var$recentWorkItemToResult(item));
                    return {
                        items: items,
                        totalSize: items.length,
                        timings: 0
                    };
                } catch (e) {
                    return {
                        items: [],
                        totalSize: 0,
                        timings: -1
                    };
                }
                else try {
                    const { result: result, durationMs: durationMs } = await (0, (0, parcelRequire("lFNae")).timed)((0, $dS9cn.utils).requestService({
                        url: this.recentCacheProps.url
                    }, {
                        path: $57281abd856e23a8$var$RECENT_PAGES_PATH,
                        queryParams: {
                            limit: $57281abd856e23a8$var$RECENT_PAGES_LIMIT
                        }
                    }));
                    const items = result.filter((page)=>!!page.title).map((recentPage)=>$57281abd856e23a8$var$recentPageToResult(recentPage, this.recentCacheProps.url));
                    return {
                        items: items,
                        totalSize: items.length,
                        timings: durationMs
                    };
                } catch (e) {
                    return {
                        items: [],
                        totalSize: 0,
                        timings: -1
                    };
                }
            };
            this.recentSpaceSupplier = async ()=>{
                if (this.recentCacheProps.isUserAnonymous) return Promise.resolve({
                    items: [],
                    timings: 0
                });
                if (this.recentCacheProps.isCollaborationGraphEnabled) return this.recentCacheProps.getCollabGraphContainers();
                else try {
                    const { result: result, durationMs: durationMs } = await (0, (0, parcelRequire("lFNae")).timed)((0, $dS9cn.utils).requestService({
                        url: this.recentCacheProps.url
                    }, {
                        path: $57281abd856e23a8$var$RECENT_SPACE_PATH,
                        queryParams: {
                            limit: $57281abd856e23a8$var$RECENT_SPACE_LIMIT
                        }
                    }));
                    return {
                        items: result.map((recentSpace)=>$57281abd856e23a8$var$recentSpaceToResult(recentSpace, `${this.recentCacheProps.url}/spaces/${recentSpace.key}`)),
                        timings: durationMs
                    };
                } catch (e) {
                    return {
                        items: [],
                        timings: -1
                    };
                }
            };
            this.recentPeopleSupplier = async ()=>{
                if (this.recentCacheProps.isUserAnonymous || !this.recentCacheProps.aggregatorClient) return Promise.resolve({
                    items: [],
                    timings: 0
                });
                return this.recentCacheProps.aggregatorClient.search({
                    query: '',
                    context: {
                        sessionId: '',
                        referrerId: null
                    },
                    scopes: [
                        (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People
                    ],
                    modelParams: [],
                    resultLimit: $57281abd856e23a8$var$RECENT_PEOPLE_LIMIT,
                    experience: $57281abd856e23a8$var$NAVIGATION_V3_EXPERIENCE,
                    sites: this.recentCacheProps.sites?.map((s)=>s.cloudId)
                }).then(({ response: response, requestDurationMs: requestDurationMs })=>$57281abd856e23a8$var$mapUrsPeople(response.retrieveScope((0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People), requestDurationMs, (this.recentCacheProps.sites || []).length > 0)).catch((e)=>({
                        items: [],
                        timings: -1
                    }));
            };
            this.recentCacheProps = props;
            this.recentItemCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.recentItemSupplier);
            this.recentSpaceCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.recentSpaceSupplier);
            this.recentPeopleCache = new (0, (0, parcelRequire("k7rsK")).SimpleCache)(this.recentPeopleSupplier);
        }
    }
    const $57281abd856e23a8$var$getRecentsCache = (0, (0, parcelRequire("8QpSo")).default)((recentsCacheProps)=>new $57281abd856e23a8$var$RecentsCache(recentsCacheProps), (0, ($parcel$interopDefault($6SBvm))));
    const $57281abd856e23a8$var$getCollabGraphClientWithConfig = (0, (0, parcelRequire("8QpSo")).default)((config)=>new (0, (0, parcelRequire("jFHlY")).CollaborationGraphClient)(config), (0, ($parcel$interopDefault($6SBvm))));
    const $57281abd856e23a8$export$2ac7f7e39d1eda48 = (props)=>{
        const aggregatorClient = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        const collabGraphClient = $57281abd856e23a8$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: props.collaborationGraphUrl || $57281abd856e23a8$var$DEFAULT_COLLAB_GRAPH_URL,
            cloudId: props.cloudId,
            isMultiSite: (props.sites || []).length > 1,
            sites: props.sites || [],
            collabGraphSessionId: props.collabGraphSessionId
        });
        const { isUserAnonymous: isUserAnonymous } = props;
        const getCollabGraphContainers = (0, $5uXOq.useCallback)(async ()=>{
            return isUserAnonymous ? Promise.resolve({
                items: [],
                timings: 0
            }) : collabGraphClient.getContainers([
                (0, $94417f843d249742$export$e28d152a38023114)
            ]).then((response)=>$57281abd856e23a8$var$mapCollabGraphContainer(response)).catch((e)=>({
                    items: [],
                    timings: -1
                }));
        }, [
            collabGraphClient,
            isUserAnonymous
        ]);
        const recentsCache = $57281abd856e23a8$var$getRecentsCache({
            ...props,
            aggregatorClient: aggregatorClient,
            getCollabGraphContainers: getCollabGraphContainers
        });
        const getRecentItems = (0, $5uXOq.useCallback)(()=>{
            return recentsCache.recentItemCache.get().value;
        }, [
            recentsCache
        ]);
        const getRecentSpaces = (0, $5uXOq.useCallback)(()=>{
            return recentsCache.recentSpaceCache.get().value;
        }, [
            recentsCache
        ]);
        const getRecentPeople = (0, $5uXOq.useCallback)(()=>{
            return recentsCache.recentPeopleCache.get().value;
        }, [
            recentsCache
        ]);
        return {
            getRecentItems: getRecentItems,
            getRecentSpaces: getRecentSpaces,
            getRecentPeople: getRecentPeople,
            getCollabGraphContainers: getCollabGraphContainers,
            searchClient: aggregatorClient,
            collabGraphClient: collabGraphClient
        };
    };
});
parcelRegister("3RKSV", function(module, exports) {
    $parcel$export(module.exports, "useFilterStore", ()=>$c22de69bbcb043d2$export$875b296eac126ec2);
    var $5uXOq = parcelRequire("5uXOq");
    var $gMpaQ;
    var $5uOu6;
    var $2k6eV;
    const $c22de69bbcb043d2$export$875b296eac126ec2 = (defaultFilters = [], productId, filterType)=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
        const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const storedFilters = readFilters(productId) ? readFilters(productId)[filterType] : [];
        const defaultFiltersRef = (0, $5uXOq.useRef)(stickySearchEnabled && storedFilters && storedFilters.length > 0 ? storedFilters : defaultFilters);
        const { filters: filters, dispatch: dispatch } = (0, (0, parcelRequire("5uOu6")).useFilter)(defaultFiltersRef.current);
        const addFilters = (0, $5uXOq.useCallback)((newFilters)=>dispatch((0, (0, parcelRequire("5uOu6")).addFilters)(newFilters, (a, b)=>{
                if (a.filterSource === (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER && b.filterSource !== (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER) return -1;
                if (a.filterSource !== (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER && b.filterSource === (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER) return 1;
                return 0;
            })), [
            dispatch
        ]);
        const loadDefaultFilters = (load)=>{
            setIsLoading(true);
            load.then((result)=>setDefaultFilters(result)).finally(()=>setIsLoading(false));
        };
        const updateFilter = (0, $5uXOq.useCallback)((id, isChecked, isVisible = true)=>dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(id, isChecked, isVisible)), [
            dispatch
        ]);
        const updateSingleValueFilter = (0, $5uXOq.useCallback)((id)=>{
            filters.forEach((f)=>dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(f.id, f.id === id)));
        }, [
            filters,
            dispatch
        ]);
        const clearFilter = (0, $5uXOq.useCallback)(()=>{
            filters.forEach((f)=>dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(f.id, false)));
        }, [
            filters,
            dispatch
        ]);
        const resetFilter = (0, $5uXOq.useCallback)(()=>{
            dispatch((0, (0, parcelRequire("5uOu6")).replaceAllFilters)(defaultFilters.length ? defaultFilters : defaultFiltersRef.current));
        }, [
            defaultFilters,
            dispatch
        ]);
        const setDefaultFilters = (0, $5uXOq.useCallback)((filters)=>{
            defaultFiltersRef.current = filters;
            resetFilter();
        }, [
            defaultFiltersRef,
            resetFilter
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (stickySearchEnabled) {
                const stickyFilter = readFilters(productId);
                stickyFilter[filterType] = filters;
                storeFilters(productId, stickyFilter);
            }
        }, [
            stickySearchEnabled,
            readFilters,
            storeFilters,
            productId,
            filterType,
            filters
        ]);
        return {
            availableFilters: filters,
            isLoading: isLoading && defaultFilters.length === 0,
            loadDefaultFilters: loadDefaultFilters,
            addFilters: addFilters,
            updateFilter: updateFilter,
            updateSingleValueFilter: updateSingleValueFilter,
            clearFilter: clearFilter,
            reset: resetFilter,
            dispatch: dispatch,
            setDefaultFilters: setDefaultFilters
        };
    };
});
parcelRegister("gMpaQ", function(module, exports) {
    $parcel$export(module.exports, "FilterOptionSource", ()=>$c1bdcdaf62eb4986$export$a386c4ddeb43c20a);
    var $c1bdcdaf62eb4986$export$a386c4ddeb43c20a;
    (function(FilterOptionSource) {
        FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
        FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
        FilterOptionSource["RECENT"] = "RECENT";
        FilterOptionSource["SEARCH"] = "SEARCH";
        FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
        FilterOptionSource["EXTERNAL"] = "EXTERNAL";
        FilterOptionSource["STATIC"] = "STATIC";
    })($c1bdcdaf62eb4986$export$a386c4ddeb43c20a || ($c1bdcdaf62eb4986$export$a386c4ddeb43c20a = {}));
});
parcelRegister("3UF9C", function(module, exports) {
    $parcel$export(module.exports, "FilterContextHOC", ()=>$503bef5c1b783a77$export$ceb34aeb37186333);
    $parcel$export(module.exports, "useGenericFilters", ()=>$503bef5c1b783a77$export$bc4556a4dba20090);
    $parcel$export(module.exports, "useSiteFilterDefinition", ()=>$503bef5c1b783a77$export$aa277293bef5fdbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $i5cPn;
    var $2k6eV;
    var $gMpaQ;
    var $3RKSV;
    var $bONub;
    var $k4hbD;
    const $503bef5c1b783a77$export$95f4aabc01d7575d = (0, ($parcel$interopDefault($5uXOq))).createContext({
        filterDefinitions: {},
        defineFilters: ()=>{}
    });
    const $503bef5c1b783a77$export$ceb34aeb37186333 = ({ children: children })=>{
        const filterDefinitions = (0, $5uXOq.useRef)({}).current;
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { stickySearchEnabled: stickySearchEnabled, resetExtensibleFiltersRef: resetExtensibleFiltersRef } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const previousExpandState = (0, $5uXOq.useRef)(isExpanded);
        const defineFilters = (productId, filters)=>{
            filterDefinitions[productId] = filters;
        };
        const resetFilters = ()=>{
            Object.keys(filterDefinitions).forEach((productId)=>{
                filterDefinitions[productId].forEach((filter)=>{
                    filter.store.reset();
                });
            });
        };
        (0, $5uXOq.useEffect)(()=>{
            if (previousExpandState.current && !isExpanded && !stickySearchEnabled) Object.keys(filterDefinitions).forEach((productId)=>{
                filterDefinitions[productId].forEach((filter)=>{
                    filter.store.reset();
                });
            });
            previousExpandState.current = isExpanded;
        }, [
            isExpanded,
            stickySearchEnabled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (resetExtensibleFiltersRef) resetExtensibleFiltersRef.current = resetFilters;
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($503bef5c1b783a77$export$95f4aabc01d7575d.Provider, {
            value: {
                filterDefinitions: filterDefinitions,
                defineFilters: defineFilters
            }
        }, children);
    };
    const $503bef5c1b783a77$export$bc4556a4dba20090 = ()=>(0, $5uXOq.useContext)($503bef5c1b783a77$export$95f4aabc01d7575d);
    const $503bef5c1b783a77$export$aa277293bef5fdbf = (workspaces, productId)=>{
        const isMultiWorkspace = workspaces && workspaces.length > 1;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const siteFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)(workspaces?.map((workspace, index)=>({
                label: workspace.name,
                id: workspace.id,
                isChecked: false,
                isVisible: index < 3,
                filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).EXTERNAL,
                avatarUrl: ''
            })), productId, (0, (0, parcelRequire("bONub")).SITE_FILTER_TYPE_NAME));
        if (isMultiWorkspace) return [
            {
                '@type': (0, (0, parcelRequire("bONub")).SITE_FILTER_TYPE_NAME),
                fieldName: 'values',
                store: siteFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).site_filters_title),
                findMoreLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).site_filters_find_more)
            }
        ];
        else return [];
    };
});
parcelRegister("dVo7Y", function(module, exports) {
    $parcel$export(module.exports, "useSearchConfigContext", ()=>$c6945e33dd34d635$export$dca16f1ca9af3934);
    var $5uXOq = parcelRequire("5uXOq");
    var $iK6UE;
    const $c6945e33dd34d635$var$SearchConfigContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        jiraSites: [],
        confluenceSites: [],
        atlasWorkspaces: []
    });
    const $c6945e33dd34d635$export$9ce36a8a6ea7b893 = (props)=>{
        const { children: children, skeleton: SkeletonComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null) } = props;
        const accessibleProducts = (0, (0, parcelRequire("iK6UE")).useSearchConfigClient)(props);
        return accessibleProducts == null ? (0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonComponent, null) : (0, ($parcel$interopDefault($5uXOq))).createElement($c6945e33dd34d635$var$SearchConfigContext.Provider, {
            value: accessibleProducts
        }, children);
    };
    function $c6945e33dd34d635$export$dca16f1ca9af3934() {
        return (0, $5uXOq.useContext)($c6945e33dd34d635$var$SearchConfigContext);
    }
});
parcelRegister("iK6UE", function(module, exports) {
    $parcel$export(module.exports, "AGGREGATOR_URL", ()=>$c78f48659b66734f$export$55ad0abefe643b5f);
    $parcel$export(module.exports, "useSearchConfigClient", ()=>$c78f48659b66734f$export$16414e90b8f90666);
    var $5uXOq = parcelRequire("5uXOq");
    var $dS9cn = parcelRequire("dS9cn");
    var $fFYHI;
    var $1EZbw;
    var $c78f48659b66734f$var$ProductsFromARI;
    (function(ProductsFromARI) {
        ProductsFromARI["JIRA"] = "jira";
        ProductsFromARI["CONFLUENCE"] = "confluence";
        ProductsFromARI["TOWNSQUARE"] = "townsquare";
    })($c78f48659b66734f$var$ProductsFromARI || ($c78f48659b66734f$var$ProductsFromARI = {}));
    const $c78f48659b66734f$var$CONFIG_API_URL = '/configuration/v1';
    const $c78f48659b66734f$export$55ad0abefe643b5f = '/gateway/api/xpsearch-aggregator';
    const $c78f48659b66734f$var$options = {
        path: $c78f48659b66734f$var$CONFIG_API_URL,
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const $c78f48659b66734f$var$noAccessState = {
        jiraSites: [],
        confluenceSites: [],
        atlasWorkspaces: []
    };
    const $c78f48659b66734f$var$dedupeEntriesById = (arr)=>{
        return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.id === initial.id) === index);
    };
    const $c78f48659b66734f$var$dedupeEntriesByCloudId = (arr)=>{
        return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.cloudId === initial.cloudId) === index);
    };
    const $c78f48659b66734f$export$ba14d9a5a581e827 = (response)=>{
        const groupedProducts = response.resources.reduce((acc, resource)=>{
            const { baseUrl: baseUrl, id: ari, siteName: siteName } = resource;
            const { id: id, product: product } = (0, (0, parcelRequire("fFYHI")).parseSiteARI)(ari);
            if (product.includes("jira")) acc.jiraSites && acc.jiraSites.push({
                product: (0, (0, parcelRequire("1EZbw")).Products).jira,
                avatarUrl: '',
                cloudId: id,
                siteUrl: baseUrl,
                siteName: siteName
            });
            if (product === "confluence") acc.confluenceSites && acc.confluenceSites.push({
                product: (0, (0, parcelRequire("1EZbw")).Products).confluence,
                avatarUrl: '',
                cloudId: id,
                siteUrl: baseUrl,
                siteName: siteName
            });
            if (product === "townsquare") acc.atlasWorkspaces && acc.atlasWorkspaces.push({
                name: siteName,
                id: id,
                baseUrl: baseUrl
            });
            return acc;
        }, $c78f48659b66734f$var$noAccessState);
        return {
            jiraSites: $c78f48659b66734f$var$dedupeEntriesByCloudId(groupedProducts.jiraSites),
            confluenceSites: $c78f48659b66734f$var$dedupeEntriesByCloudId(groupedProducts.confluenceSites),
            atlasWorkspaces: $c78f48659b66734f$var$dedupeEntriesById(groupedProducts.atlasWorkspaces)
        };
    };
    const $c78f48659b66734f$export$16414e90b8f90666 = (props)=>{
        const { aggregatorUrl: aggregatorUrl = `${$c78f48659b66734f$export$55ad0abefe643b5f}`, skip: skip = false } = props;
        const [accessibleProducts, setAccessibleProducts] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!skip && accessibleProducts === null) (0, $dS9cn.utils).requestService({
                url: aggregatorUrl
            }, $c78f48659b66734f$var$options).then((resp)=>{
                setAccessibleProducts($c78f48659b66734f$export$ba14d9a5a581e827(resp));
            }).catch((_e)=>{
                setAccessibleProducts($c78f48659b66734f$var$noAccessState);
            });
        }, [
            accessibleProducts,
            setAccessibleProducts,
            aggregatorUrl,
            skip
        ]);
        return accessibleProducts;
    };
});
parcelRegister("fFYHI", function(module, exports) {
    $parcel$export(module.exports, "parseSiteARI", ()=>$3960d39b10102c49$export$8837a793ca98a5b5);
    const $3960d39b10102c49$var$SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');
    const $3960d39b10102c49$export$8837a793ca98a5b5 = (ari)=>{
        if (!ari) return {
            product: '',
            id: ''
        };
        const [_original, product, id] = Array.from(ari.match($3960d39b10102c49$var$SITE_ARI_REGEX) || [
            '',
            '',
            ''
        ]);
        return {
            product: product,
            id: id
        };
    };
});
parcelRegister("1EZbw", function(module, exports) {
    $parcel$export(module.exports, "Products", ()=>$2b3a78109aa67a90$export$92e44ea1079b9ec6);
    var $5uXOq = parcelRequire("5uXOq");
    var $2b3a78109aa67a90$export$92e44ea1079b9ec6;
    (function(Products) {
        Products["jira"] = "JIRA";
        Products["confluence"] = "CONFLUENCE";
        Products["other"] = "OTHER";
    })($2b3a78109aa67a90$export$92e44ea1079b9ec6 || ($2b3a78109aa67a90$export$92e44ea1079b9ec6 = {}));
    const $2b3a78109aa67a90$var$primaryProductIndex = 0;
    const $2b3a78109aa67a90$var$ProductContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        products: [],
        activeIndex: $2b3a78109aa67a90$var$primaryProductIndex,
        primaryProduct: ''
    });
    const $2b3a78109aa67a90$export$7d76ff5e8c6ff5f2 = ({ children: children, products: products, activeIndex: activeIndex = 0, primaryProduct: primaryProduct = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement($2b3a78109aa67a90$var$ProductContext.Provider, {
            value: {
                products: products,
                activeIndex: Math.min(products.length - 1, Math.max(0, activeIndex)),
                primaryProduct: primaryProduct
            }
        }, children);
    const $2b3a78109aa67a90$export$964e8498268f0fe3 = ()=>(0, $5uXOq.useContext)($2b3a78109aa67a90$var$ProductContext).products;
    const $2b3a78109aa67a90$export$92c6f3c7c09f3247 = ()=>{
        const { products: products, primaryProduct: primaryProduct } = (0, $5uXOq.useContext)($2b3a78109aa67a90$var$ProductContext);
        return primaryProduct || products[$2b3a78109aa67a90$var$primaryProductIndex];
    };
    const $2b3a78109aa67a90$export$1fc003d00f9819a9 = ()=>{
        const context = (0, $5uXOq.useContext)($2b3a78109aa67a90$var$ProductContext);
        return context.products[context.activeIndex];
    };
});
parcelRegister("9WUgS", function(module, exports) {
    $parcel$export(module.exports, "defaultPermissionsSupplier", ()=>$2bbcecdd256c45ee$export$79b79eb7219cb5fd);
    var $5S6Yv;
    const $2bbcecdd256c45ee$export$79b79eb7219cb5fd = ()=>{
        const response = Object.values((0, (0, parcelRequire("5S6Yv")).ConfluenceScope));
        return Promise.resolve(response);
    };
});
parcelRegister("lnyO0", function(module, exports) {
    $parcel$export(module.exports, "FilterOptionItem", ()=>$c97aeca780b4a010$export$150fbd78f757731d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1oDph;
    var $ujWmd;
    const $c97aeca780b4a010$export$150fbd78f757731d = ({ label: label, iconProps: iconProps })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1oDph")).FilterShowMoreItem), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                name: label,
                size: 'small',
                ...iconProps
            }),
            label: label
        });
    };
});
parcelRegister("1oDph", function(module, exports) {
    $parcel$export(module.exports, "FilterShowMoreItem", ()=>$af590ee04fadb4a8$export$c09bfbbe14287de2);
    var $5uXOq = parcelRequire("5uXOq");
    var $cYugq;
    const $af590ee04fadb4a8$export$c09bfbbe14287de2 = ({ label: label, icon: icon, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYugq")).LabelWrapper), rest, icon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYugq")).IconWrapper), null, icon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYugq")).FilterColLabelText), null, label));
    };
});
parcelRegister("cYugq", function(module, exports) {
    $parcel$export(module.exports, "IconWrapper", ()=>$a6ab4ad7cc3d214c$export$be58b4326e23250f);
    $parcel$export(module.exports, "LabelWrapper", ()=>$a6ab4ad7cc3d214c$export$147422f7450ccfac);
    $parcel$export(module.exports, "FilterColLabelText", ()=>$a6ab4ad7cc3d214c$export$39d33abf45c3996);
    $parcel$export(module.exports, "FilterRowLabelText", ()=>$a6ab4ad7cc3d214c$export$dd6e1c6307d95848);
    $parcel$export(module.exports, "CheckboxWrapper", ()=>$a6ab4ad7cc3d214c$export$eef12940a6696c78);
    $parcel$export(module.exports, "PillButton", ()=>$a6ab4ad7cc3d214c$export$c5e39530e713771e);
    var $3JZ8k;
    var $bWGt6 = parcelRequire("bWGt6");
    const $a6ab4ad7cc3d214c$export$397f5285b920487e = (0, (0, parcelRequire("3JZ8k")).grid).multiple(22);
    const $a6ab4ad7cc3d214c$export$f51daa55764f8a9 = $a6ab4ad7cc3d214c$export$397f5285b920487e.half();
    const $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE = 2;
    const $a6ab4ad7cc3d214c$var$ICON_WIDTH = (0, (0, parcelRequire("3JZ8k")).grid).multiple(3).unitless + $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
    const $a6ab4ad7cc3d214c$var$ICON_HEIGHT = (0, (0, parcelRequire("3JZ8k")).grid).multiple(3).unitless + $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
    const $a6ab4ad7cc3d214c$export$be58b4326e23250f = (0, $bWGt6.default)("span", {
        target: "e6939t15"
    })({
        height: `${$a6ab4ad7cc3d214c$var$ICON_HEIGHT}px`,
        width: `${$a6ab4ad7cc3d214c$var$ICON_WIDTH}px`,
        padding: `0 ${(0, (0, parcelRequire("3JZ8k")).grid).unitless - $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px 0 ${(0, (0, parcelRequire("3JZ8k")).grid).half().unitless - $a6ab4ad7cc3d214c$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px`
    });
    const $a6ab4ad7cc3d214c$export$147422f7450ccfac = (0, $bWGt6.default)("span", {
        target: "e6939t14"
    })({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginLeft: "var(--ds-space-negative-050, -4px)",
        padding: `${(0, (0, parcelRequire("3JZ8k")).grid).unitless - 2} 0`
    });
    const $a6ab4ad7cc3d214c$export$39d33abf45c3996 = (0, $bWGt6.default)("span", {
        target: "e6939t13"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        width: $a6ab4ad7cc3d214c$export$397f5285b920487e.px,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
    });
    const $a6ab4ad7cc3d214c$export$dd6e1c6307d95848 = (0, $bWGt6.default)("span", {
        target: "e6939t12"
    })((0, (0, parcelRequire("3JZ8k")).nowrapEllipsis), {
        paddingLeft: (0, (0, parcelRequire("3JZ8k")).grid).half().px,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        width: $a6ab4ad7cc3d214c$export$f51daa55764f8a9.px
    });
    const $a6ab4ad7cc3d214c$export$eef12940a6696c78 = (0, $bWGt6.default)("span", {
        target: "e6939t11"
    })({
        padding: `${(0, (0, parcelRequire("3JZ8k")).grid).unitless - 2}px 0`,
        display: 'flex',
        flexGrow: 1
    });
    const $a6ab4ad7cc3d214c$export$c5e39530e713771e = (0, $bWGt6.default)("button", {
        target: "e6939t10"
    })((props)=>({
            height: `${(0, (0, parcelRequire("3JZ8k")).grid).multiple(3).unitless + 2}px`,
            color: props.selected ? `var(--ds-text-brand, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
            outline: 'none',
            boxSizing: 'border-box',
            padding: `${(0, (0, parcelRequire("3JZ8k")).grid).half().px} ${(0, (0, parcelRequire("3JZ8k")).grid).px}`,
            backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})` : `var(--ds-background-accent-gray-subtlest, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
            border: 'none',
            borderRadius: '14px',
            lineHeight: `${(0, (0, parcelRequire("3JZ8k")).grid).multiple(2).unitless + 2}px`,
            cursor: 'pointer',
            display: 'inline-flex',
            ':focus-visible': {
                outline: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})`}`,
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            }
        }));
});
parcelRegister("4DehF", function(module, exports) {
    $parcel$export(module.exports, "useConfluenceSections", ()=>$432480fd53e8a34c$export$468e9a0e16eb3222);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $5S6Yv;
    var $k4hbD;
    var $iRI1s;
    var $luwNM;
    var $bONub;
    var $lMcGZ;
    const $432480fd53e8a34c$var$ITEM_LIMIT_SIZE = 10;
    const $432480fd53e8a34c$var$SPACE_LIMIT_SIZE = 3;
    const $432480fd53e8a34c$var$PEOPLE_LIMIT_SIZE = 3;
    const $432480fd53e8a34c$export$468e9a0e16eb3222 = ({ formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled, rendererOverride: rendererOverride })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const confluenceItemResultMapper = (0, $5uXOq.useCallback)(({ results: results })=>results.map((result)=>({
                    id: result.content.id,
                    title: result.title,
                    type: result.content.type,
                    meta: result.container.title,
                    additionalMeta: result.lastModified ? formatDate ? formatDate(result.lastModified) : (0, (0, parcelRequire("iRI1s")).defaultFormatDate)(result.lastModified) : '',
                    url: `${result.baseUrl}${result.url}`,
                    containerId: result.content?.space?.id || result.container?.id || 'UNAVAILABLE',
                    iconRenderer: (0, (0, parcelRequire("luwNM")).ConfluenceItemIconRenderer)(result, true)
                })).slice(0, $432480fd53e8a34c$var$ITEM_LIMIT_SIZE), [
            formatDate
        ]);
        const confluenceSpaceResultMapper = (0, $5uXOq.useCallback)(({ results: results })=>results.map((result)=>({
                    id: result.id,
                    title: result.title,
                    meta: '',
                    url: `${result.baseUrl || ''}${result.container.displayUrl}`,
                    containerId: result.id,
                    icon: (0, (0, parcelRequire("luwNM")).GenericConfluenceIconRenderer)(`${result.baseUrl}${result.space.icon.path}`, true)
                })).slice(0, $432480fd53e8a34c$var$SPACE_LIMIT_SIZE), []);
        const confluencePeopleResultMapper = (0, $5uXOq.useCallback)(({ results: results })=>results.map((result)=>({
                    id: result.id,
                    title: result.name,
                    meta: '',
                    url: result.absoluteUrl?.replace('/people', '/wiki/people') || '',
                    containerId: '',
                    icon: (0, (0, parcelRequire("luwNM")).GenericConfluenceIconRenderer)(result.avatarUrl, true)
                })).slice(0, $432480fd53e8a34c$var$PEOPLE_LIMIT_SIZE), []);
        const enableSpaceAndPeopleScope = (query, filters)=>{
            return !filters.find((filter)=>filter['@type'] === 'spaces' && filter['spaceKeys'].length > 0 || filter['@type'] === 'contributors' && filter['accountIds'].length > 0 || filter['@type'] === 'lastModified' && filter.from && filter.from !== (0, (0, parcelRequire("bONub")).DEFAULT_OPTION));
        };
        const scopeId = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Item;
        return (0, $5uXOq.useMemo)(()=>[
                {
                    id: scopeId,
                    title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_content_section_heading),
                    titleRenderer: (0, (0, parcelRequire("lMcGZ")).sectionTitleRenderer)(!!autocorrectEnabled),
                    resultRenderer: additionalContentTypesEnabled && !!rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, (0, parcelRequire("lMcGZ")).ConfluenceItemResultRenderer),
                    scope: scopeId,
                    resultMapper: confluenceItemResultMapper,
                    showResultCount: true,
                    resultLimit: $432480fd53e8a34c$var$ITEM_LIMIT_SIZE
                },
                {
                    id: (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Space,
                    title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_spaces_section_heading),
                    scope: (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Space,
                    resultMapper: confluenceSpaceResultMapper,
                    isEnabled: enableSpaceAndPeopleScope
                },
                {
                    id: (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People,
                    title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_people_section_heading),
                    scope: (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People,
                    resultMapper: confluencePeopleResultMapper,
                    isEnabled: enableSpaceAndPeopleScope
                }
            ], [
            formatMessage,
            autocorrectEnabled,
            confluenceItemResultMapper,
            confluenceSpaceResultMapper,
            confluencePeopleResultMapper,
            scopeId,
            additionalContentTypesEnabled,
            rendererOverride
        ]);
    };
});
parcelRegister("luwNM", function(module, exports) {
    $parcel$export(module.exports, "getAvatarForConfluenceObjectResult", ()=>$58a870bb05bb3b63$export$310004de4fa0ccba);
    $parcel$export(module.exports, "ConfluenceItemIconRenderer", ()=>$58a870bb05bb3b63$export$9e3ce228520dfa00);
    $parcel$export(module.exports, "GenericConfluenceIconRenderer", ()=>$58a870bb05bb3b63$export$8fde8d521a2cd996);
    var $5uXOq = parcelRequire("5uXOq");
    var $8njZH;
    var $dOkKo;
    var $eABwY;
    var $7BHMh;
    var $daL8e;
    var $5m93C;
    var $kKp2J;
    var $6cEsd;
    var $lDRqn;
    var $im5Hg;
    var $61uoP;
    var $dSQQ7;
    var $9CRO6;
    var $lBSka;
    var $7zjHG;
    var $jGmM2;
    var $dg1MW;
    var $2tm8x;
    var $cHwqN;
    var $gYsK7;
    var $b7OK3;
    var $2sfBf;
    var $jGT44;
    var $feAkl;
    var $1KrIR;
    const $58a870bb05bb3b63$var$ATTACHMENT_ICON_CLASS_PREFIXES = [
        'content-type-attachment-',
        'icon-file-'
    ];
    const $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR = (0, ($parcel$interopDefault((0, parcelRequire("7BHMh")))));
    const $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR_LARGE = (0, ($parcel$interopDefault((0, parcelRequire("jGmM2")))));
    const $58a870bb05bb3b63$var$ATTACHMENT_FILE_EXTENSION_MATCHERS = [
        {
            regexp: /\.(gif|jpeg|jpg|png)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("daL8e"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("dg1MW")))))
        },
        {
            regexp: /\.(pdf)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("5m93C"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("2tm8x")))))
        },
        {
            regexp: /\.(docx|dotx|doc|dot)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("im5Hg"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("2sfBf")))))
        },
        {
            regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("6cEsd"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("gYsK7")))))
        },
        {
            regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("eABwY"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("7zjHG")))))
        },
        {
            regexp: /\.(wma|wmv|ram|mp3)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("dOkKo"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("lBSka")))))
        },
        {
            regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("kKp2J"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("cHwqN")))))
        },
        {
            regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("lDRqn"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("b7OK3")))))
        },
        {
            regexp: /\.(zip)$/i,
            avatar: (0, ($parcel$interopDefault((0, parcelRequire("8njZH"))))),
            avatarLarge: (0, ($parcel$interopDefault((0, parcelRequire("9CRO6")))))
        }
    ];
    const $58a870bb05bb3b63$var$getIconType = (iconClass, fileName, isLarge)=>{
        const prefixMatches = $58a870bb05bb3b63$var$ATTACHMENT_ICON_CLASS_PREFIXES.find((prefix)=>{
            return iconClass.startsWith(prefix);
        });
        if (prefixMatches) {
            const matchingType = $58a870bb05bb3b63$var$ATTACHMENT_FILE_EXTENSION_MATCHERS.find((extensionMatcher)=>{
                const matches = extensionMatcher.regexp.exec(fileName);
                return !!matches && matches.length > 0;
            });
            if (matchingType) return isLarge ? matchingType.avatarLarge : matchingType.avatar;
        }
        return isLarge ? $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR_LARGE : $58a870bb05bb3b63$var$DEFAULT_ATTACHMENT_AVATAR;
    };
    const $58a870bb05bb3b63$export$310004de4fa0ccba = ({ type: type, title: title, iconCssClass: iconCssClass, isCollapsed: isCollapsed })=>{
        if (type === 'page' || type === 'confluence-page') {
            const Icon = isCollapsed ? (0, ($parcel$interopDefault((0, parcelRequire("feAkl"))))) : (0, ($parcel$interopDefault((0, parcelRequire("dSQQ7")))));
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: type
            });
        } else if (type === 'blogpost' || type === 'confluence-blogpost') {
            const Icon = isCollapsed ? (0, ($parcel$interopDefault((0, parcelRequire("jGT44"))))) : (0, ($parcel$interopDefault((0, parcelRequire("61uoP")))));
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: type
            });
        } else if (type === 'attachment') {
            const IconComponent = $58a870bb05bb3b63$var$getIconType(iconCssClass || '', title, isCollapsed);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IconComponent, {
                label: type
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    const $58a870bb05bb3b63$export$9e3ce228520dfa00 = (result, largerIcons)=>()=>{
            if (result.content) return $58a870bb05bb3b63$export$310004de4fa0ccba({
                type: result.content.type,
                title: result.content.type,
                iconCssClass: result.iconCssClass,
                isCollapsed: largerIcons
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        };
    const $58a870bb05bb3b63$export$8fde8d521a2cd996 = (iconUrl, largerIcons)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1KrIR")).ResultAvatar), {
            borderColor: "transparent",
            src: iconUrl,
            appearance: "square",
            size: largerIcons ? 'small' : 'xsmall',
            testId: "result-avatar"
        });
});
parcelRegister("8njZH", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $618ffb1f66ed7d88$var$_react = $618ffb1f66ed7d88$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $618ffb1f66ed7d88$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $618ffb1f66ed7d88$var$Archive16Icon = (props)=>$618ffb1f66ed7d88$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $618ffb1f66ed7d88$var$Archive16Icon.displayName = 'Archive16Icon';
    var $618ffb1f66ed7d88$var$_default = module.exports.default = $618ffb1f66ed7d88$var$Archive16Icon;
});
parcelRegister("dOkKo", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $a0e009d71aa209df$var$_react = $a0e009d71aa209df$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $a0e009d71aa209df$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a0e009d71aa209df$var$Audio16Icon = (props)=>$a0e009d71aa209df$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $a0e009d71aa209df$var$Audio16Icon.displayName = 'Audio16Icon';
    var $a0e009d71aa209df$var$_default = module.exports.default = $a0e009d71aa209df$var$Audio16Icon;
});
parcelRegister("eABwY", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $a9f18a5320d9d60d$var$_react = $a9f18a5320d9d60d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $a9f18a5320d9d60d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a9f18a5320d9d60d$var$ExcelSpreadsheet16Icon = (props)=>$a9f18a5320d9d60d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $a9f18a5320d9d60d$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
    var $a9f18a5320d9d60d$var$_default = module.exports.default = $a9f18a5320d9d60d$var$ExcelSpreadsheet16Icon;
});
parcelRegister("7BHMh", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $589df26f9969902f$var$_react = $589df26f9969902f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $589df26f9969902f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $589df26f9969902f$var$Generic16Icon = (props)=>$589df26f9969902f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $589df26f9969902f$var$Generic16Icon.displayName = 'Generic16Icon';
    var $589df26f9969902f$var$_default = module.exports.default = $589df26f9969902f$var$Generic16Icon;
});
parcelRegister("daL8e", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $9970c4e7d3f96cd3$var$_react = $9970c4e7d3f96cd3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $9970c4e7d3f96cd3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9970c4e7d3f96cd3$var$Image16Icon = (props)=>$9970c4e7d3f96cd3$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
        }, props, {
            size: 'small'
        }));
    $9970c4e7d3f96cd3$var$Image16Icon.displayName = 'Image16Icon';
    var $9970c4e7d3f96cd3$var$_default = module.exports.default = $9970c4e7d3f96cd3$var$Image16Icon;
});
parcelRegister("5m93C", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $3e66086d4264b484$var$_react = $3e66086d4264b484$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $3e66086d4264b484$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3e66086d4264b484$var$PdfDocument16Icon = (props)=>$3e66086d4264b484$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
        }, props, {
            size: 'small'
        }));
    $3e66086d4264b484$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
    var $3e66086d4264b484$var$_default = module.exports.default = $3e66086d4264b484$var$PdfDocument16Icon;
});
parcelRegister("kKp2J", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $f1ab878cb9f5def5$var$_react = $f1ab878cb9f5def5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $f1ab878cb9f5def5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f1ab878cb9f5def5$var$PowerpointPresentation16Icon = (props)=>$f1ab878cb9f5def5$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $f1ab878cb9f5def5$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
    var $f1ab878cb9f5def5$var$_default = module.exports.default = $f1ab878cb9f5def5$var$PowerpointPresentation16Icon;
});
parcelRegister("6cEsd", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $48433e65bc802338$var$_react = $48433e65bc802338$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $48433e65bc802338$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $48433e65bc802338$var$SourceCode16Icon = (props)=>$48433e65bc802338$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm6.639 8.417L4.253 8.1l2.589-2.51a.924.924 0 1 0-1.288-1.328L2.281 7.435a.925.925 0 0 0 0 1.328l3.07 2.976a.925.925 0 1 0 1.288-1.328m7.203-3.173L10.77 4.26a.924.924 0 1 0-1.286 1.33l2.385 2.313-2.588 2.51a.924.924 0 1 0 1.287 1.327l3.274-3.173a.925.925 0 0 0 0-1.328"/></svg>`
        }, props, {
            size: 'small'
        }));
    $48433e65bc802338$var$SourceCode16Icon.displayName = 'SourceCode16Icon';
    var $48433e65bc802338$var$_default = module.exports.default = $48433e65bc802338$var$SourceCode16Icon;
});
parcelRegister("lDRqn", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $fc16ae7d17f8a28d$var$_react = $fc16ae7d17f8a28d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $fc16ae7d17f8a28d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fc16ae7d17f8a28d$var$Video16Icon = (props)=>$fc16ae7d17f8a28d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
        }, props, {
            size: 'small'
        }));
    $fc16ae7d17f8a28d$var$Video16Icon.displayName = 'Video16Icon';
    var $fc16ae7d17f8a28d$var$_default = module.exports.default = $fc16ae7d17f8a28d$var$Video16Icon;
});
parcelRegister("im5Hg", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $d5ceb35532dd9e71$var$_react = $d5ceb35532dd9e71$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $d5ceb35532dd9e71$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d5ceb35532dd9e71$var$WordDocument16Icon = (props)=>$d5ceb35532dd9e71$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $d5ceb35532dd9e71$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
    var $d5ceb35532dd9e71$var$_default = module.exports.default = $d5ceb35532dd9e71$var$WordDocument16Icon;
});
parcelRegister("61uoP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $462a6acb8358e55a$var$_react = $462a6acb8358e55a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $462a6acb8358e55a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $462a6acb8358e55a$var$Blog16Icon = (props)=>$462a6acb8358e55a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`
        }, props, {
            size: "small"
        }));
    $462a6acb8358e55a$var$Blog16Icon.displayName = 'Blog16Icon';
    var $462a6acb8358e55a$var$_default = module.exports.default = $462a6acb8358e55a$var$Blog16Icon;
});
parcelRegister("dSQQ7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a1b94e5f124869c4$var$_react = $a1b94e5f124869c4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $a1b94e5f124869c4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a1b94e5f124869c4$var$Page16Icon = (props)=>$a1b94e5f124869c4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            size: "small"
        }));
    $a1b94e5f124869c4$var$Page16Icon.displayName = 'Page16Icon';
    var $a1b94e5f124869c4$var$_default = module.exports.default = $a1b94e5f124869c4$var$Page16Icon;
});
parcelRegister("9CRO6", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $702166a50812bddf$var$_react = $702166a50812bddf$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $702166a50812bddf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $702166a50812bddf$var$Archive24Icon = (props)=>$702166a50812bddf$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $702166a50812bddf$var$Archive24Icon.displayName = 'Archive24Icon';
    var $702166a50812bddf$var$_default = module.exports.default = $702166a50812bddf$var$Archive24Icon;
});
parcelRegister("lBSka", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $fbb7315e8019fa9d$var$_react = $fbb7315e8019fa9d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $fbb7315e8019fa9d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fbb7315e8019fa9d$var$Audio24Icon = (props)=>$fbb7315e8019fa9d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $fbb7315e8019fa9d$var$Audio24Icon.displayName = 'Audio24Icon';
    var $fbb7315e8019fa9d$var$_default = module.exports.default = $fbb7315e8019fa9d$var$Audio24Icon;
});
parcelRegister("7zjHG", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $582b1603b710ea90$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>$582b1603b710ea90$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
    var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;
});
parcelRegister("jGmM2", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $e5439afabf017b97$var$_react = $e5439afabf017b97$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $e5439afabf017b97$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e5439afabf017b97$var$Generic24Icon = (props)=>$e5439afabf017b97$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $e5439afabf017b97$var$Generic24Icon.displayName = 'Generic24Icon';
    var $e5439afabf017b97$var$_default = module.exports.default = $e5439afabf017b97$var$Generic24Icon;
});
parcelRegister("dg1MW", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $9a6e2824e29d024a$var$_react = $9a6e2824e29d024a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $9a6e2824e29d024a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9a6e2824e29d024a$var$Image24Icon = (props)=>$9a6e2824e29d024a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $9a6e2824e29d024a$var$Image24Icon.displayName = 'Image24Icon';
    var $9a6e2824e29d024a$var$_default = module.exports.default = $9a6e2824e29d024a$var$Image24Icon;
});
parcelRegister("2tm8x", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $1ccf7616b127308b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>$1ccf7616b127308b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
    var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;
});
parcelRegister("cHwqN", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $93f2a85309224bbe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>$93f2a85309224bbe$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
    var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;
});
parcelRegister("gYsK7", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $c5b88baa981b1084$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>$c5b88baa981b1084$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
    var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;
});
parcelRegister("b7OK3", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $8197b56faa95d635$var$_react = $8197b56faa95d635$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $8197b56faa95d635$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8197b56faa95d635$var$Video24Icon = (props)=>$8197b56faa95d635$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $8197b56faa95d635$var$Video24Icon.displayName = 'Video24Icon';
    var $8197b56faa95d635$var$_default = module.exports.default = $8197b56faa95d635$var$Video24Icon;
});
parcelRegister("2sfBf", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>$1c9a4c12d2fc4227$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
    var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;
});
parcelRegister("jGT44", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e55ca74110fab569$var$_react = $e55ca74110fab569$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $e55ca74110fab569$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e55ca74110fab569$var$Blog24Icon = (props)=>$e55ca74110fab569$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
        }, props, {
            size: "medium"
        }));
    $e55ca74110fab569$var$Blog24Icon.displayName = 'Blog24Icon';
    var $e55ca74110fab569$var$_default = module.exports.default = $e55ca74110fab569$var$Blog24Icon;
});
parcelRegister("feAkl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b17457a34be52460$var$_react = $b17457a34be52460$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $b17457a34be52460$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b17457a34be52460$var$Page24Icon = (props)=>$b17457a34be52460$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
        }, props, {
            size: "medium"
        }));
    $b17457a34be52460$var$Page24Icon.displayName = 'Page24Icon';
    var $b17457a34be52460$var$_default = module.exports.default = $b17457a34be52460$var$Page24Icon;
});
parcelRegister("lMcGZ", function(module, exports) {
    $parcel$export(module.exports, "sectionTitleRenderer", ()=>$548089604d372bb1$export$aee00814c9e3bae7);
    $parcel$export(module.exports, "ConfluenceItemResultRenderer", ()=>$548089604d372bb1$export$1bdb91707b6d5bed);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $koVbs;
    var $k4hbD;
    var $azBuE;
    var $337hv;
    var $71Kgw;
    var $cvYmc;
    var $luwNM;
    const $548089604d372bb1$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const { productState: productState } = args;
            const recentTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_recently_viewed_section_heading));
            const contentTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_content_section_heading));
            switch(productState){
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess:
                    return recentTitle;
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading:
                    if (autocorrectEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("337hv")).LoadingSkeleton), {
                        "data-testid": 'autocorrection-loading-skeleton'
                    });
                    return contentTitle;
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess:
                    if (autocorrectEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71Kgw")).AutocorrectAsyncWrapper), {
                        fallback: contentTitle
                    });
                    return contentTitle;
                default:
                    return contentTitle;
            }
        };
    const $548089604d372bb1$export$1bdb91707b6d5bed = ({ searchResult: searchResult, ...rest })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { productState: productState } = rest;
        if (productState === 'PreQuerySuccess') return (0, (0, parcelRequire("cvYmc")).defaultResultRenderer)({
            ...rest,
            searchResult: {
                ...searchResult,
                additionalMeta: ''
            }
        });
        if (productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, (0, parcelRequire("cvYmc")).defaultResultRenderer)({
            ...rest,
            searchResult: {
                ...searchResult,
                additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_recently_viewed_section_heading) : searchResult.additionalMeta,
                icon: !!searchResult.isRecentResult ? (0, (0, parcelRequire("luwNM")).getAvatarForConfluenceObjectResult)({
                    type: searchResult.additionalMeta || '',
                    title: searchResult.title,
                    isCollapsed: rest.isCollapsed
                }) : searchResult.icon
            }
        });
        return (0, (0, parcelRequire("cvYmc")).defaultResultRenderer)({
            searchResult: searchResult,
            ...rest
        });
    };
});
parcelRegister("337hv", function(module, exports) {
    $parcel$export(module.exports, "LoadingSkeleton", ()=>$322b20dd6ad0e588$export$44c18d210d5de37b);
    $parcel$export(module.exports, "TextLabelWrapper", ()=>$322b20dd6ad0e588$export$379a552b6c4d77e1);
    $parcel$export(module.exports, "TextCorrectionWrapper", ()=>$322b20dd6ad0e588$export$98340ed1d0e44a86);
    $parcel$export(module.exports, "AutocorrectWrapper", ()=>$322b20dd6ad0e588$export$c349a6e4bcccfcee);
    $parcel$export(module.exports, "NoResultsAutocorrectWrapper", ()=>$322b20dd6ad0e588$export$4bdce96b0ba50afe);
    var $bWGt6 = parcelRequire("bWGt6");
    function $322b20dd6ad0e588$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $322b20dd6ad0e588$export$44c18d210d5de37b = (0, $bWGt6.default)("div", {
        target: "e23w5vh4"
    })({
        backgroundColor: `var(--ds-surface, ${`${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)}`})`,
        height: '16px',
        width: '128px',
        borderRadius: '3px'
    });
    const $322b20dd6ad0e588$export$379a552b6c4d77e1 = (0, $bWGt6.default)("span", {
        target: "e23w5vh3"
    })({
        color: `var(--ds-text-accent-red, ${`${(0, $829f609a65d26a98$export$2010d0fb4295b346)}`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $322b20dd6ad0e588$export$98340ed1d0e44a86 = (0, $bWGt6.default)("a", {
        target: "e23w5vh2"
    })({
        cursor: 'pointer',
        color: `var(--ds-text-accent-blue, ${`${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)}`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $322b20dd6ad0e588$export$c349a6e4bcccfcee = (0, $bWGt6.default)("div", {
        target: "e23w5vh1"
    })({
        name: "wf8ttk",
        styles: "text-transform:initial;font-weight:initial"
    });
    const $322b20dd6ad0e588$export$4bdce96b0ba50afe = (0, $bWGt6.default)("div", {
        target: "e23w5vh0"
    })({
        name: "wgx6uf",
        styles: "margin-top:var(--ds-space-100, 8px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-200, 16px)"
    });
});
parcelRegister("71Kgw", function(module, exports) {
    $parcel$export(module.exports, "AutocorrectAsyncWrapper", ()=>$a8d174fe7b782e45$export$5e9f08d9cf554737);
    var $5uXOq = parcelRequire("5uXOq");
    const $a8d174fe7b782e45$var$LoadedAutocorrection = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("6uf3G")).then(({ LoadedAutocorrection: LoadedAutocorrection })=>({
                default: LoadedAutocorrection
            })));
    const $a8d174fe7b782e45$export$5e9f08d9cf554737 = ({ container: container, fallback: fallback })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a8d174fe7b782e45$var$LoadedAutocorrection, {
            container: container,
            fallback: fallback
        }));
    };
});
parcelRegister("6uf3G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cho3x").then(()=>parcelRequire('kS6aD'));
});
parcelRegister("1A3ka", function(module, exports) {
    $parcel$export(module.exports, "useConfluenceSuppliers", ()=>$d7659a1c2a00f403$export$c9757f311cedcc1d);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $5S6Yv;
    var $gMpaQ;
    var $lMcGZ;
    var $k4hbD;
    var $3CuYo;
    var $2dI5H;
    var $kv2Va;
    var $iRI1s;
    var $luwNM;
    var $cGpvK;
    const $d7659a1c2a00f403$var$RECENT_ITEMS_SIZE_LIMIT = 10;
    const $d7659a1c2a00f403$var$RECENT_SPACES_SIZE_LIMIT = 3;
    const $d7659a1c2a00f403$var$ITEM_LIMIT_SIZE = 10;
    const $d7659a1c2a00f403$var$SPACE_LIMIT_SIZE = 3;
    const $d7659a1c2a00f403$var$PEOPLE_LIMIT_SIZE = 3;
    const $d7659a1c2a00f403$export$c9757f311cedcc1d = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, spaceFilterStore: spaceFilterStore, peopleFilterStore: peopleFilterStore, isExpanded: isExpanded, isUserAnonymous: isUserAnonymous, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, rendererOverride: rendererOverride, additionalContentTypesEnabled: additionalContentTypesEnabled })=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const warmUpCache = isExpanded && query !== '' && getActiveProduct()?.id === (0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID);
        const [hasFetchedSpaces, setHasFetchedSpaces] = (0, $5uXOq.useState)(spaceFilterStore?.availableFilters?.length > 0 || false);
        const [hasFetchedUsers, setHasFetchedUsers] = (0, $5uXOq.useState)(peopleFilterStore?.availableFilters?.length > 0 || false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { isCollaborationGraphEnabled: isCollaborationGraphEnabled } = recentClientConfig;
        const { getRecentItems: getRecentItems, getRecentSpaces: getRecentSpaces, getRecentPeople: getRecentPeople, getCollabGraphContainers: getCollabGraphContainers } = (0, (0, parcelRequire("3CuYo")).useRecentsClient)(recentClientConfig);
        (0, $5uXOq.useEffect)(()=>{
            if (warmUpCache && !isCollaborationGraphEnabled && !hasFetchedSpaces) getCollabGraphContainers().then((spaces)=>{
                if (spaces.items.length > 0) spaceFilterStore.setDefaultFilters(spaces.items.map((item, index)=>({
                        id: item.id,
                        spaceKey: item.key,
                        avatarUrl: item.avatarUrl,
                        label: item.name,
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).RECENT,
                        isChecked: false,
                        isVisible: index < 3
                    })));
                setHasFetchedSpaces(true);
            });
        }, [
            isCollaborationGraphEnabled,
            getCollabGraphContainers,
            isExpanded,
            warmUpCache
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (warmUpCache && !hasFetchedUsers) {
                getRecentPeople().then((recentPeople)=>{
                    peopleFilterStore.setDefaultFilters(recentPeople.items.map((item, index)=>({
                            id: item.userId,
                            avatarUrl: item.avatarUrl,
                            label: item.name,
                            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).RECENT,
                            isChecked: false,
                            isVisible: index < 3
                        })));
                });
                setHasFetchedUsers(true);
            }
        }, [
            warmUpCache,
            peopleFilterStore,
            getRecentPeople,
            hasFetchedUsers
        ]);
        const contentResultRenderer = additionalContentTypesEnabled && rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, (0, parcelRequire("lMcGZ")).ConfluenceItemResultRenderer);
        const scope = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Item;
        const preQueryItemSupplier = (0, $5uXOq.useMemo)(()=>()=>Promise.all([
                    getRecentItems(),
                    getRecentSpaces()
                ]).then((results)=>{
                    const recentItems = results[0].items;
                    const recentSpaces = results[1].items;
                    if (!hasFetchedSpaces && isCollaborationGraphEnabled) {
                        spaceFilterStore.setDefaultFilters(recentSpaces.map((item, index)=>({
                                id: item.id,
                                spaceKey: item.key,
                                avatarUrl: item.avatarUrl,
                                label: item.name,
                                filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).RECENT,
                                isChecked: false,
                                isVisible: index < 3
                            })));
                        setHasFetchedSpaces(true);
                    }
                    return {
                        size: results.reduce((sum, { items: items })=>{
                            return sum + items.length;
                        }, 0),
                        sections: [
                            {
                                id: 'recent-confluence-items',
                                titleRenderer: (0, (0, parcelRequire("lMcGZ")).sectionTitleRenderer)(!!autocorrectEnabled),
                                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_recently_viewed_section_heading),
                                resultRenderer: contentResultRenderer,
                                scope: scope,
                                searchResults: recentItems.map((result)=>({
                                        id: result.resultId,
                                        title: result.name,
                                        meta: result.containerName,
                                        additionalMeta: result.contentType,
                                        url: result.href,
                                        containerId: result.spaceId,
                                        icon: (0, (0, parcelRequire("luwNM")).getAvatarForConfluenceObjectResult)({
                                            type: result.contentType,
                                            title: result.name,
                                            isCollapsed: false
                                        }),
                                        isRecentResult: true
                                    })),
                                resultLimit: $d7659a1c2a00f403$var$RECENT_ITEMS_SIZE_LIMIT
                            },
                            {
                                id: 'recent-confluence-spaces',
                                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_recently_spaces_section_heading),
                                searchResults: recentSpaces.map((result)=>({
                                        id: result.resultId,
                                        title: result.name,
                                        meta: '',
                                        url: result.href,
                                        containerId: '',
                                        iconUrl: result.avatarUrl,
                                        isRecentResult: true
                                    })),
                                resultLimit: $d7659a1c2a00f403$var$RECENT_SPACES_SIZE_LIMIT
                            }
                        ]
                    };
                }), [
            getRecentItems,
            getRecentSpaces,
            hasFetchedSpaces,
            isCollaborationGraphEnabled,
            autocorrectEnabled,
            intl,
            spaceFilterStore,
            contentResultRenderer,
            scope
        ]);
        const postQueryItemSupplier = (0, $5uXOq.useMemo)(()=>!searchClientConfig?.graphQLEnabled ? undefined : async (args)=>{
                const { hasCheckedFilters: hasCheckedFilters, getUserSearchResults: getUserSearchResults } = await (parcelRequire("kOHLG"));
                const pageBlogAttachmentGraphQLResultMapper = ({ node: item })=>{
                    return {
                        id: (0, (0, parcelRequire("cGpvK")).transformAriToId)(item?.id || '', item?.type || ''),
                        title: item?.title || '',
                        url: item?.url || '',
                        meta: item?.space?.name || '',
                        additionalMeta: item?.lastModified ? formatDate ? formatDate(item?.lastModified) : (0, (0, parcelRequire("iRI1s")).defaultFormatDate)(item?.lastModified) : '',
                        containerId: (0, (0, parcelRequire("cGpvK")).transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
                        type: item?.type || '',
                        icon: (0, (0, parcelRequire("luwNM")).getAvatarForConfluenceObjectResult)({
                            type: item?.type || '',
                            title: item?.title || '',
                            iconCssClass: item?.iconCssClass || '',
                            isCollapsed: true
                        })
                    };
                };
                const spaceGraphQLResultMapper = ({ node: item })=>{
                    return {
                        id: (0, (0, parcelRequire("cGpvK")).transformAriToId)(item?.id || '', item?.type || ''),
                        title: item?.title || '',
                        meta: '',
                        url: item?.url || '',
                        type: item?.type || '',
                        containerId: (0, (0, parcelRequire("cGpvK")).transformAriToId)(item?.id || '', item?.type || ''),
                        icon: (0, (0, parcelRequire("luwNM")).GenericConfluenceIconRenderer)(`/wiki${item?.iconPath || ''}`, true)
                    };
                };
                const peopleResultMapper = (user)=>({
                        title: user.name,
                        id: user.id,
                        meta: '',
                        url: `${window.location.origin}/wiki/people/${user.id}`,
                        icon: (0, (0, parcelRequire("luwNM")).GenericConfluenceIconRenderer)(`${user.avatarUrl}`, true)
                    });
                const fetchOnlyPageBlogAttachments = hasCheckedFilters(args.filters);
                const graphQLResultsPromise = searchClientConfig?.graphQLPromise?.(args);
                const peopleResultsPromise = fetchOnlyPageBlogAttachments || isUserAnonymous ? Promise.resolve([]) : getUserSearchResults({
                    query: args.query,
                    cloudId: searchClientConfig?.cloudId || '',
                    principalId: searchClientConfig?.userId,
                    intl: intl
                }).catch((e)=>[]);
                return Promise.all([
                    graphQLResultsPromise,
                    peopleResultsPromise
                ]).then((results)=>{
                    const pageBlogAttachmentResults = results[0]?.search.pageBlogAttachments.edges.map(pageBlogAttachmentGraphQLResultMapper) || [];
                    const pageBlogAttachmentsCount = results[0]?.search.pageBlogAttachments.totalCount;
                    const spaceResults = results[0]?.search.spaces?.edges.map(spaceGraphQLResultMapper) || [];
                    const peopleResults = results[1].map(peopleResultMapper) || [];
                    return {
                        sections: [
                            {
                                id: scope,
                                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_content_section_heading),
                                searchResults: pageBlogAttachmentResults,
                                titleRenderer: (0, (0, parcelRequire("lMcGZ")).sectionTitleRenderer)(!!autocorrectEnabled),
                                resultRenderer: contentResultRenderer,
                                showResultCount: true,
                                size: pageBlogAttachmentsCount || undefined,
                                resultLimit: $d7659a1c2a00f403$var$ITEM_LIMIT_SIZE
                            },
                            {
                                id: (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).Space,
                                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_spaces_section_heading),
                                searchResults: spaceResults,
                                resultLimit: $d7659a1c2a00f403$var$SPACE_LIMIT_SIZE
                            },
                            {
                                id: (0, (0, parcelRequire("5S6Yv")).ConfluenceScope).People,
                                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_people_section_heading),
                                searchResults: peopleResults,
                                resultLimit: $d7659a1c2a00f403$var$PEOPLE_LIMIT_SIZE
                            }
                        ],
                        size: pageBlogAttachmentResults.length + spaceResults.length + peopleResults.length
                    };
                });
            }, [
            autocorrectEnabled,
            formatDate,
            intl,
            searchClientConfig,
            contentResultRenderer,
            isUserAnonymous,
            scope
        ]);
        return {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        };
    };
});
parcelRegister("cGpvK", function(module, exports) {
    $parcel$export(module.exports, "transformAriToId", ()=>$4d63df86a1050889$export$6d8886e8d5cdbeec);
    const $4d63df86a1050889$export$6d8886e8d5cdbeec = (id, type)=>{
        switch(type){
            case 'page':
                return id.split(':page/')[1];
            case 'blogpost':
                return id.split(':blogpost/')[1];
            case 'attachment':
                return id.split(':attachment/')[1];
            case 'space':
                return id.split(':space/')[1];
            case 'whiteboard':
                return id.split(':whiteboard/')[1];
            case 'embed':
                const embedAri = id.split('/');
                return embedAri[embedAri.length - 1];
            case 'database':
                const databaseAri = id.split('/');
                return databaseAri[databaseAri.length - 1];
            default:
                return id;
        }
    };
});
parcelRegister("kOHLG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2za3m").then(()=>parcelRequire('71tek'));
});
parcelRegister("gQz3v", function(module, exports) {
    $parcel$export(module.exports, "useConfluenceDateFilter", ()=>$07d41b9ec9c896ea$export$a31429ad2d37d59f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5S6Yv;
    var $gMpaQ;
    var $bONub;
    var $3RKSV;
    var $kuaGQ;
    var $koVbs;
    const $07d41b9ec9c896ea$var$getUTCDateRange = (fromOffset, toOffset)=>{
        const currentDate = new Date();
        const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const endOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999);
        const from = new Date(startOfDay.getTime() - fromOffset * 86400000);
        const to = new Date(endOfDay.getTime() - toOffset * 86400000);
        return {
            from: from.toISOString().split('Z')[0],
            to: to.toISOString().split('Z')[0]
        };
    };
    const $07d41b9ec9c896ea$export$a31429ad2d37d59f = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const dateFilterOptionsAndValues = (0, $5uXOq.useMemo)(()=>{
            return {
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).DEFAULT]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).DEFAULT,
                        label: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_any_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: true,
                        isVisible: true
                    },
                    dateRange: {
                        from: '',
                        to: ''
                    }
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).TODAY]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).TODAY,
                        label: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_today_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(0, 0)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).YESTERDAY]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).YESTERDAY,
                        label: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_yesterday_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(1, 1)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_SEVEN_DAYS]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_SEVEN_DAYS,
                        label: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_week_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(7, 0)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_THIRTY_DAYS]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_THIRTY_DAYS,
                        label: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_month_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(30, 0)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_YEAR]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_YEAR,
                        label: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_year_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $07d41b9ec9c896ea$var$getUTCDateRange(365, 0)
                }
            };
        }, [
            formatMessage
        ]);
        const dateFilterOptions = (0, $5uXOq.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
            dateFilterOptionsAndValues
        ]);
        const dateFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)(dateFilterOptions, (0, (0, parcelRequire("5S6Yv")).CONFLUENCE_PRODUCT_ID), (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).Date);
        const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, (0, parcelRequire("bONub")).DEFAULT_OPTION))?.id;
        const getLastModifiedValue = (0, $5uXOq.useCallback)(()=>{
            return appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? {
                '@type': (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).Date,
                from: dateFilterOptionsAndValues[appliedDateFilter].dateRange.from,
                to: dateFilterOptionsAndValues[appliedDateFilter].dateRange.to
            } : null;
        }, [
            appliedDateFilter,
            dateFilterOptionsAndValues
        ]);
        const confluenceTabDateFilter = (0, $5uXOq.useMemo)(()=>{
            return [
                {
                    ['@type']: (0, (0, parcelRequire("5S6Yv")).ConfluenceFilters).Date,
                    uiVariant: (0, (0, parcelRequire("bONub")).FilterUIVariant).STATIC_SELECT,
                    fieldName: 'from',
                    store: dateFilterStore,
                    loadFilterOptions: async ()=>[],
                    sectionLabel: formatMessage((0, (0, parcelRequire("kuaGQ")).messages).confluence_date_filter_title),
                    findMoreLabel: '',
                    mapSelectionToAppliedValue: ()=>getLastModifiedValue()
                }
            ];
        }, [
            dateFilterStore,
            formatMessage,
            getLastModifiedValue
        ]);
        return {
            appliedDateFilter: appliedDateFilter,
            confluenceTabDateFilter: confluenceTabDateFilter
        };
    };
});
parcelRegister("kuaGQ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$36e36222d4b88bcd$export$defe85febe8b728c);
    var $7VHMR;
    const $36e36222d4b88bcd$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        confluence_typing_state_header_text: {
            id: 'product_search_dialog.confluence.typing_state_header_text',
            defaultMessage: 'Search for content in Confluence',
            description: 'Text for the typing state header for confluence'
        },
        confluence_date_filter_title: {
            id: 'product_search_dialog.confluence.date_filter_title',
            defaultMessage: 'Last updated',
            description: 'Section title for date filters in Confluence'
        },
        confluence_date_filter_today_label: {
            id: 'product_search_dialog.confluence.date_filter_today',
            defaultMessage: 'Today',
            description: 'Date filter label for current day.'
        },
        confluence_date_filter_yesterday_label: {
            id: 'product_search_dialog.confluence.date_filter_yesterday',
            defaultMessage: 'Yesterday',
            description: 'Date filter label for previous day.'
        },
        confluence_date_filter_week_label: {
            id: 'product_search_dialog.confluence.date_filters_week',
            defaultMessage: 'Past 7 days',
            description: 'Date filter label for past week.'
        },
        confluence_date_filter_month_label: {
            id: 'product_search_dialog.confluence.date_filters_month',
            defaultMessage: 'Past 30 days',
            description: 'Date filter label for past month.'
        },
        confluence_date_filter_year_label: {
            id: 'product_search_dialog.confluence.date_filters_year',
            defaultMessage: 'Past year',
            description: 'Date filter label for past year.'
        },
        confluence_date_filter_any_label: {
            id: 'product_search_dialog.confluence.date_filters_any',
            defaultMessage: 'Any time',
            description: 'Date filter label for any time.'
        }
    });
});
parcelRegister("3HoVl", function(module, exports) {
    $parcel$export(module.exports, "useQueryParams", ()=>$3b0a40e35c359cd5$export$b37ee0d76c6d2fbc);
    var $daJkT;
    var $7xoNc;
    var $2dI5H;
    const $3b0a40e35c359cd5$export$b37ee0d76c6d2fbc = ()=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        return (url, searchSessionId, type, resultId, additionalAnalytics)=>{
            return (0, (0, parcelRequire("daJkT")).transformAnalyticsToQueryParam)({
                query: query,
                url: url,
                searchSessionId: searchSessionId,
                additionalAnalytics: additionalAnalytics,
                resultId: resultId,
                type: type,
                addQueryParams: (0, parcelRequire("7xoNc")).addQueryParams,
                addQuery: (0, parcelRequire("7xoNc")).addQuery
            });
        };
    };
});
parcelRegister("daJkT", function(module, exports) {
    $parcel$export(module.exports, "transformAnalyticsToQueryParam", ()=>$18afc4e978753d45$export$f9c120c22694d7aa);
    var $5B8KC;
    var $elSaW;
    const $18afc4e978753d45$export$f9c120c22694d7aa = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics, resultId: resultId, addQueryParams: addQueryParams, addQuery: addQuery, type: type })=>{
        const isConfluenceContent = typeof resultId === 'string' && resultId.includes('confluence') || typeof type === 'string' && [
            'confluence page',
            'confluence blogpost',
            'confluence space',
            'confluence attachment',
            'confluence whiteboard'
        ].some((contentType)=>contentType.includes(type));
        const hasAdditionalAnalytics = typeof additionalAnalytics === 'object' && Object.keys(additionalAnalytics).length > 0;
        if (!isConfluenceContent || !(query || hasAdditionalAnalytics)) return addQuery(url, 'search_id', searchSessionId);
        let events = [];
        if (query) events.push(`queryHash${(0, (0, parcelRequire("elSaW")).valueSeparator)}${(0, (0, parcelRequire("5B8KC")).hashData)(query)}`);
        if (hasAdditionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
            events.push(`${attribute}${(0, (0, parcelRequire("elSaW")).valueSeparator)}${value}`);
        });
        if (events.length === 0) return addQuery(url, 'search_id', searchSessionId);
        const analyticsFormattedForUrlParsing = encodeURIComponent(events.join((0, (0, parcelRequire("elSaW")).attributeSeparator)));
        return addQueryParams(url, {
            search_id: searchSessionId,
            additional_analytics: analyticsFormattedForUrlParsing
        });
    };
});
parcelRegister("5B8KC", function(module, exports) {
    $parcel$export(module.exports, "hashData", ()=>$58a6573bc67eb6fb$export$7904c6256691057a);
    $parcel$export(module.exports, "getUserPath", ()=>$58a6573bc67eb6fb$export$451f7a1e7c934f54);
    $parcel$export(module.exports, "getTeamPath", ()=>$58a6573bc67eb6fb$export$9456a8e088bfede1);
    var $gvK9N;
    const $58a6573bc67eb6fb$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
    const $58a6573bc67eb6fb$var$hash = (algorithm, data, asBytes = false)=>{
        const hash = (0, ($parcel$interopDefault((0, parcelRequire("gvK9N"))))).createHash(algorithm);
        hash.update(data);
        if (asBytes) return Array.from(hash.digest());
        return hash.digest('hex');
    };
    const $58a6573bc67eb6fb$export$5fdf8c875acfc1b3 = (data)=>{
        return $58a6573bc67eb6fb$var$hash('sha256', data, true);
    };
    const $58a6573bc67eb6fb$export$7904c6256691057a = (data)=>{
        return $58a6573bc67eb6fb$var$hash('sha256', data);
    };
    const $58a6573bc67eb6fb$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
        if (primaryProduct === 'confluence') return `/wiki/people/${userId}`;
        else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
    };
    const $58a6573bc67eb6fb$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
        if (primaryProduct === 'confluence') return `/wiki/people/team/${teamId}`;
        else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
    };
});
parcelRegister("elSaW", function(module, exports) {
    $parcel$export(module.exports, "valueSeparator", ()=>$93ec9862d492c681$export$a707596ddc3340c);
    $parcel$export(module.exports, "attributeSeparator", ()=>$93ec9862d492c681$export$5204c4564f8b6d00);
    const $93ec9862d492c681$export$a707596ddc3340c = '---';
    const $93ec9862d492c681$export$5204c4564f8b6d00 = '___';
    const $93ec9862d492c681$export$6e18f540c8c76192 = (additionalAnalytics)=>{
        const formattedEvents = {};
        if (typeof additionalAnalytics !== 'string') return formattedEvents;
        const events = additionalAnalytics?.split('____');
        events.forEach((event)=>{
            const formattedEvent = event?.split('---');
            const hasProperlyFormattedEvent = formattedEvent.length === 2;
            if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
        });
        return formattedEvents;
    };
});
parcelRegister("7xoNc", function(module, exports) {
    $parcel$export(module.exports, "addQuery", ()=>$c9245256a1dee5dd$export$46ffbef61eff3d00);
    $parcel$export(module.exports, "addQueryParams", ()=>$c9245256a1dee5dd$export$cbc5b385481fb319);
    const $c9245256a1dee5dd$export$46ffbef61eff3d00 = (url, key, unencodedValue)=>{
        return $c9245256a1dee5dd$export$cbc5b385481fb319(url, {
            [key]: unencodedValue
        });
    };
    const $c9245256a1dee5dd$export$cbc5b385481fb319 = (url, params)=>{
        if (!url) return url;
        const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
        const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
            if (!key) return rest;
            const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
            if (rest) return `${rest}&${nextPart}`;
            return nextPart;
        }, '');
        if (!paramsString) return url;
        if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
        return `${sanitisedUrl}?${paramsString}`;
    };
});
parcelRegister("6CRRT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bv26F")
    ]).then(()=>parcelRequire('9zGp3'));
});
parcelRegister("7PQor", function(module, exports) {
    $parcel$export(module.exports, "ExtensibleJiraTab", ()=>$03501126184a65a5$export$8db2a2835d8b9d10);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $k4hbD;
    var $8Xs9r;
    var $kv2Va;
    var $f4GCr;
    var $9Lv6B;
    var $3UF9C;
    var $9fi3n;
    var $f2vlR;
    var $eW6Jk;
    var $5fXfn;
    var $3FqY6;
    var $dVo7Y;
    var $ha1Zp;
    var $i5cPn;
    var $2dI5H;
    var $1yUhh;
    var $icutB;
    var $azBuE;
    var $edfe8;
    var $4tuQr;
    var $bYLf6;
    var $5hwDL;
    let $03501126184a65a5$var$hasLoadedFilters = false;
    let $03501126184a65a5$var$currentProjectRef;
    let $03501126184a65a5$var$currentUserRef;
    const $03501126184a65a5$export$5eff96142961f4a2 = (value)=>$03501126184a65a5$var$hasLoadedFilters = value;
    const $03501126184a65a5$var$JiraNoPreQueryResults = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYLf6")).default), {
            message: (0, (0, parcelRequire("k4hbD")).messages).jira_empty_state_prequery_heading
        });
    const $03501126184a65a5$export$8db2a2835d8b9d10 = ({ features: features, children: children, config: config, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, currentProject: currentProject, currentUser: currentUser, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, ...rest })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { jiraSites: jiraSites } = (0, (0, parcelRequire("dVo7Y")).useSearchConfigContext)();
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const hasAdvancedRoadmapsAccess = !!features?.hasAdvancedRoadmapsAccess;
        const hasSoftwareAccess = !!features?.hasSoftwareAccess;
        const isPreviewOnJiraSearchResultsEnabled = !!features?.isPreviewOnJiraSearchResultsEnabled;
        const isReportedByMeFilterEnabled = !!features?.isReportedByMeFilterEnabled;
        const isConsistentIssueDetailsEnabled = !!features?.isConsistentIssueDetailsEnabled;
        const isDateFromFilterEnabled = !!features?.enableDateFromFilter;
        const shouldShowIssueLabelsFilter = !!features?.enableIssueLabelsFilter;
        const isPreQueryFiltersEnabled = true;
        const isSearchWithTextFieldInAllIssuesLinkEnabled = !!features?.isSearchWithTextFieldInAllIssuesLinkEnabled;
        const { defineFilters: defineFilters } = (0, (0, parcelRequire("3UF9C")).useGenericFilters)();
        const { filtersDefinition: filtersDefinition, loadFilters: loadFilters, filterValueGetters: filterValueGetters } = (0, (0, parcelRequire("9fi3n")).useFilters)(rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled);
        const { jiraTabDateFilterDefinition: jiraTabDateFilterDefinition, appliedDateFilterValue: appliedDateFilterValue } = (0, (0, parcelRequire("5hwDL")).useJiraDateFilter)({
            isDateFromFilterEnabled: isDateFromFilterEnabled
        });
        const abTest = (0, (0, parcelRequire("4tuQr")).useABTest)();
        const isFasterSearchDisabled = abTest !== null && abTest !== undefined && (abTest.experimentId === 'durian-without-faster-search' || abTest.experimentId === 'default-without-faster-search');
        if ((!$03501126184a65a5$var$hasLoadedFilters || $03501126184a65a5$var$currentProjectRef?.id !== currentProject?.id || $03501126184a65a5$var$currentUserRef?.id !== currentUser?.id || $03501126184a65a5$var$currentUserRef?.avatarUrl !== currentUser?.avatarUrl) && isExpanded && getActiveProduct()?.id === (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID) && (isPreQueryFiltersEnabled || query !== '')) {
            loadFilters();
            $03501126184a65a5$var$currentProjectRef = currentProject;
            $03501126184a65a5$var$currentUserRef = currentUser;
            $03501126184a65a5$export$5eff96142961f4a2(true);
        }
        defineFilters((0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), [
            ...isDateFromFilterEnabled ? jiraTabDateFilterDefinition : [],
            ...filtersDefinition
        ]);
        const { getFiltersAdvancedSearchUrl: getFiltersAdvancedSearchUrl } = (0, (0, parcelRequire("eW6Jk")).useURLFactory)(filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled);
        const { recentSectionTitleGenerator: recentSectionTitleGenerator, sections: sections } = (0, (0, parcelRequire("f2vlR")).useSections)(hasAdvancedRoadmapsAccess, hasSoftwareAccess, getFiltersAdvancedSearchUrl, isPreviewOnJiraSearchResultsEnabled, (0, (0, parcelRequire("koVbs")).default)(), formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled);
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)((0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), sections, {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            id: (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID),
            expandedStateInputPlaceholder: formatMessage((0, (0, parcelRequire("k4hbD")).messages).jira_search_placeholder),
            title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).jira_tab_label),
            autocorrectEnabled: autocorrectEnabled,
            sections: sections,
            preQuerySectionTitleGenerator: recentSectionTitleGenerator,
            generateAdvancedSearchUrl: getFiltersAdvancedSearchUrl,
            ...rest,
            ...itemSuppliers,
            permissionSupplier: jiraSites.length > 0 ? (0, (0, parcelRequire("ha1Zp")).defaultPermissionsSupplier) : rest.permissionSupplier,
            appendQueryParams: (0, (0, parcelRequire("1yUhh")).appendQueryParams),
            isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
            debounceTime: 300
        }, ({ linkComponent: linkComponent, productState: productState })=>{
            return {
                Body: ()=>{
                    if (productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading && isFasterSearchDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("edfe8")).LoadingSpinner), null);
                    else if (productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryNoResult) return (0, ($parcel$interopDefault($5uXOq))).createElement($03501126184a65a5$var$JiraNoPreQueryResults, null);
                },
                SectionFooter: jiraSites.length > 1 ? undefined : ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("icutB")).default), {
                        advancedSearchSelected: (0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected),
                        linkComponent: linkComponent,
                        productState: productState,
                        features: features
                    }),
                Footer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fXfn")).JiraAdvancedSearch), {
                        linkComponent: linkComponent,
                        productState: productState,
                        features: features
                    })
            };
        });
    };
});
parcelRegister("9Lv6B", function(module, exports) {
    $parcel$export(module.exports, "JIRA_PRODUCT_ID", ()=>$88ac52b5e26a6c16$export$bf5ad8f7e6312fe2);
    $parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", ()=>$88ac52b5e26a6c16$export$4a204ebf24901f2e);
    $parcel$export(module.exports, "FILTER_LIST_LIMIT", ()=>$88ac52b5e26a6c16$export$a0931d840e4e9fd9);
    $parcel$export(module.exports, "ISSUE_LIST_LIMIT", ()=>$88ac52b5e26a6c16$export$f6357d218d3fefa3);
    $parcel$export(module.exports, "OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS", ()=>$88ac52b5e26a6c16$export$862d39c85199c14c);
    $parcel$export(module.exports, "OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS", ()=>$88ac52b5e26a6c16$export$223565448ddb4a15);
    $parcel$export(module.exports, "DEFAULT_COLLAB_GRAPH_URL", ()=>$88ac52b5e26a6c16$export$e5ea847149c37067);
    $parcel$export(module.exports, "DEFAULT_ISSUE_LABELS_SERVICE_URL", ()=>$88ac52b5e26a6c16$export$43bbc37c110456ee);
    $parcel$export(module.exports, "ISSUE_NAVIGATOR_URL", ()=>$88ac52b5e26a6c16$export$da00a8e161805bdf);
    $parcel$export(module.exports, "JiraScope", ()=>$88ac52b5e26a6c16$export$45df25c6bac04c78);
    $parcel$export(module.exports, "JiraFilters", ()=>$88ac52b5e26a6c16$export$dfd4d34c680dbd6e);
    const $88ac52b5e26a6c16$export$bf5ad8f7e6312fe2 = 'jira';
    const $88ac52b5e26a6c16$export$4a204ebf24901f2e = 'jira.nav-v3';
    const $88ac52b5e26a6c16$export$a0931d840e4e9fd9 = 10;
    const $88ac52b5e26a6c16$export$f6357d218d3fefa3 = 10;
    const $88ac52b5e26a6c16$export$862d39c85199c14c = 6;
    const $88ac52b5e26a6c16$export$223565448ddb4a15 = 8;
    const $88ac52b5e26a6c16$export$e5ea847149c37067 = 'gateway/api/collaboration';
    const $88ac52b5e26a6c16$export$43bbc37c110456ee = '/rest/api/1.0/labels/suggest';
    const $88ac52b5e26a6c16$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
    var $88ac52b5e26a6c16$export$45df25c6bac04c78;
    (function(JiraScope) {
        JiraScope["Issue"] = "jira.issue";
        JiraScope["ProjectFilter"] = "jira.project,filter";
        JiraScope["BoardProjectFilter"] = "jira.board,project,filter";
        JiraScope["BoardProjectFilterPlans"] = "jira.board,project,filter,plan";
        JiraScope["Project"] = "jira.project";
        JiraScope["Assignee"] = "urs.user-jira";
    })($88ac52b5e26a6c16$export$45df25c6bac04c78 || ($88ac52b5e26a6c16$export$45df25c6bac04c78 = {}));
    var $88ac52b5e26a6c16$export$dfd4d34c680dbd6e;
    (function(JiraFilters) {
        JiraFilters["Projects"] = "projects";
        JiraFilters["Assignees"] = "assignees";
        JiraFilters["Status"] = "binary_status_categories";
        JiraFilters["Date"] = "lastModified";
        JiraFilters["ReportedBy"] = "reportedBy";
        JiraFilters["IssueLabels"] = "issueLabels";
    })($88ac52b5e26a6c16$export$dfd4d34c680dbd6e || ($88ac52b5e26a6c16$export$dfd4d34c680dbd6e = {}));
});
parcelRegister("9fi3n", function(module, exports) {
    $parcel$export(module.exports, "useFilters", ()=>$a71ac9960ce3e1f1$export$973ca22476b0e05f);
    var $koVbs;
    var $5uXOq = parcelRequire("5uXOq");
    var $4Pado;
    var $k4hbD;
    var $9Lv6B;
    var $bONub;
    var $3RKSV;
    var $3UF9C;
    var $9p2Gk;
    var $lnyO0;
    var $gMpaQ;
    var $71nSq;
    const $a71ac9960ce3e1f1$export$fe780e7155e72c07 = (projects, project)=>{
        if (!project) return projects;
        const newOption = {
            ...project,
            isChecked: false,
            isVisible: true,
            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).EXTERNAL
        };
        const existingItem = projects.find((s)=>s.id === project.id);
        if (!existingItem?.isVisible) {
            const lastVisibleItemIdx = projects.findIndex((s)=>!s.isVisible) - 1;
            if (lastVisibleItemIdx > 0) projects[lastVisibleItemIdx].isVisible = false;
        }
        return [
            newOption
        ].concat(projects.filter((s)=>s.id !== project.id));
    };
    const $a71ac9960ce3e1f1$export$e54fe71d6476ce8f = (assignees, currentUser)=>{
        if (!currentUser) return assignees;
        const newOption = {
            id: currentUser.id,
            label: currentUser.name,
            avatarUrl: currentUser.avatarUrl,
            isChecked: false,
            isVisible: true,
            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER
        };
        const existingItem = assignees.find((assignee)=>assignee.id === currentUser.id);
        if (!existingItem?.isVisible) {
            const lastVisibleItemIdx = assignees.findIndex((assignee)=>!assignee.isVisible) - 1;
            if (lastVisibleItemIdx > 0) assignees[lastVisibleItemIdx].isVisible = false;
        }
        return [
            newOption
        ].concat(assignees.filter((assignee)=>assignee.id !== currentUser.id));
    };
    const $a71ac9960ce3e1f1$export$973ca22476b0e05f = (rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getFilterItemsByJiraScope: getFilterItemsByJiraScope, getProjectOptions: getProjectOptions, fetchIssueLabelOptions: fetchIssueLabelOptions, statusFilterOptions: statusFilterOptions } = (0, (0, parcelRequire("9p2Gk")).useFiltersClient)(config);
        const siteFilterDefinition = (0, (0, parcelRequire("3UF9C")).useSiteFilterDefinition)(rest.workspaces || [], (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID));
        const projectsFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)([], (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), (0, (0, parcelRequire("9Lv6B")).JiraFilters).Projects);
        const assigneesFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)([], (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), (0, (0, parcelRequire("9Lv6B")).JiraFilters).Assignees);
        const reportedByFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)([], (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), (0, (0, parcelRequire("9Lv6B")).JiraFilters).ReportedBy);
        const statusFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)(statusFilterOptions, (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), (0, (0, parcelRequire("9Lv6B")).JiraFilters).Status);
        const issueLabelsFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)([], (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), (0, (0, parcelRequire("9Lv6B")).JiraFilters).IssueLabels);
        const loadFilters = (0, $5uXOq.useCallback)(()=>{
            projectsFilterStore.loadDefaultFilters(getProjectOptions().then((results)=>$a71ac9960ce3e1f1$export$fe780e7155e72c07(results, currentProject)));
            assigneesFilterStore.loadDefaultFilters(getFilterItemsByJiraScope((0, (0, parcelRequire("9Lv6B")).JiraScope).Assignee, '').then((results)=>$a71ac9960ce3e1f1$export$e54fe71d6476ce8f(results, currentUser)));
            if (shouldShowIssueLabelsFilter) issueLabelsFilterStore.loadDefaultFilters(fetchIssueLabelOptions(''));
            const defaultReportByOption = currentUser && currentUser.id ? {
                id: currentUser.id,
                label: formatMessage((0, (0, parcelRequire("4Pado")).messages).reported_by_me_filter_option),
                avatarUrl: '',
                isChecked: false,
                isVisible: true,
                filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER
            } : undefined;
            if (defaultReportByOption && isReportedByMeFilterEnabled) reportedByFilterStore.setDefaultFilters([
                defaultReportByOption
            ]);
        }, [
            projectsFilterStore,
            getProjectOptions,
            assigneesFilterStore,
            getFilterItemsByJiraScope,
            shouldShowIssueLabelsFilter,
            currentUser,
            formatMessage,
            isReportedByMeFilterEnabled,
            currentProject,
            issueLabelsFilterStore,
            fetchIssueLabelOptions,
            reportedByFilterStore
        ]);
        const searchProject = (0, $5uXOq.useCallback)(async (query)=>{
            const result = await getFilterItemsByJiraScope((0, (0, parcelRequire("9Lv6B")).JiraScope).Project, query);
            return result?.map((item)=>({
                    value: item,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnyO0")).FilterOptionItem), {
                        label: item.label,
                        iconProps: {
                            src: item.avatarUrl,
                            appearance: 'square'
                        }
                    })
                })) || [];
        }, [
            getFilterItemsByJiraScope
        ]);
        const searchAssignee = (0, $5uXOq.useCallback)(async (query)=>{
            const result = await getFilterItemsByJiraScope((0, (0, parcelRequire("9Lv6B")).JiraScope).Assignee, query);
            return result?.map((item)=>({
                    value: item,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnyO0")).FilterOptionItem), {
                        label: item.label,
                        iconProps: {
                            src: item.avatarUrl
                        }
                    })
                })) || [];
        }, [
            getFilterItemsByJiraScope
        ]);
        const searchIssueLabels = (0, $5uXOq.useCallback)(async (query)=>{
            if (shouldShowIssueLabelsFilter) {
                const result = await fetchIssueLabelOptions(query);
                return result?.map((item)=>({
                        value: item,
                        label: item.label
                    })) || [];
            }
            return [];
        }, [
            fetchIssueLabelOptions,
            shouldShowIssueLabelsFilter
        ]);
        const defaultValueGetter = (0, $5uXOq.useCallback)((availableFilters, valueKey = 'id')=>availableFilters.filter((f)=>f.isChecked && f[valueKey]).map((f)=>f[valueKey]), []);
        const appliedReportedByFilter = reportedByFilterStore?.availableFilters?.find((f)=>f.isChecked)?.id;
        const getReportedByMe = (0, $5uXOq.useCallback)(()=>{
            return appliedReportedByFilter ? {
                '@type': (0, (0, parcelRequire("9Lv6B")).JiraFilters).ReportedBy,
                accountIds: [
                    appliedReportedByFilter
                ]
            } : null;
        }, [
            appliedReportedByFilter
        ]);
        const reportedByDefinition = isReportedByMeFilterEnabled ? [
            {
                ['@type']: (0, (0, parcelRequire("9Lv6B")).JiraFilters).ReportedBy,
                fieldName: 'accountIds',
                store: reportedByFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, (0, parcelRequire("4Pado")).messages).report_by_filters_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: getReportedByMe,
                filterConfig: {
                    hideIcon: true,
                    usePreloadedOptions: true,
                    labelComponent: (0, (0, parcelRequire("71nSq")).FilterColLabText)
                }
            }
        ] : [];
        const appliedIssueLabelsFilters = (0, $5uXOq.useMemo)(()=>defaultValueGetter(issueLabelsFilterStore.availableFilters, 'label'), [
            defaultValueGetter,
            issueLabelsFilterStore.availableFilters
        ]);
        const getAppliedIssueLabels = (0, $5uXOq.useCallback)(()=>{
            if (appliedIssueLabelsFilters.length > 0) return {
                '@type': (0, (0, parcelRequire("9Lv6B")).JiraFilters).IssueLabels,
                issueLabels: appliedIssueLabelsFilters
            };
            return null;
        }, [
            appliedIssueLabelsFilters
        ]);
        const issueLabelsFilterDefinition = shouldShowIssueLabelsFilter ? [
            {
                ['@type']: (0, (0, parcelRequire("9Lv6B")).JiraFilters).IssueLabels,
                uiVariant: (0, (0, parcelRequire("bONub")).FilterUIVariant).MULTI_SELECT,
                fieldName: 'issueLabels',
                store: issueLabelsFilterStore,
                loadFilterOptions: searchIssueLabels,
                sectionLabel: formatMessage((0, (0, parcelRequire("4Pado")).messages).issue_labels_filters_title),
                findMoreLabel: '',
                placeholderText: formatMessage((0, (0, parcelRequire("4Pado")).messages).issue_labels_filters_placeholder),
                mapSelectionToAppliedValue: getAppliedIssueLabels,
                filterConfig: {
                    mainGroupLabel: formatMessage((0, (0, parcelRequire("4Pado")).messages).issue_labels_filters_options_group_label)
                }
            }
        ] : [];
        const filtersDefinition = [
            ...siteFilterDefinition,
            {
                ['@type']: (0, (0, parcelRequire("9Lv6B")).JiraFilters).Projects,
                fieldName: 'projectIds',
                store: projectsFilterStore,
                loadFilterOptions: searchProject,
                sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).project_filters_title),
                findMoreLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).project_filters_find_more),
                filterConfig: {
                    filterOptionIconShape: 'square'
                }
            },
            {
                ['@type']: (0, (0, parcelRequire("9Lv6B")).JiraFilters).Assignees,
                fieldName: 'accountIds',
                store: assigneesFilterStore,
                loadFilterOptions: searchAssignee,
                sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).assignee_filters_title),
                findMoreLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).assignee_filters_find_more),
                filterConfig: {
                    filterOptionIconShape: 'circle'
                }
            },
            ...reportedByDefinition,
            {
                ['@type']: (0, (0, parcelRequire("9Lv6B")).JiraFilters).Status,
                fieldName: 'binaryStatusCategories',
                store: statusFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).binary_status_category_filters_title),
                findMoreLabel: '',
                filterConfig: {
                    filterGroupedBy: 'row',
                    hideIcon: true,
                    usePreloadedOptions: true
                }
            },
            ...issueLabelsFilterDefinition
        ];
        const filterValueGetters = (0, $5uXOq.useMemo)(()=>({
                projects: ()=>defaultValueGetter(projectsFilterStore.availableFilters),
                assignees: ()=>defaultValueGetter(assigneesFilterStore.availableFilters),
                statuses: ()=>defaultValueGetter(statusFilterStore.availableFilters),
                reportedBy: ()=>defaultValueGetter(reportedByFilterStore.availableFilters),
                issueLabels: ()=>shouldShowIssueLabelsFilter ? appliedIssueLabelsFilters : []
            }), [
            defaultValueGetter,
            projectsFilterStore.availableFilters,
            assigneesFilterStore.availableFilters,
            statusFilterStore.availableFilters,
            reportedByFilterStore.availableFilters,
            appliedIssueLabelsFilters,
            shouldShowIssueLabelsFilter
        ]);
        return {
            filterValueGetters: filterValueGetters,
            filtersDefinition: filtersDefinition,
            loadFilters: loadFilters
        };
    };
});
parcelRegister("4Pado", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e65a6288707a6982$export$defe85febe8b728c);
    var $7VHMR;
    const $e65a6288707a6982$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jira_boards_icon_accessibility_text: {
            id: 'product_search_dialog.jira.boards_icon_accessibility_text',
            defaultMessage: 'Board icon',
            description: 'The alternative accessibility text for a Jira Software board icon.'
        },
        date_filter_today_label: {
            id: 'product_search_dialog.jira.date_filter_today',
            defaultMessage: 'Today',
            description: 'Date filter label for today.'
        },
        date_filter_yesterday_label: {
            id: 'product_search_dialog.jira.date_filter_yesterday',
            defaultMessage: 'Yesterday',
            description: 'Date filter label for yesterday.'
        },
        date_filter_past_7_days_label: {
            id: 'product_search_dialog.jira.date_filter_past_7_days',
            defaultMessage: 'Past 7 days',
            description: 'Date filter label for past 7 days.'
        },
        date_filter_past_30_days_label: {
            id: 'product_search_dialog.jira.date_filter_past_30_days',
            defaultMessage: 'Past 30 days',
            description: 'Date filter label for past 30 days.'
        },
        date_filter_past_year_label: {
            id: 'product_search_dialog.jira.date_filter_past_year',
            defaultMessage: 'Past year',
            description: 'Date filter label for past year.'
        },
        report_by_filters_title: {
            id: 'product_search_dialog.jira.report_by_filters',
            defaultMessage: 'Filter by reporter',
            description: 'Section title for report by filters in Jira'
        },
        reported_by_me_filter_option: {
            id: 'product_search_dialog.jira.reported_by_me_filter',
            defaultMessage: 'Reported by me',
            description: 'Filter option for reported by me'
        },
        issue_labels_filters_title: {
            id: 'product_search_dialog.jira.issue_labels_filters',
            defaultMessage: 'Filter by label',
            description: 'Section title for label filter in Jira'
        },
        issue_labels_filters_placeholder: {
            id: 'product_search_dialog.jira.issue_labels_filters_placeholder',
            defaultMessage: 'Select label',
            description: 'Placeholder text inside Dropdown Select component for label filter'
        },
        issue_labels_filters_options_group_label: {
            id: 'product_search_dialog.jira.issue_labels_filters_options_group_label',
            defaultMessage: 'All labels',
            description: 'Title/label of the options group within the issue labels filter dropdown'
        }
    });
});
parcelRegister("9p2Gk", function(module, exports) {
    $parcel$export(module.exports, "useFiltersClient", ()=>$8df42fd5acdf3bca$export$86c53720f7942492);
    var $koVbs;
    var $k4hbD;
    var $9Lv6B;
    var $gMpaQ;
    var $jFHlY;
    var $lQmoS;
    var $lvCts;
    var $6SBvm = parcelRequire("6SBvm");
    var $8QpSo;
    var $dVo7Y;
    var $jFHlY;
    var $3JOCw = parcelRequire("3JOCw");
    var $dS9cn = parcelRequire("dS9cn");
    var $8oG5R;
    var $75NXP;
    const $8df42fd5acdf3bca$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
    const $8df42fd5acdf3bca$var$getCollabGraphClientWithConfig = (0, (0, parcelRequire("8QpSo")).default)((config)=>new (0, (0, parcelRequire("jFHlY")).CollaborationGraphClient)({
            collaborationGraphUrl: config.collaborationGraphUrl,
            cloudId: config.cloudId,
            isMultiSite: config.isMultiSite,
            sites: config.sites
        }), (0, ($parcel$interopDefault($6SBvm))));
    const $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS = 3;
    const $8df42fd5acdf3bca$export$86c53720f7942492 = (config)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { jiraSites: jiraSites } = (0, (0, parcelRequire("dVo7Y")).useSearchConfigContext)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const aggregatorClient = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        const statusFilterOptions = [
            {
                id: 'open',
                filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                isChecked: false,
                isVisible: true,
                label: formatMessage((0, (0, parcelRequire("k4hbD")).messages).binary_status_category_filter_option_open)
            },
            {
                id: 'done',
                filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                isChecked: false,
                isVisible: true,
                label: formatMessage((0, (0, parcelRequire("k4hbD")).messages).binary_status_category_filter_option_done)
            }
        ];
        const jiraScopeFilterItemMapper = (item, isVisible, isRecent)=>({
                id: item.id,
                avatarUrl: item.avatarUrl || item.attributes?.avatar?.url,
                label: item.name,
                filterSource: isRecent ? (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).RECENT : (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).SEARCH,
                isChecked: false,
                isVisible: isVisible
            });
        const filterSupplier = async (currentScope, query, defaultItem)=>{
            if (!aggregatorClient) return [];
            return aggregatorClient.search({
                query: query,
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    currentScope
                ],
                modelParams: [],
                resultLimit: (0, (0, parcelRequire("9Lv6B")).FILTER_LIST_LIMIT),
                experience: (0, (0, parcelRequire("9Lv6B")).NAVIGATION_V3_EXPERIENCE)
            }).then(({ response: response })=>{
                if (!response) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(`Expected a response but did not get any for scope: ${currentScope}`);
                const scopedResponse = response.retrieveScope(currentScope);
                if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
                if (scopedResponse.error) throw (0, (0, parcelRequire("lQmoS")).responseErrorToError)(scopedResponse.error);
                const maxVisible = defaultItem !== undefined ? $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS - 1 : $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS;
                const options = scopedResponse.results.map((result, i)=>jiraScopeFilterItemMapper(result, i < maxVisible, query === ''));
                return defaultItem !== undefined ? [
                    defaultItem,
                    ...options
                ] : options;
            });
        };
        const fetchCollabGraphProjectOptions = async ()=>{
            const collabGraphClient = $8df42fd5acdf3bca$var$getCollabGraphClientWithConfig({
                collaborationGraphUrl: config?.collaborationGraphUrl || (0, (0, parcelRequire("9Lv6B")).DEFAULT_COLLAB_GRAPH_URL),
                cloudId: config?.cloudId || '',
                isMultiSite: jiraSites?.length > 1,
                sites: jiraSites
            });
            return await collabGraphClient.getContainers([
                'jiraProject'
            ], jiraSites).then(({ collaborationGraphEntities: collaborationGraphEntities })=>{
                return collaborationGraphEntities.map((entity, i)=>({
                        label: entity.containerDetails.name,
                        id: entity.containerDetails.id,
                        avatarUrl: entity.containerDetails.iconUrl,
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).COLLABORATION_GRAPH,
                        isChecked: false,
                        isVisible: i < $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS
                    }));
            });
        };
        const interleaveCGAndRecentResults = async (uniqueFn, collabGraphOptions)=>{
            if (collabGraphOptions?.length === (0, (0, parcelRequire("jFHlY")).MAX_CG_RESULTS)) return collabGraphOptions;
            else try {
                const recentOptions = await filterSupplier((0, (0, parcelRequire("9Lv6B")).JiraScope).Project, '');
                return collabGraphOptions?.length ? (0, ($parcel$interopDefault($3JOCw)))([
                    ...collabGraphOptions,
                    ...recentOptions
                ], uniqueFn).map((item, i)=>({
                        ...item,
                        isVisible: i < $8df42fd5acdf3bca$var$MAX_VISIBLE_ITEMS
                    })) : recentOptions;
            } catch (e) {
                return collabGraphOptions?.length ? collabGraphOptions : [];
            }
        };
        const getProjectOptions = async ()=>{
            let collaborationGraphOptions;
            if (!!config?.cloudId) collaborationGraphOptions = await fetchCollabGraphProjectOptions();
            const interleavedResults = await interleaveCGAndRecentResults((project)=>project.id, collaborationGraphOptions);
            return interleavedResults;
        };
        const issueLabelFilterItemMapper = (issueLabel, isExternal)=>{
            return {
                id: (0, (0, parcelRequire("8oG5R")).sha256Hash)(`${config?.cloudId || ''}_${issueLabel.label}`),
                filterSource: isExternal ? (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).EXTERNAL : (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).SEARCH,
                isChecked: false,
                isVisible: isExternal,
                label: issueLabel.label
            };
        };
        const fireOperationalEvent = (payload)=>{
            fireAnalyticsEvent({
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
                source: 'searchDialog',
                ...payload
            });
        };
        const fetchIssueLabelOptions = async (query)=>{
            const params = new URLSearchParams([
                [
                    'query',
                    query
                ]
            ]);
            const path = `${(0, (0, parcelRequire("9Lv6B")).DEFAULT_ISSUE_LABELS_SERVICE_URL)}?${params.toString()}`;
            const options = {
                requestInit: {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        [$8df42fd5acdf3bca$var$CAPABILITY_HEADER_NAME]: 'PRODUCT_SEARCH_DIALOG'
                    }
                }
            };
            try {
                return await (0, $dS9cn.utils).requestService({
                    url: path
                }, options).then((response)=>response?.suggestions?.map((issueLabel)=>issueLabelFilterItemMapper(issueLabel, query === '')));
            } catch (error) {
                fireOperationalEvent({
                    action: 'failed',
                    actionSubject: 'fetchIssueLabels',
                    attributes: {
                        error: (0, (0, parcelRequire("lQmoS")).responseErrorToError)(error).message
                    }
                });
                return [];
            }
        };
        return {
            mapJiraScopeFilterItem: jiraScopeFilterItemMapper,
            mapIssueLabelFilterItem: issueLabelFilterItemMapper,
            statusFilterOptions: statusFilterOptions,
            fetchIssueLabelOptions: fetchIssueLabelOptions,
            fetchCollabGraphProjectOptions: fetchCollabGraphProjectOptions,
            getProjectOptions: getProjectOptions,
            getFilterItemsByJiraScope: filterSupplier
        };
    };
});
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
parcelRegister("71nSq", function(module, exports) {
    $parcel$export(module.exports, "FilterColLabText", ()=>$5b82822acf4f40fb$export$53582861b2eaced6);
    var $k5uoT;
    var $bWGt6 = parcelRequire("bWGt6");
    const $5b82822acf4f40fb$export$53582861b2eaced6 = (0, $bWGt6.default)("span", {
        target: "ekcv2vh0"
    })({
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 22}px`,
        paddingLeft: "var(--ds-space-050, 4px)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
    });
});
parcelRegister("f2vlR", function(module, exports) {
    $parcel$export(module.exports, "useSections", ()=>$23582cadd68d58c9$export$5e1b8123b0df487f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $k4hbD;
    var $9Lv6B;
    var $1yUhh;
    var $4biU5;
    var $cvYmc;
    var $l7Y85;
    var $8Vidy;
    var $5C7CC;
    var $hqNwv;
    var $dn5wJ;
    const $23582cadd68d58c9$var$HoverCard = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("gWzuy")).then((mod)=>({
                default: mod.HoverCard
            })));
    const $23582cadd68d58c9$var$HoverCardResultWrapper = ({ children: children, url: url = '' })=>{
        const hidePreviewAction = (0, $5uXOq.useMemo)(()=>{
            return {
                hide: false,
                exclude: [
                    (0, (0, parcelRequire("dn5wJ")).CardAction).PreviewAction
                ]
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l7Y85")).HoverCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqNwv")).default), {
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($23582cadd68d58c9$var$HoverCard, {
            url: url,
            actionOptions: hidePreviewAction
        }, children))));
    };
    const $23582cadd68d58c9$var$viewAllLinkRendererIssues = ({ section: section, totalResults: totalResults })=>{
        const isTotalItemsGreaterThanTheLimit = (totalResults || section.searchResults?.length) > (section.resultLimit || 0);
        return isTotalItemsGreaterThanTheLimit ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).common_show_all_results_link) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    const $23582cadd68d58c9$export$5e1b8123b0df487f = (hasAdvancedRoadmapsAccess, hasSoftwareAccess, viewAllLinkGenerator, isPreviewOnJiraSearchResultsEnabled, intl, formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled)=>{
        const appendQueryParams = (0, (0, parcelRequire("1yUhh")).useQueryParams)();
        const mapJiraItems = (response)=>response.results.map((item)=>{
                const base = {
                    id: item.id,
                    title: item.name,
                    url: appendQueryParams(item.url || '', item),
                    meta: '',
                    iconUrl: item.attributes?.avatar?.url || '',
                    type: item.attributes['@type']
                };
                if (item.attributes && item.attributes['@type'] === (0, (0, parcelRequire("4biU5")).AttributeType).issue) return {
                    ...base,
                    title: `${item.attributes?.key}  ${item.name}`,
                    meta: item.attributes?.container?.title || '',
                    containerId: item.attributes?.containerId,
                    additionalMeta: (0, (0, parcelRequire("8Vidy")).getTimeDetailForJiraIssueResult)(intl, formatDate, item.attributes?.updated)
                };
                if (item.attributes && item.attributes['@type'] === (0, (0, parcelRequire("4biU5")).AttributeType).board) return {
                    ...base,
                    meta: item.attributes?.container?.title || '',
                    containerId: item.attributes?.containerId
                };
                return base;
            });
        const getSectionDetailsByAccess = ()=>{
            if (hasAdvancedRoadmapsAccess) return {
                scope: (0, (0, parcelRequire("9Lv6B")).JiraScope).BoardProjectFilterPlans,
                recentHeading: (0, (0, parcelRequire("k4hbD")).messages).jira_recent_boards_projects_filters_plans_section_heading,
                searchHeading: (0, (0, parcelRequire("k4hbD")).messages).jira_boards_projects_filters_plans_section_heading
            };
            if (hasSoftwareAccess) return {
                scope: (0, (0, parcelRequire("9Lv6B")).JiraScope).BoardProjectFilter,
                recentHeading: (0, (0, parcelRequire("k4hbD")).messages).jira_recent_boards_projects_filters_section_heading,
                searchHeading: (0, (0, parcelRequire("k4hbD")).messages).jira_boards_projects_filters_section_heading
            };
            return {
                scope: (0, (0, parcelRequire("9Lv6B")).JiraScope).ProjectFilter,
                recentHeading: (0, (0, parcelRequire("k4hbD")).messages).jira_recent_projects_filters_section_heading,
                searchHeading: (0, (0, parcelRequire("k4hbD")).messages).jira_projects_filters_section_heading
            };
        };
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const secondSectionDetails = getSectionDetailsByAccess();
        const enableNoIssueSection = (query, filters)=>!filters.find((filter)=>filter['accountIds']?.length > 0 || filter['projectIds']?.length > 0 || filter['binaryStatusCategories']?.length > 0 || filter['issueLabels']?.length > 0);
        const resultRenderer = ()=>{
            return (args)=>(0, (0, parcelRequire("cvYmc")).defaultResultRenderer)(isConsistentIssueDetailsEnabled ? {
                    ...args,
                    isCollapsed: true
                } : args);
        };
        const sections = [
            {
                id: (0, (0, parcelRequire("9Lv6B")).JiraScope).Issue,
                title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).jira_issues_section_heading),
                titleRenderer: (0, (0, parcelRequire("5C7CC")).sectionTitleRenderer)(!!autocorrectEnabled),
                scope: (0, (0, parcelRequire("9Lv6B")).JiraScope).Issue,
                resultMapper: mapJiraItems,
                showResultCount: true,
                resultLimit: (0, (0, parcelRequire("9Lv6B")).ISSUE_LIST_LIMIT),
                viewAllLinkRenderer: $23582cadd68d58c9$var$viewAllLinkRendererIssues,
                resultRenderer: resultRenderer(),
                viewAllLinkGenerator: viewAllLinkGenerator,
                resultWrapper: isPreviewOnJiraSearchResultsEnabled ? $23582cadd68d58c9$var$HoverCardResultWrapper : undefined
            },
            {
                id: secondSectionDetails.scope,
                title: formatMessage(secondSectionDetails.searchHeading),
                scope: secondSectionDetails.scope,
                resultMapper: mapJiraItems,
                isEnabled: enableNoIssueSection,
                resultLimit: hasAdvancedRoadmapsAccess ? (0, (0, parcelRequire("9Lv6B")).OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS) : (0, (0, parcelRequire("9Lv6B")).OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS)
            }
        ];
        const recentSectionTitleGenerator = (section)=>section.id === (0, (0, parcelRequire("9Lv6B")).JiraScope).Issue ? formatMessage((0, (0, parcelRequire("k4hbD")).messages).jira_recently_viewed_issues_section_heading) : formatMessage(secondSectionDetails.recentHeading);
        return {
            recentSectionTitleGenerator: recentSectionTitleGenerator,
            sections: sections,
            mapJiraItems: mapJiraItems,
            getSectionDetailsByAccess: getSectionDetailsByAccess
        };
    };
});
parcelRegister("1yUhh", function(module, exports) {
    $parcel$export(module.exports, "useQueryParams", ()=>$a8d4b6dc4532af30$export$b37ee0d76c6d2fbc);
    $parcel$export(module.exports, "appendQueryParams", ()=>$a8d4b6dc4532af30$export$a0b32aef6b0d7373);
    var $WBFHc;
    var $4biU5;
    var $7xoNc;
    const $a8d4b6dc4532af30$export$fd0142e43ea55591 = (href, searchResult)=>{
        const hrefWithReferrals = (0, (0, parcelRequire("WBFHc")).attachJiraReferralIds)(href, {
            searchObjectId: searchResult.id,
            searchContainerId: searchResult.attributes.containerId,
            searchContentType: (0, (0, parcelRequire("4biU5")).AttributeType).issue
        });
        return hrefWithReferrals;
    };
    const $a8d4b6dc4532af30$export$8aceb1d6e8b68a94 = (href, searchResult)=>{
        const containerAttribute = searchResult.attributes['@type'] === (0, (0, parcelRequire("4biU5")).AttributeType).board ? {
            searchContainerId: searchResult.attributes.containerId
        } : {};
        const contentTypeAttribute = {
            searchContentType: searchResult.attributes['@type']
        };
        const hrefWithReferrals = (0, (0, parcelRequire("WBFHc")).attachJiraReferralIds)(href, {
            ...contentTypeAttribute,
            ...containerAttribute,
            searchObjectId: searchResult.id
        });
        return hrefWithReferrals;
    };
    const $a8d4b6dc4532af30$export$b37ee0d76c6d2fbc = ()=>{
        return (href, searchResult)=>{
            if (searchResult.attributes['@type'] === (0, (0, parcelRequire("4biU5")).AttributeType).issue) return $a8d4b6dc4532af30$export$fd0142e43ea55591(href, searchResult);
            return $a8d4b6dc4532af30$export$8aceb1d6e8b68a94(href, searchResult);
        };
    };
    const $a8d4b6dc4532af30$export$a0b32aef6b0d7373 = (url, searchSessionId)=>{
        return (0, (0, parcelRequire("7xoNc")).addQueryParams)(url, {
            searchSessionId: searchSessionId
        });
    };
});
parcelRegister("WBFHc", function(module, exports) {
    $parcel$export(module.exports, "attachJiraReferralIds", ()=>$f74da4ecf1f65489$export$6ad518df41ca9b2f);
    var $7xoNc;
    const $f74da4ecf1f65489$export$6ad518df41ca9b2f = (href, ids)=>{
        return (0, (0, parcelRequire("7xoNc")).addQueryParams)(href, ids);
    };
});
parcelRegister("l7Y85", function(module, exports) {
    $parcel$export(module.exports, "HoverCardWrapper", ()=>$b907af13130be8c0$export$54477ee883ec6167);
    var $bWGt6 = parcelRequire("bWGt6");
    function $b907af13130be8c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b907af13130be8c0$export$54477ee883ec6167 = (0, $bWGt6.default)("div", {
        target: "esh65ev0"
    })({
        name: "1082qq3",
        styles: "display:block;width:100%"
    });
});
parcelRegister("8Vidy", function(module, exports) {
    $parcel$export(module.exports, "getTimeDetailForJiraIssueResult", ()=>$aaa9f8745993162d$export$1d30bb3376c56ddb);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4hbD;
    var $b0tBm;
    const $aaa9f8745993162d$export$1d30bb3376c56ddb = (intl, formatDate, updated)=>{
        if (!updated) {
            const message = intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_recently_viewed_section_heading);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                title: message
            }, message);
        }
        if (formatDate) return formatDate(updated);
        else return (0, (0, parcelRequire("b0tBm")).dateFormatter)(updated);
    };
});
parcelRegister("b0tBm", function(module, exports) {
    $parcel$export(module.exports, "dateFormatter", ()=>$c92e528d6b4598c6$export$406508d2ca449bd);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $2tElP;
    var $k4hbD;
    const $c92e528d6b4598c6$var$SECONDS_IN_MIN = 60;
    const $c92e528d6b4598c6$var$SECONDS_IN_HR = $c92e528d6b4598c6$var$SECONDS_IN_MIN * 60;
    const $c92e528d6b4598c6$var$SECONDS_IN_DAY = $c92e528d6b4598c6$var$SECONDS_IN_HR * 24;
    const $c92e528d6b4598c6$var$WithUpdatedLabel = (formattedDate)=>{
        const i18nMessage = (0, (0, parcelRequire("k4hbD")).messages).common_updated_date_formatter;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...i18nMessage,
            values: {
                date: formattedDate
            }
        });
    };
    function $c92e528d6b4598c6$export$406508d2ca449bd(lastModified) {
        const secondsSinceUpdate = Math.floor((Date.now() - new Date(lastModified).getTime()) / 1000);
        const totalDays = Math.floor(secondsSinceUpdate / $c92e528d6b4598c6$var$SECONDS_IN_DAY);
        const totalHours = Math.floor(secondsSinceUpdate / $c92e528d6b4598c6$var$SECONDS_IN_HR);
        const totalMinutes = Math.floor(secondsSinceUpdate / $c92e528d6b4598c6$var$SECONDS_IN_MIN);
        if (secondsSinceUpdate > 1 && secondsSinceUpdate < 60) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: -secondsSinceUpdate,
            style: "narrow",
            unit: "second"
        }, $c92e528d6b4598c6$var$WithUpdatedLabel);
        if (totalMinutes >= 1 && totalMinutes < 60) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: -totalMinutes,
            style: "narrow",
            unit: "minute"
        }, $c92e528d6b4598c6$var$WithUpdatedLabel);
        if (totalHours >= 1 && totalHours < 24) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: -totalHours,
            style: "narrow",
            unit: "hour"
        }, $c92e528d6b4598c6$var$WithUpdatedLabel);
        if (totalDays >= 1 && totalDays < 8) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: -totalDays,
            style: "narrow",
            unit: "day"
        }, $c92e528d6b4598c6$var$WithUpdatedLabel);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
            year: "numeric",
            month: "short",
            day: "2-digit",
            value: lastModified
        }, $c92e528d6b4598c6$var$WithUpdatedLabel);
    }
});
parcelRegister("5C7CC", function(module, exports) {
    $parcel$export(module.exports, "sectionTitleRenderer", ()=>$8dc8dbbedcfb827a$export$aee00814c9e3bae7);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $koVbs;
    var $k4hbD;
    var $azBuE;
    var $337hv;
    var $71Kgw;
    const $8dc8dbbedcfb827a$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const { productState: productState } = args;
            const recentTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_recently_viewed_section_heading));
            const issuesTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("k4hbD")).messages).jira_issues_section_heading));
            switch(productState){
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess:
                    return recentTitle;
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading:
                    if (autocorrectEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("337hv")).LoadingSkeleton), {
                        "data-testid": 'autocorrection-loading-skeleton'
                    });
                    return issuesTitle;
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess:
                    if (autocorrectEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71Kgw")).AutocorrectAsyncWrapper), {
                        fallback: issuesTitle
                    });
                    return issuesTitle;
                default:
                    return issuesTitle;
            }
        };
});
parcelRegister("hqNwv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$971336ce10923695$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $971336ce10923695$var$ErrorBoundary extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError(_) {
            return {
                hasError: true
            };
        }
        componentDidCatch(error, errorInfo) {
            this.props.onError && this.props.onError(error);
        }
        render() {
            if (this.state.hasError) return this.props.fallback ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.props.fallback) : null;
            return this.props.children;
        }
    }
    var $971336ce10923695$export$2e2bcd8739ae039 = $971336ce10923695$var$ErrorBoundary;
});
parcelRegister("dn5wJ", function(module, exports) {
    $parcel$export(module.exports, "CardAction", ()=>$b402a0f22139e437$export$f40b7e0b762b928b);
    var $b402a0f22139e437$export$f40b7e0b762b928b;
    (function(CardAction) {
        CardAction["DownloadAction"] = "DownloadAction";
        CardAction["PreviewAction"] = "PreviewAction";
        CardAction["ViewAction"] = "ViewAction";
        CardAction["ChangeStatusAction"] = "ChangeStatusAction";
        CardAction["FollowAction"] = "FollowAction";
        CardAction["CopyLinkAction"] = "CopyLinkAction";
        CardAction["AISummaryAction"] = "AISummaryAction";
        CardAction["AutomationAction"] = "AutomationAction";
    })($b402a0f22139e437$export$f40b7e0b762b928b || ($b402a0f22139e437$export$f40b7e0b762b928b = {}));
});
parcelRegister("gWzuy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("afxky")
    ]).then(()=>parcelRequire('3Awyp'));
});
parcelRegister("eW6Jk", function(module, exports) {
    $parcel$export(module.exports, "useURLFactory", ()=>$0622859967535f1a$export$f63780fc2b3633e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Lv6B;
    var $VSDnB;
    const $0622859967535f1a$var$DEFAULT_ORDER_BY = 'ORDER BY created DESC';
    const $0622859967535f1a$var$buildTextSearchInputJql = (query)=>{
        if (!query) return '';
        const encodedQuery = encodeURIComponent(query);
        return `textfields ~ "${encodedQuery}*"`;
    };
    const $0622859967535f1a$var$addOrderBy = (jql)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('nin-text-fields-new-text-search-field')) return jql;
        if (!jql) return $0622859967535f1a$var$DEFAULT_ORDER_BY;
        return `${jql} ${$0622859967535f1a$var$DEFAULT_ORDER_BY}`;
    };
    const $0622859967535f1a$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
    const $0622859967535f1a$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
    const $0622859967535f1a$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
    const $0622859967535f1a$var$escapeAndQuoteLabels = (label)=>{
        const escapedLabel = label.replace(/([\\"])/g, '\\$1');
        return `"${escapedLabel}"`;
    };
    const $0622859967535f1a$var$buildJqlQuery = (query, projectIds, accountIds, reporterIds, binaryStatusCategoryValues, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled)=>{
        let textJQL;
        if (isSearchWithTextFieldInAllIssuesLinkEnabled) textJQL = query ? `text ~ "${encodeURIComponent(query)}${(0, (0, parcelRequire("VSDnB")).fg)('nin-text-fields-new-text-search-field') ? '*' : ''}"` : '';
        else textJQL = query ? $0622859967535f1a$var$buildTextSearchInputJql(query) : '';
        const projectJQL = projectIds.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : '';
        const assigneeJQL = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : '';
        const issueLabelsJQL = issueLabels.length > 0 ? `labels IN (${encodeURIComponent(issueLabels.map((label)=>$0622859967535f1a$var$escapeAndQuoteLabels(label)).join(','))})` : '';
        const reporterJQL = reporterIds.length > 0 ? `reporter IN (${encodeURIComponent(reporterIds.join(','))})` : '';
        const updateDateJQL = appliedDateFilterValue !== null ? `updated >= "${appliedDateFilterValue.from}" AND updated <= "${appliedDateFilterValue.to}"` : '';
        const binaryStatusCategoryJQL = binaryStatusCategoryValues?.length === 1 ? `statusCategory IN (${encodeURIComponent($0622859967535f1a$var$getStatusesByStatusCategory(binaryStatusCategoryValues))})` : '';
        return (0, (0, parcelRequire("VSDnB")).fg)('nin-text-fields-new-text-search-field') ? $0622859967535f1a$var$addOrderBy([
            textJQL,
            projectJQL,
            assigneeJQL,
            reporterJQL,
            binaryStatusCategoryJQL,
            issueLabelsJQL,
            updateDateJQL
        ].filter(Boolean).join(' AND ')) : [
            textJQL,
            projectJQL,
            assigneeJQL,
            reporterJQL,
            binaryStatusCategoryJQL,
            issueLabelsJQL,
            updateDateJQL
        ].filter(Boolean).join(' AND ');
    };
    const $0622859967535f1a$var$getStatusesByStatusCategory = (values)=>{
        if (!!values.find((v)=>v === 'open')) return '"undefined", "In Progress", "To Do"';
        if (!!values.find((v)=>v === 'done')) return '"Done"';
        return '';
    };
    const $0622859967535f1a$export$f63780fc2b3633e = (filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled = false)=>{
        const buildJiraAdvancedSearchPath = (0, $5uXOq.useCallback)((query)=>{
            const trimmedQuery = query.trim();
            const projectIds = filterValueGetters.projects();
            const accountIds = filterValueGetters.assignees();
            const reporterIds = filterValueGetters.reportedBy();
            const binaryStatusCategories = filterValueGetters.statuses();
            const issueLabels = filterValueGetters.issueLabels();
            if ((projectIds.length !== 0 || accountIds.length !== 0 || reporterIds.length !== 0 || binaryStatusCategories.length === 1 || issueLabels.length !== 0 || appliedDateFilterValue !== null) && (trimmedQuery || isPreQueryFiltersEnabled)) return $0622859967535f1a$var$buildJQLAdvancedIssueUrl($0622859967535f1a$var$buildJqlQuery(trimmedQuery, projectIds, accountIds, reporterIds, binaryStatusCategories, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled));
            if (!trimmedQuery) return query === '' ? (0, (0, parcelRequire("9Lv6B")).ISSUE_NAVIGATOR_URL) : $0622859967535f1a$var$buildSmartQueryAdvancedSearchUrl(query);
            return $0622859967535f1a$var$buildJiraSearchUrl(trimmedQuery);
        }, [
            filterValueGetters,
            appliedDateFilterValue,
            isPreQueryFiltersEnabled,
            isSearchWithTextFieldInAllIssuesLinkEnabled
        ]);
        const useFiltersAdvancedSearchUrlFactory = (0, $5uXOq.useCallback)((query, siteUrl)=>`${siteUrl ?? ''}${buildJiraAdvancedSearchPath(query)}`, [
            buildJiraAdvancedSearchPath
        ]);
        return {
            getFiltersAdvancedSearchUrl: useFiltersAdvancedSearchUrlFactory
        };
    };
});
parcelRegister("5fXfn", function(module, exports) {
    $parcel$export(module.exports, "JiraAdvancedSearch", ()=>$67511804354a3ced$export$f8ed21c35936f5aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $gsomE;
    var $3FqY6;
    var $k4hbD;
    var $koVbs;
    var $8U8gz;
    const $67511804354a3ced$export$f5d288a16f3b101c = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8U8gz")).GetDefaultFooter), {
            linkComponent: props.linkComponent,
            productState: props.productState,
            searchFooterLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).jira_view_all_issues_new)
        }));
    };
    const $67511804354a3ced$export$f8ed21c35936f5aa = (0, (0, parcelRequire("gsomE")).withAnalytics)({
        advancedSearchSelected: (0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)
    })($67511804354a3ced$export$f5d288a16f3b101c);
    var $67511804354a3ced$export$2e2bcd8739ae039 = $67511804354a3ced$export$f8ed21c35936f5aa;
});
parcelRegister("gsomE", function(module, exports) {
    $parcel$export(module.exports, "withAnalytics", ()=>$2f16f957c4f4adf8$export$af9baadf0e4f6e13);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $3FqY6;
    function $2f16f957c4f4adf8$export$af9baadf0e4f6e13(analytics) {
        return (Component)=>{
            class WrappedComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
                render() {
                    const { createAnalyticsEvent: createAnalyticsEvent, ...rest } = this.props;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                        ...rest,
                        ...this.wrappedAnalyticsCallback
                    });
                }
                constructor(...args){
                    super(...args), this.wrappedAnalyticsCallback = Object.keys(analytics).reduce((acc, key)=>({
                            ...acc,
                            [key]: (...args)=>{
                                this.props.createAnalyticsEvent && this.props.createAnalyticsEvent(analytics[key](...args)).fire((0, (0, parcelRequire("3FqY6")).DEFAULT_GAS_CHANNEL));
                            }
                        }), {});
                }
            }
            return (0, (0, parcelRequire("cb25w")).default)()(WrappedComponent);
        };
    }
});
parcelRegister("8U8gz", function(module, exports) {
    $parcel$export(module.exports, "GetDefaultFooter", ()=>$a50192ade6dfad61$export$e3c8b9bd86c3cfd6);
    var $5uXOq = parcelRequire("5uXOq");
    var $7sOan;
    var $a353g;
    const $a50192ade6dfad61$export$e3c8b9bd86c3cfd6 = ({ productState: productState, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a353g")).SearchFooter), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7sOan")).default), rest));
    };
});
parcelRegister("7sOan", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cbceebc00131f88$export$2e2bcd8739ae039);
    var $1W52p;
    var $9cbceebc00131f88$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1W52p")).default);
});
parcelRegister("1W52p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccc5d9bf7f88d6e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cIQMR;
    var $8FPdi;
    var $fYvdU;
    var $26g7Y;
    var $2o8gl;
    var $fSpRR;
    var $ctdFS;
    var $8TPno;
    var $hN1kQ;
    var $dnt4h;
    var $2dI5H;
    var $7xoNc;
    var $8oG5R;
    var $3FqY6;
    var $75NXP;
    var $8RXs9;
    var $dgPZl;
    var $kv2Va;
    var $khXKC;
    var $2k6eV;
    var $i5cPn;
    var $6ZsPS;
    var $94iog;
    const $ccc5d9bf7f88d6e3$var$onKeyDown = (e, target)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            target.firstElementChild?.click?.();
        }
    };
    const $ccc5d9bf7f88d6e3$var$onKeyDownWithShift = (e, target)=>{
        if (e.key === 'Enter' && e.shiftKey) {
            e.preventDefault();
            target.firstElementChild?.click?.();
        }
    };
    const $ccc5d9bf7f88d6e3$export$de2cb7be8250c972 = ({ query: query, isLoading: isLoading, activeProduct: activeProduct, closeDialog: closeDialog, searchFooterLabel: searchFooterLabel, searchFooterLabelWithIcon: searchFooterLabelWithIcon, intl: intl, linkComponent: linkComponent, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', squareReturnIcon: squareReturnIcon = false, filterByProductFooter: filterByProductFooter = false })=>{
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const productName = activeProduct?.title;
        const productId = activeProduct?.id;
        const urlGenerator = activeProduct?.generateAdvancedSearchUrl || urlGeneratorForNoResultsScreen;
        const baseSearchUrl = filterByProductFooter ? `${urlGenerator(query)}&product=confluence` : urlGenerator(query);
        const advancedSearchUrl = query && productId === (0, (0, parcelRequire("94iog")).ProductKeys).Confluence ? (0, (0, parcelRequire("7xoNc")).addQuery)(baseSearchUrl, 'search_id', searchSessionId) : baseSearchUrl;
        const workspaces = activeProduct?.workspaces;
        const showSearchOnEnter = !!activeProduct?.showSearchOnEnter;
        const actionSubjectId = `${productName}AdvancedSearchLink`;
        const [isKeyboardHighlighted, ref] = (0, (0, parcelRequire("fYvdU")).useKeyboardNavigation)({
            onKeydownCallback: showSearchOnEnter ? $ccc5d9bf7f88d6e3$var$onKeyDownWithShift : $ccc5d9bf7f88d6e3$var$onKeyDown
        });
        const { resetSearchSession: resetSearchSession } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const searchLabel = searchFooterLabel || intl.formatMessage((0, (0, parcelRequire("dgPZl")).messages).extensible_advanced_search_footer);
        const advancedSearchContentLabel = searchFooterLabelWithIcon || searchLabel;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const onAdvancedSearchClicked = (0, $5uXOq.useCallback)((e)=>{
            resetSearchSession();
            if (filterByProductFooter) closeDialog();
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)({
                trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                actionSubjectId: actionSubjectId,
                isLoading: isLoading,
                newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e)
            }));
        }, [
            fireAnalyticsEvent,
            isLoading,
            actionSubjectId,
            resetSearchSession,
            closeDialog,
            filterByProductFooter
        ]);
        const ModifierKeyIcon = (0, $5uXOq.useMemo)(()=>window.navigator.userAgent.includes('Mac') ? (0, (0, parcelRequire("fSpRR")).CommandIcon) : (0, (0, parcelRequire("ctdFS")).ControlIcon), []);
        if (workspaces && workspaces?.length > 1) {
            const workspacesWithAdvancedSearchLinks = workspaces.map((workspace)=>({
                    product: productName || '',
                    content: workspace.name,
                    key: workspace.name,
                    advancedSearchUrl: activeProduct?.generateAdvancedSearchUrl?.(query, workspace.baseUrl) || ''
                }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dnt4h")).default), {
                workspaces: workspacesWithAdvancedSearchLinks,
                linkComponent: linkComponent,
                isLoading: isLoading,
                onClick: (_, e)=>{
                    (0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)({
                        actionSubjectId: actionSubjectId,
                        trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                        isLoading: isLoading,
                        newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e)
                    });
                }
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ref: ref,
            onClick: onAdvancedSearchClicked,
            role: "none",
            style: {
                display: 'flex',
                height: '100%'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hN1kQ")).AdvancedSearchLink), {
            href: advancedSearchUrl,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("khXKC")).ContentWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TPno")).CenteredAdvancedSearchGroup), null, filterByProductFooter ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2o8gl"))))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: searchLabel
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: searchLabel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TPno")).AdvancedSearchContent), null, advancedSearchContentLabel))), showSearchOnEnter ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("khXKC")).SearchFooterLabelWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("khXKC")).SearchFooterLabel), null, "Shift"), "+", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIQMR")).ReturnIcon), {
            inverted: isKeyboardHighlighted
        })) : squareReturnIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("khXKC")).SearchFooterLabelWrapper), null, filterByProductFooter && (0, ($parcel$interopDefault($5uXOq))).createElement(ModifierKeyIcon, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FPdi")).SquareReturnIcon), null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIQMR")).ReturnIcon), {
            inverted: isKeyboardHighlighted
        }))));
    };
    const $ccc5d9bf7f88d6e3$var$AdvancedSearchFooter = ({ ...rest })=>{
        const { query: query, isLoading: isLoading } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { setIsExpanded: setIsExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const activeProduct = getActiveProduct();
        const closeDialog = (0, $5uXOq.useCallback)(()=>{
            setIsExpanded(false);
        }, [
            setIsExpanded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ccc5d9bf7f88d6e3$export$f3c4a714981c0a07, {
            ...rest,
            query: query,
            isLoading: isLoading,
            activeProduct: activeProduct,
            closeDialog: closeDialog
        });
    };
    const $ccc5d9bf7f88d6e3$export$f3c4a714981c0a07 = (0, (0, parcelRequire("8RXs9")).default)($ccc5d9bf7f88d6e3$export$de2cb7be8250c972);
    var $ccc5d9bf7f88d6e3$export$2e2bcd8739ae039 = $ccc5d9bf7f88d6e3$var$AdvancedSearchFooter;
});
parcelRegister("8FPdi", function(module, exports) {
    $parcel$export(module.exports, "SquareReturnIcon", ()=>$e27d60379addc563$export$4501fc029b186da8);
    var $5uXOq = parcelRequire("5uXOq");
    const $e27d60379addc563$export$4501fc029b186da8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "20",
            height: "20",
            rx: "3",
            fill: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "nonzero",
            d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
            fill: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        }));
});
parcelRegister("2o8gl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));
    var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
    function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1bd43b75b5db29b6$var$FilterIcon = (props)=>$1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
            LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
        }, props));
    $1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
    var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;
});
parcelRegister("fSpRR", function(module, exports) {
    $parcel$export(module.exports, "CommandIcon", ()=>$03ece57c2e5dc7b8$export$76bfbab5e3f9a6a3);
    var $5uXOq = parcelRequire("5uXOq");
    const $03ece57c2e5dc7b8$export$76bfbab5e3f9a6a3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "20",
            height: "20",
            rx: "3",
            fill: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
            fill: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        }));
});
parcelRegister("ctdFS", function(module, exports) {
    $parcel$export(module.exports, "ControlIcon", ()=>$4342e06acf440894$export$1de95e9d7dda5112);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWGt6 = parcelRequire("bWGt6");
    const $4342e06acf440894$var$IconContainer = (0, $bWGt6.default)("span", {
        target: "elmkl3i0"
    })({
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-border-radius-400, 4px)",
        border: "'1px solid transparent'",
        color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        display: 'flex',
        alignItems: 'center',
        padding: `0 ${"var(--ds-space-075, 6px)"}`
    });
    const $4342e06acf440894$export$1de95e9d7dda5112 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($4342e06acf440894$var$IconContainer, null, "Ctrl");
});
parcelRegister("dnt4h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc824825d09983ba$export$2e2bcd8739ae039);
    var $aq7Ns;
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $8oG5R;
    var $3FqY6;
    var $75NXP;
    var $k4hbD;
    const $fc824825d09983ba$var$MAX_PRIMARY_WORKSPACES = 5;
    const $fc824825d09983ba$var$getActionSubjectIdForProduct = (product)=>{
        return `${product.toLowerCase()}AdvancedSearchLink`;
    };
    const $fc824825d09983ba$export$c1abbe883cc8875 = ({ workspaces: workspaces, linkComponent: linkComponent, onClick: onClick, isLoading: isLoading, intl: intl })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const links = workspaces.map((workspace)=>({
                content: workspace.content,
                key: workspace.key,
                href: workspace.advancedSearchUrl
            }));
        const label = intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).multi_site_advanced_search_label);
        const dropdownLabel = intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).multi_site_advanced_search_more_dropdown, {
            count: links.length - $fc824825d09983ba$var$MAX_PRIMARY_WORKSPACES
        });
        const onAdvancedSearchClicked = (0, $5uXOq.useCallback)(({ key: key }, e)=>{
            const workspace = workspaces.filter((w)=>w.key === key)[0];
            if (!workspace) return;
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onMultiSiteAdvancedSearchSelected)({
                trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                actionSubjectId: $fc824825d09983ba$var$getActionSubjectIdForProduct(workspace.product),
                isLoading: isLoading,
                newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e),
                destinationId: key,
                index: workspaces.map((w)=>w.key).indexOf(key)
            }));
        }, [
            fireAnalyticsEvent,
            isLoading,
            workspaces
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aq7Ns")).SearchFooterLinks), {
            linkComponent: linkComponent,
            onClick: (link, e)=>{
                onAdvancedSearchClicked(link, e);
                onClick && onClick(link.href, e);
            },
            label: label,
            dropdownTriggerLabel: dropdownLabel,
            links: links,
            maxPrimaryLinks: $fc824825d09983ba$var$MAX_PRIMARY_WORKSPACES
        });
    };
    var $fc824825d09983ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($fc824825d09983ba$export$c1abbe883cc8875);
});
parcelRegister("aq7Ns", function(module, exports) {
    $parcel$export(module.exports, "SearchFooterLinks", ()=>$d20f170b0828d6a0$export$697ca8c8f8bb38fc);
    var $fVnbM;
    var $3bDjY;
    var $5uXOq = parcelRequire("5uXOq");
    var $l5sRC;
    var $1N35P;
    const $d20f170b0828d6a0$var$DropDownLinks = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("hPo75")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $d20f170b0828d6a0$var$DEFAULT_MAX_PRIMARY_LINKS = 5;
    const $d20f170b0828d6a0$export$697ca8c8f8bb38fc = ({ label: label, links: links, dropdownTriggerLabel: dropdownTriggerLabel, onClick: onClick, linkComponent: linkComponent, maxPrimaryLinks: maxPrimaryLinks })=>{
        const primaryLinks = links.slice(0, maxPrimaryLinks || $d20f170b0828d6a0$var$DEFAULT_MAX_PRIMARY_LINKS);
        const dropdownLinks = links.slice(maxPrimaryLinks || $d20f170b0828d6a0$var$DEFAULT_MAX_PRIMARY_LINKS, links.length);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1N35P")).SearchFooterLinksContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1N35P")).LabelContainer), null, label), primaryLinks.map((link)=>{
            const { key: key, href: href, content: content } = link;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1N35P")).PrimaryButtonWrapper), {
                key: key,
                onClick: (e)=>onClick && onClick(link, e)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1N35P")).PrimaryButtonStyledLink), {
                href: href,
                linkComponent: linkComponent
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: content,
                tag: (0, (0, parcelRequire("l5sRC")).ForwardedRefToolTipTag)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                spacing: "compact",
                tabIndex: -1
            }, content))));
        }), dropdownLinks && dropdownLinks.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d20f170b0828d6a0$var$DropDownLinks, {
            dropdownLinks: dropdownLinks,
            dropdownTriggerLabel: dropdownTriggerLabel,
            onClick: onClick,
            linkComponent: linkComponent
        })) : null);
    };
});
parcelRegister("l5sRC", function(module, exports) {
    $parcel$export(module.exports, "ForwardedRefToolTipTag", ()=>$aabad6bec7df30e0$export$349601f91196bc9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1N35P;
    const $aabad6bec7df30e0$export$349601f91196bc9c = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1N35P")).TruncatedTextDiv), {
            ...props,
            ref: ref
        }));
});
parcelRegister("1N35P", function(module, exports) {
    $parcel$export(module.exports, "SearchFooterLinksContainer", ()=>$6c323b6c6c4e407f$export$636ae9b701e134a6);
    $parcel$export(module.exports, "LabelContainer", ()=>$6c323b6c6c4e407f$export$f5ae33f1b01a6402);
    $parcel$export(module.exports, "TruncatedTextDiv", ()=>$6c323b6c6c4e407f$export$f060a0d7354d6f0f);
    $parcel$export(module.exports, "PrimaryButtonWrapper", ()=>$6c323b6c6c4e407f$export$70f18730b5e534f8);
    $parcel$export(module.exports, "PrimaryButtonStyledLink", ()=>$6c323b6c6c4e407f$export$c0a945c47b321ccb);
    $parcel$export(module.exports, "DropownMenuLink", ()=>$6c323b6c6c4e407f$export$62368ee747a81340);
    var $k5uoT;
    var $kCMvS;
    var $3JZ8k;
    var $bWGt6 = parcelRequire("bWGt6");
    function $6c323b6c6c4e407f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6c323b6c6c4e407f$export$636ae9b701e134a6 = (0, $bWGt6.default)("div", {
        target: "e17810te5"
    })({
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'start',
        flexDirection: 'row',
        padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`,
        alignItems: 'center',
        maxWidth: (0, (0, parcelRequire("3JZ8k")).dialogWidth),
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
    });
    const $6c323b6c6c4e407f$export$f5ae33f1b01a6402 = (0, $bWGt6.default)("div", {
        target: "e17810te4"
    })({
        name: "1qp6hzm",
        styles: "margin-right:var(--ds-space-050, 4px);flex-shrink:0"
    });
    const $6c323b6c6c4e407f$export$f060a0d7354d6f0f = (0, $bWGt6.default)("div", {
        target: "e17810te3"
    })({
        name: "l8l8b8",
        styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
    });
    const $6c323b6c6c4e407f$export$70f18730b5e534f8 = (0, $bWGt6.default)("div", {
        target: "e17810te2"
    })({
        name: "7bnap7",
        styles: "flex:1 1 0;overflow:hidden;max-width:max-content;margin-right:var(--ds-space-025, 2px)"
    });
    const $6c323b6c6c4e407f$export$c0a945c47b321ccb = (0, $bWGt6.default)((0, (0, parcelRequire("kCMvS")).Link), {
        target: "e17810te1"
    })({
        display: 'flex',
        textOverflow: 'ellipsis',
        borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`,
        transitionDuration: '0.2s',
        transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        '&:focus': {
            outline: 'none',
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`} inset`
        },
        '&:hover': {
            textDecoration: 'none'
        }
    });
    const $6c323b6c6c4e407f$export$62368ee747a81340 = (0, $bWGt6.default)((0, (0, parcelRequire("kCMvS")).Link), {
        target: "e17810te0"
    })({
        display: 'block',
        position: 'relative',
        '&:focus': {
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outlineOffset: '-2px'
        },
        '&:hover': {
            textDecoration: 'none'
        }
    });
});
parcelRegister("hPo75", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hGOpo").then(()=>parcelRequire('eKvJc'));
});
parcelRegister("dgPZl", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a8414778ae08dd8c$export$defe85febe8b728c);
    var $7VHMR;
    const $a8414778ae08dd8c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        extensible_advanced_search_footer: {
            id: 'extensible_search_dialog.advanced_search',
            defaultMessage: 'Advanced search',
            description: 'If the user has not passed any label for the footer then the footer in the dialog leads to the advanced search of the product.'
        },
        extensible_connect_to: {
            id: 'extensible_search_dialog.connect_to',
            defaultMessage: 'Connect to',
            description: 'When the user has not connected a third party app, they are prompted to connect the third party app e.g. "Connect to Google Drive".'
        },
        extensible_connect: {
            id: 'extensible_search_dialog.connect',
            defaultMessage: 'Connect',
            description: 'The text shown on the button to connect a third party app'
        }
    });
});
parcelRegister("khXKC", function(module, exports) {
    $parcel$export(module.exports, "ContentWrapper", ()=>$ad3302c1ee9eacf9$export$6ce170286acaa8d3);
    $parcel$export(module.exports, "SearchFooterLabelWrapper", ()=>$ad3302c1ee9eacf9$export$85cc5ece3620f7ef);
    $parcel$export(module.exports, "SearchFooterLabel", ()=>$ad3302c1ee9eacf9$export$db59656b68ced4b);
    var $bWGt6 = parcelRequire("bWGt6");
    function $ad3302c1ee9eacf9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ad3302c1ee9eacf9$export$6ce170286acaa8d3 = (0, $bWGt6.default)("div", {
        target: "er9v89y2"
    })({
        name: "15currb",
        styles: "display:flex;height:100%"
    });
    const $ad3302c1ee9eacf9$export$85cc5ece3620f7ef = (0, $bWGt6.default)("div", {
        target: "er9v89y1"
    })({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        gap: "var(--ds-space-050, 4px)",
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`
    });
    const $ad3302c1ee9eacf9$export$db59656b68ced4b = (0, $bWGt6.default)("div", {
        target: "er9v89y0"
    })({
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        padding: `0px ${"var(--ds-space-025, 2px)"}`,
        borderRadius: '4px'
    });
});
parcelRegister("94iog", function(module, exports) {
    $parcel$export(module.exports, "ProductKeys", ()=>$a84b62e2bbdc746d$export$ef2c0ffddaaaf76c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gGW0q;
    var $b2Pj5;
    var $VSDnB;
    var $8Xs9r;
    var $k4hbD;
    var $c59Mn;
    var $23vLA;
    var $9fSwv;
    var $hyCj5;
    var $7ttuB;
    var $il5K0;
    var $lYkqd;
    var $VfjmV;
    var $7bjp7;
    var $dtzJn;
    var $7VoGI;
    var $bUT2o;
    var $j97IK;
    var $3HoVl;
    var $hNXQY;
    const $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c = {
        Confluence: 'confluence',
        Atlas: 'townsquare',
        Mercury: 'mercury'
    };
    const $a84b62e2bbdc746d$export$a55448378aa900a7 = ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ttuB")).PersistRecentSearch), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2Pj5")).EnlargedSearchResultContent), {
            ...searchResult,
            isKeyboardHighlighted: isKeyboardHighlighted,
            icon: (0, ($parcel$interopDefault($5uXOq))).isValidElement(searchResult.icon) ? searchResult.icon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }));
    };
    const $a84b62e2bbdc746d$export$1763eeb490def9b = ({ onRetry: onRetry, linkComponent: linkComponent, confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, onPreQueryErrorCallback: onPreQueryErrorCallback, cloudId: cloudId, orgId: orgId, primaryProduct: primaryProduct })=>{
        const { user: user } = (0, (0, parcelRequire("7VoGI")).useUserContext)();
        const features = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const appendAnalyticsQueryParams = (0, (0, parcelRequire("3HoVl")).useQueryParams)();
        const isEnhancedSearchAnalyticsEnabled = (0, (0, parcelRequire("VSDnB")).fg)('cc_page_experiences_enhanced_search_analytics_conf');
        const appendQueryParams = isEnhancedSearchAnalyticsEnabled && primaryProduct === 'confluence' ? appendAnalyticsQueryParams : undefined;
        const preQueryItemSupplier = (0, (0, parcelRequire("gGW0q")).useQuickFindItemSupplier)({
            confCloudClient: confCloudClient,
            aggAbsoluteUrl: aggAbsoluteUrl,
            markErrorAsHandled: onPreQueryErrorCallback,
            itemRenderer: $a84b62e2bbdc746d$export$a55448378aa900a7,
            recentContentResultMapper: (0, (0, parcelRequire("il5K0")).quickFindRecentItemResultMapper),
            recentSpaceResultMapper: (0, (0, parcelRequire("lYkqd")).quickFindRecentSpaceResultMapper),
            userId: user.id,
            cloudId: cloudId
        });
        const defaultSections = (0, $5uXOq.useMemo)(()=>{
            switch(primaryProduct){
                case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Confluence:
                    return [
                        {
                            id: 'confluence.page',
                            title: ''
                        }
                    ];
                case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Atlas:
                    return [
                        {
                            id: 'townsquare.goal',
                            title: ''
                        }
                    ];
                case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Mercury:
                    return [
                        {
                            id: 'mercury.focusarea',
                            title: ''
                        }
                    ];
                default:
                    return [];
            }
        }, [
            primaryProduct
        ]);
        const { backendExperiment: backendExperiment } = (0, (0, parcelRequire("j97IK")).useExperiments)();
        const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
        const quickFindPeopleAndTeamsResultMapper = (0, (0, parcelRequire("VfjmV")).getQuickFindPeopleAndTeamsResultMapper)(primaryProduct, orgId || '', cloudId);
        const quickFindPostQueryItemSupplier = (0, (0, parcelRequire("gGW0q")).useQuickFindPostQueryItemSupplier)({
            cloudId: cloudId,
            resultRenderer: $a84b62e2bbdc746d$export$a55448378aa900a7,
            confluenceResultMapper: (0, (0, parcelRequire("dtzJn")).quickFindConfluenceContentMapper),
            atlasResultMapper: (0, (0, parcelRequire("bUT2o")).quickFindAtlasContentMapper),
            spaceResultMapper: (0, (0, parcelRequire("7bjp7")).quickFindConfluenceSpaceMapper),
            peopleAndTeamsResultMapper: quickFindPeopleAndTeamsResultMapper,
            sectionTitle: formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_results_section),
            userId: user.id,
            orgId: orgId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            primaryProduct: primaryProduct,
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                    name: name,
                    layerId: layerId,
                    shadowId: shadowId
                }))
        });
        const noResultsPostQueryItemSupplier = (0, $5uXOq.useCallback)(()=>Promise.resolve((0, (0, parcelRequire("23vLA")).EMPTY_SEARCH_ITEMS)), []);
        const postQueryItemSupplier = features?.quickFind?.postQueryDisabled ? noResultsPostQueryItemSupplier : quickFindPostQueryItemSupplier;
        const generateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query, baseUrl, usage)=>{
            let url = '';
            const params = new URLSearchParams();
            const trimmedQuery = query.trim();
            if (trimmedQuery) params.append('text', trimmedQuery);
            if (primaryProduct === $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Confluence) {
                url = '/wiki/search/';
                if (usage === 'onInputEnterModified') params.append('product', 'confluence');
            } else if (primaryProduct === $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Atlas) {
                url = `/o/${orgId}/search/`;
                params.append('cloudId', cloudId);
            } else if (primaryProduct === $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Mercury) url = '/focus/search/';
            url += `?${params.toString()}`;
            url = url.replace(/\+/g, '%20');
            return url;
        }, [
            cloudId,
            orgId,
            primaryProduct
        ]);
        const title = (0, $5uXOq.useMemo)(()=>{
            switch(primaryProduct){
                case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Confluence:
                    return formatMessage((0, (0, parcelRequire("k4hbD")).messages).confluence_tab_label);
                case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Atlas:
                    return formatMessage((0, (0, parcelRequire("k4hbD")).messages).atlas_tab_label);
                case $a84b62e2bbdc746d$export$ef2c0ffddaaaf76c.Mercury:
                    return formatMessage((0, (0, parcelRequire("k4hbD")).messages).mercury_tab_label);
                default:
                    return '';
            }
        }, [
            formatMessage,
            primaryProduct
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            permissionSupplier: ()=>Promise.resolve(defaultSections.map((s)=>s.id)),
            sections: defaultSections,
            id: primaryProduct,
            title: title,
            order: 0,
            expandedStateInputPlaceholder: formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_search_input_placeholder),
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier,
            onRetry: onRetry,
            ResultRenderer: (0, (0, parcelRequire("9fSwv")).QuickFindResultRenderer),
            SearchItemsTransformer: (0, (0, parcelRequire("hyCj5")).QuickFindConfluenceTransformer),
            isPrefetchingEnabled: true,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            searchFooterLabel: 'Search your organization',
            linkComponent: linkComponent,
            appendQueryParams: appendQueryParams
        });
    };
});
parcelRegister("gGW0q", function(module, exports) {
    $parcel$export(module.exports, "RECENT_ITEMS_SECTION_ID", ()=>$127163fa0d7261bb$export$9747eb11a16f4445);
    $parcel$export(module.exports, "RECENT_SPACES_SECTION_ID", ()=>$127163fa0d7261bb$export$3813b30107e5b323);
    $parcel$export(module.exports, "useQuickFindItemSupplier", ()=>$127163fa0d7261bb$export$ec546060f7cdc293);
    $parcel$export(module.exports, "CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID", ()=>$127163fa0d7261bb$export$7b0766a033869f00);
    $parcel$export(module.exports, "useQuickFindPostQueryItemSupplier", ()=>$127163fa0d7261bb$export$f872504428bf2e7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $au661;
    var $aCZVj;
    var $jovPR;
    var $fZ270;
    var $eXMAG;
    const $127163fa0d7261bb$var$INCLUDED_PRODUCTS = [
        'confluence',
        'jira',
        'townsquare'
    ];
    const $127163fa0d7261bb$var$INCLUDED_OBJECT_TYPES = [
        'page',
        'blogpost',
        'whiteboard',
        'issue',
        'project',
        'goal',
        'content'
    ];
    const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED = 200;
    const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED = 10;
    const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED = 7;
    const $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED = 3;
    const $127163fa0d7261bb$var$POST_QUERY_MAX_CONTENTS = 7;
    const $127163fa0d7261bb$var$POST_QUERY_MAX_SPACES = 1;
    const $127163fa0d7261bb$export$9747eb11a16f4445 = 'recent-items';
    const $127163fa0d7261bb$export$3813b30107e5b323 = 'recent-spaces';
    const $127163fa0d7261bb$export$ec546060f7cdc293 = ({ confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, markErrorAsHandled: markErrorAsHandled, itemRenderer: itemRenderer, recentContentResultMapper: recentContentResultMapper, recentSpaceResultMapper: recentSpaceResultMapper, userId: userId, cloudId: cloudId })=>{
        return (0, $5uXOq.useCallback)(async ()=>{
            const getSections = ({ recentContents: recentContents, recentSpaces: recentSpaces })=>({
                    sections: [
                        {
                            id: $127163fa0d7261bb$export$9747eb11a16f4445,
                            title: '',
                            searchResults: recentContents,
                            resultLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED,
                            resultRenderer: itemRenderer
                        },
                        {
                            id: $127163fa0d7261bb$export$3813b30107e5b323,
                            title: '',
                            searchResults: recentSpaces,
                            resultLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED,
                            resultRenderer: itemRenderer
                        }
                    ]
                });
            if (!userId) return getSections({
                recentContents: [],
                recentSpaces: []
            });
            const recentActivitiesPromise = (0, (0, parcelRequire("aCZVj")).recentActivitiesQuery)({
                variables: {
                    filteredProducts: $127163fa0d7261bb$var$INCLUDED_PRODUCTS,
                    filteredObjectTypes: $127163fa0d7261bb$var$INCLUDED_OBJECT_TYPES,
                    filteredRootContainerIds: [
                        `ari:cloud:platform::site/${cloudId}`,
                        `ari:cloud:townsquare::site/${cloudId}`
                    ],
                    itemsLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const recentSpacesPromise = confCloudClient ? confCloudClient.query({
                query: (0, (0, parcelRequire("au661")).QuickFindSpacesQuery),
                variables: {
                    spaceLimit: $127163fa0d7261bb$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED
                }
            }) : Promise.resolve(undefined);
            const { recentContents: recentContents, recentSpaces: recentSpaces } = await Promise.all([
                recentActivitiesPromise,
                recentSpacesPromise
            ]).then(([recentItemsResponse, recentSpacesResponse])=>{
                const recentContents = recentItemsResponse?.data?.activity?.myActivity?.all.edges.filter((edge)=>edge?.node?.object?.data).map(recentContentResultMapper) || [];
                const recentSpacesResults = (0, (0, parcelRequire("eXMAG")).parsePartialApolloResults)(recentSpacesResponse?.data?.myVisitedSpaces, recentSpacesResponse?.errors);
                const recentSpaces = recentSpacesResults?.nodes?.spaces?.map(recentSpaceResultMapper) || [];
                return {
                    recentContents: recentContents,
                    recentSpaces: recentSpaces
                };
            }).catch((err)=>{
                markErrorAsHandled && markErrorAsHandled(err);
                throw err;
            });
            return getSections({
                recentContents: recentContents,
                recentSpaces: recentSpaces
            });
        }, [
            confCloudClient,
            userId,
            markErrorAsHandled,
            itemRenderer,
            recentContentResultMapper,
            recentSpaceResultMapper,
            aggAbsoluteUrl,
            cloudId
        ]);
    };
    const $127163fa0d7261bb$var$CONFLUENCE_CONTENT_ENTITIES = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:whiteboard',
        'ati:cloud:confluence:database'
    ];
    const $127163fa0d7261bb$var$ATLAS_ENTITIES = [
        'ati:cloud:townsquare:project',
        'ati:cloud:townsquare:goal',
        'ati:cloud:townsquare:tag'
    ];
    const $127163fa0d7261bb$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID = 'townsquare.project,goal,tag';
    const $127163fa0d7261bb$export$7b0766a033869f00 = 'confluence.page,blogpost,attachment';
    const $127163fa0d7261bb$export$47653725e5b469bb = 'space';
    const $127163fa0d7261bb$export$f80b16ba1f3b0d5c = 'people-and-teams';
    const $127163fa0d7261bb$var$ProductKeys = {
        Confluence: 'confluence',
        Atlas: 'townsquare',
        Mercury: 'mercury'
    };
    const $127163fa0d7261bb$export$f872504428bf2e7e = ({ aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, resultRenderer: resultRenderer, confluenceResultMapper: confluenceResultMapper, atlasResultMapper: atlasResultMapper, spaceResultMapper: spaceResultMapper, peopleAndTeamsResultMapper: peopleAndTeamsResultMapper, sectionTitle: sectionTitle, userId: userId, orgId: orgId, primaryProduct: primaryProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, $5uXOq.useCallback)(async (args)=>{
            const { query: query, analyticsInfo: analyticsInfo } = args;
            const getPeopleAndTeamsResults = async (query, userId, cloudId)=>{
                if (!userId || !cloudId) return [];
                const peopleResults = await (0, (0, parcelRequire("fZ270")).getUserAndTeamSearchResults)({
                    query: query,
                    cloudId: cloudId,
                    principalId: userId || '',
                    orgId: orgId || '',
                    intl: intl
                }).catch((e)=>{
                    console.error(e);
                    return [];
                });
                return peopleResults.map(peopleAndTeamsResultMapper);
            };
            const getConfluenceResults = async (query, cloudId)=>{
                const contentQueryResults = await (0, (0, parcelRequire("jovPR")).quickFindSearchQuery)({
                    variables: {
                        query: query,
                        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                        resultsLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_CONTENTS,
                        spaceLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_SPACES,
                        includeAncestors: true,
                        contentEntities: $127163fa0d7261bb$var$CONFLUENCE_CONTENT_ENTITIES,
                        confluenceFilters: {
                            titleMatchOnly: true
                        },
                        searchSessionId: analyticsInfo?.searchSessionId,
                        queryVersion: analyticsInfo?.queryVersion,
                        includeSpaces: true,
                        experimentId: experimentId,
                        shadowExperimentId: shadowExperimentId,
                        experimentLayers: experimentLayers
                    },
                    aggAbsoluteUrl: aggAbsoluteUrl
                });
                const contentResponse = contentQueryResults.data?.search.results?.edges || [];
                const contentResults = contentResponse.map(confluenceResultMapper);
                const spaceResponse = contentQueryResults.data?.search.spaces?.edges || [];
                const spaceResults = spaceResponse.map(spaceResultMapper);
                return {
                    contentResults: contentResults,
                    spaceResults: spaceResults
                };
            };
            const getAtlasResults = async (query, analyticsInfo)=>{
                const contentQueryResults = await (0, (0, parcelRequire("jovPR")).quickFindSearchQuery)({
                    variables: {
                        query: query,
                        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                        contentEntities: $127163fa0d7261bb$var$ATLAS_ENTITIES,
                        confluenceFilters: {
                            titleMatchOnly: true
                        },
                        resultsLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_CONTENTS,
                        spaceLimit: $127163fa0d7261bb$var$POST_QUERY_MAX_SPACES,
                        includeAncestors: false,
                        searchSessionId: analyticsInfo?.searchSessionId,
                        queryVersion: analyticsInfo?.queryVersion,
                        includeSpaces: false,
                        experimentId: experimentId,
                        shadowExperimentId: shadowExperimentId,
                        experimentLayers: experimentLayers
                    },
                    aggAbsoluteUrl: aggAbsoluteUrl
                });
                const contentResponse = contentQueryResults.data?.search.results?.edges || [];
                const contentResults = contentResponse.map(atlasResultMapper);
                return {
                    contentResults: contentResults,
                    spaceResults: []
                };
            };
            const getResults = (product)=>{
                switch(product){
                    case $127163fa0d7261bb$var$ProductKeys.Confluence:
                        return getConfluenceResults(query, cloudId);
                    case $127163fa0d7261bb$var$ProductKeys.Atlas:
                        return getAtlasResults(query, analyticsInfo);
                    default:
                        return getConfluenceResults(query, cloudId);
                }
            };
            const { contentResults: contentResults, spaceResults: spaceResults } = await getResults(primaryProduct);
            const peopleAndTeamsResults = await getPeopleAndTeamsResults(query, userId, cloudId);
            const getContentSectionId = (product)=>{
                switch(product){
                    case $127163fa0d7261bb$var$ProductKeys.Confluence:
                        return $127163fa0d7261bb$export$7b0766a033869f00;
                    case $127163fa0d7261bb$var$ProductKeys.Atlas:
                        return $127163fa0d7261bb$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID;
                    default:
                        return $127163fa0d7261bb$export$7b0766a033869f00;
                }
            };
            return {
                sections: [
                    {
                        id: getContentSectionId(primaryProduct),
                        title: sectionTitle,
                        searchResults: contentResults,
                        resultRenderer: resultRenderer
                    },
                    {
                        id: $127163fa0d7261bb$export$47653725e5b469bb,
                        searchResults: spaceResults,
                        title: !contentResults.length ? sectionTitle : '',
                        resultRenderer: resultRenderer
                    },
                    {
                        id: $127163fa0d7261bb$export$f80b16ba1f3b0d5c,
                        searchResults: peopleAndTeamsResults,
                        title: !contentResults.length && !spaceResults.length ? sectionTitle : '',
                        resultRenderer: resultRenderer
                    }
                ]
            };
        }, [
            cloudId,
            resultRenderer,
            confluenceResultMapper,
            atlasResultMapper,
            spaceResultMapper,
            peopleAndTeamsResultMapper,
            sectionTitle,
            intl,
            orgId,
            userId,
            aggAbsoluteUrl,
            primaryProduct,
            experimentId,
            shadowExperimentId,
            experimentLayers
        ]);
    };
});
parcelRegister("au661", function(module, exports) {
    $parcel$export(module.exports, "QuickFindSpacesQuery", ()=>$04ec88293f9b8f2d$export$9af2898b36d6a2cf);
    var $5cllN;
    const $04ec88293f9b8f2d$var$QuickFindSpacesFragment = (0, (0, parcelRequire("5cllN")).default)`
	fragment QuickFindSpacesFragment on Space {
		id
		key
		name
		icon {
			path
		}
		links {
			webui
		}
	}
`;
    const $04ec88293f9b8f2d$export$9af2898b36d6a2cf = (0, (0, parcelRequire("5cllN")).default)`
	query QuickFindSpacesQuery($spaceLimit: Int!) {
		myVisitedSpaces(limit: $spaceLimit) {
			nodes {
				spaces {
					...QuickFindSpacesFragment
				}
			}
		}
	}
	${$04ec88293f9b8f2d$var$QuickFindSpacesFragment}
`;
});
parcelRegister("aCZVj", function(module, exports) {
    $parcel$export(module.exports, "recentActivitiesQuery", ()=>$1a1eb1715e55a592$export$ba6bff93c920ff4a);
    var $hIfEM;
    const $1a1eb1715e55a592$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
        return (0, (0, parcelRequire("hIfEM")).fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: (0, $95c01b8f6a4d40eb$export$8a781e50bcd90a75),
            operationName: $95c01b8f6a4d40eb$export$5db520940cf00715
        });
    };
});
parcelRegister("hIfEM", function(module, exports) {
    $parcel$export(module.exports, "fetchAgg", ()=>$29ade44762956c6d$export$f49dad89491f6bf2);
    var $dS9cn = parcelRequire("dS9cn");
    const $29ade44762956c6d$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
    async function $29ade44762956c6d$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $29ade44762956c6d$var$DEFAULT_GRAPHQL_ENDPOINT }) {
        const options = {
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    operationName: operationName,
                    query: graphQuery,
                    variables: variables
                })
            },
            queryParams: {
                ...operationName && {
                    q: operationName
                }
            }
        };
        return (0, $dS9cn.utils).requestService({
            url: url
        }, options);
    }
});
const $95c01b8f6a4d40eb$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $95c01b8f6a4d40eb$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $95c01b8f6a4d40eb$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $95c01b8f6a4d40eb$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $95c01b8f6a4d40eb$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $95c01b8f6a4d40eb$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
  }
`;
const $95c01b8f6a4d40eb$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$95c01b8f6a4d40eb$var$JiraSingleIssueLineTextFieldFragment}
`;
const $95c01b8f6a4d40eb$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $95c01b8f6a4d40eb$export$8a781e50bcd90a75 = `
  query ${$95c01b8f6a4d40eb$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
        ) {
          __typename
          edges {
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$95c01b8f6a4d40eb$var$ConfluencePageFragment}
  ${$95c01b8f6a4d40eb$var$ConfluenceBlogPostFragment}
  ${$95c01b8f6a4d40eb$var$ConfluenceWhiteboardFragment}
  ${$95c01b8f6a4d40eb$var$AtlasProjectFragment}
  ${$95c01b8f6a4d40eb$var$AtlasGoalFragment}
  ${$95c01b8f6a4d40eb$var$JiraIssueFragment}
`;
parcelRegister("jovPR", function(module, exports) {
    $parcel$export(module.exports, "quickFindSearchQuery", ()=>$fef551ab6609ace3$export$ac350a1cbaa2773a);
    var $hIfEM;
    const $fef551ab6609ace3$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
        return (0, (0, parcelRequire("hIfEM")).fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: (0, $48743fafd26957e0$export$5dd443f88002bca3),
            operationName: $48743fafd26957e0$export$5db520940cf00715
        });
    };
});
const $48743fafd26957e0$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    __typename
    key
  }
}
`;
const $48743fafd26957e0$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    __typename
    key
  }
}
`;
const $48743fafd26957e0$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $48743fafd26957e0$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $48743fafd26957e0$export$5dd443f88002bca3 = `
  query ${$48743fafd26957e0$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
  ) {
    search {
      results: search(
        experience: "quick-find"
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$48743fafd26957e0$var$SearchConfluencePageBlogAttachment}
            ${$48743fafd26957e0$var$SearchResultAtlasProject}
            ${$48743fafd26957e0$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
        experience: "searchDialog"
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;
parcelRegister("fZ270", function(module, exports) {
    $parcel$export(module.exports, "getUserAndTeamSearchResults", ()=>$5d362ef29a27e34b$export$69624d2b3a5a261b);
    var $3Q8Js;
    const $5d362ef29a27e34b$var$MAX_RESULTS_USERS = 2;
    const $5d362ef29a27e34b$export$6e670d76ab78fcb3 = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
    const $5d362ef29a27e34b$export$69624d2b3a5a261b = ({ query: query, cloudId: cloudId, orgId: orgId, principalId: principalId = 'Context', intl: intl })=>(0, (0, parcelRequire("3Q8Js")).default)({
            searchQueryFilter: $5d362ef29a27e34b$export$6e670d76ab78fcb3,
            includeUsers: true,
            includeGroups: false,
            includeTeams: true,
            context: {
                contextType: 'confluence_search-dialog',
                principalId: principalId,
                productKey: 'confluence',
                siteId: cloudId,
                organizationId: orgId
            },
            maxNumberOfResults: $5d362ef29a27e34b$var$MAX_RESULTS_USERS,
            query: query
        }, intl);
});
parcelRegister("3Q8Js", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94c7434acb15702b$export$2e2bcd8739ae039);
    var $f5wjp;
    var $lrQGi;
    const $94c7434acb15702b$var$getUserRecommendations = (request, intl)=>{
        const url = (0, (0, parcelRequire("lrQGi")).config).getRecommendationServiceUrl(request.baseUrl || '');
        return fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                context: request.context,
                includeUsers: request.includeUsers,
                includeGroups: request.includeGroups,
                includeTeams: request.includeTeams,
                includeNonLicensedUsers: request.includeNonLicensedUsers,
                maxNumberOfResults: request.maxNumberOfResults,
                performSearchQueryOnly: false,
                searchQuery: {
                    cpusQueryHighlights: {
                        query: '',
                        field: ''
                    },
                    ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    },
                    customQuery: '',
                    customerDirectoryId: '',
                    filter: request.searchQueryFilter || '',
                    minimumAccessLevel: 'APPLICATION',
                    queryString: request.query,
                    restrictTo: {
                        userIds: [],
                        groupIds: []
                    },
                    searchUserbase: false
                }
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject({
                message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
                statusCode: response.status
            });
        }).then((response)=>(0, (0, parcelRequire("f5wjp")).transformUsers)(response, intl));
    };
    var $94c7434acb15702b$export$2e2bcd8739ae039 = $94c7434acb15702b$var$getUserRecommendations;
});
parcelRegister("f5wjp", function(module, exports) {
    $parcel$export(module.exports, "transformUsers", ()=>$ba878881f0891deb$export$fb8c90bfc4beaa59);
    var $Jzvpo;
    var $60uqU;
    const $ba878881f0891deb$var$getLozenzeProperties = (entity, intl)=>{
        if (entity.attributes?.workspaceMember) return intl.formatMessage((0, (0, parcelRequire("Jzvpo")).messages).memberLozengeText);
        if (entity.attributes?.isConfluenceExternalCollaborator) {
            const lozengeTooltipMessage = entity.entityType === (0, (0, parcelRequire("60uqU")).EntityType).GROUP ? (0, (0, parcelRequire("Jzvpo")).messages).guestGroupLozengeTooltip : (0, (0, parcelRequire("Jzvpo")).messages).guestUserLozengeTooltip;
            return {
                text: intl.formatMessage((0, (0, parcelRequire("Jzvpo")).messages).guestLozengeText),
                tooltip: intl.formatMessage(lozengeTooltipMessage),
                appearance: 'default'
            };
        }
        return undefined;
    };
    const $ba878881f0891deb$var$transformUser = (item, intl)=>{
        const type = item.entityType;
        if (type === (0, (0, parcelRequire("60uqU")).EntityType).USER) {
            const user = item;
            const lozenge = $ba878881f0891deb$var$getLozenzeProperties(user, intl);
            return {
                id: user.id,
                type: user.nonLicensedUser ? (0, $f93312f7d4958f08$export$50042ec1d2e00e63) : (0, $f93312f7d4958f08$export$8436e53e45ffe15b),
                avatarUrl: user.avatarUrl,
                name: user.name,
                email: user.email,
                title: user.title,
                lozenge: lozenge,
                tooltip: user.name,
                isExternal: Boolean(user.nonLicensedUser),
                sources: user.nonLicensedUser ? [
                    'other-atlassian'
                ] : undefined
            };
        }
        if (type === (0, (0, parcelRequire("60uqU")).EntityType).TEAM) {
            const team = item;
            return {
                id: team.id,
                type: (0, $f93312f7d4958f08$export$26bc40b960693765),
                description: team.description || '',
                name: team.displayName || '',
                memberCount: team.memberCount,
                members: team.members,
                includesYou: team.includesYou,
                avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
                tooltip: team.displayName,
                verified: team.verified
            };
        }
        if (type === (0, (0, parcelRequire("60uqU")).EntityType).GROUP) {
            const group = item;
            const lozenge = $ba878881f0891deb$var$getLozenzeProperties(group, intl);
            return {
                id: group.id,
                type: (0, $f93312f7d4958f08$export$d460f747b73abb10),
                name: group.name || '',
                lozenge: lozenge
            };
        }
        return;
    };
    const $ba878881f0891deb$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$ba878881f0891deb$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';
parcelRegister("Jzvpo", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0fd0da3298001d54$export$defe85febe8b728c);
    var $7VHMR;
    const $0fd0da3298001d54$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        externalUserSourcesHeading: {
            id: 'fabric.elements.user-picker.external.sourced.from',
            defaultMessage: 'Found in:',
            description: 'From where the external user is coming'
        },
        slackProvider: {
            id: 'fabric.elements.user-picker.slack.provider',
            defaultMessage: 'Slack',
            description: 'This external user is sourced from Slack provider'
        },
        googleProvider: {
            id: 'fabric.elements.user-picker.google.provider',
            defaultMessage: 'Google',
            description: 'This external user is sourced from Google provider'
        },
        microsoftProvider: {
            id: 'fabric.elements.user-picker.microsoft.provider',
            defaultMessage: 'Microsoft',
            description: 'This external user is sourced from Microsoft provider'
        },
        gitHubProvider: {
            id: 'fabric.elements.user-picker.github.provider',
            defaultMessage: 'GitHub',
            description: 'This external user is sourced from GitHub provider'
        },
        memberLozengeText: {
            id: 'fabric.elements.user-picker.member.lozenge.text',
            defaultMessage: 'MEMBER',
            description: 'Text within the Lozenge when the user is a workspace member'
        },
        guestLozengeText: {
            id: 'fabric.elements.user-picker.guest.lozenge.text',
            defaultMessage: 'GUEST',
            description: 'Text within the lozenge when the user is a guest of confluence'
        },
        guestUserLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
            defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
        },
        guestGroupLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
            defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
        }
    });
});
parcelRegister("60uqU", function(module, exports) {
    $parcel$export(module.exports, "EntityType", ()=>$e9a061fa52eafd84$export$8eda7e02f8f033b2);
    var $e9a061fa52eafd84$export$8eda7e02f8f033b2;
    (function(EntityType) {
        EntityType["USER"] = "USER";
        EntityType["TEAM"] = "TEAM";
        EntityType["GROUP"] = "GROUP";
    })($e9a061fa52eafd84$export$8eda7e02f8f033b2 || ($e9a061fa52eafd84$export$8eda7e02f8f033b2 = {}));
});
parcelRegister("lrQGi", function(module, exports) {
    $parcel$export(module.exports, "config", ()=>$8648972412521072$export$e506a1d27d1eaa20);
    const $8648972412521072$export$e506a1d27d1eaa20 = {
        getRecommendationServiceUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
        },
        getUsersServiceUrl (productKey, baseUrl = '') {
            return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
        },
        getGraphQLUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
        },
        getTeamsUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
        }
    };
});
parcelRegister("eXMAG", function(module, exports) {
    $parcel$export(module.exports, "parsePartialApolloResults", ()=>$d02099fd0b809c29$export$e877f985e0128c5e);
    var $eiiEv;
    function $d02099fd0b809c29$export$e877f985e0128c5e(data, graphQLErrors) {
        if (!graphQLErrors?.length) return data;
        if (graphQLErrors?.length && data) {
            console.warn('Returning partial data despite GraphQL errors: ', graphQLErrors);
            return data;
        }
        throw new (0, (0, parcelRequire("eiiEv")).GraphQLNoResultsWithErrorResponseError)(graphQLErrors);
    }
});
parcelRegister("eiiEv", function(module, exports) {
    $parcel$export(module.exports, "GraphQLNoResultsWithErrorResponseError", ()=>$9ff2f5ddeb9ffe12$export$beb638af7aef4c03);
    class $9ff2f5ddeb9ffe12$export$beb638af7aef4c03 extends Error {
        constructor(graphQLErrors){
            super();
            this.name = 'GraphQLNoResultsWithErrorResponseError';
            this.graphQLErrors = graphQLErrors;
            this.message = 'GraphQL returned errors and no results';
        }
    }
});
parcelRegister("b2Pj5", function(module, exports) {
    $parcel$export(module.exports, "EnlargedSearchResultContent", ()=>$deff8b6fcada06c8$export$171a2a7e5a778acc);
    var $5uXOq = parcelRequire("5uXOq");
    var $54Fwx;
    var $8FPdi;
    var $rpOSY;
    var $ousew;
    var $8Lig8;
    var $42CjB;
    var $eiKpf;
    const $deff8b6fcada06c8$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
        const contentRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const [isHover, setIsHover] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        const isActive = isKeyboardHighlighted || isHover;
        const showReturnIcon = (0, $5uXOq.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
            isKeyboardHighlighted,
            returnIcon,
            isRecentSearch
        ]);
        const showRemoveIcon = (0, $5uXOq.useMemo)(()=>isRecentSearch && isActive, [
            isRecentSearch,
            isActive
        ]);
        const showAdditionalMeta = (0, $5uXOq.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
            displayAdditionalMetaWhenHighlightedOnly,
            isActive,
            additionalMeta
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
                behavior: 'auto',
                block: 'nearest'
            });
        }, [
            isKeyboardHighlighted
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedResultContentWrapper), {
            ref: contentRef,
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            onMouseEnter: ()=>setIsHover(true),
            onMouseLeave: ()=>setIsHover(false)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedIconContainer), null, icon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultContentWrapper), {
            "data-testid": "collapsed-result-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedResultTitleContainer), {
            isCollapsed: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            title: title,
            className: "SearchDialogResultTitle"
        }, highlightedTitle ? (0, (0, parcelRequire("8Lig8")).enrichResultTitle)(highlightedTitle) : title), typeof label === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultLabel), {
            title: title
        }, label) : label), meta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedCollapsedResultDetailWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedCollapsedResultDetail), null, meta))), showAdditionalMeta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedResultDetail), null, additionalMeta), showReturnIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedReturnIconContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FPdi")).SquareReturnIcon), null)), showRemoveIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedReturnIconContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, (0, parcelRequire("54Fwx")).RemoveIcon),
            spacing: 'compact',
            onClick: onRemove,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("rpOSY")).messages).remove_button_label),
            appearance: 'subtle'
        })));
    };
});
parcelRegister("54Fwx", function(module, exports) {
    $parcel$export(module.exports, "RemoveIcon", ()=>$bcfdb9ab02365327$export$6382847193091a26);
    var $5uXOq = parcelRequire("5uXOq");
    const $bcfdb9ab02365327$export$6382847193091a26 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("rpOSY", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a2a6e63cc6de5e45$export$defe85febe8b728c);
    var $7VHMR;
    const $a2a6e63cc6de5e45$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        remove_button_label: {
            id: 'search_dialog.results.remove_button_label',
            defaultMessage: 'Remove this.',
            description: 'Label of the button that has remove function and appearance.'
        }
    });
});
parcelRegister("8Lig8", function(module, exports) {
    $parcel$export(module.exports, "enrichResultTitle", ()=>$67a3dba4d63955ca$export$c43ff622b37ceaa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    const $67a3dba4d63955ca$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
    const $67a3dba4d63955ca$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
    const $67a3dba4d63955ca$var$highlightRE = new RegExp(`${$67a3dba4d63955ca$var$HIGHLIGHT_START_TAG}(.*?)${$67a3dba4d63955ca$var$HIGHLIGHT_END_TAG}.*`);
    const $67a3dba4d63955ca$var$openingTagRE = new RegExp(`(.*?)${$67a3dba4d63955ca$var$HIGHLIGHT_START_TAG}`);
    const $67a3dba4d63955ca$export$c43ff622b37ceaa9 = (title)=>{
        const enrichedTitle = [];
        let counter = 0;
        if (!title.match($67a3dba4d63955ca$var$highlightRE)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            key: title + counter
        }, title);
        while(title){
            const [preMatch, preText] = title.match($67a3dba4d63955ca$var$openingTagRE) || [];
            title = title.replace(preText, '');
            if (preText && preText !== '') enrichedTitle.push((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "span",
                key: preText + counter
            }, preText));
            const [boldMatch, highlightText] = title.match($67a3dba4d63955ca$var$highlightRE) || [];
            title = title.replace(`${$67a3dba4d63955ca$var$HIGHLIGHT_START_TAG}${highlightText}${$67a3dba4d63955ca$var$HIGHLIGHT_END_TAG}`, '');
            if (highlightText && highlightText !== '') enrichedTitle.push((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "strong",
                key: highlightText + counter
            }, highlightText));
            if (preMatch === undefined && boldMatch === undefined) {
                if (title !== '') enrichedTitle.push((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span",
                    key: title + counter
                }, title));
                break;
            }
            counter++;
        }
        return enrichedTitle;
    };
});
parcelRegister("c59Mn", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$dbd376a2b13fd4d2$export$defe85febe8b728c);
    var $7VHMR;
    const $dbd376a2b13fd4d2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        quick_find_search_input_placeholder: {
            id: 'product_search_dialog.quick_find_search_input_rovo_placeholder',
            defaultMessage: 'Search or ask Rovo',
            description: 'A placeholder for the quick find search input'
        },
        quick_find_recent_search_text_dialog: {
            id: 'product_search_dialog.quick_find_recent_search_text_dialog',
            defaultMessage: 'From your recent searches',
            description: 'Recent search indicator text in search dialog box'
        },
        quick_find_show_organization_results: {
            id: 'product_search_dialog.quick_find_show_organization_results',
            defaultMessage: 'Search your organization',
            description: 'A label for a link that takes users to Full Page Search'
        },
        quick_find_show_filtered_results: {
            id: 'product_search_dialog.quick_find_show_filtered_confluence_results',
            defaultMessage: 'Filter by Confluence spaces, contributors and more',
            description: 'A label for a link that takes users to Full Page Search with a product filter applied'
        },
        quick_find_show_filtered_results_with_icon: {
            id: 'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon',
            defaultMessage: 'Filter by {confluenceIcon} Confluence spaces, contributors and more',
            description: 'A label for a link that takes users to Full Page Search with a product filter applied with confluence icon'
        },
        quick_find_ask_atlassian_intelligence: {
            id: 'product_search_dialog.quick_find_ask_atlassian_intelligence',
            defaultMessage: 'Ask Atlassian Intelligence',
            description: 'A label for the link that takes users to an AI search'
        },
        quick_find_recently_viewed: {
            id: 'product_search_dialog.quick_find_recently_viewed',
            defaultMessage: 'Recently Viewed',
            description: 'Section title for recent content in Quick Find'
        },
        quick_find_recent_draft_label: {
            id: 'product_search_dialog.quick_find_recent_draft_label',
            defaultMessage: 'DRAFT',
            description: 'Lozenge label for draft results'
        },
        quick_find_recent_spaces_additional_meta: {
            id: 'product_search_dialog.quick_find_recent_spaces_additional_meta',
            defaultMessage: 'You recently visited',
            description: 'Additional meta for Quick Find recent spaces results'
        },
        quick_find_footer_text: {
            id: 'product_search_dialog.quick_find_footer_help_text',
            defaultMessage: 'Help us improve search',
            description: 'Quick find footer text'
        },
        quick_find_footer_full_page_search_link: {
            id: 'product_search_dialog.quick_find_footer_full_page_search_products_link',
            defaultMessage: 'Search across products',
            description: 'A label for a link that takes users to Full Page Search'
        },
        quick_find_no_content_header: {
            id: 'product_search_dialog.quick_find_no_content_header',
            defaultMessage: 'Seek and you shall find',
            description: 'Header of prompt to begin search journey if no recent content results are rendered'
        },
        quick_find_no_content_body: {
            id: 'product_search_dialog.quick_find_no_content_body_rovo',
            defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated products",
            description: 'Body text of prompt to begin search journey if no recent content results are rendered'
        },
        quick_find_post_query_no_results_header: {
            id: 'product_search_dialog.quick_find_post_query_no_results_header',
            defaultMessage: "We couldn't find any results with that title",
            description: 'Header of prompt if entering query in quickfind returns no results'
        },
        quick_find_post_query_no_results_body: {
            id: 'product_search_dialog.quick_find_post_query_no_results_body',
            defaultMessage: '<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term.',
            description: 'Body text of prompt if entering query in quickfind returns no results'
        },
        quick_find_search_results: {
            id: 'product_search_dialog.quick_find_search_results',
            defaultMessage: 'Search Results',
            description: 'Section title for search results in Quick Find'
        },
        quick_find_confluence_space: {
            id: 'product_search_dialog.quick_find_confluence_space',
            defaultMessage: 'Confluence Space',
            description: 'Metadata for Confluence Space results'
        },
        quick_find_results_section: {
            id: 'product_search_dialog.quick_find_results_section',
            defaultMessage: 'Search Results',
            description: 'Section title for post query items in Quick Find'
        },
        quick_find_results_team: {
            id: 'product_search_dialog.quick_find_result_item_team',
            defaultMessage: 'Team',
            description: 'Label for team search results'
        },
        quick_find_recent_search: {
            id: 'product_search_dialog.quick_find_recent_search',
            defaultMessage: 'Recent search',
            description: 'Metadata for recent search results'
        },
        remove_button_label: {
            id: 'product_search_dialog.results.remove_button_label',
            defaultMessage: 'Remove this.',
            description: 'Label of the button that has remove function and appearance.'
        },
        quick_find_rovo_tip: {
            id: 'product_search_dialog.quick_find_rovo_tip',
            defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer.",
            description: 'Banner message for showing tip of using question query.'
        }
    });
});
parcelRegister("23vLA", function(module, exports) {
    $parcel$export(module.exports, "EMPTY_SEARCH_ITEMS", ()=>$9b0453a9d305fc01$export$205c1cd8d8ed1926);
    const $9b0453a9d305fc01$export$205c1cd8d8ed1926 = {
        size: 0,
        sections: []
    };
});
parcelRegister("9fSwv", function(module, exports) {
    $parcel$export(module.exports, "QuickFindResultRenderer", ()=>$ea3ff240b098aaee$export$6e27f80792772bd6);
    var $4BodE;
    var $a9a3f;
    var $5bKWp;
    var $5uXOq = parcelRequire("5uXOq");
    var $azBuE;
    var $aKYAO;
    var $idS9H;
    var $dOrUw;
    var $9KiUn;
    var $9bNhQ;
    var $gXkA8;
    var $ousew;
    var $c59Mn;
    var $8ilpI;
    var $9bNhQ;
    var $kv2Va;
    var $5IxfD;
    var $lTDGC;
    var $94iog;
    var $7JF8H;
    var $6ZsPS;
    var $7xoNc;
    const $ea3ff240b098aaee$export$6e27f80792772bd6 = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, linkComponent: linkComponent, appendQueryParams: appendQueryParams, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery })=>{
        const isMobileView = (0, (0, parcelRequire("aKYAO")).useIsMobileView)();
        const { isRovoEnabled: isRovoEnabled } = (0, (0, parcelRequire("lTDGC")).useRovoContext)();
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const activeProduct = getActiveProduct();
        const productId = activeProduct?.id;
        const renderResults = (0, $5uXOq.useCallback)(()=>{
            switch(productState){
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess:
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryLoading:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("idS9H")).GenericSearchResult), {
                        searchItems: preQueryItems,
                        linkComponent: linkComponent,
                        screen: "preQuerySearchResults",
                        productState: productState,
                        isCollapsed: isMobileView,
                        appendQueryParams: appendQueryParams
                    });
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryNoResult:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gXkA8")).PreQueryEmptyScreen), null);
                case (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryError:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ilpI")).SearchErrorScreen), {
                        onRetry: onRetryPreQuery
                    });
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryTyping:
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("idS9H")).GenericSearchResult), {
                        searchItems: postQueryItems,
                        linkComponent: linkComponent,
                        screen: "cachedResults",
                        productState: productState,
                        isCollapsed: isMobileView,
                        appendQueryParams: appendQueryParams
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a9a3f")).EnlargedSearchResultSection), {
                        title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_search_results)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4BodE")).EnlargedSearchResultContentSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4BodE")).EnlargedSearchResultContentSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4BodE")).EnlargedSearchResultContentSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4BodE")).EnlargedSearchResultContentSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4BodE")).EnlargedSearchResultContentSkeleton), null)));
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryError:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ilpI")).SearchErrorScreen), {
                        onRetry: onRetryPostQuery
                    });
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryNoResult:
                    const urlGeneratorForNoResultsScreen = (query)=>{
                        const generateUrl = activeProduct?.generateAdvancedSearchUrl || (()=>'');
                        const advancedSearchUrl = generateUrl(query);
                        return (0, (0, parcelRequire("7xoNc")).addQuery)(advancedSearchUrl, 'search_id', searchSessionId);
                    };
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7JF8H")).default), {
                        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
                        fromQuickFindPostQueryNoResults: true
                    });
                case (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("idS9H")).GenericSearchResult), {
                        searchItems: postQueryItems,
                        linkComponent: linkComponent,
                        screen: "postQuerySearchResults",
                        productState: productState,
                        isCollapsed: isMobileView,
                        appendQueryParams: appendQueryParams
                    });
            }
        }, [
            productState,
            preQueryItems,
            linkComponent,
            isMobileView,
            appendQueryParams,
            postQueryItems,
            onRetryPreQuery,
            onRetryPostQuery,
            activeProduct?.generateAdvancedSearchUrl,
            searchSessionId
        ]);
        const showSearchFooter = productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryLoading || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQueryNoResult || productId === (0, (0, parcelRequire("94iog")).ProductKeys).Confluence && (productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryNoResult);
        const showFilterFooter = productId === (0, (0, parcelRequire("94iog")).ProductKeys).Confluence && (productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryNoResult);
        const showFeedbackFooter = productState === (0, (0, parcelRequire("azBuE")).ProductStates).PreQuerySuccess || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryLoading || productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQueryNoResult;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isRovoEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5IxfD")).QuickFindRovoTip), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bKWp")).SearchDialogContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bKWp")).ResultContainerOuter), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bKWp")).ResultContainer), {
            "aria-live": "polite"
        }, renderResults()))), showSearchFooter && productId === (0, (0, parcelRequire("94iog")).ProductKeys).Confluence ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9bNhQ")).SearchFooterPersistRecentSearch), {
            linkComponent: linkComponent
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9bNhQ")).SearchFooter), {
            linkComponent: linkComponent
        }), showFilterFooter && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KiUn")).FilterFooter), null), showFeedbackFooter && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOrUw")).FeedbackFooter), null));
    };
});
parcelRegister("4BodE", function(module, exports) {
    $parcel$export(module.exports, "EnlargedSearchResultContentSkeleton", ()=>$568ef0183cbcb010$export$958cb3907bb9ede);
    var $5uXOq = parcelRequire("5uXOq");
    var $eiKpf;
    const $568ef0183cbcb010$export$958cb3907bb9ede = ({})=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedResultContentWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedIconContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedSkeletonIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultContentWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedResultTitleContainerSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedResultDetailSkeleton), null)));
    };
});
parcelRegister("a9a3f", function(module, exports) {
    $parcel$export(module.exports, "EnlargedSearchResultSection", ()=>$ebea77da566a11aa$export$3cb2a92d364e01db);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $iHixP;
    const $ebea77da566a11aa$export$3cb2a92d364e01db = ({ title: title, totalResults: totalResults, children: children })=>{
        const hasTitle = Boolean(title);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).EnlargedSearchResultSectionContainer), null, hasTitle && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).EnlargedSearchResultSectionHeading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).EnlargedSearchResultsSectionTitle), null, title, totalResults ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).SearchResultSectionTitleBadgeContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            testId: "search-result-count-badge"
        }, totalResults)) : null)), children);
    };
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("iHixP", function(module, exports) {
    $parcel$export(module.exports, "SearchResultSectionContainer", ()=>$44e18234b9d22800$export$ee908270616a8c0);
    $parcel$export(module.exports, "EnlargedSearchResultSectionContainer", ()=>$44e18234b9d22800$export$503dfba90bfcca30);
    $parcel$export(module.exports, "SearchResultSectionHeading", ()=>$44e18234b9d22800$export$12a98bde80b93e83);
    $parcel$export(module.exports, "EnlargedSearchResultSectionHeading", ()=>$44e18234b9d22800$export$7ff5e58611d4f213);
    $parcel$export(module.exports, "SearchResultsSectionTitle", ()=>$44e18234b9d22800$export$ce295363b4299a23);
    $parcel$export(module.exports, "EnlargedSearchResultsSectionTitle", ()=>$44e18234b9d22800$export$ba58138b255a651c);
    $parcel$export(module.exports, "SearchResultSectionTitleBadgeContainer", ()=>$44e18234b9d22800$export$47dafe5a3fc802fe);
    var $3JZ8k;
    var $bWGt6 = parcelRequire("bWGt6");
    function $44e18234b9d22800$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $44e18234b9d22800$export$ee908270616a8c0 = (0, $bWGt6.default)("div", {
        target: "e1vq42j46"
    })({
        padding: `${"var(--ds-space-100, 8px)"} 0`
    });
    const $44e18234b9d22800$export$503dfba90bfcca30 = (0, $bWGt6.default)("div", {
        target: "e1vq42j45"
    })({
        name: "1yyzl0r",
        styles: "padding:0;display:flex;flex-direction:column;gap:var(--ds-space-025, 2px)"
    });
    const $44e18234b9d22800$export$12a98bde80b93e83 = (0, $bWGt6.default)("div", {
        target: "e1vq42j44"
    })({
        marginBottom: "var(--ds-space-075, 6px)",
        maxHeight: (0, (0, parcelRequire("3JZ8k")).grid).multiple(4).px
    });
    const $44e18234b9d22800$export$7ff5e58611d4f213 = (0, $bWGt6.default)("div", {
        target: "e1vq42j43"
    })({
        name: "1ifu3fr",
        styles: "height:28px;display:flex"
    });
    const $44e18234b9d22800$export$ce295363b4299a23 = (0, $bWGt6.default)("h2", {
        target: "e1vq42j42"
    })({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: (0, (0, parcelRequire("3JZ8k")).grid).twice().px,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        textTransform: 'uppercase',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        boxSizing: 'border-box',
        padding: `0 ${(0, (0, parcelRequire("3JZ8k")).grid).twice().px}`
    });
    const $44e18234b9d22800$export$ba58138b255a651c = (0, $bWGt6.default)("span", {
        target: "e1vq42j41"
    })({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        textTransform: 'uppercase',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        boxSizing: 'border-box',
        padding: `0 ${"var(--ds-space-100, 8px)"}`
    });
    const $44e18234b9d22800$export$47dafe5a3fc802fe = (0, $bWGt6.default)("div", {
        target: "e1vq42j40"
    })({
        marginLeft: (0, (0, parcelRequire("3JZ8k")).grid).px,
        fontWeight: 400
    });
});
parcelRegister("5bKWp", function(module, exports) {
    $parcel$export(module.exports, "SearchDialogWrapper", ()=>$8517d4d988dbeb18$export$dcefba65c42da69c);
    $parcel$export(module.exports, "ResultContainerOuter", ()=>$8517d4d988dbeb18$export$d6e44c2a92a613c2);
    $parcel$export(module.exports, "ResultContainer", ()=>$8517d4d988dbeb18$export$ab35601bed9ca017);
    $parcel$export(module.exports, "SidebarScrollContainer", ()=>$8517d4d988dbeb18$export$34a31057caff1acb);
    $parcel$export(module.exports, "SidebarContainerPane", ()=>$8517d4d988dbeb18$export$6b8430dd9f61a5c7);
    $parcel$export(module.exports, "SidebarContainerBorder", ()=>$8517d4d988dbeb18$export$33eeaf745b96a17f);
    $parcel$export(module.exports, "SidebarBottomFixedContainer", ()=>$8517d4d988dbeb18$export$dc065bf90da5c17d);
    $parcel$export(module.exports, "SidebarContainer", ()=>$8517d4d988dbeb18$export$f39f3f768bc98e3d);
    $parcel$export(module.exports, "SearchDialogContent", ()=>$8517d4d988dbeb18$export$c9e0e8491f083dd5);
    $parcel$export(module.exports, "ResultRenderWrapper", ()=>$8517d4d988dbeb18$export$8644783c0dd52b5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JZ8k;
    var $k5uoT;
    var $bWGt6 = parcelRequire("bWGt6");
    function $8517d4d988dbeb18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8517d4d988dbeb18$var$SIDEBAR_PANE_WIDTH = (0, (0, parcelRequire("k5uoT")).gridSize)() * 34;
    const $8517d4d988dbeb18$var$resultContainerVerticalPadding = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $8517d4d988dbeb18$export$dcefba65c42da69c = (0, $bWGt6.default)("div", {
        target: "ee3sr7s8"
    })("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, (0, parcelRequire("3JZ8k")).dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, (0, parcelRequire("3JZ8k")).dialogWidth};` : '', " box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, (0, parcelRequire("3JZ8k")).grid).multiple(0.5).px + ' ' + (0, (0, parcelRequire("3JZ8k")).grid).px + ' ' + (0, $829f609a65d26a98$export$7d3359664e8bb0e5) + ', 0 0 1px ' + (0, $829f609a65d26a98$export$d2d3bedfb276cac0)})`, ";border-radius:3px;background-color:var(--ds-surface-overlay, #fff);overflow:hidden;margin-top:", (0, (0, parcelRequire("3JZ8k")).grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
    const $8517d4d988dbeb18$export$d6e44c2a92a613c2 = (0, $bWGt6.default)("div", {
        target: "ee3sr7s7"
    })({
        name: "s8tasg",
        styles: "flex:1;display:flex;flex-direction:column;overflow:hidden;max-width:100%;box-sizing:border-box"
    });
    const $8517d4d988dbeb18$export$ab35601bed9ca017 = (0, $bWGt6.default)("div", {
        target: "ee3sr7s6"
    })({
        name: "n94oxe",
        styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
    });
    const $8517d4d988dbeb18$export$34a31057caff1acb = (0, $bWGt6.default)("div", {
        target: "ee3sr7s5"
    })({
        flex: '1 1 auto',
        overflowX: 'hidden',
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
    });
    const $8517d4d988dbeb18$export$6b8430dd9f61a5c7 = (0, $bWGt6.default)("div", {
        target: "ee3sr7s4"
    })("flex:0 1 auto;width:", $8517d4d988dbeb18$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){display:none;}");
    const $8517d4d988dbeb18$export$33eeaf745b96a17f = (0, $bWGt6.default)("div", {
        target: "ee3sr7s3"
    })({
        margin: `${"var(--ds-space-200, 16px)"} 0`,
        borderLeft: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`
    });
    const $8517d4d988dbeb18$export$dc065bf90da5c17d = (0, $bWGt6.default)("div", {
        target: "ee3sr7s2"
    })({
        padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`,
        flex: '0 0 auto'
    });
    const $8517d4d988dbeb18$export$f39f3f768bc98e3d = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($8517d4d988dbeb18$export$33eeaf745b96a17f, null), (0, ($parcel$interopDefault($5uXOq))).createElement($8517d4d988dbeb18$export$6b8430dd9f61a5c7, null, (0, ($parcel$interopDefault($5uXOq))).createElement($8517d4d988dbeb18$export$34a31057caff1acb, null, children)));
    const $8517d4d988dbeb18$var$totalDialogHeightPx = 776 + $8517d4d988dbeb18$var$resultContainerVerticalPadding * 2;
    const $8517d4d988dbeb18$var$footerHeight = (0, (0, parcelRequire("k5uoT")).gridSize)() * 6;
    const $8517d4d988dbeb18$var$belowDialogSpace = (0, (0, parcelRequire("k5uoT")).gridSize)() * 28;
    const $8517d4d988dbeb18$var$aiFullDialogPromptHeight = 64;
    const $8517d4d988dbeb18$export$c9e0e8491f083dd5 = (0, $bWGt6.default)("div", {
        target: "ee3sr7s1"
    })("display:flex;max-height:", (props)=>`calc(100vh - ${$8517d4d988dbeb18$var$belowDialogSpace - $8517d4d988dbeb18$var$footerHeight + (props.aiSearchFullDialogEnabled ? $8517d4d988dbeb18$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $8517d4d988dbeb18$var$totalDialogHeightPx + $8517d4d988dbeb18$var$belowDialogSpace, "px){max-height:", (props)=>`${$8517d4d988dbeb18$var$totalDialogHeightPx - $8517d4d988dbeb18$var$footerHeight - (props.aiSearchFullDialogEnabled ? $8517d4d988dbeb18$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");
    const $8517d4d988dbeb18$export$8644783c0dd52b5e = (0, $bWGt6.default)("div", {
        target: "ee3sr7s0"
    })("position:relative;display:flex;flex-direction:column;justify-content:space-between;min-height:", (props)=>props.shouldFixMinimumHeight ? `${props.minimumHeight}px` : 'auto', ";@media screen and (max-width: ", (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth), "px){flex-grow:1;}");
});
parcelRegister("aKYAO", function(module, exports) {
    $parcel$export(module.exports, "useIsMobileView", ()=>$7df7357fe96e0b4e$export$853d1166284edec0);
    var $3JZ8k;
    const $7df7357fe96e0b4e$export$853d1166284edec0 = ()=>window.innerWidth <= (0, (0, parcelRequire("3JZ8k")).dialogPageTakeoverWidth);
});
parcelRegister("idS9H", function(module, exports) {
    $parcel$export(module.exports, "GenericSearchResult", ()=>$6334d3524c536429$export$855c9ab7e6e3e97f);
    var $a9a3f;
    var $9GJaT;
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $tUDIN;
    var $lVuuE;
    var $8W5yo;
    var $8djaw;
    var $7ttuB;
    var $hNXQY;
    var $apEtD;
    const $6334d3524c536429$export$f6fdc80358dfd95 = 10;
    const $6334d3524c536429$export$fd06a2c70d34842e = (searchResultSections, sectionIndex)=>searchResultSections.slice(0, sectionIndex).reduce((accumulator, currentElem)=>accumulator + Math.min(currentElem.searchResults.length, currentElem.resultLimit || $6334d3524c536429$export$f6fdc80358dfd95), 0);
    const $6334d3524c536429$var$getTotalResultCount = (forceHideResultCount, section)=>{
        const resultCount = !forceHideResultCount && section.showResultCount && section.size && section.searchResults.length ? Math.max(section.size, section.searchResults.length) : undefined;
        const totalResults = Boolean(resultCount && section.searchResults.length < (section.resultLimit || $6334d3524c536429$export$f6fdc80358dfd95) && resultCount >= section.searchResults.length) ? section.searchResults.length : resultCount;
        return totalResults;
    };
    const $6334d3524c536429$var$GenericSearchResultWithIntl = ({ children: children, forceHideResultCount: forceHideResultCount = false, generateSectionTitle: generateSectionTitle = ({ title: title })=>title, intl: intl, isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, renderSectionViewAll: renderSectionViewAll, searchItems: searchItems, screen: screen, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext, appendQueryParams: appendQueryParams })=>{
        const { quickFind: quickFind } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        if (!searchItems || !(0, (0, parcelRequire("lVuuE")).hasSearchResults)(searchItems)) {
            if (children) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("apEtD")).SearchResultWrapper), null, children);
            return null;
        }
        const ResultSection = quickFind?.enabled ? (0, (0, parcelRequire("a9a3f")).EnlargedSearchResultSection) : (0, (0, parcelRequire("9GJaT")).SearchResultSection);
        const QuickFindPersistRecentSearch = quickFind?.enabled ? (0, ($parcel$interopDefault($5uXOq))).Fragment : (0, (0, parcelRequire("7ttuB")).PersistRecentSearch);
        const ItemSection = (props)=>{
            const { section: section, sectionIndex: sectionIndex } = props;
            const itemLimit = typeof section.resultLimit === 'number' ? section.resultLimit : $6334d3524c536429$export$f6fdc80358dfd95;
            const searchResults = section.searchResults?.slice(0, itemLimit) || [];
            const totalResults = $6334d3524c536429$var$getTotalResultCount(forceHideResultCount, section);
            const totalNumberOfItemsInPreviousSections = $6334d3524c536429$export$fd06a2c70d34842e(searchItems.sections, sectionIndex);
            if (searchResults.length === 0) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ResultSection, {
                totalResults: totalResults,
                title: section.titleRenderer ? section.titleRenderer({
                    isCollapsed: isCollapsed,
                    productState: productState
                }) : generateSectionTitle(section, intl)
            }, searchResults.map((result, index)=>{
                const analyticContext = {
                    sectionIndex: sectionIndex,
                    sectionId: section.id,
                    containerId: result.containerId || null,
                    indexWithinSection: index,
                    globalIndex: totalNumberOfItemsInPreviousSections + index,
                    isCached: result.isRecentResult || false,
                    metadata: {
                        contentId: result.id,
                        containerId: result.containerId || null,
                        contentType: result.type || null
                    }
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
                    key: result.id,
                    analyticContext: analyticContext,
                    nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext || {}
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(QuickFindPersistRecentSearch, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8W5yo")).SearchResultItem), {
                    isCollapsed: isCollapsed,
                    linkComponent: linkComponent,
                    productState: productState,
                    resultRenderer: section.resultRenderer,
                    resultWrapper: section.resultWrapper,
                    screen: screen,
                    searchResult: result,
                    appendQueryParams: appendQueryParams,
                    useAnalyticsOverride: section.useAnalyticsOverride
                })));
            }), renderSectionViewAll && section.viewAllLinkGenerator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8djaw")).ViewAllLink), {
                linkComponent: linkComponent,
                section: section,
                totalResults: totalResults
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("apEtD")).SearchResultWrapper), null, searchItems.sections.map((section, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement(ItemSection, {
                section: section,
                sectionIndex: index,
                key: section.id
            })), children);
    };
    const $6334d3524c536429$export$855c9ab7e6e3e97f = (0, (0, parcelRequire("8RXs9")).default)($6334d3524c536429$var$GenericSearchResultWithIntl);
});
parcelRegister("9GJaT", function(module, exports) {
    $parcel$export(module.exports, "SearchResultSection", ()=>$a53ee31faa6de3a1$export$51a5a703da15f0f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $iHixP;
    const $a53ee31faa6de3a1$export$51a5a703da15f0f7 = ({ title: title, totalResults: totalResults, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).SearchResultSectionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).SearchResultSectionHeading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).SearchResultsSectionTitle), null, title, totalResults ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHixP")).SearchResultSectionTitleBadgeContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
            testId: "search-result-count-badge"
        }, totalResults)) : null)), children);
    };
});
parcelRegister("lVuuE", function(module, exports) {
    $parcel$export(module.exports, "hasSearchResults", ()=>$3da56dcd3f8448d0$export$bcf020eea629e7ed);
    const $3da56dcd3f8448d0$export$bcf020eea629e7ed = (searchItems)=>{
        const sectionsWithSearchResults = searchItems.sections.filter(({ searchResults: searchResults })=>searchResults.length > 0);
        return sectionsWithSearchResults.length > 0;
    };
});
parcelRegister("8W5yo", function(module, exports) {
    $parcel$export(module.exports, "SearchResultItem", ()=>$26a82d6e28c4aa57$export$56e008c8bd1ccf7c);
    var $5Zza9;
    var $1OFaa;
    var $5uXOq = parcelRequire("5uXOq");
    var $6ZsPS;
    var $7xoNc;
    var $cvYmc;
    var $lywjH;
    const $26a82d6e28c4aa57$var$DefaultSearchResultItemWrapper = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $26a82d6e28c4aa57$var$SearchResultItemKeyboardHiglightWrapper = ({ searchResultId: searchResultId, children: children })=>{
        const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, (0, parcelRequire("1OFaa")).useKeyboardHighlighting)({
            searchResultId: searchResultId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, children(isKeyboardHighlighted));
    };
    const $26a82d6e28c4aa57$export$56e008c8bd1ccf7c = ({ isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, resultRenderer: resultRenderer, resultWrapper: resultWrapper, screen: screen, searchResult: searchResult, appendQueryParams: appendQueryParams, useAnalyticsOverride: useAnalyticsOverride = ()=>({}) })=>{
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { onHighlightCallback: defaultOnHighlightCallback, onSelectCallback: defaultOnSelectCallback, onContextMenuCallback: defaultOnContextMenuCallback } = (0, (0, parcelRequire("lywjH")).useSearchResultAnalyticsCallbacks)({
            screen: screen,
            actionSubject: 'searchResult'
        });
        const { onHighlightCallback: overriddenOnHighlightCallback, onSelectCallback: overriddenOnSelectCallback, onContextMenuCallback: overriddenOnContextMenuCallback } = useAnalyticsOverride({
            screen: screen
        });
        const url = appendQueryParams === undefined ? (0, (0, parcelRequire("7xoNc")).addQuery)(searchResult.url, 'search_id', searchSessionId) : appendQueryParams(searchResult.url, searchSessionId, searchResult.type, searchResult.id);
        const SearchResultItemWrapper = resultWrapper || $26a82d6e28c4aa57$var$DefaultSearchResultItemWrapper;
        const searchResultContentRenderer = (0, $5uXOq.useCallback)((isKeyboardHighlighted)=>resultRenderer ? resultRenderer({
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                productState: productState,
                screen: screen,
                searchResult: searchResult
            }) : (0, (0, parcelRequire("cvYmc")).defaultResultRenderer)({
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                screen: screen,
                searchResult: searchResult
            }), [
            isCollapsed,
            productState,
            resultRenderer,
            screen,
            searchResult
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(SearchResultItemWrapper, {
            url: url
        }, url ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zza9")).SearchResultLink), {
            href: url,
            linkComponent: searchResult.linkComponent ?? linkComponent,
            searchResultId: searchResult.id,
            onContextMenu: overriddenOnContextMenuCallback || defaultOnContextMenuCallback,
            onHighlighted: overriddenOnHighlightCallback || defaultOnHighlightCallback,
            onSelect: overriddenOnSelectCallback || defaultOnSelectCallback,
            "data-testid": `link-${searchResult.id}`
        }, (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)) : (0, ($parcel$interopDefault($5uXOq))).createElement($26a82d6e28c4aa57$var$SearchResultItemKeyboardHiglightWrapper, {
            searchResultId: searchResult.id
        }, (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)));
    };
});
parcelRegister("5Zza9", function(module, exports) {
    $parcel$export(module.exports, "SearchResultLink", ()=>$1d3b9fa4072269d9$export$76cc11d043a1381);
    var $5uXOq = parcelRequire("5uXOq");
    var $eiKpf;
    var $1OFaa;
    const $1d3b9fa4072269d9$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
        const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, (0, parcelRequire("1OFaa")).useKeyboardHighlighting)({
            searchResultId: searchResultId,
            onHighlighted: onHighlighted
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            onClick: onSelect,
            onContextMenu: onContextMenu,
            role: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest
        }, children(isKeyboardHighlighted)));
    };
});
parcelRegister("1OFaa", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardHighlighting", ()=>$cd3a02b4d41aab00$export$9803d460130e453);
    var $5uXOq = parcelRequire("5uXOq");
    var $fYvdU;
    const $cd3a02b4d41aab00$var$onKeyDown = (e, target)=>{
        if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
            e.preventDefault();
            let clickTarget = target;
            while(clickTarget.firstElementChild instanceof HTMLElement && clickTarget.firstElementChild?.click)clickTarget = clickTarget.firstElementChild;
            clickTarget.click();
        }
    };
    const $cd3a02b4d41aab00$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
        const [isKeyboardHighlighted, ref] = (0, (0, parcelRequire("fYvdU")).useKeyboardNavigation)({
            onKeydownCallback: $cd3a02b4d41aab00$var$onKeyDown,
            navigationTrackingId: searchResultId ?? null
        });
        const previousHighlight = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted?.();
            previousHighlight.current = isKeyboardHighlighted;
        }, [
            isKeyboardHighlighted,
            previousHighlight,
            onHighlighted
        ]);
        return {
            isKeyboardHighlighted: isKeyboardHighlighted,
            ref: ref
        };
    };
});
parcelRegister("lywjH", function(module, exports) {
    $parcel$export(module.exports, "useSearchResultAnalyticsCallbacks", ()=>$8ce201bcb35d3d00$export$4381245974d3b25a);
    var $5uXOq = parcelRequire("5uXOq");
    var $3FqY6;
    var $75NXP;
    const $8ce201bcb35d3d00$export$4381245974d3b25a = ({ onHighlighted: onHighlighted, onSelect: onSelect, screen: screen, actionSubject: actionSubject })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const onHighlightCallback = (0, $5uXOq.useCallback)(()=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onSearchResultHighlighted)({
                screen: screen,
                actionSubject: actionSubject
            }));
            onHighlighted?.();
        }, [
            actionSubject,
            fireAnalyticsEvent,
            onHighlighted,
            screen
        ]);
        const onSelectCallback = (0, $5uXOq.useCallback)((e)=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onSearchResultSelected)({
                screen: screen,
                actionSubject: actionSubject
            }));
            onSelect?.(e);
        }, [
            actionSubject,
            fireAnalyticsEvent,
            onSelect,
            screen
        ]);
        const onContextMenuCallback = (0, $5uXOq.useCallback)((e)=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onSearchResultContext)({
                screen: screen,
                actionSubject: actionSubject
            }));
        }, [
            actionSubject,
            fireAnalyticsEvent,
            screen
        ]);
        return {
            onHighlightCallback: onHighlightCallback,
            onSelectCallback: onSelectCallback,
            onContextMenuCallback: onContextMenuCallback
        };
    };
});
parcelRegister("8djaw", function(module, exports) {
    $parcel$export(module.exports, "ViewAllLink", ()=>$9d2eca8cb63a35b9$export$f8fe8ba0816633ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $e7T97;
    var $k4hbD;
    var $2dI5H;
    var $75NXP;
    var $3FqY6;
    const $9d2eca8cb63a35b9$export$f8fe8ba0816633ed = ({ linkComponent: linkComponent, section: section, totalResults: totalResults = 0 })=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const { viewAllLinkGenerator: viewAllLinkGenerator, viewAllLinkRenderer: viewAllLinkRenderer } = section;
        if (!viewAllLinkGenerator) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onClick: ()=>{
                fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onSearchResultViewAllLinkClicked)(section.id));
            },
            role: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e7T97")).SearchResultSectionLink), {
            linkComponent: linkComponent,
            href: viewAllLinkGenerator(query),
            testId: "search-result-section-link"
        }, viewAllLinkRenderer ? viewAllLinkRenderer({
            section: section,
            totalResults: totalResults
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).common_show_all_results_link)));
    };
});
parcelRegister("e7T97", function(module, exports) {
    $parcel$export(module.exports, "SearchResultSectionLink", ()=>$8a2fa9a37d3334b2$export$f39804bac419a7f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7297k;
    const $8a2fa9a37d3334b2$export$f39804bac419a7f4 = ({ children: children, linkComponent: linkComponent, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7297k")).SectionLink), {
            appearance: "link",
            ...rest,
            component: linkComponent || undefined
        }, children);
});
parcelRegister("7297k", function(module, exports) {
    $parcel$export(module.exports, "SectionLink", ()=>$4e0c934de1c69b04$export$3545bd757920e2b3);
    var $fVnbM;
    var $3JZ8k;
    var $bWGt6 = parcelRequire("bWGt6");
    const $4e0c934de1c69b04$export$3545bd757920e2b3 = (0, $bWGt6.default)((0, (0, parcelRequire("fVnbM")).default), {
        target: "e1052ovn0"
    })("margin-left:", (0, (0, parcelRequire("3JZ8k")).grid).half().px, ";color:", `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";cursor:pointer!important;&:hover{text-decoration:underline!important;}");
});
parcelRegister("7ttuB", function(module, exports) {
    $parcel$export(module.exports, "usePersistRecentSearches", ()=>$947af48e629e5ba7$export$3adda20dc7f5408f);
    $parcel$export(module.exports, "PersistRecentSearch", ()=>$947af48e629e5ba7$export$c8074e5d4e733c21);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VoGI;
    var $033iF;
    var $kv2Va;
    var $2dI5H;
    const $947af48e629e5ba7$export$3adda20dc7f5408f = (overrideQuery)=>{
        const previousQuery = (0, $5uXOq.useRef)(null);
        const { user: user } = (0, (0, parcelRequire("7VoGI")).useUserContext)();
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const product = getActiveProduct();
        const persistRecentSearch = (0, $5uXOq.useCallback)(()=>{
            if (user?.id && product?.id) {
                if (overrideQuery && overrideQuery.trim() !== '') (0, (0, parcelRequire("033iF")).addRecentSearch)(overrideQuery, user.id, product.id, (0, (0, parcelRequire("033iF")).RECENT_SEARCH_KEY));
                else if (previousQuery.current !== query && query.trim() !== '') {
                    (0, (0, parcelRequire("033iF")).addRecentSearch)(query, user.id, product.id, (0, (0, parcelRequire("033iF")).RECENT_SEARCH_KEY));
                    previousQuery.current = query;
                }
            }
        }, [
            product?.id,
            query,
            user.id,
            overrideQuery
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            persistRecentSearch();
        }, [
            persistRecentSearch
        ]);
        const onEnter = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter') persistRecentSearch();
        }, [
            persistRecentSearch
        ]);
        return [
            onClick,
            onEnter
        ];
    };
    const $947af48e629e5ba7$export$c8074e5d4e733c21 = ({ children: children, overrideQuery: overrideQuery })=>{
        const [onClick, onEnter] = $947af48e629e5ba7$export$3adda20dc7f5408f(overrideQuery);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onClick: onClick,
            onKeyDown: onEnter,
            style: {
                width: '100%'
            },
            "data-testid": "persist-recent-search"
        }, children));
    };
});
parcelRegister("7VoGI", function(module, exports) {
    $parcel$export(module.exports, "UserProvider", ()=>$552748c768c14934$export$88f24fd8fcfab6ca);
    $parcel$export(module.exports, "useUserContext", ()=>$552748c768c14934$export$87c54b525b914dab);
    var $5uXOq = parcelRequire("5uXOq");
    const $552748c768c14934$var$UserContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        user: {},
        setUser: (user)=>{}
    });
    const $552748c768c14934$export$88f24fd8fcfab6ca = ({ user: initialUser, children: children })=>{
        const [user, setUser] = (0, $5uXOq.useState)(initialUser || {});
        return (0, ($parcel$interopDefault($5uXOq))).createElement($552748c768c14934$var$UserContext.Provider, {
            value: {
                user: user,
                setUser: setUser
            }
        }, children);
    };
    function $552748c768c14934$export$87c54b525b914dab() {
        return (0, $5uXOq.useContext)($552748c768c14934$var$UserContext);
    }
});
parcelRegister("033iF", function(module, exports) {
    $parcel$export(module.exports, "RECENT_SEARCH_KEY", ()=>$c020cb84bb06833e$export$ec4722d39a5031c0);
    $parcel$export(module.exports, "addRecentSearch", ()=>$c020cb84bb06833e$export$74e99d9695eabee6);
    $parcel$export(module.exports, "getRecentSearches", ()=>$c020cb84bb06833e$export$1216255791599668);
    $parcel$export(module.exports, "removeRecentSearch", ()=>$c020cb84bb06833e$export$6adb2cc1366d1e30);
    const $c020cb84bb06833e$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
    const $c020cb84bb06833e$export$c1b7badf23670c19 = 50;
    const $c020cb84bb06833e$export$74e99d9695eabee6 = (value, userId, product, recentSearchKey)=>{
        const recentSearchesRaw = $c020cb84bb06833e$var$getLocalStorageItem(recentSearchKey);
        const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
        if (!recentSearches[userId]) recentSearches[userId] = {};
        let userSearches = recentSearches[userId];
        if (!userSearches[product]) userSearches[product] = [];
        let productSearches = userSearches[product];
        const trimmedValue = value.trim();
        if (productSearches.length === $c020cb84bb06833e$export$c1b7badf23670c19) productSearches.pop();
        if (productSearches.includes(trimmedValue)) productSearches = productSearches.filter((v)=>v !== trimmedValue);
        productSearches.unshift(trimmedValue);
        recentSearches[userId][product] = productSearches;
        $c020cb84bb06833e$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
    };
    const $c020cb84bb06833e$export$1216255791599668 = (userId, product, recentSearchKey)=>{
        const recentSearchesRaw = $c020cb84bb06833e$var$getLocalStorageItem(recentSearchKey);
        const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
        const userSearches = recentSearches[userId] || {};
        return userSearches[product] || [];
    };
    const $c020cb84bb06833e$export$6adb2cc1366d1e30 = (value, userId, product, recentSearchKey)=>{
        const recentSearchesRaw = $c020cb84bb06833e$var$getLocalStorageItem(recentSearchKey);
        const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
        if (!recentSearches[userId] || !recentSearches[userId][product]) return [];
        recentSearches[userId][product] = recentSearches[userId][product].filter((v)=>v !== value);
        $c020cb84bb06833e$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
        return recentSearches[userId][product];
    };
    const $c020cb84bb06833e$var$setLocalStorageItem = (key, value)=>{
        window.localStorage.setItem(key, value);
    };
    const $c020cb84bb06833e$var$getLocalStorageItem = (key)=>{
        return window.localStorage.getItem(key);
    };
});
parcelRegister("apEtD", function(module, exports) {
    $parcel$export(module.exports, "SearchResultWrapper", ()=>$a349d88b309f0316$export$7ef688c5abd67ccc);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $hNXQY;
    const $a349d88b309f0316$var$QuickFindSearchResultWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1v67m8r-0"
    })`display:flex;flex-direction:column;gap:${"var(--ds-space-025, 2px)"};padding:${"var(--ds-space-100, 8px)"};`;
    const $a349d88b309f0316$export$7ef688c5abd67ccc = ({ children: children })=>{
        const { quickFind: quickFind } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        return quickFind?.enabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($a349d88b309f0316$var$QuickFindSearchResultWrapper, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("dOrUw", function(module, exports) {
    $parcel$export(module.exports, "FeedbackFooter", ()=>$287dd821bdf974d0$export$e7b87342306a8337);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $c59Mn;
    var $6em9K;
    var $dC5iT;
    var $8CUq3;
    var $luzFO;
    const $287dd821bdf974d0$var$footerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.150',
        paddingBottom: 'space.150',
        paddingLeft: 'space.200',
        paddingRight: 'space.200',
        borderTop: '1px solid',
        borderColor: 'color.border',
        display: 'flex',
        alignItems: 'center',
        color: 'color.text',
        gap: 'space.150'
    });
    const $287dd821bdf974d0$export$e7b87342306a8337 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $287dd821bdf974d0$var$footerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_footer_text), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6em9K")).default), {
            TriggerComponent: ({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luzFO")).FeedbackButton), {
                    onClick: onClick
                })
        }));
    };
});
parcelRegister("6em9K", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$264736d3030d4874$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6ARj7;
    var $i5re6;
    var $koVbs;
    var $7VoGI;
    var $aoQqW;
    var $lvCts;
    var $kv2Va;
    var $hNXQY;
    var $j97IK;
    const $264736d3030d4874$var$AkFeedbackCollector = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("kJQ13")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $264736d3030d4874$var$AkFeedbackFlag = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("kJQ13")).then(({ FeedbackFlag: FeedbackFlag })=>{
            return {
                default: FeedbackFlag
            };
        }));
    const $264736d3030d4874$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
    const $264736d3030d4874$var$ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
    const $264736d3030d4874$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
    const $264736d3030d4874$var$FeedbackCollector = ({ TriggerComponent: TriggerComponent = (0, (0, parcelRequire("aoQqW")).FeedbackButton) })=>{
        const { user: user } = (0, (0, parcelRequire("7VoGI")).useUserContext)();
        const { name: name, id: id } = user;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [displayFlag, setDisplayFlag] = (0, $5uXOq.useState)(false);
        const aggregatorClient = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
        const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, (0, parcelRequire("j97IK")).useExperiments)();
        const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const activeProduct = getActiveProduct()?.title;
        const primaryProduct = getPrimaryProduct()?.title;
        const isHello = $264736d3030d4874$var$HELLO_TENANT_ID === cloudId;
        const isQuickFind = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)().quickFind?.enabled;
        const experience = isQuickFind ? 'quick-find' : 'quick-search';
        const feedbackContext = JSON.stringify({
            experimentLayers: backendExperiment?.experimentLayers,
            frontendExperiments: frontendExperiments,
            frontendVersion: (0, $7531534e67cbfa1e$export$2db401a6b81eceee),
            product: activeProduct,
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            userId: id,
            source: 'product-search-dialog',
            isHello: isHello,
            experience: experience,
            release: (0, (0, parcelRequire("i5re6")).getProductReleaseVersion)(primaryProduct)
        });
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerComponent, {
            onClick: (e)=>{
                e.preventDefault();
                setIsOpen(true);
            }
        }), isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($264736d3030d4874$var$AkFeedbackCollector, {
            locale: locale,
            onClose: ()=>setIsOpen(false),
            onSubmit: ()=>setDisplayFlag(true),
            atlassianAccountId: id,
            name: name,
            entrypointId: $264736d3030d4874$var$ENTRYPOINT_ID,
            additionalFields: [
                {
                    id: $264736d3030d4874$var$FEEDBACK_CONTEXT_CF,
                    value: feedbackContext
                }
            ]
        })) : null, displayFlag && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ARj7")).default), {
            onDismissed: ()=>setDisplayFlag(false)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($264736d3030d4874$var$AkFeedbackFlag, {
            locale: locale
        }))));
    };
    var $264736d3030d4874$export$2e2bcd8739ae039 = $264736d3030d4874$var$FeedbackCollector;
});
parcelRegister("i5re6", function(module, exports) {
    $parcel$export(module.exports, "getProductReleaseVersion", ()=>$ff5cd6a755b3284a$export$d521605fb33b0dfd);
    const $ff5cd6a755b3284a$var$memoizedQuerySelector = (selectors)=>{
        let element = null;
        return ()=>{
            if (!element) element = document.querySelector(selectors);
            return element;
        };
    };
    const $ff5cd6a755b3284a$export$d521605fb33b0dfd = (product)=>{
        switch(product?.toLowerCase()){
            case 'confluence':
                return window.__buildInfo?.FRONTEND_VERSION || 'noversion';
            case 'jira':
                return window.BUILD_KEY;
            case 'townsquare':
                const versionMeta = $ff5cd6a755b3284a$var$memoizedQuerySelector('meta[name="release-version"]');
                if (versionMeta instanceof HTMLMetaElement) return versionMeta.content;
        }
        return 'noversion';
    };
});
parcelRegister("aoQqW", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$e053694233c54610$export$116fedbe5e2e2bd8);
    var $f8Sb3;
    parcelRequire("5uXOq");
    var $ousew;
    var $k4hbD;
    var $eCeGD;
    function $e053694233c54610$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e053694233c54610$var$buttonStyles = {
        name: "1y6tyz0",
        styles: "margin:0 auto;width:fit-content"
    };
    const $e053694233c54610$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $e053694233c54610$var$buttonStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            onClick: onClick,
            appearance: "subtle"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).common_give_feedback)));
    };
});
const $7531534e67cbfa1e$var$packageName = "platform-pkg";
const $7531534e67cbfa1e$var$packageVersion = "0.0.0-use.local";
const $7531534e67cbfa1e$export$2db401a6b81eceee = `${$7531534e67cbfa1e$var$packageName}@${$7531534e67cbfa1e$var$packageVersion}`;
parcelRegister("kJQ13", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aOfb9")
    ]).then(()=>parcelRequire('ncXSS'));
});
parcelRegister("luzFO", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$7f80209c20eb6026$export$116fedbe5e2e2bd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8CUq3;
    var $5ILhZ;
    var $iqsNk;
    const $7f80209c20eb6026$var$feedbackButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        color: 'color.link',
        padding: 'space.0',
        ':hover': {
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    });
    const $7f80209c20eb6026$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $7f80209c20eb6026$var$feedbackButtonStyles,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("iqsNk")).messages).feedbackButton));
});
parcelRegister("iqsNk", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bde196608288079f$export$defe85febe8b728c);
    var $7VHMR;
    const $bde196608288079f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedbackButton: {
            id: 'feedback_button',
            defaultMessage: 'Give feedback',
            description: 'Click this button to give feedback for search.'
        }
    });
});
parcelRegister("9KiUn", function(module, exports) {
    $parcel$export(module.exports, "FilterFooter", ()=>$53e3819222dc3555$export$b4bfb1c3ed0cdeca);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $7anl7;
    var $7sOan;
    var $c59Mn;
    var $2WacJ;
    var $7ttuB;
    const $53e3819222dc3555$export$b4bfb1c3ed0cdeca = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const confluenceIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
            appearance: "brand",
            size: "small"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ttuB")).PersistRecentSearch), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WacJ")).QuickFindAdvancedSearchLink), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7sOan")).default), {
            squareReturnIcon: true,
            searchFooterLabel: formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_show_filtered_results),
            searchFooterLabelWithIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("c59Mn")).messages).quick_find_show_filtered_results_with_icon,
                values: {
                    confluenceIcon: confluenceIcon
                }
            }),
            filterByProductFooter: true
        })));
    };
});
parcelRegister("7anl7", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceIcon", ()=>$1c9c2365ff37a453$export$68f3db7f6af48bcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
    };
    const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $1c9c2365ff37a453$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("2WacJ", function(module, exports) {
    $parcel$export(module.exports, "QuickFindAdvancedSearchLink", ()=>$fdc46d020a4f9e19$export$a10ba81e8e8d140);
    var $bWGt6 = parcelRequire("bWGt6");
    const $fdc46d020a4f9e19$export$a10ba81e8e8d140 = (0, $bWGt6.default)("div", {
        target: "e58cvu60"
    })({
        borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '> span > a': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
        }
    });
});
parcelRegister("9bNhQ", function(module, exports) {
    $parcel$export(module.exports, "SearchFooter", ()=>$69249c2884524feb$export$64ded8b71dfcba9e);
    $parcel$export(module.exports, "SearchFooterPersistRecentSearch", ()=>$69249c2884524feb$export$8784f9fd2cdbbd0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $7sOan;
    var $c59Mn;
    var $2WacJ;
    var $7ttuB;
    const $69249c2884524feb$export$64ded8b71dfcba9e = ({ linkComponent: linkComponent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WacJ")).QuickFindAdvancedSearchLink), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7sOan")).default), {
            linkComponent: linkComponent,
            squareReturnIcon: true,
            searchFooterLabel: formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_footer_full_page_search_link)
        }));
    };
    const $69249c2884524feb$export$8784f9fd2cdbbd0a = ({ linkComponent: linkComponent })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ttuB")).PersistRecentSearch), null, (0, ($parcel$interopDefault($5uXOq))).createElement($69249c2884524feb$export$64ded8b71dfcba9e, {
            linkComponent: linkComponent
        }));
    };
});
parcelRegister("gXkA8", function(module, exports) {
    $parcel$export(module.exports, "PreQueryEmptyScreen", ()=>$00d6c8cbe57bc275$export$f16a7ed214a332fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $4bcZr;
    var $c59Mn;
    var $ousew;
    const $00d6c8cbe57bc275$export$f76aab36aa9d8077 = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("afQgD")));
    const $00d6c8cbe57bc275$export$f16a7ed214a332fa = ({})=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4bcZr")).EmptyState), {
            Image: $00d6c8cbe57bc275$export$f76aab36aa9d8077,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_no_content_header),
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_no_content_body)
        });
    };
});
parcelRegister("4bcZr", function(module, exports) {
    $parcel$export(module.exports, "EmptyState", ()=>$dda640ab52c1dabd$export$fddf379e22a74b00);
    var $5uXOq = parcelRequire("5uXOq");
    var $azqDa;
    const $dda640ab52c1dabd$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azqDa")).Wrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Image, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azqDa")).Title), null, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azqDa")).Content), null, content)));
});
parcelRegister("azqDa", function(module, exports) {
    $parcel$export(module.exports, "Title", ()=>$8f804d6b826fc48a$export$f99233281efd08a0);
    $parcel$export(module.exports, "Content", ()=>$8f804d6b826fc48a$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "Wrapper", ()=>$8f804d6b826fc48a$export$e6dfd72ab29f8598);
    var $3JZ8k;
    var $dC5iT;
    var $8CUq3;
    var $5uXOq = parcelRequire("5uXOq");
    var $bWGt6 = parcelRequire("bWGt6");
    const $8f804d6b826fc48a$var$TitleContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        font: 'font.heading.small',
        fontWeight: 'font.weight.medium',
        lineHeight: '20px',
        color: 'color.text',
        marginTop: 'space.100'
    });
    const $8f804d6b826fc48a$export$f99233281efd08a0 = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8f804d6b826fc48a$var$TitleContainerStyles
        }, children);
    };
    const $8f804d6b826fc48a$export$7c6e2c02157bb7d2 = (0, $bWGt6.default)("div", {
        target: "e1ttkipm1"
    })({
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '20px',
        marginTop: (0, (0, parcelRequire("3JZ8k")).grid).px,
        color: (0, (0, parcelRequire("3JZ8k")).primaryTextColour)
    });
    const $8f804d6b826fc48a$export$e6dfd72ab29f8598 = (0, $bWGt6.default)("div", {
        target: "e1ttkipm0"
    })({
        textAlign: 'center',
        padding: (0, (0, parcelRequire("3JZ8k")).grid).twice().px
    });
});
parcelRegister("afQgD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jnlZ0").then(()=>parcelRequire('2sLjS'));
});
parcelRegister("8ilpI", function(module, exports) {
    $parcel$export(module.exports, "SearchErrorScreen", ()=>$3a578a54f04954f4$export$66fb8d8f30619036);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5Ctj;
    const $3a578a54f04954f4$export$66fb8d8f30619036 = ({ onRetry: onRetry = ()=>null })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5Ctj")).default), {
            onRetry: onRetry
        });
    };
});
parcelRegister("i5Ctj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9363639e1d8132c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4bcZr;
    var $kCMvS;
    var $ousew;
    var $8RXs9;
    var $k4hbD;
    var $66ZQB;
    const $9363639e1d8132c1$var$Image = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("fbRMa")));
    class $9363639e1d8132c1$export$930da00ff8e1539f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4bcZr")).EmptyState), {
                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_error_state_failed_search_heading),
                Image: $9363639e1d8132c1$var$Image,
                content: this.getContent()
            });
        }
        constructor(...args){
            super(...args), this.getContent = ()=>{
                const { onRetry: onRetry } = this.props;
                const linkComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("66ZQB")).Button), {
                        ...props,
                        role: "button",
                        tabIndex: 0,
                        onClick: ()=>onRetry(),
                        onKeyDown: (event)=>event.key === 'Enter' ? onRetry() : undefined
                    });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, (0, parcelRequire("k4hbD")).messages).common_error_state_failed_search_body,
                    values: {
                        emptyLink: (s)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kCMvS")).Link), {
                                linkComponent: linkComponent,
                                href: ''
                            }, s)
                    }
                });
            };
        }
    }
    var $9363639e1d8132c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($9363639e1d8132c1$export$930da00ff8e1539f);
});
parcelRegister("66ZQB", function(module, exports) {
    $parcel$export(module.exports, "Button", ()=>$a41176d265b0ecd7$export$353f5b6fc5456de1);
    var $bWGt6 = parcelRequire("bWGt6");
    const $a41176d265b0ecd7$export$353f5b6fc5456de1 = (0, $bWGt6.default)("span", {
        target: "e1hs8rk0"
    })({
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        cursor: 'pointer'
    });
});
parcelRegister("fbRMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5oNOR").then(()=>parcelRequire('4vwHe'));
});
parcelRegister("5IxfD", function(module, exports) {
    $parcel$export(module.exports, "QuickFindRovoTip", ()=>$d768a0065491f860$export$719e67cc0251dc18);
    var $e78BF;
    var $dC5iT;
    var $8CUq3;
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $eiKpf;
    var $54Fwx;
    var $42CjB;
    var $c59Mn;
    var $73b2G;
    var $3bJE0;
    const $d768a0065491f860$var$RovoTipMessageStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '95%',
        marginLeft: 'space.050',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        paddingLeft: 'space.050'
    });
    const $d768a0065491f860$var$RovoTipContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.075',
        paddingLeft: 'space.100',
        paddingRight: 'space.100'
    });
    const $d768a0065491f860$var$RovoTipStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        minHeight: `${"var(--ds-space-500, 40px)"}`,
        paddingLeft: 'space.150',
        paddingRight: 'space.100',
        borderRadius: `${"var(--ds-space-050, 4px)"}`,
        backgroundColor: 'color.background.accent.purple.subtlest',
        color: 'color.text.accent.purple'
    });
    const $d768a0065491f860$export$719e67cc0251dc18 = ()=>{
        const { showRovoTip: showRovoTip, dismissRovoTip: dismissRovoTip } = (0, (0, parcelRequire("73b2G")).useQuickFindRovoTip)();
        const { focusInput: focusInput } = (0, (0, parcelRequire("3bJE0")).useInputContext)();
        if (!showRovoTip) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d768a0065491f860$var$RovoTipContainerStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d768a0065491f860$var$RovoTipStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("e78BF"))))), {
            label: "blank",
            color: "var(--ds-text-accent-purple, #5E4DB2)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d768a0065491f860$var$RovoTipMessageStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, "Rovo tip:"), " ", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_rovo_tip)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).EnlargedReturnIconContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, (0, parcelRequire("54Fwx")).RemoveIcon),
            spacing: 'compact',
            onClick: (event)=>{
                event.preventDefault();
                event.stopPropagation();
                dismissRovoTip();
                focusInput && focusInput();
            },
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).remove_button_label),
            appearance: 'subtle'
        }))));
    };
});
parcelRegister("e78BF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a46865398d7c7cda$var$_react = $a46865398d7c7cda$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a46865398d7c7cda$var$_UNSAFE_baseNew = $a46865398d7c7cda$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a46865398d7c7cda$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a46865398d7c7cda$var$LightbulbIcon = (props)=>$a46865398d7c7cda$var$_react.default.createElement($a46865398d7c7cda$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 12.25V14c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-1.75m-4.5 0v-.715c0-.483-.286-.912-.685-1.182a5.25 5.25 0 1 1 5.871 0c-.4.27-.686.7-.686 1.182v.715m-4.5 0h4.5"/>`
        }, props));
    $a46865398d7c7cda$var$LightbulbIcon.displayName = 'LightbulbIcon';
    var $a46865398d7c7cda$var$_default = module.exports.default = $a46865398d7c7cda$var$LightbulbIcon;
});
parcelRegister("73b2G", function(module, exports) {
    $parcel$export(module.exports, "useQuickFindRovoTip", ()=>$f26cc4706fba3d7f$export$ccc3a6663aee8d48);
    var $5uXOq = parcelRequire("5uXOq");
    var $c7qbA;
    var $7VoGI;
    var $kv2Va;
    const $f26cc4706fba3d7f$export$ccc3a6663aee8d48 = ()=>{
        const { user: user } = (0, (0, parcelRequire("7VoGI")).useUserContext)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const product = getActiveProduct();
        const [showRovoTip, setShowRovoTip] = (0, $5uXOq.useState)(true);
        (0, $5uXOq.useEffect)(()=>{
            if (!product) return;
            const rovoTipFromLocalStorage = (0, (0, parcelRequire("c7qbA")).getRovoTip)(product.id, user?.id);
            setShowRovoTip(rovoTipFromLocalStorage);
        }, [
            user.id,
            product
        ]);
        const dismissRovoTip = (0, $5uXOq.useCallback)(()=>{
            if (product?.id) {
                const rovoTipFromLocalStorage = (0, (0, parcelRequire("c7qbA")).setRovoTip)(product.id, user?.id);
                setShowRovoTip(rovoTipFromLocalStorage);
            }
        }, [
            user.id,
            product
        ]);
        return {
            showRovoTip: showRovoTip,
            dismissRovoTip: dismissRovoTip
        };
    };
});
parcelRegister("c7qbA", function(module, exports) {
    $parcel$export(module.exports, "getRovoTip", ()=>$180f656868691a56$export$b9330795d9444727);
    $parcel$export(module.exports, "setRovoTip", ()=>$180f656868691a56$export$297a6fb093b042a3);
    const $180f656868691a56$export$568e0ce3cc5a9972 = 'atlassian.unified-search.quick-find-rovo-tip';
    const $180f656868691a56$export$4bac6b574c2c1d97 = 'anonymous-user';
    const $180f656868691a56$export$b9330795d9444727 = (productId, userId)=>{
        const userIdOrAnonymous = userId || $180f656868691a56$export$4bac6b574c2c1d97;
        const quickFindRovoTipRaw = $180f656868691a56$var$getLocalStorageItem($180f656868691a56$export$568e0ce3cc5a9972);
        const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
        const rovoTipProducts = rovoTip[userIdOrAnonymous] || {};
        return rovoTipProducts[productId] === undefined ? true : rovoTipProducts[productId];
    };
    const $180f656868691a56$export$297a6fb093b042a3 = (productId, userId)=>{
        const userIdOrAnonymous = userId || $180f656868691a56$export$4bac6b574c2c1d97;
        const quickFindRovoTipRaw = $180f656868691a56$var$getLocalStorageItem($180f656868691a56$export$568e0ce3cc5a9972);
        const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
        if (!rovoTip[userIdOrAnonymous]) rovoTip[userIdOrAnonymous] = {};
        rovoTip[userIdOrAnonymous][productId] = false;
        $180f656868691a56$var$setLocalStorageItem($180f656868691a56$export$568e0ce3cc5a9972, JSON.stringify(rovoTip));
        return rovoTip[userIdOrAnonymous][productId];
    };
    const $180f656868691a56$var$setLocalStorageItem = (key, value)=>{
        window.localStorage.setItem(key, value);
    };
    const $180f656868691a56$var$getLocalStorageItem = (key)=>{
        return window.localStorage.getItem(key);
    };
});
parcelRegister("3bJE0", function(module, exports) {
    $parcel$export(module.exports, "InputContext", ()=>$2f62bc43e1f7b917$export$37fb8590cf2c088c);
    $parcel$export(module.exports, "useInputContext", ()=>$2f62bc43e1f7b917$export$25c2004aac4f3cc);
    var $5uXOq = parcelRequire("5uXOq");
    const $2f62bc43e1f7b917$var$Context = (0, ($parcel$interopDefault($5uXOq))).createContext({
        focusInput: undefined
    });
    const $2f62bc43e1f7b917$export$37fb8590cf2c088c = ({ children: children, forwardRef: forwardRef })=>{
        const focusInput = (0, $5uXOq.useCallback)(()=>{
            if (typeof forwardRef === 'object') forwardRef?.current?.focus();
        }, [
            forwardRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2f62bc43e1f7b917$var$Context.Provider, {
            value: {
                focusInput: focusInput
            }
        }, children);
    };
    const $2f62bc43e1f7b917$export$25c2004aac4f3cc = ()=>{
        return (0, $5uXOq.useContext)($2f62bc43e1f7b917$var$Context);
    };
});
parcelRegister("lTDGC", function(module, exports) {
    $parcel$export(module.exports, "RovoContextProvider", ()=>$5a4ba11087fc4efc$export$ee92d5ccc84fac27);
    $parcel$export(module.exports, "useRovoContext", ()=>$5a4ba11087fc4efc$export$4deb785ed026cc56);
    var $5uXOq = parcelRequire("5uXOq");
    const $5a4ba11087fc4efc$var$RovoContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        isRovoEnabled: false,
        setIsRovoEnabled: (isRovoEnabled)=>{}
    });
    const $5a4ba11087fc4efc$export$ee92d5ccc84fac27 = ({ isEnabled: isEnabled, children: children })=>{
        const [isRovoEnabled, setIsRovoEnabled] = (0, $5uXOq.useState)(isEnabled || false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5a4ba11087fc4efc$var$RovoContext.Provider, {
            value: {
                isRovoEnabled: isRovoEnabled,
                setIsRovoEnabled: setIsRovoEnabled
            }
        }, children);
    };
    function $5a4ba11087fc4efc$export$4deb785ed026cc56() {
        return (0, $5uXOq.useContext)($5a4ba11087fc4efc$var$RovoContext);
    }
});
parcelRegister("7JF8H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dde1580d0c592255$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gsomE;
    var $3FqY6;
    var $1FaYJ;
    var $cI0dp;
    var $2dI5H;
    var $j4xTD;
    var $71Kgw;
    var $337hv;
    const $dde1580d0c592255$var$NoResultsWithHooks = ({ urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', advancedSearchSelected: advancedSearchSelected, fromQuickFindPostQueryNoResults: fromQuickFindPostQueryNoResults })=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { autocorrectionEnabled: autocorrectionEnabled } = (0, (0, parcelRequire("j4xTD")).useAutocorrectionEnabled)();
        const advancedSearchUrl = urlGeneratorForNoResultsScreen(query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, autocorrectionEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71Kgw")).AutocorrectAsyncWrapper), {
            container: (0, (0, parcelRequire("337hv")).NoResultsAutocorrectWrapper)
        }), fromQuickFindPostQueryNoResults ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cI0dp")).default), {
            advancedSearchUrl: advancedSearchUrl,
            advancedSearchSelected: advancedSearchSelected
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1FaYJ")).default), {
            advancedSearchUrl: advancedSearchUrl,
            advancedSearchSelected: advancedSearchSelected
        }));
    };
    var $dde1580d0c592255$export$2e2bcd8739ae039 = (0, (0, parcelRequire("gsomE")).withAnalytics)({
        advancedSearchSelected: (0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)
    })($dde1580d0c592255$var$NoResultsWithHooks);
});
parcelRegister("1FaYJ", function(module, exports) {
    $parcel$export(module.exports, "Image", ()=>$7c121ea0aed31f46$export$3e431a229df88919);
    $parcel$export(module.exports, "default", ()=>$7c121ea0aed31f46$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4bcZr;
    var $kCMvS;
    var $ousew;
    var $8RXs9;
    var $8oG5R;
    var $3FqY6;
    var $k4hbD;
    var $fVnbM;
    var $c1tQw;
    const $7c121ea0aed31f46$export$3e431a229df88919 = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("3xWPH")));
    class $7c121ea0aed31f46$export$ef6006467f04ee41 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4bcZr")).EmptyState), {
                title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_empty_state_heading),
                Image: $7c121ea0aed31f46$export$3e431a229df88919,
                content: this.getContent()
            });
        }
        constructor(...args){
            super(...args), this.onAdvancedSearchClicked = (e)=>{
                const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
                advancedSearchSelected({
                    trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                    actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).NO_RESULTS,
                    isLoading: false,
                    newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e)
                });
                onClick && onClick(advancedSearchUrl, e);
            }, this.getContent = ()=>{
                const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
                if (!hasFilters) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    role: "none",
                    onClick: this.onAdvancedSearchClicked
                }, isMultiSite || !advancedSearchUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).common_empty_state_body_no_advanced_search) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, (0, parcelRequire("k4hbD")).messages).common_empty_state_body,
                    values: {
                        a: (s)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kCMvS")).Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl
                            }, s)
                    }
                }));
                else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    tagName: "div",
                    ...(0, (0, parcelRequire("k4hbD")).messages).filters_applied
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1tQw")).ClearFiltersButtonWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "primary",
                    onClick: clearFilters
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).clear_filters))));
            };
        }
    }
    var $7c121ea0aed31f46$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($7c121ea0aed31f46$export$ef6006467f04ee41);
});
parcelRegister("c1tQw", function(module, exports) {
    $parcel$export(module.exports, "ClearFiltersButtonWrapper", ()=>$a9d1644c82c28bc4$export$8c06dfd742f74a6f);
    var $bWGt6 = parcelRequire("bWGt6");
    function $a9d1644c82c28bc4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a9d1644c82c28bc4$export$8c06dfd742f74a6f = (0, $bWGt6.default)("div", {
        target: "eg9i8g80"
    })({
        name: "1y04g5d",
        styles: "padding-top:var(--ds-space-400, 32px)"
    });
});
parcelRegister("3xWPH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9jcb2").then(()=>parcelRequire('4iDjt'));
});
parcelRegister("cI0dp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8058a8d49035bb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4bcZr;
    var $kCMvS;
    var $ousew;
    var $8RXs9;
    var $8oG5R;
    var $3FqY6;
    var $k4hbD;
    var $c59Mn;
    var $fVnbM;
    var $c1tQw;
    var $1FaYJ;
    class $c8058a8d49035bb5$export$be28e1c115e337c7 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4bcZr")).EmptyState), {
                title: intl.formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_post_query_no_results_header),
                Image: (0, (0, parcelRequire("1FaYJ")).Image),
                content: this.getContent()
            });
        }
        constructor(...args){
            super(...args), this.onAdvancedSearchClicked = (e)=>{
                const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
                advancedSearchSelected({
                    trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                    actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).NO_RESULTS,
                    isLoading: false,
                    newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e)
                });
                onClick && onClick(advancedSearchUrl, e);
            }, this.getContent = ()=>{
                const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
                if (!hasFilters) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    role: "none",
                    onClick: this.onAdvancedSearchClicked
                }, isMultiSite || !advancedSearchUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).common_empty_state_body_no_advanced_search) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, (0, parcelRequire("c59Mn")).messages).quick_find_post_query_no_results_body,
                    values: {
                        SearchContentLink: (s)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kCMvS")).Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl
                            }, s)
                    }
                }));
                else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    tagName: "div",
                    ...(0, (0, parcelRequire("k4hbD")).messages).filters_applied
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1tQw")).ClearFiltersButtonWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "primary",
                    onClick: clearFilters
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).clear_filters))));
            };
        }
    }
    var $c8058a8d49035bb5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($c8058a8d49035bb5$export$be28e1c115e337c7);
});
parcelRegister("j4xTD", function(module, exports) {
    $parcel$export(module.exports, "AUTOCORRECT_API_PATH", ()=>$bbfab367b46fb33c$export$9e194549e403d7c0);
    $parcel$export(module.exports, "DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS", ()=>$bbfab367b46fb33c$export$8cc0d0855105f007);
    $parcel$export(module.exports, "isSupportedLanguage", ()=>$bbfab367b46fb33c$export$47c66070d6d6cd6d);
    $parcel$export(module.exports, "sanitizeLanguage", ()=>$bbfab367b46fb33c$export$2c7172743adddb3f);
    $parcel$export(module.exports, "shouldFetchAutocorrection", ()=>$bbfab367b46fb33c$export$68b44e0f3b4076e);
    $parcel$export(module.exports, "useAutocorrectionEnabled", ()=>$bbfab367b46fb33c$export$bf742519320d45e9);
    $parcel$export(module.exports, "fetchAutocorrection", ()=>$bbfab367b46fb33c$export$ac1bfa03f151bc79);
    var $koVbs;
    var $iCBcG = parcelRequire("iCBcG");
    var $dS9cn = parcelRequire("dS9cn");
    var $kv2Va;
    var $bbfab367b46fb33c$var$SUPPORTED_LANGUAGES;
    (function(SUPPORTED_LANGUAGES) {
        SUPPORTED_LANGUAGES["English"] = "en";
    })($bbfab367b46fb33c$var$SUPPORTED_LANGUAGES || ($bbfab367b46fb33c$var$SUPPORTED_LANGUAGES = {}));
    const $bbfab367b46fb33c$export$9e194549e403d7c0 = 'autocorrect';
    const $bbfab367b46fb33c$export$8cc0d0855105f007 = 250;
    const $bbfab367b46fb33c$export$47c66070d6d6cd6d = (language)=>{
        return Object.values($bbfab367b46fb33c$var$SUPPORTED_LANGUAGES).includes(language);
    };
    const $bbfab367b46fb33c$export$2c7172743adddb3f = (locale)=>{
        if (locale.includes('-')) return locale.split('-')[0];
        return locale;
    };
    const $bbfab367b46fb33c$export$68b44e0f3b4076e = (query)=>{
        return query.length >= 4;
    };
    const $bbfab367b46fb33c$export$bf742519320d45e9 = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const lang = $bbfab367b46fb33c$export$2c7172743adddb3f(locale);
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const product = getActiveProduct();
        return {
            autocorrectionEnabled: !!product?.autocorrectEnabled && $bbfab367b46fb33c$export$47c66070d6d6cd6d(lang),
            productId: product?.id || ''
        };
    };
    const $bbfab367b46fb33c$export$ac1bfa03f151bc79 = (0, ($parcel$interopDefault($iCBcG)))(({ query: query, aggregatorUrl: aggregatorUrl, lang: lang, cloudId: cloudId })=>{
        return (0, $dS9cn.utils).requestService({
            url: aggregatorUrl
        }, {
            path: `${$bbfab367b46fb33c$export$9e194549e403d7c0}`,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: query,
                    language: lang,
                    cloudId: cloudId
                })
            }
        });
    }, $bbfab367b46fb33c$export$8cc0d0855105f007);
});
parcelRegister("iCBcG", function(module, exports) {
    'use strict';
    module.exports = function debounce(fn) {
        var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var lastCallAt = void 0;
        var deferred = void 0;
        var timer = void 0;
        var pendingArgs = [];
        return function debounced() {
            var currentWait = $d8e8a274648ab511$var$getWait(wait);
            var currentTime = new Date().getTime();
            var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
            lastCallAt = currentTime;
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
                args
            ])).then(function(result) {
                return result[0];
            }) : Promise.resolve(fn.call.apply(fn, [
                this
            ].concat(args)));
            if (deferred) clearTimeout(timer);
            else deferred = $d8e8a274648ab511$var$defer();
            pendingArgs.push(args);
            timer = setTimeout(flush.bind(this), currentWait);
            if (options.accumulate) {
                var argsIndex = pendingArgs.length - 1;
                return deferred.promise.then(function(results) {
                    return results[argsIndex];
                });
            }
            return deferred.promise;
        };
        function flush() {
            var thisDeferred = deferred;
            clearTimeout(timer);
            Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
            pendingArgs = [];
            deferred = null;
        }
    };
    function $d8e8a274648ab511$var$getWait(wait) {
        return typeof wait === 'function' ? wait() : wait;
    }
    function $d8e8a274648ab511$var$defer() {
        var deferred = {};
        deferred.promise = new Promise(function(resolve, reject) {
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    }
});
parcelRegister("hyCj5", function(module, exports) {
    $parcel$export(module.exports, "QuickFindConfluenceTransformer", ()=>$b4e0a31d5cd30309$export$d1cc89207db04ec4);
    var $5uXOq = parcelRequire("5uXOq");
    var $jTmj1;
    var $5F6IF;
    var $7gTwf;
    var $fkSsY;
    var $4Cvc8;
    var $6NSru;
    const $b4e0a31d5cd30309$export$d1cc89207db04ec4 = ({ children: children, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jTmj1")).PreQueryFilterTransformer), rest, (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5F6IF")).PreQueryRecentlyViewedTransformer), args, (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7gTwf")).RecentSearchesTransformer), args, (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkSsY")).QueryFilterTransformer), args, (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Cvc8")).PostQueryRecentlyViewedTransformer), args, (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NSru")).DeduplicateRecentlyViewedAndResultsTransformer), args, (args)=>children(args)))))));
    };
});
parcelRegister("jTmj1", function(module, exports) {
    $parcel$export(module.exports, "PreQueryFilterTransformer", ()=>$0aca07f3068a99cf$export$eb528a71db3ec636);
    var $gGW0q;
    var $2dI5H;
    const $0aca07f3068a99cf$export$eb528a71db3ec636 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const filteredPreQuerySections = query ? preQueryItems.sections : preQueryItems.sections.filter((section)=>section.id !== (0, (0, parcelRequire("gGW0q")).RECENT_SPACES_SECTION_ID));
        const filteredPreQueryItems = {
            sections: filteredPreQuerySections,
            size: filteredPreQuerySections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0)
        };
        return children({
            preQueryItems: filteredPreQueryItems,
            postQueryItems: postQueryItems,
            productState: productState
        });
    };
});
parcelRegister("5F6IF", function(module, exports) {
    $parcel$export(module.exports, "PreQueryRecentlyViewedTransformer", ()=>$100a41540d6269e5$export$4cf1eef5109c47c9);
    var $8RXs9;
    var $c59Mn;
    var $5gpK9;
    const $100a41540d6269e5$export$8d431b8c84c2735b = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
        const newPreQueryItemsSections = preQueryItems.sections.map((section, i)=>{
            if (section.id === (0, (0, parcelRequire("5gpK9")).RECENT_SEARCHES_SECTION_ID) || section.searchResults.length === 0) return section;
            else {
                const newSection = {
                    ...section,
                    title: intl.formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_recently_viewed)
                };
                return newSection;
            }
        });
        preQueryItems.sections = newPreQueryItemsSections;
        return children({
            preQueryItems: preQueryItems,
            postQueryItems: postQueryItems,
            productState: productState
        });
    };
    const $100a41540d6269e5$export$4cf1eef5109c47c9 = (0, (0, parcelRequire("8RXs9")).default)($100a41540d6269e5$export$8d431b8c84c2735b);
});
parcelRegister("5gpK9", function(module, exports) {
    $parcel$export(module.exports, "RECENT_SEARCHES_SECTION_ID", ()=>$30106d69ed0c6a1b$export$6c90641783086ccb);
    $parcel$export(module.exports, "useRecentSearchesSection", ()=>$30106d69ed0c6a1b$export$e5468815b4eb37d);
    var $b2Pj5;
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $c59Mn;
    var $kv2Va;
    var $2dI5H;
    var $b3QDU;
    var $l431r;
    var $lywjH;
    var $7ttuB;
    var $3bJE0;
    const $30106d69ed0c6a1b$export$6c90641783086ccb = 'recent-searches';
    const $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY = 3;
    const $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY = 1;
    const $30106d69ed0c6a1b$export$e5468815b4eb37d = ()=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const { focusInput: focusInput } = (0, (0, parcelRequire("3bJE0")).useInputContext)();
        const { recentSearchItems: recentSearchItems, removeRecentSearch: removeRecentSearch } = (0, (0, parcelRequire("b3QDU")).useRecentSearches)({
            Icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l431r")).QuickFindIcon), null)
        });
        const recentSearches = recentSearchItems.map((result)=>({
                id: result.id,
                title: result.title,
                icon: result.icon,
                url: getActiveProduct()?.generateAdvancedSearchUrl?.(result.title) || '',
                meta: '',
                additionalMeta: query !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_recent_search_text_dialog) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_recent_search)
            }));
        const recentSearchesSection = (0, $5uXOq.useMemo)(()=>{
            return {
                id: $30106d69ed0c6a1b$export$6c90641783086ccb,
                title: '',
                searchResults: recentSearches,
                resultRenderer: ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted, isCollapsed: isCollapsed })=>{
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ttuB")).PersistRecentSearch), {
                        overrideQuery: searchResult.title
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2Pj5")).EnlargedSearchResultContent), {
                        ...searchResult,
                        icon: searchResult.icon,
                        isKeyboardHighlighted: isKeyboardHighlighted,
                        isCollapsed: isCollapsed,
                        isRecentSearch: true,
                        onRemove: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            removeRecentSearch(searchResult.title);
                            focusInput && focusInput();
                        },
                        displayAdditionalMetaWhenHighlightedOnly: query === ''
                    }));
                },
                resultLimit: query ? $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY : $30106d69ed0c6a1b$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY,
                useAnalyticsOverride: ({ screen: screen })=>(0, (0, parcelRequire("lywjH")).useSearchResultAnalyticsCallbacks)({
                        screen: screen,
                        actionSubject: 'recentSearch'
                    })
            };
        }, [
            query,
            recentSearches,
            removeRecentSearch,
            focusInput
        ]);
        return recentSearchesSection;
    };
});
parcelRegister("b3QDU", function(module, exports) {
    $parcel$export(module.exports, "useRecentSearches", ()=>$7d5696f9b254c3ec$export$d349a1b1b7874c14);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VoGI;
    var $033iF;
    var $kv2Va;
    var $3ewb4;
    var $8oG5R;
    const $7d5696f9b254c3ec$export$e0495117e49f394c = 50;
    const $7d5696f9b254c3ec$export$d349a1b1b7874c14 = ({ Icon: Icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ewb4")).DefaultIcon), null), limit: limit = $7d5696f9b254c3ec$export$e0495117e49f394c })=>{
        const { user: user } = (0, (0, parcelRequire("7VoGI")).useUserContext)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const product = getActiveProduct();
        const [recentSearchItems, setRecentSearchItems] = (0, $5uXOq.useState)([]);
        const memoizedIcon = (0, $5uXOq.useMemo)(()=>Icon, [
            Icon
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!product || !user.id) return;
            const recentSearches = (0, (0, parcelRequire("033iF")).getRecentSearches)(user.id, product.id, (0, (0, parcelRequire("033iF")).RECENT_SEARCH_KEY));
            const searchResults = recentSearches.map((value)=>({
                    id: (0, (0, parcelRequire("8oG5R")).sha256Hash)(value),
                    title: value,
                    icon: memoizedIcon
                }));
            if (recentSearchItems.length === 0 && searchResults.length > 0) setRecentSearchItems(searchResults);
        }, [
            product,
            user.id,
            memoizedIcon,
            recentSearchItems.length
        ]);
        const removeRecentSearch = (0, $5uXOq.useCallback)((query)=>{
            if (user?.id && product?.id) {
                const recentSearches = (0, (0, parcelRequire("033iF")).removeRecentSearch)(query, user.id, product.id, (0, (0, parcelRequire("033iF")).RECENT_SEARCH_KEY));
                if (recentSearches) {
                    const searchResults = recentSearches.map((value)=>({
                            id: (0, (0, parcelRequire("8oG5R")).sha256Hash)(value),
                            title: value,
                            icon: memoizedIcon
                        }));
                    setRecentSearchItems(searchResults);
                }
            }
        }, [
            product,
            user.id,
            memoizedIcon
        ]);
        return {
            recentSearchItems: recentSearchItems.slice(0, limit),
            removeRecentSearch: removeRecentSearch
        };
    };
});
parcelRegister("3ewb4", function(module, exports) {
    $parcel$export(module.exports, "DefaultIcon", ()=>$bddf1c2f5cf58373$export$d206ce4c12e8ddf6);
    var $5uXOq = parcelRequire("5uXOq");
    var $feC7X;
    var $bWGt6 = parcelRequire("bWGt6");
    function $bddf1c2f5cf58373$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bddf1c2f5cf58373$var$IconContainer = (0, $bWGt6.default)("span", {
        target: "eao5nkl0"
    })({
        name: "1kyddlo",
        styles: "margin-left:var(--ds-space-negative-025, -2px);margin-top:var(--ds-space-025, 2px)"
    });
    const $bddf1c2f5cf58373$export$d206ce4c12e8ddf6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($bddf1c2f5cf58373$var$IconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("feC7X"))))), {
            color: `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        }));
});
parcelRegister("feC7X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b175bd18e8763918$var$_react = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b175bd18e8763918$var$_clock = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("hyKRO")));
    var $b175bd18e8763918$var$_frequent = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("6uqJA")));
    function $b175bd18e8763918$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b175bd18e8763918$var$ClockIcon = (props)=>$b175bd18e8763918$var$_react.default.createElement($b175bd18e8763918$var$_clock.default, Object.assign({
            LEGACY_fallbackIcon: $b175bd18e8763918$var$_frequent.default
        }, props));
    $b175bd18e8763918$var$ClockIcon.Name = 'ClockIconMigration';
    var $b175bd18e8763918$var$_default = module.exports.default = $b175bd18e8763918$var$ClockIcon;
});
parcelRegister("6uqJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
    function $4b9a484973717fe2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>$4b9a484973717fe2$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
        }, props, {
            newIcon: $4b9a484973717fe2$var$_clock.default
        }));
    $4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
    var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;
});
parcelRegister("l431r", function(module, exports) {
    $parcel$export(module.exports, "QuickFindIcon", ()=>$5c0fbc733091b4c7$export$f5db5b3314f27023);
    var $5uXOq = parcelRequire("5uXOq");
    var $feC7X;
    var $bWGt6 = parcelRequire("bWGt6");
    const $5c0fbc733091b4c7$var$IconContainer = (0, $bWGt6.default)("span", {
        target: "e10r90tl0"
    })({
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-border-radius-400, 4px)",
        border: "'1px solid transparent'"
    });
    const $5c0fbc733091b4c7$export$f5db5b3314f27023 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($5c0fbc733091b4c7$var$IconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("feC7X"))))), {
            color: `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        }));
});
parcelRegister("7gTwf", function(module, exports) {
    $parcel$export(module.exports, "RecentSearchesTransformer", ()=>$b0c7bbcbd5e831f0$export$2142bc2fa441a5b0);
    var $5gpK9;
    const $b0c7bbcbd5e831f0$export$2142bc2fa441a5b0 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
        const recentSearchesSection = (0, (0, parcelRequire("5gpK9")).useRecentSearchesSection)();
        const preQueryItemsWithRecentSearches = {
            sections: [
                recentSearchesSection,
                ...preQueryItems.sections
            ],
            size: preQueryItems.size
        };
        return children({
            preQueryItems: preQueryItemsWithRecentSearches,
            postQueryItems: postQueryItems,
            productState: productState
        });
    };
});
parcelRegister("fkSsY", function(module, exports) {
    $parcel$export(module.exports, "QueryFilterTransformer", ()=>$f230ac300e4f3052$export$308bb2328bfeb2be);
    var $2dI5H;
    var $hkGQV;
    const $f230ac300e4f3052$var$RECENTLY_VIEWED_ITEMS_SHOWN = 10;
    const $f230ac300e4f3052$export$308bb2328bfeb2be = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const filteredPreQueryItems = (0, (0, parcelRequire("hkGQV")).filterAllSectionItems)({
            sections: preQueryItems.sections,
            size: preQueryItems.size
        }, query, $f230ac300e4f3052$var$RECENTLY_VIEWED_ITEMS_SHOWN);
        const highlightedPostQueryItems = (0, (0, parcelRequire("hkGQV")).highlightPostQueryResultTitles)(postQueryItems, query);
        return children({
            preQueryItems: filteredPreQueryItems,
            postQueryItems: highlightedPostQueryItems,
            productState: productState
        });
    };
});
parcelRegister("hkGQV", function(module, exports) {
    $parcel$export(module.exports, "filterFirstSectionItems", ()=>$991a69ad04863d88$export$c942155d15f72814);
    $parcel$export(module.exports, "filterAllSectionItems", ()=>$991a69ad04863d88$export$f48d35d3732436aa);
    $parcel$export(module.exports, "highlightPostQueryResultTitles", ()=>$991a69ad04863d88$export$630e09546900f38e);
    $parcel$export(module.exports, "mergeFirstSectionSearchItems", ()=>$991a69ad04863d88$export$c28e3f530240553c);
    var $lha1K;
    var $5gpK9;
    var $3JOCw = parcelRequire("3JOCw");
    const $991a69ad04863d88$export$c942155d15f72814 = (searchItems, query, numberOfResultItems = 3)=>{
        if (!searchItems.sections[0]) return searchItems;
        const filteredSearchResults = searchItems.sections[0].searchResults.filter((item)=>{
            return item.title.toLowerCase().includes(query.toLowerCase());
        }).slice(0, numberOfResultItems);
        return {
            size: filteredSearchResults.length,
            sections: [
                {
                    ...searchItems.sections[0],
                    searchResults: filteredSearchResults
                }
            ]
        };
    };
    const $991a69ad04863d88$export$f48d35d3732436aa = (searchItems, query, numberOfResultItems = 3)=>{
        if (query === '') return searchItems;
        const wordsInQuery = query.split(' ');
        const itemScoreMap = {};
        const filteredSearchSections = searchItems.sections.map((section)=>{
            return {
                ...section,
                searchResults: section.searchResults.map((item)=>{
                    const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
                        if (!acc) return acc;
                        return item.title.toLowerCase().includes(word.toLowerCase());
                    }, true);
                    if (doAllWordsMatch) {
                        const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, (0, parcelRequire("lha1K")).highlightMatchedText)(item.title, wordsInQuery);
                        itemScoreMap[item.id] = score;
                        return {
                            ...item,
                            highlightedTitle: section.id !== (0, (0, parcelRequire("5gpK9")).RECENT_SEARCHES_SECTION_ID) ? highlightedTitle : negatedHighlightedTitle
                        };
                    }
                    return null;
                }).filter((item)=>item).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.id] - itemScoreMap[item.id] : 0).slice(0, numberOfResultItems)
            };
        });
        const size = filteredSearchSections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0);
        return {
            size: size,
            sections: filteredSearchSections
        };
    };
    const $991a69ad04863d88$export$630e09546900f38e = (postQueryItems, query)=>{
        const wordsInQuery = query.split(' ');
        const highlightedSearchSections = postQueryItems.sections.map((section)=>{
            return {
                ...section,
                searchResults: section.searchResults.map((item)=>{
                    const { highlightedTitle: highlightedTitle } = (0, (0, parcelRequire("lha1K")).highlightMatchedText)(item.title, wordsInQuery);
                    return {
                        ...item,
                        highlightedTitle: highlightedTitle
                    };
                })
            };
        });
        return {
            size: postQueryItems.size,
            sections: highlightedSearchSections
        };
    };
    const $991a69ad04863d88$export$c28e3f530240553c = (intermediateSearchItems, postQuerySearchItems)=>{
        if (!intermediateSearchItems.sections[0] || intermediateSearchItems.sections[0]?.searchResults.length === 0) return postQuerySearchItems;
        if (!postQuerySearchItems.sections[0] || postQuerySearchItems.sections[0]?.searchResults.length === 0) return intermediateSearchItems;
        const fullMergedResultsList = [
            ...intermediateSearchItems.sections[0].searchResults.map((result)=>({
                    ...result,
                    isRecentResult: true
                })),
            ...postQuerySearchItems.sections[0].searchResults
        ];
        const deduplicatedList = (0, ($parcel$interopDefault($3JOCw)))(fullMergedResultsList, (item)=>item.id);
        const sections = [
            {
                ...postQuerySearchItems.sections[0],
                searchResults: deduplicatedList
            }
        ];
        return {
            size: sections.reduce((accumulator, currentElem)=>accumulator + currentElem.searchResults.length, 0),
            sections: sections
        };
    };
});
parcelRegister("lha1K", function(module, exports) {
    $parcel$export(module.exports, "highlightMatchedText", ()=>$0360f977acb1f130$export$9f4c92a576b56d82);
    const $0360f977acb1f130$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
    const $0360f977acb1f130$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
    const $0360f977acb1f130$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
    const $0360f977acb1f130$var$CONSECUTIVE_START_REGEX = new RegExp(`${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`, 'g');
    const $0360f977acb1f130$var$CONSECUTIVE_END_REGEX = new RegExp(`${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`, 'g');
    const $0360f977acb1f130$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`, 'g');
    const $0360f977acb1f130$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
    const $0360f977acb1f130$var$cleanStartRegex = new RegExp($0360f977acb1f130$var$HIGHLIGHT_START_TAG, 'g');
    const $0360f977acb1f130$var$cleanEndRegex = new RegExp($0360f977acb1f130$var$HIGHLIGHT_END_TAG, 'g');
    const $0360f977acb1f130$export$9f4c92a576b56d82 = (source, matchWords)=>{
        const cleanedSource = source.replace($0360f977acb1f130$var$cleanStartRegex, '').replace($0360f977acb1f130$var$cleanEndRegex, '');
        const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
        const wordsDetails = cleanedSource.split(' ').map((word)=>{
            const lowerCaseWord = word.toLowerCase();
            const alphabetOnlyWord = lowerCaseWord.replace($0360f977acb1f130$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
            let partialCount = 0;
            let startsWithCount = 0;
            let exactMatchCount = 0;
            let exactMatch = '';
            let partialMatch = '';
            let startsWithMatch = '';
            for(let i = 0; i < lowerCaseMatchWords.length; ++i){
                if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                    exactMatchCount++;
                    exactMatch = lowerCaseMatchWords[i];
                    break;
                }
                if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                    startsWithCount++;
                    startsWithMatch = lowerCaseMatchWords[i];
                    continue;
                }
                if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                    partialCount++;
                    partialMatch = lowerCaseMatchWords[i];
                }
            }
            const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
            if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
                const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
                const regExp = new RegExp(`(${pattern.replace($0360f977acb1f130$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
                const openingClosingRegExp = new RegExp(`(${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}|${$0360f977acb1f130$var$HIGHLIGHT_END_TAG})`, 'ig');
                const highlighted = word.replace(regExp, `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}$1${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`).replace($0360f977acb1f130$var$CONSECUTIVE_START_END_REGEX, ``);
                const mirror = {
                    [`${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`]: `${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`,
                    [`${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`]: `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`
                };
                const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
                const negatedHighlight = `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`.replace($0360f977acb1f130$var$CONSECUTIVE_START_REGEX, `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}`).replace($0360f977acb1f130$var$CONSECUTIVE_END_REGEX, `${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`).replace($0360f977acb1f130$var$CONSECUTIVE_START_END_REGEX, '');
                return {
                    highlighted: highlighted,
                    negatedHighlight: negatedHighlight,
                    score: score
                };
            }
            return {
                negatedHighlight: `${$0360f977acb1f130$var$HIGHLIGHT_START_TAG}${word}${$0360f977acb1f130$var$HIGHLIGHT_END_TAG}`,
                highlighted: word,
                score: score
            };
        });
        const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
        const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
        const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
        if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
            highlightedTitle: highlightedTitle,
            negatedHighlightedTitle: negatedHighlightedTitle,
            score: finalScore
        };
        return {};
    };
});
parcelRegister("4Cvc8", function(module, exports) {
    $parcel$export(module.exports, "PostQueryRecentlyViewedTransformer", ()=>$e80594c1acf5b2bc$export$1607c6754b1f6fc5);
    var $8RXs9;
    var $azBuE;
    var $c59Mn;
    var $5gpK9;
    const $e80594c1acf5b2bc$var$RECENTLY_VIEWED_ITEMS_SHOWN = 5;
    const $e80594c1acf5b2bc$var$PostQueryRecentlyViewedTransformerWithIntl = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
        let recentlyViewedCount = 0;
        const recentlyViewedSections = preQueryItems.sections.filter((section)=>section.id !== (0, (0, parcelRequire("5gpK9")).RECENT_SEARCHES_SECTION_ID)).filter((section)=>section.searchResults.length > 0).map((section, i)=>{
            const newSection = {
                ...section,
                resultLimit: Math.min(section.searchResults.length, $e80594c1acf5b2bc$var$RECENTLY_VIEWED_ITEMS_SHOWN - recentlyViewedCount),
                title: i === 0 ? intl.formatMessage((0, (0, parcelRequire("c59Mn")).messages).quick_find_recently_viewed) : ''
            };
            recentlyViewedCount = Math.min(recentlyViewedCount + section.searchResults.length, $e80594c1acf5b2bc$var$RECENTLY_VIEWED_ITEMS_SHOWN);
            return newSection;
        });
        const recentSearchesSection = preQueryItems.sections.find((section)=>section.id === (0, (0, parcelRequire("5gpK9")).RECENT_SEARCHES_SECTION_ID));
        const postQueryItemsSectionsWithRecentSearches = recentSearchesSection && productState === (0, (0, parcelRequire("azBuE")).ProductStates).PostQuerySuccess ? [
            ...postQueryItems.sections,
            recentSearchesSection
        ] : [
            ...postQueryItems.sections
        ];
        const postQueryItemsWithRecentlyViewed = {
            size: [
                ...recentlyViewedSections,
                ...postQueryItems.sections
            ].map((section)=>section.searchResults.length).reduce((a, b)=>a + b, 0),
            sections: [
                ...recentlyViewedSections,
                ...postQueryItemsSectionsWithRecentSearches
            ]
        };
        return children({
            preQueryItems: preQueryItems,
            postQueryItems: postQueryItemsWithRecentlyViewed,
            productState: productState
        });
    };
    const $e80594c1acf5b2bc$export$1607c6754b1f6fc5 = (0, (0, parcelRequire("8RXs9")).default)($e80594c1acf5b2bc$var$PostQueryRecentlyViewedTransformerWithIntl);
});
parcelRegister("6NSru", function(module, exports) {
    $parcel$export(module.exports, "DeduplicateRecentlyViewedAndResultsTransformer", ()=>$a143d1b989f5e8db$export$91b234728c3a1640);
    var $gGW0q;
    const $a143d1b989f5e8db$var$MAX_RENDERED_SEARCH_RESULTS = 5;
    const $a143d1b989f5e8db$export$91b234728c3a1640 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
        const searchResults = postQueryItems.sections.find((section)=>section.id === (0, (0, parcelRequire("gGW0q")).CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID))?.searchResults || [];
        const recentlyViewedResults = postQueryItems.sections.find((section)=>section.id === (0, (0, parcelRequire("gGW0q")).RECENT_ITEMS_SECTION_ID))?.searchResults || [];
        const dedupedSearchResults = searchResults.filter((searchResult)=>{
            const isDuplicate = recentlyViewedResults.some((recentlyViewedResult)=>recentlyViewedResult.ari === searchResult.ari);
            return searchResult.ari && !isDuplicate;
        });
        const postDeduplication = {
            ...postQueryItems,
            sections: postQueryItems.sections.map((section)=>{
                if (section.id === (0, (0, parcelRequire("gGW0q")).CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID)) return {
                    ...section,
                    searchResults: dedupedSearchResults.slice(0, $a143d1b989f5e8db$var$MAX_RENDERED_SEARCH_RESULTS)
                };
                return section;
            })
        };
        return children({
            preQueryItems: preQueryItems,
            postQueryItems: postDeduplication,
            productState: productState
        });
    };
});
parcelRegister("il5K0", function(module, exports) {
    $parcel$export(module.exports, "quickFindRecentItemResultMapper", ()=>$fee5fffed0f32421$export$1aadfab314f9e7ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $3kLdO;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $bE3Ky;
    var $c59Mn;
    var $bBlrR;
    var $7WTmq;
    var $iySxd;
    const $fee5fffed0f32421$var$CONTEXT_PATH = '/wiki';
    const $fee5fffed0f32421$var$labelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineStart: 'space.050'
    });
    const $fee5fffed0f32421$export$1aadfab314f9e7ce = (edge)=>{
        const item = edge.node;
        const productType = item.object.product;
        switch(productType){
            case (0, (0, parcelRequire("3kLdO")).QuickFindAllActivityDataEdgeNodeObjectProduct).JIRA:
                return {
                    id: item.object.id,
                    title: `${item.object.data?.key}: ${(item.object.data?.fieldsById?.edges || [
                        {}
                    ])[0].node?.text}` || '',
                    url: item.object.data?.webUrl || '',
                    icon: (0, (0, parcelRequire("bBlrR")).ContentIconRenderer)({
                        type: 'jira',
                        title: item.object.data?.title
                    }),
                    meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iySxd")).QuickFindResultMeta), {
                        meta: [
                            'Jira',
                            (0, (0, parcelRequire("iySxd")).capitalizeFirstLetter)(item.object.type)
                        ]
                    }),
                    additionalMeta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bE3Ky")).EventTypeMessage), {
                        timestamp: item.event.timestamp,
                        eventType: item.event.eventType
                    }),
                    isRecentResult: true,
                    type: `${item.object.product} ${item.object.type}`
                };
            case (0, (0, parcelRequire("3kLdO")).QuickFindAllActivityDataEdgeNodeObjectProduct).CONFLUENCE:
                const isDraft = (item.object.data?.pageStatus === 'DRAFT' || item.object.data?.blogStatus === 'DRAFT') && item.object.data?.subtype !== 'LIVE';
                return {
                    ari: item.object.id,
                    id: item.object.id,
                    title: item.object.data?.title || '',
                    url: `${item.object.data?.links?.base || $fee5fffed0f32421$var$CONTEXT_PATH}${item.object.data?.links?.webUi}`,
                    icon: (0, (0, parcelRequire("bBlrR")).ContentIconRenderer)({
                        type: item.object.type,
                        title: item.object.data?.title,
                        isDraft: isDraft
                    }),
                    label: isDraft ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $fee5fffed0f32421$var$labelStyles,
                        as: "span"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_recent_draft_label))) : '',
                    meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7WTmq")).ConfluenceResultMeta), {
                        resultContentType: item.object.type,
                        resultAncestors: item.object.data?.ancestors,
                        resultSpace: item.object.data?.space
                    }),
                    additionalMeta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bE3Ky")).EventTypeMessage), {
                        timestamp: item.event.timestamp,
                        eventType: item.event.eventType
                    }),
                    isRecentResult: true,
                    type: `${item.object.product} ${item.object.type}`,
                    containerId: item.object.data?.space?.id || undefined
                };
            case (0, (0, parcelRequire("3kLdO")).QuickFindAllActivityDataEdgeNodeObjectProduct).ATLAS:
                return {
                    id: item.object.id,
                    title: `${item.object.data?.name}` || '',
                    url: item.object.data?.url || '',
                    icon: (0, (0, parcelRequire("bBlrR")).ContentIconRenderer)({
                        type: 'atlas',
                        imageSrc: item.object.data?.iconData || '',
                        title: item.object.data?.title
                    }),
                    meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iySxd")).QuickFindResultMeta), {
                        meta: [
                            (0, (0, parcelRequire("iySxd")).capitalizeFirstLetter)(item.object.type),
                            item.object.data?.key
                        ]
                    }),
                    additionalMeta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bE3Ky")).EventTypeMessage), {
                        timestamp: item.event.timestamp,
                        eventType: item.event.eventType
                    }),
                    isRecentResult: true,
                    type: `${item.object.product} ${item.object.type}`
                };
            default:
                return {
                    id: '',
                    title: '',
                    url: '',
                    icon: '',
                    meta: ''
                };
        }
    };
});
parcelRegister("3kLdO", function(module, exports) {
    $parcel$export(module.exports, "QuickFindAllActivityDataEdgeNodeObjectProduct", ()=>$b20780cd62bfa3ab$export$790b2750b9190c2a);
    var $b20780cd62bfa3ab$export$790b2750b9190c2a;
    (function(QuickFindAllActivityDataEdgeNodeObjectProduct) {
        QuickFindAllActivityDataEdgeNodeObjectProduct["JIRA"] = "jira";
        QuickFindAllActivityDataEdgeNodeObjectProduct["CONFLUENCE"] = "confluence";
        QuickFindAllActivityDataEdgeNodeObjectProduct["ATLAS"] = "townsquare";
    })($b20780cd62bfa3ab$export$790b2750b9190c2a || ($b20780cd62bfa3ab$export$790b2750b9190c2a = {}));
    var $b20780cd62bfa3ab$export$d245b105c09339d8;
    (function(VIEWED_EVENT) {
        VIEWED_EVENT["VIEWED"] = "viewed";
    })($b20780cd62bfa3ab$export$d245b105c09339d8 || ($b20780cd62bfa3ab$export$d245b105c09339d8 = {}));
    var $b20780cd62bfa3ab$export$eb4e9f525aef1cc3;
    (function(WORKED_EVENT) {
        WORKED_EVENT["COMMENTED"] = "commented";
        WORKED_EVENT["CREATED"] = "created";
        WORKED_EVENT["EDITED"] = "edited";
        WORKED_EVENT["PUBLISHED"] = "published";
        WORKED_EVENT["UPDATED"] = "updated";
    })($b20780cd62bfa3ab$export$eb4e9f525aef1cc3 || ($b20780cd62bfa3ab$export$eb4e9f525aef1cc3 = {}));
});
parcelRegister("bE3Ky", function(module, exports) {
    $parcel$export(module.exports, "WORKED_EVENT", ()=>$50c2ee22ee222e6f$export$eb4e9f525aef1cc3);
    $parcel$export(module.exports, "EventTypeMessage", ()=>$50c2ee22ee222e6f$export$9e4fb3fb50a3c754);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $2tElP;
    var $kUxFz;
    var $it1wb;
    var $4PxOH;
    var $30tN5;
    var $fsGYp;
    var $50c2ee22ee222e6f$export$d245b105c09339d8;
    (function(VIEWED_EVENT) {
        VIEWED_EVENT["VIEWED"] = "viewed";
    })($50c2ee22ee222e6f$export$d245b105c09339d8 || ($50c2ee22ee222e6f$export$d245b105c09339d8 = {}));
    var $50c2ee22ee222e6f$export$eb4e9f525aef1cc3;
    (function(WORKED_EVENT) {
        WORKED_EVENT["COMMENTED"] = "commented";
        WORKED_EVENT["CREATED"] = "created";
        WORKED_EVENT["EDITED"] = "edited";
        WORKED_EVENT["PUBLISHED"] = "published";
        WORKED_EVENT["UPDATED"] = "updated";
    })($50c2ee22ee222e6f$export$eb4e9f525aef1cc3 || ($50c2ee22ee222e6f$export$eb4e9f525aef1cc3 = {}));
    function $50c2ee22ee222e6f$export$e873c799b137eec4(date) {
        return (0, (0, parcelRequire("kUxFz")).default)(new Date(date), $50c2ee22ee222e6f$var$startOfOneWeekAgo());
    }
    function $50c2ee22ee222e6f$var$startOfOneWeekAgo() {
        return (0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("4PxOH")).default)(new Date(), 1));
    }
    const $50c2ee22ee222e6f$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData = true })=>{
        const isAbsolute = $50c2ee22ee222e6f$export$e873c799b137eec4(timestamp);
        const message = (0, (0, parcelRequire("fsGYp")).useEventTypeMessage)(eventType, {
            isMyActivityData: isMyActivityData,
            isAbsolute: isAbsolute
        });
        const { value: value, unit: unit } = (0, (0, parcelRequire("30tN5")).selectUnit)(new Date(timestamp).getTime(), new Date(), {
            day: 7
        });
        const values = isAbsolute ? {
            absoluteTime: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
                value: timestamp,
                month: "short",
                day: "2-digit",
                year: "numeric"
            })
        } : {
            relativeTime: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
                value: value,
                unit: unit
            })
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...message,
            values: values
        });
    };
});
parcelRegister("30tN5", function(module, exports) {
    $parcel$export(module.exports, "selectUnit", ()=>$eb796f916e517007$export$b8f7189986dd5395);
    const $eb796f916e517007$var$MS_PER_SECOND = 1e3;
    const $eb796f916e517007$var$SECS_PER_MIN = 60;
    const $eb796f916e517007$var$SECS_PER_HOUR = $eb796f916e517007$var$SECS_PER_MIN * 60;
    const $eb796f916e517007$var$SECS_PER_DAY = $eb796f916e517007$var$SECS_PER_HOUR * 24;
    const $eb796f916e517007$var$SECS_PER_WEEK = $eb796f916e517007$var$SECS_PER_DAY * 7;
    function $eb796f916e517007$export$b8f7189986dd5395(from, to = Date.now(), thresholds = {}) {
        const resolvedThresholds = {
            ...$eb796f916e517007$export$f4fd60e41371f80d,
            ...thresholds || {}
        };
        const secs = (+from - +to) / $eb796f916e517007$var$MS_PER_SECOND;
        if (Math.abs(secs) < resolvedThresholds.second) return {
            value: Math.round(secs),
            unit: 'second'
        };
        const mins = secs / $eb796f916e517007$var$SECS_PER_MIN;
        if (Math.abs(mins) < resolvedThresholds.minute) return {
            value: Math.round(mins),
            unit: 'minute'
        };
        const hours = secs / $eb796f916e517007$var$SECS_PER_HOUR;
        if (Math.abs(hours) < resolvedThresholds.hour) return {
            value: Math.round(hours),
            unit: 'hour'
        };
        const days = secs / $eb796f916e517007$var$SECS_PER_DAY;
        if (Math.abs(days) < resolvedThresholds.day) return {
            value: Math.round(days),
            unit: 'day'
        };
        const weeks = secs / $eb796f916e517007$var$SECS_PER_WEEK;
        return {
            value: Math.round(weeks),
            unit: 'week'
        };
    }
    const $eb796f916e517007$export$f4fd60e41371f80d = {
        second: 45,
        minute: 45,
        hour: 22,
        day: 5
    };
});
parcelRegister("fsGYp", function(module, exports) {
    $parcel$export(module.exports, "WrappedRecentWorkEventTypeMessagesProvider", ()=>$7e590f3611eefa6e$export$779009172d654787);
    $parcel$export(module.exports, "useEventTypeMessage", ()=>$7e590f3611eefa6e$export$7948ea9187af6c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $54yUM;
    var $jxobG;
    const $7e590f3611eefa6e$export$613b94bf89cb511d = (0, $5uXOq.createContext)({
        eventTypeMessages: (0, (0, parcelRequire("jxobG")).LOCAL_EVENT_TYPE_MESSAGES)
    });
    function $7e590f3611eefa6e$export$63b523c1d6b0c2f4({ children: children, locale: locale }) {
        const artifact = (0, (0, parcelRequire("54yUM")).useRecentWorkArtifact)(locale);
        const providerValue = (0, $5uXOq.useMemo)(()=>({
                eventTypeMessages: (0, (0, parcelRequire("jxobG")).LOCAL_EVENT_TYPE_MESSAGES),
                eventTypeMessagesTranslated: (0, (0, parcelRequire("jxobG")).translatedStringsToMessageDescriptors)(artifact?.localization.eventTypes)
            }), [
            artifact
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7e590f3611eefa6e$export$613b94bf89cb511d.Provider, {
            value: providerValue
        }, children);
    }
    function $7e590f3611eefa6e$export$779009172d654787({ children: children }) {
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7e590f3611eefa6e$export$63b523c1d6b0c2f4, {
            locale: locale
        }, children);
    }
    const $7e590f3611eefa6e$export$ddd7b41a8fb59ad6 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($7e590f3611eefa6e$export$613b94bf89cb511d);
    function $7e590f3611eefa6e$export$7948ea9187af6c9(eventType, options = {}) {
        const { eventTypeMessages: eventTypeMessages, eventTypeMessagesTranslated: translatedMessagesMap } = $7e590f3611eefa6e$export$ddd7b41a8fb59ad6();
        return (0, (0, parcelRequire("jxobG")).messageForEventType)(eventType, translatedMessagesMap || eventTypeMessages, options);
    }
});
parcelRegister("54yUM", function(module, exports) {
    $parcel$export(module.exports, "useRecentWorkArtifact", ()=>$94c556438de1cbd7$export$9c10d80bcd5b4264);
    var $5uXOq = parcelRequire("5uXOq");
    var $btDaU;
    var $3LJ9C;
    const $94c556438de1cbd7$export$9c10d80bcd5b4264 = (locale)=>{
        const dimensions = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("3LJ9C")).FD_CLIENT_FETCH_PROPS).dimensions,
                locale: locale
            }), [
            locale
        ]);
        return (0, (0, parcelRequire("btDaU")).useFlightDeckArtifact)((0, (0, parcelRequire("3LJ9C")).FD_CLIENT_FETCH_PROPS).name, dimensions);
    };
});
parcelRegister("jxobG", function(module, exports) {
    $parcel$export(module.exports, "LOCAL_EVENT_TYPE_MESSAGES", ()=>$c2569fc67eab27ad$export$be5e766167e613a9);
    $parcel$export(module.exports, "messageForEventType", ()=>$c2569fc67eab27ad$export$d3dc5798f9d19382);
    $parcel$export(module.exports, "translatedStringsToMessageDescriptors", ()=>$c2569fc67eab27ad$export$ba0d5bdc49112491);
    var $2YGrx;
    const $c2569fc67eab27ad$export$be5e766167e613a9 = {
        commented: (0, (0, parcelRequire("2YGrx")).commentedEventTypeMessages),
        created: (0, (0, parcelRequire("2YGrx")).createdEventTypeMessages),
        edited: (0, (0, parcelRequire("2YGrx")).editedEventTypeMessages),
        published: (0, (0, parcelRequire("2YGrx")).publishedEventTypeMessages),
        updated: (0, (0, parcelRequire("2YGrx")).updatedEventTypeMessages),
        viewed: (0, (0, parcelRequire("2YGrx")).viewedEventTypeMessages)
    };
    function $c2569fc67eab27ad$export$d3dc5798f9d19382(eventType, eventTypeMessages = $c2569fc67eab27ad$export$be5e766167e613a9, options = {}) {
        const { isAbsolute: isAbsolute = true, isMyActivityData: isMyActivityData = true, isSimple: isSimple = false } = options;
        const eventTypeMessage = eventTypeMessages.hasOwnProperty(eventType) ? eventTypeMessages[eventType] : (0, (0, parcelRequire("2YGrx")).defaultEventTypeMessages);
        if (isSimple) {
            if (isMyActivityData) return eventTypeMessage.standalone;
            else return eventTypeMessage.multiStandalone;
        } else {
            if (isMyActivityData && isAbsolute) return eventTypeMessage.absolute;
            else if (isMyActivityData && !isAbsolute) return eventTypeMessage.relative;
            else if (!isMyActivityData && isAbsolute) return eventTypeMessage.multiAbsolute;
            else return eventTypeMessage.multiRelative;
        }
    }
    function $c2569fc67eab27ad$export$ba0d5bdc49112491(translatedStrings) {
        if (!translatedStrings) return undefined;
        return Object.entries(translatedStrings).reduce((acc, [eventType, translatedMessages])=>{
            acc[eventType] = Object.entries(translatedMessages).reduce((eventTypeMessages, [translatedKey, translatedEntry])=>{
                eventTypeMessages[translatedKey] = {
                    defaultMessage: translatedEntry,
                    id: `recentWork.eventTypeMessage.translated.${translatedKey}.no-translate`
                };
                return eventTypeMessages;
            }, {});
            return acc;
        }, {});
    }
});
parcelRegister("2YGrx", function(module, exports) {
    $parcel$export(module.exports, "commentedEventTypeMessages", ()=>$1668b2c18bde6139$export$29c048cc57fefaf8);
    $parcel$export(module.exports, "createdEventTypeMessages", ()=>$1668b2c18bde6139$export$99e7e287b0f1db7);
    $parcel$export(module.exports, "editedEventTypeMessages", ()=>$1668b2c18bde6139$export$4d0c20aef6601783);
    $parcel$export(module.exports, "publishedEventTypeMessages", ()=>$1668b2c18bde6139$export$2cd1ec4decb563bb);
    $parcel$export(module.exports, "updatedEventTypeMessages", ()=>$1668b2c18bde6139$export$3b389551d0b5bf03);
    $parcel$export(module.exports, "viewedEventTypeMessages", ()=>$1668b2c18bde6139$export$2d3fe6e7f84a868e);
    $parcel$export(module.exports, "defaultEventTypeMessages", ()=>$1668b2c18bde6139$export$9be55d016b768442);
    var $7VHMR;
    const $1668b2c18bde6139$export$29c048cc57fefaf8 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You commented on {absoluteTime}',
            description: 'action taken on this object with absolute timestamp - comment added',
            id: 'recentWork.eventTypeMessage.absolute.commented'
        },
        relative: {
            defaultMessage: 'You commented {relativeTime}',
            description: 'action taken by the user on this object with relative timestamp - comment added',
            id: 'recentWork.eventTypeMessage.relative.commented'
        },
        standalone: {
            defaultMessage: 'You commented',
            description: 'action taken by the user on this object - comment added',
            id: 'recentWork.eventTypeMessage.commented'
        },
        multiAbsolute: {
            defaultMessage: 'Commented on {absoluteTime}',
            description: 'action taken by the user on this object with absolute timestamp - comment added',
            id: 'recentWork.eventTypeMessage.multi.absolute.commented'
        },
        multiRelative: {
            defaultMessage: 'Commented {relativeTime}',
            description: 'action taken on this object with relative timestamp - comment added',
            id: 'recentWork.eventTypeMessage.multi.relative.commented'
        },
        multiStandalone: {
            defaultMessage: 'Commented',
            description: 'action taken on this object - comment added',
            id: 'recentWork.eventTypeMessage.multi.commented'
        }
    });
    const $1668b2c18bde6139$export$99e7e287b0f1db7 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You created on {absoluteTime}',
            description: 'action taken by the user on this object with absolute timestamp - initially created',
            id: 'recentWork.eventTypeMessage.absolute.created'
        },
        relative: {
            defaultMessage: 'You created {relativeTime}',
            description: 'action taken by the user on this object with relative timestamp - initially created',
            id: 'recentWork.eventTypeMessage.relative.created'
        },
        standalone: {
            defaultMessage: 'You created',
            description: 'action taken by the user on this object - initially created',
            id: 'recentWork.eventTypeMessage.created'
        },
        multiAbsolute: {
            defaultMessage: 'Created on {absoluteTime}',
            description: 'action taken on this object with absolute timestamp - initially created',
            id: 'recentWork.eventTypeMessage.multi.absolute.created'
        },
        multiRelative: {
            defaultMessage: 'Created {relativeTime}',
            description: 'action taken on this object with relative timestamp - initially created',
            id: 'recentWork.eventTypeMessage.multi.relative.created'
        },
        multiStandalone: {
            defaultMessage: 'Created',
            description: 'action taken on this object - initially created',
            id: 'recentWork.eventTypeMessage.multi.created'
        }
    });
    const $1668b2c18bde6139$export$4d0c20aef6601783 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You edited on {absoluteTime}',
            description: 'action taken by the user on this object with absolute timestamp - edited',
            id: 'recentWork.eventTypeMessage.absolute.edited'
        },
        relative: {
            defaultMessage: 'You edited {relativeTime}',
            description: 'action taken by the user on this object with relative timestamp - edited',
            id: 'recentWork.eventTypeMessage.relative.edited'
        },
        standalone: {
            defaultMessage: 'You edited',
            description: 'action taken by the user on this object - edited',
            id: 'recentWork.eventTypeMessage.edited'
        },
        multiAbsolute: {
            defaultMessage: 'Edited on {absoluteTime}',
            description: 'action taken on this object with absolute timestamp - edited',
            id: 'recentWork.eventTypeMessage.multi.absolute.edited'
        },
        multiRelative: {
            defaultMessage: 'Edited {relativeTime}',
            description: 'action taken on this object with relative timestamp - edited',
            id: 'recentWork.eventTypeMessage.multi.relative.edited'
        },
        multiStandalone: {
            defaultMessage: 'Edited',
            description: 'action taken on this object - edited',
            id: 'recentWork.eventTypeMessage.multi.edited'
        }
    });
    const $1668b2c18bde6139$export$2cd1ec4decb563bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You published on {absoluteTime}',
            description: 'action taken by the user on this object with absolute timestamp - published',
            id: 'recentWork.eventTypeMessage.absolute.published'
        },
        relative: {
            defaultMessage: 'You published {relativeTime}',
            description: 'action taken by the user on this object with relative timestamp - published',
            id: 'recentWork.eventTypeMessage.relative.published'
        },
        standalone: {
            defaultMessage: 'You published',
            description: 'action taken by the user on this object - published',
            id: 'recentWork.eventTypeMessage.published'
        },
        multiAbsolute: {
            defaultMessage: 'Published on {absoluteTime}',
            description: 'action taken on this object with absolute timestamp - published',
            id: 'recentWork.eventTypeMessage.multi.absolute.published'
        },
        multiRelative: {
            defaultMessage: 'Published {relativeTime}',
            description: 'action taken on this object with relative timestamp - published',
            id: 'recentWork.eventTypeMessage.multi.relative.published'
        },
        multiStandalone: {
            defaultMessage: 'Published',
            description: 'action taken on this object - published',
            id: 'recentWork.eventTypeMessage.multi.published'
        }
    });
    const $1668b2c18bde6139$export$3b389551d0b5bf03 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You updated on {absoluteTime}',
            description: 'action taken by the user on this object with absolute timestamp - updated',
            id: 'recentWork.eventTypeMessage.absolute.updated'
        },
        relative: {
            defaultMessage: 'You updated {relativeTime}',
            description: 'action taken by the user on this object with relative timestamp - updated',
            id: 'recentWork.eventTypeMessage.relative.updated'
        },
        standalone: {
            defaultMessage: 'You updated',
            description: 'action taken by the user on this object - updated',
            id: 'recentWork.eventTypeMessage.updated'
        },
        multiAbsolute: {
            defaultMessage: 'Updated on {absoluteTime}',
            description: 'action taken on this object with absolute timestamp - updated',
            id: 'recentWork.eventTypeMessage.multi.absolute.updated'
        },
        multiRelative: {
            defaultMessage: 'Updated {relativeTime}',
            description: 'action taken on this object with relative timestamp - updated',
            id: 'recentWork.eventTypeMessage.multi.relative.updated'
        },
        multiStandalone: {
            defaultMessage: 'Updated',
            description: 'action taken on this object - updated',
            id: 'recentWork.eventTypeMessage.multi.updated'
        }
    });
    const $1668b2c18bde6139$export$2d3fe6e7f84a868e = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You viewed on {absoluteTime}',
            description: 'action taken by the user on this object with absolute timestamp - viewed',
            id: 'recentWork.eventTypeMessage.absolute.viewed'
        },
        relative: {
            defaultMessage: 'You viewed {relativeTime}',
            description: 'action taken by the user on this object with relative timestamp - viewed',
            id: 'recentWork.eventTypeMessage.relative.viewed'
        },
        standalone: {
            defaultMessage: 'You viewed',
            description: 'action taken by the user on this object - viewed',
            id: 'recentWork.eventTypeMessage.viewed'
        },
        multiAbsolute: {
            defaultMessage: 'Viewed on {absoluteTime}',
            description: 'action taken on this object with absolute timestamp - viewed',
            id: 'recentWork.eventTypeMessage.multi.absolute.viewed'
        },
        multiRelative: {
            defaultMessage: 'Viewed {relativeTime}',
            description: 'action taken on this object with relative timestamp - viewed',
            id: 'recentWork.eventTypeMessage.multi.relative.viewed'
        },
        multiStandalone: {
            defaultMessage: 'Viewed',
            description: 'action taken on this object - viewed',
            id: 'recentWork.eventTypeMessage.multi.viewed'
        }
    });
    const $1668b2c18bde6139$export$9be55d016b768442 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        absolute: {
            defaultMessage: 'You worked on {absoluteTime}',
            description: 'action taken by the user on this object with an absolute or relative date/time - worked on',
            id: 'recentWork.eventTypeMessage.absolute.workedOn'
        },
        relative: {
            defaultMessage: 'You worked on {relativeTime}',
            description: 'action taken by the user on this object with an absolute or relative date/time - worked on',
            id: 'recentWork.eventTypeMessage.absolute.workedOn'
        },
        standalone: {
            defaultMessage: 'You worked on',
            description: 'action taken by the user on this object - worked on',
            id: 'recentWork.eventTypeMessage.workedOn'
        },
        multiAbsolute: {
            defaultMessage: 'Worked on {absoluteTime}',
            description: 'action taken on this object with an absolute or relative date/time - worked on',
            id: 'recentWork.eventTypeMessage.multi.absolute.workedOn'
        },
        multiRelative: {
            defaultMessage: 'Worked on {relativeTime}',
            description: 'action taken on this object with an absolute or relative date/time - worked on',
            id: 'recentWork.eventTypeMessage.multi.dateTime.workedOn'
        },
        multiStandalone: {
            defaultMessage: 'Worked on',
            description: 'action taken on this object - worked on',
            id: 'recentWork.eventTypeMessage.multi.workedOn'
        }
    });
});
parcelRegister("bBlrR", function(module, exports) {
    $parcel$export(module.exports, "ContentIconRenderer", ()=>$50357333f14de355$export$bf56fa242f0fc37d);
    $parcel$export(module.exports, "GenericIconRenderer", ()=>$50357333f14de355$export$e5d849fb708254a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $ujWmd;
    var $jB3w5;
    var $2UiHO;
    var $h5fUN;
    var $9xuGL;
    var $bFmnZ;
    var $4sHZ9;
    var $kdfZa;
    var $01Hwk;
    var $cwmS5;
    const $50357333f14de355$var$negativeMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.negative.025',
        display: 'flex'
    });
    const $50357333f14de355$var$iconTypes = {
        ATLAS: 'atlas',
        ATTACHMENT: 'attachment',
        BLOGPOST: 'blogpost',
        COMMENT: 'comment',
        CONTENT: 'content',
        CONFLUENCEBLOGPOST: 'confluence-blogpost',
        CONFLUENCEPAGE: 'confluence-page',
        DATABASE: 'database',
        FOLDER: 'folder',
        JIRA: 'jira',
        PAGE: 'page',
        WHITEBOARD: 'whiteboard'
    };
    const $50357333f14de355$var$iconStyles = {
        BLUE: 'blue',
        GRAY: 'gray',
        PURPLE: 'purple',
        SHAPE: 'square',
        SIZE: '24',
        TEAL: 'teal',
        YELLOW: 'yellow'
    };
    const $50357333f14de355$export$bf56fa242f0fc37d = ({ type: type, imageSrc: imageSrc, title: title, isDraft: isDraft = false })=>{
        if (type === $50357333f14de355$var$iconTypes.PAGE || type === $50357333f14de355$var$iconTypes.CONFLUENCEPAGE || type === $50357333f14de355$var$iconTypes.CONTENT) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("kdfZa"))))),
            label: type,
            appearance: isDraft ? $50357333f14de355$var$iconStyles.GRAY : $50357333f14de355$var$iconStyles.BLUE,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        else if (type === $50357333f14de355$var$iconTypes.BLOGPOST || type === $50357333f14de355$var$iconTypes.CONFLUENCEBLOGPOST) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2UiHO"))))),
            label: type,
            appearance: $50357333f14de355$var$iconStyles.BLUE,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        else if (type === $50357333f14de355$var$iconTypes.DATABASE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("4sHZ9"))))),
            label: type,
            appearance: $50357333f14de355$var$iconStyles.PURPLE,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        else if (type === $50357333f14de355$var$iconTypes.FOLDER) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("9xuGL"))))),
            label: type,
            appearance: $50357333f14de355$var$iconStyles.BLUE,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        else if (type === $50357333f14de355$var$iconTypes.WHITEBOARD) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("h5fUN"))))),
            label: type,
            appearance: $50357333f14de355$var$iconStyles.TEAL,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        else if (type === $50357333f14de355$var$iconTypes.COMMENT) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))),
            label: type,
            appearance: $50357333f14de355$var$iconStyles.YELLOW,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        else if (type === $50357333f14de355$var$iconTypes.ATTACHMENT) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("01Hwk")).AttachmentIcon), {
            title: title || '',
            size: "medium",
            label: type
        });
        else if (type === $50357333f14de355$var$iconTypes.ATLAS) return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            width: "24px",
            height: "24px",
            src: imageSrc || '',
            "aria-label": type,
            alt: type
        });
        else if (type === $50357333f14de355$var$iconTypes.JIRA) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jB3w5"))))),
            label: type,
            appearance: $50357333f14de355$var$iconStyles.BLUE,
            shape: $50357333f14de355$var$iconStyles.SHAPE,
            size: $50357333f14de355$var$iconStyles.SIZE
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null);
    };
    const $50357333f14de355$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $50357333f14de355$var$negativeMarginStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        }));
});
parcelRegister("jB3w5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e44433503bdca276$var$_react = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e44433503bdca276$var$_UNSAFE_baseNew = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e44433503bdca276$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e44433503bdca276$var$IssueIcon = (props)=>$e44433503bdca276$var$_react.default.createElement($e44433503bdca276$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m5 7.875 2 2.375 4-4.75m-9 7.75h12c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $e44433503bdca276$var$IssueIcon.displayName = 'IssueIcon';
    var $e44433503bdca276$var$_default = module.exports.default = $e44433503bdca276$var$IssueIcon;
});
parcelRegister("2UiHO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $21df524c58bafc58$var$_UNSAFE_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $21df524c58bafc58$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>$21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 13.25A3.25 3.25 0 0 0 6.25 10V8.25m0 0V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v3c0 .69.56 1.25 1.25 1.25zm9 0V4c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25zm0 0V10A3.25 3.25 0 0 1 12 13.25"/>`
        }, props));
    $21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
    var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;
});
parcelRegister("h5fUN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6ff3fae3688d83c$var$_react = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c6ff3fae3688d83c$var$_UNSAFE_baseNew = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c6ff3fae3688d83c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6ff3fae3688d83c$var$WhiteboardIcon = (props)=>$c6ff3fae3688d83c$var$_react.default.createElement($c6ff3fae3688d83c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7 3.284C7.52 1.68 10.122.61 11.163 1.68c1.84 1.89-4.659 4.45-.52 3.742 3.122-.535 4.527 1.44 2.966 3.578M6.75 7.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3.5 1.5-3 5h6z"/>`
        }, props));
    $c6ff3fae3688d83c$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
    var $c6ff3fae3688d83c$var$_default = module.exports.default = $c6ff3fae3688d83c$var$WhiteboardIcon;
});
parcelRegister("bFmnZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87e4e36d6c115ce9$var$_UNSAFE_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87e4e36d6c115ce9$var$CommentIcon = (props)=>$87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
        }, props));
    $87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
    var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;
});
parcelRegister("4sHZ9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $33fbe57d5c4f37e3$var$_react = $33fbe57d5c4f37e3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $33fbe57d5c4f37e3$var$_UNSAFE_baseNew = $33fbe57d5c4f37e3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $33fbe57d5c4f37e3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $33fbe57d5c4f37e3$var$DatabaseIcon = (props)=>$33fbe57d5c4f37e3$var$_react.default.createElement($33fbe57d5c4f37e3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 7.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v4.25m-12.5 0H8m-6.25 0v3.5m12.5-3.5H8m6.25 0v3.5M8 7.25v3.5m0 3.5h5c.69 0 1.25-.56 1.25-1.25v-2.25M8 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25M8 14.25v-3.5m0 0h6.25m-6.25 0H1.75"/>`
        }, props));
    $33fbe57d5c4f37e3$var$DatabaseIcon.displayName = 'DatabaseIcon';
    var $33fbe57d5c4f37e3$var$_default = module.exports.default = $33fbe57d5c4f37e3$var$DatabaseIcon;
});
parcelRegister("kdfZa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb716bf3c984513d$var$_UNSAFE_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb716bf3c984513d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb716bf3c984513d$var$PageIcon = (props)=>$eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
    var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;
});
parcelRegister("01Hwk", function(module, exports) {
    $parcel$export(module.exports, "AttachmentIcon", ()=>$fdf17f1c79e5d780$export$edc04f92718bbea4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8njZH;
    var $9CRO6;
    var $dOkKo;
    var $lBSka;
    var $eABwY;
    var $7zjHG;
    var $7BHMh;
    var $jGmM2;
    var $96Idm;
    var $RiK2l;
    var $daL8e;
    var $dg1MW;
    var $5m93C;
    var $2tm8x;
    var $kKp2J;
    var $cHwqN;
    var $6cEsd;
    var $gYsK7;
    var $lDRqn;
    var $b7OK3;
    var $im5Hg;
    var $2sfBf;
    const $fdf17f1c79e5d780$var$AttachmentFileExtensionMatchers = [
        {
            regexp: /\.(pdf)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("5m93C"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("2tm8x")))))
            ]
        },
        {
            regexp: /\.(gif)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("96Idm"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("RiK2l")))))
            ]
        },
        {
            regexp: /\.(jpeg|jpg|png)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("daL8e"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("dg1MW")))))
            ]
        },
        {
            regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("6cEsd"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("gYsK7")))))
            ]
        },
        {
            regexp: /\.(zip|tar|gz|bz2|rar)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("8njZH"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("9CRO6")))))
            ]
        },
        {
            regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("eABwY"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("7zjHG")))))
            ]
        },
        {
            regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("kKp2J"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("cHwqN")))))
            ]
        },
        {
            regexp: /\.(docx|dotx|doc|dot)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("im5Hg"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("2sfBf")))))
            ]
        },
        {
            regexp: /\.(wma|wmv|ram|mp3)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("dOkKo"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("lBSka")))))
            ]
        },
        {
            regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
            icon: [
                (0, ($parcel$interopDefault((0, parcelRequire("lDRqn"))))),
                (0, ($parcel$interopDefault((0, parcelRequire("b7OK3")))))
            ]
        }
    ];
    const $fdf17f1c79e5d780$var$getIconArray = (title)=>{
        const extension = $fdf17f1c79e5d780$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
            const matches = extensionMatcher.regexp.exec(title);
            return matches && matches.length > 0;
        });
        if (extension) return extension.icon;
        return [
            (0, ($parcel$interopDefault((0, parcelRequire("7BHMh"))))),
            (0, ($parcel$interopDefault((0, parcelRequire("jGmM2")))))
        ];
    };
    const $fdf17f1c79e5d780$export$ebe2a8421106a1ee = {
        small: 0,
        medium: 1
    };
    const $fdf17f1c79e5d780$export$edc04f92718bbea4 = ({ title: title, label: label, size: size })=>{
        const iconArray = $fdf17f1c79e5d780$var$getIconArray(title);
        const sizeIndex = $fdf17f1c79e5d780$export$ebe2a8421106a1ee[size];
        const icon = iconArray[sizeIndex];
        return (0, $5uXOq.createElement)(icon, {
            label: label,
            testId: icon.name
        });
    };
});
parcelRegister("96Idm", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $6a16f8a7ac90846b$var$_react = $6a16f8a7ac90846b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $6a16f8a7ac90846b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6a16f8a7ac90846b$var$Gif16Icon = (props)=>$6a16f8a7ac90846b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
        }, props, {
            size: 'small'
        }));
    $6a16f8a7ac90846b$var$Gif16Icon.displayName = 'Gif16Icon';
    var $6a16f8a7ac90846b$var$_default = module.exports.default = $6a16f8a7ac90846b$var$Gif16Icon;
});
parcelRegister("RiK2l", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0a037d07967bfa4f$var$Gif24Icon = (props)=>$0a037d07967bfa4f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
    var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;
});
parcelRegister("cwmS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a921419639fe8f6f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a921419639fe8f6f$var$sizeMap = {
        '16': {
            name: "157xhr7",
            styles: "width:16px;height:16px"
        },
        '24': {
            name: "rrel8y",
            styles: "width:24px;height:24px"
        },
        '32': {
            name: "68x97p",
            styles: "width:32px;height:32px"
        },
        '40': {
            name: "1mfsro6",
            styles: "width:40px;height:40px"
        },
        '48': {
            name: "18jhpep",
            styles: "width:48px;height:48px"
        }
    };
    const $a921419639fe8f6f$var$appearanceMap = {
        grayBold: {
            name: "algye9",
            styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        limeBold: {
            name: "a86nvv",
            styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        greenBold: {
            name: "13e2qqr",
            styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        blueBold: {
            name: "jpsdma",
            styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        redBold: {
            name: "1bg8y7a",
            styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        purpleBold: {
            name: "19bo3lb",
            styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        magentaBold: {
            name: "1l16rgo",
            styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        tealBold: {
            name: "7kw5zl",
            styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        orangeBold: {
            name: "h77eay",
            styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        yellowBold: {
            name: "sbe4w3",
            styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        gray: {
            name: "yxgei8",
            styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
        },
        lime: {
            name: "o9c6oh",
            styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
        },
        orange: {
            name: "szqzk5",
            styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
        },
        magenta: {
            name: "o6ptuw",
            styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
        },
        green: {
            name: "157dg7e",
            styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
        },
        blue: {
            name: "x3nujl",
            styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
        },
        red: {
            name: "zqoyws",
            styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
        },
        purple: {
            name: "fitjkd",
            styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
        },
        teal: {
            name: "b3m1ww",
            styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
        },
        yellow: {
            name: "1j18jub",
            styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
        }
    };
    const $a921419639fe8f6f$var$shapeMap = {
        square: {
            name: "vwdoqr",
            styles: "border-radius:var(--ds-border-radius-100, 4px)"
        },
        circle: {
            name: "i2ucdk",
            styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
        }
    };
    const $a921419639fe8f6f$var$iconTileStyles = {
        name: "ykimcl",
        styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
    };
    function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
        const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent } = props;
        const ExpandedIcon = Icon;
        if (LEGACY_fallbackComponent && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $a921419639fe8f6f$var$iconTileStyles,
                $a921419639fe8f6f$var$appearanceMap[appearance],
                $a921419639fe8f6f$var$sizeMap[size],
                $a921419639fe8f6f$var$shapeMap[shape]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        }));
    }
});
parcelRegister("7WTmq", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceResultMeta", ()=>$f082e1865db27da9$export$9138e703d4b4585b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f5TWP;
    var $cgL5K;
    var $iySxd;
    var $bWGt6 = parcelRequire("bWGt6");
    function $f082e1865db27da9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f082e1865db27da9$var$ConfluenceResultMetaWrapper = (0, $bWGt6.default)("span", {
        target: "e10xva5d1"
    })({
        name: "fhxb3m",
        styles: "display:flex;flex-direction:row;align-items:center"
    });
    const $f082e1865db27da9$var$ConfluenceTypeWrapper = (0, $bWGt6.default)("span", {
        target: "e10xva5d0"
    })({
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    });
    const $f082e1865db27da9$var$BreadCrumbs = ({ breadCrumbs: breadCrumbs = [] })=>{
        if (breadCrumbs.length === 0) return null;
        let twoBreadcrumbs = [];
        if (breadCrumbs.length > 2) twoBreadcrumbs = [
            breadCrumbs[0],
            breadCrumbs[breadCrumbs.length - 1]
        ];
        else twoBreadcrumbs = breadCrumbs;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            separator: "/",
            space: "space.100"
        }, twoBreadcrumbs.map(({ id: id, title: title }, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                color: "color.text.subtle",
                size: "small",
                key: id
            }, title)));
    };
    const $f082e1865db27da9$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
        const breadcrumbs = $f082e1865db27da9$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f082e1865db27da9$var$ConfluenceResultMetaWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($f082e1865db27da9$var$ConfluenceTypeWrapper, null, "Confluence"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iySxd")).SpacerWrapper), null, "\u2022"), (0, ($parcel$interopDefault($5uXOq))).createElement($f082e1865db27da9$var$ConfluenceTypeWrapper, null, `${(0, (0, parcelRequire("iySxd")).capitalizeFirstLetter)(resultContentType)}`), breadcrumbs?.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iySxd")).SpacerWrapper), null, "\u2022"), (0, ($parcel$interopDefault($5uXOq))).createElement($f082e1865db27da9$var$BreadCrumbs, {
            breadCrumbs: breadcrumbs
        })));
    };
    const $f082e1865db27da9$export$ed9f69ac7e699c53 = (ancestors, space)=>{
        let breadcrumbs = [];
        if (space) {
            const spaceBreadcrumb = {
                id: space?.id,
                title: space?.name
            };
            if (!ancestors || ancestors.length === 0) breadcrumbs = [
                spaceBreadcrumb
            ];
            else if (ancestors.length >= 1) breadcrumbs = [
                spaceBreadcrumb,
                ...ancestors.slice(1)
            ];
        }
        return breadcrumbs.filter((breadCrumb)=>breadCrumb.id && breadCrumb.title);
    };
});
parcelRegister("iySxd", function(module, exports) {
    $parcel$export(module.exports, "SpacerWrapper", ()=>$e9a2ef39864e9f1a$export$b05a2e78ddf8915e);
    $parcel$export(module.exports, "capitalizeFirstLetter", ()=>$e9a2ef39864e9f1a$export$d07f57595c356899);
    $parcel$export(module.exports, "QuickFindResultMeta", ()=>$e9a2ef39864e9f1a$export$73e5ecb29f7bf6e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWGt6 = parcelRequire("bWGt6");
    const $e9a2ef39864e9f1a$var$ResultMetaWrapper = (0, $bWGt6.default)("span", {
        target: "eflzzry1"
    })({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    });
    const $e9a2ef39864e9f1a$export$b05a2e78ddf8915e = (0, $bWGt6.default)("span", {
        target: "eflzzry0"
    })({
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
        margin: `0px ${"var(--ds-space-100, 8px)"}`
    });
    function $e9a2ef39864e9f1a$export$d07f57595c356899(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
    const $e9a2ef39864e9f1a$export$73e5ecb29f7bf6e9 = ({ meta: meta })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e9a2ef39864e9f1a$var$ResultMetaWrapper, null, meta.filter((metaItem)=>metaItem !== null && metaItem !== undefined).map((metaItem, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, metaItem, index !== meta.length - 1 && (0, ($parcel$interopDefault($5uXOq))).createElement($e9a2ef39864e9f1a$export$b05a2e78ddf8915e, null, "\u2022"))));
    };
});
parcelRegister("lYkqd", function(module, exports) {
    $parcel$export(module.exports, "quickFindRecentSpaceResultMapper", ()=>$8525d00f54a62176$export$d04e5b6d01e34c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $kgoHi;
    var $8CUq3;
    var $ujWmd;
    var $c59Mn;
    const $8525d00f54a62176$var$negativeMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.negative.025'
    });
    const $8525d00f54a62176$var$CONTEXT_PATH = '/wiki';
    const $8525d00f54a62176$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $8525d00f54a62176$var$negativeMarginStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        }));
    const $8525d00f54a62176$export$d04e5b6d01e34c3 = (item)=>({
            id: item?.id || '',
            title: item?.name || '',
            meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_confluence_space),
            additionalMeta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_recent_spaces_additional_meta),
            url: `${$8525d00f54a62176$var$CONTEXT_PATH}${item?.links?.webui || ''}`,
            containerId: item?.id || undefined,
            icon: $8525d00f54a62176$export$e5d849fb708254a9({
                iconUrl: `${$8525d00f54a62176$var$CONTEXT_PATH}${item?.icon?.path || ''}`,
                size: 'small'
            }),
            isRecentResult: true,
            type: 'confluence space'
        });
});
parcelRegister("VfjmV", function(module, exports) {
    $parcel$export(module.exports, "getQuickFindPeopleAndTeamsResultMapper", ()=>$6f13b8667f0b538a$export$dbdea3e42644cff8);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $bBlrR;
    var $c59Mn;
    var $5B8KC;
    const $6f13b8667f0b538a$export$dbdea3e42644cff8 = (primaryProduct, orgId, cloudId)=>{
        return (result)=>{
            if (result.type === 'team') return {
                title: result.name,
                id: result.id,
                type: result.type,
                meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_results_team),
                url: `${window.location.origin}${(0, (0, parcelRequire("5B8KC")).getTeamPath)(result.id, primaryProduct, orgId, cloudId)}`,
                icon: (0, (0, parcelRequire("bBlrR")).GenericIconRenderer)({
                    iconUrl: result.avatarUrl
                })
            };
            else return {
                title: result.name,
                id: result.id,
                type: result.type,
                meta: result.title || '',
                url: `${window.location.origin}${(0, (0, parcelRequire("5B8KC")).getUserPath)(result.id, primaryProduct, orgId, cloudId)}`,
                icon: (0, (0, parcelRequire("bBlrR")).GenericIconRenderer)({
                    iconUrl: result.avatarUrl,
                    appearance: 'circle'
                })
            };
        };
    };
});
parcelRegister("7bjp7", function(module, exports) {
    $parcel$export(module.exports, "quickFindConfluenceSpaceMapper", ()=>$f553aa6fd8e1a7f8$export$831f92f4f63a8807);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $c59Mn;
    var $4ZbRt;
    var $bBlrR;
    const $f553aa6fd8e1a7f8$export$831f92f4f63a8807 = ({ node: item })=>{
        return {
            id: (0, (0, parcelRequire("4ZbRt")).transformAriToId)(item?.id || '', item?.type || ''),
            title: item?.title || '',
            meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("c59Mn")).messages).quick_find_confluence_space),
            url: item?.url || '',
            type: 'confluence space',
            containerId: item?.id,
            icon: (0, (0, parcelRequire("bBlrR")).GenericIconRenderer)({
                iconUrl: `/wiki${item?.iconPath || ''}`,
                size: 'small'
            })
        };
    };
});
parcelRegister("4ZbRt", function(module, exports) {
    $parcel$export(module.exports, "transformAriToId", ()=>$d10aa42ae5e2bb68$export$6d8886e8d5cdbeec);
    const $d10aa42ae5e2bb68$export$6d8886e8d5cdbeec = (id, type)=>{
        switch(type){
            case 'page':
                return id.split(':page/')[1];
            case 'blogpost':
                return id.split(':blogpost/')[1];
            case 'attachment':
                return id.split(':attachment/')[1];
            case 'space':
                return id.split(':space/')[1];
            case 'whiteboard':
                return id.split(':whiteboard/')[1];
            case 'embed':
                const embedAri = id.split('/');
                return embedAri[embedAri.length - 1];
            case 'database':
                const databaseAri = id.split('/');
                return databaseAri[databaseAri.length - 1];
            default:
                return id;
        }
    };
});
parcelRegister("dtzJn", function(module, exports) {
    $parcel$export(module.exports, "quickFindConfluenceContentMapper", ()=>$063ed7719c2ec5f6$export$6a180a233e580286);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBlrR;
    var $4ZbRt;
    var $7WTmq;
    var $bE3Ky;
    const $063ed7719c2ec5f6$export$6a180a233e580286 = ({ node: item })=>{
        return {
            ari: item?.id,
            id: (0, (0, parcelRequire("4ZbRt")).transformAriToId)(item?.id || '', item?.type || ''),
            title: item?.title || '',
            url: item?.url || '',
            meta: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7WTmq")).ConfluenceResultMeta), {
                resultContentType: item?.type || '',
                resultAncestors: item?.confluenceEntity?.ancestors,
                resultSpace: item?.space
            }),
            additionalMeta: item?.lastModified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bE3Ky")).EventTypeMessage), {
                timestamp: item.lastModified,
                eventType: (0, (0, parcelRequire("bE3Ky")).WORKED_EVENT).UPDATED,
                isMyActivityData: false
            }) : '',
            containerId: (0, (0, parcelRequire("4ZbRt")).transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
            type: `confluence ${item?.type}` || '',
            icon: (0, (0, parcelRequire("bBlrR")).ContentIconRenderer)({
                type: item?.type || '',
                title: item?.title
            })
        };
    };
});
parcelRegister("bUT2o", function(module, exports) {
    $parcel$export(module.exports, "quickFindAtlasContentMapper", ()=>$c92e39198c7c5383$export$92506b66b43d2a63);
    var $5uXOq = parcelRequire("5uXOq");
    var $7k20O;
    var $4ZbRt;
    var $5qRwM;
    var $iySxd;
    const $c92e39198c7c5383$var$getIcon = (result)=>{
        return result?.iconUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qRwM")).default), {
            height: 24,
            width: 24,
            title: result.type,
            src: result.iconUrl
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    const $c92e39198c7c5383$var$getKey = (item)=>{
        if ((0, (0, parcelRequire("7k20O")).isSearchResultAtlasProjectPartial)(item)) return item.project?.key;
        else if ((0, (0, parcelRequire("7k20O")).isSearchResultAtlasGoalPartial)(item)) return item.goal?.key;
        else return null;
    };
    const $c92e39198c7c5383$var$getTitle = (item)=>{
        if (!item) return '';
        let entityKey = $c92e39198c7c5383$var$getKey(item);
        if (entityKey) return `${entityKey}: ${item.title || ''}`;
        return item.title || '';
    };
    const $c92e39198c7c5383$export$92506b66b43d2a63 = ({ node: item })=>{
        return {
            id: (0, (0, parcelRequire("4ZbRt")).transformAriToId)(item?.id || '', item?.type || ''),
            title: $c92e39198c7c5383$var$getTitle(item),
            url: item?.url || '',
            meta: (0, (0, parcelRequire("iySxd")).capitalizeFirstLetter)(item?.type || ''),
            additionalMeta: '',
            containerId: '',
            type: `atlas ${item?.type}` || '',
            icon: $c92e39198c7c5383$var$getIcon(item)
        };
    };
});
parcelRegister("7k20O", function(module, exports) {
    $parcel$export(module.exports, "isSearchResultAtlasProjectPartial", ()=>$2cea3646501572ab$export$1724df33341798e0);
    $parcel$export(module.exports, "isSearchResultAtlasGoalPartial", ()=>$2cea3646501572ab$export$1d556a3125797ca6);
    const $2cea3646501572ab$var$SearchDefaultResultAtlas = ``;
    const $2cea3646501572ab$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
  }
}
`;
    const $2cea3646501572ab$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
    }
    targetDate {
      label
    }
  }
}
`;
    const $2cea3646501572ab$export$1724df33341798e0 = (partial)=>{
        return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
    };
    const $2cea3646501572ab$export$1d556a3125797ca6 = (partial)=>{
        return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
    };
    const $2cea3646501572ab$export$bff995b1cea89df3 = (partial)=>{
        return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
    };
    const $2cea3646501572ab$export$aa63de26c950cf0f = (partial)=>{
        return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
    };
    const $2cea3646501572ab$export$750af6f011d7ee10 = (partial)=>{
        return $2cea3646501572ab$export$1d556a3125797ca6(partial) || $2cea3646501572ab$export$1724df33341798e0(partial) || $2cea3646501572ab$export$bff995b1cea89df3(partial) || $2cea3646501572ab$export$aa63de26c950cf0f(partial);
    };
    const $2cea3646501572ab$export$272c689528faac47 = ()=>{
        return `
		${$2cea3646501572ab$var$SearchResultAtlasGoal}
		${$2cea3646501572ab$var$SearchResultAtlasProject}
		${$2cea3646501572ab$var$SearchDefaultResultAtlas}
	`;
    };
});
parcelRegister("a353g", function(module, exports) {
    $parcel$export(module.exports, "SearchFooter", ()=>$ca1f4818c3f18a6a$export$64ded8b71dfcba9e);
    var $k5uoT;
    var $bWGt6 = parcelRequire("bWGt6");
    const $ca1f4818c3f18a6a$var$footerHeight = (0, (0, parcelRequire("k5uoT")).gridSize)() * 6;
    const $ca1f4818c3f18a6a$export$64ded8b71dfcba9e = (0, $bWGt6.default)("div", {
        target: "e1jzvw2y0"
    })({
        width: '100%',
        borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        height: `${$ca1f4818c3f18a6a$var$footerHeight}px`
    });
});
parcelRegister("ha1Zp", function(module, exports) {
    $parcel$export(module.exports, "defaultPermissionsSupplier", ()=>$34f45a70c8cf1c6d$export$79b79eb7219cb5fd);
    var $4biU5;
    const $34f45a70c8cf1c6d$export$79b79eb7219cb5fd = ()=>{
        const response = Object.values((0, (0, parcelRequire("4biU5")).Scope));
        return Promise.resolve(response);
    };
});
parcelRegister("icutB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68ed6f1424c61374$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8RXs9;
    var $8oG5R;
    var $3FqY6;
    var $k4hbD;
    var $2dI5H;
    var $4dZPc;
    const $68ed6f1424c61374$export$4c85ccfa2dce935c = (query, features)=>{
        let allLinks = {
            board: {
                href: `/secure/ManageRapidViews.jspa?contains=${query}`,
                message: (0, (0, parcelRequire("k4hbD")).messages).jira_advanced_search_boards,
                actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).JIRA_BOARDS
            },
            project: {
                href: `/projects?contains=${query}`,
                message: (0, (0, parcelRequire("k4hbD")).messages).jira_advanced_search_projects,
                actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).JIRA_PROJECTS
            },
            filters: {
                href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
                message: (0, (0, parcelRequire("k4hbD")).messages).jira_advanced_search_filters,
                actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).JIRA_FILTERS
            },
            plans: {
                href: `/jira/plans`,
                message: (0, (0, parcelRequire("k4hbD")).messages).jira_advanced_search_plans,
                actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).JIRA_PLANS
            },
            people: {
                href: `/jira/people/search?q=${query}`,
                message: (0, (0, parcelRequire("k4hbD")).messages).jira_advanced_search_people,
                actionSubjectId: (0, (0, parcelRequire("3FqY6")).AdvancedSearchLinkSubjectId).JIRA_PEOPLE
            }
        };
        if (!features?.hasAdvancedRoadmapsAccess) delete allLinks.plans;
        if (!features?.hasAdvancedRoadmapsAccess && !features?.hasSoftwareAccess) delete allLinks.board;
        return allLinks;
    };
    const $68ed6f1424c61374$export$b16edfe49ade2612 = ({ advancedSearchSelected: advancedSearchSelected, features: features, linkComponent: linkComponent })=>{
        const { query: query, isLoading: isLoading } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const onClickAndFireEvent = (e, actionSubjectId)=>{
            e.preventDefault();
            advancedSearchSelected({
                actionSubjectId: actionSubjectId,
                trigger: (0, (0, parcelRequire("8oG5R")).getTrigger)(e),
                isLoading: isLoading,
                newTab: (0, (0, parcelRequire("8oG5R")).isNewTab)(e)
            });
        };
        const searchConfiguration = $68ed6f1424c61374$export$4c85ccfa2dce935c(query, features);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dZPc")).AdvancedSearchContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dZPc")).LabelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("k4hbD")).messages).jira_advanced_search_label)), Object.keys(searchConfiguration).map((key)=>{
            const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                onClick: (e)=>onClickAndFireEvent(e, actionSubjectId),
                role: "none",
                style: {
                    height: '100%'
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dZPc")).StyledLink), {
                linkComponent: linkComponent,
                key: `search_link_${key}`,
                href: href
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), message)));
        }));
    };
    var $68ed6f1424c61374$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($68ed6f1424c61374$export$b16edfe49ade2612);
});
parcelRegister("4dZPc", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSearchContainer", ()=>$ff863c289484f355$export$cb4aeb4aba07ad10);
    $parcel$export(module.exports, "LabelContainer", ()=>$ff863c289484f355$export$f5ae33f1b01a6402);
    $parcel$export(module.exports, "StyledLink", ()=>$ff863c289484f355$export$9048d548939551ee);
    var $kCMvS;
    var $bWGt6 = parcelRequire("bWGt6");
    function $ff863c289484f355$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ff863c289484f355$export$cb4aeb4aba07ad10 = (0, $bWGt6.default)("div", {
        target: "eq9f4ne2"
    })({
        name: "1es2nqu",
        styles: "padding:var(--ds-space-200, 16px)"
    });
    const $ff863c289484f355$export$f5ae33f1b01a6402 = (0, $bWGt6.default)("span", {
        target: "eq9f4ne1"
    })({
        marginRight: "var(--ds-space-100, 8px)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        '&:hover, &:focus': {
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
        },
        ':visited': {
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
        }
    });
    const $ff863c289484f355$export$9048d548939551ee = (0, $bWGt6.default)((0, (0, parcelRequire("kCMvS")).Link), {
        target: "eq9f4ne0"
    })({
        WebkitBoxAlign: 'baseline',
        alignItems: 'baseline',
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontWeight: 500,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        borderRadius: '3px',
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-150, 8px)"}`,
        marginRight: "var(--ds-space-050, 4px)",
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            textDecoration: 'none',
            transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        },
        '&:visited, &:focus-visible, &:focus': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
});
parcelRegister("bYLf6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93559d09366e5717$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4bcZr;
    var $8RXs9;
    var $k4hbD;
    const $93559d09366e5717$var$Image = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("eULUN")));
    const $93559d09366e5717$var$NoPreQueryResults = ({ intl: intl, message: message })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4bcZr")).EmptyState), {
            title: intl.formatMessage(message || (0, (0, parcelRequire("k4hbD")).messages).common_empty_state_prequery_heading),
            Image: $93559d09366e5717$var$Image
        });
    var $93559d09366e5717$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($93559d09366e5717$var$NoPreQueryResults);
});
parcelRegister("eULUN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("frHYK").then(()=>parcelRequire('ldK5O'));
});
parcelRegister("5hwDL", function(module, exports) {
    $parcel$export(module.exports, "useJiraDateFilter", ()=>$cd3eda81797e2df9$export$ab45d91883e25704);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Lv6B;
    var $gMpaQ;
    var $bONub;
    var $3RKSV;
    var $4Pado;
    var $k4hbD;
    var $koVbs;
    const $cd3eda81797e2df9$var$getDateRange = (fromOffset, toOffset = -1)=>{
        const from = new Date();
        const to = new Date();
        from.setDate(from.getDate() - fromOffset);
        to.setDate(to.getDate() - toOffset);
        return {
            from: from.toISOString().split('T')[0],
            to: to.toISOString().split('T')[0]
        };
    };
    const $cd3eda81797e2df9$export$ab45d91883e25704 = ({ isDateFromFilterEnabled: isDateFromFilterEnabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const dateFilterOptionsAndValues = (0, $5uXOq.useMemo)(()=>{
            return !isDateFromFilterEnabled ? null : {
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).DEFAULT]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).DEFAULT,
                        label: formatMessage((0, (0, parcelRequire("k4hbD")).messages).date_filter_any_time_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: true,
                        isVisible: true
                    },
                    dateRange: {
                        from: '',
                        to: ''
                    }
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).TODAY]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).TODAY,
                        label: formatMessage((0, (0, parcelRequire("4Pado")).messages).date_filter_today_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $cd3eda81797e2df9$var$getDateRange(0)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).YESTERDAY]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).YESTERDAY,
                        label: formatMessage((0, (0, parcelRequire("4Pado")).messages).date_filter_yesterday_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $cd3eda81797e2df9$var$getDateRange(1, 0)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_SEVEN_DAYS]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_SEVEN_DAYS,
                        label: formatMessage((0, (0, parcelRequire("4Pado")).messages).date_filter_past_7_days_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $cd3eda81797e2df9$var$getDateRange(7)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_THIRTY_DAYS]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_THIRTY_DAYS,
                        label: formatMessage((0, (0, parcelRequire("4Pado")).messages).date_filter_past_30_days_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $cd3eda81797e2df9$var$getDateRange(30)
                },
                [(0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_YEAR]: {
                    filter: {
                        id: (0, (0, parcelRequire("bONub")).LastModifiedValues).PAST_YEAR,
                        label: formatMessage((0, (0, parcelRequire("4Pado")).messages).date_filter_past_year_label),
                        filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC,
                        avatarUrl: '',
                        isChecked: false,
                        isVisible: true
                    },
                    dateRange: $cd3eda81797e2df9$var$getDateRange(365)
                }
            };
        }, [
            isDateFromFilterEnabled,
            formatMessage
        ]);
        const dateFilterOptions = (0, $5uXOq.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
            dateFilterOptionsAndValues
        ]);
        const dateFilterStore = (0, (0, parcelRequire("3RKSV")).useFilterStore)(dateFilterOptions, (0, (0, parcelRequire("9Lv6B")).JIRA_PRODUCT_ID), (0, (0, parcelRequire("9Lv6B")).JiraFilters).Date);
        const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, (0, parcelRequire("bONub")).DEFAULT_OPTION))?.id;
        const appliedDateFilterValue = appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? dateFilterOptionsAndValues[appliedDateFilter].dateRange : null;
        const getLastModifiedValue = (0, $5uXOq.useCallback)(()=>{
            return appliedDateFilterValue ? {
                '@type': (0, (0, parcelRequire("9Lv6B")).JiraFilters).Date,
                from: appliedDateFilterValue.from,
                to: appliedDateFilterValue.to
            } : null;
        }, [
            appliedDateFilterValue
        ]);
        const jiraTabDateFilterDefinition = (0, $5uXOq.useMemo)(()=>{
            return isDateFromFilterEnabled ? [
                {
                    ['@type']: (0, (0, parcelRequire("9Lv6B")).JiraFilters).Date,
                    uiVariant: (0, (0, parcelRequire("bONub")).FilterUIVariant).STATIC_SELECT,
                    fieldName: 'from',
                    store: dateFilterStore,
                    loadFilterOptions: async ()=>[],
                    sectionLabel: formatMessage((0, (0, parcelRequire("k4hbD")).messages).date_filter_filters_title),
                    findMoreLabel: '',
                    mapSelectionToAppliedValue: ()=>getLastModifiedValue()
                }
            ] : [];
        }, [
            isDateFromFilterEnabled,
            dateFilterStore,
            formatMessage,
            getLastModifiedValue
        ]);
        return {
            appliedDateFilterValue: appliedDateFilterValue,
            jiraTabDateFilterDefinition: jiraTabDateFilterDefinition,
            dateFilterOptionsAndValues: dateFilterOptionsAndValues
        };
    };
});
parcelRegister("9RlGt", function(module, exports) {
    $parcel$export(module.exports, "FilterContextProvider", ()=>$82a54352c7d6692f$export$eb71bf38f5ae0f9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $tUDIN;
    var $5uOu6;
    var $gMpaQ;
    var $k4hbD;
    var $lL734;
    const $82a54352c7d6692f$var$BROCCOLI_30_EXPERIMENT = {
        experimentId: 'broccoli-30-frontend',
        days: 30
    };
    const $82a54352c7d6692f$var$BROCCOLI_60_EXPERIMENT = {
        experimentId: 'broccoli-60-frontend',
        days: 60
    };
    const $82a54352c7d6692f$var$BROCCOLI_90_EXPERIMENT = {
        experimentId: 'broccoli-90-frontend',
        days: 90
    };
    const $82a54352c7d6692f$export$40e7ffc2d13a061c = [
        $82a54352c7d6692f$var$BROCCOLI_30_EXPERIMENT,
        $82a54352c7d6692f$var$BROCCOLI_60_EXPERIMENT,
        $82a54352c7d6692f$var$BROCCOLI_90_EXPERIMENT
    ];
    class $82a54352c7d6692f$export$bea22cefe0b3447c {
        static{
            this.OPEN = new $82a54352c7d6692f$export$bea22cefe0b3447c('open', '"undefined", "In Progress", "To Do"');
        }
        static{
            this.DONE = new $82a54352c7d6692f$export$bea22cefe0b3447c('done', '"Done"');
        }
        constructor(id, jqlValue){
            this.id = id;
            this.jqlValue = jqlValue;
        }
    }
    const $82a54352c7d6692f$export$b5d1c2ef6aead4e6 = [
        {
            title: (0, (0, parcelRequire("k4hbD")).messages).binary_status_category_filter_option_open,
            id: $82a54352c7d6692f$export$bea22cefe0b3447c.OPEN.id,
            isChecked: false,
            isVisible: true,
            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC
        },
        {
            title: (0, (0, parcelRequire("k4hbD")).messages).binary_status_category_filter_option_done,
            id: $82a54352c7d6692f$export$bea22cefe0b3447c.DONE.id,
            isChecked: false,
            isVisible: true,
            filterSource: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC
        }
    ];
    const $82a54352c7d6692f$export$973ca22476b0e05f = (defaultFilters = [])=>{
        const { filters: filters, dispatch: dispatch } = (0, (0, parcelRequire("5uOu6")).useFilter)(defaultFilters);
        const addFilters = (0, $5uXOq.useCallback)((newFilters)=>dispatch((0, (0, parcelRequire("5uOu6")).addFilters)(newFilters, (a, b)=>{
                if (a.filterSource === (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER && b.filterSource !== (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER) return -1;
                if (a.filterSource !== (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER && b.filterSource === (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).CURRENT_USER) return 1;
                return 0;
            })), [
            dispatch
        ]);
        const updateFilter = (0, $5uXOq.useCallback)((id, isChecked)=>dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(id, isChecked, true)), [
            dispatch
        ]);
        const clearFilter = (0, $5uXOq.useCallback)(()=>{
            filters.forEach((f)=>dispatch((0, (0, parcelRequire("5uOu6")).updateFilterState)(f.id, false)));
        }, [
            filters,
            dispatch
        ]);
        const resetFilter = (0, $5uXOq.useCallback)(()=>{
            dispatch((0, (0, parcelRequire("5uOu6")).replaceAllFilters)(defaultFilters));
        }, [
            defaultFilters,
            dispatch
        ]);
        return {
            availableFilters: filters,
            addFilters: addFilters,
            updateFilter: updateFilter,
            clearFilter: clearFilter,
            reset: resetFilter,
            dispatch: dispatch
        };
    };
    const $82a54352c7d6692f$var$DEFAULT_FILTER_STATE = {
        availableFilters: [],
        addFilters: ()=>{},
        updateFilter: ()=>{},
        clearFilter: ()=>{},
        reset: ()=>{},
        dispatch: ()=>{}
    };
    const $82a54352c7d6692f$var$FilterContext = (0, $5uXOq.createContext)({
        projectFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
        assigneeFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
        siteFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
        binaryStatusCategoryFilters: $82a54352c7d6692f$var$DEFAULT_FILTER_STATE,
        dateFilterFrom: {
            value: '',
            setValue: (_value)=>null
        },
        dateFilterTo: {
            value: '',
            setValue: (_value)=>null
        }
    });
    function $82a54352c7d6692f$export$5e1edcb3c154ab79(availableFilters) {
        const appliedFilters = availableFilters.map((availableFilter, index)=>({
                ...availableFilter,
                index: index
            })).filter((filterWithIndex)=>filterWithIndex.isChecked);
        return {
            applied: appliedFilters.map((appliedFilter)=>({
                    id: appliedFilter.id,
                    source: appliedFilter.filterSource,
                    index: appliedFilter.index
                })),
            recommendedIds: availableFilters.map((appliedFilter)=>({
                    id: appliedFilter.id,
                    source: appliedFilter.filterSource
                }))
        };
    }
    const $82a54352c7d6692f$var$transformDateFiltersForAnalytics = (dateFilterFrom)=>{
        const availiableFilters = $82a54352c7d6692f$export$40e7ffc2d13a061c.map((experiment)=>experiment.days).map((days)=>[
                days,
                (0, (0, parcelRequire("lL734")).getDateXDaysBack)(days)
            ]);
        const appliedFilter = availiableFilters.filter(([_, date])=>date === dateFilterFrom).map(([days, _])=>({
                id: days
            }));
        return {
            applied: appliedFilter.map(({ id: id })=>({
                    id: id,
                    source: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC
                })),
            recommendedIds: availiableFilters.map(([days, _])=>({
                    id: days,
                    source: (0, (0, parcelRequire("gMpaQ")).FilterOptionSource).STATIC
                }))
        };
    };
    const $82a54352c7d6692f$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultProjectFilters: defaultProjectFilters, defaultAssigneeFilters: defaultAssigneeFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
        const previousEnabledState = (0, ($parcel$interopDefault($5uXOq))).useRef(isEnabled);
        const [dateFilterFrom, setDateFilterFrom] = (0, $5uXOq.useState)('');
        const [dateFilterTo, setDateFilterTo] = (0, $5uXOq.useState)('');
        const projectFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f(defaultProjectFilters);
        const assigneeFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f(defaultAssigneeFilters);
        const siteFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f(defaultSiteFilters);
        const binaryStatusCategoryFilterStore = $82a54352c7d6692f$export$973ca22476b0e05f($82a54352c7d6692f$export$b5d1c2ef6aead4e6);
        const filtersAnalyticsContext = projectFilterStore.availableFilters.length === 0 && assigneeFilterStore.availableFilters.length === 0 ? {} : {
            projects: $82a54352c7d6692f$export$5e1edcb3c154ab79(projectFilterStore.availableFilters),
            assignees: $82a54352c7d6692f$export$5e1edcb3c154ab79(assigneeFilterStore.availableFilters),
            binaryStatusCategories: $82a54352c7d6692f$export$5e1edcb3c154ab79(binaryStatusCategoryFilterStore.availableFilters),
            dateFrom: $82a54352c7d6692f$var$transformDateFiltersForAnalytics(dateFilterFrom)
        };
        if (previousEnabledState.current && !isEnabled) {
            projectFilterStore.reset();
            assigneeFilterStore.reset();
            siteFilterStore.reset();
            binaryStatusCategoryFilterStore.clearFilter();
            setDateFilterFrom('');
            setDateFilterTo('');
        }
        previousEnabledState.current = isEnabled;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($82a54352c7d6692f$var$FilterContext.Provider, {
            value: {
                projectFilters: projectFilterStore,
                assigneeFilters: assigneeFilterStore,
                siteFilters: siteFilterStore,
                binaryStatusCategoryFilters: binaryStatusCategoryFilterStore,
                dateFilterFrom: {
                    value: dateFilterFrom,
                    setValue: setDateFilterFrom
                },
                dateFilterTo: {
                    value: dateFilterTo,
                    setValue: setDateFilterTo
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext
        }, children));
    };
    const $82a54352c7d6692f$export$396ef541d9951d45 = ()=>{
        const filterContext = (0, ($parcel$interopDefault($5uXOq))).useContext($82a54352c7d6692f$var$FilterContext);
        return filterContext;
    };
});
parcelRegister("lL734", function(module, exports) {
    $parcel$export(module.exports, "getDateXDaysBack", ()=>$e0620f149fbe48f1$export$e4a4d5c1140c233a);
    const $e0620f149fbe48f1$export$edfa1467d84b6872 = (item, query)=>{
        const lowerQuery = query.toLowerCase().trim();
        return item.name.toLowerCase().includes(lowerQuery) || item.attributes.key.toLowerCase().includes(lowerQuery);
    };
    const $e0620f149fbe48f1$export$e4a4d5c1140c233a = (daysBefore)=>{
        const date = new Date();
        date.setDate(date.getDate() - daysBefore);
        return date.toISOString().split('T')[0];
    };
});
parcelRegister("6P5ov", function(module, exports) {
    $parcel$export(module.exports, "MultiProductDialog", ()=>$576ecf3485148ab8$export$c952be4395be8d29);
    var $5uXOq = parcelRequire("5uXOq");
    var $7J7Sh;
    var $i8oou;
    var $5rLBT;
    var $2k6eV;
    var $lvCts;
    var $3wz5U;
    var $9Mho6;
    var $2dI5H;
    var $7VoGI;
    var $7Givh;
    var $6ZsPS;
    var $i5cPn;
    var $dnjeJ;
    var $gNiXZ;
    var $2DWAC;
    var $5ZS4j;
    const $576ecf3485148ab8$var$ConditionalWrapper = ({ wrapper: wrapper, children: children })=>wrapper?.({
            children: children
        }) ?? children;
    const $576ecf3485148ab8$var$SearchAIDialogComponent = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("eyPmZ")).then(({ SearchAIDialog: SearchAIDialog })=>({
                default: SearchAIDialog
            })));
    const $576ecf3485148ab8$var$SearchAIAnswerDialog = ({ aiSearchConfig: aiSearchConfig, onClose: onClose, edition: edition, closeParentDialog: closeParentDialog })=>{
        const { query: query, setQueryOnly: setQueryOnly } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const aggregatorClient = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        const cloudId = aggregatorClient?.getAggregatorConfig().cloudId || '';
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { user: user } = (0, (0, parcelRequire("7VoGI")).useUserContext)();
        const { resetSearchSession: resetSearchSession } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const { allowChangeExpand: allowChangeExpand } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const filters = (0, (0, parcelRequire("7Givh")).useAppliedFilters)('confluence');
        const onNavigate = (0, $5uXOq.useCallback)(()=>{
            resetSearchSession();
            allowChangeExpand(true);
        }, [
            resetSearchSession,
            allowChangeExpand
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($576ecf3485148ab8$var$SearchAIDialogComponent, {
            query: query,
            setQuery: setQueryOnly,
            cloudId: cloudId,
            getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
            edition: edition,
            followUpsEnabled: aiSearchConfig.followUpsEnabled,
            onNavigate: onNavigate,
            onClose: onClose,
            searchSessionId: searchSessionId,
            userDetails: user,
            source: "searchDialog",
            parsedFilters: filters,
            closeParentDialog: closeParentDialog
        }));
    };
    const $576ecf3485148ab8$export$c952be4395be8d29 = ({ children: children, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, dialogFeatures: dialogFeatures, user: user, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, keepExpandedInTab: keepExpandedInTab, pageLoadMetrics: pageLoadMetrics, DialogWrapper: DialogWrapper, OnboardingRenderer: OnboardingRenderer, experience: experience, aiSearchConfig: aiSearchConfig, edition: edition, primaryProduct: primaryProduct, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
        (0, (0, parcelRequire("dnjeJ")).useUFOComponentExperience)((0, (0, parcelRequire("9Mho6")).initialisationExperience));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8oou")).MetaContextProvider), {
            theme: theme,
            experience: experience,
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded,
            abTestCloudId: abTestCloudId,
            aggregatorUrl: aggregatorUrl,
            clientProviderFeatures: dialogFeatures,
            user: user,
            dialogFeatures: dialogFeatures,
            primaryProduct: primaryProduct,
            forwardRef: forwardRef,
            isRovoEnabled: isRovoEnabled,
            queryParams: queryParams
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7J7Sh")).KeyboardWrapper), {
            shouldFillContainer: shouldFillContainer,
            forwardRef: forwardRef,
            keepExpandedInTab: keepExpandedInTab
        }, ({ ref: ref, onRetry: onRetry })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wz5U")).ActiveProductSearchInput), {
                shouldFillContainer: shouldFillContainer,
                forwardRef: ref,
                onNavigateGeneric: onNavigateGeneric,
                features: dialogFeatures,
                pageLoadMetrics: pageLoadMetrics
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($576ecf3485148ab8$var$ConditionalWrapper, {
                wrapper: DialogWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gNiXZ")).ActiveProductProvider), null, ({ activeProduct: activeProduct, showSearchAIDialog: showSearchAIDialog, onCloseAIDialog: onCloseAIDialog, defaultAIConfig: defaultAIConfig })=>{
                const finalAIConfig = dialogFeatures?.isGriffinNavEnabled ? aiSearchConfig || defaultAIConfig : aiSearchConfig;
                return showSearchAIDialog && finalAIConfig && isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement($576ecf3485148ab8$var$SearchAIAnswerDialog, {
                    aiSearchConfig: finalAIConfig,
                    onClose: onCloseAIDialog,
                    edition: edition,
                    closeParentDialog: ()=>setIsExpanded(false)
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ZS4j")).ProductSearchDialogWrapper), {
                    shouldFillContainer: shouldFillContainer
                }, OnboardingRenderer && isExpanded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2DWAC")).DisableXPSAB), null, (0, ($parcel$interopDefault($5uXOq))).createElement(OnboardingRenderer, {
                    activeProductId: activeProduct?.id
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rLBT")).ProductTabs), null), children({
                    ref: ref,
                    onRetry: onRetry
                }));
            }))));
        }));
    };
});
parcelRegister("7J7Sh", function(module, exports) {
    $parcel$export(module.exports, "KeyboardWrapper", ()=>$531fcb313c93fb66$export$8ee2389f89cfdd2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yucS;
    var $fYvdU;
    var $9enEu;
    var $i5cPn;
    var $aR1b2;
    var $hNXQY;
    class $531fcb313c93fb66$export$bb50437fb01e8bb5 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isExpanded: isExpanded, isQuickFind: isQuickFind, shouldFillContainer: shouldFillContainer, children: children } = this.props;
            const SearchAnchorComponent = isQuickFind ? (0, (0, parcelRequire("7yucS")).EnlargedSearchAnchor) : (0, (0, parcelRequire("9enEu")).SearchAnchor);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SearchAnchorComponent, {
                onBlur: this.onBlurHandler,
                onFocus: this.onFocusHandler,
                onKeyDown: this.handleKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fYvdU")).KeyboardHighlightProvider), {
                listenerNode: this.state.ref
            }, children ? children(this.setRef) : null));
        }
        constructor(...args){
            super(...args), this.state = {
                ref: null
            }, this.timeout = undefined, this.handleKeyDown = (event)=>{
                if (event.key === 'Escape' && !event.defaultPrevented && this.props.isExpanded) {
                    event.preventDefault();
                    this.close();
                }
            }, this.onBlurHandler = ()=>{
                this.timeout = window.setTimeout(()=>{
                    this.close();
                });
            }, this.onFocusHandler = ()=>{
                window.clearTimeout(this.timeout);
            }, this.setRef = (ref)=>{
                if (this.state.ref !== ref) this.setState({
                    ref: ref
                });
            }, this.close = ()=>{
                const { ref: ref } = this.state;
                ref && ref.blur();
                this.props.onClose();
            };
        }
    }
    const $531fcb313c93fb66$export$8ee2389f89cfdd2f = ({ children: children, keepExpandedInTab: keepExpandedInTab = false, forwardRef: forwardRef, shouldFillContainer: shouldFillContainer, ...rest })=>{
        const { isExpanded: isExpanded, setIsExpanded: setIsExpanded, allowChangeExpand: allowChangeExpand } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const inputRef = (0, $5uXOq.useRef)(null);
        const mergedForwardref = (0, (0, parcelRequire("aR1b2")).mergeRefCallback)(inputRef, forwardRef);
        const isQuickFind = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)().quickFind?.enabled;
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setIsExpanded(false);
        }, [
            setIsExpanded
        ]);
        const onTabChange = (0, $5uXOq.useCallback)(()=>{
            if (document.hidden) allowChangeExpand(false);
            else {
                if (isExpanded) inputRef?.current?.focus?.();
                allowChangeExpand(true);
            }
        }, [
            allowChangeExpand,
            isExpanded
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (keepExpandedInTab) {
                document.addEventListener('visibilitychange', onTabChange);
                return ()=>{
                    document.removeEventListener('visibilitychange', onTabChange);
                };
            }
        }, [
            onTabChange,
            keepExpandedInTab
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($531fcb313c93fb66$export$bb50437fb01e8bb5, {
            ...rest,
            shouldFillContainer: shouldFillContainer,
            onClose: onClose,
            isExpanded: isExpanded,
            isQuickFind: isQuickFind
        }, (setRef)=>{
            const ref = (0, (0, parcelRequire("aR1b2")).mergeRefCallback)(setRef, mergedForwardref);
            const onRetry = ()=>{
                inputRef?.current?.focus?.();
            };
            return children({
                ref: ref,
                onRetry: onRetry
            });
        });
    };
});
parcelRegister("7yucS", function(module, exports) {
    $parcel$export(module.exports, "EnlargedSearchAnchor", ()=>$740d2c18f0dc3fe4$export$774d556eae0f6945);
    var $5uXOq = parcelRequire("5uXOq");
    var $hLeR9;
    const $740d2c18f0dc3fe4$export$774d556eae0f6945 = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).EnlargedSearchAnchorWrapper), {
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).AbsoluteContainer), {
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).SearchDialogAnchor), {
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer
        }, children)));
});
parcelRegister("9enEu", function(module, exports) {
    $parcel$export(module.exports, "SearchAnchor", ()=>$ca26fcb83502085a$export$bc951697710bb35a);
    var $5uXOq = parcelRequire("5uXOq");
    var $hLeR9;
    const $ca26fcb83502085a$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).SearchAnchorWrapper), {
            shouldFillContainer: shouldFillContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLeR9")).SearchDialogAnchor), {
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer
        }, children)));
});
parcelRegister("aR1b2", function(module, exports) {
    $parcel$export(module.exports, "mergeRefCallback", ()=>$57727f9aa893daf5$export$bf39ce724f6cc9e5);
    const $57727f9aa893daf5$var$callRef = (callbackOrForwardRef, ref)=>{
        if (!callbackOrForwardRef) return;
        if (typeof callbackOrForwardRef === 'function') callbackOrForwardRef(ref);
        else if (typeof callbackOrForwardRef === 'object' && Object.prototype.hasOwnProperty.call(callbackOrForwardRef, 'current')) callbackOrForwardRef.current = ref;
        else throw new Error('unsupported ref format, currently only callback and forward refs are supported');
    };
    const $57727f9aa893daf5$export$bf39ce724f6cc9e5 = (...refs)=>{
        return (ref)=>{
            refs.forEach((r)=>$57727f9aa893daf5$var$callRef(r, ref));
        };
    };
});
parcelRegister("i8oou", function(module, exports) {
    $parcel$export(module.exports, "MetaContextProvider", ()=>$abdb99ba2b051c55$export$3d88e5d350ac07d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $2AbEM;
    var $i5cPn;
    var $2dI5H;
    var $kv2Va;
    var $aySTE;
    var $4k2KW;
    var $6ZsPS;
    var $lvCts;
    var $4tuQr;
    var $jQ6em;
    var $ebv5l;
    var $7VoGI;
    var $eARpK;
    var $3UF9C;
    var $hI9zY;
    var $ihzp7;
    var $hNXQY;
    var $8zfVb;
    var $3bJE0;
    var $lTDGC;
    var $4QKbG;
    const $abdb99ba2b051c55$export$3d88e5d350ac07d9 = ({ children: children, theme: theme, setIsExpanded: setIsExpanded, isExpanded: isExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, experience: experience, clientProviderFeatures: clientProviderFeatures, user: user, dialogFeatures: dialogFeatures, primaryProduct: primaryProduct, forwardRef: forwardRef, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4QKbG")).QueryParamsProvider), {
            queryParams: queryParams
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hNXQY")).FeaturesProvider), {
            dialogFeatures: dialogFeatures
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VoGI")).UserProvider), {
            user: user
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lTDGC")).RovoContextProvider), {
            isEnabled: isRovoEnabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aySTE")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zfVb")).QuickFindAnalyticContext), {
            isQuickFind: dialogFeatures?.quickFind?.enabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4k2KW")).BuildVersionAnalyticContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2AbEM")).ThemeProvider), {
            partialSearchCSS: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5cPn")).DialogExpansionContextProvider), {
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kv2Va")).ProductRouter), {
            primaryProduct: primaryProduct
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvCts")).AggregatorClientContextProvider), {
            abTestCloudId: abTestCloudId,
            aggregatorUrl: aggregatorUrl,
            features: clientProviderFeatures
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4tuQr")).ABTestContextProvider), {
            experience: experience
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ZsPS")).SearchSessionProvider), {
            sessionKey: `ssid_provider_${isExpanded}`
        }, isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jQ6em")).default), null) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2dI5H")).QueryContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3UF9C")).FilterContextHOC), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hI9zY")).AutocorrectionProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bJE0")).InputContext), {
            forwardRef: forwardRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eARpK")).AsyncLoadOnQuery), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ihzp7")).DialogShownHandler), {
            isExpanded: isExpanded
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ebv5l")).DialogDismissedHandler), {
            isExpanded: isExpanded
        }), children)))))))))))))))));
    };
});
parcelRegister("aySTE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecc9fe0da8e58978$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $i5FdW;
    var $9hHHT;
    var $jY7fH;
    class $ecc9fe0da8e58978$var$MessagesIntlProvider extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props), this.fetchLocale = ()=>{
                (0, (0, parcelRequire("9hHHT")).getMessagesForLocale)(this.props.intl.locale).then((messages)=>this.setState({
                        messages: messages
                    }));
            };
            this.state = {
                messages: (0, (0, parcelRequire("9hHHT")).ENGLISH_LOCALES).indexOf(props.intl.locale) !== -1 ? (0, (0, parcelRequire("jY7fH")).default) : undefined
            };
            this.fetchLocale();
        }
        render() {
            const { children: children } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                messages: this.state.messages,
                locale: this.props.intl.locale
            }, children);
        }
    }
    const $ecc9fe0da8e58978$var$MessagesIntlProviderWithIntl = (0, (0, parcelRequire("8RXs9")).default)($ecc9fe0da8e58978$var$MessagesIntlProvider);
    var $ecc9fe0da8e58978$export$2e2bcd8739ae039 = $ecc9fe0da8e58978$var$MessagesIntlProviderWithIntl;
});
parcelRegister("9hHHT", function(module, exports) {
    $parcel$export(module.exports, "ENGLISH_LOCALES", ()=>$1ac9bebb062b7c13$export$507533edf8f43d4e);
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$1ac9bebb062b7c13$export$d0a3169680473b6c);
    var $jY7fH;
    const $1ac9bebb062b7c13$export$507533edf8f43d4e = [
        'en',
        'en-US',
        'en-GB'
    ];
    async function $1ac9bebb062b7c13$var$getMessages(locale) {
        let messages;
        switch(locale){
            case 'cs':
                messages = (parcelRequire("2F4hB"));
                break;
            case 'da':
                messages = (parcelRequire("1jfiv"));
                break;
            case 'de':
                messages = (parcelRequire("3fKVi"));
                break;
            case 'en':
                messages = Promise.resolve((parcelRequire("jY7fH")));
                break;
            case 'en_GB':
                messages = (parcelRequire("6SpHw"));
                break;
            case 'en_ZZ':
                messages = (parcelRequire("lo0Wo"));
                break;
            case 'es':
                messages = (parcelRequire("9VRwF"));
                break;
            case 'et':
                messages = (parcelRequire("ksRlS"));
                break;
            case 'fi':
                messages = (parcelRequire("fRZgT"));
                break;
            case 'fr':
                messages = (parcelRequire("eVwsU"));
                break;
            case 'hu':
                messages = (parcelRequire("bACZJ"));
                break;
            case 'is':
                messages = (parcelRequire("9LtqA"));
                break;
            case 'it':
                messages = (parcelRequire("504mL"));
                break;
            case 'ja':
                messages = (parcelRequire("2NJON"));
                break;
            case 'ko':
                messages = (parcelRequire("3UcgS"));
                break;
            case 'nb':
                messages = (parcelRequire("6S0U3"));
                break;
            case 'nl':
                messages = (parcelRequire("5Y71T"));
                break;
            case 'pl':
                messages = (parcelRequire("6TwIL"));
                break;
            case 'pt_BR':
                messages = (parcelRequire("9utk6"));
                break;
            case 'pt_PT':
                messages = (parcelRequire("1MLCk"));
                break;
            case 'ro':
                messages = (parcelRequire("dCFn2"));
                break;
            case 'ru':
                messages = (parcelRequire("8vJD8"));
                break;
            case 'sk':
                messages = (parcelRequire("cgqqi"));
                break;
            case 'sv':
                messages = (parcelRequire("dmNz1"));
                break;
            case 'th':
                messages = (parcelRequire("2GGgW"));
                break;
            case 'tr':
                messages = (parcelRequire("cFaq2"));
                break;
            case 'uk':
                messages = (parcelRequire("3aoIP"));
                break;
            case 'vi':
                messages = (parcelRequire("fi1v7"));
                break;
            case 'zh':
                messages = (parcelRequire("5OPlv"));
                break;
            case 'zh_TW':
                messages = (parcelRequire("3VCID"));
                break;
            default:
                throw new Error('Unknown locale: ' + locale);
        }
        return (await messages).default;
    }
    const $1ac9bebb062b7c13$export$d0a3169680473b6c = async (locale)=>{
        locale = locale.replace('-', '_');
        try {
            return await $1ac9bebb062b7c13$var$getMessages(locale);
        } catch (e) {}
        try {
            const parentLocale = locale.split(/[-_]/)[0];
            return await $1ac9bebb062b7c13$var$getMessages(parentLocale);
        } catch (e) {}
        return 0, (0, parcelRequire("jY7fH")).default;
    };
});
parcelRegister("jY7fH", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$ad43061586046ad5$export$2e2bcd8739ae039);
    var $ad43061586046ad5$export$2e2bcd8739ae039 = {
        'cross_product_search_dialog.atlas.tab_label': 'Atlas',
        'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
        'cross_product_search_dialog.confluence.tab_label': 'Confluence',
        'cross_product_search_dialog.google_drive.tab_label': 'Drive',
        'cross_product_search_dialog.google_drive.unauthenticated_prompt': 'You can work on all of your Google sheets, docs, slides and more, without ever leaving Atlassian. Only you have this access.',
        'cross_product_search_dialog.jira.tab_label': 'Jira',
        'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
        'cross_product_search_dialog.recently_viewed_title': 'Recently Viewed {sectionTitle}',
        'cross_product_search_dialog.townsquare_globex_tab_label': 'Home',
        'cross_product_search_dialog.townsquare_recent_goals': 'Recent Goals',
        'cross_product_search_dialog.townsquare_recent_help_links': 'Recent Help Links',
        'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': 'Recent Learnings, Risks and Decisions',
        'cross_product_search_dialog.townsquare_recent_projects': 'Recent Projects',
        'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
        'cross_product_search_dialog.trello.tab_label': 'Trello',
        'cross_product_search_dialog.view_all_results_link': 'View all {sectionTitle}',
        'extensible_search_dialog.advanced_search': 'Advanced search',
        'extensible_search_dialog.connect': 'Connect',
        'extensible_search_dialog.connect_to': 'Connect to',
        'global_search.jira.advanced_search_boards': 'Boards',
        'global_search.jira.advanced_search_filters': 'Filters',
        'global_search.jira.advanced_search_issues': 'Issues',
        'global_search.jira.advanced_search_label': 'Go to all:',
        'global_search.jira.advanced_search_people': 'People',
        'global_search.jira.advanced_search_plans': 'Plans',
        'global_search.jira.advanced_search_projects': 'Projects',
        'global_search.jira.search_placeholder': 'Search Jira',
        'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Search for issues, boards, projects, and filters',
        'product_s earch_dialog.confluence.assignee_filters_find_more': 'Find an assignee',
        'product_search_dialog.atlas.search_input_expanded_placeholder': 'Search Atlas',
        'product_search_dialog.autocorrection.label': 'Did you mean',
        'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Search for code in {source}',
        'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Recently updated repositories',
        'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositories',
        'product_search_dialog.bitbucket.expanded.input-placeholder': 'Search Bitbucket',
        'product_search_dialog.bitbucket.repository_heading': 'Repositories',
        'product_search_dialog.common.site_filters': 'Filter by site',
        'product_search_dialog.compass.component_type.application': 'Application',
        'product_search_dialog.compass.component_type.capability': 'Capability',
        'product_search_dialog.compass.component_type.cloud_resource': 'Cloud resource',
        'product_search_dialog.compass.component_type.data_pipeline': 'Data pipeline',
        'product_search_dialog.compass.component_type.library': 'Library',
        'product_search_dialog.compass.component_type.machine_learning_model': 'Machine learning model',
        'product_search_dialog.compass.component_type.other': 'Other',
        'product_search_dialog.compass.component_type.service': 'Service',
        'product_search_dialog.compass.component_type.ui_element': 'UI element',
        'product_search_dialog.compass.component_type.website': 'Website',
        'product_search_dialog.compass.components_section_heading': 'Components',
        'product_search_dialog.compass.expanded.input-placeholder': 'Search Compass',
        'product_search_dialog.compass.people_section_heading': 'People',
        'product_search_dialog.compass.recently_viewed_components': 'Recently viewed components',
        'product_search_dialog.compass.recently_viewed_teams': 'Recently viewed teams',
        'product_search_dialog.compass.tab_label': 'Compass',
        'product_search_dialog.compass.teams_section_heading': 'Teams',
        'product_search_dialog.compass.upsell_modal_cta_text': 'Get Compass free',
        'product_search_dialog.compass.upsell_modal_description': "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
        'product_search_dialog.compass.upsell_modal_description.bitbucket': 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
        'product_search_dialog.compass.upsell_modal_heading': 'Control your software sprawl, so developers can control their time',
        'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Bring more context to your code',
        'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Learn more about Compass',
        'product_search_dialog.compass.upsell_modal_learn_more_link': 'Learn more',
        'product_search_dialog.compass.upsell_tab_title_lozenge': 'New',
        'product_search_dialog.compass.view_all_components_label': 'View all components',
        'product_search_dialog.compass.view_all_results_label': 'View all results',
        'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence advanced search',
        'product_search_dialog.confluence.clear_filters': 'Clear filters',
        'product_search_dialog.confluence.content_section_heading': 'Content',
        'product_search_dialog.confluence.contributor_filters': 'Filter by contributor',
        'product_search_dialog.confluence.contributor_filters_find_more': 'Find a contributor',
        'product_search_dialog.confluence.date_filter_title': 'Last updated',
        'product_search_dialog.confluence.date_filter_today': 'Today',
        'product_search_dialog.confluence.date_filter_yesterday': 'Yesterday',
        'product_search_dialog.confluence.date_filters_any': 'Any time',
        'product_search_dialog.confluence.date_filters_month': 'Past 30 days',
        'product_search_dialog.confluence.date_filters_week': 'Past 7 days',
        'product_search_dialog.confluence.date_filters_year': 'Past year',
        'product_search_dialog.confluence.empty_state_body_no_advanced_search': 'Try different keywords, fewer of them, or ones that are more general.',
        'product_search_dialog.confluence.empty_state_body_prequery_filters': "We can\u2019t find anything created or updated in the last 90 days with your selected filters.",
        'product_search_dialog.confluence.empty_state_body_title': "We couldn't find any matches for your search.",
        'product_search_dialog.confluence.filters_applied': 'Looks like you have some filters applied',
        'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Pages, blogs and attachments',
        'product_search_dialog.confluence.people_section_heading': 'People',
        'product_search_dialog.confluence.search_input_expanded_placeholder': 'Search Confluence',
        'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Search or ask questions within your Confluence',
        'product_search_dialog.confluence.space_filters': 'Filter by space',
        'product_search_dialog.confluence.space_filters_find_more': 'Find a space',
        'product_search_dialog.confluence.spaces_section_heading': 'Spaces',
        'product_search_dialog.confluence.typing_state_header_text': 'Search for content in Confluence',
        'product_search_dialog.empty.no_results_body': 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
        'product_search_dialog.empty.no_results_body_no_advanced_search': 'Try again with a different term',
        'product_search_dialog.empty.no_results_heading': "We couldn't find anything matching your search.",
        'product_search_dialog.empty_prequery.error_heading': 'Something went wrong with showing initial results',
        'product_search_dialog.empty_prequery.no_results_heading': 'Search for what you need',
        'product_search_dialog.error.failed_search_body': 'It might just be a hiccup. The best thing to do is to <a>try again.</a>',
        'product_search_dialog.error.failed_search_heading': "We're having trouble searching",
        'product_search_dialog.give_feedback': 'Give feedback',
        'product_search_dialog.google_drive.files_heading': 'Files',
        'product_search_dialog.inline_onboarding_action': 'Ok',
        'product_search_dialog.inline_onboarding_body': 'Use the Jira and Confluence tabs to search and see recent items in either location.',
        'product_search_dialog.inline_onboarding_title': 'Search across Jira and Confluence',
        'product_search_dialog.jira.assignee_filters': 'Filter by assignee',
        'product_search_dialog.jira.boards_icon_accessibility_text': 'Board icon',
        'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Boards, Projects, Filters and Plans',
        'product_search_dialog.jira.boards_projects_filters_section_heading': 'Boards, Projects and Filters',
        'product_search_dialog.jira.date_filter_30': '30d',
        'product_search_dialog.jira.date_filter_60': '60d',
        'product_search_dialog.jira.date_filter_90': '90d',
        'product_search_dialog.jira.date_filter_any': 'Any time',
        'product_search_dialog.jira.date_filter_past_30_days': 'Past 30 days',
        'product_search_dialog.jira.date_filter_past_7_days': 'Past 7 days',
        'product_search_dialog.jira.date_filter_past_year': 'Past year',
        'product_search_dialog.jira.date_filter_today': 'Today',
        'product_search_dialog.jira.date_filter_yesterday': 'Yesterday',
        'product_search_dialog.jira.date_filters': 'Last updated',
        'product_search_dialog.jira.empty_prequery.no_results_heading': 'Start searching to find your work',
        'product_search_dialog.jira.issue_filter_done': 'Done',
        'product_search_dialog.jira.issue_filter_open': 'Open',
        'product_search_dialog.jira.issue_filters': 'Filter by status',
        'product_search_dialog.jira.issue_labels_filters': 'Filter by label',
        'product_search_dialog.jira.issue_labels_filters_options_group_label': 'All labels',
        'product_search_dialog.jira.issue_labels_filters_placeholder': 'Select label',
        'product_search_dialog.jira.issues_section_heading': 'Issues',
        'product_search_dialog.jira.jira_view_all_issues_new': 'View all issues',
        'product_search_dialog.jira.project_filters': 'Filter by project',
        'product_search_dialog.jira.project_filters_find_more': 'Find a project',
        'product_search_dialog.jira.projects_filters_section_heading': 'Projects and Filters',
        'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading': 'Recent Boards, Projects, Filters and Plans',
        'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Recent Boards, Projects and Filters',
        'product_search_dialog.jira.recent_projects_filters_section_heading': 'Recent Projects and Filters',
        'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Recently viewed issues',
        'product_search_dialog.jira.report_by_filters': 'Filter by reporter',
        'product_search_dialog.jira.reported_by_me_filter': 'Reported by me',
        'product_search_dialog.jira.site_filters_find_more': 'Find a site',
        'product_search_dialog.jira.view_all_issues': 'Advanced issue search',
        'product_search_dialog.loading_filters': 'Loading',
        'product_search_dialog.more_filters': 'View all filters',
        'product_search_dialog.multi_site_advanced_search_label': 'Search on:',
        'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} more',
        'product_search_dialog.no_options_filters': 'No options',
        'product_search_dialog.opsgenie.advanced_search': 'Advanced alert search',
        'product_search_dialog.opsgenie.alert_heading': 'Alerts',
        'product_search_dialog.opsgenie.expanded.input-placeholder': 'Search Opsgenie',
        'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Recent Alerts',
        'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Ask Atlassian Intelligence',
        'product_search_dialog.quick_find_confluence_space': 'Confluence Space',
        'product_search_dialog.quick_find_footer_full_page_search_link': 'Search your organization',
        'product_search_dialog.quick_find_footer_text': 'Help us improve the search experience',
        'product_search_dialog.quick_find_no_content_body': "Search or ask for anything you're looking for in your Atlassian products",
        'product_search_dialog.quick_find_no_content_header': 'Seek and you shall find',
        'product_search_dialog.quick_find_recent_draft_label': 'DRAFT',
        'product_search_dialog.quick_find_recent_search': 'Recent search',
        'product_search_dialog.quick_find_recent_search_text_dialog': 'From your recent searches',
        'product_search_dialog.quick_find_recent_spaces_additional_meta': 'You recently visited',
        'product_search_dialog.quick_find_recently_viewed': 'Recently Viewed',
        'product_search_dialog.quick_find_result_item_team': 'Team',
        'product_search_dialog.quick_find_results_section': 'Search Results',
        'product_search_dialog.quick_find_search_input_placeholder': 'Search or ask anything',
        'product_search_dialog.quick_find_search_results': 'Search Results',
        'product_search_dialog.quick_find_show_filtered_results': 'Filter by Confluence space, contributor and more',
        'product_search_dialog.quick_find_show_organization_results': 'Search your organization',
        'product_search_dialog.recent_spaces_section_heading': 'Recent spaces',
        'product_search_dialog.recently_viewed_heading': 'Advanced search',
        'product_search_dialog.recently_viewed_section_heading': 'Recently viewed',
        'product_search_dialog.recently_worked_with_section_heading': 'Recently worked with',
        'product_search_dialog.search_input_collapsed_placeholder': 'Search',
        'product_search_dialog.search_people_link': 'Search people',
        'product_search_dialog.show_all_results_link': 'View all results',
        'product_search_dialog.show_more_results_link': 'Show more',
        'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Search Home',
        'product_search_dialog.townsquare_goals_heading': 'Goals',
        'product_search_dialog.townsquare_goals_view_all': 'Search all goals',
        'product_search_dialog.townsquare_help_links_heading': 'Help Links',
        'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Learnings, Risks and Decisions',
        'product_search_dialog.townsquare_people_heading': 'People',
        'product_search_dialog.townsquare_people_view_all': 'Search all people',
        'product_search_dialog.townsquare_projects_heading': 'Projects',
        'product_search_dialog.townsquare_projects_view_all': 'Search all projects',
        'product_search_dialog.townsquare_recent_people': 'Recent People',
        'product_search_dialog.townsquare_recent_topics': 'Recent Topics',
        'product_search_dialog.townsquare_teams_heading': 'Teams',
        'product_search_dialog.townsquare_teams_view_all': 'Search all teams',
        'product_search_dialog.townsquare_topics_heading': 'Topics',
        'product_search_dialog.townsquare_topics_view_all': 'Search all topics',
        'product_search_dialog.trello.archived': 'Archived',
        'product_search_dialog.trello.archived.card-hover': 'This card is archived',
        'product_search_dialog.trello.board': 'Board',
        'product_search_dialog.trello.boards_heading': 'Boards',
        'product_search_dialog.trello.cards_heading': 'Cards',
        'product_search_dialog.trello.closed': 'Closed',
        'product_search_dialog.trello.closed.board-hover': 'This board is closed',
        'product_search_dialog.trello.expanded.input-placeholder': 'Search Trello',
        'product_search_dialog.trello.feedback_link': 'Help us improve your search results!',
        'product_search_dialog.trello.list': 'List',
        'product_search_dialog.trello.private_workspace': 'Private Workspace',
        'product_search_dialog.trello.recent_boards_heading': 'Recent boards',
        'product_search_dialog.trello.workspace': 'Workspace',
        'product_search_dialog.updated_date_formatter': 'Updated {date}',
        'search_dialog.filters.group.show-more': 'Show more',
        'search_dialog.search_input_clear_label': 'Clear search session',
        'search_dialog.search_input_exit_label': 'Exit Search'
    };
});
parcelRegister("2F4hB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3sAPx").then(()=>parcelRequire('jXoZr'));
});
parcelRegister("1jfiv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8vWAn").then(()=>parcelRequire('8QdkF'));
});
parcelRegister("3fKVi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7HA1r").then(()=>parcelRequire('iqmRB'));
});
parcelRegister("6SpHw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3BzbC").then(()=>parcelRequire('hU8Wg'));
});
parcelRegister("lo0Wo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9RW1d").then(()=>parcelRequire('G6p7g'));
});
parcelRegister("9VRwF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b5XP1").then(()=>parcelRequire('8XBJD'));
});
parcelRegister("ksRlS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("byj2y").then(()=>parcelRequire('2OsED'));
});
parcelRegister("fRZgT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7sAPX").then(()=>parcelRequire('kYYal'));
});
parcelRegister("eVwsU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eeiTb").then(()=>parcelRequire('dEbhi'));
});
parcelRegister("bACZJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("EHrdN").then(()=>parcelRequire('3cACL'));
});
parcelRegister("9LtqA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("14Ui1").then(()=>parcelRequire('dJ2yL'));
});
parcelRegister("504mL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3WEpk").then(()=>parcelRequire('4mTJs'));
});
parcelRegister("2NJON", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iE9PC").then(()=>parcelRequire('e3A3t'));
});
parcelRegister("3UcgS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dv7Zj").then(()=>parcelRequire('jsrqy'));
});
parcelRegister("6S0U3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l7ce6").then(()=>parcelRequire('lB7uF'));
});
parcelRegister("5Y71T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1cODx").then(()=>parcelRequire('jGHC1'));
});
parcelRegister("6TwIL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hfK9H").then(()=>parcelRequire('a9EL3'));
});
parcelRegister("9utk6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9dTI3").then(()=>parcelRequire('50j5y'));
});
parcelRegister("1MLCk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("47p8o").then(()=>parcelRequire('l5flR'));
});
parcelRegister("dCFn2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6mMIP").then(()=>parcelRequire('2V7Za'));
});
parcelRegister("8vJD8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dUSlS").then(()=>parcelRequire('gKwhP'));
});
parcelRegister("cgqqi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("78oxQ").then(()=>parcelRequire('2SnNI'));
});
parcelRegister("dmNz1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dNsh7").then(()=>parcelRequire('cRUF7'));
});
parcelRegister("2GGgW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7keBB").then(()=>parcelRequire('1ng90'));
});
parcelRegister("cFaq2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("epd5A").then(()=>parcelRequire('j8EgG'));
});
parcelRegister("3aoIP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9XZEb").then(()=>parcelRequire('9QTmV'));
});
parcelRegister("fi1v7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hjtOe").then(()=>parcelRequire('27gZm'));
});
parcelRegister("5OPlv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hzdFQ").then(()=>parcelRequire('dKu0d'));
});
parcelRegister("3VCID", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1SjcY").then(()=>parcelRequire('k6ygv'));
});
parcelRegister("4k2KW", function(module, exports) {
    $parcel$export(module.exports, "BuildVersionAnalyticContext", ()=>$b4c67553dbafe429$export$7095b8205ce661b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $tUDIN;
    const $b4c67553dbafe429$export$7095b8205ce661b6 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: {
                frontend: (0, $7531534e67cbfa1e$export$2db401a6b81eceee)
            },
            nonPrivacySafeAnalyticContext: {}
        }, children);
});
parcelRegister("jQ6em", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c1427246b87c479$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $75NXP;
    var $6ZsPS;
    var $9c1427246b87c479$export$2e2bcd8739ae039 = ()=>{
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            fireAnalyticsEvent({
                eventType: 'operational',
                action: 'exposed',
                actionSubject: 'quickSearchExperiment',
                source: 'searchDialog'
            });
        }, [
            fireAnalyticsEvent,
            searchSessionId
        ]);
        return null;
    };
});
parcelRegister("ebv5l", function(module, exports) {
    $parcel$export(module.exports, "DialogDismissedHandler", ()=>$0656c1e6493952a0$export$50483e15753411d8);
    var $5uXOq = parcelRequire("5uXOq");
    var $gsomE;
    var $3FqY6;
    class $0656c1e6493952a0$export$b768cbf5d904a94a extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            const { onDialogClosed: onDialogClosed, isExpanded: isExpanded } = this.props;
            if (prevProps.isExpanded && !isExpanded) onDialogClosed();
        }
        render() {
            return null;
        }
    }
    const $0656c1e6493952a0$export$50483e15753411d8 = (0, (0, parcelRequire("gsomE")).withAnalytics)({
        onDialogClosed: (0, (0, parcelRequire("3FqY6")).onDismissed)
    })($0656c1e6493952a0$export$b768cbf5d904a94a);
});
parcelRegister("eARpK", function(module, exports) {
    $parcel$export(module.exports, "AsyncLoadOnQuery", ()=>$de1588b902d53d4e$export$c658105a3bdf0409);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5cPn;
    var $2dI5H;
    const $de1588b902d53d4e$export$c658105a3bdf0409 = ()=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const [isFetched, setIsFetched] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (query && isFetched === false && isExpanded) {
                (parcelRequire("blsRW"));
                (parcelRequire("2l5ol"));
                setIsFetched(true);
            }
        }, [
            query,
            isFetched,
            setIsFetched,
            isExpanded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
});
parcelRegister("2l5ol", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lTiBM").then(()=>parcelRequire('c40YO'));
});
parcelRegister("hI9zY", function(module, exports) {
    $parcel$export(module.exports, "AutocorrectionProvider", ()=>$13d3be8a5d1cfe7f$export$8ba6d08e2bcc861f);
    $parcel$export(module.exports, "useAutocorrection", ()=>$13d3be8a5d1cfe7f$export$2f6912f63e498900);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2dI5H;
    var $j4xTD;
    var $lvCts;
    const $13d3be8a5d1cfe7f$var$NO_CORRECTION = [];
    const $13d3be8a5d1cfe7f$var$AutocorrectionContext = (0, $5uXOq.createContext)({
        correction: undefined,
        setCorrection: ()=>{}
    });
    const $13d3be8a5d1cfe7f$export$8ba6d08e2bcc861f = ({ children: children })=>{
        const { autocorrectionEnabled: autocorrectionEnabled } = (0, (0, parcelRequire("j4xTD")).useAutocorrectionEnabled)();
        const [correction, setCorrection] = (0, $5uXOq.useState)($13d3be8a5d1cfe7f$var$NO_CORRECTION);
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const lang = (0, (0, parcelRequire("j4xTD")).sanitizeLanguage)(locale);
        const aggregatorClient = (0, (0, parcelRequire("lvCts")).useTypedAggregatorClient)();
        const { url: aggregatorUrl, cloudId: cloudId } = aggregatorClient?.getAggregatorConfig() || {};
        (0, $5uXOq.useEffect)(()=>{
            setCorrection($13d3be8a5d1cfe7f$var$NO_CORRECTION);
            if (autocorrectionEnabled && (0, (0, parcelRequire("j4xTD")).shouldFetchAutocorrection)(query) && aggregatorUrl && cloudId) (0, (0, parcelRequire("j4xTD")).fetchAutocorrection)({
                query: query,
                aggregatorUrl: aggregatorUrl,
                lang: lang,
                cloudId: cloudId
            }).then((result)=>{
                if (!!result.termCorrections) setCorrection(result.termCorrections);
            }).catch((_error_)=>{});
        }, [
            autocorrectionEnabled,
            query,
            aggregatorUrl,
            cloudId,
            lang
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($13d3be8a5d1cfe7f$var$AutocorrectionContext.Provider, {
            value: {
                correction: correction,
                setCorrection: setCorrection
            }
        }, children);
    };
    const $13d3be8a5d1cfe7f$export$2f6912f63e498900 = ()=>{
        return (0, $5uXOq.useContext)($13d3be8a5d1cfe7f$var$AutocorrectionContext);
    };
});
parcelRegister("ihzp7", function(module, exports) {
    $parcel$export(module.exports, "DialogShownHandler", ()=>$e3877db627479ac3$export$914029055eb3fe8e);
    var $5uXOq = parcelRequire("5uXOq");
    var $kv2Va;
    var $3FqY6;
    var $gsomE;
    const $e3877db627479ac3$export$18e8dcaf0a5a46b2 = ({ isExpanded: isExpanded, onDialogShown: onDialogShown })=>{
        const { products: products } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        (0, $5uXOq.useEffect)(()=>{
            const emitAnalyticsEvent = ()=>{
                const visibleProducts = products.map((product)=>product.title);
                const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
                onDialogShown({
                    visibleProducts: visibleProducts,
                    visibleTabsCount: visibleTabsCount
                });
            };
            isExpanded && emitAnalyticsEvent();
        }, [
            isExpanded
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    const $e3877db627479ac3$export$914029055eb3fe8e = (0, (0, parcelRequire("gsomE")).withAnalytics)({
        onDialogShown: (0, (0, parcelRequire("3FqY6")).onShown)
    })($e3877db627479ac3$export$18e8dcaf0a5a46b2);
});
parcelRegister("8zfVb", function(module, exports) {
    $parcel$export(module.exports, "QuickFindAnalyticContext", ()=>$05f4ad407d190e0b$export$bf21b659e40e8eb4);
    var $5uXOq = parcelRequire("5uXOq");
    var $tUDIN;
    const $05f4ad407d190e0b$export$bf21b659e40e8eb4 = ({ children: children, isQuickFind: isQuickFind = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("tUDIN")).SearchDialogAnalyticsContext), {
            analyticContext: {
                isQuickFind: isQuickFind
            },
            nonPrivacySafeAnalyticContext: {}
        }, children);
});
parcelRegister("5rLBT", function(module, exports) {
    $parcel$export(module.exports, "ProductTabs", ()=>$ad9945747297e609$export$f698db24bc555eee);
    var $fphHl;
    var $jxIT3;
    var $cte3m;
    var $5uXOq = parcelRequire("5uXOq");
    var $3FqY6;
    var $75NXP;
    var $4tuQr;
    var $2DWAC;
    var $i5cPn;
    var $kv2Va;
    var $gnqGE;
    const $ad9945747297e609$var$CustomTab = ({ index: index, title: title, tabRenderer: tabRenderer })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxIT3")).default), {
            key: index,
            testId: `search-dialog-product-tab-${index}`
        }, tabRenderer ? tabRenderer({
            title: title
        }) : title);
    };
    const $ad9945747297e609$export$bd4c4b880e23a953 = (props)=>{
        const { products: products, showProduct: showProduct, getActiveProduct: getActiveProduct, isExpanded: isExpanded, abTest: abTest } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const onTabClicked = (index)=>{
            const id = products[index].id;
            showProduct(products[index].id);
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onTabSelected)({
                tabName: id
            }));
        };
        const activeProductId = getActiveProduct()?.id;
        const activeProductIndex = products.findIndex((product)=>product.id === activeProductId);
        const primaryProduct = products.find((product)=>product.order === 0);
        if (activeProductIndex === -1 && isExpanded && primaryProduct && abTest) {
            showProduct(primaryProduct.id);
            return null;
        }
        if (!isExpanded || products.length === 1 || !abTest || !primaryProduct) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2DWAC")).DisableXPSAB), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnqGE")).TabControlsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fphHl")).default), {
            selected: activeProductIndex,
            onChange: onTabClicked,
            id: "tab-controls",
            shouldUnmountTabPanelOnChange: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cte3m")).default), null, products.map((product, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ad9945747297e609$var$CustomTab, {
                key: product.id,
                index: index,
                title: product.title,
                tabRenderer: product.tabRenderer
            }))))));
    };
    const $ad9945747297e609$export$f698db24bc555eee = (0, (0, parcelRequire("4tuQr")).withABTestContext)((0, (0, parcelRequire("kv2Va")).withProductContext)((0, (0, parcelRequire("i5cPn")).withDialogExpansionContext)($ad9945747297e609$export$bd4c4b880e23a953)));
});
parcelRegister("fphHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4810d6c8b7d5c95d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $dWD6q;
    var $8emiI;
    function $4810d6c8b7d5c95d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4810d6c8b7d5c95d$var$baseStyles = {
        name: "7i0hsw",
        styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
    };
    const $4810d6c8b7d5c95d$var$tabsStyles = (0, (0, parcelRequire("8emiI")).getTabsStyles)();
    const $4810d6c8b7d5c95d$var$analyticsAttributes = {
        componentName: 'tabs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>tabPanel && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabPanelContext).Provider, {
            value: {
                role: 'tabpanel',
                id: `${tabsId}-${index}-tab`,
                hidden: isSelected ? undefined : true,
                'aria-labelledby': `${tabsId}-${index}`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tabPanel);
    const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
        const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
        const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
        const selected = SelectedType === undefined ? selectedState : SelectedType;
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter((child)=>Boolean(child));
        const [tabList, ...tabPanels] = childrenArray;
        const visited = (0, $5uXOq.useRef)(new Set([
            selected
        ]));
        if (!visited.current.has(selected)) visited.current.add(selected);
        const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
            if (onChangeProp) onChangeProp(index, analyticsEvent);
            setSelected(index);
        }, [
            onChangeProp
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$4810d6c8b7d5c95d$var$analyticsAttributes
        });
        const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[selected],
            index: selected,
            isSelected: true,
            tabsId: id
        }) : Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
                tabPanel: tabPanels[tabIndex],
                index: tabIndex,
                isSelected: tabIndex === selected,
                tabsId: id
            }));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $4810d6c8b7d5c95d$var$baseStyles,
                $4810d6c8b7d5c95d$var$tabsStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabListContext).Provider, {
            value: {
                selected: selected,
                onChange: onChangeAnalytics,
                tabsId: id
            }
        }, tabList), (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, tabPanelsWithContext)));
    };
    var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;
});
parcelRegister("dWD6q", function(module, exports) {
    $parcel$export(module.exports, "TabContext", ()=>$b47499898157cfdc$export$5a5d356ca5f10a0a);
    $parcel$export(module.exports, "TabListContext", ()=>$b47499898157cfdc$export$aa6907f9fd69e93b);
    $parcel$export(module.exports, "TabPanelContext", ()=>$b47499898157cfdc$export$2054129d247c3102);
    var $5uXOq = parcelRequire("5uXOq");
    const $b47499898157cfdc$export$5a5d356ca5f10a0a = (0, $5uXOq.createContext)(null);
    const $b47499898157cfdc$export$aa6907f9fd69e93b = (0, $5uXOq.createContext)(null);
    const $b47499898157cfdc$export$2054129d247c3102 = (0, $5uXOq.createContext)(null);
});
parcelRegister("8emiI", function(module, exports) {
    $parcel$export(module.exports, "getTabsStyles", ()=>$899bec80a30728c7$export$dd5afd2190fb792c);
    $parcel$export(module.exports, "getTabListStyles", ()=>$899bec80a30728c7$export$42a3c683c377bcb2);
    $parcel$export(module.exports, "getTabListStylesOld", ()=>$899bec80a30728c7$export$f208f8acf591dbc2);
    var $f8Sb3;
    var $6VxaK;
    const $899bec80a30728c7$var$tabInlinePadding = "var(--ds-space-100, 8px)";
    const $899bec80a30728c7$var$tabBlockPadding = "var(--ds-space-075, 6px)";
    const $899bec80a30728c7$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
    const $899bec80a30728c7$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
    const $899bec80a30728c7$var$getTabPanelStyles = ()=>({
            flexGrow: 1,
            minHeight: '0%',
            display: 'flex'
        });
    const $899bec80a30728c7$export$dd5afd2190fb792c = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tabpanel"]': $899bec80a30728c7$var$getTabPanelStyles(),
            '& > [hidden]': {
                display: 'none'
            }
        });
    const $899bec80a30728c7$var$tabLineStyles = {
        content: '""',
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $899bec80a30728c7$export$42a3c683c377bcb2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $899bec80a30728c7$export$916c8b0fccbb37d2(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
            '&::before': {
                ...$899bec80a30728c7$var$tabLineStyles,
                height: "var(--ds-border-width, 1px)",
                backgroundColor: (0, (0, parcelRequire("6VxaK")).tabLineColors).lineColor
            }
        });
    const $899bec80a30728c7$export$916c8b0fccbb37d2 = ()=>{
        const colors = (0, (0, parcelRequire("6VxaK")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
    const $899bec80a30728c7$var$tabLineStylesOld = {
        content: '""',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $899bec80a30728c7$export$f208f8acf591dbc2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $899bec80a30728c7$export$442d081208938078(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
            '&::before': {
                ...$899bec80a30728c7$var$tabLineStylesOld,
                height: $899bec80a30728c7$var$underlineHeight,
                backgroundColor: (0, (0, parcelRequire("6VxaK")).tabLineColors).lineColor
            }
        });
    const $899bec80a30728c7$export$442d081208938078 = ()=>{
        const colors = (0, (0, parcelRequire("6VxaK")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
});
parcelRegister("6VxaK", function(module, exports) {
    $parcel$export(module.exports, "tabColors", ()=>$874e3836572be4cc$export$5159a1ad8efe50bc);
    $parcel$export(module.exports, "tabLineColors", ()=>$874e3836572be4cc$export$6be6fa4649b31472);
    const $874e3836572be4cc$export$5159a1ad8efe50bc = {
        labelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        activeLabelColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`,
        hoverLabelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        selectedColor: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        focusBorderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
    };
    const $874e3836572be4cc$export$6be6fa4649b31472 = {
        lineColor: `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    };
});
parcelRegister("jxIT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a23bdf24c904bdb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jhVLw;
    var $cgL5K;
    var $eQ4wW;
    const $5a23bdf24c904bdb$var$Tab = (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
        const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, (0, parcelRequire("eQ4wW")).useTab)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1
        }, children)));
    });
    var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;
});
parcelRegister("eQ4wW", function(module, exports) {
    $parcel$export(module.exports, "useTab", ()=>$4d8616502e4de6b0$export$fdf4756d5b8ef90a);
    $parcel$export(module.exports, "useTabList", ()=>$4d8616502e4de6b0$export$773e389e644c5874);
    $parcel$export(module.exports, "useTabPanel", ()=>$4d8616502e4de6b0$export$fae0121b5afe572d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWD6q;
    const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
        const tabData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabContext));
        if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
        return tabData;
    };
    const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
        const tabListData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabListContext));
        if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
        return tabListData;
    };
    const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
        const tabPanelData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabPanelContext));
        if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
        return tabPanelData;
    };
});
parcelRegister("cte3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15f9538b451f314$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $eQ4wW;
    var $dWD6q;
    var $8emiI;
    function $e15f9538b451f314$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15f9538b451f314$var$baseStyles = {
        name: "g0wsdz",
        styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
    };
    const $e15f9538b451f314$var$tabListStyles = (0, (0, parcelRequire("8emiI")).getTabListStyles)();
    const $e15f9538b451f314$var$tabListStylesOld = (0, (0, parcelRequire("8emiI")).getTabListStylesOld)();
    const $e15f9538b451f314$var$TabList = ({ children: children })=>{
        const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, (0, parcelRequire("eQ4wW")).useTabList)();
        const ref = (0, $5uXOq.createRef)();
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
        const length = childrenArray.length;
        const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
            const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
            if (newSelectedNode) newSelectedNode.focus();
            onChange(index);
        }, [
            tabsId,
            ref,
            onChange
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (![
                'ArrowRight',
                'ArrowLeft',
                'Home',
                'End'
            ].includes(e.key)) return;
            e.preventDefault();
            const lastTabIndex = length - 1;
            if ([
                'Home',
                'End'
            ].includes(e.key)) {
                const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
                selectTabByIndex(newSelected);
                return;
            }
            const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
            const modifier = e.key === 'ArrowRight' ? 1 : -1;
            let newSelected = selectedIndex + modifier;
            if (newSelected < 0 || newSelected >= length) newSelected = newSelected < 0 ? lastTabIndex : 0;
            selectTabByIndex(newSelected);
        }, [
            length,
            selectTabByIndex
        ]);
        const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabContext).Provider, {
                value: {
                    onClick: ()=>onChange(index),
                    onKeyDown: onKeyDown,
                    'aria-setsize': length,
                    role: 'tab',
                    id: `${tabsId}-${index}`,
                    'aria-posinset': index + 1,
                    'aria-selected': isSelected,
                    'aria-controls': `${tabsId}-${index}-tab`,
                    tabIndex: isSelected ? 0 : -1
                },
                key: index
            }, tab), [
            length,
            onKeyDown,
            onChange,
            tabsId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "tablist",
            ref: ref,
            css: [
                $e15f9538b451f314$var$baseStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $e15f9538b451f314$var$tabListStyles : $e15f9538b451f314$var$tabListStylesOld
            ]
        }, childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))));
    };
    var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;
});
parcelRegister("2DWAC", function(module, exports) {
    $parcel$export(module.exports, "DisableXPSAB", ()=>$4166b18629be3a52$export$67fbd6b459867ac2);
    var $5uXOq = parcelRequire("5uXOq");
    var $4tuQr;
    const $4166b18629be3a52$export$67fbd6b459867ac2 = ({ children: children })=>{
        const abTest = (0, (0, parcelRequire("4tuQr")).useABTest)();
        if (abTest?.experimentId === 'xps-hidden') return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("gnqGE", function(module, exports) {
    $parcel$export(module.exports, "TabControlsWrapper", ()=>$1514ab84f2b5017c$export$f26b9facc67e59ba);
    var $bWGt6 = parcelRequire("bWGt6");
    const $1514ab84f2b5017c$export$f26b9facc67e59ba = (0, $bWGt6.default)("div", {
        target: "et5m3c0"
    })({
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"}`
    });
});
parcelRegister("3wz5U", function(module, exports) {
    $parcel$export(module.exports, "ActiveProductSearchInput", ()=>$e63cabfbbda63efb$export$88d712058aeecea7);
    var $5uXOq = parcelRequire("5uXOq");
    var $2AbEM;
    var $kv2Va;
    var $aR1b2;
    var $2dI5H;
    var $i5cPn;
    var $4tuQr;
    var $bPysz;
    var $ghYvR;
    var $bjTHS;
    var $2k6eV;
    const $e63cabfbbda63efb$export$83ddef5d719c74b1 = ({ forwardRef: forwardRef, isExpanded: isExpanded, setIsExpanded: setIsExpanded, activeProductId: activeProductId, query: query, setQuery: setQuery, onNavigateGeneric: onNavigateGeneric, isLoading: isLoading, pageLoadMetrics: pageLoadMetrics, shouldFillContainer: shouldFillContainer })=>{
        const inputRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (pageLoadMetrics) {
                const { metric: metric, customDataGetter: customDataGetter } = pageLoadMetrics;
                metric.stop({
                    customData: customDataGetter()
                });
            }
        }, [
            pageLoadMetrics
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isExpanded) inputRef?.current?.focus();
        }, [
            isExpanded,
            inputRef,
            activeProductId
        ]);
        const ref = (0, (0, parcelRequire("aR1b2")).mergeRefCallback)(forwardRef, inputRef);
        const onOpen = (0, $5uXOq.useCallback)(()=>setIsExpanded(true), [
            setIsExpanded
        ]);
        const onBack = (0, $5uXOq.useCallback)(()=>{
            setIsExpanded(false);
        }, [
            setIsExpanded
        ]);
        const inputComponentProps = {
            activeProductId: activeProductId,
            query: query,
            setQuery: setQuery,
            forwardRef: ref,
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded,
            onOpen: onOpen,
            onNavigateGeneric: onNavigateGeneric,
            onBack: onBack,
            isLoading: isLoading,
            shouldFillContainer: shouldFillContainer
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjTHS")).GenericProductSearchInput), inputComponentProps);
    };
    const $e63cabfbbda63efb$export$88d712058aeecea7 = ({ features: features, shouldFillContainer: shouldFillContainer, ...rest })=>{
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const { query: query, setQuery: setQuery, isLoading: isLoading } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { stickySearchEnabled: stickySearchEnabled } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const abTest = (0, (0, parcelRequire("4tuQr")).useABTest)();
        const theme = (0, (0, parcelRequire("2AbEM")).useTheme)();
        const activeProduct = getActiveProduct();
        if (!abTest) return features?.interactiveSkeleton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghYvR")).ProductSearchInputSkeletonInteractive), {
            theme: theme,
            shouldFillContainer: shouldFillContainer,
            stickySearchEnabled: stickySearchEnabled,
            ...features.interactiveSkeleton
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bPysz")).ProductSearchInputSkeleton), {
            shouldFillContainer: shouldFillContainer,
            theme: theme
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e63cabfbbda63efb$export$83ddef5d719c74b1, {
            ...rest,
            shouldFillContainer: shouldFillContainer,
            activeProductId: activeProduct?.id,
            query: query,
            setQuery: setQuery,
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded,
            isLoading: isLoading
        });
    };
});
parcelRegister("ghYvR", function(module, exports) {
    $parcel$export(module.exports, "ProductSearchInputSkeletonInteractive", ()=>$3c18a1528422c7a4$export$e3798ad624b9f761);
    var $5uXOq = parcelRequire("5uXOq");
    var $2VWh9;
    var $2AbEM;
    const $3c18a1528422c7a4$export$e3798ad624b9f761 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2AbEM")).ThemeProvider), {
            partialSearchCSS: props.theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2VWh9")).SearchInputSkeletonInteractive), props));
    };
});
parcelRegister("2VWh9", function(module, exports) {
    $parcel$export(module.exports, "SearchInputSkeletonInteractive", ()=>$8f3a15c2a2955cf8$export$fca483ab36e9fec9);
    var $5uXOq = parcelRequire("5uXOq");
    var $9enEu;
    var $3bWiA;
    var $3ZeOg;
    var $j1SOM;
    const $8f3a15c2a2955cf8$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
        const checkedForInputSkeletonState = (0, $5uXOq.useRef)(false);
        if (!checkedForInputSkeletonState.current) {
            if (!window.inputSkeletonState) (0, (0, parcelRequire("j1SOM")).resetInputSkeletonState)();
            checkedForInputSkeletonState.current = true;
        }
        const searchInputRef = (0, $5uXOq.useRef)(null);
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)((0, (0, parcelRequire("j1SOM")).getInputSkeletonFocus)());
        const [value, setValue] = (0, $5uXOq.useState)(()=>{
            const stickySearchQuery = (0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_QUERY_KEY));
            return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, (0, parcelRequire("j1SOM")).getInputSkeletonQuery)();
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            (0, (0, parcelRequire("j1SOM")).removeInputSkeletonEventListeners)();
            const isFoucsed = (0, (0, parcelRequire("j1SOM")).getInputSkeletonFocus)();
            const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, (0, parcelRequire("j1SOM")).getInputSkeletonSelection)();
            if (isFoucsed) {
                searchInputRef?.current?.focus();
                searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }, []);
        const onFocus = ()=>{
            setIsExpanded(true);
            (0, (0, parcelRequire("j1SOM")).setInputSkeletonIsFocus)(true);
            searchInputRef?.current?.focus();
        };
        const onBlur = ()=>{
            setIsExpanded(false);
            (0, (0, parcelRequire("j1SOM")).setInputSkeletonIsFocus)(false);
            if (!stickySearchEnabled) {
                setValue('');
                (0, (0, parcelRequire("j1SOM")).setInputSkeletonQuery)('');
                (0, (0, parcelRequire("j1SOM")).setInputSkeletonSelection)(0, 0, 'none');
            }
        };
        const onKeyDown = (e)=>{
            if (e.key === 'Escape') {
                searchInputRef?.current?.blur();
                onBlur();
            }
        };
        const onInput = (newValue)=>{
            setValue(newValue);
            (0, (0, parcelRequire("j1SOM")).setInputSkeletonQuery)(newValue);
            (0, (0, parcelRequire("j1SOM")).setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
            if (stickySearchEnabled) (0, (0, parcelRequire("3ZeOg")).setSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_QUERY_KEY), newValue);
        };
        const onSelect = ()=>{
            (0, (0, parcelRequire("j1SOM")).setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        };
        (0, $5uXOq.useEffect)(()=>{
            let storedSearchInputRef = null;
            if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
            return ()=>{
                if (storedSearchInputRef) {
                    (0, (0, parcelRequire("j1SOM")).setInputSkeletonQuery)(storedSearchInputRef.value);
                    (0, (0, parcelRequire("j1SOM")).setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                    (0, (0, parcelRequire("j1SOM")).setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
                }
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9enEu")).SearchAnchor), {
            isExpanded: isExpanded,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: onKeyDown,
            shouldFillContainer: shouldFillContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bWiA")).default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        }));
    };
});
parcelRegister("3bWiA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11a67e855bc3630f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $bu8Mq;
    var $42CjB;
    var $2AbEM;
    var $6I8Kl;
    var $b9NEf;
    var $lWgWi;
    const $11a67e855bc3630f$var$MAX_INPUT_LENGTH = 500;
    const $11a67e855bc3630f$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer })=>{
        const handleInput = (e)=>{
            if (onInput) onInput(e.currentTarget.value);
        };
        const handleClick = (e)=>{
            if (onClick) onClick(e);
        };
        const handleTabEnter = (e)=>{
            if (e.key === 'Enter' && onClick) onClick();
        };
        const handleKeyDown = (e)=>{
            if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
            if (!e.defaultPrevented && e.key === 'Enter') {
                e.preventDefault();
                onEnter && onEnter(e);
            }
        };
        const handleSelect = (e)=>{
            if (onSelect) onSelect(e);
        };
        const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, (0, parcelRequire("b9NEf")).HiddenTooltip);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            component: TooltipComponent,
            position: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).MobileSearchIconWrapper), {
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            label: "Search",
            onClick: handleClick,
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
                    theme: theme,
                    isExpanded: isExpanded,
                    size: "medium"
                })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).DesktopSearchIconWrapper), {
            ...theme,
            isExpanded: isExpanded,
            onKeyPress: handleTabEnter
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
            theme: theme,
            isExpanded: isExpanded
        })), isExpanded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).ArrowIconWrapper), {
            ...theme,
            onClick: onBack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bu8Mq"))))), {
            label: exitSearchLabel || 'Exit Search',
            LEGACY_size: "large",
            color: "currentColor"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SearchInputField), {
            "data-test-id": "search-dialog-input",
            onInput: handleInput,
            onChange: handleInput,
            onKeyDown: handleKeyDown,
            onClick: handleClick,
            onSelect: handleSelect,
            isExpanded: isExpanded,
            placeholder: placeholder,
            ref: forwardRef || undefined,
            value: value,
            maxLength: $11a67e855bc3630f$var$MAX_INPUT_LENGTH,
            "aria-label": placeholder,
            ...theme
        }), (showClearButton || !!toggleAISearchButton) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lWgWi")).SearchInputOverlay), {
            theme: theme,
            showClearButton: showClearButton,
            onClear: onClear,
            allowChangeExpand: allowChangeExpand,
            clearSearchLabel: clearSearchLabel,
            toggleAISearchButton: toggleAISearchButton
        })));
    };
    var $11a67e855bc3630f$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const theme = (0, (0, parcelRequire("2AbEM")).useTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($11a67e855bc3630f$export$55d7609a8f1eccd2, {
            ...props,
            theme: theme,
            forwardRef: ref
        });
    });
});
parcelRegister("lWgWi", function(module, exports) {
    $parcel$export(module.exports, "SearchInputOverlay", ()=>$55ed4baddf3d1eb5$export$bde709da22d710bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9NEf;
    var $ip0rq;
    const $55ed4baddf3d1eb5$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).InputBoxOverlayRight), null, showClearButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).ClearIconWrapper), {
            ...theme,
            role: "button",
            onClick: onClear,
            onMouseEnter: ()=>{
                allowChangeExpand?.(false);
            },
            onMouseLeave: ()=>{
                allowChangeExpand?.(true);
            },
            tabIndex: 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ip0rq"))))), {
            color: "currentColor",
            label: clearSearchLabel || 'Clear search session',
            LEGACY_size: "small"
        })), toggleAISearchButton);
    };
});
parcelRegister("ip0rq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d65ae76e92cae981$var$_react = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d65ae76e92cae981$var$_crossCircle = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("hI6SY")));
    var $d65ae76e92cae981$var$_selectClear = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("673MF")));
    function $d65ae76e92cae981$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d65ae76e92cae981$var$CrossCircleIcon = (props)=>$d65ae76e92cae981$var$_react.default.createElement($d65ae76e92cae981$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $d65ae76e92cae981$var$_selectClear.default
        }, props));
    $d65ae76e92cae981$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $d65ae76e92cae981$var$_default = module.exports.default = $d65ae76e92cae981$var$CrossCircleIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("bjTHS", function(module, exports) {
    $parcel$export(module.exports, "GenericProductSearchInput", ()=>$dfb8c51fd095fc5a$export$372be6d3f9d3f49);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $jn29h;
    var $k4hbD;
    var $kv2Va;
    var $hNXQY;
    var $4QKbG;
    const $dfb8c51fd095fc5a$var$debounceTime = 250;
    const $dfb8c51fd095fc5a$var$GenericInputWithIntl = ({ activeProductId: activeProductId, intl: intl, onNavigateGeneric: onNavigateGeneric, query: query, isExpanded: isExpanded, isLoading: isLoading, onOpen: onOpen, forwardRef: forwardRef, onBack: onBack, setQuery: setQuery, shouldFillContainer: shouldFillContainer })=>{
        const { getProduct: getProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        const { queryParams: queryParams } = (0, (0, parcelRequire("4QKbG")).useQueryParams)();
        const queryParamText = queryParams?.text?.toString() || '';
        const onNavigateGenericInput = (0, $5uXOq.useCallback)((productId)=>(href, event)=>{
                if (href) onNavigateGeneric(productId, href, event);
            }, [
            onNavigateGeneric
        ]);
        const setQueryRef = (0, $5uXOq.useRef)(setQuery);
        (0, $5uXOq.useEffect)(()=>{
            setQueryRef.current = setQuery;
        }, [
            setQuery
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isGriffinNavEnabled) setQueryRef.current(queryParamText);
        }, [
            isGriffinNavEnabled,
            queryParamText,
            setQueryRef
        ]);
        const { advancedSearchUrl: advancedSearchUrl, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, onNavigate: onNavigate, actionSubjectId: actionSubjectId, expandedStateInputPlaceholder: expandedStateInputPlaceholder } = (()=>{
            if (!activeProductId || !getProduct(activeProductId)) return {
                advancedSearchUrl: '',
                secondaryAdvancedSearchURL: '',
                onNavigate: isGriffinNavEnabled ? onNavigateGenericInput('') : ()=>{},
                actionSubjectId: 'noActiveProduct'
            };
            return {
                advancedSearchUrl: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query) || '',
                secondaryAdvancedSearchURL: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query, undefined, 'onInputEnterModified') || '',
                expandedStateInputPlaceholder: getProduct(activeProductId)?.expandedStateInputPlaceholder || '',
                onNavigate: onNavigateGenericInput(activeProductId),
                actionSubjectId: activeProductId
            };
        })();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jn29h")).ProductSearchInput), {
            shouldFillContainer: shouldFillContainer,
            forwardRef: forwardRef,
            value: query,
            isExpanded: isExpanded,
            isLoading: isLoading,
            onOpen: onOpen,
            debounceTime: $dfb8c51fd095fc5a$var$debounceTime,
            advancedSearchURL: advancedSearchUrl,
            secondaryAdvancedSearchURL: secondaryAdvancedSearchURL,
            actionSubjectId: actionSubjectId,
            onBack: onBack,
            onInput: setQuery,
            expandedPlaceholder: expandedStateInputPlaceholder ? expandedStateInputPlaceholder : intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_search_input_collapsed_placeholder),
            collapsedPlaceholder: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_search_input_collapsed_placeholder),
            onNavigate: onNavigate
        });
    };
    const $dfb8c51fd095fc5a$export$372be6d3f9d3f49 = (0, (0, parcelRequire("8RXs9")).default)($dfb8c51fd095fc5a$var$GenericInputWithIntl);
});
parcelRegister("jn29h", function(module, exports) {
    $parcel$export(module.exports, "ProductSearchInput", ()=>$3378b59567d048c9$export$1ea4f29215db3ad6);
    var $7aggy;
    var $j1SOM;
    var $3ZeOg;
    var $3bWiA;
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $agEiU;
    var $8oG5R;
    var $lYEL5;
    var $75NXP;
    var $3FqY6;
    var $6ZsPS;
    var $k4hbD;
    var $aR1b2;
    var $2k6eV;
    var $i5cPn;
    var $kv2Va;
    var $2dI5H;
    var $7ttuB;
    var $hNXQY;
    var $4QKbG;
    const $3378b59567d048c9$var$SearchAIPromptComponent = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8gwjq")).then(({ SearchAIPrompt: SearchAIPrompt })=>({
                default: SearchAIPrompt
            })));
    const $3378b59567d048c9$var$AskAIButton = ()=>{
        const { query: query } = (0, (0, parcelRequire("2dI5H")).useQuery)();
        const queryHash = (0, (0, parcelRequire("8oG5R")).sha256Hash)(query);
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const activeProduct = getActiveProduct();
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        const handleToggleShowSearchAIDialog = (0, $5uXOq.useCallback)((show)=>{
            if (isGriffinNavEnabled) setIsExpanded(show);
            toggleShowSearchAIDialog(show);
        }, [
            isGriffinNavEnabled,
            setIsExpanded,
            toggleShowSearchAIDialog
        ]);
        return !!activeProduct?.aiSearchConfig || !!showSearchAIDialog && isExpanded || isGriffinNavEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3378b59567d048c9$var$SearchAIPromptComponent, {
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            onToggleShowSearchAIDialog: handleToggleShowSearchAIDialog,
            source: "searchDialog"
        })) : null;
    };
    const $3378b59567d048c9$var$getTooltipContent = (message)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agEiU")).KeyboardShortcutContainer), null, message, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agEiU")).KeyboardShortcut), null, '/'));
    class $3378b59567d048c9$export$f964308946b6123b extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            const { onInput: onInput, stickySearchEnabled: stickySearchEnabled } = this.props;
            const skeletonFocused = (0, (0, parcelRequire("j1SOM")).getInputSkeletonFocus)();
            const skeletonQuery = (0, (0, parcelRequire("j1SOM")).getInputSkeletonQuery)();
            const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, (0, parcelRequire("j1SOM")).getInputSkeletonSelection)();
            const stickySearchQuery = (0, (0, parcelRequire("3ZeOg")).getSessionItem)((0, (0, parcelRequire("3ZeOg")).SEARCH_QUERY_KEY)) || '';
            if (skeletonFocused) {
                this.expand((0, (0, parcelRequire("3FqY6")).Trigger).CLICK);
                onInput?.(skeletonQuery);
                if (this.ref) {
                    this.ref.value = skeletonQuery;
                    this.ref.focus();
                    this.ref?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
                }
            }
            (0, (0, parcelRequire("j1SOM")).removeInputSkeletonState)();
            if (stickySearchEnabled && stickySearchQuery) onInput?.(stickySearchQuery);
        }
        render() {
            const { value: value, isExpanded: isExpanded, expandedPlaceholder: expandedPlaceholder, collapsedPlaceholder: collapsedPlaceholder, debounceTime: debounceTime, intl: intl, showAIToggleButton: showAIToggleButton, isQuickFind: isQuickFind, ...rest } = this.props;
            const placeholder = isExpanded ? expandedPlaceholder : collapsedPlaceholder;
            const tooltipContent = $3378b59567d048c9$var$getTooltipContent(intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_search_input_collapsed_placeholder));
            const SearchInputComponent = isQuickFind ? (0, (0, parcelRequire("7aggy")).default) : (0, (0, parcelRequire("3bWiA")).default);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lYEL5")).default), {
                query: value,
                debounceTime: debounceTime
            }) : null, (0, ($parcel$interopDefault($5uXOq))).createElement(SearchInputComponent, {
                ...rest,
                onClick: this.onInputClick,
                onInput: this.onInput,
                ref: this.onRef,
                isExpanded: isExpanded,
                placeholder: placeholder,
                value: value,
                onEnter: this.onEnter,
                onClear: this.onClear,
                toggleAISearchButton: showAIToggleButton ? (0, ($parcel$interopDefault($5uXOq))).createElement($3378b59567d048c9$var$AskAIButton, null) : undefined,
                tooltipContent: tooltipContent,
                exitSearchLabel: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_search_input_exit_button_label),
                clearSearchLabel: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_search_input_clear_button_label),
                ...isQuickFind && {
                    ariaLabelContent: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).common_search_input_enlarged_aria_label)
                }
            }));
        }
        constructor(...args){
            super(...args), this.ref = null, this.onInput = (value)=>{
                if (value !== this.props.value) {
                    this.expand((0, (0, parcelRequire("3FqY6")).Trigger).TEXT_ENTERED);
                    this.props.onInput?.(value);
                }
            }, this.expand = (trigger)=>{
                const { isExpanded: isExpanded, onOpen: onOpen, preQueryScreenViewed: preQueryScreenViewed, searchSessionId: searchSessionId } = this.props;
                if (!isExpanded) {
                    onOpen();
                    preQueryScreenViewed({
                        searchSessionId: searchSessionId,
                        trigger: trigger
                    });
                }
            }, this.close = (e)=>{
                const { isExpanded: isExpanded, onBack: onBack } = this.props;
                if (isExpanded) onBack?.(e);
            }, this.onInputClick = ()=>{
                setTimeout(()=>this.ref?.focus());
                this.expand((0, (0, parcelRequire("3FqY6")).Trigger).CLICK);
            }, this.onEnter = (event)=>{
                const { isExpanded: isExpanded, onEnter: onEnter } = this.props;
                if (isExpanded) onEnter?.(event);
            }, this.onClear = ()=>{
                setTimeout(()=>this.ref?.focus());
                this.props.onClear?.();
            }, this.onRef = (0, (0, parcelRequire("aR1b2")).mergeRefCallback)(this.props.forwardRef, (ref)=>{
                this.ref = ref;
            });
        }
    }
    const $3378b59567d048c9$export$b12c0eea3d812057 = (0, (0, parcelRequire("8RXs9")).default)($3378b59567d048c9$export$f964308946b6123b);
    const $3378b59567d048c9$export$1ea4f29215db3ad6 = (props)=>{
        const [_ignore, persistRecentSearchOnEnter] = (0, (0, parcelRequire("7ttuB")).usePersistRecentSearches)();
        const { actionSubjectId: actionSubjectId, advancedSearchURL: advancedSearchURL, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, isLoading: isLoading, onNavigate: onNavigate, ...rest } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { stickySearchEnabled: stickySearchEnabled, query: query, resetSearchSession: resetSearchSession, showSearchAIDialog: showSearchAIDialog } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const { allowChangeExpand: allowChangeExpand } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { getActiveProduct: getActiveProduct } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const { quickFind: quickFind, isGriffinNavEnabled: isGriffinNavEnabled } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        const showSearchOnEnter = !!getActiveProduct()?.showSearchOnEnter;
        const invokePostQuerySearchRef = getActiveProduct()?.invokePostQuerySearchRef;
        const activeProduct = getActiveProduct();
        const showAskAIButton = (0, $5uXOq.useMemo)(()=>{
            if (activeProduct) return !!activeProduct.aiSearchConfig;
            return query.length > 0;
        }, [
            query,
            activeProduct
        ]);
        const aiSearchEnabled = isGriffinNavEnabled ? showAskAIButton : !!getActiveProduct()?.aiSearchConfig || !!showSearchAIDialog;
        const isQuickFind = quickFind?.enabled;
        const { queryParams: queryParams } = (0, (0, parcelRequire("4QKbG")).useQueryParams)();
        const onEnter = (0, $5uXOq.useCallback)((event)=>{
            persistRecentSearchOnEnter(event);
            if (showSearchAIDialog) return;
            if (showSearchOnEnter && !event?.shiftKey) {
                if (invokePostQuerySearchRef) {
                    fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onNonDebouncedSearchTriggered)());
                    invokePostQuerySearchRef.current();
                }
                return;
            }
            const modifierKeyPressed = navigator.userAgent.includes('Mac') ? event.metaKey : event.ctrlKey;
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onAdvancedSearchSelected)({
                actionSubjectId: actionSubjectId,
                isLoading: isLoading,
                newTab: false,
                trigger: modifierKeyPressed ? (0, (0, parcelRequire("3FqY6")).Trigger).SHORTCUT_MODIFIED : (0, (0, parcelRequire("3FqY6")).Trigger).SHORTCUT
            }));
            if (stickySearchEnabled && advancedSearchURL && !isGriffinNavEnabled) resetSearchSession();
            if (isGriffinNavEnabled) event.currentTarget.blur();
            onNavigate(modifierKeyPressed && secondaryAdvancedSearchURL ? secondaryAdvancedSearchURL : advancedSearchURL, event);
        }, [
            persistRecentSearchOnEnter,
            showSearchAIDialog,
            showSearchOnEnter,
            fireAnalyticsEvent,
            actionSubjectId,
            isLoading,
            stickySearchEnabled,
            advancedSearchURL,
            onNavigate,
            secondaryAdvancedSearchURL,
            invokePostQuerySearchRef,
            resetSearchSession,
            isGriffinNavEnabled
        ]);
        const onClear = (0, $5uXOq.useCallback)(()=>{
            fireAnalyticsEvent((0, (0, parcelRequire("3FqY6")).onXButtonClicked)({
                actionSubjectId: actionSubjectId,
                searchSessionId: searchSessionId
            }));
            resetSearchSession();
            allowChangeExpand(true);
        }, [
            fireAnalyticsEvent,
            actionSubjectId,
            searchSessionId,
            resetSearchSession,
            allowChangeExpand
        ]);
        const onPreQueryScreenViewedCB = (0, $5uXOq.useCallback)((preQueryProps)=>fireAnalyticsEvent({
                ...(0, (0, parcelRequire("3FqY6")).onPreQueryScreenViewed)(preQueryProps),
                actionSubject: actionSubjectId
            }), [
            fireAnalyticsEvent,
            actionSubjectId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3378b59567d048c9$export$b12c0eea3d812057, {
            ...rest,
            onEnter: onEnter,
            searchSessionId: searchSessionId,
            preQueryScreenViewed: onPreQueryScreenViewedCB,
            onClear: onClear,
            showClearButton: stickySearchEnabled && query !== '',
            allowChangeExpand: allowChangeExpand,
            stickySearchEnabled: stickySearchEnabled,
            showSearchOnEnter: showSearchOnEnter,
            showAIToggleButton: aiSearchEnabled,
            isLoading: isLoading,
            onNavigate: onNavigate,
            isQuickFind: isQuickFind,
            isGriffinNavEnabled: isGriffinNavEnabled,
            queryParams: queryParams
        });
    };
});
parcelRegister("7aggy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dc50a9c0bd82455$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $bu8Mq;
    var $42CjB;
    var $2AbEM;
    var $6I8Kl;
    var $b9NEf;
    var $znWph;
    var $d78H7;
    const $2dc50a9c0bd82455$var$MAX_INPUT_LENGTH = 500;
    const $2dc50a9c0bd82455$export$33e4ffe00576d3b4 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, shouldFillContainer: shouldFillContainer, onSelect: onSelect, ariaLabelContent: ariaLabelContent })=>{
        const handleInput = (e)=>{
            if (onInput) onInput(e.currentTarget.value);
        };
        const handleClick = (e)=>{
            if (onClick) onClick(e);
        };
        const handleKeyDown = (e)=>{
            if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
            if (!e.defaultPrevented && e.key === 'Enter') {
                e.preventDefault();
                onEnter && onEnter(e);
            }
        };
        const handleSelect = (e)=>{
            if (onSelect) onSelect(e);
        };
        const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, (0, parcelRequire("b9NEf")).HiddenTooltip);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            component: TooltipComponent,
            position: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).MobileSearchIconWrapper), {
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            onClick: handleClick,
            label: "Search",
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
                    theme: theme,
                    isExpanded: isExpanded,
                    size: "small"
                })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("znWph")).EnlargedDesktopSearchIconWrapper), {
            ...theme,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6I8Kl")).SearchIcon), {
            theme: theme,
            isExpanded: isExpanded,
            size: isExpanded ? 'medium' : 'small',
            primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        })), isExpanded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).ArrowIconWrapper), {
            ...theme,
            onClick: onBack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bu8Mq"))))), {
            label: exitSearchLabel || 'Exit Search',
            LEGACY_size: "large",
            color: "currentColor"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("znWph")).EnlargedSearchInputField), {
            "data-test-id": "search-dialog-input",
            onInput: handleInput,
            onChange: handleInput,
            onKeyDown: handleKeyDown,
            onClick: handleClick,
            onSelect: handleSelect,
            isExpanded: isExpanded,
            placeholder: placeholder,
            ref: forwardRef || undefined,
            value: value,
            maxLength: $2dc50a9c0bd82455$var$MAX_INPUT_LENGTH,
            "aria-label": ariaLabelContent || placeholder,
            ...theme
        }), showClearButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d78H7")).EnlargedSearchInputOverlay), {
            theme: theme,
            showClearButton: showClearButton,
            onClear: onClear,
            allowChangeExpand: allowChangeExpand,
            clearSearchLabel: clearSearchLabel,
            isExpanded: isExpanded
        })));
    };
    var $2dc50a9c0bd82455$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const theme = (0, (0, parcelRequire("2AbEM")).useTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2dc50a9c0bd82455$export$33e4ffe00576d3b4, {
            ...props,
            theme: theme,
            forwardRef: ref
        });
    });
});
parcelRegister("znWph", function(module, exports) {
    $parcel$export(module.exports, "EnlargedDesktopSearchIconWrapper", ()=>$c3baf951aebf86a1$export$3324ef4e3e3970dc);
    $parcel$export(module.exports, "EnlargedClearIconWrapper", ()=>$c3baf951aebf86a1$export$68bd88880d49fc5);
    $parcel$export(module.exports, "EnlargedSearchInputField", ()=>$c3baf951aebf86a1$export$aa34c63c6bd8fcb0);
    var $3JZ8k;
    var $b9NEf;
    var $bWGt6 = parcelRequire("bWGt6");
    const $c3baf951aebf86a1$export$3324ef4e3e3970dc = (0, $bWGt6.default)((0, (0, parcelRequire("b9NEf")).DesktopSearchIconWrapper), {
        target: "e4mn9mz2"
    })("width:", (props)=>props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).enlargedInputFieldHeight).half().px : (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";height:", (props)=>props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).enlargedInputFieldHeight).half().px : (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px, ";top:", (props)=>props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).grid).multiple(1.5).px : (0, (0, parcelRequire("3JZ8k")).grid).px, ";left:", (props)=>props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).grid).multiple(2).px : (0, (0, parcelRequire("3JZ8k")).grid).px, ";display:flex;align-items:center;");
    const $c3baf951aebf86a1$export$68bd88880d49fc5 = (0, $bWGt6.default)((0, (0, parcelRequire("b9NEf")).ClearIconWrapper), {
        target: "e4mn9mz1"
    })("width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);padding-top:0;padding-bottom:0;padding-left:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-150, 12px)"}` : '0', ";padding-right:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-200, 16px)"}` : '2px', ";color:", `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`, ";");
    const $c3baf951aebf86a1$export$aa34c63c6bd8fcb0 = (0, $bWGt6.default)((0, (0, parcelRequire("b9NEf")).SearchInputField), {
        target: "e4mn9mz0"
    })("display:flex;align-items:center;height:", (props)=>props.isExpanded ? (0, (0, parcelRequire("3JZ8k")).enlargedInputFieldHeight).px : (0, (0, parcelRequire("3JZ8k")).inputFieldHeight).px, ";border-radius:", (props)=>props.isExpanded ? '8px' : '5px', ";padding:", (props)=>props.isExpanded ? `${"var(--ds-space-150, 12px)"} 52px ${"var(--ds-space-150, 12px)"} 52px` : `0px ${"var(--ds-space-300, 24px)"} 0px 30px`, ";:focus{border:none;box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, (0, parcelRequire("3JZ8k")).grid).multiple(0.5).px + ' ' + (0, (0, parcelRequire("3JZ8k")).grid).px + ' ' + (0, $829f609a65d26a98$export$7d3359664e8bb0e5) + ', 0 0 1px ' + (0, $829f609a65d26a98$export$d2d3bedfb276cac0)})`, ";}");
});
parcelRegister("d78H7", function(module, exports) {
    $parcel$export(module.exports, "EnlargedSearchInputOverlay", ()=>$34a2e607a591d65f$export$cfdb69c9b0b1fec);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9NEf;
    var $2jwCH;
    var $znWph;
    const $34a2e607a591d65f$export$cfdb69c9b0b1fec = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, isExpanded: isExpanded })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9NEf")).InputBoxOverlayRight), null, showClearButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("znWph")).EnlargedClearIconWrapper), {
            ...theme,
            role: "button",
            onClick: onClear,
            onMouseEnter: ()=>{
                allowChangeExpand?.(false);
            },
            onMouseLeave: ()=>{
                allowChangeExpand?.(true);
            },
            tabIndex: 0,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2jwCH"))))), {
            color: "currentColor",
            label: clearSearchLabel || 'Clear search session',
            LEGACY_size: "medium",
            spacing: "spacious"
        })));
    };
});
parcelRegister("2jwCH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));
    var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>$1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
            LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
        }, props));
    $1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
    var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("agEiU", function(module, exports) {
    $parcel$export(module.exports, "KeyboardShortcutContainer", ()=>$c11edbcf060d4242$export$e2deb14b255cffa0);
    $parcel$export(module.exports, "KeyboardShortcut", ()=>$c11edbcf060d4242$export$47a1bf8d9994c680);
    var $bWGt6 = parcelRequire("bWGt6");
    function $c11edbcf060d4242$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c11edbcf060d4242$export$e2deb14b255cffa0 = (0, $bWGt6.default)("div", {
        target: "e19ugnpx1"
    })({
        name: "1buofu5",
        styles: "display:flex;line-height:16px;align-items:center;padding-bottom:var(--ds-space-025, 2px);padding-top:var(--ds-space-025, 2px)"
    });
    const $c11edbcf060d4242$export$47a1bf8d9994c680 = (0, $bWGt6.default)("div", {
        target: "e19ugnpx0"
    })({
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        border: `1px solid ${`var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`}`,
        borderRadius: '2px',
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
        lineHeight: '16px'
    });
});
parcelRegister("lYEL5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b889dd0552f6aff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3FqY6;
    var $gsomE;
    var $lFKmC = parcelRequire("lFKmC");
    class $8b889dd0552f6aff$export$6cdeb9eeefdb65f3 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            const { query: query } = this.props;
            if (prevProps.query !== query) setTimeout(()=>this.textEntered());
        }
        componentWillUnmount() {
            this.textEntered.cancel();
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args), this.textEntered = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                const { textEntered: textEntered } = this.props;
                textEntered();
            }, this.props.debounceTime || 0);
        }
    }
    var $8b889dd0552f6aff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("gsomE")).withAnalytics)({
        textEntered: (0, (0, parcelRequire("3FqY6")).onTextEntered)
    })($8b889dd0552f6aff$export$6cdeb9eeefdb65f3);
});
parcelRegister("8gwjq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lWHV5").then(()=>parcelRequire('3Htia'));
});
parcelRegister("7Givh", function(module, exports) {
    $parcel$export(module.exports, "useAppliedFilters", ()=>$7b67174a3474dde8$export$51b04ed1f44b6aaf);
    var $bONub;
    var $3UF9C;
    const $7b67174a3474dde8$export$51b04ed1f44b6aaf = (activeProductId)=>{
        const { filterDefinitions: filterDefinitions } = (0, (0, parcelRequire("3UF9C")).useGenericFilters)();
        let appliedFilters = [];
        const filters = filterDefinitions[activeProductId];
        if (filters !== undefined) filters.forEach((filter)=>{
            if (filter.mapSelectionToAppliedValue) {
                const valueToApply = filter.mapSelectionToAppliedValue();
                !!valueToApply && appliedFilters.push(valueToApply);
            } else {
                let applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.id);
                if (filter['@type'] === (0, (0, parcelRequire("bONub")).SITE_FILTER_TYPE_NAME) && applied.length === 0) applied = filter.store.availableFilters.slice(0, 3).map((filter)=>filter.id);
                if (filter['@type'] === 'spaces') applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.spaceKey || '');
                if (applied.length > 0) appliedFilters.push({
                    '@type': filter['@type'],
                    [filter.fieldName]: applied
                });
            }
        });
        return appliedFilters;
    };
});
parcelRegister("dnjeJ", function(module, exports) {
    $parcel$export(module.exports, "useUFOComponentExperience", ()=>$44448c24118cb590$export$30ab340faaed55d4);
    var $5uXOq = parcelRequire("5uXOq");
    const $44448c24118cb590$var$useConstructor = (callback)=>{
        const hasBeenFired = (0, $5uXOq.useRef)(false);
        if (!hasBeenFired.current) {
            callback();
            hasBeenFired.current = true;
        }
        return null;
    };
    const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                experience.abort();
            };
        }, []);
        $44448c24118cb590$var$useConstructor(()=>experience.start());
        return null;
    };
});
parcelRegister("gNiXZ", function(module, exports) {
    $parcel$export(module.exports, "ActiveProductProvider", ()=>$a0aa6cb8c87f81f6$export$8cce9f9e667fae48);
    var $5uXOq = parcelRequire("5uXOq");
    var $kv2Va;
    var $2k6eV;
    const $a0aa6cb8c87f81f6$export$8cce9f9e667fae48 = ({ children: children })=>{
        const { getActiveProduct: getActiveProduct, getDefaultAIConfig: getDefaultAIConfig } = (0, (0, parcelRequire("kv2Va")).useProductContext)();
        const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, (0, parcelRequire("2k6eV")).useSessionUserInput)();
        const onCloseAIDialog = (0, $5uXOq.useCallback)(()=>{
            toggleShowSearchAIDialog(false);
        }, [
            toggleShowSearchAIDialog
        ]);
        const defaultAIConfig = getDefaultAIConfig();
        return children({
            activeProduct: getActiveProduct(),
            showSearchAIDialog: showSearchAIDialog,
            onCloseAIDialog: onCloseAIDialog,
            defaultAIConfig: defaultAIConfig
        });
    };
});
parcelRegister("5ZS4j", function(module, exports) {
    $parcel$export(module.exports, "ProductSearchDialogWrapper", ()=>$d690986f2d02d893$export$99f979ec765e5f8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $jj80G;
    var $i5cPn;
    var $hNXQY;
    const $d690986f2d02d893$export$99f979ec765e5f8f = ({ children: children, shouldFillContainer: shouldFillContainer })=>{
        const { isExpanded: isExpanded } = (0, (0, parcelRequire("i5cPn")).useDialogExpansionContext)();
        const { quickFind: quickFind } = (0, (0, parcelRequire("hNXQY")).useFeaturesContext)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jj80G")).SearchDialog), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            style: {
                boxShadow: isExpanded ? undefined : 'none',
                borderRadius: quickFind?.enabled ? "var(--ds-space-100, 8px)" : undefined
            }
        }, children);
    };
});
parcelRegister("jj80G", function(module, exports) {
    $parcel$export(module.exports, "SearchDialog", ()=>$0c0b33d125acba1d$export$2aadebb53f6015f6);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bKWp;
    const $0c0b33d125acba1d$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bKWp")).SearchDialogWrapper), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            "data-test-id": "search-dialog-dialog-wrapper",
            tabIndex: -1,
            style: style
        }, children);
});
parcelRegister("eyPmZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8bGFX")
    ]).then(()=>parcelRequire('7sXJw'));
});
parcelRegister("ffvO4", function(module, exports) {
    $parcel$export(module.exports, "OpsgenieTab", ()=>$4140a4c6d2998b1d$export$7571e7fdcc46c96b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $f4GCr;
    var $k4hbD;
    var $3UM2O;
    var $8Xs9r;
    var $eGmm9;
    var $k5VJd;
    const $4140a4c6d2998b1d$var$OPSGENIE_PRODUCT_ID = 'opsgenie';
    const $4140a4c6d2998b1d$export$864cff1b26c75e89 = (alert)=>{
        return {
            title: alert.message,
            id: alert.id,
            meta: alert.status.charAt(0).toUpperCase() + alert.status.slice(1),
            url: alert.link,
            iconUrl: alert.iconURI,
            containerId: ''
        };
    };
    const $4140a4c6d2998b1d$export$527d10d7fdeeea4e = ({ intl: intl, cloudId: cloudId, generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl, hostUrl: hostUrl, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, ...rest })=>{
        const urlGeneratorArguments = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                hostUrl: hostUrl
            }), [
            cloudId,
            hostUrl
        ]);
        const { viewAllLinkGenerator: viewAllLinkGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, (0, parcelRequire("k5VJd")).useOpsgenieURLGenerators)(urlGeneratorArguments);
        const sections = [
            {
                id: (0, (0, parcelRequire("eGmm9")).OpsgenieScope).OpsgenieAlert,
                title: intl.formatMessage((0, (0, parcelRequire("3UM2O")).messages).opsgenie_alerts_heading),
                scope: (0, (0, parcelRequire("eGmm9")).OpsgenieScope).OpsgenieAlert,
                showResultCount: true,
                viewAllLinkGenerator: viewAllLinkGenerator,
                resultMapper: ({ results: results })=>results.map((value)=>$4140a4c6d2998b1d$export$864cff1b26c75e89(value))
            }
        ];
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)($4140a4c6d2998b1d$var$OPSGENIE_PRODUCT_ID, sections, {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        });
        const preQuerySectionTitleGenerator = (0, $5uXOq.useCallback)((section)=>section.id === (0, (0, parcelRequire("eGmm9")).OpsgenieScope).OpsgenieAlert ? intl.formatMessage((0, (0, parcelRequire("3UM2O")).messages).opsgenie_recent_alerts) : '', [
            intl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            expandedStateInputPlaceholder: intl.formatMessage((0, (0, parcelRequire("3UM2O")).messages).opsgenie_expanded_input_placeholder),
            generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl || viewAllLinkGenerator,
            id: $4140a4c6d2998b1d$var$OPSGENIE_PRODUCT_ID,
            preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
            searchFooterLabel: intl.formatMessage((0, (0, parcelRequire("3UM2O")).messages).opsgenie_advanced_search),
            sections: sections,
            title: intl.formatMessage((0, (0, parcelRequire("k4hbD")).messages).opsgenie_tab_label),
            urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
            ...rest,
            ...itemSuppliers
        });
    };
    const $4140a4c6d2998b1d$export$7571e7fdcc46c96b = (0, (0, parcelRequire("8RXs9")).default)($4140a4c6d2998b1d$export$527d10d7fdeeea4e);
});
parcelRegister("3UM2O", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$71f6266f9d0dc873$export$defe85febe8b728c);
    var $7VHMR;
    const $71f6266f9d0dc873$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        opsgenie_expanded_input_placeholder: {
            id: 'product_search_dialog.opsgenie.expanded.input-placeholder',
            defaultMessage: 'Search Opsgenie',
            description: 'The placeholder which is visible to the user when opsgenie tab is active '
        },
        opsgenie_recent_alerts: {
            id: 'product_search_dialog.opsgenie.opsgenie_recent_alerts',
            defaultMessage: 'Recent Alerts',
            description: ''
        },
        opsgenie_alerts_heading: {
            id: 'product_search_dialog.opsgenie.alert_heading',
            defaultMessage: 'Alerts',
            description: ''
        },
        opsgenie_advanced_search: {
            id: 'product_search_dialog.opsgenie.advanced_search',
            defaultMessage: 'Advanced alert search',
            description: 'Advanced search link text when inside Opsgenie tab'
        }
    });
});
parcelRegister("eGmm9", function(module, exports) {
    $parcel$export(module.exports, "OpsgenieScope", ()=>$275cc94eefbb021e$export$dc14148e3ded2998);
    var $275cc94eefbb021e$export$dc14148e3ded2998;
    (function(OpsgenieScope) {
        OpsgenieScope["OpsgenieAlert"] = "opsgenie.alert";
    })($275cc94eefbb021e$export$dc14148e3ded2998 || ($275cc94eefbb021e$export$dc14148e3ded2998 = {}));
});
parcelRegister("k5VJd", function(module, exports) {
    $parcel$export(module.exports, "useOpsgenieURLGenerators", ()=>$c518ba9dda1d08c5$export$c78c65c0f344862e);
    var $5uXOq = parcelRequire("5uXOq");
    const $c518ba9dda1d08c5$var$getOpsgenieAggregatorRedirectUrl = ({ cloudId: cloudId, hostUrl: hostUrl = '' })=>{
        return `${hostUrl}/gateway/api/xpsearch-aggregator/redirect/advanced/opsgenie/${cloudId}`;
    };
    const $c518ba9dda1d08c5$export$c78c65c0f344862e = (arg)=>{
        const opsgenieAggregatorRedirector = (0, $5uXOq.useCallback)((query)=>`${$c518ba9dda1d08c5$var$getOpsgenieAggregatorRedirectUrl(arg)}?query=${query}`, [
            arg
        ]);
        return {
            viewAllLinkGenerator: opsgenieAggregatorRedirector,
            urlGeneratorForNoResultsScreen: opsgenieAggregatorRedirector
        };
    };
});
parcelRegister("bHEFa", function(module, exports) {
    $parcel$export(module.exports, "TownsquareTab", ()=>$fead6f04769a8277$export$b2c9c8ae315d8935);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $9i3B5;
    var $dVo7Y;
    var $1ICFC;
    var $8Xs9r;
    var $3UF9C;
    var $l6iRn;
    var $1Z4tV;
    var $iwg9m;
    var $aIZdc;
    var $5IPCv;
    const $fead6f04769a8277$var$defaultPermissionsSupplier = ()=>{
        const response = Object.values((0, (0, parcelRequire("iwg9m")).TownsquareScope));
        return Promise.resolve(response);
    };
    const $fead6f04769a8277$export$e502dfe73eec1c84 = ({ intl: intl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, userTeamConfig: userTeamConfig, workspaces: workspaces, atlasClientBaseUrlOverride: atlasClientBaseUrlOverride, organizationId: organizationId, ...rest })=>{
        const [isGlobalExperienceWorkspace, setGlobalExperienceWorkspace] = (0, $5uXOq.useState)();
        const { atlasWorkspaces: atlasWorkspaces } = (0, (0, parcelRequire("dVo7Y")).useSearchConfigContext)();
        if (!workspaces) workspaces = atlasWorkspaces;
        const siteFilterDefinition = (0, (0, parcelRequire("3UF9C")).useSiteFilterDefinition)(workspaces, (0, (0, parcelRequire("1Z4tV")).TOWNSQUARE_PRODUCT_ID));
        const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, (0, parcelRequire("1Z4tV")).useTownsquareSuppliers)({
            userTeamConfig: userTeamConfig,
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier,
            workspaces: workspaces,
            isGlobalExperienceWorkspace: isGlobalExperienceWorkspace
        });
        const { defineFilters: defineFilters } = (0, (0, parcelRequire("3UF9C")).useGenericFilters)();
        defineFilters((0, (0, parcelRequire("1Z4tV")).TOWNSQUARE_PRODUCT_ID), siteFilterDefinition);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9i3B5")).isGlobalExperienceWorkspaceForCloudId)(userTeamConfig?.context.siteId, atlasClientBaseUrlOverride).then((result)=>{
                setGlobalExperienceWorkspace(result);
            }).catch(()=>{
                setGlobalExperienceWorkspace(false);
            });
        }, [
            atlasClientBaseUrlOverride,
            userTeamConfig?.context.siteId
        ]);
        let permissionSupplier = workspaces && workspaces.length > 0 || isGlobalExperienceWorkspace ? $fead6f04769a8277$var$defaultPermissionsSupplier : rest.permissionSupplier;
        if (isGlobalExperienceWorkspace === undefined) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            ...rest,
            id: (0, (0, parcelRequire("1Z4tV")).TOWNSQUARE_PRODUCT_ID),
            expandedStateInputPlaceholder: intl.formatMessage(isGlobalExperienceWorkspace ? (0, (0, parcelRequire("1ICFC")).messages).townsquare_search_input_expanded_placeholder : (0, (0, parcelRequire("1ICFC")).messages).atlas_search_input_expanded_placeholder),
            sections: (0, (0, parcelRequire("l6iRn")).getSections)(intl, workspaces, isGlobalExperienceWorkspace, userTeamConfig?.context.organizationId),
            title: intl.formatMessage(isGlobalExperienceWorkspace ? (0, (0, parcelRequire("1ICFC")).messages).townsquare_globex_tab_label : (0, (0, parcelRequire("1ICFC")).messages).townsquare_tab_label),
            preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
            preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
            postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
            workspaces: workspaces,
            permissionSupplier: permissionSupplier
        }, ()=>{
            return {
                Footer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
            };
        });
    };
    const $fead6f04769a8277$export$485492c388dcd81e = (props)=>{
        if ((0, (0, parcelRequire("5IPCv")).default).initializeCompleted() && (0, (0, parcelRequire("5IPCv")).default).checkGate('ignore_atlas_product_search_dialog_on_fedramp') && (0, (0, parcelRequire("aIZdc")).isFedRamp)()) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fead6f04769a8277$export$e502dfe73eec1c84, props);
    };
    const $fead6f04769a8277$export$b2c9c8ae315d8935 = (0, (0, parcelRequire("8RXs9")).default)($fead6f04769a8277$export$485492c388dcd81e);
});
parcelRegister("9i3B5", function(module, exports) {
    $parcel$export(module.exports, "isGlobalExperienceWorkspaceForCloudId", ()=>$b5b9b84c25cd7779$export$d39036e5b47a0af);
    var $VSDnB;
    function $b5b9b84c25cd7779$var$getServiceUrl(cloudId, baseUrlOverride) {
        const maybeShardedPath = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? `/townsquare/s/${cloudId}` : '/watermelon';
        const path = `/gateway/api${maybeShardedPath}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`;
        if (baseUrlOverride) return `${baseUrlOverride}${path}`;
        return path;
    }
    async function $b5b9b84c25cd7779$export$d39036e5b47a0af(cloudId, baseUrlOverride) {
        if (cloudId === undefined) return false;
        try {
            const response = await fetch($b5b9b84c25cd7779$var$getServiceUrl(cloudId, baseUrlOverride), {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return workspaceType === 'GLOBAL_EXPERIENCE';
            }
            return false;
        } catch (err) {
            return false;
        }
    }
});
parcelRegister("1ICFC", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e68bbdea7fdeab88$export$defe85febe8b728c);
    var $7VHMR;
    const $e68bbdea7fdeab88$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlas_search_input_expanded_placeholder: {
            id: 'product_search_dialog.atlas.search_input_expanded_placeholder',
            defaultMessage: 'Search Atlas',
            description: 'Input placeholder shown when searching for items in the Atlas product'
        },
        townsquare_search_input_expanded_placeholder: {
            id: 'product_search_dialog.townsquare.search_input_expanded_placeholder',
            defaultMessage: 'Search Home',
            description: 'Input placeholder shown when searching for items in Atlassian Home'
        },
        townsquare_tab_label: {
            id: 'cross_product_search_dialog.townsquare_tab_label',
            defaultMessage: 'Atlas',
            description: ''
        },
        townsquare_globex_tab_label: {
            id: 'cross_product_search_dialog.townsquare_globex_tab_label',
            defaultMessage: 'Home',
            description: ''
        },
        townsquare_recent_projects: {
            id: 'cross_product_search_dialog.townsquare_recent_projects',
            defaultMessage: 'Recent Projects',
            description: ''
        },
        townsquare_recent_goals: {
            id: 'cross_product_search_dialog.townsquare_recent_goals',
            defaultMessage: 'Recent Goals',
            description: ''
        },
        townsquare_recent_help_links: {
            id: 'cross_product_search_dialog.townsquare_recent_help_links',
            defaultMessage: 'Recent Help Links',
            description: ''
        },
        townsquare_recent_learnings_risks_decisions: {
            id: 'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions',
            defaultMessage: 'Recent Learnings, Risks and Decisions',
            description: 'Section heading for all types of project learnings: learnings, risks and decisions'
        },
        townsquare_recent_topics: {
            id: 'product_search_dialog.townsquare_recent_topics',
            defaultMessage: 'Recent Topics',
            description: 'Topic: A collection of projects, goals, teams and help curated through tagging objects.'
        },
        townsquare_recent_people: {
            id: 'product_search_dialog.townsquare_recent_people',
            defaultMessage: 'Recent People',
            description: ''
        },
        townsquare_projects_heading: {
            id: 'product_search_dialog.townsquare_projects_heading',
            defaultMessage: 'Projects',
            description: ''
        },
        townsquare_projects_view_all: {
            id: 'product_search_dialog.townsquare_projects_view_all',
            defaultMessage: 'Search all projects',
            description: 'Link to send the user to atlas extended project search'
        },
        townsquare_goals_heading: {
            id: 'product_search_dialog.townsquare_goals_heading',
            defaultMessage: 'Goals',
            description: ''
        },
        townsquare_goals_view_all: {
            id: 'product_search_dialog.townsquare_goals_view_all',
            defaultMessage: 'Search all goals',
            description: 'Link to send the user to atlas extended goal search'
        },
        townsquare_help_links_heading: {
            id: 'product_search_dialog.townsquare_help_links_heading',
            defaultMessage: 'Help Links',
            description: ''
        },
        townsquare_topics_heading: {
            id: 'product_search_dialog.townsquare_topics_heading',
            defaultMessage: 'Topics',
            description: 'Topic: A collection of projects, goals, teams and help curated through tagging objects.'
        },
        townsquare_topics_view_all: {
            id: 'product_search_dialog.townsquare_topics_view_all',
            defaultMessage: 'Search all topics',
            description: 'Link to send the user to atlas extended topic search'
        },
        townsquare_learnings_risks_decisions_heading: {
            id: 'product_search_dialog.townsquare_learnings_risks_decisions_heading',
            defaultMessage: 'Learnings, Risks and Decisions',
            description: 'Section heading for all types of project learnings: learnings, risks and decisions'
        },
        townsquare_people_heading: {
            id: 'product_search_dialog.townsquare_people_heading',
            defaultMessage: 'People',
            description: ''
        },
        townsquare_people_view_all: {
            id: 'product_search_dialog.townsquare_people_view_all',
            defaultMessage: 'Search all people',
            description: 'Link to send the user to atlas extended people search'
        },
        townsquare_teams_heading: {
            id: 'product_search_dialog.townsquare_teams_heading',
            defaultMessage: 'Teams',
            description: ''
        },
        townsquare_teams_view_all: {
            id: 'product_search_dialog.townsquare_teams_view_all',
            defaultMessage: 'Search all teams',
            description: 'Link to send the user to atlas extended team search'
        }
    });
});
parcelRegister("l6iRn", function(module, exports) {
    $parcel$export(module.exports, "MAX_ITEMS_PER_SECTION", ()=>$49e767ce964dc9ed$export$ece7c64a85a33d85);
    $parcel$export(module.exports, "getSections", ()=>$49e767ce964dc9ed$export$ddbcae0b0bd6b092);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $1ICFC;
    var $iwg9m;
    var $lKCn7;
    let $49e767ce964dc9ed$var$defaultTownsquareResultMapper = ({ results: results })=>results.map((value)=>$49e767ce964dc9ed$var$mapAggregatorResponseToSearchItem(value)).slice(0, $49e767ce964dc9ed$export$ece7c64a85a33d85);
    const $49e767ce964dc9ed$export$ece7c64a85a33d85 = 3;
    const $49e767ce964dc9ed$var$mapAggregatorResponseToSearchItem = (response)=>{
        if ('account_id' in response) return {
            title: response.name,
            id: response.account_id,
            meta: '',
            url: response.absoluteUrl || '',
            iconUrl: response.picture,
            containerId: ''
        };
        else return {
            title: response.title,
            id: response.id,
            meta: '',
            url: response.url,
            iconUrl: response.iconUrl,
            containerId: ''
        };
    };
    const $49e767ce964dc9ed$export$ddbcae0b0bd6b092 = (intl, workspaces, isGlobalExperienceWorkspace, orgId)=>[
            {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareProject,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_projects_heading),
                showResultCount: false,
                scope: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareProject,
                resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper,
                viewAllLinkGenerator: (query)=>{
                    return (0, (0, parcelRequire("lKCn7")).default)('projects', query, workspaces, isGlobalExperienceWorkspace, orgId);
                },
                viewAllLinkRenderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("1ICFC")).messages).townsquare_projects_view_all)
            },
            {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareGoal,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_goals_heading),
                scope: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareGoal,
                resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper,
                viewAllLinkGenerator: (query)=>(0, (0, parcelRequire("lKCn7")).default)('goals', query, workspaces, isGlobalExperienceWorkspace, orgId),
                viewAllLinkRenderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("1ICFC")).messages).townsquare_goals_view_all)
            },
            {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareHelpLink,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_help_links_heading),
                scope: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareHelpLink,
                resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper
            },
            {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareTag,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_topics_heading),
                scope: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareTag,
                resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper,
                viewAllLinkGenerator: (query)=>(0, (0, parcelRequire("lKCn7")).default)('topics', query, workspaces, isGlobalExperienceWorkspace, orgId),
                viewAllLinkRenderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("1ICFC")).messages).townsquare_topics_view_all)
            },
            {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareLearning,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_learnings_risks_decisions_heading),
                scope: (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareLearning,
                resultMapper: $49e767ce964dc9ed$var$defaultTownsquareResultMapper
            }
        ];
});
parcelRegister("iwg9m", function(module, exports) {
    $parcel$export(module.exports, "TownsquareScope", ()=>$942dcc058359fc29$export$fca43c5c12a4e3fa);
    var $942dcc058359fc29$export$fca43c5c12a4e3fa;
    (function(TownsquareScope) {
        TownsquareScope["TownsquareProject"] = "townsquare.project";
        TownsquareScope["TownsquareGoal"] = "townsquare.goal";
        TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
        TownsquareScope["TownsquareTag"] = "townsquare.tag";
        TownsquareScope["TownsquareLearning"] = "townsquare.learning";
        TownsquareScope["People"] = "townsquare.people";
        TownsquareScope["Teams"] = "townsquare.teams";
    })($942dcc058359fc29$export$fca43c5c12a4e3fa || ($942dcc058359fc29$export$fca43c5c12a4e3fa = {}));
});
parcelRegister("lKCn7", function(module, exports) {
    $parcel$export(module.exports, "createProfileLink", ()=>$666aede204901136$export$5b4f9e589794eb96);
    $parcel$export(module.exports, "createTeamProfileLink", ()=>$666aede204901136$export$a1c75f05b6ef3ec6);
    $parcel$export(module.exports, "default", ()=>$666aede204901136$export$2e2bcd8739ae039);
    const $666aede204901136$export$b182d98f245a5298 = (isGlobalExperienceWorkspace)=>{
        const hostname = window.location.hostname;
        const subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
        if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) return `https://${subdomain}.stg.atlassian.com`;
        return `https://${subdomain}.atlassian.com`;
    };
    const $666aede204901136$export$4c191d74745f6ab1 = (entityId, path, isGlobalExperienceWorkspace, orgId)=>{
        const baseUrl = $666aede204901136$export$b182d98f245a5298(isGlobalExperienceWorkspace);
        if (isGlobalExperienceWorkspace && orgId) return `${baseUrl}/o/${orgId}/${path}/${entityId}`;
        return `${baseUrl}/${path}/${entityId}`;
    };
    const $666aede204901136$export$5b4f9e589794eb96 = (accountId, isGlobalExperienceWorkspace, orgId)=>$666aede204901136$export$4c191d74745f6ab1(accountId, 'people', isGlobalExperienceWorkspace, orgId);
    const $666aede204901136$export$a1c75f05b6ef3ec6 = (teamId, isGlobalExperienceWorkspace, orgId)=>$666aede204901136$export$4c191d74745f6ab1(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
    const $666aede204901136$var$getAtlasViewAllRedirectUrl = (entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId)=>{
        let url;
        if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) url = new URL(workspaces[0].baseUrl);
        else url = new URL($666aede204901136$export$b182d98f245a5298(isGlobalExperienceWorkspace));
        const pathPrefix = isGlobalExperienceWorkspace && orgId ? `o/${orgId}/` : '';
        url.pathname = `${pathPrefix}action/search/${entity}`;
        url.searchParams.append('searchText', searchText);
        return url.href;
    };
    var $666aede204901136$export$2e2bcd8739ae039 = $666aede204901136$var$getAtlasViewAllRedirectUrl;
});
parcelRegister("1Z4tV", function(module, exports) {
    $parcel$export(module.exports, "TOWNSQUARE_PRODUCT_ID", ()=>$43c3794682d18a62$export$dac5be8ec1b3ddb1);
    $parcel$export(module.exports, "useTownsquareSuppliers", ()=>$43c3794682d18a62$export$a0d26d0ba1e6d87a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $g12zs;
    var $1ICFC;
    var $f4GCr;
    var $l6iRn;
    var $iwg9m;
    var $lKCn7;
    const $43c3794682d18a62$export$dac5be8ec1b3ddb1 = 'townsquare';
    const $43c3794682d18a62$var$sectionSortOrder = [
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareProject,
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareGoal,
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).People,
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).Teams,
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareTag,
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareHelpLink,
        (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareLearning
    ];
    const $43c3794682d18a62$var$sortSections = (sectionA, sectionB)=>{
        const indexA = $43c3794682d18a62$var$sectionSortOrder.indexOf(sectionA.id);
        const indexB = $43c3794682d18a62$var$sectionSortOrder.indexOf(sectionB.id);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
    };
    const $43c3794682d18a62$export$a0d26d0ba1e6d87a = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, workspaces: workspaces, organizationId: organizationId, isGlobalExperienceWorkspace: isGlobalExperienceWorkspace })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const orgId = organizationId ?? userTeamConfig?.context.organizationId;
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)($43c3794682d18a62$export$dac5be8ec1b3ddb1, (0, (0, parcelRequire("l6iRn")).getSections)(intl, workspaces, isGlobalExperienceWorkspace, orgId), {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        });
        if (userTeamConfig) userTeamConfig.context.productKey = isGlobalExperienceWorkspace ? 'people' : userTeamConfig?.context.productKey;
        const peopleAndTeamSupplier = (0, (0, parcelRequire("g12zs")).usePeopleAndTeamsQuery)({
            people: {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).People,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_people_heading),
                viewAllLinkGenerator: (query)=>(0, (0, parcelRequire("lKCn7")).default)('people', query, workspaces, isGlobalExperienceWorkspace, orgId),
                viewAllLinkRenderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("1ICFC")).messages).townsquare_people_view_all)
            },
            teams: {
                id: (0, (0, parcelRequire("iwg9m")).TownsquareScope).Teams,
                title: intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_teams_heading),
                viewAllLinkGenerator: (query)=>(0, (0, parcelRequire("lKCn7")).default)('teams', query, workspaces, isGlobalExperienceWorkspace, orgId),
                viewAllLinkRenderer: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("1ICFC")).messages).townsquare_teams_view_all)
            }
        }, (0, (0, parcelRequire("l6iRn")).MAX_ITEMS_PER_SECTION));
        const preQueryItemSupplierWithPeopleAndTeams = async (args)=>{
            const existingSections = await itemSuppliers.preQueryItemSupplier(args);
            const people = userTeamConfig ? await peopleAndTeamSupplier('', {
                resolveUserUrl: (userId)=>(0, (0, parcelRequire("lKCn7")).createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
                resolveTeamUrl: (teamId)=>(0, (0, parcelRequire("lKCn7")).createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
                ...userTeamConfig
            }) : null;
            const unsortedSections = [
                ...existingSections.sections,
                ...people?.sections ?? []
            ];
            return {
                size: unsortedSections.length,
                sections: unsortedSections.sort($43c3794682d18a62$var$sortSections)
            };
        };
        const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
            const existingSections = await itemSuppliers.postQueryItemSupplier(args);
            const { filters: filters } = args;
            const selectedWorkspace = filters.filter((filter)=>filter['@type'] === 'sites').map((filter)=>filter.values[0]).filter((val)=>val).shift();
            const people = userTeamConfig ? await peopleAndTeamSupplier(args.query, {
                resolveUserUrl: (userId)=>(0, (0, parcelRequire("lKCn7")).createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
                resolveTeamUrl: (teamId)=>(0, (0, parcelRequire("lKCn7")).createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
                ...userTeamConfig,
                context: {
                    ...userTeamConfig.context,
                    siteId: selectedWorkspace || userTeamConfig.context.siteId
                }
            }) : null;
            const unsortedSections = [
                ...existingSections.sections,
                ...people?.sections ?? []
            ];
            return {
                size: unsortedSections.length,
                sections: unsortedSections.sort($43c3794682d18a62$var$sortSections)
            };
        };
        const preQuerySectionTitleGenerator = (section)=>{
            switch(section.id){
                case (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareProject:
                    return intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_recent_projects);
                case (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareGoal:
                    return intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_recent_goals);
                case (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareHelpLink:
                    return intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_recent_help_links);
                case (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareTag:
                    return intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_recent_topics);
                case (0, (0, parcelRequire("iwg9m")).TownsquareScope).TownsquareLearning:
                    return intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_recent_learnings_risks_decisions);
                case (0, (0, parcelRequire("iwg9m")).TownsquareScope).People:
                    return intl.formatMessage((0, (0, parcelRequire("1ICFC")).messages).townsquare_recent_people);
                default:
                    return '';
            }
        };
        return {
            preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
            postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
            preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
        };
    };
});
parcelRegister("gUnI2", function(module, exports) {
    $parcel$export(module.exports, "TrelloTab", ()=>$6d456a53f60ae907$export$78fe0655c043c20);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $k4hbD;
    var $eS6IA;
    var $8Xs9r;
    var $f4GCr;
    var $e2gaa;
    var $9UICj;
    var $3MXT1;
    var $jNI9m;
    var $6cESN;
    var $6ZsPS;
    var $7xoNc;
    const $6d456a53f60ae907$var$TrelloBodyAsync = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("jN9iq")).then(({ TrelloBody: TrelloBody })=>({
                default: TrelloBody
            })));
    const $6d456a53f60ae907$export$78fe0655c043c20 = ({ feedbackUrl: feedbackUrl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, generateAdvancedSearchUrl: generateAdvancedSearchUrl, features: features, resultOnClick: resultOnClick, ...rest })=>{
        const searchSessionId = (0, (0, parcelRequire("6ZsPS")).useSearchSessionId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const trelloGenerateAdvancedSearchUrl = (0, $5uXOq.useCallback)((query)=>{
            return (0, (0, parcelRequire("7xoNc")).addQueryParams)((0, (0, parcelRequire("6cESN")).viewAllLinkGenerator)(query), {
                search_id: searchSessionId
            });
        }, [
            searchSessionId
        ]);
        const boardSection = (0, $5uXOq.useMemo)(()=>{
            return {
                id: (0, (0, parcelRequire("3MXT1")).TrelloScope).Board,
                title: formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_boards_heading),
                scope: (0, (0, parcelRequire("3MXT1")).TrelloScope).Board,
                showResultCount: false,
                resultMapper: ({ results: results })=>results.map((board)=>({
                            id: board.id,
                            title: board.name,
                            meta: board.organization?.displayName ?? '',
                            closed: board.closed,
                            url: board.url,
                            prefs: board.prefs,
                            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNI9m")).BoardIcon), board),
                            containerId: board.idOrganization ?? undefined
                        })),
                resultRenderer: (args)=>{
                    const { id: id, title: title, meta: meta, closed: closed, url: url, prefs: prefs } = args?.searchResult;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e2gaa")).TrelloSearchResultComponent), {
                        id: id,
                        title: title,
                        meta: {
                            title: formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_workspace),
                            value: meta
                        },
                        closed: closed,
                        url: url,
                        prefs: prefs,
                        isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                        isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                        screen: args?.screen,
                        onResultClick: resultOnClick
                    });
                }
            };
        }, [
            features?.isColorBlindModeEnabled,
            features?.isPreviewOnTrelloSearchResultsEnabled,
            formatMessage,
            resultOnClick
        ]);
        const cardSection = (0, $5uXOq.useMemo)(()=>{
            return {
                id: (0, (0, parcelRequire("3MXT1")).TrelloScope).Card,
                title: formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_cards_heading),
                scope: (0, (0, parcelRequire("3MXT1")).TrelloScope).Card,
                showResultCount: false,
                resultMapper: ({ results: results })=>results.map((card)=>({
                            id: card.id,
                            title: card.name,
                            meta: card.board.name,
                            additionalMeta: card.list.name,
                            closed: card.closed,
                            url: card.url,
                            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNI9m")).CardIcon), null),
                            containerId: card.idBoard
                        })),
                resultRenderer: (args)=>{
                    const { id: id, title: title, meta: meta, additionalMeta: additionalMeta, url: url, closed: closed } = args?.searchResult;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e2gaa")).TrelloSearchResultComponent), {
                        id: id,
                        title: title,
                        meta: {
                            title: formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_board),
                            value: meta
                        },
                        additionalMeta: {
                            title: formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_list),
                            value: additionalMeta
                        },
                        closed: closed,
                        url: url,
                        isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                        isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                        screen: args?.screen,
                        onResultClick: resultOnClick
                    });
                }
            };
        }, [
            features?.isColorBlindModeEnabled,
            features?.isPreviewOnTrelloSearchResultsEnabled,
            formatMessage,
            resultOnClick
        ]);
        const sections = (0, $5uXOq.useMemo)(()=>{
            return features?.isCardResultsSectionFirst ? [
                cardSection,
                {
                    ...boardSection,
                    viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
                }
            ] : [
                boardSection,
                {
                    ...cardSection,
                    viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
                }
            ];
        }, [
            boardSection,
            cardSection,
            features?.isCardResultsSectionFirst,
            trelloGenerateAdvancedSearchUrl
        ]);
        const itemSuppliers = (0, (0, parcelRequire("f4GCr")).useDefaultSuppliers)((0, (0, parcelRequire("3MXT1")).TRELLO_PRODUCT_ID), sections, {
            preQueryItemSupplier: preQueryItemSupplier,
            postQueryItemSupplier: postQueryItemSupplier
        });
        const preQuerySectionTitleGenerator = (0, $5uXOq.useCallback)((section)=>section.id === (0, (0, parcelRequire("3MXT1")).TrelloScope).Board ? formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_recent_boards_heading) : '', [
            formatMessage
        ]);
        const Footer = (0, $5uXOq.useMemo)(()=>{
            return feedbackUrl ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UICj")).TrelloFooter), {
                    feedbackUrl: feedbackUrl,
                    urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl
                }) : undefined;
        }, [
            feedbackUrl,
            trelloGenerateAdvancedSearchUrl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Xs9r")).SearchDialogProduct), {
            id: (0, (0, parcelRequire("3MXT1")).TRELLO_PRODUCT_ID),
            expandedStateInputPlaceholder: formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_expanded_input_placeholder),
            preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
            generateAdvancedSearchUrl: trelloGenerateAdvancedSearchUrl,
            sections: sections,
            title: formatMessage((0, (0, parcelRequire("k4hbD")).messages).trello_tab_label),
            ...rest,
            ...itemSuppliers
        }, (props)=>{
            return features?.isCardResultsSectionFirst ? {
                Footer: Footer,
                Body: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($6d456a53f60ae907$var$TrelloBodyAsync, props)
            } : {
                Footer: Footer
            };
        });
    };
});
parcelRegister("eS6IA", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$02719a3df0703f5e$export$defe85febe8b728c);
    var $7VHMR;
    const $02719a3df0703f5e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        trello_archived: {
            id: 'product_search_dialog.trello.archived',
            defaultMessage: 'Archived',
            description: 'Will show on a search result if a Trello card is archived'
        },
        trello_archived_card_hover: {
            id: 'product_search_dialog.trello.archived.card-hover',
            defaultMessage: 'This card is archived',
            description: 'Hover text for archived status of card search result'
        },
        trello_board: {
            id: 'product_search_dialog.trello.board',
            defaultMessage: 'Board',
            description: 'A Trello Board'
        },
        trello_closed: {
            id: 'product_search_dialog.trello.closed',
            defaultMessage: 'Closed',
            description: 'Will show on a search result if a Trello board is closed'
        },
        trello_closed_board_hover: {
            id: 'product_search_dialog.trello.closed.board-hover',
            defaultMessage: 'This board is closed',
            description: 'Hover text for closed status of board search result'
        },
        trello_list: {
            id: 'product_search_dialog.trello.list',
            defaultMessage: 'List',
            description: 'A list on a Trello board'
        },
        trello_workspace: {
            id: 'product_search_dialog.trello.workspace',
            defaultMessage: 'Workspace',
            description: 'A Trello Workspace'
        },
        trello_private_workspace: {
            id: 'product_search_dialog.trello.private_workspace',
            defaultMessage: 'Private Workspace',
            description: 'A Trello private workspace'
        },
        trello_expanded_input_placeholder: {
            id: 'product_search_dialog.trello.expanded.input-placeholder',
            defaultMessage: 'Search Trello',
            description: 'The expanded placeholder text when the Trello tab is active.'
        },
        trello_recent_boards_heading: {
            id: 'product_search_dialog.trello.recent_boards_heading',
            defaultMessage: 'Recent boards',
            description: 'Heading for Recent boards, a Trello search result type'
        },
        trello_boards_heading: {
            id: 'product_search_dialog.trello.boards_heading',
            defaultMessage: 'Boards',
            description: 'Heading for Boards, a Trello search result type'
        },
        trello_cards_heading: {
            id: 'product_search_dialog.trello.cards_heading',
            defaultMessage: 'Cards',
            description: 'Heading for Cards, a Trello search result type'
        },
        trello_feedback_link: {
            id: 'product_search_dialog.trello.feedback_link',
            defaultMessage: 'Help us improve your search results!',
            description: 'Link redirecting to a feedback form'
        }
    });
});
parcelRegister("e2gaa", function(module, exports) {
    $parcel$export(module.exports, "TrelloSearchResultComponent", ()=>$770e5e4ad8bb17d6$export$995a33bac606d212);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $eiKpf;
    var $eS6IA;
    var $eMsAl;
    var $jNI9m;
    var $8ZlAw;
    const $770e5e4ad8bb17d6$export$995a33bac606d212 = ({ id: id, title: title, url: url, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, isColorBlindModeEnabled: isColorBlindModeEnabled, screen: screen, onResultClick: onResultClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isBoard = Boolean(prefs);
        const type = (0, $5uXOq.useMemo)(()=>isBoard ? 'board' : 'card', [
            isBoard
        ]);
        const metaValue = (0, $5uXOq.useMemo)(()=>isBoard && !meta.value ? formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_private_workspace) : meta.value, [
            formatMessage,
            isBoard,
            meta.value
        ]);
        const resultContentWrapperOnClick = (0, $5uXOq.useCallback)(()=>{
            if (onResultClick !== undefined) onResultClick();
        }, [
            onResultClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ZlAw")).HoverPreviewsResultWrapper), {
            id: id,
            title: title,
            url: url,
            prefs: prefs,
            meta: meta,
            additionalMeta: additionalMeta,
            closed: closed,
            type: type,
            isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled,
            isColorBlindModeEnabled: isColorBlindModeEnabled,
            screen: screen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultContentWrapper), {
            isCollapsed: true,
            onClick: resultContentWrapperOnClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).IconContainer), null, isBoard && prefs ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNI9m")).BoardIcon), {
            id: id,
            name: title,
            url: url,
            prefs: prefs
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNI9m")).CardIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).CollapsedResultContentWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiKpf")).ResultTitleContainer), {
            isCollapsed: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            title: !isPreviewOnTrelloSearchResultsEnabled ? title : undefined
        }, title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMsAl")).CollapsedResultDetailWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMsAl")).BoardAndListCol), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMsAl")).BoardAndListDetail), {
            title: !isPreviewOnTrelloSearchResultsEnabled ? `${meta.title}: ${metaValue}` : undefined
        }, metaValue), additionalMeta ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMsAl")).BoardAndListDetail), {
            title: !isPreviewOnTrelloSearchResultsEnabled ? `${additionalMeta.title}: ${additionalMeta.value}` : undefined
        }, ": ", additionalMeta.value) : null), closed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMsAl")).ArchivedCol), {
            title: !isPreviewOnTrelloSearchResultsEnabled ? isBoard ? formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_closed_board_hover) : formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_archived_card_hover) : undefined
        }, "\u2022 ", isBoard ? formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_closed) : formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_archived)) : null))));
    };
});
parcelRegister("eMsAl", function(module, exports) {
    $parcel$export(module.exports, "BoardAndListCol", ()=>$d8a74695157867e5$export$14ccea95a01eec04);
    $parcel$export(module.exports, "BoardAndListDetail", ()=>$d8a74695157867e5$export$67495cfd95013c39);
    $parcel$export(module.exports, "ArchivedCol", ()=>$d8a74695157867e5$export$cd22da1a99fcf7b1);
    $parcel$export(module.exports, "CollapsedResultDetailWrapper", ()=>$d8a74695157867e5$export$43a2b5c94cb85d9c);
    var $bWGt6 = parcelRequire("bWGt6");
    function $d8a74695157867e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d8a74695157867e5$export$14ccea95a01eec04 = (0, $bWGt6.default)("div", {
        target: "e1rjmdl23"
    })({
        name: "andpxo",
        styles: "display:flex;overflow:hidden"
    });
    const $d8a74695157867e5$export$67495cfd95013c39 = (0, $bWGt6.default)("div", {
        target: "e1rjmdl22"
    })({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '5%',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '14px',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    });
    const $d8a74695157867e5$export$cd22da1a99fcf7b1 = (0, $bWGt6.default)("div", {
        target: "e1rjmdl21"
    })({
        marginLeft: "var(--ds-space-050, 4px)",
        flexShrink: 0,
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: '14px',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    });
    const $d8a74695157867e5$export$43a2b5c94cb85d9c = (0, $bWGt6.default)("div", {
        target: "e1rjmdl20"
    })({
        name: "zjik7",
        styles: "display:flex"
    });
});
parcelRegister("jNI9m", function(module, exports) {
    $parcel$export(module.exports, "getCardIconUrl", ()=>$2e3a87544bc74a86$export$d00fcd959e6e6c2b);
    $parcel$export(module.exports, "getBoardIconUrl", ()=>$2e3a87544bc74a86$export$419622b78ee4bd67);
    $parcel$export(module.exports, "BoardIcon", ()=>$2e3a87544bc74a86$export$2f9da8868573b55d);
    $parcel$export(module.exports, "CardIcon", ()=>$2e3a87544bc74a86$export$f4619d70a16e5ea0);
    var $k5uoT;
    var $kTHGn;
    var $bWGt6 = parcelRequire("bWGt6");
    const $2e3a87544bc74a86$var$baseStyle = {
        display: 'flex',
        flexShrink: 0,
        borderRadius: '2px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    };
    const $2e3a87544bc74a86$export$d00fcd959e6e6c2b = ()=>{
        const iconColor = (0, (0, parcelRequire("kTHGn")).default)('color.icon', (0, $829f609a65d26a98$export$7d61b15e0da132af));
        return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 0C1.19391 0 0 1.19391 0 2.66667V16C0 17.4728 1.19391 18.6667 2.66667 18.6667H21.3333C22.8061 18.6667 24 17.4728 24 16V2.66667C24 1.19391 22.8061 0 21.3333 0H2.66667ZM21.3333 2.66667H2.66667V10.6667H21.3333V2.66667ZM18.6667 14.6667C18.6667 15.403 19.2636 16 20 16C20.7364 16 21.3333 15.403 21.3333 14.6667C21.3333 13.9303 20.7364 13.3333 20 13.3333C19.2636 13.3333 18.6667 13.9303 18.6667 14.6667ZM4 16C3.26362 16 2.66667 15.403 2.66667 14.6667C2.66667 13.9303 3.26362 13.3333 4 13.3333H9.33333C10.0697 13.3333 10.6667 13.9303 10.6667 14.6667C10.6667 15.403 10.0697 16 9.33333 16H4Z" fill="${iconColor}"/></svg>`)}`;
    };
    const $2e3a87544bc74a86$export$419622b78ee4bd67 = ()=>{
        const iconColor = (0, (0, parcelRequire("kTHGn")).default)('color.icon', (0, $829f609a65d26a98$export$7d61b15e0da132af));
        return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.77778C0 0.795938 0.795938 0 1.77778 0H14.2222C15.2041 0 16 0.795938 16 1.77778V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222V1.77778ZM1.77778 2.66667C1.77778 2.17575 2.17575 1.77778 2.66667 1.77778H6.22222C6.71314 1.77778 7.11111 2.17575 7.11111 2.66667V11.5556C7.11111 12.0465 6.71314 12.4444 6.22222 12.4444H2.66667C2.17575 12.4444 1.77778 12.0465 1.77778 11.5556V2.66667ZM9.77778 1.77778C9.28686 1.77778 8.88889 2.17575 8.88889 2.66667V8C8.88889 8.49092 9.28686 8.88889 9.77778 8.88889H13.3333C13.8243 8.88889 14.2222 8.49092 14.2222 8V2.66667C14.2222 2.17575 13.8243 1.77778 13.3333 1.77778H9.77778Z" fill="${iconColor}"/></svg>`)}`;
    };
    const $2e3a87544bc74a86$export$2f9da8868573b55d = (0, $bWGt6.default)("span", {
        target: "est758s1"
    })(({ prefs: { backgroundImageScaled: backgroundImageScaled, backgroundImage: backgroundImage, backgroundColor: backgroundColor } })=>{
        const boardUrl = backgroundImageScaled?.[0]?.url || backgroundImage;
        if (boardUrl) return {
            ...$2e3a87544bc74a86$var$baseStyle,
            height: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
            width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
            backgroundImage: `url(${boardUrl})`
        };
        return {
            ...$2e3a87544bc74a86$var$baseStyle,
            height: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
            width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
            backgroundColor: backgroundColor || `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
        };
    });
    const $2e3a87544bc74a86$export$f4619d70a16e5ea0 = (0, $bWGt6.default)("span", {
        target: "est758s0"
    })(()=>{
        return {
            ...$2e3a87544bc74a86$var$baseStyle,
            height: `19px`,
            width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
            marginBottom: "var(--ds-space-100, 8px)",
            backgroundImage: `url(${$2e3a87544bc74a86$export$d00fcd959e6e6c2b()})`
        };
    });
});
parcelRegister("8ZlAw", function(module, exports) {
    $parcel$export(module.exports, "HoverPreviewsResultWrapper", ()=>$0912af53c3ec2c23$export$5662bd1eb353c490);
    var $5uXOq = parcelRequire("5uXOq");
    var $ij3jm;
    const $0912af53c3ec2c23$var$TrelloPopperAsync = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("eapSc")).then(({ TrelloPopper: TrelloPopper })=>({
                default: TrelloPopper
            })));
    const $0912af53c3ec2c23$export$5662bd1eb353c490 = ({ id: id, title: title, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, type: type, children: children, isColorBlindModeEnabled: isColorBlindModeEnabled, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, screen: screen })=>{
        const { getCard: getCard } = (0, (0, parcelRequire("ij3jm")).useTrelloCard)();
        const [result, setResult] = (0, $5uXOq.useState)();
        const onFetchCard = (0, $5uXOq.useCallback)(async ()=>{
            const card = await getCard(id);
            if (card) setResult({
                ...card,
                type: 'card',
                id: id,
                title: title,
                closed: closed,
                meta: meta,
                additionalMeta: additionalMeta,
                screen: screen
            });
        }, [
            getCard,
            id,
            title,
            closed,
            meta,
            screen,
            additionalMeta
        ]);
        const onFetchBoard = (0, $5uXOq.useCallback)(()=>{
            if (prefs) setResult({
                type: 'board',
                id: id,
                title: title,
                prefs: prefs,
                meta: meta,
                closed: closed,
                screen: screen
            });
        }, [
            id,
            title,
            prefs,
            meta,
            closed,
            screen
        ]);
        if (!isPreviewOnTrelloSearchResultsEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0912af53c3ec2c23$var$TrelloPopperAsync, {
            type: type,
            result: result,
            onFetchCard: onFetchCard,
            onFetchBoard: onFetchBoard,
            isColorBlindModeEnabled: isColorBlindModeEnabled,
            screen: screen
        }, children));
    };
});
parcelRegister("ij3jm", function(module, exports) {
    $parcel$export(module.exports, "useTrelloCard", ()=>$045591519f532e78$export$167729b86606a89e);
    var $5uXOq = parcelRequire("5uXOq");
    var $75NXP;
    var $3FqY6;
    const $045591519f532e78$var$cards = new Map();
    const $045591519f532e78$export$167729b86606a89e = ()=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (0, parcelRequire("75NXP")).useAnalytics)();
        const loadCard = (0, $5uXOq.useCallback)(async (cardId)=>{
            try {
                const response = await fetch(`/1/card/${cardId}?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover`);
                if (response.ok) {
                    const cardResponse = await response.json();
                    $045591519f532e78$var$cards.set(cardId, cardResponse);
                    return cardResponse;
                } else throw new Error(`Invalid response: ${response?.status}`);
            } catch (e) {
                if (e instanceof Error) fireAnalyticsEvent({
                    ...(0, (0, parcelRequire("3FqY6")).onCardRequestFailed)({
                        attributes: {
                            errorMsg: e?.message,
                            errorName: e?.name
                        }
                    })
                });
            }
        }, [
            fireAnalyticsEvent
        ]);
        const getCard = (0, $5uXOq.useCallback)(async (cardId)=>{
            return $045591519f532e78$var$cards.get(cardId) ? Promise.resolve($045591519f532e78$var$cards.get(cardId)) : loadCard(cardId);
        }, [
            loadCard
        ]);
        return {
            getCard: getCard
        };
    };
});
parcelRegister("eapSc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9qiCl").then(()=>parcelRequire('6h9YI'));
});
parcelRegister("9UICj", function(module, exports) {
    $parcel$export(module.exports, "TrelloFooter", ()=>$cc24001924c5ab43$export$c139d851a817966);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $eS6IA;
    var $7sOan;
    var $1poKc;
    const $cc24001924c5ab43$export$c139d851a817966 = ({ feedbackUrl: feedbackUrl, ...rest })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1poKc")).SearchFooterWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7sOan")).default), rest), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1poKc")).FeedbackLinkWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1poKc")).FeedbackLink), {
            appearance: "subtle-link",
            href: feedbackUrl,
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("eS6IA")).messages).trello_feedback_link))));
    };
});
parcelRegister("1poKc", function(module, exports) {
    $parcel$export(module.exports, "FeedbackLinkWrapper", ()=>$f9c183129a568a14$export$b68f382ed631ffe5);
    $parcel$export(module.exports, "FeedbackLink", ()=>$f9c183129a568a14$export$4d44d7534024e0b6);
    $parcel$export(module.exports, "SearchFooterWrapper", ()=>$f9c183129a568a14$export$a6be8d069f8a5fb4);
    var $a353g;
    var $fVnbM;
    var $bWGt6 = parcelRequire("bWGt6");
    const $f9c183129a568a14$export$b68f382ed631ffe5 = (0, $bWGt6.default)("div", {
        target: "evrkq7c2"
    })({
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        padding: `${"var(--ds-space-050, 4px)"} 0`
    });
    const $f9c183129a568a14$export$4d44d7534024e0b6 = (0, $bWGt6.default)((0, (0, parcelRequire("fVnbM")).default), {
        target: "evrkq7c1"
    })("&&{text-decoration:underline;&:hover{color:", `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`, "!important;}}");
    const $f9c183129a568a14$var$searchFooterWrapperHeight = "var(--ds-space-1000, 80px)";
    const $f9c183129a568a14$export$a6be8d069f8a5fb4 = (0, $bWGt6.default)((0, (0, parcelRequire("a353g")).SearchFooter), {
        target: "evrkq7c0"
    })({
        display: 'flex',
        flexDirection: 'column',
        height: $f9c183129a568a14$var$searchFooterWrapperHeight
    });
});
parcelRegister("3MXT1", function(module, exports) {
    $parcel$export(module.exports, "TRELLO_PRODUCT_ID", ()=>$a857210ee855aeeb$export$4788c0ef19dba72f);
    $parcel$export(module.exports, "TrelloScope", ()=>$a857210ee855aeeb$export$1f420d5694f8d5b3);
    const $a857210ee855aeeb$export$4788c0ef19dba72f = 'trello';
    var $a857210ee855aeeb$export$1f420d5694f8d5b3;
    (function(TrelloScope) {
        TrelloScope["Board"] = "trello.board";
        TrelloScope["Card"] = "trello.card";
    })($a857210ee855aeeb$export$1f420d5694f8d5b3 || ($a857210ee855aeeb$export$1f420d5694f8d5b3 = {}));
});
parcelRegister("6cESN", function(module, exports) {
    $parcel$export(module.exports, "viewAllLinkGenerator", ()=>$17795d4edba82704$export$28a2ffcf7191490b);
    const $17795d4edba82704$var$getBaseUrl = ()=>{
        const hostname = window?.location?.hostname;
        if (hostname?.includes('jira-dev.com') || hostname?.startsWith('trellis.coffee') || hostname?.startsWith('localhost') || hostname?.startsWith('team.stg')) return 'https://trellis.coffee';
        return 'https://trello.com';
    };
    const $17795d4edba82704$export$28a2ffcf7191490b = (query)=>query ? `${$17795d4edba82704$var$getBaseUrl()}/search?q=${encodeURIComponent(query)}` : `${$17795d4edba82704$var$getBaseUrl()}/search`;
});
parcelRegister("jN9iq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kPTH8").then(()=>parcelRequire('b47ZY'));
});
parcelRegister("cbTYT", function(module, exports) {
    $parcel$export(module.exports, "useNINGlobalScopeEnrolment", ()=>$a1f5a8d976347fb9$export$3585e395a7eced19);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $fu3P4;
    var $VILOn;
    const $a1f5a8d976347fb9$export$3585e395a7eced19 = ({ cloudId: cloudId, isExpanded: isExpanded })=>{
        const fetched = (0, $5uXOq.useRef)(false);
        const [isNinGlobalScopeEnrolmentEnabled, setIsNinGlobalScopeEnrolmentEnabled] = (0, $5uXOq.useState)(()=>{
            if (false) return true;
            const localStorageData = (0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)();
            if (localStorageData !== null && localStorageData !== undefined) return !!localStorageData;
            return true;
        });
        (0, $5uXOq.useEffect)(()=>{
            if (false || fetched.current || !isExpanded) return;
            (0, (0, parcelRequire("fu3P4")).default)(cloudId).then((isNinGlobalScopeEnrolmentEnabledData)=>{
                fetched.current = true;
                setIsNinGlobalScopeEnrolmentEnabled(isNinGlobalScopeEnrolmentEnabledData);
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useNINGlobalScopeEnrolment',
                        packageName: 'jiraAtlassianNavigation',
                        teamName: 'navigation'
                    },
                    error: error instanceof Error ? error : new Error('Error fetching jira.user.nin.global.scope.enrolment from the server'),
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            cloudId,
            isExpanded
        ]);
        return isNinGlobalScopeEnrolmentEnabled;
    };
});
parcelRegister("fu3P4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$667869f7351d8a5e$export$2e2bcd8739ae039);
    var $eusud;
    const $667869f7351d8a5e$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY = `
    query SelectedGlobalScopeIssueNavigatorQuery($cloudId: ID!) {
        myPreferences(keys: [
            "jira.user.nin.global.scope.enrolment"
        ]),
        jira {
            applicationPropertiesByKey(cloudId: $cloudId, keys: ["jira.admin.nin.global.scope.enrolment"]) {
                value
            }
        }
    }
`;
    const $667869f7351d8a5e$var$fetchIsGlobalScopeEnrolmentEnabledFromServer = async (cloudId)=>{
        const apiResult = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $667869f7351d8a5e$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY,
                variables: {
                    cloudId: cloudId
                }
            })
        });
        const userPreferenceValue = apiResult.data.myPreferences['jira.user.nin.global.scope.enrolment'];
        if (userPreferenceValue !== 'nin' && userPreferenceValue !== 'gin' && userPreferenceValue !== null) throw new RangeError('Unexpected user preference value');
        const applicationPropertyValue = apiResult.data.jira.applicationPropertiesByKey[0].value;
        if (applicationPropertyValue !== 'true' && applicationPropertyValue !== 'false') throw new RangeError('Unexpected application property value');
        return userPreferenceValue !== 'gin' && applicationPropertyValue === 'true';
    };
    var $667869f7351d8a5e$export$2e2bcd8739ae039 = $667869f7351d8a5e$var$fetchIsGlobalScopeEnrolmentEnabledFromServer;
});
parcelRegister("VILOn", function(module, exports) {
    $parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", ()=>$5dc42c779a970b72$export$55632339cd4dae9c);
    $parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", ()=>$5dc42c779a970b72$export$7b78bfe0a111cecf);
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$82b2633cf7498c5e);
    $parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$458eda2352a1e223);
    var $bSSG7;
    var $dJl1T;
    const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
    const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
    const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('nin-changeboarding');
    const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
            $5dc42c779a970b72$export$34434fbbe40a8047();
        }
    };
    const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
        }
    };
});
